var fI = Object.defineProperty;
var dI = (e, t, n) => t in e ? fI(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ci = (e, t, n) => dI(e, typeof t != "symbol" ? t + "" : t, n);
import * as ie from "react";
import W, { useState as Fe, createContext as Le, useContext as Ie, useLayoutEffect as V2, useEffect as Se, useRef as _e, useCallback as Me, useMemo as $e, forwardRef as Xt, createElement as pI, cloneElement as bu, Children as hI, isValidElement as ry, version as vI, useReducer as B2, Component as iy, memo as Bf, PureComponent as U2, useImperativeHandle as mI, Fragment as gI } from "react";
import yI, { flushSync as oy, createPortal as da, unstable_batchedUpdates as bI } from "react-dom";
import _I, { keyframes as wI } from "styled-components";
import { toast as pr } from "react-toastify";
import { useMutation as ay, useQuery as K2, QueryClientProvider as xI } from "@tanstack/react-query";
import { useField as EI } from "formik";
import { Link as Ya } from "react-router-dom";
import { Outlet as SI } from "react-router";
import * as Xu from "@apollo/client";
import { gql as ni } from "@apollo/client";
import * as fh from "pdfjs-dist";
function Wd(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var kc = { exports: {} }, Ol = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var c_;
function OI() {
  if (c_) return Ol;
  c_ = 1;
  var e = W, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, u) {
    var c, f = {}, d = null, p = null;
    u !== void 0 && (d = "" + u), l.key !== void 0 && (d = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (c in l) r.call(l, c) && !o.hasOwnProperty(c) && (f[c] = l[c]);
    if (s && s.defaultProps) for (c in l = s.defaultProps, l) f[c] === void 0 && (f[c] = l[c]);
    return { $$typeof: t, type: s, key: d, ref: p, props: f, _owner: i.current };
  }
  return Ol.Fragment = n, Ol.jsx = a, Ol.jsxs = a, Ol;
}
var $l = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f_;
function $I() {
  return f_ || (f_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = W, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), h = Symbol.iterator, v = "@@iterator";
    function m(V) {
      if (V === null || typeof V != "object")
        return null;
      var ge = h && V[h] || V[v];
      return typeof ge == "function" ? ge : null;
    }
    var g = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(V) {
      {
        for (var ge = arguments.length, Ae = new Array(ge > 1 ? ge - 1 : 0), We = 1; We < ge; We++)
          Ae[We - 1] = arguments[We];
        w("error", V, Ae);
      }
    }
    function w(V, ge, Ae) {
      {
        var We = g.ReactDebugCurrentFrame, ut = We.getStackAddendum();
        ut !== "" && (ge += "%s", Ae = Ae.concat([ut]));
        var mt = Ae.map(function(tt) {
          return String(tt);
        });
        mt.unshift("Warning: " + ge), Function.prototype.apply.call(console[V], console, mt);
      }
    }
    var x = !1, S = !1, O = !1, P = !1, b = !1, _;
    _ = Symbol.for("react.module.reference");
    function E(V) {
      return !!(typeof V == "string" || typeof V == "function" || V === r || V === o || b || V === i || V === u || V === c || P || V === p || x || S || O || typeof V == "object" && V !== null && (V.$$typeof === d || V.$$typeof === f || V.$$typeof === a || V.$$typeof === s || V.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      V.$$typeof === _ || V.getModuleId !== void 0));
    }
    function A(V, ge, Ae) {
      var We = V.displayName;
      if (We)
        return We;
      var ut = ge.displayName || ge.name || "";
      return ut !== "" ? Ae + "(" + ut + ")" : Ae;
    }
    function k(V) {
      return V.displayName || "Context";
    }
    function R(V) {
      if (V == null)
        return null;
      if (typeof V.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof V == "function")
        return V.displayName || V.name || null;
      if (typeof V == "string")
        return V;
      switch (V) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case s:
            var ge = V;
            return k(ge) + ".Consumer";
          case a:
            var Ae = V;
            return k(Ae._context) + ".Provider";
          case l:
            return A(V, V.render, "ForwardRef");
          case f:
            var We = V.displayName || null;
            return We !== null ? We : R(V.type) || "Memo";
          case d: {
            var ut = V, mt = ut._payload, tt = ut._init;
            try {
              return R(tt(mt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var N = Object.assign, U = 0, H, ee, ue, Q, $, F, I;
    function L() {
    }
    L.__reactDisabledLog = !0;
    function K() {
      {
        if (U === 0) {
          H = console.log, ee = console.info, ue = console.warn, Q = console.error, $ = console.group, F = console.groupCollapsed, I = console.groupEnd;
          var V = {
            configurable: !0,
            enumerable: !0,
            value: L,
            writable: !0
          };
          Object.defineProperties(console, {
            info: V,
            log: V,
            warn: V,
            error: V,
            group: V,
            groupCollapsed: V,
            groupEnd: V
          });
        }
        U++;
      }
    }
    function Y() {
      {
        if (U--, U === 0) {
          var V = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: N({}, V, {
              value: H
            }),
            info: N({}, V, {
              value: ee
            }),
            warn: N({}, V, {
              value: ue
            }),
            error: N({}, V, {
              value: Q
            }),
            group: N({}, V, {
              value: $
            }),
            groupCollapsed: N({}, V, {
              value: F
            }),
            groupEnd: N({}, V, {
              value: I
            })
          });
        }
        U < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var se = g.ReactCurrentDispatcher, ve;
    function B(V, ge, Ae) {
      {
        if (ve === void 0)
          try {
            throw Error();
          } catch (ut) {
            var We = ut.stack.trim().match(/\n( *(at )?)/);
            ve = We && We[1] || "";
          }
        return `
` + ve + V;
      }
    }
    var T = !1, D;
    {
      var C = typeof WeakMap == "function" ? WeakMap : Map;
      D = new C();
    }
    function z(V, ge) {
      if (!V || T)
        return "";
      {
        var Ae = D.get(V);
        if (Ae !== void 0)
          return Ae;
      }
      var We;
      T = !0;
      var ut = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var mt;
      mt = se.current, se.current = null, K();
      try {
        if (ge) {
          var tt = function() {
            throw Error();
          };
          if (Object.defineProperty(tt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(tt, []);
            } catch (Fn) {
              We = Fn;
            }
            Reflect.construct(V, [], tt);
          } else {
            try {
              tt.call();
            } catch (Fn) {
              We = Fn;
            }
            V.call(tt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Fn) {
            We = Fn;
          }
          V();
        }
      } catch (Fn) {
        if (Fn && We && typeof Fn.stack == "string") {
          for (var Ye = Fn.stack.split(`
`), On = We.stack.split(`
`), Wt = Ye.length - 1, nn = On.length - 1; Wt >= 1 && nn >= 0 && Ye[Wt] !== On[nn]; )
            nn--;
          for (; Wt >= 1 && nn >= 0; Wt--, nn--)
            if (Ye[Wt] !== On[nn]) {
              if (Wt !== 1 || nn !== 1)
                do
                  if (Wt--, nn--, nn < 0 || Ye[Wt] !== On[nn]) {
                    var fr = `
` + Ye[Wt].replace(" at new ", " at ");
                    return V.displayName && fr.includes("<anonymous>") && (fr = fr.replace("<anonymous>", V.displayName)), typeof V == "function" && D.set(V, fr), fr;
                  }
                while (Wt >= 1 && nn >= 0);
              break;
            }
        }
      } finally {
        T = !1, se.current = mt, Y(), Error.prepareStackTrace = ut;
      }
      var Ka = V ? V.displayName || V.name : "", Ho = Ka ? B(Ka) : "";
      return typeof V == "function" && D.set(V, Ho), Ho;
    }
    function Z(V, ge, Ae) {
      return z(V, !1);
    }
    function ne(V) {
      var ge = V.prototype;
      return !!(ge && ge.isReactComponent);
    }
    function de(V, ge, Ae) {
      if (V == null)
        return "";
      if (typeof V == "function")
        return z(V, ne(V));
      if (typeof V == "string")
        return B(V);
      switch (V) {
        case u:
          return B("Suspense");
        case c:
          return B("SuspenseList");
      }
      if (typeof V == "object")
        switch (V.$$typeof) {
          case l:
            return Z(V.render);
          case f:
            return de(V.type, ge, Ae);
          case d: {
            var We = V, ut = We._payload, mt = We._init;
            try {
              return de(mt(ut), ge, Ae);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, Ee = {}, re = g.ReactDebugCurrentFrame;
    function xe(V) {
      if (V) {
        var ge = V._owner, Ae = de(V.type, V._source, ge ? ge.type : null);
        re.setExtraStackFrame(Ae);
      } else
        re.setExtraStackFrame(null);
    }
    function De(V, ge, Ae, We, ut) {
      {
        var mt = Function.call.bind(fe);
        for (var tt in V)
          if (mt(V, tt)) {
            var Ye = void 0;
            try {
              if (typeof V[tt] != "function") {
                var On = Error((We || "React class") + ": " + Ae + " type `" + tt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof V[tt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw On.name = "Invariant Violation", On;
              }
              Ye = V[tt](ge, tt, We, Ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Wt) {
              Ye = Wt;
            }
            Ye && !(Ye instanceof Error) && (xe(ut), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", We || "React class", Ae, tt, typeof Ye), xe(null)), Ye instanceof Error && !(Ye.message in Ee) && (Ee[Ye.message] = !0, xe(ut), y("Failed %s type: %s", Ae, Ye.message), xe(null));
          }
      }
    }
    var pe = Array.isArray;
    function j(V) {
      return pe(V);
    }
    function q(V) {
      {
        var ge = typeof Symbol == "function" && Symbol.toStringTag, Ae = ge && V[Symbol.toStringTag] || V.constructor.name || "Object";
        return Ae;
      }
    }
    function J(V) {
      try {
        return X(V), !1;
      } catch {
        return !0;
      }
    }
    function X(V) {
      return "" + V;
    }
    function te(V) {
      if (J(V))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", q(V)), X(V);
    }
    var le = g.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ce, He;
    function it(V) {
      if (fe.call(V, "ref")) {
        var ge = Object.getOwnPropertyDescriptor(V, "ref").get;
        if (ge && ge.isReactWarning)
          return !1;
      }
      return V.ref !== void 0;
    }
    function vt(V) {
      if (fe.call(V, "key")) {
        var ge = Object.getOwnPropertyDescriptor(V, "key").get;
        if (ge && ge.isReactWarning)
          return !1;
      }
      return V.key !== void 0;
    }
    function bt(V, ge) {
      typeof V.ref == "string" && le.current;
    }
    function si(V, ge) {
      {
        var Ae = function() {
          Ce || (Ce = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ge));
        };
        Ae.isReactWarning = !0, Object.defineProperty(V, "key", {
          get: Ae,
          configurable: !0
        });
      }
    }
    function li(V, ge) {
      {
        var Ae = function() {
          He || (He = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ge));
        };
        Ae.isReactWarning = !0, Object.defineProperty(V, "ref", {
          get: Ae,
          configurable: !0
        });
      }
    }
    var Di = function(V, ge, Ae, We, ut, mt, tt) {
      var Ye = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: V,
        key: ge,
        ref: Ae,
        props: tt,
        // Record the component responsible for creating this element.
        _owner: mt
      };
      return Ye._store = {}, Object.defineProperty(Ye._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ye, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: We
      }), Object.defineProperty(Ye, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: ut
      }), Object.freeze && (Object.freeze(Ye.props), Object.freeze(Ye)), Ye;
    };
    function qo(V, ge, Ae, We, ut) {
      {
        var mt, tt = {}, Ye = null, On = null;
        Ae !== void 0 && (te(Ae), Ye = "" + Ae), vt(ge) && (te(ge.key), Ye = "" + ge.key), it(ge) && (On = ge.ref, bt(ge, ut));
        for (mt in ge)
          fe.call(ge, mt) && !ye.hasOwnProperty(mt) && (tt[mt] = ge[mt]);
        if (V && V.defaultProps) {
          var Wt = V.defaultProps;
          for (mt in Wt)
            tt[mt] === void 0 && (tt[mt] = Wt[mt]);
        }
        if (Ye || On) {
          var nn = typeof V == "function" ? V.displayName || V.name || "Unknown" : V;
          Ye && si(tt, nn), On && li(tt, nn);
        }
        return Di(V, Ye, On, ut, We, le.current, tt);
      }
    }
    var ui = g.ReactCurrentOwner, Xi = g.ReactDebugCurrentFrame;
    function Rr(V) {
      if (V) {
        var ge = V._owner, Ae = de(V.type, V._source, ge ? ge.type : null);
        Xi.setExtraStackFrame(Ae);
      } else
        Xi.setExtraStackFrame(null);
    }
    var lh;
    lh = !1;
    function uh(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function i_() {
      {
        if (ui.current) {
          var V = R(ui.current.type);
          if (V)
            return `

Check the render method of \`` + V + "`.";
        }
        return "";
      }
    }
    function tI(V) {
      return "";
    }
    var o_ = {};
    function nI(V) {
      {
        var ge = i_();
        if (!ge) {
          var Ae = typeof V == "string" ? V : V.displayName || V.name;
          Ae && (ge = `

Check the top-level render call using <` + Ae + ">.");
        }
        return ge;
      }
    }
    function a_(V, ge) {
      {
        if (!V._store || V._store.validated || V.key != null)
          return;
        V._store.validated = !0;
        var Ae = nI(ge);
        if (o_[Ae])
          return;
        o_[Ae] = !0;
        var We = "";
        V && V._owner && V._owner !== ui.current && (We = " It was passed a child from " + R(V._owner.type) + "."), Rr(V), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Ae, We), Rr(null);
      }
    }
    function s_(V, ge) {
      {
        if (typeof V != "object")
          return;
        if (j(V))
          for (var Ae = 0; Ae < V.length; Ae++) {
            var We = V[Ae];
            uh(We) && a_(We, ge);
          }
        else if (uh(V))
          V._store && (V._store.validated = !0);
        else if (V) {
          var ut = m(V);
          if (typeof ut == "function" && ut !== V.entries)
            for (var mt = ut.call(V), tt; !(tt = mt.next()).done; )
              uh(tt.value) && a_(tt.value, ge);
        }
      }
    }
    function rI(V) {
      {
        var ge = V.type;
        if (ge == null || typeof ge == "string")
          return;
        var Ae;
        if (typeof ge == "function")
          Ae = ge.propTypes;
        else if (typeof ge == "object" && (ge.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ge.$$typeof === f))
          Ae = ge.propTypes;
        else
          return;
        if (Ae) {
          var We = R(ge);
          De(Ae, V.props, "prop", We, V);
        } else if (ge.PropTypes !== void 0 && !lh) {
          lh = !0;
          var ut = R(ge);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ut || "Unknown");
        }
        typeof ge.getDefaultProps == "function" && !ge.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function iI(V) {
      {
        for (var ge = Object.keys(V.props), Ae = 0; Ae < ge.length; Ae++) {
          var We = ge[Ae];
          if (We !== "children" && We !== "key") {
            Rr(V), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", We), Rr(null);
            break;
          }
        }
        V.ref !== null && (Rr(V), y("Invalid attribute `ref` supplied to `React.Fragment`."), Rr(null));
      }
    }
    var l_ = {};
    function u_(V, ge, Ae, We, ut, mt) {
      {
        var tt = E(V);
        if (!tt) {
          var Ye = "";
          (V === void 0 || typeof V == "object" && V !== null && Object.keys(V).length === 0) && (Ye += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var On = tI();
          On ? Ye += On : Ye += i_();
          var Wt;
          V === null ? Wt = "null" : j(V) ? Wt = "array" : V !== void 0 && V.$$typeof === t ? (Wt = "<" + (R(V.type) || "Unknown") + " />", Ye = " Did you accidentally export a JSX literal instead of a component?") : Wt = typeof V, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Wt, Ye);
        }
        var nn = qo(V, ge, Ae, ut, mt);
        if (nn == null)
          return nn;
        if (tt) {
          var fr = ge.children;
          if (fr !== void 0)
            if (We)
              if (j(fr)) {
                for (var Ka = 0; Ka < fr.length; Ka++)
                  s_(fr[Ka], V);
                Object.freeze && Object.freeze(fr);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              s_(fr, V);
        }
        if (fe.call(ge, "key")) {
          var Ho = R(V), Fn = Object.keys(ge).filter(function(cI) {
            return cI !== "key";
          }), ch = Fn.length > 0 ? "{key: someKey, " + Fn.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!l_[Ho + ch]) {
            var uI = Fn.length > 0 ? "{" + Fn.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ch, Ho, uI, Ho), l_[Ho + ch] = !0;
          }
        }
        return V === r ? iI(nn) : rI(nn), nn;
      }
    }
    function oI(V, ge, Ae) {
      return u_(V, ge, Ae, !0);
    }
    function aI(V, ge, Ae) {
      return u_(V, ge, Ae, !1);
    }
    var sI = aI, lI = oI;
    $l.Fragment = r, $l.jsx = sI, $l.jsxs = lI;
  })()), $l;
}
var d_;
function TI() {
  return d_ || (d_ = 1, process.env.NODE_ENV === "production" ? kc.exports = OI() : kc.exports = $I()), kc.exports;
}
var M = TI();
function kI() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = q2(t)) && (r && (r += " "), r += n);
  return r;
}
function q2(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = q2(e[r])) && (n && (n += " "), n += t);
  return n;
}
var sy = "-";
function PI(e) {
  var t = AI(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function o(s) {
    var l = s.split(sy);
    return l[0] === "" && l.length !== 1 && l.shift(), H2(l, t) || DI(s);
  }
  function a(s, l) {
    var u = n[s] || [];
    return l && i[s] ? [].concat(u, i[s]) : u;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function H2(e, t) {
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), i = r ? H2(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var o = e.join(sy);
    return t.validators.find(function(a) {
      var s = a.validator;
      return s(o);
    })?.classGroupId;
  }
}
var p_ = /^\[(.+)\]$/;
function DI(e) {
  if (p_.test(e)) {
    var t = p_.exec(e)[1], n = t?.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function AI(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = II(Object.entries(e.classGroups), n);
  return i.forEach(function(o) {
    var a = o[0], s = o[1];
    Uv(s, r, a, t);
  }), r;
}
function Uv(e, t, n, r) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var o = i === "" ? t : h_(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (CI(i)) {
        Uv(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(a) {
      var s = a[0], l = a[1];
      Uv(l, h_(t, s), n, r);
    });
  });
}
function h_(e, t) {
  var n = e;
  return t.split(sy).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function CI(e) {
  return e.isThemeGetter;
}
function II(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], i = n[1], o = i.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var l = s[0], u = s[1];
        return [t + l, u];
      })) : a;
    });
    return [r, o];
  }) : e;
}
function NI(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, a) {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return i(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : i(a, s);
    }
  };
}
var W2 = "!";
function RI(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], i = t.length;
  return function(a) {
    for (var s = [], l = 0, u = 0, c, f = 0; f < a.length; f++) {
      var d = a[f];
      if (l === 0) {
        if (d === r && (n || a.slice(f, f + i) === t)) {
          s.push(a.slice(u, f)), u = f + i;
          continue;
        }
        if (d === "/") {
          c = f;
          continue;
        }
      }
      d === "[" ? l++ : d === "]" && l--;
    }
    var p = s.length === 0 ? a : a.substring(u), h = p.startsWith(W2), v = h ? p.substring(1) : p, m = c && c > u ? c - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: h,
      baseClassName: v,
      maybePostfixModifierPosition: m
    };
  };
}
function MI(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var i = r[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function jI(e) {
  return {
    cache: NI(e.cacheSize),
    splitModifiers: RI(e),
    ...PI(e)
  };
}
var FI = /\s+/;
function zI(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, i = t.getConflictingClassGroupIds, o = /* @__PURE__ */ new Set();
  return e.trim().split(FI).map(function(a) {
    var s = n(a), l = s.modifiers, u = s.hasImportantModifier, c = s.baseClassName, f = s.maybePostfixModifierPosition, d = r(f ? c.substring(0, f) : c), p = !!f;
    if (!d) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (d = r(c), !d)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      p = !1;
    }
    var h = MI(l).join(":"), v = u ? h + W2 : h;
    return {
      isTailwindClass: !0,
      modifierId: v,
      classGroupId: d,
      originalClassName: a,
      hasPostfixModifier: p
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, l = a.classGroupId, u = a.hasPostfixModifier, c = s + l;
    return o.has(c) ? !1 : (o.add(c), i(l, u).forEach(function(f) {
      return o.add(s + f);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function LI() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, i, o, a = s;
  function s(u) {
    var c = t[0], f = t.slice(1), d = f.reduce(function(p, h) {
      return h(p);
    }, c());
    return r = jI(d), i = r.cache.get, o = r.cache.set, a = l, l(u);
  }
  function l(u) {
    var c = i(u);
    if (c)
      return c;
    var f = zI(u, r);
    return o(u, f), f;
  }
  return function() {
    return a(kI.apply(null, arguments));
  };
}
function Ot(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var Z2 = /^\[(?:([a-z-]+):)?(.+)\]$/i, VI = /^\d+\/\d+$/, BI = /* @__PURE__ */ new Set(["px", "full", "screen"]), UI = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, KI = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, qI = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Mr(e) {
  return ra(e) || BI.has(e) || VI.test(e) || Kv(e);
}
function Kv(e) {
  return ka(e, "length", QI);
}
function HI(e) {
  return ka(e, "size", G2);
}
function WI(e) {
  return ka(e, "position", G2);
}
function ZI(e) {
  return ka(e, "url", JI);
}
function Pc(e) {
  return ka(e, "number", ra);
}
function ra(e) {
  return !Number.isNaN(Number(e));
}
function GI(e) {
  return e.endsWith("%") && ra(e.slice(0, -1));
}
function Tl(e) {
  return v_(e) || ka(e, "number", v_);
}
function Qe(e) {
  return Z2.test(e);
}
function kl() {
  return !0;
}
function eo(e) {
  return UI.test(e);
}
function YI(e) {
  return ka(e, "", XI);
}
function ka(e, t, n) {
  var r = Z2.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function QI(e) {
  return KI.test(e);
}
function G2() {
  return !1;
}
function JI(e) {
  return e.startsWith("url(");
}
function v_(e) {
  return Number.isInteger(Number(e));
}
function XI(e) {
  return qI.test(e);
}
function e6() {
  var e = Ot("colors"), t = Ot("spacing"), n = Ot("blur"), r = Ot("brightness"), i = Ot("borderColor"), o = Ot("borderRadius"), a = Ot("borderSpacing"), s = Ot("borderWidth"), l = Ot("contrast"), u = Ot("grayscale"), c = Ot("hueRotate"), f = Ot("invert"), d = Ot("gap"), p = Ot("gradientColorStops"), h = Ot("gradientColorStopPositions"), v = Ot("inset"), m = Ot("margin"), g = Ot("opacity"), y = Ot("padding"), w = Ot("saturate"), x = Ot("scale"), S = Ot("sepia"), O = Ot("skew"), P = Ot("space"), b = Ot("translate"), _ = function() {
    return ["auto", "contain", "none"];
  }, E = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, A = function() {
    return ["auto", Qe, t];
  }, k = function() {
    return [Qe, t];
  }, R = function() {
    return ["", Mr];
  }, N = function() {
    return ["auto", ra, Qe];
  }, U = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, H = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, ee = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, ue = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, Q = function() {
    return ["", "0", Qe];
  }, $ = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, F = function() {
    return [ra, Pc];
  }, I = function() {
    return [ra, Qe];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [kl],
      spacing: [Mr],
      blur: ["none", "", eo, Qe],
      brightness: F(),
      borderColor: [e],
      borderRadius: ["none", "", "full", eo, Qe],
      borderSpacing: k(),
      borderWidth: R(),
      contrast: F(),
      grayscale: Q(),
      hueRotate: I(),
      invert: Q(),
      gap: k(),
      gradientColorStops: [e],
      gradientColorStopPositions: [GI, Kv],
      inset: A(),
      margin: A(),
      opacity: F(),
      padding: k(),
      saturate: F(),
      scale: F(),
      sepia: Q(),
      skew: I(),
      space: k(),
      translate: k()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Qe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [eo]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": $()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": $()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(U(), [Qe])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: E()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": E()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": E()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: _()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": _()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": _()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Tl]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: A()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Qe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Q()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Q()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Tl]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [kl]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Tl]
        }, Qe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": N()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": N()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [kl]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Tl]
        }, Qe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": N()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": N()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Qe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Qe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(ue())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(ue(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(ue(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [m]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [m]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [m]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [m]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [m]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [m]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [m]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [m]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [m]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", Qe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", Qe, Mr]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [eo]
        }, eo, Qe]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Qe, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", Qe, Mr]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Qe, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", eo, Kv]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Pc]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [kl]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Qe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ra, Pc]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Qe, Mr]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Qe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Qe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [g]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [g]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(H(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Mr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Qe, Mr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: k()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Qe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Qe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [g]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(U(), [WI])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", HI]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ZI]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [g]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(H(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [g]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: H()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(H())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Qe, Mr]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Mr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: R()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [g]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Mr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", eo, YI]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [kl]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [g]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": ee()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ee()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", eo, Qe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [w]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [S]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [g]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [w]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [S]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Qe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: I()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Qe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: I()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Qe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Tl, Qe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [b]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [b]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [O]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [O]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Qe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Qe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": k()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": k()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": k()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": k()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": k()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": k()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": k()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": k()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": k()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": k()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": k()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": k()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": k()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": k()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": k()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": k()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": k()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": k()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Qe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Mr, Pc]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var Un = /* @__PURE__ */ LI(e6);
function xle(e) {
  const { className: t, children: n, ...r } = e;
  return /* @__PURE__ */ M.jsx("div", { className: Un("p-8", t), ...r, children: /* @__PURE__ */ M.jsxs("div", { className: "border border-orange-2 p-4 bg-orange-100", children: [
    /* @__PURE__ */ M.jsx("h2", { className: "text-2xl mb-4", children: e.heading || "Note" }),
    n
  ] }) });
}
const Ele = (e) => /* @__PURE__ */ M.jsx("div", { ...e });
function Y2(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = Y2(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Q2() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = Y2(e)) && (r && (r += " "), r += t);
  return r;
}
const m_ = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, g_ = Q2, Pr = (e, t) => (n) => {
  var r;
  if (t?.variants == null) return g_(e, n?.class, n?.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((u) => {
    const c = n?.[u], f = o?.[u];
    if (c === null) return null;
    const d = m_(c) || m_(f);
    return i[u][d];
  }), s = n && Object.entries(n).reduce((u, c) => {
    let [f, d] = c;
    return d === void 0 || (u[f] = d), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, c) => {
    let { class: f, className: d, ...p } = c;
    return Object.entries(p).every((h) => {
      let [v, m] = h;
      return Array.isArray(m) ? m.includes({
        ...o,
        ...s
      }[v]) : {
        ...o,
        ...s
      }[v] === m;
    }) ? [
      ...u,
      f,
      d
    ] : u;
  }, []);
  return g_(e, a, l, n?.class, n?.className);
}, t6 = Pr(
  [
    "z-0",
    "flex-grow-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      variant: {
        green: "bg-green-400 focus:ring-green-400 hover:bg-green-500 disabled:bg-green-400",
        blue: "bg-blue-400",
        red: "bg-red-400 focus:ring-red-400 hover:bg-red-500 disabled:bg-red-400",
        gray: "text-black bg-neutral-200 focus:ring-gray-200 hover:bg-neutral-300 disabled:bg-neutral-200",
        black: "bg-black focus:ring-neutral-800 hover:bg-neutral-800 disabled:bg-neutral-800"
      }
    }
  }
), ly = ({
  variant: e = "black",
  className: t,
  ...n
}) => /* @__PURE__ */ M.jsx(
  "button",
  {
    ...n,
    className: Un(t6({ variant: e }), t)
  }
);
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
const n6 = {
  prefix: "fas",
  iconName: "bars",
  icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"]
}, r6 = {
  prefix: "fas",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
}, i6 = {
  prefix: "fas",
  iconName: "clipboard",
  icon: [384, 512, [128203], "f328", "M192 0c-41.8 0-77.4 26.7-90.5 64L64 64C28.7 64 0 92.7 0 128L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64l-37.5 0C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM112 192l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
}, o6 = {
  prefix: "fas",
  iconName: "user-gear",
  icon: [640, 512, ["user-cog"], "f4fe", "M224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM178.3 304l91.4 0c11.8 0 23.4 1.2 34.5 3.3c-2.1 18.5 7.4 35.6 21.8 44.8c-16.6 10.6-26.7 31.6-20 53.3c4 12.9 9.4 25.5 16.4 37.6s15.2 23.1 24.4 33c15.7 16.9 39.6 18.4 57.2 8.7l0 .9c0 9.2 2.7 18.5 7.9 26.3L29.7 512C13.3 512 0 498.7 0 482.3C0 383.8 79.8 304 178.3 304zM436 218.2c0-7 4.5-13.3 11.3-14.8c10.5-2.4 21.5-3.7 32.7-3.7s22.2 1.3 32.7 3.7c6.8 1.5 11.3 7.8 11.3 14.8l0 30.6c7.9 3.4 15.4 7.7 22.3 12.8l24.9-14.3c6.1-3.5 13.7-2.7 18.5 2.4c7.6 8.1 14.3 17.2 20.1 27.2s10.3 20.4 13.5 31c2.1 6.7-1.1 13.7-7.2 17.2l-25 14.4c.4 4 .7 8.1 .7 12.3s-.2 8.2-.7 12.3l25 14.4c6.1 3.5 9.2 10.5 7.2 17.2c-3.3 10.6-7.8 21-13.5 31s-12.5 19.1-20.1 27.2c-4.8 5.1-12.5 5.9-18.5 2.4l-24.9-14.3c-6.9 5.1-14.3 9.4-22.3 12.8l0 30.6c0 7-4.5 13.3-11.3 14.8c-10.5 2.4-21.5 3.7-32.7 3.7s-22.2-1.3-32.7-3.7c-6.8-1.5-11.3-7.8-11.3-14.8l0-30.5c-8-3.4-15.6-7.7-22.5-12.9l-24.7 14.3c-6.1 3.5-13.7 2.7-18.5-2.4c-7.6-8.1-14.3-17.2-20.1-27.2s-10.3-20.4-13.5-31c-2.1-6.7 1.1-13.7 7.2-17.2l24.8-14.3c-.4-4.1-.7-8.2-.7-12.4s.2-8.3 .7-12.4L343.8 325c-6.1-3.5-9.2-10.5-7.2-17.2c3.3-10.6 7.7-21 13.5-31s12.5-19.1 20.1-27.2c4.8-5.1 12.4-5.9 18.5-2.4l24.8 14.3c6.9-5.1 14.5-9.4 22.5-12.9l0-30.5zm92.1 133.5a48.1 48.1 0 1 0 -96.1 0 48.1 48.1 0 1 0 96.1 0z"]
}, a6 = o6, J2 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, s6 = {
  prefix: "fas",
  iconName: "x",
  icon: [384, 512, [120], "58", "M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z"]
};
/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
function l6(e, t, n) {
  return (t = c6(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function y_(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y_(Object(n), !0).forEach(function(r) {
      l6(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y_(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function u6(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function c6(e) {
  var t = u6(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const b_ = () => {
};
let uy = {}, X2 = {}, eO = null, tO = {
  mark: b_,
  measure: b_
};
try {
  typeof window < "u" && (uy = window), typeof document < "u" && (X2 = document), typeof MutationObserver < "u" && (eO = MutationObserver), typeof performance < "u" && (tO = performance);
} catch {
}
const {
  userAgent: __ = ""
} = uy.navigator || {}, Eo = uy, Pt = X2, w_ = eO, Dc = tO;
Eo.document;
const Yi = !!Pt.documentElement && !!Pt.head && typeof Pt.addEventListener == "function" && typeof Pt.createElement == "function", nO = ~__.indexOf("MSIE") || ~__.indexOf("Trident/");
var f6 = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, d6 = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, rO = {
  classic: {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fab: "brands",
    "fa-brands": "brands"
  },
  duotone: {
    fa: "solid",
    fad: "solid",
    "fa-solid": "solid",
    "fa-duotone": "solid",
    fadr: "regular",
    "fa-regular": "regular",
    fadl: "light",
    "fa-light": "light",
    fadt: "thin",
    "fa-thin": "thin"
  },
  sharp: {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light",
    fast: "thin",
    "fa-thin": "thin"
  },
  "sharp-duotone": {
    fa: "solid",
    fasds: "solid",
    "fa-solid": "solid",
    fasdr: "regular",
    "fa-regular": "regular",
    fasdl: "light",
    "fa-light": "light",
    fasdt: "thin",
    "fa-thin": "thin"
  }
}, p6 = {
  GROUP: "duotone-group",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, iO = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], En = "classic", Zd = "duotone", h6 = "sharp", v6 = "sharp-duotone", oO = [En, Zd, h6, v6], m6 = {
  classic: {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  duotone: {
    900: "fad",
    400: "fadr",
    300: "fadl",
    100: "fadt"
  },
  sharp: {
    900: "fass",
    400: "fasr",
    300: "fasl",
    100: "fast"
  },
  "sharp-duotone": {
    900: "fasds",
    400: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, g6 = {
  "Font Awesome 6 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 6 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  },
  "Font Awesome 6 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 6 Duotone": {
    900: "fad",
    400: "fadr",
    normal: "fadr",
    300: "fadl",
    100: "fadt"
  },
  "Font Awesome 6 Sharp": {
    900: "fass",
    400: "fasr",
    normal: "fasr",
    300: "fasl",
    100: "fast"
  },
  "Font Awesome 6 Sharp Duotone": {
    900: "fasds",
    400: "fasdr",
    normal: "fasdr",
    300: "fasdl",
    100: "fasdt"
  }
}, y6 = /* @__PURE__ */ new Map([["classic", {
  defaultShortPrefixId: "fas",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin", "brands"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp", {
  defaultShortPrefixId: "fass",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["duotone", {
  defaultShortPrefixId: "fad",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}], ["sharp-duotone", {
  defaultShortPrefixId: "fasds",
  defaultStyleId: "solid",
  styleIds: ["solid", "regular", "light", "thin"],
  futureStyleIds: [],
  defaultFontWeight: 900
}]]), b6 = {
  classic: {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    brands: "fab"
  },
  duotone: {
    solid: "fad",
    regular: "fadr",
    light: "fadl",
    thin: "fadt"
  },
  sharp: {
    solid: "fass",
    regular: "fasr",
    light: "fasl",
    thin: "fast"
  },
  "sharp-duotone": {
    solid: "fasds",
    regular: "fasdr",
    light: "fasdl",
    thin: "fasdt"
  }
}, _6 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], x_ = {
  kit: {
    fak: "kit",
    "fa-kit": "kit"
  },
  "kit-duotone": {
    fakd: "kit-duotone",
    "fa-kit-duotone": "kit-duotone"
  }
}, w6 = ["kit"], x6 = {
  kit: {
    "fa-kit": "fak"
  }
}, E6 = ["fak", "fakd"], S6 = {
  kit: {
    fak: "fa-kit"
  }
}, E_ = {
  kit: {
    kit: "fak"
  },
  "kit-duotone": {
    "kit-duotone": "fakd"
  }
}, Ac = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, O6 = ["fa-classic", "fa-duotone", "fa-sharp", "fa-sharp-duotone"], $6 = ["fak", "fa-kit", "fakd", "fa-kit-duotone"], T6 = {
  "Font Awesome Kit": {
    400: "fak",
    normal: "fak"
  },
  "Font Awesome Kit Duotone": {
    400: "fakd",
    normal: "fakd"
  }
}, k6 = {
  classic: {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  },
  duotone: {
    "fa-regular": "fadr",
    "fa-light": "fadl",
    "fa-thin": "fadt"
  },
  sharp: {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl",
    "fa-thin": "fast"
  },
  "sharp-duotone": {
    "fa-solid": "fasds",
    "fa-regular": "fasdr",
    "fa-light": "fasdl",
    "fa-thin": "fasdt"
  }
}, P6 = {
  classic: ["fas", "far", "fal", "fat", "fad"],
  duotone: ["fadr", "fadl", "fadt"],
  sharp: ["fass", "fasr", "fasl", "fast"],
  "sharp-duotone": ["fasds", "fasdr", "fasdl", "fasdt"]
}, qv = {
  classic: {
    fab: "fa-brands",
    fad: "fa-duotone",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  },
  duotone: {
    fadr: "fa-regular",
    fadl: "fa-light",
    fadt: "fa-thin"
  },
  sharp: {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light",
    fast: "fa-thin"
  },
  "sharp-duotone": {
    fasds: "fa-solid",
    fasdr: "fa-regular",
    fasdl: "fa-light",
    fasdt: "fa-thin"
  }
}, D6 = ["fa-solid", "fa-regular", "fa-light", "fa-thin", "fa-duotone", "fa-brands"], Hv = ["fa", "fas", "far", "fal", "fat", "fad", "fadr", "fadl", "fadt", "fab", "fass", "fasr", "fasl", "fast", "fasds", "fasdr", "fasdl", "fasdt", ...O6, ...D6], A6 = ["solid", "regular", "light", "thin", "duotone", "brands"], aO = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], C6 = aO.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), I6 = [...Object.keys(P6), ...A6, "2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", Ac.GROUP, Ac.SWAP_OPACITY, Ac.PRIMARY, Ac.SECONDARY].concat(aO.map((e) => "".concat(e, "x"))).concat(C6.map((e) => "w-".concat(e))), N6 = {
  "Font Awesome 5 Free": {
    900: "fas",
    400: "far"
  },
  "Font Awesome 5 Pro": {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal"
  },
  "Font Awesome 5 Brands": {
    400: "fab",
    normal: "fab"
  },
  "Font Awesome 5 Duotone": {
    900: "fad"
  }
};
const zi = "___FONT_AWESOME___", Wv = 16, sO = "fa", lO = "svg-inline--fa", pa = "data-fa-i2svg", Zv = "data-fa-pseudo-element", R6 = "data-fa-pseudo-element-pending", cy = "data-prefix", fy = "data-icon", S_ = "fontawesome-i2svg", M6 = "async", j6 = ["HTML", "HEAD", "STYLE", "SCRIPT"], uO = (() => {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
})();
function ec(e) {
  return new Proxy(e, {
    get(t, n) {
      return n in t ? t[n] : t[En];
    }
  });
}
const cO = be({}, rO);
cO[En] = be(be(be(be({}, {
  "fa-duotone": "duotone"
}), rO[En]), x_.kit), x_["kit-duotone"]);
const F6 = ec(cO), Gv = be({}, b6);
Gv[En] = be(be(be(be({}, {
  duotone: "fad"
}), Gv[En]), E_.kit), E_["kit-duotone"]);
const O_ = ec(Gv), Yv = be({}, qv);
Yv[En] = be(be({}, Yv[En]), S6.kit);
const dy = ec(Yv), Qv = be({}, k6);
Qv[En] = be(be({}, Qv[En]), x6.kit);
ec(Qv);
const z6 = f6, fO = "fa-layers-text", L6 = d6, V6 = be({}, m6);
ec(V6);
const B6 = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], dh = p6, U6 = [...w6, ...I6], Xl = Eo.FontAwesomeConfig || {};
function K6(e) {
  var t = Pt.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function q6(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
Pt && typeof Pt.querySelector == "function" && [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach((t) => {
  let [n, r] = t;
  const i = q6(K6(n));
  i != null && (Xl[r] = i);
});
const dO = {
  styleDefault: "solid",
  familyDefault: En,
  cssPrefix: sO,
  replacementClass: lO,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Xl.familyPrefix && (Xl.cssPrefix = Xl.familyPrefix);
const ks = be(be({}, dO), Xl);
ks.autoReplaceSvg || (ks.observeMutations = !1);
const Ve = {};
Object.keys(dO).forEach((e) => {
  Object.defineProperty(Ve, e, {
    enumerable: !0,
    set: function(t) {
      ks[e] = t, eu.forEach((n) => n(Ve));
    },
    get: function() {
      return ks[e];
    }
  });
});
Object.defineProperty(Ve, "familyPrefix", {
  enumerable: !0,
  set: function(e) {
    ks.cssPrefix = e, eu.forEach((t) => t(Ve));
  },
  get: function() {
    return ks.cssPrefix;
  }
});
Eo.FontAwesomeConfig = Ve;
const eu = [];
function H6(e) {
  return eu.push(e), () => {
    eu.splice(eu.indexOf(e), 1);
  };
}
const to = Wv, yi = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function W6(e) {
  if (!e || !Yi)
    return;
  const t = Pt.createElement("style");
  t.setAttribute("type", "text/css"), t.innerHTML = e;
  const n = Pt.head.childNodes;
  let r = null;
  for (let i = n.length - 1; i > -1; i--) {
    const o = n[i], a = (o.tagName || "").toUpperCase();
    ["STYLE", "LINK"].indexOf(a) > -1 && (r = o);
  }
  return Pt.head.insertBefore(t, r), e;
}
const Z6 = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function _u() {
  let e = 12, t = "";
  for (; e-- > 0; )
    t += Z6[Math.random() * 62 | 0];
  return t;
}
function Ys(e) {
  const t = [];
  for (let n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function py(e) {
  return e.classList ? Ys(e.classList) : (e.getAttribute("class") || "").split(" ").filter((t) => t);
}
function pO(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function G6(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, '="').concat(pO(e[n]), '" '), "").trim();
}
function Gd(e) {
  return Object.keys(e || {}).reduce((t, n) => t + "".concat(n, ": ").concat(e[n].trim(), ";"), "");
}
function hy(e) {
  return e.size !== yi.size || e.x !== yi.x || e.y !== yi.y || e.rotate !== yi.rotate || e.flipX || e.flipY;
}
function Y6(e) {
  let {
    transform: t,
    containerWidth: n,
    iconWidth: r
  } = e;
  const i = {
    transform: "translate(".concat(n / 2, " 256)")
  }, o = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), l = {
    transform: "".concat(o, " ").concat(a, " ").concat(s)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: i,
    inner: l,
    path: u
  };
}
function Q6(e) {
  let {
    transform: t,
    width: n = Wv,
    height: r = Wv,
    startCentered: i = !1
  } = e, o = "";
  return i && nO ? o += "translate(".concat(t.x / to - n / 2, "em, ").concat(t.y / to - r / 2, "em) ") : i ? o += "translate(calc(-50% + ".concat(t.x / to, "em), calc(-50% + ").concat(t.y / to, "em)) ") : o += "translate(".concat(t.x / to, "em, ").concat(t.y / to, "em) "), o += "scale(".concat(t.size / to * (t.flipX ? -1 : 1), ", ").concat(t.size / to * (t.flipY ? -1 : 1), ") "), o += "rotate(".concat(t.rotate, "deg) "), o;
}
var J6 = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";
  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";
  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-counter-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  transform: scale(var(--fa-layers-scale, 0.25));
  transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%, 90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%, 24% {
    transform: rotate(-18deg);
  }
  12%, 28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%, 100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}

.fa-rotate-180 {
  transform: rotate(180deg);
}

.fa-rotate-270 {
  transform: rotate(270deg);
}

.fa-flip-horizontal {
  transform: scale(-1, 1);
}

.fa-flip-vertical {
  transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}

.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}`;
function hO() {
  const e = sO, t = lO, n = Ve.cssPrefix, r = Ve.replacementClass;
  let i = J6;
  if (n !== e || r !== t) {
    const o = new RegExp("\\.".concat(e, "\\-"), "g"), a = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    i = i.replace(o, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return i;
}
let $_ = !1;
function ph() {
  Ve.autoAddCss && !$_ && (W6(hO()), $_ = !0);
}
var X6 = {
  mixout() {
    return {
      dom: {
        css: hO,
        insertCss: ph
      }
    };
  },
  hooks() {
    return {
      beforeDOMElementCreation() {
        ph();
      },
      beforeI2svg() {
        ph();
      }
    };
  }
};
const Li = Eo || {};
Li[zi] || (Li[zi] = {});
Li[zi].styles || (Li[zi].styles = {});
Li[zi].hooks || (Li[zi].hooks = {});
Li[zi].shims || (Li[zi].shims = []);
var bi = Li[zi];
const vO = [], mO = function() {
  Pt.removeEventListener("DOMContentLoaded", mO), Uf = 1, vO.map((e) => e());
};
let Uf = !1;
Yi && (Uf = (Pt.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(Pt.readyState), Uf || Pt.addEventListener("DOMContentLoaded", mO));
function eN(e) {
  Yi && (Uf ? setTimeout(e, 0) : vO.push(e));
}
function tc(e) {
  const {
    tag: t,
    attributes: n = {},
    children: r = []
  } = e;
  return typeof e == "string" ? pO(e) : "<".concat(t, " ").concat(G6(n), ">").concat(r.map(tc).join(""), "</").concat(t, ">");
}
function T_(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var hh = function(t, n, r, i) {
  var o = Object.keys(t), a = o.length, s = n, l, u, c;
  for (r === void 0 ? (l = 1, c = t[o[0]]) : (l = 0, c = r); l < a; l++)
    u = o[l], c = s(c, t[u], u, t);
  return c;
};
function tN(e) {
  const t = [];
  let n = 0;
  const r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n++);
    if (i >= 55296 && i <= 56319 && n < r) {
      const o = e.charCodeAt(n++);
      (o & 64512) == 56320 ? t.push(((i & 1023) << 10) + (o & 1023) + 65536) : (t.push(i), n--);
    } else
      t.push(i);
  }
  return t;
}
function Jv(e) {
  const t = tN(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function nN(e, t) {
  const n = e.length;
  let r = e.charCodeAt(t), i;
  return r >= 55296 && r <= 56319 && n > t + 1 && (i = e.charCodeAt(t + 1), i >= 56320 && i <= 57343) ? (r - 55296) * 1024 + i - 56320 + 65536 : r;
}
function k_(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function Xv(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const {
    skipHooks: r = !1
  } = n, i = k_(t);
  typeof bi.hooks.addPack == "function" && !r ? bi.hooks.addPack(e, k_(t)) : bi.styles[e] = be(be({}, bi.styles[e] || {}), i), e === "fas" && Xv("fa", t);
}
const {
  styles: wu,
  shims: rN
} = bi, gO = Object.keys(dy), iN = gO.reduce((e, t) => (e[t] = Object.keys(dy[t]), e), {});
let vy = null, yO = {}, bO = {}, _O = {}, wO = {}, xO = {};
function oN(e) {
  return ~U6.indexOf(e);
}
function aN(e, t) {
  const n = t.split("-"), r = n[0], i = n.slice(1).join("-");
  return r === e && i !== "" && !oN(i) ? i : null;
}
const EO = () => {
  const e = (r) => hh(wu, (i, o, a) => (i[a] = hh(o, r, {}), i), {});
  yO = e((r, i, o) => (i[3] && (r[i[3]] = o), i[2] && i[2].filter((s) => typeof s == "number").forEach((s) => {
    r[s.toString(16)] = o;
  }), r)), bO = e((r, i, o) => (r[o] = o, i[2] && i[2].filter((s) => typeof s == "string").forEach((s) => {
    r[s] = o;
  }), r)), xO = e((r, i, o) => {
    const a = i[2];
    return r[o] = o, a.forEach((s) => {
      r[s] = o;
    }), r;
  });
  const t = "far" in wu || Ve.autoFetchSvg, n = hh(rN, (r, i) => {
    const o = i[0];
    let a = i[1];
    const s = i[2];
    return a === "far" && !t && (a = "fas"), typeof o == "string" && (r.names[o] = {
      prefix: a,
      iconName: s
    }), typeof o == "number" && (r.unicodes[o.toString(16)] = {
      prefix: a,
      iconName: s
    }), r;
  }, {
    names: {},
    unicodes: {}
  });
  _O = n.names, wO = n.unicodes, vy = Yd(Ve.styleDefault, {
    family: Ve.familyDefault
  });
};
H6((e) => {
  vy = Yd(e.styleDefault, {
    family: Ve.familyDefault
  });
});
EO();
function my(e, t) {
  return (yO[e] || {})[t];
}
function sN(e, t) {
  return (bO[e] || {})[t];
}
function ia(e, t) {
  return (xO[e] || {})[t];
}
function SO(e) {
  return _O[e] || {
    prefix: null,
    iconName: null
  };
}
function lN(e) {
  const t = wO[e], n = my("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function So() {
  return vy;
}
const OO = () => ({
  prefix: null,
  iconName: null,
  rest: []
});
function uN(e) {
  let t = En;
  const n = gO.reduce((r, i) => (r[i] = "".concat(Ve.cssPrefix, "-").concat(i), r), {});
  return oO.forEach((r) => {
    (e.includes(n[r]) || e.some((i) => iN[r].includes(i))) && (t = r);
  }), t;
}
function Yd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    family: n = En
  } = t, r = F6[n][e];
  if (n === Zd && !e)
    return "fad";
  const i = O_[n][e] || O_[n][r], o = e in bi.styles ? e : null;
  return i || o || null;
}
function cN(e) {
  let t = [], n = null;
  return e.forEach((r) => {
    const i = aN(Ve.cssPrefix, r);
    i ? n = i : r && t.push(r);
  }), {
    iconName: n,
    rest: t
  };
}
function P_(e) {
  return e.sort().filter((t, n, r) => r.indexOf(t) === n);
}
function Qd(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    skipLookups: n = !1
  } = t;
  let r = null;
  const i = Hv.concat($6), o = P_(e.filter((f) => i.includes(f))), a = P_(e.filter((f) => !Hv.includes(f))), s = o.filter((f) => (r = f, !iO.includes(f))), [l = null] = s, u = uN(o), c = be(be({}, cN(a)), {}, {
    prefix: Yd(l, {
      family: u
    })
  });
  return be(be(be({}, c), hN({
    values: e,
    family: u,
    styles: wu,
    config: Ve,
    canonical: c,
    givenPrefix: r
  })), fN(n, r, c));
}
function fN(e, t, n) {
  let {
    prefix: r,
    iconName: i
  } = n;
  if (e || !r || !i)
    return {
      prefix: r,
      iconName: i
    };
  const o = t === "fa" ? SO(i) : {}, a = ia(r, i);
  return i = o.iconName || a || i, r = o.prefix || r, r === "far" && !wu.far && wu.fas && !Ve.autoFetchSvg && (r = "fas"), {
    prefix: r,
    iconName: i
  };
}
const dN = oO.filter((e) => e !== En || e !== Zd), pN = Object.keys(qv).filter((e) => e !== En).map((e) => Object.keys(qv[e])).flat();
function hN(e) {
  const {
    values: t,
    family: n,
    canonical: r,
    givenPrefix: i = "",
    styles: o = {},
    config: a = {}
  } = e, s = n === Zd, l = t.includes("fa-duotone") || t.includes("fad"), u = a.familyDefault === "duotone", c = r.prefix === "fad" || r.prefix === "fa-duotone";
  if (!s && (l || u || c) && (r.prefix = "fad"), (t.includes("fa-brands") || t.includes("fab")) && (r.prefix = "fab"), !r.prefix && dN.includes(n) && (Object.keys(o).find((d) => pN.includes(d)) || a.autoFetchSvg)) {
    const d = y6.get(n).defaultShortPrefixId;
    r.prefix = d, r.iconName = ia(r.prefix, r.iconName) || r.iconName;
  }
  return (r.prefix === "fa" || i === "fa") && (r.prefix = So() || "fas"), r;
}
class vN {
  constructor() {
    this.definitions = {};
  }
  add() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    const i = n.reduce(this._pullDefinitions, {});
    Object.keys(i).forEach((o) => {
      this.definitions[o] = be(be({}, this.definitions[o] || {}), i[o]), Xv(o, i[o]);
      const a = dy[En][o];
      a && Xv(a, i[o]), EO();
    });
  }
  reset() {
    this.definitions = {};
  }
  _pullDefinitions(t, n) {
    const r = n.prefix && n.iconName && n.icon ? {
      0: n
    } : n;
    return Object.keys(r).map((i) => {
      const {
        prefix: o,
        iconName: a,
        icon: s
      } = r[i], l = s[2];
      t[o] || (t[o] = {}), l.length > 0 && l.forEach((u) => {
        typeof u == "string" && (t[o][u] = s);
      }), t[o][a] = s;
    }), t;
  }
}
let D_ = [], ns = {};
const gs = {}, mN = Object.keys(gs);
function gN(e, t) {
  let {
    mixoutsTo: n
  } = t;
  return D_ = e, ns = {}, Object.keys(gs).forEach((r) => {
    mN.indexOf(r) === -1 && delete gs[r];
  }), D_.forEach((r) => {
    const i = r.mixout ? r.mixout() : {};
    if (Object.keys(i).forEach((o) => {
      typeof i[o] == "function" && (n[o] = i[o]), typeof i[o] == "object" && Object.keys(i[o]).forEach((a) => {
        n[o] || (n[o] = {}), n[o][a] = i[o][a];
      });
    }), r.hooks) {
      const o = r.hooks();
      Object.keys(o).forEach((a) => {
        ns[a] || (ns[a] = []), ns[a].push(o[a]);
      });
    }
    r.provides && r.provides(gs);
  }), n;
}
function em(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), i = 2; i < n; i++)
    r[i - 2] = arguments[i];
  return (ns[e] || []).forEach((a) => {
    t = a.apply(null, [t, ...r]);
  }), t;
}
function ha(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  (ns[e] || []).forEach((o) => {
    o.apply(null, n);
  });
}
function Oo() {
  const e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return gs[e] ? gs[e].apply(null, t) : void 0;
}
function tm(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  let {
    iconName: t
  } = e;
  const n = e.prefix || So();
  if (t)
    return t = ia(n, t) || t, T_($O.definitions, n, t) || T_(bi.styles, n, t);
}
const $O = new vN(), yN = () => {
  Ve.autoReplaceSvg = !1, Ve.observeMutations = !1, ha("noAuto");
}, bN = {
  i2svg: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Yi ? (ha("beforeI2svg", e), Oo("pseudoElements2svg", e), Oo("i2svg", e)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
  },
  watch: function() {
    let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const {
      autoReplaceSvgRoot: t
    } = e;
    Ve.autoReplaceSvg === !1 && (Ve.autoReplaceSvg = !0), Ve.observeMutations = !0, eN(() => {
      wN({
        autoReplaceSvgRoot: t
      }), ha("watch", e);
    });
  }
}, _N = {
  icon: (e) => {
    if (e === null)
      return null;
    if (typeof e == "object" && e.prefix && e.iconName)
      return {
        prefix: e.prefix,
        iconName: ia(e.prefix, e.iconName) || e.iconName
      };
    if (Array.isArray(e) && e.length === 2) {
      const t = e[1].indexOf("fa-") === 0 ? e[1].slice(3) : e[1], n = Yd(e[0]);
      return {
        prefix: n,
        iconName: ia(n, t) || t
      };
    }
    if (typeof e == "string" && (e.indexOf("".concat(Ve.cssPrefix, "-")) > -1 || e.match(z6))) {
      const t = Qd(e.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: t.prefix || So(),
        iconName: ia(t.prefix, t.iconName) || t.iconName
      };
    }
    if (typeof e == "string") {
      const t = So();
      return {
        prefix: t,
        iconName: ia(t, e) || e
      };
    }
  }
}, ur = {
  noAuto: yN,
  config: Ve,
  dom: bN,
  parse: _N,
  library: $O,
  findIconDefinition: tm,
  toHtml: tc
}, wN = function() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  const {
    autoReplaceSvgRoot: t = Pt
  } = e;
  (Object.keys(bi.styles).length > 0 || Ve.autoFetchSvg) && Yi && Ve.autoReplaceSvg && ur.dom.i2svg({
    node: t
  });
};
function Jd(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map((n) => tc(n));
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (!Yi) return;
      const n = Pt.createElement("div");
      return n.innerHTML = e.html, n.children;
    }
  }), e;
}
function xN(e) {
  let {
    children: t,
    main: n,
    mask: r,
    attributes: i,
    styles: o,
    transform: a
  } = e;
  if (hy(a) && n.found && !r.found) {
    const {
      width: s,
      height: l
    } = n, u = {
      x: s / l / 2,
      y: 0.5
    };
    i.style = Gd(be(be({}, o), {}, {
      "transform-origin": "".concat(u.x + a.x / 16, "em ").concat(u.y + a.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: i,
    children: t
  }];
}
function EN(e) {
  let {
    prefix: t,
    iconName: n,
    children: r,
    attributes: i,
    symbol: o
  } = e;
  const a = o === !0 ? "".concat(t, "-").concat(Ve.cssPrefix, "-").concat(n) : o;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: be(be({}, i), {}, {
        id: a
      }),
      children: r
    }]
  }];
}
function gy(e) {
  const {
    icons: {
      main: t,
      mask: n
    },
    prefix: r,
    iconName: i,
    transform: o,
    symbol: a,
    title: s,
    maskId: l,
    titleId: u,
    extra: c,
    watchable: f = !1
  } = e, {
    width: d,
    height: p
  } = n.found ? n : t, h = E6.includes(r), v = [Ve.replacementClass, i ? "".concat(Ve.cssPrefix, "-").concat(i) : ""].filter((S) => c.classes.indexOf(S) === -1).filter((S) => S !== "" || !!S).concat(c.classes).join(" ");
  let m = {
    children: [],
    attributes: be(be({}, c.attributes), {}, {
      "data-prefix": r,
      "data-icon": i,
      class: v,
      role: c.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(d, " ").concat(p)
    })
  };
  const g = h && !~c.classes.indexOf("fa-fw") ? {
    width: "".concat(d / p * 16 * 0.0625, "em")
  } : {};
  f && (m.attributes[pa] = ""), s && (m.children.push({
    tag: "title",
    attributes: {
      id: m.attributes["aria-labelledby"] || "title-".concat(u || _u())
    },
    children: [s]
  }), delete m.attributes.title);
  const y = be(be({}, m), {}, {
    prefix: r,
    iconName: i,
    main: t,
    mask: n,
    maskId: l,
    transform: o,
    symbol: a,
    styles: be(be({}, g), c.styles)
  }), {
    children: w,
    attributes: x
  } = n.found && t.found ? Oo("generateAbstractMask", y) || {
    children: [],
    attributes: {}
  } : Oo("generateAbstractIcon", y) || {
    children: [],
    attributes: {}
  };
  return y.children = w, y.attributes = x, a ? EN(y) : xN(y);
}
function A_(e) {
  const {
    content: t,
    width: n,
    height: r,
    transform: i,
    title: o,
    extra: a,
    watchable: s = !1
  } = e, l = be(be(be({}, a.attributes), o ? {
    title: o
  } : {}), {}, {
    class: a.classes.join(" ")
  });
  s && (l[pa] = "");
  const u = be({}, a.styles);
  hy(i) && (u.transform = Q6({
    transform: i,
    startCentered: !0,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  const c = Gd(u);
  c.length > 0 && (l.style = c);
  const f = [];
  return f.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), o && f.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [o]
  }), f;
}
function SN(e) {
  const {
    content: t,
    title: n,
    extra: r
  } = e, i = be(be(be({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), o = Gd(r.styles);
  o.length > 0 && (i.style = o);
  const a = [];
  return a.push({
    tag: "span",
    attributes: i,
    children: [t]
  }), n && a.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), a;
}
const {
  styles: vh
} = bi;
function nm(e) {
  const t = e[0], n = e[1], [r] = e.slice(4);
  let i = null;
  return Array.isArray(r) ? i = {
    tag: "g",
    attributes: {
      class: "".concat(Ve.cssPrefix, "-").concat(dh.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(Ve.cssPrefix, "-").concat(dh.SECONDARY),
        fill: "currentColor",
        d: r[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(Ve.cssPrefix, "-").concat(dh.PRIMARY),
        fill: "currentColor",
        d: r[1]
      }
    }]
  } : i = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: r
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: i
  };
}
const ON = {
  found: !1,
  width: 512,
  height: 512
};
function $N(e, t) {
  !uO && !Ve.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function rm(e, t) {
  let n = t;
  return t === "fa" && Ve.styleDefault !== null && (t = So()), new Promise((r, i) => {
    if (n === "fa") {
      const o = SO(e) || {};
      e = o.iconName || e, t = o.prefix || t;
    }
    if (e && t && vh[t] && vh[t][e]) {
      const o = vh[t][e];
      return r(nm(o));
    }
    $N(e, t), r(be(be({}, ON), {}, {
      icon: Ve.showMissingIcons && e ? Oo("missingIconAbstract") || {} : {}
    }));
  });
}
const C_ = () => {
}, im = Ve.measurePerformance && Dc && Dc.mark && Dc.measure ? Dc : {
  mark: C_,
  measure: C_
}, Vl = 'FA "6.7.2"', TN = (e) => (im.mark("".concat(Vl, " ").concat(e, " begins")), () => TO(e)), TO = (e) => {
  im.mark("".concat(Vl, " ").concat(e, " ends")), im.measure("".concat(Vl, " ").concat(e), "".concat(Vl, " ").concat(e, " begins"), "".concat(Vl, " ").concat(e, " ends"));
};
var yy = {
  begin: TN,
  end: TO
};
const gf = () => {
};
function I_(e) {
  return typeof (e.getAttribute ? e.getAttribute(pa) : null) == "string";
}
function kN(e) {
  const t = e.getAttribute ? e.getAttribute(cy) : null, n = e.getAttribute ? e.getAttribute(fy) : null;
  return t && n;
}
function PN(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(Ve.replacementClass);
}
function DN() {
  return Ve.autoReplaceSvg === !0 ? yf.replace : yf[Ve.autoReplaceSvg] || yf.replace;
}
function AN(e) {
  return Pt.createElementNS("http://www.w3.org/2000/svg", e);
}
function CN(e) {
  return Pt.createElement(e);
}
function kO(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    ceFn: n = e.tag === "svg" ? AN : CN
  } = t;
  if (typeof e == "string")
    return Pt.createTextNode(e);
  const r = n(e.tag);
  return Object.keys(e.attributes || []).forEach(function(o) {
    r.setAttribute(o, e.attributes[o]);
  }), (e.children || []).forEach(function(o) {
    r.appendChild(kO(o, {
      ceFn: n
    }));
  }), r;
}
function IN(e) {
  let t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
const yf = {
  replace: function(e) {
    const t = e[0];
    if (t.parentNode)
      if (e[1].forEach((n) => {
        t.parentNode.insertBefore(kO(n), t);
      }), t.getAttribute(pa) === null && Ve.keepOriginalSource) {
        let n = Pt.createComment(IN(t));
        t.parentNode.replaceChild(n, t);
      } else
        t.remove();
  },
  nest: function(e) {
    const t = e[0], n = e[1];
    if (~py(t).indexOf(Ve.replacementClass))
      return yf.replace(e);
    const r = new RegExp("".concat(Ve.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      const o = n[0].attributes.class.split(" ").reduce((a, s) => (s === Ve.replacementClass || s.match(r) ? a.toSvg.push(s) : a.toNode.push(s), a), {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), o.toNode.length === 0 ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    const i = n.map((o) => tc(o)).join(`
`);
    t.setAttribute(pa, ""), t.innerHTML = i;
  }
};
function N_(e) {
  e();
}
function PO(e, t) {
  const n = typeof t == "function" ? t : gf;
  if (e.length === 0)
    n();
  else {
    let r = N_;
    Ve.mutateApproach === M6 && (r = Eo.requestAnimationFrame || N_), r(() => {
      const i = DN(), o = yy.begin("mutate");
      e.map(i), o(), n();
    });
  }
}
let by = !1;
function DO() {
  by = !0;
}
function om() {
  by = !1;
}
let Kf = null;
function R_(e) {
  if (!w_ || !Ve.observeMutations)
    return;
  const {
    treeCallback: t = gf,
    nodeCallback: n = gf,
    pseudoElementsCallback: r = gf,
    observeMutationsRoot: i = Pt
  } = e;
  Kf = new w_((o) => {
    if (by) return;
    const a = So();
    Ys(o).forEach((s) => {
      if (s.type === "childList" && s.addedNodes.length > 0 && !I_(s.addedNodes[0]) && (Ve.searchPseudoElements && r(s.target), t(s.target)), s.type === "attributes" && s.target.parentNode && Ve.searchPseudoElements && r(s.target.parentNode), s.type === "attributes" && I_(s.target) && ~B6.indexOf(s.attributeName))
        if (s.attributeName === "class" && kN(s.target)) {
          const {
            prefix: l,
            iconName: u
          } = Qd(py(s.target));
          s.target.setAttribute(cy, l || a), u && s.target.setAttribute(fy, u);
        } else PN(s.target) && n(s.target);
    });
  }), Yi && Kf.observe(i, {
    childList: !0,
    attributes: !0,
    characterData: !0,
    subtree: !0
  });
}
function NN() {
  Kf && Kf.disconnect();
}
function RN(e) {
  const t = e.getAttribute("style");
  let n = [];
  return t && (n = t.split(";").reduce((r, i) => {
    const o = i.split(":"), a = o[0], s = o.slice(1);
    return a && s.length > 0 && (r[a] = s.join(":").trim()), r;
  }, {})), n;
}
function MN(e) {
  const t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "";
  let i = Qd(py(e));
  return i.prefix || (i.prefix = So()), t && n && (i.prefix = t, i.iconName = n), i.iconName && i.prefix || (i.prefix && r.length > 0 && (i.iconName = sN(i.prefix, e.innerText) || my(i.prefix, Jv(e.innerText))), !i.iconName && Ve.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (i.iconName = e.firstChild.data)), i;
}
function jN(e) {
  const t = Ys(e.attributes).reduce((i, o) => (i.name !== "class" && i.name !== "style" && (i[o.name] = o.value), i), {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return Ve.autoA11y && (n ? t["aria-labelledby"] = "".concat(Ve.replacementClass, "-title-").concat(r || _u()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function FN() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: yi,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function M_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  };
  const {
    iconName: n,
    prefix: r,
    rest: i
  } = MN(e), o = jN(e), a = em("parseNodeAttributes", {}, e);
  let s = t.styleParser ? RN(e) : [];
  return be({
    iconName: n,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: r,
    transform: yi,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: s,
      attributes: o
    }
  }, a);
}
const {
  styles: zN
} = bi;
function AO(e) {
  const t = Ve.autoReplaceSvg === "nest" ? M_(e, {
    styleParser: !1
  }) : M_(e);
  return ~t.extra.classes.indexOf(fO) ? Oo("generateLayersText", e, t) : Oo("generateSvgReplacementMutation", e, t);
}
function LN() {
  return [..._6, ...Hv];
}
function j_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Yi) return Promise.resolve();
  const n = Pt.documentElement.classList, r = (c) => n.add("".concat(S_, "-").concat(c)), i = (c) => n.remove("".concat(S_, "-").concat(c)), o = Ve.autoFetchSvg ? LN() : iO.concat(Object.keys(zN));
  o.includes("fa") || o.push("fa");
  const a = [".".concat(fO, ":not([").concat(pa, "])")].concat(o.map((c) => ".".concat(c, ":not([").concat(pa, "])"))).join(", ");
  if (a.length === 0)
    return Promise.resolve();
  let s = [];
  try {
    s = Ys(e.querySelectorAll(a));
  } catch {
  }
  if (s.length > 0)
    r("pending"), i("complete");
  else
    return Promise.resolve();
  const l = yy.begin("onTree"), u = s.reduce((c, f) => {
    try {
      const d = AO(f);
      d && c.push(d);
    } catch (d) {
      uO || d.name === "MissingIcon" && console.error(d);
    }
    return c;
  }, []);
  return new Promise((c, f) => {
    Promise.all(u).then((d) => {
      PO(d, () => {
        r("active"), r("complete"), i("pending"), typeof t == "function" && t(), l(), c();
      });
    }).catch((d) => {
      l(), f(d);
    });
  });
}
function VN(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  AO(e).then((n) => {
    n && PO([n], t);
  });
}
function BN(e) {
  return function(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = (t || {}).icon ? t : tm(t || {});
    let {
      mask: i
    } = n;
    return i && (i = (i || {}).icon ? i : tm(i || {})), e(r, be(be({}, n), {}, {
      mask: i
    }));
  };
}
const UN = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    transform: n = yi,
    symbol: r = !1,
    mask: i = null,
    maskId: o = null,
    title: a = null,
    titleId: s = null,
    classes: l = [],
    attributes: u = {},
    styles: c = {}
  } = t;
  if (!e) return;
  const {
    prefix: f,
    iconName: d,
    icon: p
  } = e;
  return Jd(be({
    type: "icon"
  }, e), () => (ha("beforeDOMElementCreation", {
    iconDefinition: e,
    params: t
  }), Ve.autoA11y && (a ? u["aria-labelledby"] = "".concat(Ve.replacementClass, "-title-").concat(s || _u()) : (u["aria-hidden"] = "true", u.focusable = "false")), gy({
    icons: {
      main: nm(p),
      mask: i ? nm(i.icon) : {
        found: !1,
        width: null,
        height: null,
        icon: {}
      }
    },
    prefix: f,
    iconName: d,
    transform: be(be({}, yi), n),
    symbol: r,
    title: a,
    maskId: o,
    titleId: s,
    extra: {
      attributes: u,
      styles: c,
      classes: l
    }
  })));
};
var KN = {
  mixout() {
    return {
      icon: BN(UN)
    };
  },
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.treeCallback = j_, e.nodeCallback = VN, e;
      }
    };
  },
  provides(e) {
    e.i2svg = function(t) {
      const {
        node: n = Pt,
        callback: r = () => {
        }
      } = t;
      return j_(n, r);
    }, e.generateSvgReplacementMutation = function(t, n) {
      const {
        iconName: r,
        title: i,
        titleId: o,
        prefix: a,
        transform: s,
        symbol: l,
        mask: u,
        maskId: c,
        extra: f
      } = n;
      return new Promise((d, p) => {
        Promise.all([rm(r, a), u.iconName ? rm(u.iconName, u.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then((h) => {
          let [v, m] = h;
          d([t, gy({
            icons: {
              main: v,
              mask: m
            },
            prefix: a,
            iconName: r,
            transform: s,
            symbol: l,
            maskId: c,
            title: i,
            titleId: o,
            extra: f,
            watchable: !0
          })]);
        }).catch(p);
      });
    }, e.generateAbstractIcon = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        transform: o,
        styles: a
      } = t;
      const s = Gd(a);
      s.length > 0 && (r.style = s);
      let l;
      return hy(o) && (l = Oo("generateAbstractTransformGrouping", {
        main: i,
        transform: o,
        containerWidth: i.width,
        iconWidth: i.width
      })), n.push(l || i.icon), {
        children: n,
        attributes: r
      };
    };
  }
}, qN = {
  mixout() {
    return {
      layer(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          classes: n = []
        } = t;
        return Jd({
          type: "layer"
        }, () => {
          ha("beforeDOMElementCreation", {
            assembler: e,
            params: t
          });
          let r = [];
          return e((i) => {
            Array.isArray(i) ? i.map((o) => {
              r = r.concat(o.abstract);
            }) : r = r.concat(i.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(Ve.cssPrefix, "-layers"), ...n].join(" ")
            },
            children: r
          }];
        });
      }
    };
  }
}, HN = {
  mixout() {
    return {
      counter(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          title: n = null,
          classes: r = [],
          attributes: i = {},
          styles: o = {}
        } = t;
        return Jd({
          type: "counter",
          content: e
        }, () => (ha("beforeDOMElementCreation", {
          content: e,
          params: t
        }), SN({
          content: e.toString(),
          title: n,
          extra: {
            attributes: i,
            styles: o,
            classes: ["".concat(Ve.cssPrefix, "-layers-counter"), ...r]
          }
        })));
      }
    };
  }
}, WN = {
  mixout() {
    return {
      text(e) {
        let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        const {
          transform: n = yi,
          title: r = null,
          classes: i = [],
          attributes: o = {},
          styles: a = {}
        } = t;
        return Jd({
          type: "text",
          content: e
        }, () => (ha("beforeDOMElementCreation", {
          content: e,
          params: t
        }), A_({
          content: e,
          transform: be(be({}, yi), n),
          title: r,
          extra: {
            attributes: o,
            styles: a,
            classes: ["".concat(Ve.cssPrefix, "-layers-text"), ...i]
          }
        })));
      }
    };
  },
  provides(e) {
    e.generateLayersText = function(t, n) {
      const {
        title: r,
        transform: i,
        extra: o
      } = n;
      let a = null, s = null;
      if (nO) {
        const l = parseInt(getComputedStyle(t).fontSize, 10), u = t.getBoundingClientRect();
        a = u.width / l, s = u.height / l;
      }
      return Ve.autoA11y && !r && (o.attributes["aria-hidden"] = "true"), Promise.resolve([t, A_({
        content: t.innerHTML,
        width: a,
        height: s,
        transform: i,
        title: r,
        extra: o,
        watchable: !0
      })]);
    };
  }
};
const ZN = new RegExp('"', "ug"), F_ = [1105920, 1112319], z_ = be(be(be(be({}, {
  FontAwesome: {
    normal: "fas",
    400: "fas"
  }
}), g6), N6), T6), am = Object.keys(z_).reduce((e, t) => (e[t.toLowerCase()] = z_[t], e), {}), GN = Object.keys(am).reduce((e, t) => {
  const n = am[t];
  return e[t] = n[900] || [...Object.entries(n)][0][1], e;
}, {});
function YN(e) {
  const t = e.replace(ZN, ""), n = nN(t, 0), r = n >= F_[0] && n <= F_[1], i = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: Jv(i ? t[0] : t),
    isSecondary: r || i
  };
}
function QN(e, t) {
  const n = e.replace(/^['"]|['"]$/g, "").toLowerCase(), r = parseInt(t), i = isNaN(r) ? "normal" : r;
  return (am[n] || {})[i] || GN[n];
}
function L_(e, t) {
  const n = "".concat(R6).concat(t.replace(":", "-"));
  return new Promise((r, i) => {
    if (e.getAttribute(n) !== null)
      return r();
    const a = Ys(e.children).filter((d) => d.getAttribute(Zv) === t)[0], s = Eo.getComputedStyle(e, t), l = s.getPropertyValue("font-family"), u = l.match(L6), c = s.getPropertyValue("font-weight"), f = s.getPropertyValue("content");
    if (a && !u)
      return e.removeChild(a), r();
    if (u && f !== "none" && f !== "") {
      const d = s.getPropertyValue("content");
      let p = QN(l, c);
      const {
        value: h,
        isSecondary: v
      } = YN(d), m = u[0].startsWith("FontAwesome");
      let g = my(p, h), y = g;
      if (m) {
        const w = lN(h);
        w.iconName && w.prefix && (g = w.iconName, p = w.prefix);
      }
      if (g && !v && (!a || a.getAttribute(cy) !== p || a.getAttribute(fy) !== y)) {
        e.setAttribute(n, y), a && e.removeChild(a);
        const w = FN(), {
          extra: x
        } = w;
        x.attributes[Zv] = t, rm(g, p).then((S) => {
          const O = gy(be(be({}, w), {}, {
            icons: {
              main: S,
              mask: OO()
            },
            prefix: p,
            iconName: y,
            extra: x,
            watchable: !0
          })), P = Pt.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(P, e.firstChild) : e.appendChild(P), P.outerHTML = O.map((b) => tc(b)).join(`
`), e.removeAttribute(n), r();
        }).catch(i);
      } else
        r();
    } else
      r();
  });
}
function JN(e) {
  return Promise.all([L_(e, "::before"), L_(e, "::after")]);
}
function XN(e) {
  return e.parentNode !== document.head && !~j6.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(Zv) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function V_(e) {
  if (Yi)
    return new Promise((t, n) => {
      const r = Ys(e.querySelectorAll("*")).filter(XN).map(JN), i = yy.begin("searchPseudoElements");
      DO(), Promise.all(r).then(() => {
        i(), om(), t();
      }).catch(() => {
        i(), om(), n();
      });
    });
}
var e5 = {
  hooks() {
    return {
      mutationObserverCallbacks(e) {
        return e.pseudoElementsCallback = V_, e;
      }
    };
  },
  provides(e) {
    e.pseudoElements2svg = function(t) {
      const {
        node: n = Pt
      } = t;
      Ve.searchPseudoElements && V_(n);
    };
  }
};
let B_ = !1;
var t5 = {
  mixout() {
    return {
      dom: {
        unwatch() {
          DO(), B_ = !0;
        }
      }
    };
  },
  hooks() {
    return {
      bootstrap() {
        R_(em("mutationObserverCallbacks", {}));
      },
      noAuto() {
        NN();
      },
      watch(e) {
        const {
          observeMutationsRoot: t
        } = e;
        B_ ? om() : R_(em("mutationObserverCallbacks", {
          observeMutationsRoot: t
        }));
      }
    };
  }
};
const U_ = (e) => {
  let t = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return e.toLowerCase().split(" ").reduce((n, r) => {
    const i = r.toLowerCase().split("-"), o = i[0];
    let a = i.slice(1).join("-");
    if (o && a === "h")
      return n.flipX = !0, n;
    if (o && a === "v")
      return n.flipY = !0, n;
    if (a = parseFloat(a), isNaN(a))
      return n;
    switch (o) {
      case "grow":
        n.size = n.size + a;
        break;
      case "shrink":
        n.size = n.size - a;
        break;
      case "left":
        n.x = n.x - a;
        break;
      case "right":
        n.x = n.x + a;
        break;
      case "up":
        n.y = n.y - a;
        break;
      case "down":
        n.y = n.y + a;
        break;
      case "rotate":
        n.rotate = n.rotate + a;
        break;
    }
    return n;
  }, t);
};
var n5 = {
  mixout() {
    return {
      parse: {
        transform: (e) => U_(e)
      }
    };
  },
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-transform");
        return n && (e.transform = U_(n)), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractTransformGrouping = function(t) {
      let {
        main: n,
        transform: r,
        containerWidth: i,
        iconWidth: o
      } = t;
      const a = {
        transform: "translate(".concat(i / 2, " 256)")
      }, s = "translate(".concat(r.x * 32, ", ").concat(r.y * 32, ") "), l = "scale(".concat(r.size / 16 * (r.flipX ? -1 : 1), ", ").concat(r.size / 16 * (r.flipY ? -1 : 1), ") "), u = "rotate(".concat(r.rotate, " 0 0)"), c = {
        transform: "".concat(s, " ").concat(l, " ").concat(u)
      }, f = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, d = {
        outer: a,
        inner: c,
        path: f
      };
      return {
        tag: "g",
        attributes: be({}, d.outer),
        children: [{
          tag: "g",
          attributes: be({}, d.inner),
          children: [{
            tag: n.icon.tag,
            children: n.icon.children,
            attributes: be(be({}, n.icon.attributes), d.path)
          }]
        }]
      };
    };
  }
};
const mh = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function K_(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function r5(e) {
  return e.tag === "g" ? e.children : [e];
}
var i5 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-mask"), r = n ? Qd(n.split(" ").map((i) => i.trim())) : OO();
        return r.prefix || (r.prefix = So()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
      }
    };
  },
  provides(e) {
    e.generateAbstractMask = function(t) {
      let {
        children: n,
        attributes: r,
        main: i,
        mask: o,
        maskId: a,
        transform: s
      } = t;
      const {
        width: l,
        icon: u
      } = i, {
        width: c,
        icon: f
      } = o, d = Y6({
        transform: s,
        containerWidth: c,
        iconWidth: l
      }), p = {
        tag: "rect",
        attributes: be(be({}, mh), {}, {
          fill: "white"
        })
      }, h = u.children ? {
        children: u.children.map(K_)
      } : {}, v = {
        tag: "g",
        attributes: be({}, d.inner),
        children: [K_(be({
          tag: u.tag,
          attributes: be(be({}, u.attributes), d.path)
        }, h))]
      }, m = {
        tag: "g",
        attributes: be({}, d.outer),
        children: [v]
      }, g = "mask-".concat(a || _u()), y = "clip-".concat(a || _u()), w = {
        tag: "mask",
        attributes: be(be({}, mh), {}, {
          id: g,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [p, m]
      }, x = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: y
          },
          children: r5(f)
        }, w]
      };
      return n.push(x, {
        tag: "rect",
        attributes: be({
          fill: "currentColor",
          "clip-path": "url(#".concat(y, ")"),
          mask: "url(#".concat(g, ")")
        }, mh)
      }), {
        children: n,
        attributes: r
      };
    };
  }
}, o5 = {
  provides(e) {
    let t = !1;
    Eo.matchMedia && (t = Eo.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function() {
      const n = [], r = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      const o = be(be({}, i), {}, {
        attributeName: "opacity"
      }), a = {
        tag: "circle",
        attributes: be(be({}, r), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return t || a.children.push({
        tag: "animate",
        attributes: be(be({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: be(be({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), n.push(a), n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: t ? [] : [{
          tag: "animate",
          attributes: be(be({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), t || n.push({
        tag: "path",
        attributes: be(be({}, r), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: be(be({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: n
      };
    };
  }
}, a5 = {
  hooks() {
    return {
      parseNodeAttributes(e, t) {
        const n = t.getAttribute("data-fa-symbol"), r = n === null ? !1 : n === "" ? !0 : n;
        return e.symbol = r, e;
      }
    };
  }
}, s5 = [X6, KN, qN, HN, WN, e5, t5, n5, i5, o5, a5];
gN(s5, {
  mixoutsTo: ur
});
ur.noAuto;
ur.config;
ur.library;
ur.dom;
const sm = ur.parse;
ur.findIconDefinition;
ur.toHtml;
const l5 = ur.icon;
ur.layer;
ur.text;
ur.counter;
var Cc = { exports: {} }, Ic = { exports: {} }, ct = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var q_;
function u5() {
  if (q_) return ct;
  q_ = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function w(S) {
    if (typeof S == "object" && S !== null) {
      var O = S.$$typeof;
      switch (O) {
        case t:
          switch (S = S.type, S) {
            case l:
            case u:
            case r:
            case o:
            case i:
            case f:
              return S;
            default:
              switch (S = S && S.$$typeof, S) {
                case s:
                case c:
                case h:
                case p:
                case a:
                  return S;
                default:
                  return O;
              }
          }
        case n:
          return O;
      }
    }
  }
  function x(S) {
    return w(S) === u;
  }
  return ct.AsyncMode = l, ct.ConcurrentMode = u, ct.ContextConsumer = s, ct.ContextProvider = a, ct.Element = t, ct.ForwardRef = c, ct.Fragment = r, ct.Lazy = h, ct.Memo = p, ct.Portal = n, ct.Profiler = o, ct.StrictMode = i, ct.Suspense = f, ct.isAsyncMode = function(S) {
    return x(S) || w(S) === l;
  }, ct.isConcurrentMode = x, ct.isContextConsumer = function(S) {
    return w(S) === s;
  }, ct.isContextProvider = function(S) {
    return w(S) === a;
  }, ct.isElement = function(S) {
    return typeof S == "object" && S !== null && S.$$typeof === t;
  }, ct.isForwardRef = function(S) {
    return w(S) === c;
  }, ct.isFragment = function(S) {
    return w(S) === r;
  }, ct.isLazy = function(S) {
    return w(S) === h;
  }, ct.isMemo = function(S) {
    return w(S) === p;
  }, ct.isPortal = function(S) {
    return w(S) === n;
  }, ct.isProfiler = function(S) {
    return w(S) === o;
  }, ct.isStrictMode = function(S) {
    return w(S) === i;
  }, ct.isSuspense = function(S) {
    return w(S) === f;
  }, ct.isValidElementType = function(S) {
    return typeof S == "string" || typeof S == "function" || S === r || S === u || S === o || S === i || S === f || S === d || typeof S == "object" && S !== null && (S.$$typeof === h || S.$$typeof === p || S.$$typeof === a || S.$$typeof === s || S.$$typeof === c || S.$$typeof === m || S.$$typeof === g || S.$$typeof === y || S.$$typeof === v);
  }, ct.typeOf = w, ct;
}
var ft = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var H_;
function c5() {
  return H_ || (H_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, g = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function w(z) {
      return typeof z == "string" || typeof z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      z === r || z === u || z === o || z === i || z === f || z === d || typeof z == "object" && z !== null && (z.$$typeof === h || z.$$typeof === p || z.$$typeof === a || z.$$typeof === s || z.$$typeof === c || z.$$typeof === m || z.$$typeof === g || z.$$typeof === y || z.$$typeof === v);
    }
    function x(z) {
      if (typeof z == "object" && z !== null) {
        var Z = z.$$typeof;
        switch (Z) {
          case t:
            var ne = z.type;
            switch (ne) {
              case l:
              case u:
              case r:
              case o:
              case i:
              case f:
                return ne;
              default:
                var de = ne && ne.$$typeof;
                switch (de) {
                  case s:
                  case c:
                  case h:
                  case p:
                  case a:
                    return de;
                  default:
                    return Z;
                }
            }
          case n:
            return Z;
        }
      }
    }
    var S = l, O = u, P = s, b = a, _ = t, E = c, A = r, k = h, R = p, N = n, U = o, H = i, ee = f, ue = !1;
    function Q(z) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(z) || x(z) === l;
    }
    function $(z) {
      return x(z) === u;
    }
    function F(z) {
      return x(z) === s;
    }
    function I(z) {
      return x(z) === a;
    }
    function L(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function K(z) {
      return x(z) === c;
    }
    function Y(z) {
      return x(z) === r;
    }
    function se(z) {
      return x(z) === h;
    }
    function ve(z) {
      return x(z) === p;
    }
    function B(z) {
      return x(z) === n;
    }
    function T(z) {
      return x(z) === o;
    }
    function D(z) {
      return x(z) === i;
    }
    function C(z) {
      return x(z) === f;
    }
    ft.AsyncMode = S, ft.ConcurrentMode = O, ft.ContextConsumer = P, ft.ContextProvider = b, ft.Element = _, ft.ForwardRef = E, ft.Fragment = A, ft.Lazy = k, ft.Memo = R, ft.Portal = N, ft.Profiler = U, ft.StrictMode = H, ft.Suspense = ee, ft.isAsyncMode = Q, ft.isConcurrentMode = $, ft.isContextConsumer = F, ft.isContextProvider = I, ft.isElement = L, ft.isForwardRef = K, ft.isFragment = Y, ft.isLazy = se, ft.isMemo = ve, ft.isPortal = B, ft.isProfiler = T, ft.isStrictMode = D, ft.isSuspense = C, ft.isValidElementType = w, ft.typeOf = x;
  })()), ft;
}
var W_;
function CO() {
  return W_ || (W_ = 1, process.env.NODE_ENV === "production" ? Ic.exports = u5() : Ic.exports = c5()), Ic.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var gh, Z_;
function f5() {
  if (Z_) return gh;
  Z_ = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(c) {
        return a[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return gh = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        u = e(s);
        for (var d = 0; d < u.length; d++)
          n.call(s, u[d]) && (l[u[d]] = s[u[d]]);
      }
    }
    return l;
  }, gh;
}
var yh, G_;
function _y() {
  if (G_) return yh;
  G_ = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return yh = e, yh;
}
var bh, Y_;
function IO() {
  return Y_ || (Y_ = 1, bh = Function.call.bind(Object.prototype.hasOwnProperty)), bh;
}
var _h, Q_;
function d5() {
  if (Q_) return _h;
  Q_ = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ _y(), n = {}, r = /* @__PURE__ */ IO();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var f;
          try {
            if (typeof o[c] != "function") {
              var d = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw d.name = "Invariant Violation", d;
            }
            f = o[c](a, c, l, s, null, t);
          } catch (h) {
            f = h;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + s + " type: " + f.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, _h = i, _h;
}
var wh, J_;
function p5() {
  if (J_) return wh;
  J_ = 1;
  var e = CO(), t = f5(), n = /* @__PURE__ */ _y(), r = /* @__PURE__ */ IO(), i = /* @__PURE__ */ d5(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return wh = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function f($) {
      var F = $ && (u && $[u] || $[c]);
      if (typeof F == "function")
        return F;
    }
    var d = "<<anonymous>>", p = {
      array: g("array"),
      bigint: g("bigint"),
      bool: g("boolean"),
      func: g("function"),
      number: g("number"),
      object: g("object"),
      string: g("string"),
      symbol: g("symbol"),
      any: y(),
      arrayOf: w,
      element: x(),
      elementType: S(),
      instanceOf: O,
      node: E(),
      objectOf: b,
      oneOf: P,
      oneOfType: _,
      shape: k,
      exact: R
    };
    function h($, F) {
      return $ === F ? $ !== 0 || 1 / $ === 1 / F : $ !== $ && F !== F;
    }
    function v($, F) {
      this.message = $, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function m($) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, I = 0;
      function L(Y, se, ve, B, T, D, C) {
        if (B = B || d, D = D || ve, C !== n) {
          if (l) {
            var z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw z.name = "Invariant Violation", z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Z = B + ":" + ve;
            !F[Z] && // Avoid spamming the console because they are often not actionable except for lib authors
            I < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + D + "` prop on `" + B + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[Z] = !0, I++);
          }
        }
        return se[ve] == null ? Y ? se[ve] === null ? new v("The " + T + " `" + D + "` is marked as required " + ("in `" + B + "`, but its value is `null`.")) : new v("The " + T + " `" + D + "` is marked as required in " + ("`" + B + "`, but its value is `undefined`.")) : null : $(se, ve, B, T, D);
      }
      var K = L.bind(null, !1);
      return K.isRequired = L.bind(null, !0), K;
    }
    function g($) {
      function F(I, L, K, Y, se, ve) {
        var B = I[L], T = H(B);
        if (T !== $) {
          var D = ee(B);
          return new v(
            "Invalid " + Y + " `" + se + "` of type " + ("`" + D + "` supplied to `" + K + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return m(F);
    }
    function y() {
      return m(a);
    }
    function w($) {
      function F(I, L, K, Y, se) {
        if (typeof $ != "function")
          return new v("Property `" + se + "` of component `" + K + "` has invalid PropType notation inside arrayOf.");
        var ve = I[L];
        if (!Array.isArray(ve)) {
          var B = H(ve);
          return new v("Invalid " + Y + " `" + se + "` of type " + ("`" + B + "` supplied to `" + K + "`, expected an array."));
        }
        for (var T = 0; T < ve.length; T++) {
          var D = $(ve, T, K, Y, se + "[" + T + "]", n);
          if (D instanceof Error)
            return D;
        }
        return null;
      }
      return m(F);
    }
    function x() {
      function $(F, I, L, K, Y) {
        var se = F[I];
        if (!s(se)) {
          var ve = H(se);
          return new v("Invalid " + K + " `" + Y + "` of type " + ("`" + ve + "` supplied to `" + L + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m($);
    }
    function S() {
      function $(F, I, L, K, Y) {
        var se = F[I];
        if (!e.isValidElementType(se)) {
          var ve = H(se);
          return new v("Invalid " + K + " `" + Y + "` of type " + ("`" + ve + "` supplied to `" + L + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m($);
    }
    function O($) {
      function F(I, L, K, Y, se) {
        if (!(I[L] instanceof $)) {
          var ve = $.name || d, B = Q(I[L]);
          return new v("Invalid " + Y + " `" + se + "` of type " + ("`" + B + "` supplied to `" + K + "`, expected ") + ("instance of `" + ve + "`."));
        }
        return null;
      }
      return m(F);
    }
    function P($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function F(I, L, K, Y, se) {
        for (var ve = I[L], B = 0; B < $.length; B++)
          if (h(ve, $[B]))
            return null;
        var T = JSON.stringify($, function(C, z) {
          var Z = ee(z);
          return Z === "symbol" ? String(z) : z;
        });
        return new v("Invalid " + Y + " `" + se + "` of value `" + String(ve) + "` " + ("supplied to `" + K + "`, expected one of " + T + "."));
      }
      return m(F);
    }
    function b($) {
      function F(I, L, K, Y, se) {
        if (typeof $ != "function")
          return new v("Property `" + se + "` of component `" + K + "` has invalid PropType notation inside objectOf.");
        var ve = I[L], B = H(ve);
        if (B !== "object")
          return new v("Invalid " + Y + " `" + se + "` of type " + ("`" + B + "` supplied to `" + K + "`, expected an object."));
        for (var T in ve)
          if (r(ve, T)) {
            var D = $(ve, T, K, Y, se + "." + T, n);
            if (D instanceof Error)
              return D;
          }
        return null;
      }
      return m(F);
    }
    function _($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var F = 0; F < $.length; F++) {
        var I = $[F];
        if (typeof I != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ue(I) + " at index " + F + "."
          ), a;
      }
      function L(K, Y, se, ve, B) {
        for (var T = [], D = 0; D < $.length; D++) {
          var C = $[D], z = C(K, Y, se, ve, B, n);
          if (z == null)
            return null;
          z.data && r(z.data, "expectedType") && T.push(z.data.expectedType);
        }
        var Z = T.length > 0 ? ", expected one of type [" + T.join(", ") + "]" : "";
        return new v("Invalid " + ve + " `" + B + "` supplied to " + ("`" + se + "`" + Z + "."));
      }
      return m(L);
    }
    function E() {
      function $(F, I, L, K, Y) {
        return N(F[I]) ? null : new v("Invalid " + K + " `" + Y + "` supplied to " + ("`" + L + "`, expected a ReactNode."));
      }
      return m($);
    }
    function A($, F, I, L, K) {
      return new v(
        ($ || "React class") + ": " + F + " type `" + I + "." + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + K + "`."
      );
    }
    function k($) {
      function F(I, L, K, Y, se) {
        var ve = I[L], B = H(ve);
        if (B !== "object")
          return new v("Invalid " + Y + " `" + se + "` of type `" + B + "` " + ("supplied to `" + K + "`, expected `object`."));
        for (var T in $) {
          var D = $[T];
          if (typeof D != "function")
            return A(K, Y, se, T, ee(D));
          var C = D(ve, T, K, Y, se + "." + T, n);
          if (C)
            return C;
        }
        return null;
      }
      return m(F);
    }
    function R($) {
      function F(I, L, K, Y, se) {
        var ve = I[L], B = H(ve);
        if (B !== "object")
          return new v("Invalid " + Y + " `" + se + "` of type `" + B + "` " + ("supplied to `" + K + "`, expected `object`."));
        var T = t({}, I[L], $);
        for (var D in T) {
          var C = $[D];
          if (r($, D) && typeof C != "function")
            return A(K, Y, se, D, ee(C));
          if (!C)
            return new v(
              "Invalid " + Y + " `" + se + "` key `" + D + "` supplied to `" + K + "`.\nBad object: " + JSON.stringify(I[L], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var z = C(ve, D, K, Y, se + "." + D, n);
          if (z)
            return z;
        }
        return null;
      }
      return m(F);
    }
    function N($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(N);
          if ($ === null || s($))
            return !0;
          var F = f($);
          if (F) {
            var I = F.call($), L;
            if (F !== $.entries) {
              for (; !(L = I.next()).done; )
                if (!N(L.value))
                  return !1;
            } else
              for (; !(L = I.next()).done; ) {
                var K = L.value;
                if (K && !N(K[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function U($, F) {
      return $ === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function H($) {
      var F = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : U(F, $) ? "symbol" : F;
    }
    function ee($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var F = H($);
      if (F === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function ue($) {
      var F = ee($);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function Q($) {
      return !$.constructor || !$.constructor.name ? d : $.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, wh;
}
var xh, X_;
function h5() {
  if (X_) return xh;
  X_ = 1;
  var e = /* @__PURE__ */ _y();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, xh = function() {
    function r(a, s, l, u, c, f) {
      if (f !== e) {
        var d = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw d.name = "Invariant Violation", d;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, xh;
}
var e1;
function v5() {
  if (e1) return Cc.exports;
  if (e1 = 1, process.env.NODE_ENV !== "production") {
    var e = CO(), t = !0;
    Cc.exports = /* @__PURE__ */ p5()(e.isElement, t);
  } else
    Cc.exports = /* @__PURE__ */ h5()();
  return Cc.exports;
}
var m5 = /* @__PURE__ */ v5();
const Re = /* @__PURE__ */ Wd(m5);
function t1(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function vo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? t1(Object(n), !0).forEach(function(r) {
      rs(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : t1(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function qf(e) {
  "@babel/helpers - typeof";
  return qf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qf(e);
}
function rs(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function g5(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function NO(e, t) {
  if (e == null) return {};
  var n = g5(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function lm(e) {
  return y5(e) || b5(e) || _5(e) || w5();
}
function y5(e) {
  if (Array.isArray(e)) return um(e);
}
function b5(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function _5(e, t) {
  if (e) {
    if (typeof e == "string") return um(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return um(e, t);
  }
}
function um(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function w5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x5(e) {
  var t, n = e.beat, r = e.fade, i = e.beatFade, o = e.bounce, a = e.shake, s = e.flash, l = e.spin, u = e.spinPulse, c = e.spinReverse, f = e.pulse, d = e.fixedWidth, p = e.inverse, h = e.border, v = e.listItem, m = e.flip, g = e.size, y = e.rotation, w = e.pull, x = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": i,
    "fa-bounce": o,
    "fa-shake": a,
    "fa-flash": s,
    "fa-spin": l,
    "fa-spin-reverse": c,
    "fa-spin-pulse": u,
    "fa-pulse": f,
    "fa-fw": d,
    "fa-inverse": p,
    "fa-border": h,
    "fa-li": v,
    "fa-flip": m === !0,
    "fa-flip-horizontal": m === "horizontal" || m === "both",
    "fa-flip-vertical": m === "vertical" || m === "both"
  }, rs(t, "fa-".concat(g), typeof g < "u" && g !== null), rs(t, "fa-rotate-".concat(y), typeof y < "u" && y !== null && y !== 0), rs(t, "fa-pull-".concat(w), typeof w < "u" && w !== null), rs(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(x).map(function(S) {
    return x[S] ? S : null;
  }).filter(function(S) {
    return S;
  });
}
function E5(e) {
  return e = e - 0, e === e;
}
function RO(e) {
  return E5(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var S5 = ["style"];
function O5(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function $5(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), i = RO(n.slice(0, r)), o = n.slice(r + 1).trim();
    return i.startsWith("webkit") ? t[O5(i)] = o : t[i] = o, t;
  }, {});
}
function MO(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(l) {
    return MO(e, l);
  }), i = Object.keys(t.attributes || {}).reduce(function(l, u) {
    var c = t.attributes[u];
    switch (u) {
      case "class":
        l.attrs.className = c, delete t.attributes.class;
        break;
      case "style":
        l.attrs.style = $5(c);
        break;
      default:
        u.indexOf("aria-") === 0 || u.indexOf("data-") === 0 ? l.attrs[u.toLowerCase()] = c : l.attrs[RO(u)] = c;
    }
    return l;
  }, {
    attrs: {}
  }), o = n.style, a = o === void 0 ? {} : o, s = NO(n, S5);
  return i.attrs.style = vo(vo({}, i.attrs.style), a), e.apply(void 0, [t.tag, vo(vo({}, i.attrs), s)].concat(lm(r)));
}
var jO = !1;
try {
  jO = process.env.NODE_ENV === "production";
} catch {
}
function T5() {
  if (!jO && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function n1(e) {
  if (e && qf(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (sm.icon)
    return sm.icon(e);
  if (e === null)
    return null;
  if (e && qf(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function Eh(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? rs({}, e, t) : {};
}
var k5 = ["forwardedRef"];
function ar(e) {
  var t = e.forwardedRef, n = NO(e, k5), r = n.icon, i = n.mask, o = n.symbol, a = n.className, s = n.title, l = n.titleId, u = n.maskId, c = n1(r), f = Eh("classes", [].concat(lm(x5(n)), lm(a.split(" ")))), d = Eh("transform", typeof n.transform == "string" ? sm.transform(n.transform) : n.transform), p = Eh("mask", n1(i)), h = l5(c, vo(vo(vo(vo({}, f), d), p), {}, {
    symbol: o,
    title: s,
    titleId: l,
    maskId: u
  }));
  if (!h)
    return T5("Could not find icon", c), null;
  var v = h.abstract, m = {
    ref: t
  };
  return Object.keys(n).forEach(function(g) {
    ar.defaultProps.hasOwnProperty(g) || (m[g] = n[g]);
  }), P5(v[0], m);
}
ar.displayName = "FontAwesomeIcon";
ar.propTypes = {
  beat: Re.bool,
  border: Re.bool,
  beatFade: Re.bool,
  bounce: Re.bool,
  className: Re.string,
  fade: Re.bool,
  flash: Re.bool,
  mask: Re.oneOfType([Re.object, Re.array, Re.string]),
  maskId: Re.string,
  fixedWidth: Re.bool,
  inverse: Re.bool,
  flip: Re.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: Re.oneOfType([Re.object, Re.array, Re.string]),
  listItem: Re.bool,
  pull: Re.oneOf(["right", "left"]),
  pulse: Re.bool,
  rotation: Re.oneOf([0, 90, 180, 270]),
  shake: Re.bool,
  size: Re.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: Re.bool,
  spinPulse: Re.bool,
  spinReverse: Re.bool,
  symbol: Re.oneOfType([Re.bool, Re.string]),
  title: Re.string,
  titleId: Re.string,
  transform: Re.oneOfType([Re.string, Re.object]),
  swapOpacity: Re.bool
};
ar.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var P5 = MO.bind(null, W.createElement);
const D5 = Pr(
  [
    "absolute",
    "p-1",
    "text-sm",
    "-translate-y-1/2",
    "top-1/2",
    "left-full",
    "text-neutral-800",
    "dark:text-neutral-100",
    "z-[9999]",
    "transition-opacity"
  ],
  {
    variants: {
      visible: {
        true: "opacity-100",
        false: "opacity-0"
      }
    }
  }
), A5 = (e) => /* @__PURE__ */ M.jsx("p", { className: D5({ visible: e.visible }), children: "Copied!" }), Sle = ({
  text: e,
  onCopy: t,
  element: n,
  copyElement: r,
  disabled: i = !1,
  className: o = ""
}) => {
  const [a, s] = Fe(!1);
  return /* @__PURE__ */ M.jsxs(
    "button",
    {
      disabled: i,
      className: `${o} relative w-3 h-3`,
      onClick: () => {
        t?.(e), navigator.clipboard.writeText(e), s(!0), setTimeout(() => s(!1), 1500);
      },
      children: [
        n || /* @__PURE__ */ M.jsx(
          ar,
          {
            className: "w-full h-full p-1 cursor-pointer place-items-center aspect-square",
            icon: i6
          }
        ),
        /* @__PURE__ */ M.jsx(A5, { visible: a, children: r || "Copied!" })
      ]
    }
  );
};
var cm = function(e, t) {
  return cm = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, cm(e, t);
};
function FO(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  cm(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var we = function() {
  return we = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, we.apply(this, arguments);
};
function Dr(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function Pa(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function C5(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Bt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}
function Zr(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var r1 = "production", wy = typeof process > "u" || process.env === void 0 ? r1 : process.env.NODE_ENV || r1, Ai = function(e) {
  return {
    isEnabled: function(t) {
      return e.some(function(n) {
        return !!t[n];
      });
    }
  };
}, xu = {
  measureLayout: Ai(["layout", "layoutId", "drag"]),
  animation: Ai([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Ai(["exit"]),
  drag: Ai(["drag", "dragControls"]),
  focus: Ai(["whileFocus"]),
  hover: Ai(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Ai(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Ai([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Ai([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function I5(e) {
  for (var t in e)
    e[t] !== null && (t === "projectionNodeConstructor" ? xu.projectionNodeConstructor = e[t] : xu[t].Component = e[t]);
}
var Qs = function() {
}, Or = function() {
};
process.env.NODE_ENV !== "production" && (Qs = function(e, t) {
  !e && typeof console < "u" && console.warn(t);
}, Or = function(e, t) {
  if (!e)
    throw new Error(t);
});
var zO = Le({ strict: !1 }), LO = Object.keys(xu), N5 = LO.length;
function R5(e, t, n) {
  var r = [], i = Ie(zO);
  if (!t)
    return null;
  wy !== "production" && n && i.strict && Or(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var o = 0; o < N5; o++) {
    var a = LO[o], s = xu[a], l = s.isEnabled, u = s.Component;
    l(e) && u && r.push(ie.createElement(u, we({ key: a }, e, { visualElement: t })));
  }
  return r;
}
var xy = Le({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), Xd = Le({});
function M5() {
  return Ie(Xd).visualElement;
}
var nc = Le(null), Js = typeof document < "u", Hf = Js ? V2 : Se, fm = { current: null }, VO = !1;
function j5() {
  if (VO = !0, !!Js)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), t = function() {
        return fm.current = e.matches;
      };
      e.addListener(t), t();
    } else
      fm.current = !1;
}
function F5() {
  !VO && j5();
  var e = Bt(Fe(fm.current), 1), t = e[0];
  return t;
}
function z5() {
  var e = F5(), t = Ie(xy).reducedMotion;
  return t === "never" ? !1 : t === "always" ? !0 : e;
}
function L5(e, t, n, r) {
  var i = Ie(zO), o = M5(), a = Ie(nc), s = z5(), l = _e(void 0);
  r || (r = i.renderer), !l.current && r && (l.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceId: a?.id,
    blockInitialAnimation: a?.initial === !1,
    shouldReduceMotion: s
  }));
  var u = l.current;
  return Hf(function() {
    u?.syncRender();
  }), Se(function() {
    var c;
    (c = u?.animationState) === null || c === void 0 || c.animateChanges();
  }), Hf(function() {
    return function() {
      return u?.notifyUnmount();
    };
  }, []), u;
}
function is(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function V5(e, t, n) {
  return Me(
    function(r) {
      var i;
      r && ((i = e.mount) === null || i === void 0 || i.call(e, r)), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : is(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function BO(e) {
  return Array.isArray(e);
}
function Vr(e) {
  return typeof e == "string" || BO(e);
}
function B5(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.get();
  }), t;
}
function U5(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.getVelocity();
  }), t;
}
function UO(e, t, n, r, i) {
  var o;
  return r === void 0 && (r = {}), i === void 0 && (i = {}), typeof t == "function" && (t = t(n ?? e.custom, r, i)), typeof t == "string" && (t = (o = e.variants) === null || o === void 0 ? void 0 : o[t]), typeof t == "function" && (t = t(n ?? e.custom, r, i)), t;
}
function ep(e, t, n) {
  var r = e.getProps();
  return UO(r, t, n ?? r.custom, B5(e), U5(e));
}
function tp(e) {
  var t;
  return typeof ((t = e.animate) === null || t === void 0 ? void 0 : t.start) == "function" || Vr(e.initial) || Vr(e.animate) || Vr(e.whileHover) || Vr(e.whileDrag) || Vr(e.whileTap) || Vr(e.whileFocus) || Vr(e.exit);
}
function KO(e) {
  return !!(tp(e) || e.variants);
}
function K5(e, t) {
  if (tp(e)) {
    var n = e.initial, r = e.animate;
    return {
      initial: n === !1 || Vr(n) ? n : void 0,
      animate: Vr(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function q5(e) {
  var t = K5(e, Ie(Xd)), n = t.initial, r = t.animate;
  return $e(function() {
    return { initial: n, animate: r };
  }, [i1(n), i1(r)]);
}
function i1(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function Xs(e) {
  var t = _e(null);
  return t.current === null && (t.current = e()), t.current;
}
var tu = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, H5 = 1;
function W5() {
  return Xs(function() {
    if (tu.hasEverUpdated)
      return H5++;
  });
}
var Eu = Le({}), qO = Le({});
function Z5(e, t, n, r) {
  var i, o = t.layoutId, a = t.layout, s = t.drag, l = t.dragConstraints, u = t.layoutScroll, c = Ie(qO);
  !r || !n || n?.projection || (n.projection = new r(e, n.getLatestValues(), (i = n.parent) === null || i === void 0 ? void 0 : i.projection), n.projection.setOptions({
    layoutId: o,
    layout: a,
    alwaysMeasureLayout: !!s || l && is(l),
    visualElement: n,
    scheduleRender: function() {
      return n.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: c,
    layoutScroll: u
  }));
}
var G5 = (
  /** @class */
  (function(e) {
    FO(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, t.prototype.componentDidUpdate = function() {
    }, t.prototype.updateProps = function() {
      var n = this.props, r = n.visualElement, i = n.props;
      r && r.setProps(i);
    }, t.prototype.render = function() {
      return this.props.children;
    }, t;
  })(W.Component)
);
function Y5(e) {
  var t = e.preloadedFeatures, n = e.createVisualElement, r = e.projectionNodeConstructor, i = e.useRender, o = e.useVisualState, a = e.Component;
  t && I5(t);
  function s(l, u) {
    var c = Q5(l);
    l = we(we({}, l), { layoutId: c });
    var f = Ie(xy), d = null, p = q5(l), h = f.isStatic ? void 0 : W5(), v = o(l, f.isStatic);
    return !f.isStatic && Js && (p.visualElement = L5(a, v, we(we({}, f), l), n), Z5(h, l, p.visualElement, r || xu.projectionNodeConstructor), d = R5(l, p.visualElement, t)), ie.createElement(
      G5,
      { visualElement: p.visualElement, props: we(we({}, f), l) },
      d,
      ie.createElement(Xd.Provider, { value: p }, i(a, l, h, V5(v, p.visualElement, u), v, f.isStatic, p.visualElement))
    );
  }
  return Xt(s);
}
function Q5(e) {
  var t, n = e.layoutId, r = (t = Ie(Eu)) === null || t === void 0 ? void 0 : t.id;
  return r && n !== void 0 ? r + "-" + n : n;
}
function J5(e) {
  function t(r, i) {
    return i === void 0 && (i = {}), Y5(e(r, i));
  }
  if (typeof Proxy > "u")
    return t;
  var n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(r, i) {
      return n.has(i) || n.set(i, t(i)), n.get(i);
    }
  });
}
var X5 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function Ey(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(X5.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var Wf = {};
function eR(e) {
  Object.assign(Wf, e);
}
var dm = ["", "X", "Y", "Z"], tR = ["translate", "scale", "rotate", "skew"], Su = ["transformPerspective", "x", "y", "z"];
tR.forEach(function(e) {
  return dm.forEach(function(t) {
    return Su.push(e + t);
  });
});
function nR(e, t) {
  return Su.indexOf(e) - Su.indexOf(t);
}
var rR = new Set(Su);
function rc(e) {
  return rR.has(e);
}
var iR = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function HO(e) {
  return iR.has(e);
}
function WO(e, t) {
  var n = t.layout, r = t.layoutId;
  return rc(e) || HO(e) || (n || r !== void 0) && (!!Wf[e] || e === "opacity");
}
var Vi = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, oR = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function aR(e, t, n, r) {
  var i = e.transform, o = e.transformKeys, a = t.enableHardwareAcceleration, s = a === void 0 ? !0 : a, l = t.allowTransformNone, u = l === void 0 ? !0 : l, c = "";
  o.sort(nR);
  for (var f = !1, d = o.length, p = 0; p < d; p++) {
    var h = o[p];
    c += "".concat(oR[h] || h, "(").concat(i[h], ") "), h === "z" && (f = !0);
  }
  return !f && s ? c += "translateZ(0)" : c = c.trim(), r ? c = r(i, n ? "" : c) : u && n && (c = "none"), c;
}
function sR(e) {
  var t = e.originX, n = t === void 0 ? "50%" : t, r = e.originY, i = r === void 0 ? "50%" : r, o = e.originZ, a = o === void 0 ? 0 : o;
  return "".concat(n, " ").concat(i, " ").concat(a);
}
function ZO(e) {
  return e.startsWith("--");
}
var lR = function(e, t) {
  return t && typeof e == "number" ? t.transform(e) : e;
};
const GO = (e, t) => (n) => Math.max(Math.min(n, t), e), nu = (e) => e % 1 ? Number(e.toFixed(5)) : e, Ou = /(-)?([\d]*\.?[\d])+/g, pm = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, uR = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function ic(e) {
  return typeof e == "string";
}
const Da = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, ru = Object.assign(Object.assign({}, Da), { transform: GO(0, 1) }), Nc = Object.assign(Object.assign({}, Da), { default: 1 }), oc = (e) => ({
  test: (t) => ic(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), ro = oc("deg"), wi = oc("%"), Ke = oc("px"), cR = oc("vh"), fR = oc("vw"), o1 = Object.assign(Object.assign({}, wi), { parse: (e) => wi.parse(e) / 100, transform: (e) => wi.transform(e * 100) }), Sy = (e, t) => (n) => !!(ic(n) && uR.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), YO = (e, t, n) => (r) => {
  if (!ic(r))
    return r;
  const [i, o, a, s] = r.match(Ou);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, oa = {
  test: Sy("hsl", "hue"),
  parse: YO("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + wi.transform(nu(t)) + ", " + wi.transform(nu(n)) + ", " + nu(ru.transform(r)) + ")"
}, dR = GO(0, 255), Sh = Object.assign(Object.assign({}, Da), { transform: (e) => Math.round(dR(e)) }), mo = {
  test: Sy("rgb", "red"),
  parse: YO("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + Sh.transform(e) + ", " + Sh.transform(t) + ", " + Sh.transform(n) + ", " + nu(ru.transform(r)) + ")"
};
function pR(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substr(1, 2), n = e.substr(3, 2), r = e.substr(5, 2), i = e.substr(7, 2)) : (t = e.substr(1, 1), n = e.substr(2, 1), r = e.substr(3, 1), i = e.substr(4, 1), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const hm = {
  test: Sy("#"),
  parse: pR,
  transform: mo.transform
}, Dn = {
  test: (e) => mo.test(e) || hm.test(e) || oa.test(e),
  parse: (e) => mo.test(e) ? mo.parse(e) : oa.test(e) ? oa.parse(e) : hm.parse(e),
  transform: (e) => ic(e) ? e : e.hasOwnProperty("red") ? mo.transform(e) : oa.transform(e)
}, QO = "${c}", JO = "${n}";
function hR(e) {
  var t, n, r, i;
  return isNaN(e) && ic(e) && ((n = (t = e.match(Ou)) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0) + ((i = (r = e.match(pm)) === null || r === void 0 ? void 0 : r.length) !== null && i !== void 0 ? i : 0) > 0;
}
function XO(e) {
  typeof e == "number" && (e = `${e}`);
  const t = [];
  let n = 0;
  const r = e.match(pm);
  r && (n = r.length, e = e.replace(pm, QO), t.push(...r.map(Dn.parse)));
  const i = e.match(Ou);
  return i && (e = e.replace(Ou, JO), t.push(...i.map(Da.parse))), { values: t, numColors: n, tokenised: e };
}
function e$(e) {
  return XO(e).values;
}
function t$(e) {
  const { values: t, numColors: n, tokenised: r } = XO(e), i = t.length;
  return (o) => {
    let a = r;
    for (let s = 0; s < i; s++)
      a = a.replace(s < n ? QO : JO, s < n ? Dn.transform(o[s]) : nu(o[s]));
    return a;
  };
}
const vR = (e) => typeof e == "number" ? 0 : e;
function mR(e) {
  const t = e$(e);
  return t$(e)(t.map(vR));
}
const Bi = { test: hR, parse: e$, createTransformer: t$, getAnimatableNone: mR }, gR = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function yR(e) {
  let [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(Ou) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = gR.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const bR = /([a-z-]*)\(.*?\)/g, vm = Object.assign(Object.assign({}, Bi), { getAnimatableNone: (e) => {
  const t = e.match(bR);
  return t ? t.map(yR).join(" ") : e;
} });
var a1 = we(we({}, Da), { transform: Math.round }), n$ = {
  // Border props
  borderWidth: Ke,
  borderTopWidth: Ke,
  borderRightWidth: Ke,
  borderBottomWidth: Ke,
  borderLeftWidth: Ke,
  borderRadius: Ke,
  radius: Ke,
  borderTopLeftRadius: Ke,
  borderTopRightRadius: Ke,
  borderBottomRightRadius: Ke,
  borderBottomLeftRadius: Ke,
  // Positioning props
  width: Ke,
  maxWidth: Ke,
  height: Ke,
  maxHeight: Ke,
  size: Ke,
  top: Ke,
  right: Ke,
  bottom: Ke,
  left: Ke,
  // Spacing props
  padding: Ke,
  paddingTop: Ke,
  paddingRight: Ke,
  paddingBottom: Ke,
  paddingLeft: Ke,
  margin: Ke,
  marginTop: Ke,
  marginRight: Ke,
  marginBottom: Ke,
  marginLeft: Ke,
  // Transform props
  rotate: ro,
  rotateX: ro,
  rotateY: ro,
  rotateZ: ro,
  scale: Nc,
  scaleX: Nc,
  scaleY: Nc,
  scaleZ: Nc,
  skew: ro,
  skewX: ro,
  skewY: ro,
  distance: Ke,
  translateX: Ke,
  translateY: Ke,
  translateZ: Ke,
  x: Ke,
  y: Ke,
  z: Ke,
  perspective: Ke,
  transformPerspective: Ke,
  opacity: ru,
  originX: o1,
  originY: o1,
  originZ: Ke,
  // Misc
  zIndex: a1,
  // SVG
  fillOpacity: ru,
  strokeOpacity: ru,
  numOctaves: a1
};
function Oy(e, t, n, r) {
  var i, o = e.style, a = e.vars, s = e.transform, l = e.transformKeys, u = e.transformOrigin;
  l.length = 0;
  var c = !1, f = !1, d = !0;
  for (var p in t) {
    var h = t[p];
    if (ZO(p)) {
      a[p] = h;
      continue;
    }
    var v = n$[p], m = lR(h, v);
    if (rc(p)) {
      if (c = !0, s[p] = m, l.push(p), !d)
        continue;
      h !== ((i = v.default) !== null && i !== void 0 ? i : 0) && (d = !1);
    } else HO(p) ? (u[p] = m, f = !0) : o[p] = m;
  }
  c ? o.transform = aR(e, n, d, r) : r ? o.transform = r({}, "") : !t.transform && o.transform && (o.transform = "none"), f && (o.transformOrigin = sR(u));
}
var $y = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function r$(e, t, n) {
  for (var r in t)
    !Vi(t[r]) && !WO(r, n) && (e[r] = t[r]);
}
function _R(e, t, n) {
  var r = e.transformTemplate;
  return $e(function() {
    var i = $y();
    Oy(i, t, { enableHardwareAcceleration: !n }, r);
    var o = i.vars, a = i.style;
    return we(we({}, o), a);
  }, [t]);
}
function wR(e, t, n) {
  var r = e.style || {}, i = {};
  return r$(i, r, e), Object.assign(i, _R(e, t, n)), e.transformValues && (i = e.transformValues(i)), i;
}
function xR(e, t, n) {
  var r = {}, i = wR(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), r.style = i, r;
}
var ER = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function Zf(e) {
  return ER.has(e);
}
var i$ = function(e) {
  return !Zf(e);
};
function SR(e) {
  e && (i$ = function(t) {
    return t.startsWith("on") ? !Zf(t) : e(t);
  });
}
try {
  SR(require("@emotion/is-prop-valid").default);
} catch {
}
function OR(e, t, n) {
  var r = {};
  for (var i in e)
    (i$(i) || n === !0 && Zf(i) || !t && !Zf(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function s1(e, t, n) {
  return typeof e == "string" ? e : Ke.transform(t + n * e);
}
function $R(e, t, n) {
  var r = s1(t, e.x, e.width), i = s1(n, e.y, e.height);
  return "".concat(r, " ").concat(i);
}
var TR = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function kR(e, t, n, r, i) {
  n === void 0 && (n = 1), r === void 0 && (r = 0), e.pathLength = 1;
  var o = TR;
  e[o.offset] = Ke.transform(-r);
  var a = Ke.transform(t), s = Ke.transform(n);
  e[o.array] = "".concat(a, " ").concat(s);
}
function Ty(e, t, n, r) {
  var i = t.attrX, o = t.attrY, a = t.originX, s = t.originY, l = t.pathLength, u = t.pathSpacing, c = u === void 0 ? 1 : u, f = t.pathOffset, d = f === void 0 ? 0 : f, p = Dr(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  Oy(e, p, n, r), e.attrs = e.style, e.style = {};
  var h = e.attrs, v = e.style, m = e.dimensions;
  h.transform && (m && (v.transform = h.transform), delete h.transform), m && (a !== void 0 || s !== void 0 || v.transform) && (v.transformOrigin = $R(m, a !== void 0 ? a : 0.5, s !== void 0 ? s : 0.5)), i !== void 0 && (h.x = i), o !== void 0 && (h.y = o), l !== void 0 && kR(h, l, c, d);
}
var o$ = function() {
  return we(we({}, $y()), { attrs: {} });
};
function PR(e, t) {
  var n = $e(function() {
    var i = o$();
    return Ty(i, t, { enableHardwareAcceleration: !1 }, e.transformTemplate), we(we({}, i.attrs), { style: we({}, i.style) });
  }, [t]);
  if (e.style) {
    var r = {};
    r$(r, e.style, e), n.style = we(we({}, r), n.style);
  }
  return n;
}
function DR(e) {
  e === void 0 && (e = !1);
  var t = function(n, r, i, o, a, s) {
    var l = a.latestValues, u = Ey(n) ? PR : xR, c = u(r, l, s), f = OR(r, typeof n == "string", e), d = we(we(we({}, f), c), { ref: o });
    return i && (d["data-projection-id"] = i), pI(n, d);
  };
  return t;
}
var AR = /([a-z])([A-Z])/g, CR = "$1-$2", a$ = function(e) {
  return e.replace(AR, CR).toLowerCase();
};
function s$(e, t, n, r) {
  var i = t.style, o = t.vars;
  Object.assign(e.style, i, r && r.getProjectionStyles(n));
  for (var a in o)
    e.style.setProperty(a, o[a]);
}
var l$ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function u$(e, t, n, r) {
  s$(e, t, void 0, r);
  for (var i in t.attrs)
    e.setAttribute(l$.has(i) ? i : a$(i), t.attrs[i]);
}
function ky(e) {
  var t = e.style, n = {};
  for (var r in t)
    (Vi(t[r]) || WO(r, e)) && (n[r] = t[r]);
  return n;
}
function c$(e) {
  var t = ky(e);
  for (var n in e)
    if (Vi(e[n])) {
      var r = n === "x" || n === "y" ? "attr" + n.toUpperCase() : n;
      t[r] = e[n];
    }
  return t;
}
function Py(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var $u = function(e) {
  return Array.isArray(e);
}, IR = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, f$ = function(e) {
  return $u(e) ? e[e.length - 1] || 0 : e;
};
function bf(e) {
  var t = Vi(e) ? e.get() : e;
  return IR(t) ? t.toValue() : t;
}
function l1(e, t, n, r) {
  var i = e.scrapeMotionValuesFromProps, o = e.createRenderState, a = e.onMount, s = {
    latestValues: NR(t, n, r, i),
    renderState: o()
  };
  return a && (s.mount = function(l) {
    return a(t, l, s);
  }), s;
}
var d$ = function(e) {
  return function(t, n) {
    var r = Ie(Xd), i = Ie(nc);
    return n ? l1(e, t, r, i) : Xs(function() {
      return l1(e, t, r, i);
    });
  };
};
function NR(e, t, n, r) {
  var i = {}, o = n?.initial === !1, a = r(e);
  for (var s in a)
    i[s] = bf(a[s]);
  var l = e.initial, u = e.animate, c = tp(e), f = KO(e);
  t && f && !c && e.inherit !== !1 && (l ?? (l = t.initial), u ?? (u = t.animate));
  var d = o || l === !1, p = d ? u : l;
  if (p && typeof p != "boolean" && !Py(p)) {
    var h = Array.isArray(p) ? p : [p];
    h.forEach(function(v) {
      var m = UO(e, v);
      if (m) {
        var g = m.transitionEnd;
        m.transition;
        var y = Dr(m, ["transitionEnd", "transition"]);
        for (var w in y) {
          var x = y[w];
          if (Array.isArray(x)) {
            var S = d ? x.length - 1 : 0;
            x = x[S];
          }
          x !== null && (i[w] = x);
        }
        for (var w in g)
          i[w] = g[w];
      }
    });
  }
  return i;
}
var RR = {
  useVisualState: d$({
    scrapeMotionValuesFromProps: c$,
    createRenderState: o$,
    onMount: function(e, t, n) {
      var r = n.renderState, i = n.latestValues;
      try {
        r.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      Ty(r, i, { enableHardwareAcceleration: !1 }, e.transformTemplate), u$(t, r);
    }
  })
}, MR = {
  useVisualState: d$({
    scrapeMotionValuesFromProps: ky,
    createRenderState: $y
  })
};
function jR(e, t, n, r, i) {
  var o = t.forwardMotionProps, a = o === void 0 ? !1 : o, s = Ey(e) ? RR : MR;
  return we(we({}, s), { preloadedFeatures: n, useRender: DR(a), createVisualElement: r, projectionNodeConstructor: i, Component: e });
}
var xt;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})(xt || (xt = {}));
function np(e, t, n, r) {
  return r === void 0 && (r = { passive: !0 }), e.addEventListener(t, n, r), function() {
    return e.removeEventListener(t, n);
  };
}
function mm(e, t, n, r) {
  Se(function() {
    var i = e.current;
    if (n && i)
      return np(i, t, n, r);
  }, [e, t, n, r]);
}
function FR(e) {
  var t = e.whileFocus, n = e.visualElement, r = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive(xt.Focus, !0);
  }, i = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive(xt.Focus, !1);
  };
  mm(n, "focus", t ? r : void 0), mm(n, "blur", t ? i : void 0);
}
function p$(e) {
  return typeof PointerEvent < "u" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function h$(e) {
  var t = !!e.touches;
  return t;
}
function zR(e) {
  return function(t) {
    var n = t instanceof MouseEvent, r = !n || n && t.button === 0;
    r && e(t);
  };
}
var LR = { pageX: 0, pageY: 0 };
function VR(e, t) {
  t === void 0 && (t = "page");
  var n = e.touches[0] || e.changedTouches[0], r = n || LR;
  return {
    x: r[t + "X"],
    y: r[t + "Y"]
  };
}
function BR(e, t) {
  return t === void 0 && (t = "page"), {
    x: e[t + "X"],
    y: e[t + "Y"]
  };
}
function Dy(e, t) {
  return t === void 0 && (t = "page"), {
    point: h$(e) ? VR(e, t) : BR(e, t)
  };
}
var v$ = function(e, t) {
  t === void 0 && (t = !1);
  var n = function(r) {
    return e(r, Dy(r));
  };
  return t ? zR(n) : n;
}, UR = function() {
  return Js && window.onpointerdown === null;
}, KR = function() {
  return Js && window.ontouchstart === null;
}, qR = function() {
  return Js && window.onmousedown === null;
}, HR = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, WR = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function m$(e) {
  return UR() ? e : KR() ? WR[e] : qR() ? HR[e] : e;
}
function ys(e, t, n, r) {
  return np(e, m$(t), v$(n, t === "pointerdown"), r);
}
function Gf(e, t, n, r) {
  return mm(e, m$(t), n && v$(n, t === "pointerdown"), r);
}
function g$(e) {
  var t = null;
  return function() {
    var n = function() {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
var u1 = g$("dragHorizontal"), c1 = g$("dragVertical");
function y$(e) {
  var t = !1;
  if (e === "y")
    t = c1();
  else if (e === "x")
    t = u1();
  else {
    var n = u1(), r = c1();
    n && r ? t = function() {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function b$() {
  var e = y$(!0);
  return e ? (e(), !1) : !0;
}
function f1(e, t, n) {
  return function(r, i) {
    var o;
    !p$(r) || b$() || ((o = e.animationState) === null || o === void 0 || o.setActive(xt.Hover, t), n?.(r, i));
  };
}
function ZR(e) {
  var t = e.onHoverStart, n = e.onHoverEnd, r = e.whileHover, i = e.visualElement;
  Gf(i, "pointerenter", t || r ? f1(i, !0, t) : void 0, { passive: !t }), Gf(i, "pointerleave", n || r ? f1(i, !1, n) : void 0, { passive: !n });
}
var _$ = function(e, t) {
  return t ? e === t ? !0 : _$(e, t.parentElement) : !1;
};
function Ay(e) {
  return Se(function() {
    return function() {
      return e();
    };
  }, []);
}
const Yf = (e, t, n) => Math.min(Math.max(n, e), t), Oh = 1e-3, GR = 0.01, d1 = 10, YR = 0.05, QR = 1;
function JR({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, o;
  Qs(e <= d1 * 1e3, "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = Yf(YR, QR, a), e = Yf(GR, d1, e / 1e3), a < 1 ? (i = (u) => {
    const c = u * a, f = c * e, d = c - n, p = gm(u, a), h = Math.exp(-f);
    return Oh - d / p * h;
  }, o = (u) => {
    const f = u * a * e, d = f * n + n, p = Math.pow(a, 2) * Math.pow(u, 2) * e, h = Math.exp(-f), v = gm(Math.pow(u, 2), a);
    return (-i(u) + Oh > 0 ? -1 : 1) * ((d - p) * h) / v;
  }) : (i = (u) => {
    const c = Math.exp(-u * e), f = (u - n) * e + 1;
    return -Oh + c * f;
  }, o = (u) => {
    const c = Math.exp(-u * e), f = (n - u) * (e * e);
    return c * f;
  });
  const s = 5 / e, l = eM(i, o, s);
  if (e = e * 1e3, isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: a * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const XR = 12;
function eM(e, t, n) {
  let r = n;
  for (let i = 1; i < XR; i++)
    r = r - e(r) / t(r);
  return r;
}
function gm(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const tM = ["duration", "bounce"], nM = ["stiffness", "damping", "mass"];
function p1(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function rM(e) {
  let t = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!p1(e, nM) && p1(e, tM)) {
    const n = JR(e);
    t = Object.assign(Object.assign(Object.assign({}, t), n), { velocity: 0, mass: 1 }), t.isResolvedFromDuration = !0;
  }
  return t;
}
function Cy(e) {
  var { from: t = 0, to: n = 1, restSpeed: r = 2, restDelta: i } = e, o = Dr(e, ["from", "to", "restSpeed", "restDelta"]);
  const a = { done: !1, value: t };
  let { stiffness: s, damping: l, mass: u, velocity: c, duration: f, isResolvedFromDuration: d } = rM(o), p = h1, h = h1;
  function v() {
    const m = c ? -(c / 1e3) : 0, g = n - t, y = l / (2 * Math.sqrt(s * u)), w = Math.sqrt(s / u) / 1e3;
    if (i === void 0 && (i = Math.min(Math.abs(n - t) / 100, 0.4)), y < 1) {
      const x = gm(w, y);
      p = (S) => {
        const O = Math.exp(-y * w * S);
        return n - O * ((m + y * w * g) / x * Math.sin(x * S) + g * Math.cos(x * S));
      }, h = (S) => {
        const O = Math.exp(-y * w * S);
        return y * w * O * (Math.sin(x * S) * (m + y * w * g) / x + g * Math.cos(x * S)) - O * (Math.cos(x * S) * (m + y * w * g) - x * g * Math.sin(x * S));
      };
    } else if (y === 1)
      p = (x) => n - Math.exp(-w * x) * (g + (m + w * g) * x);
    else {
      const x = w * Math.sqrt(y * y - 1);
      p = (S) => {
        const O = Math.exp(-y * w * S), P = Math.min(x * S, 300);
        return n - O * ((m + y * w * g) * Math.sinh(P) + x * g * Math.cosh(P)) / x;
      };
    }
  }
  return v(), {
    next: (m) => {
      const g = p(m);
      if (d)
        a.done = m >= f;
      else {
        const y = h(m) * 1e3, w = Math.abs(y) <= r, x = Math.abs(n - g) <= i;
        a.done = w && x;
      }
      return a.value = a.done ? n : g, a;
    },
    flipTarget: () => {
      c = -c, [t, n] = [n, t], v();
    }
  };
}
Cy.needsInterpolation = (e, t) => typeof e == "string" || typeof t == "string";
const h1 = (e) => 0, Tu = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, qt = (e, t, n) => -n * e + n * t + e;
function $h(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function v1({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = $h(l, s, e + 1 / 3), o = $h(l, s, e), a = $h(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const iM = (e, t, n) => {
  const r = e * e, i = t * t;
  return Math.sqrt(Math.max(0, n * (i - r) + r));
}, oM = [hm, mo, oa], m1 = (e) => oM.find((t) => t.test(e)), g1 = (e) => `'${e}' is not an animatable color. Use the equivalent color code instead.`, w$ = (e, t) => {
  let n = m1(e), r = m1(t);
  Or(!!n, g1(e)), Or(!!r, g1(t));
  let i = n.parse(e), o = r.parse(t);
  n === oa && (i = v1(i), n = mo), r === oa && (o = v1(o), r = mo);
  const a = Object.assign({}, i);
  return (s) => {
    for (const l in a)
      l !== "alpha" && (a[l] = iM(i[l], o[l], s));
    return a.alpha = qt(i.alpha, o.alpha, s), n.transform(a);
  };
}, ym = (e) => typeof e == "number", aM = (e, t) => (n) => t(e(n)), rp = (...e) => e.reduce(aM);
function x$(e, t) {
  return ym(e) ? (n) => qt(e, t, n) : Dn.test(e) ? w$(e, t) : S$(e, t);
}
const E$ = (e, t) => {
  const n = [...e], r = n.length, i = e.map((o, a) => x$(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}, sM = (e, t) => {
  const n = Object.assign(Object.assign({}, e), t), r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = x$(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
};
function y1(e) {
  const t = Bi.parse(e), n = t.length;
  let r = 0, i = 0, o = 0;
  for (let a = 0; a < n; a++)
    r || typeof t[a] == "number" ? r++ : t[a].hue !== void 0 ? o++ : i++;
  return { parsed: t, numNumbers: r, numRGB: i, numHSL: o };
}
const S$ = (e, t) => {
  const n = Bi.createTransformer(t), r = y1(e), i = y1(t);
  return r.numHSL === i.numHSL && r.numRGB === i.numRGB && r.numNumbers >= i.numNumbers ? rp(E$(r.parsed, i.parsed), n) : (Qs(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (a) => `${a > 0 ? t : e}`);
}, lM = (e, t) => (n) => qt(e, t, n);
function uM(e) {
  if (typeof e == "number")
    return lM;
  if (typeof e == "string")
    return Dn.test(e) ? w$ : S$;
  if (Array.isArray(e))
    return E$;
  if (typeof e == "object")
    return sM;
}
function cM(e, t, n) {
  const r = [], i = n || uM(e[0]), o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] : t;
      s = rp(l, s);
    }
    r.push(s);
  }
  return r;
}
function fM([e, t], [n]) {
  return (r) => n(Tu(e, t, r));
}
function dM(e, t) {
  const n = e.length, r = n - 1;
  return (i) => {
    let o = 0, a = !1;
    if (i <= e[0] ? a = !0 : i >= e[r] && (o = r - 1, a = !0), !a) {
      let l = 1;
      for (; l < n && !(e[l] > i || l === r); l++)
        ;
      o = l - 1;
    }
    const s = Tu(e[o], e[o + 1], i);
    return t[o](s);
  };
}
function O$(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  Or(o === t.length, "Both input and output ranges must be the same length"), Or(!r || !Array.isArray(r) || r.length === o - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[o - 1] && (e = [].concat(e), t = [].concat(t), e.reverse(), t.reverse());
  const a = cM(t, r, i), s = o === 2 ? fM(e, a) : dM(e, a);
  return n ? (l) => s(Yf(e[0], e[o - 1], l)) : s;
}
const ip = (e) => (t) => 1 - e(1 - t), Iy = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, pM = (e) => (t) => Math.pow(t, e), $$ = (e) => (t) => t * t * ((e + 1) * t - e), hM = (e) => {
  const t = $$(e);
  return (n) => (n *= 2) < 1 ? 0.5 * t(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1)));
}, T$ = 1.525, vM = 4 / 11, mM = 8 / 11, gM = 9 / 10, Ny = (e) => e, Ry = pM(2), yM = ip(Ry), k$ = Iy(Ry), P$ = (e) => 1 - Math.sin(Math.acos(e)), My = ip(P$), bM = Iy(My), jy = $$(T$), _M = ip(jy), wM = Iy(jy), xM = hM(T$), EM = 4356 / 361, SM = 35442 / 1805, OM = 16061 / 1805, Qf = (e) => {
  if (e === 1 || e === 0)
    return e;
  const t = e * e;
  return e < vM ? 7.5625 * t : e < mM ? 9.075 * t - 9.9 * e + 3.4 : e < gM ? EM * t - SM * e + OM : 10.8 * e * e - 20.52 * e + 10.72;
}, $M = ip(Qf), TM = (e) => e < 0.5 ? 0.5 * (1 - Qf(1 - e * 2)) : 0.5 * Qf(e * 2 - 1) + 0.5;
function kM(e, t) {
  return e.map(() => t || k$).splice(0, e.length - 1);
}
function PM(e) {
  const t = e.length;
  return e.map((n, r) => r !== 0 ? r / (t - 1) : 0);
}
function DM(e, t) {
  return e.map((n) => n * t);
}
function _f({ from: e = 0, to: t = 1, ease: n, offset: r, duration: i = 300 }) {
  const o = { done: !1, value: e }, a = Array.isArray(t) ? t : [e, t], s = DM(r && r.length === a.length ? r : PM(a), i);
  function l() {
    return O$(s, a, {
      ease: Array.isArray(n) ? n : kM(a, n)
    });
  }
  let u = l();
  return {
    next: (c) => (o.value = u(c), o.done = c >= i, o),
    flipTarget: () => {
      a.reverse(), u = l();
    }
  };
}
function AM({ velocity: e = 0, from: t = 0, power: n = 0.8, timeConstant: r = 350, restDelta: i = 0.5, modifyTarget: o }) {
  const a = { done: !1, value: t };
  let s = n * e;
  const l = t + s, u = o === void 0 ? l : o(l);
  return u !== l && (s = u - t), {
    next: (c) => {
      const f = -s * Math.exp(-c / r);
      return a.done = !(f > i || f < -i), a.value = a.done ? u : u + f, a;
    },
    flipTarget: () => {
    }
  };
}
const b1 = { keyframes: _f, spring: Cy, decay: AM };
function CM(e) {
  if (Array.isArray(e.to))
    return _f;
  if (b1[e.type])
    return b1[e.type];
  const t = new Set(Object.keys(e));
  return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? _f : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? Cy : _f;
}
const D$ = 1 / 60 * 1e3, IM = typeof performance < "u" ? () => performance.now() : () => Date.now(), A$ = typeof window < "u" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e(IM()), D$);
function NM(e) {
  let t = [], n = [], r = 0, i = !1, o = !1;
  const a = /* @__PURE__ */ new WeakSet(), s = {
    schedule: (l, u = !1, c = !1) => {
      const f = c && i, d = f ? t : n;
      return u && a.add(l), d.indexOf(l) === -1 && (d.push(l), f && i && (r = t.length)), l;
    },
    cancel: (l) => {
      const u = n.indexOf(l);
      u !== -1 && n.splice(u, 1), a.delete(l);
    },
    process: (l) => {
      if (i) {
        o = !0;
        return;
      }
      if (i = !0, [t, n] = [n, t], n.length = 0, r = t.length, r)
        for (let u = 0; u < r; u++) {
          const c = t[u];
          c(l), a.has(c) && (s.schedule(c), e());
        }
      i = !1, o && (o = !1, s.process(l));
    }
  };
  return s;
}
const RM = 40;
let bm = !0, ku = !1, _m = !1;
const bs = {
  delta: 0,
  timestamp: 0
}, ac = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], op = ac.reduce((e, t) => (e[t] = NM(() => ku = !0), e), {}), Gr = ac.reduce((e, t) => {
  const n = op[t];
  return e[t] = (r, i = !1, o = !1) => (ku || jM(), n.schedule(r, i, o)), e;
}, {}), Ps = ac.reduce((e, t) => (e[t] = op[t].cancel, e), {}), Th = ac.reduce((e, t) => (e[t] = () => op[t].process(bs), e), {}), MM = (e) => op[e].process(bs), C$ = (e) => {
  ku = !1, bs.delta = bm ? D$ : Math.max(Math.min(e - bs.timestamp, RM), 1), bs.timestamp = e, _m = !0, ac.forEach(MM), _m = !1, ku && (bm = !1, A$(C$));
}, jM = () => {
  ku = !0, bm = !0, _m || A$(C$);
}, Jf = () => bs;
function I$(e, t, n = 0) {
  return e - t - n;
}
function FM(e, t, n = 0, r = !0) {
  return r ? I$(t + -e, t, n) : t - (e - t) + n;
}
function zM(e, t, n, r) {
  return r ? e >= t + n : e <= -n;
}
const LM = (e) => {
  const t = ({ delta: n }) => e(n);
  return {
    start: () => Gr.update(t, !0),
    stop: () => Ps.update(t)
  };
};
function N$(e) {
  var t, n, { from: r, autoplay: i = !0, driver: o = LM, elapsed: a = 0, repeat: s = 0, repeatType: l = "loop", repeatDelay: u = 0, onPlay: c, onStop: f, onComplete: d, onRepeat: p, onUpdate: h } = e, v = Dr(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: m } = v, g, y = 0, w = v.duration, x, S = !1, O = !0, P;
  const b = CM(v);
  !((n = (t = b).needsInterpolation) === null || n === void 0) && n.call(t, r, m) && (P = O$([0, 100], [r, m], {
    clamp: !1
  }), r = 0, m = 100);
  const _ = b(Object.assign(Object.assign({}, v), { from: r, to: m }));
  function E() {
    y++, l === "reverse" ? (O = y % 2 === 0, a = FM(a, w, u, O)) : (a = I$(a, w, u), l === "mirror" && _.flipTarget()), S = !1, p && p();
  }
  function A() {
    g.stop(), d && d();
  }
  function k(N) {
    if (O || (N = -N), a += N, !S) {
      const U = _.next(Math.max(0, a));
      x = U.value, P && (x = P(x)), S = O ? U.done : a <= 0;
    }
    h?.(x), S && (y === 0 && (w ?? (w = a)), y < s ? zM(a, w, u, O) && E() : A());
  }
  function R() {
    c?.(), g = o(k), g.start();
  }
  return i && R(), {
    stop: () => {
      f?.(), g.stop();
    }
  };
}
function R$(e, t) {
  return t ? e * (1e3 / t) : 0;
}
function VM({ from: e = 0, velocity: t = 0, min: n, max: r, power: i = 0.8, timeConstant: o = 750, bounceStiffness: a = 500, bounceDamping: s = 10, restDelta: l = 1, modifyTarget: u, driver: c, onUpdate: f, onComplete: d, onStop: p }) {
  let h;
  function v(w) {
    return n !== void 0 && w < n || r !== void 0 && w > r;
  }
  function m(w) {
    return n === void 0 ? r : r === void 0 || Math.abs(n - w) < Math.abs(r - w) ? n : r;
  }
  function g(w) {
    h?.stop(), h = N$(Object.assign(Object.assign({}, w), {
      driver: c,
      onUpdate: (x) => {
        var S;
        f?.(x), (S = w.onUpdate) === null || S === void 0 || S.call(w, x);
      },
      onComplete: d,
      onStop: p
    }));
  }
  function y(w) {
    g(Object.assign({ type: "spring", stiffness: a, damping: s, restDelta: l }, w));
  }
  if (v(e))
    y({ from: e, velocity: t, to: m(e) });
  else {
    let w = i * t + e;
    typeof u < "u" && (w = u(w));
    const x = m(w), S = x === n ? -1 : 1;
    let O, P;
    const b = (_) => {
      O = P, P = _, t = R$(_ - O, Jf().delta), (S === 1 && _ > x || S === -1 && _ < x) && y({ from: _, to: x, velocity: t });
    };
    g({
      type: "decay",
      from: e,
      velocity: t,
      timeConstant: o,
      power: i,
      restDelta: l,
      modifyTarget: u,
      onUpdate: v(w) ? b : void 0
    });
  }
  return {
    stop: () => h?.stop()
  };
}
const wm = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), _1 = (e) => wm(e) && e.hasOwnProperty("z"), Rc = (e, t) => Math.abs(e - t);
function M$(e, t) {
  if (ym(e) && ym(t))
    return Rc(e, t);
  if (wm(e) && wm(t)) {
    const n = Rc(e.x, t.x), r = Rc(e.y, t.y), i = _1(e) && _1(t) ? Rc(e.z, t.z) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(i, 2));
  }
}
const j$ = (e, t) => 1 - 3 * t + 3 * e, F$ = (e, t) => 3 * t - 6 * e, z$ = (e) => 3 * e, Xf = (e, t, n) => ((j$(t, n) * e + F$(t, n)) * e + z$(t)) * e, L$ = (e, t, n) => 3 * j$(t, n) * e * e + 2 * F$(t, n) * e + z$(t), BM = 1e-7, UM = 10;
function KM(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = Xf(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > BM && ++s < UM);
  return a;
}
const qM = 8, HM = 1e-3;
function WM(e, t, n, r) {
  for (let i = 0; i < qM; ++i) {
    const o = L$(t, n, r);
    if (o === 0)
      return t;
    const a = Xf(t, n, r) - e;
    t -= a / o;
  }
  return t;
}
const wf = 11, Mc = 1 / (wf - 1);
function ZM(e, t, n, r) {
  if (e === t && n === r)
    return Ny;
  const i = new Float32Array(wf);
  for (let a = 0; a < wf; ++a)
    i[a] = Xf(a * Mc, e, n);
  function o(a) {
    let s = 0, l = 1;
    const u = wf - 1;
    for (; l !== u && i[l] <= a; ++l)
      s += Mc;
    --l;
    const c = (a - i[l]) / (i[l + 1] - i[l]), f = s + c * Mc, d = L$(f, e, n);
    return d >= HM ? WM(a, f, e, n) : d === 0 ? f : KM(a, s, s + Mc, e, n);
  }
  return (a) => a === 0 || a === 1 ? a : Xf(o(a), t, r);
}
function GM(e) {
  var t = e.onTap, n = e.onTapStart, r = e.onTapCancel, i = e.whileTap, o = e.visualElement, a = t || n || r || i, s = _e(!1), l = _e(null), u = {
    passive: !(n || t || r || h)
  };
  function c() {
    var v;
    (v = l.current) === null || v === void 0 || v.call(l), l.current = null;
  }
  function f() {
    var v;
    return c(), s.current = !1, (v = o.animationState) === null || v === void 0 || v.setActive(xt.Tap, !1), !b$();
  }
  function d(v, m) {
    f() && (_$(o.getInstance(), v.target) ? t?.(v, m) : r?.(v, m));
  }
  function p(v, m) {
    f() && r?.(v, m);
  }
  function h(v, m) {
    var g;
    c(), !s.current && (s.current = !0, l.current = rp(ys(window, "pointerup", d, u), ys(window, "pointercancel", p, u)), (g = o.animationState) === null || g === void 0 || g.setActive(xt.Tap, !0), n?.(v, m));
  }
  Gf(o, "pointerdown", a ? h : void 0, u), Ay(c);
}
var w1 = /* @__PURE__ */ new Set();
function V$(e, t, n) {
  e || w1.has(t) || (console.warn(t), w1.add(t));
}
var xm = /* @__PURE__ */ new WeakMap(), kh = /* @__PURE__ */ new WeakMap(), YM = function(e) {
  var t;
  (t = xm.get(e.target)) === null || t === void 0 || t(e);
}, QM = function(e) {
  e.forEach(YM);
};
function JM(e) {
  var t = e.root, n = Dr(e, ["root"]), r = t || document;
  kh.has(r) || kh.set(r, {});
  var i = kh.get(r), o = JSON.stringify(n);
  return i[o] || (i[o] = new IntersectionObserver(QM, we({ root: t }, n))), i[o];
}
function XM(e, t, n) {
  var r = JM(t);
  return xm.set(e, n), r.observe(e), function() {
    xm.delete(e), r.unobserve(e);
  };
}
function ej(e) {
  var t = e.visualElement, n = e.whileInView, r = e.onViewportEnter, i = e.onViewportLeave, o = e.viewport, a = o === void 0 ? {} : o, s = _e({
    hasEnteredView: !1,
    isInView: !1
  }), l = !!(n || r || i);
  a.once && s.current.hasEnteredView && (l = !1);
  var u = typeof IntersectionObserver > "u" ? rj : nj;
  u(l, s.current, t, a);
}
var tj = {
  some: 0,
  all: 1
};
function nj(e, t, n, r) {
  var i = r.root, o = r.margin, a = r.amount, s = a === void 0 ? "some" : a, l = r.once;
  Se(function() {
    if (e) {
      var u = {
        root: i?.current,
        rootMargin: o,
        threshold: typeof s == "number" ? s : tj[s]
      }, c = function(f) {
        var d, p = f.isIntersecting;
        if (t.isInView !== p && (t.isInView = p, !(l && !p && t.hasEnteredView))) {
          p && (t.hasEnteredView = !0), (d = n.animationState) === null || d === void 0 || d.setActive(xt.InView, p);
          var h = n.getProps(), v = p ? h.onViewportEnter : h.onViewportLeave;
          v?.(f);
        }
      };
      return XM(n.getInstance(), u, c);
    }
  }, [e, i, o, s]);
}
function rj(e, t, n, r) {
  var i = r.fallback, o = i === void 0 ? !0 : i;
  Se(function() {
    !e || !o || (wy !== "production" && V$(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var a;
      t.hasEnteredView = !0;
      var s = n.getProps().onViewportEnter;
      s?.(null), (a = n.animationState) === null || a === void 0 || a.setActive(xt.InView, !0);
    }));
  }, [e]);
}
var go = function(e) {
  return function(t) {
    return e(t), null;
  };
}, ij = {
  inView: go(ej),
  tap: go(GM),
  focus: go(FR),
  hover: go(ZR)
}, oj = 0, aj = function() {
  return oj++;
}, B$ = function() {
  return Xs(aj);
};
function U$() {
  var e = Ie(nc);
  if (e === null)
    return [!0, null];
  var t = e.isPresent, n = e.onExitComplete, r = e.register, i = B$();
  Se(function() {
    return r(i);
  }, []);
  var o = function() {
    return n?.(i);
  };
  return !t && n ? [!1, o] : [!0];
}
function K$(e, t) {
  if (!Array.isArray(t))
    return !1;
  var n = t.length;
  if (n !== e.length)
    return !1;
  for (var r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
var ed = function(e) {
  return e * 1e3;
}, x1 = {
  linear: Ny,
  easeIn: Ry,
  easeInOut: k$,
  easeOut: yM,
  circIn: P$,
  circInOut: bM,
  circOut: My,
  backIn: jy,
  backInOut: wM,
  backOut: _M,
  anticipate: xM,
  bounceIn: $M,
  bounceInOut: TM,
  bounceOut: Qf
}, E1 = function(e) {
  if (Array.isArray(e)) {
    Or(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var t = Bt(e, 4), n = t[0], r = t[1], i = t[2], o = t[3];
    return ZM(n, r, i, o);
  } else if (typeof e == "string")
    return Or(x1[e] !== void 0, "Invalid easing type '".concat(e, "'")), x1[e];
  return e;
}, sj = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, S1 = function(e, t) {
  return e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
  Bi.test(t) && // And it contains numbers and/or colors
  !t.startsWith("url("));
}, Wo = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, jc = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, Ph = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, lj = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, O1 = {
  x: Wo,
  y: Wo,
  z: Wo,
  rotate: Wo,
  rotateX: Wo,
  rotateY: Wo,
  rotateZ: Wo,
  scaleX: jc,
  scaleY: jc,
  scale: jc,
  opacity: Ph,
  backgroundColor: Ph,
  color: Ph,
  default: jc
}, uj = function(e, t) {
  var n;
  return $u(t) ? n = lj : n = O1[e] || O1.default, we({ to: t }, n(t));
}, cj = we(we({}, n$), {
  // Color props
  color: Dn,
  backgroundColor: Dn,
  outlineColor: Dn,
  fill: Dn,
  stroke: Dn,
  // Border props
  borderColor: Dn,
  borderTopColor: Dn,
  borderRightColor: Dn,
  borderBottomColor: Dn,
  borderLeftColor: Dn,
  filter: vm,
  WebkitFilter: vm
}), Fy = function(e) {
  return cj[e];
};
function zy(e, t) {
  var n, r = Fy(e);
  return r !== vm && (r = Bi), (n = r.getAnimatableNone) === null || n === void 0 ? void 0 : n.call(r, t);
}
function fj(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var t = Dr(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(t).length;
}
var $1 = !1;
function dj(e) {
  var t = e.ease, n = e.times, r = e.yoyo, i = e.flip, o = e.loop, a = Dr(e, ["ease", "times", "yoyo", "flip", "loop"]), s = we({}, a);
  return n && (s.offset = n), a.duration && (s.duration = ed(a.duration)), a.repeatDelay && (s.repeatDelay = ed(a.repeatDelay)), t && (s.ease = sj(t) ? t.map(E1) : E1(t)), a.type === "tween" && (s.type = "keyframes"), (r || o || i) && (Qs(!$1, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), $1 = !0, r ? s.repeatType = "reverse" : o ? s.repeatType = "loop" : i && (s.repeatType = "mirror"), s.repeat = o || r || i || a.repeat), a.type !== "spring" && (s.type = "keyframes"), s;
}
function pj(e, t) {
  var n, r, i = Ly(e, t) || {};
  return (r = (n = i.delay) !== null && n !== void 0 ? n : e.delay) !== null && r !== void 0 ? r : 0;
}
function hj(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = Zr([], Bt(e.to), !1), e.to[0] = e.from), e;
}
function vj(e, t, n) {
  var r;
  return Array.isArray(t.to) && ((r = e.duration) !== null && r !== void 0 || (e.duration = 0.8)), hj(t), fj(e) || (e = we(we({}, e), uj(n, t.to))), we(we({}, t), dj(e));
}
function mj(e, t, n, r, i) {
  var o, a = Ly(r, e), s = (o = a.from) !== null && o !== void 0 ? o : t.get(), l = S1(e, n);
  s === "none" && l && typeof n == "string" ? s = zy(e, n) : T1(s) && typeof n == "string" ? s = k1(n) : !Array.isArray(n) && T1(n) && typeof s == "string" && (n = k1(s));
  var u = S1(e, s);
  Qs(u === l, "You are trying to animate ".concat(e, ' from "').concat(s, '" to "').concat(n, '". ').concat(s, " is not an animatable value - to enable this animation set ").concat(s, " to a value animatable to ").concat(n, " via the `style` property."));
  function c() {
    var d = {
      from: s,
      to: n,
      velocity: t.getVelocity(),
      onComplete: i,
      onUpdate: function(p) {
        return t.set(p);
      }
    };
    return a.type === "inertia" || a.type === "decay" ? VM(we(we({}, d), a)) : N$(we(we({}, vj(a, d, e)), { onUpdate: function(p) {
      var h;
      d.onUpdate(p), (h = a.onUpdate) === null || h === void 0 || h.call(a, p);
    }, onComplete: function() {
      var p;
      d.onComplete(), (p = a.onComplete) === null || p === void 0 || p.call(a);
    } }));
  }
  function f() {
    var d, p, h = f$(n);
    return t.set(h), i(), (d = a?.onUpdate) === null || d === void 0 || d.call(a, h), (p = a?.onComplete) === null || p === void 0 || p.call(a), { stop: function() {
    } };
  }
  return !u || !l || a.type === !1 ? f : c;
}
function T1(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function k1(e) {
  return typeof e == "number" ? 0 : zy("", e);
}
function Ly(e, t) {
  return e[t] || e.default || e;
}
function Vy(e, t, n, r) {
  return r === void 0 && (r = {}), t.start(function(i) {
    var o, a, s = mj(e, t, n, r, i), l = pj(r, e), u = function() {
      return a = s();
    };
    return l ? o = window.setTimeout(u, ed(l)) : u(), function() {
      clearTimeout(o), a?.stop();
    };
  });
}
var gj = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, yj = function(e) {
  return /^0[^.\s]+$/.test(e);
};
function By(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Uy(e, t) {
  var n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
var iu = (
  /** @class */
  (function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(t) {
      var n = this;
      return By(this.subscriptions, t), function() {
        return Uy(n.subscriptions, t);
      };
    }, e.prototype.notify = function(t, n, r) {
      var i = this.subscriptions.length;
      if (i)
        if (i === 1)
          this.subscriptions[0](t, n, r);
        else
          for (var o = 0; o < i; o++) {
            var a = this.subscriptions[o];
            a && a(t, n, r);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  })()
), bj = function(e) {
  return !isNaN(parseFloat(e));
}, _j = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new iu(), this.velocityUpdateSubscribers = new iu(), this.renderSubscribers = new iu(), this.canTrackVelocity = !1, this.updateAndNotify = function(r, i) {
        i === void 0 && (i = !0), n.prev = n.current, n.current = r;
        var o = Jf(), a = o.delta, s = o.timestamp;
        n.lastUpdated !== s && (n.timeDelta = a, n.lastUpdated = s, Gr.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), i && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function() {
        return Gr.postRender(n.velocityCheck);
      }, this.velocityCheck = function(r) {
        var i = r.timestamp;
        i !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = bj(this.current);
    }
    return e.prototype.onChange = function(t) {
      return this.updateSubscribers.add(t);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(t) {
      return t(this.get()), this.renderSubscribers.add(t);
    }, e.prototype.attach = function(t) {
      this.passiveEffect = t;
    }, e.prototype.set = function(t, n) {
      n === void 0 && (n = !0), !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        R$(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(t) {
      var n = this;
      return this.stop(), new Promise(function(r) {
        n.hasAnimated = !0, n.stopAnimation = t(r);
      }).then(function() {
        return n.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  })()
);
function Ds(e) {
  return new _j(e);
}
var q$ = function(e) {
  return function(t) {
    return t.test(e);
  };
}, wj = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, H$ = [Da, Ke, wi, ro, fR, cR, wj], Pl = function(e) {
  return H$.find(q$(e));
}, xj = Zr(Zr([], Bt(H$), !1), [Dn, Bi], !1), Ej = function(e) {
  return xj.find(q$(e));
};
function Sj(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, Ds(n));
}
function Oj(e, t) {
  var n = ep(e, t), r = n ? e.makeTargetAnimatable(n, !1) : {}, i = r.transitionEnd, o = i === void 0 ? {} : i;
  r.transition;
  var a = Dr(r, ["transitionEnd", "transition"]);
  a = we(we({}, a), o);
  for (var s in a) {
    var l = f$(a[s]);
    Sj(e, s, l);
  }
}
function $j(e, t, n) {
  var r, i, o, a, s = Object.keys(t).filter(function(p) {
    return !e.hasValue(p);
  }), l = s.length;
  if (l)
    for (var u = 0; u < l; u++) {
      var c = s[u], f = t[c], d = null;
      Array.isArray(f) && (d = f[0]), d === null && (d = (i = (r = n[c]) !== null && r !== void 0 ? r : e.readValue(c)) !== null && i !== void 0 ? i : t[c]), d != null && (typeof d == "string" && (gj(d) || yj(d)) ? d = parseFloat(d) : !Ej(d) && Bi.test(f) && (d = zy(c, f)), e.addValue(c, Ds(d)), (o = (a = n)[c]) !== null && o !== void 0 || (a[c] = d), e.setBaseTarget(c, d));
    }
}
function Tj(e, t) {
  if (t) {
    var n = t[e] || t.default || t;
    return n.from;
  }
}
function kj(e, t, n) {
  var r, i, o = {};
  for (var a in e)
    o[a] = (r = Tj(a, t)) !== null && r !== void 0 ? r : (i = n.getValue(a)) === null || i === void 0 ? void 0 : i.get();
  return o;
}
function Pj(e, t, n) {
  n === void 0 && (n = {}), e.notifyAnimationStart(t);
  var r;
  if (Array.isArray(t)) {
    var i = t.map(function(a) {
      return Em(e, a, n);
    });
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = Em(e, t, n);
  else {
    var o = typeof t == "function" ? ep(e, t, n.custom) : t;
    r = W$(e, o, n);
  }
  return r.then(function() {
    return e.notifyAnimationComplete(t);
  });
}
function Em(e, t, n) {
  var r;
  n === void 0 && (n = {});
  var i = ep(e, t, n.custom), o = (i || {}).transition, a = o === void 0 ? e.getDefaultTransition() || {} : o;
  n.transitionOverride && (a = n.transitionOverride);
  var s = i ? function() {
    return W$(e, i, n);
  } : function() {
    return Promise.resolve();
  }, l = !((r = e.variantChildren) === null || r === void 0) && r.size ? function(p) {
    p === void 0 && (p = 0);
    var h = a.delayChildren, v = h === void 0 ? 0 : h, m = a.staggerChildren, g = a.staggerDirection;
    return Dj(e, t, v + p, m, g, n);
  } : function() {
    return Promise.resolve();
  }, u = a.when;
  if (u) {
    var c = Bt(u === "beforeChildren" ? [s, l] : [l, s], 2), f = c[0], d = c[1];
    return f().then(d);
  } else
    return Promise.all([s(), l(n.delay)]);
}
function W$(e, t, n) {
  var r, i = n === void 0 ? {} : n, o = i.delay, a = o === void 0 ? 0 : o, s = i.transitionOverride, l = i.type, u = e.makeTargetAnimatable(t), c = u.transition, f = c === void 0 ? e.getDefaultTransition() : c, d = u.transitionEnd, p = Dr(u, ["transition", "transitionEnd"]);
  s && (f = s);
  var h = [], v = l && ((r = e.animationState) === null || r === void 0 ? void 0 : r.getState()[l]);
  for (var m in p) {
    var g = e.getValue(m), y = p[m];
    if (!(!g || y === void 0 || v && Cj(v, m))) {
      var w = we({ delay: a }, f);
      e.shouldReduceMotion && rc(m) && (w = we(we({}, w), { type: !1, delay: 0 }));
      var x = Vy(m, g, y, w);
      h.push(x);
    }
  }
  return Promise.all(h).then(function() {
    d && Oj(e, d);
  });
}
function Dj(e, t, n, r, i, o) {
  n === void 0 && (n = 0), r === void 0 && (r = 0), i === void 0 && (i = 1);
  var a = [], s = (e.variantChildren.size - 1) * r, l = i === 1 ? function(u) {
    return u === void 0 && (u = 0), u * r;
  } : function(u) {
    return u === void 0 && (u = 0), s - u * r;
  };
  return Array.from(e.variantChildren).sort(Aj).forEach(function(u, c) {
    a.push(Em(u, t, we(we({}, o), { delay: n + l(c) })).then(function() {
      return u.notifyAnimationComplete(t);
    }));
  }), Promise.all(a);
}
function Aj(e, t) {
  return e.sortNodePosition(t);
}
function Cj(e, t) {
  var n = e.protectedKeys, r = e.needsAnimating, i = n.hasOwnProperty(t) && r[t] !== !0;
  return r[t] = !1, i;
}
var Ky = [
  xt.Animate,
  xt.InView,
  xt.Focus,
  xt.Hover,
  xt.Tap,
  xt.Drag,
  xt.Exit
], Ij = Zr([], Bt(Ky), !1).reverse(), Nj = Ky.length;
function Rj(e) {
  return function(t) {
    return Promise.all(t.map(function(n) {
      var r = n.animation, i = n.options;
      return Pj(e, r, i);
    }));
  };
}
function Mj(e) {
  var t = Rj(e), n = Fj(), r = {}, i = !0, o = function(c, f) {
    var d = ep(e, f);
    if (d) {
      d.transition;
      var p = d.transitionEnd, h = Dr(d, ["transition", "transitionEnd"]);
      c = we(we(we({}, c), h), p);
    }
    return c;
  };
  function a(c) {
    return r[c] !== void 0;
  }
  function s(c) {
    t = c(e);
  }
  function l(c, f) {
    for (var d, p = e.getProps(), h = e.getVariantContext(!0) || {}, v = [], m = /* @__PURE__ */ new Set(), g = {}, y = 1 / 0, w = function(P) {
      var b = Ij[P], _ = n[b], E = (d = p[b]) !== null && d !== void 0 ? d : h[b], A = Vr(E), k = b === f ? _.isActive : null;
      k === !1 && (y = P);
      var R = E === h[b] && E !== p[b] && A;
      if (R && i && e.manuallyAnimateOnMount && (R = !1), _.protectedKeys = we({}, g), // If it isn't active and hasn't *just* been set as inactive
      !_.isActive && k === null || // If we didn't and don't have any defined prop for this animation type
      !E && !_.prevProp || // Or if the prop doesn't define an animation
      Py(E) || typeof E == "boolean")
        return "continue";
      var N = jj(_.prevProp, E), U = N || // If we're making this variant active, we want to always make it active
      b === f && _.isActive && !R && A || // If we removed a higher-priority variant (i is in reverse order)
      P > y && A, H = Array.isArray(E) ? E : [E], ee = H.reduce(o, {});
      k === !1 && (ee = {});
      var ue = _.prevResolvedValues, Q = ue === void 0 ? {} : ue, $ = we(we({}, Q), ee), F = function(Y) {
        U = !0, m.delete(Y), _.needsAnimating[Y] = !0;
      };
      for (var I in $) {
        var L = ee[I], K = Q[I];
        g.hasOwnProperty(I) || (L !== K ? $u(L) && $u(K) ? !K$(L, K) || N ? F(I) : _.protectedKeys[I] = !0 : L !== void 0 ? F(I) : m.add(I) : L !== void 0 && m.has(I) ? F(I) : _.protectedKeys[I] = !0);
      }
      _.prevProp = E, _.prevResolvedValues = ee, _.isActive && (g = we(we({}, g), ee)), i && e.blockInitialAnimation && (U = !1), U && !R && v.push.apply(v, Zr([], Bt(H.map(function(Y) {
        return {
          animation: Y,
          options: we({ type: b }, c)
        };
      })), !1));
    }, x = 0; x < Nj; x++)
      w(x);
    if (r = we({}, g), m.size) {
      var S = {};
      m.forEach(function(P) {
        var b = e.getBaseTarget(P);
        b !== void 0 && (S[P] = b);
      }), v.push({ animation: S });
    }
    var O = !!v.length;
    return i && p.initial === !1 && !e.manuallyAnimateOnMount && (O = !1), i = !1, O ? t(v) : Promise.resolve();
  }
  function u(c, f, d) {
    var p;
    if (n[c].isActive === f)
      return Promise.resolve();
    (p = e.variantChildren) === null || p === void 0 || p.forEach(function(m) {
      var g;
      return (g = m.animationState) === null || g === void 0 ? void 0 : g.setActive(c, f);
    }), n[c].isActive = f;
    var h = l(d, c);
    for (var v in n)
      n[v].protectedKeys = {};
    return h;
  }
  return {
    isAnimated: a,
    animateChanges: l,
    setActive: u,
    setAnimateFunction: s,
    getState: function() {
      return n;
    }
  };
}
function jj(e, t) {
  return typeof t == "string" ? t !== e : BO(t) ? !K$(t, e) : !1;
}
function Zo(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Fj() {
  var e;
  return e = {}, e[xt.Animate] = Zo(!0), e[xt.InView] = Zo(), e[xt.Hover] = Zo(), e[xt.Tap] = Zo(), e[xt.Drag] = Zo(), e[xt.Focus] = Zo(), e[xt.Exit] = Zo(), e;
}
var zj = {
  animation: go(function(e) {
    var t = e.visualElement, n = e.animate;
    t.animationState || (t.animationState = Mj(t)), Py(n) && Se(function() {
      return n.subscribe(t);
    }, [n]);
  }),
  exit: go(function(e) {
    var t = e.custom, n = e.visualElement, r = Bt(U$(), 2), i = r[0], o = r[1], a = Ie(nc);
    Se(function() {
      var s, l;
      n.isPresent = i;
      var u = (s = n.animationState) === null || s === void 0 ? void 0 : s.setActive(xt.Exit, !i, { custom: (l = a?.custom) !== null && l !== void 0 ? l : t });
      !i && u?.then(o);
    }, [i]);
  })
}, Z$ = (
  /** @class */
  (function() {
    function e(t, n, r) {
      var i = this, o = r === void 0 ? {} : r, a = o.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (i.lastMoveEvent && i.lastMoveEventInfo) {
          var d = Ah(i.lastMoveEventInfo, i.history), p = i.startEvent !== null, h = M$(d.offset, { x: 0, y: 0 }) >= 3;
          if (!(!p && !h)) {
            var v = d.point, m = Jf().timestamp;
            i.history.push(we(we({}, v), { timestamp: m }));
            var g = i.handlers, y = g.onStart, w = g.onMove;
            p || (y && y(i.lastMoveEvent, d), i.startEvent = i.lastMoveEvent), w && w(i.lastMoveEvent, d);
          }
        }
      }, this.handlePointerMove = function(d, p) {
        if (i.lastMoveEvent = d, i.lastMoveEventInfo = Dh(p, i.transformPagePoint), p$(d) && d.buttons === 0) {
          i.handlePointerUp(d, p);
          return;
        }
        Gr.update(i.updatePoint, !0);
      }, this.handlePointerUp = function(d, p) {
        i.end();
        var h = i.handlers, v = h.onEnd, m = h.onSessionEnd, g = Ah(Dh(p, i.transformPagePoint), i.history);
        i.startEvent && v && v(d, g), m && m(d, g);
      }, !(h$(t) && t.touches.length > 1)) {
        this.handlers = n, this.transformPagePoint = a;
        var s = Dy(t), l = Dh(s, this.transformPagePoint), u = l.point, c = Jf().timestamp;
        this.history = [we(we({}, u), { timestamp: c })];
        var f = n.onSessionStart;
        f && f(t, Ah(l, this.history)), this.removeListeners = rp(ys(window, "pointermove", this.handlePointerMove), ys(window, "pointerup", this.handlePointerUp), ys(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(t) {
      this.handlers = t;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), Ps.update(this.updatePoint);
    }, e;
  })()
);
function Dh(e, t) {
  return t ? { point: t(e.point) } : e;
}
function P1(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Ah(e, t) {
  var n = e.point;
  return {
    point: n,
    delta: P1(n, G$(t)),
    offset: P1(n, Lj(t)),
    velocity: Vj(t, 0.1)
  };
}
function Lj(e) {
  return e[0];
}
function G$(e) {
  return e[e.length - 1];
}
function Vj(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var n = e.length - 1, r = null, i = G$(e); n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > ed(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  var o = (i.timestamp - r.timestamp) / 1e3;
  if (o === 0)
    return { x: 0, y: 0 };
  var a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function Ui(e) {
  return e.max - e.min;
}
function D1(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 0.01), M$(e, t) < n;
}
function A1(e, t, n, r) {
  r === void 0 && (r = 0.5), e.origin = r, e.originPoint = qt(t.min, t.max, e.origin), e.scale = Ui(n) / Ui(t), (D1(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = qt(n.min, n.max, e.origin) - e.originPoint, (D1(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function ou(e, t, n, r) {
  A1(e.x, t.x, n.x, r?.originX), A1(e.y, t.y, n.y, r?.originY);
}
function C1(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Ui(t);
}
function Bj(e, t, n) {
  C1(e.x, t.x, n.x), C1(e.y, t.y, n.y);
}
function I1(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Ui(t);
}
function au(e, t, n) {
  I1(e.x, t.x, n.x), I1(e.y, t.y, n.y);
}
function Uj(e, t, n) {
  var r = t.min, i = t.max;
  return r !== void 0 && e < r ? e = n ? qt(r, e, n.min) : Math.max(e, r) : i !== void 0 && e > i && (e = n ? qt(i, e, n.max) : Math.min(e, i)), e;
}
function N1(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function Kj(e, t) {
  var n = t.top, r = t.left, i = t.bottom, o = t.right;
  return {
    x: N1(e.x, r, o),
    y: N1(e.y, n, i)
  };
}
function R1(e, t) {
  var n, r = t.min - e.min, i = t.max - e.max;
  return t.max - t.min < e.max - e.min && (n = Bt([i, r], 2), r = n[0], i = n[1]), { min: r, max: i };
}
function qj(e, t) {
  return {
    x: R1(e.x, t.x),
    y: R1(e.y, t.y)
  };
}
function Hj(e, t) {
  var n = 0.5, r = Ui(e), i = Ui(t);
  return i > r ? n = Tu(t.min, t.max - r, e.min) : r > i && (n = Tu(e.min, e.max - i, t.min)), Yf(0, 1, n);
}
function Wj(e, t) {
  var n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
var Sm = 0.35;
function Zj(e) {
  return e === void 0 && (e = Sm), e === !1 ? e = 0 : e === !0 && (e = Sm), {
    x: M1(e, "left", "right"),
    y: M1(e, "top", "bottom")
  };
}
function M1(e, t, n) {
  return {
    min: j1(e, t),
    max: j1(e, n)
  };
}
function j1(e, t) {
  var n;
  return typeof e == "number" ? e : (n = e[t]) !== null && n !== void 0 ? n : 0;
}
var F1 = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, su = function() {
  return {
    x: F1(),
    y: F1()
  };
}, z1 = function() {
  return { min: 0, max: 0 };
}, _n = function() {
  return {
    x: z1(),
    y: z1()
  };
};
function hi(e) {
  return [e("x"), e("y")];
}
function Y$(e) {
  var t = e.top, n = e.left, r = e.right, i = e.bottom;
  return {
    x: { min: n, max: r },
    y: { min: t, max: i }
  };
}
function Gj(e) {
  var t = e.x, n = e.y;
  return { top: n.min, right: t.max, bottom: n.max, left: t.min };
}
function Yj(e, t) {
  if (!t)
    return e;
  var n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Ch(e) {
  return e === void 0 || e === 1;
}
function Q$(e) {
  var t = e.scale, n = e.scaleX, r = e.scaleY;
  return !Ch(t) || !Ch(n) || !Ch(r);
}
function io(e) {
  return Q$(e) || L1(e.x) || L1(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function L1(e) {
  return e && e !== "0%";
}
function td(e, t, n) {
  var r = e - n, i = t * r;
  return n + i;
}
function V1(e, t, n, r, i) {
  return i !== void 0 && (e = td(e, i, r)), td(e, n, r) + t;
}
function Om(e, t, n, r, i) {
  t === void 0 && (t = 0), n === void 0 && (n = 1), e.min = V1(e.min, t, n, r, i), e.max = V1(e.max, t, n, r, i);
}
function J$(e, t) {
  var n = t.x, r = t.y;
  Om(e.x, n.translate, n.scale, n.originPoint), Om(e.y, r.translate, r.scale, r.originPoint);
}
function Qj(e, t, n, r) {
  var i, o;
  r === void 0 && (r = !1);
  var a = n.length;
  if (a) {
    t.x = t.y = 1;
    for (var s, l, u = 0; u < a; u++)
      s = n[u], l = s.projectionDelta, ((o = (i = s.instance) === null || i === void 0 ? void 0 : i.style) === null || o === void 0 ? void 0 : o.display) !== "contents" && (r && s.options.layoutScroll && s.scroll && s !== s.root && os(e, { x: -s.scroll.x, y: -s.scroll.y }), l && (t.x *= l.x.scale, t.y *= l.y.scale, J$(e, l)), r && io(s.latestValues) && os(e, s.latestValues));
  }
}
function ao(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function B1(e, t, n) {
  var r = Bt(n, 3), i = r[0], o = r[1], a = r[2], s = t[a] !== void 0 ? t[a] : 0.5, l = qt(e.min, e.max, s);
  Om(e, t[i], t[o], l, t.scale);
}
var Jj = ["x", "scaleX", "originX"], Xj = ["y", "scaleY", "originY"];
function os(e, t) {
  B1(e.x, t, Jj), B1(e.y, t, Xj);
}
function X$(e, t) {
  return Y$(Yj(e.getBoundingClientRect(), t));
}
function e8(e, t, n) {
  var r = X$(e, n), i = t.scroll;
  return i && (ao(r.x, i.x), ao(r.y, i.y)), r;
}
var t8 = /* @__PURE__ */ new WeakMap(), n8 = (
  /** @class */
  (function() {
    function e(t) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = _n(), this.visualElement = t;
    }
    return e.prototype.start = function(t, n) {
      var r = this, i = n === void 0 ? {} : n, o = i.snapToCursor, a = o === void 0 ? !1 : o;
      if (this.visualElement.isPresent !== !1) {
        var s = function(f) {
          r.stopAnimation(), a && r.snapToCursor(Dy(f, "page").point);
        }, l = function(f, d) {
          var p, h = r.getProps(), v = h.drag, m = h.dragPropagation, g = h.onDragStart;
          v && !m && (r.openGlobalLock && r.openGlobalLock(), r.openGlobalLock = y$(v), !r.openGlobalLock) || (r.isDragging = !0, r.currentDirection = null, r.resolveConstraints(), r.visualElement.projection && (r.visualElement.projection.isAnimationBlocked = !0, r.visualElement.projection.target = void 0), hi(function(y) {
            var w, x, S = r.getAxisMotionValue(y).get() || 0;
            if (wi.test(S)) {
              var O = (x = (w = r.visualElement.projection) === null || w === void 0 ? void 0 : w.layout) === null || x === void 0 ? void 0 : x.actual[y];
              if (O) {
                var P = Ui(O);
                S = P * (parseFloat(S) / 100);
              }
            }
            r.originPoint[y] = S;
          }), g?.(f, d), (p = r.visualElement.animationState) === null || p === void 0 || p.setActive(xt.Drag, !0));
        }, u = function(f, d) {
          var p = r.getProps(), h = p.dragPropagation, v = p.dragDirectionLock, m = p.onDirectionLock, g = p.onDrag;
          if (!(!h && !r.openGlobalLock)) {
            var y = d.offset;
            if (v && r.currentDirection === null) {
              r.currentDirection = r8(y), r.currentDirection !== null && m?.(r.currentDirection);
              return;
            }
            r.updateAxis("x", d.point, y), r.updateAxis("y", d.point, y), r.visualElement.syncRender(), g?.(f, d);
          }
        }, c = function(f, d) {
          return r.stop(f, d);
        };
        this.panSession = new Z$(t, {
          onSessionStart: s,
          onStart: l,
          onMove: u,
          onSessionEnd: c
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(t, n) {
      var r = this.isDragging;
      if (this.cancel(), !!r) {
        var i = n.velocity;
        this.startAnimation(i);
        var o = this.getProps().onDragEnd;
        o?.(t, n);
      }
    }, e.prototype.cancel = function() {
      var t, n;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (t = this.panSession) === null || t === void 0 || t.end(), this.panSession = void 0;
      var r = this.getProps().dragPropagation;
      !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (n = this.visualElement.animationState) === null || n === void 0 || n.setActive(xt.Drag, !1);
    }, e.prototype.updateAxis = function(t, n, r) {
      var i = this.getProps().drag;
      if (!(!r || !Fc(t, i, this.currentDirection))) {
        var o = this.getAxisMotionValue(t), a = this.originPoint[t] + r[t];
        this.constraints && this.constraints[t] && (a = Uj(a, this.constraints[t], this.elastic[t])), o.set(a);
      }
    }, e.prototype.resolveConstraints = function() {
      var t = this, n = this.getProps(), r = n.dragConstraints, i = n.dragElastic, o = (this.visualElement.projection || {}).layout, a = this.constraints;
      r && is(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && o ? this.constraints = Kj(o.actual, r) : this.constraints = !1, this.elastic = Zj(i), a !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && hi(function(s) {
        t.getAxisMotionValue(s) && (t.constraints[s] = Wj(o.actual[s], t.constraints[s]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var t = this.getProps(), n = t.dragConstraints, r = t.onMeasureDragConstraints;
      if (!n || !is(n))
        return !1;
      var i = n.current;
      Or(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var o = this.visualElement.projection;
      if (!o || !o.layout)
        return !1;
      var a = e8(i, o.root, this.visualElement.getTransformPagePoint()), s = qj(o.layout.actual, a);
      if (r) {
        var l = r(Gj(s));
        this.hasMutatedConstraints = !!l, l && (s = Y$(l));
      }
      return s;
    }, e.prototype.startAnimation = function(t) {
      var n = this, r = this.getProps(), i = r.drag, o = r.dragMomentum, a = r.dragElastic, s = r.dragTransition, l = r.dragSnapToOrigin, u = r.onDragTransitionEnd, c = this.constraints || {}, f = hi(function(d) {
        var p;
        if (Fc(d, i, n.currentDirection)) {
          var h = (p = c?.[d]) !== null && p !== void 0 ? p : {};
          l && (h = { min: 0, max: 0 });
          var v = a ? 200 : 1e6, m = a ? 40 : 1e7, g = we(we({ type: "inertia", velocity: o ? t[d] : 0, bounceStiffness: v, bounceDamping: m, timeConstant: 750, restDelta: 1, restSpeed: 10 }, s), h);
          return n.startAxisValueAnimation(d, g);
        }
      });
      return Promise.all(f).then(u);
    }, e.prototype.startAxisValueAnimation = function(t, n) {
      var r = this.getAxisMotionValue(t);
      return Vy(t, r, 0, n);
    }, e.prototype.stopAnimation = function() {
      var t = this;
      hi(function(n) {
        return t.getAxisMotionValue(n).stop();
      });
    }, e.prototype.getAxisMotionValue = function(t) {
      var n, r, i = "_drag" + t.toUpperCase(), o = this.visualElement.getProps()[i];
      return o || this.visualElement.getValue(t, (r = (n = this.visualElement.getProps().initial) === null || n === void 0 ? void 0 : n[t]) !== null && r !== void 0 ? r : 0);
    }, e.prototype.snapToCursor = function(t) {
      var n = this;
      hi(function(r) {
        var i = n.getProps().drag;
        if (Fc(r, i, n.currentDirection)) {
          var o = n.visualElement.projection, a = n.getAxisMotionValue(r);
          if (o && o.layout) {
            var s = o.layout.actual[r], l = s.min, u = s.max;
            a.set(t[r] - qt(l, u, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var t = this, n, r = this.getProps(), i = r.drag, o = r.dragConstraints, a = this.visualElement.projection;
      if (!(!is(o) || !a || !this.constraints)) {
        this.stopAnimation();
        var s = { x: 0, y: 0 };
        hi(function(u) {
          var c = t.getAxisMotionValue(u);
          if (c) {
            var f = c.get();
            s[u] = Hj({ min: f, max: f }, t.constraints[u]);
          }
        });
        var l = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = l ? l({}, "") : "none", (n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout(), this.resolveConstraints(), hi(function(u) {
          if (Fc(u, i, null)) {
            var c = t.getAxisMotionValue(u), f = t.constraints[u], d = f.min, p = f.max;
            c.set(qt(d, p, s[u]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var t = this, n;
      t8.set(this.visualElement, this);
      var r = this.visualElement.getInstance(), i = ys(r, "pointerdown", function(u) {
        var c = t.getProps(), f = c.drag, d = c.dragListener, p = d === void 0 ? !0 : d;
        f && p && t.start(u);
      }), o = function() {
        var u = t.getProps().dragConstraints;
        is(u) && (t.constraints = t.resolveRefConstraints());
      }, a = this.visualElement.projection, s = a.addEventListener("measure", o);
      a && !a.layout && ((n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout()), o();
      var l = np(window, "resize", function() {
        return t.scalePositionWithinConstraints();
      });
      return a.addEventListener("didUpdate", (function(u) {
        var c = u.delta, f = u.hasLayoutChanged;
        t.isDragging && f && (hi(function(d) {
          var p = t.getAxisMotionValue(d);
          p && (t.originPoint[d] += c[d].translate, p.set(p.get() + c[d].translate));
        }), t.visualElement.syncRender());
      })), function() {
        l(), i(), s();
      };
    }, e.prototype.getProps = function() {
      var t = this.visualElement.getProps(), n = t.drag, r = n === void 0 ? !1 : n, i = t.dragDirectionLock, o = i === void 0 ? !1 : i, a = t.dragPropagation, s = a === void 0 ? !1 : a, l = t.dragConstraints, u = l === void 0 ? !1 : l, c = t.dragElastic, f = c === void 0 ? Sm : c, d = t.dragMomentum, p = d === void 0 ? !0 : d;
      return we(we({}, t), { drag: r, dragDirectionLock: o, dragPropagation: s, dragConstraints: u, dragElastic: f, dragMomentum: p });
    }, e;
  })()
);
function Fc(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function r8(e, t) {
  t === void 0 && (t = 10);
  var n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
function i8(e) {
  var t = e.dragControls, n = e.visualElement, r = Xs(function() {
    return new n8(n);
  });
  Se(function() {
    return t && t.subscribe(r);
  }, [r, t]), Se(function() {
    return r.addListeners();
  }, [r]);
}
function o8(e) {
  var t = e.onPan, n = e.onPanStart, r = e.onPanEnd, i = e.onPanSessionStart, o = e.visualElement, a = t || n || r || i, s = _e(null), l = Ie(xy).transformPagePoint, u = {
    onSessionStart: i,
    onStart: n,
    onMove: t,
    onEnd: function(f, d) {
      s.current = null, r && r(f, d);
    }
  };
  Se(function() {
    s.current !== null && s.current.updateHandlers(u);
  });
  function c(f) {
    s.current = new Z$(f, u, {
      transformPagePoint: l
    });
  }
  Gf(o, "pointerdown", a && c), Ay(function() {
    return s.current && s.current.end();
  });
}
var a8 = {
  pan: go(o8),
  drag: go(i8)
}, zc = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function s8() {
  var e = zc.map(function() {
    return new iu();
  }), t = {}, n = {
    clearAllListeners: function() {
      return e.forEach(function(r) {
        return r.clear();
      });
    },
    updatePropListeners: function(r) {
      zc.forEach(function(i) {
        var o, a = "on" + i, s = r[a];
        (o = t[i]) === null || o === void 0 || o.call(t), s && (t[i] = n[a](s));
      });
    }
  };
  return e.forEach(function(r, i) {
    n["on" + zc[i]] = function(o) {
      return r.add(o);
    }, n["notify" + zc[i]] = function() {
      for (var o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      return r.notify.apply(r, Zr([], Bt(o), !1));
    };
  }), n;
}
function l8(e, t, n) {
  var r;
  for (var i in t) {
    var o = t[i], a = n[i];
    if (Vi(o))
      e.addValue(i, o), process.env.NODE_ENV === "development" && V$(o.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(o.version, " with 6.5.1 may not work as expected."));
    else if (Vi(a))
      e.addValue(i, Ds(o));
    else if (a !== o)
      if (e.hasValue(i)) {
        var s = e.getValue(i);
        !s.hasAnimated && s.set(o);
      } else
        e.addValue(i, Ds((r = e.getStaticValue(i)) !== null && r !== void 0 ? r : o));
  }
  for (var i in n)
    t[i] === void 0 && e.removeValue(i);
  return t;
}
var eT = function(e) {
  var t = e.treeType, n = t === void 0 ? "" : t, r = e.build, i = e.getBaseTarget, o = e.makeTargetAnimatable, a = e.measureViewportBox, s = e.render, l = e.readValueFromInstance, u = e.removeValueFromRenderState, c = e.sortNodePosition, f = e.scrapeMotionValuesFromProps;
  return function(d, p) {
    var h = d.parent, v = d.props, m = d.presenceId, g = d.blockInitialAnimation, y = d.visualState, w = d.shouldReduceMotion;
    p === void 0 && (p = {});
    var x = !1, S = y.latestValues, O = y.renderState, P, b = s8(), _ = /* @__PURE__ */ new Map(), E = /* @__PURE__ */ new Map(), A = {}, k = we({}, S), R;
    function N() {
      !P || !x || (U(), s(P, O, v.style, L.projection));
    }
    function U() {
      r(L, O, S, p, v);
    }
    function H() {
      b.notifyUpdate(S);
    }
    function ee(K, Y) {
      var se = Y.onChange(function(B) {
        S[K] = B, v.onUpdate && Gr.update(H, !1, !0);
      }), ve = Y.onRenderRequest(L.scheduleRender);
      E.set(K, function() {
        se(), ve();
      });
    }
    var ue = f(v);
    for (var Q in ue) {
      var $ = ue[Q];
      S[Q] !== void 0 && Vi($) && $.set(S[Q], !1);
    }
    var F = tp(v), I = KO(v), L = we(we({
      treeType: n,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: h ? h.depth + 1 : 0,
      parent: h,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: m,
      shouldReduceMotion: w,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: I ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!h?.isMounted(),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: g,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!P;
      },
      mount: function(K) {
        x = !0, P = L.current = K, L.projection && L.projection.mount(K), I && h && !F && (R = h?.addVariantChild(L)), _.forEach(function(Y, se) {
          return ee(se, Y);
        }), h?.children.add(L), L.setProps(v);
      },
      /**
       *
       */
      unmount: function() {
        var K;
        (K = L.projection) === null || K === void 0 || K.unmount(), Ps.update(H), Ps.render(N), E.forEach(function(Y) {
          return Y();
        }), R?.(), h?.children.delete(L), b.clearAllListeners(), P = void 0, x = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(K) {
        var Y, se = L.getClosestVariantNode();
        if (se)
          return (Y = se.variantChildren) === null || Y === void 0 || Y.add(K), function() {
            return se.variantChildren.delete(K);
          };
      },
      sortNodePosition: function(K) {
        return !c || n !== K.treeType ? 0 : c(L.getInstance(), K.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return I ? L : h?.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return v.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return P;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(K) {
        return S[K];
      },
      setStaticValue: function(K, Y) {
        return S[K] = Y;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return S;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(K) {
        L.isVisible !== K && (L.isVisible = K, L.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(K, Y) {
        return Y === void 0 && (Y = !0), o(L, K, v, Y);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return a(P, v);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(K, Y) {
        L.hasValue(K) && L.removeValue(K), _.set(K, Y), S[K] = Y.get(), ee(K, Y);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(K) {
        var Y;
        _.delete(K), (Y = E.get(K)) === null || Y === void 0 || Y(), E.delete(K), delete S[K], u(K, O);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(K) {
        return _.has(K);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(K, Y) {
        var se = _.get(K);
        return se === void 0 && Y !== void 0 && (se = Ds(Y), L.addValue(K, se)), se;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(K) {
        return _.forEach(K);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(K) {
        var Y;
        return (Y = S[K]) !== null && Y !== void 0 ? Y : l(P, K, p);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(K, Y) {
        k[K] = Y;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(K) {
        if (i) {
          var Y = i(v, K);
          if (Y !== void 0 && !Vi(Y))
            return Y;
        }
        return k[K];
      }
    }, b), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return U(), O;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        Gr.render(N, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: N,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(K) {
        (K.transformTemplate || v.transformTemplate) && L.scheduleRender(), v = K, b.updatePropListeners(K), A = l8(L, f(v), A);
      },
      getProps: function() {
        return v;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(K) {
        var Y;
        return (Y = v.variants) === null || Y === void 0 ? void 0 : Y[K];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return v.transition;
      },
      getTransformPagePoint: function() {
        return v.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(K) {
        if (K === void 0 && (K = !1), K)
          return h?.getVariantContext();
        if (!F) {
          var Y = h?.getVariantContext() || {};
          return v.initial !== void 0 && (Y.initial = v.initial), Y;
        }
        for (var se = {}, ve = 0; ve < u8; ve++) {
          var B = tT[ve], T = v[B];
          (Vr(T) || T === !1) && (se[B] = T);
        }
        return se;
      }
    });
    return L;
  };
}, tT = Zr(["initial"], Bt(Ky), !1), u8 = tT.length;
function $m(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var nT = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function c8(e) {
  var t = nT.exec(e);
  if (!t)
    return [,];
  var n = Bt(t, 3), r = n[1], i = n[2];
  return [r, i];
}
var f8 = 4;
function Tm(e, t, n) {
  n === void 0 && (n = 1), Or(n <= f8, 'Max CSS variable fallback depth detected in property "'.concat(e, '". This may indicate a circular fallback dependency.'));
  var r = Bt(c8(e), 2), i = r[0], o = r[1];
  if (i) {
    var a = window.getComputedStyle(t).getPropertyValue(i);
    return a ? a.trim() : $m(o) ? Tm(o, t, n + 1) : o;
  }
}
function d8(e, t, n) {
  var r, i = Dr(t, []), o = e.getInstance();
  if (!(o instanceof Element))
    return { target: i, transitionEnd: n };
  n && (n = we({}, n)), e.forEachValue(function(u) {
    var c = u.get();
    if ($m(c)) {
      var f = Tm(c, o);
      f && u.set(f);
    }
  });
  for (var a in i) {
    var s = i[a];
    if ($m(s)) {
      var l = Tm(s, o);
      l && (i[a] = l, n && ((r = n[a]) !== null && r !== void 0 || (n[a] = s)));
    }
  }
  return { target: i, transitionEnd: n };
}
var p8 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), rT = function(e) {
  return p8.has(e);
}, h8 = function(e) {
  return Object.keys(e).some(rT);
}, iT = function(e, t) {
  e.set(t, !1), e.set(t);
}, Lc = function(e) {
  return e === Da || e === Ke;
}, U1;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(U1 || (U1 = {}));
var K1 = function(e, t) {
  return parseFloat(e.split(", ")[t]);
}, q1 = function(e, t) {
  return function(n, r) {
    var i = r.transform;
    if (i === "none" || !i)
      return 0;
    var o = i.match(/^matrix3d\((.+)\)$/);
    if (o)
      return K1(o[1], t);
    var a = i.match(/^matrix\((.+)\)$/);
    return a ? K1(a[1], e) : 0;
  };
}, v8 = /* @__PURE__ */ new Set(["x", "y", "z"]), m8 = Su.filter(function(e) {
  return !v8.has(e);
});
function g8(e) {
  var t = [];
  return m8.forEach(function(n) {
    var r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.syncRender(), t;
}
var H1 = {
  // Dimensions
  width: function(e, t) {
    var n = e.x, r = t.paddingLeft, i = r === void 0 ? "0" : r, o = t.paddingRight, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  height: function(e, t) {
    var n = e.y, r = t.paddingTop, i = r === void 0 ? "0" : r, o = t.paddingBottom, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  top: function(e, t) {
    var n = t.top;
    return parseFloat(n);
  },
  left: function(e, t) {
    var n = t.left;
    return parseFloat(n);
  },
  bottom: function(e, t) {
    var n = e.y, r = t.top;
    return parseFloat(r) + (n.max - n.min);
  },
  right: function(e, t) {
    var n = e.x, r = t.left;
    return parseFloat(r) + (n.max - n.min);
  },
  // Transform
  x: q1(4, 13),
  y: q1(5, 14)
}, y8 = function(e, t, n) {
  var r = t.measureViewportBox(), i = t.getInstance(), o = getComputedStyle(i), a = o.display, s = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach(function(u) {
    s[u] = H1[u](r, o);
  }), t.syncRender();
  var l = t.measureViewportBox();
  return n.forEach(function(u) {
    var c = t.getValue(u);
    iT(c, s[u]), e[u] = H1[u](l, o);
  }), e;
}, b8 = function(e, t, n, r) {
  n === void 0 && (n = {}), r === void 0 && (r = {}), t = we({}, t), r = we({}, r);
  var i = Object.keys(t).filter(rT), o = [], a = !1, s = [];
  if (i.forEach(function(c) {
    var f = e.getValue(c);
    if (e.hasValue(c)) {
      var d = n[c], p = Pl(d), h = t[c], v;
      if ($u(h)) {
        var m = h.length, g = h[0] === null ? 1 : 0;
        d = h[g], p = Pl(d);
        for (var y = g; y < m; y++)
          v ? Or(Pl(h[y]) === v, "All keyframes must be of the same type") : (v = Pl(h[y]), Or(v === p || Lc(p) && Lc(v), "Keyframes must be of the same dimension as the current value"));
      } else
        v = Pl(h);
      if (p !== v)
        if (Lc(p) && Lc(v)) {
          var w = f.get();
          typeof w == "string" && f.set(parseFloat(w)), typeof h == "string" ? t[c] = parseFloat(h) : Array.isArray(h) && v === Ke && (t[c] = h.map(parseFloat));
        } else p?.transform && v?.transform && (d === 0 || h === 0) ? d === 0 ? f.set(v.transform(d)) : t[c] = p.transform(h) : (a || (o = g8(e), a = !0), s.push(c), r[c] = r[c] !== void 0 ? r[c] : t[c], iT(f, h));
    }
  }), s.length) {
    var l = s.indexOf("height") >= 0 ? window.pageYOffset : null, u = y8(t, e, s);
    return o.length && o.forEach(function(c) {
      var f = Bt(c, 2), d = f[0], p = f[1];
      e.getValue(d).set(p);
    }), e.syncRender(), l !== null && window.scrollTo({ top: l }), { target: u, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function _8(e, t, n, r) {
  return h8(t) ? b8(e, t, n, r) : { target: t, transitionEnd: r };
}
var w8 = function(e, t, n, r) {
  var i = d8(e, t, r);
  return t = i.target, r = i.transitionEnd, _8(e, t, n, r);
};
function x8(e) {
  return window.getComputedStyle(e);
}
var oT = {
  treeType: "dom",
  readValueFromInstance: function(e, t) {
    if (rc(t)) {
      var n = Fy(t);
      return n && n.default || 0;
    } else {
      var r = x8(e);
      return (ZO(t) ? r.getPropertyValue(t) : r[t]) || 0;
    }
  },
  sortNodePosition: function(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, t) {
    var n;
    return (n = e.style) === null || n === void 0 ? void 0 : n[t];
  },
  measureViewportBox: function(e, t) {
    var n = t.transformPagePoint;
    return X$(e, n);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, t, n) {
    var r = n.transformTemplate;
    t.style.transform = r ? r({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, t) {
    e.style.transform = t.style.transform;
  },
  removeValueFromRenderState: function(e, t) {
    var n = t.vars, r = t.style;
    delete n[e], delete r[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, t, n, r) {
    var i = n.transformValues;
    r === void 0 && (r = !0);
    var o = t.transition, a = t.transitionEnd, s = Dr(t, ["transition", "transitionEnd"]), l = kj(s, o || {}, e);
    if (i && (a && (a = i(a)), s && (s = i(s)), l && (l = i(l))), r) {
      $j(e, s, l);
      var u = w8(e, s, l, a);
      a = u.transitionEnd, s = u.target;
    }
    return we({ transition: o, transitionEnd: a }, s);
  },
  scrapeMotionValuesFromProps: ky,
  build: function(e, t, n, r, i) {
    e.isVisible !== void 0 && (t.style.visibility = e.isVisible ? "visible" : "hidden"), Oy(t, n, r, i.transformTemplate);
  },
  render: s$
}, E8 = eT(oT), S8 = eT(we(we({}, oT), { getBaseTarget: function(e, t) {
  return e[t];
}, readValueFromInstance: function(e, t) {
  var n;
  return rc(t) ? ((n = Fy(t)) === null || n === void 0 ? void 0 : n.default) || 0 : (t = l$.has(t) ? t : a$(t), e.getAttribute(t));
}, scrapeMotionValuesFromProps: c$, build: function(e, t, n, r, i) {
  Ty(t, n, r, i.transformTemplate);
}, render: u$ })), O8 = function(e, t) {
  return Ey(e) ? S8(t, { enableHardwareAcceleration: !1 }) : E8(t, { enableHardwareAcceleration: !0 });
};
function W1(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
var Dl = {
  correct: function(e, t) {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Ke.test(e))
        e = parseFloat(e);
      else
        return e;
    var n = W1(e, t.target.x), r = W1(e, t.target.y);
    return "".concat(n, "% ").concat(r, "%");
  }
}, Z1 = "_$css", $8 = {
  correct: function(e, t) {
    var n = t.treeScale, r = t.projectionDelta, i = e, o = e.includes("var("), a = [];
    o && (e = e.replace(nT, function(v) {
      return a.push(v), Z1;
    }));
    var s = Bi.parse(e);
    if (s.length > 5)
      return i;
    var l = Bi.createTransformer(e), u = typeof s[0] != "number" ? 1 : 0, c = r.x.scale * n.x, f = r.y.scale * n.y;
    s[0 + u] /= c, s[1 + u] /= f;
    var d = qt(c, f, 0.5);
    typeof s[2 + u] == "number" && (s[2 + u] /= d), typeof s[3 + u] == "number" && (s[3 + u] /= d);
    var p = l(s);
    if (o) {
      var h = 0;
      p = p.replace(Z1, function() {
        var v = a[h];
        return h++, v;
      });
    }
    return p;
  }
}, T8 = (
  /** @class */
  (function(e) {
    FO(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.componentDidMount = function() {
      var n = this, r = this.props, i = r.visualElement, o = r.layoutGroup, a = r.switchLayoutGroup, s = r.layoutId, l = i.projection;
      eR(P8), l && (o?.group && o.group.add(l), a?.register && s && a.register(l), l.root.didUpdate(), l.addEventListener("animationComplete", function() {
        n.safeToRemove();
      }), l.setOptions(we(we({}, l.options), { onExitComplete: function() {
        return n.safeToRemove();
      } }))), tu.hasEverUpdated = !0;
    }, t.prototype.getSnapshotBeforeUpdate = function(n) {
      var r = this, i = this.props, o = i.layoutDependency, a = i.visualElement, s = i.drag, l = i.isPresent, u = a.projection;
      return u && (u.isPresent = l, s || n.layoutDependency !== o || o === void 0 ? u.willUpdate() : this.safeToRemove(), n.isPresent !== l && (l ? u.promote() : u.relegate() || Gr.postRender(function() {
        var c;
        !((c = u.getStack()) === null || c === void 0) && c.members.length || r.safeToRemove();
      }))), null;
    }, t.prototype.componentDidUpdate = function() {
      var n = this.props.visualElement.projection;
      n && (n.root.didUpdate(), !n.currentAnimation && n.isLead() && this.safeToRemove());
    }, t.prototype.componentWillUnmount = function() {
      var n = this.props, r = n.visualElement, i = n.layoutGroup, o = n.switchLayoutGroup, a = r.projection;
      a && (a.scheduleCheckAfterUnmount(), i?.group && i.group.remove(a), o?.deregister && o.deregister(a));
    }, t.prototype.safeToRemove = function() {
      var n = this.props.safeToRemove;
      n?.();
    }, t.prototype.render = function() {
      return null;
    }, t;
  })(W.Component)
);
function k8(e) {
  var t = Bt(U$(), 2), n = t[0], r = t[1], i = Ie(Eu);
  return W.createElement(T8, we({}, e, { layoutGroup: i, switchLayoutGroup: Ie(qO), isPresent: n, safeToRemove: r }));
}
var P8 = {
  borderRadius: we(we({}, Dl), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: Dl,
  borderTopRightRadius: Dl,
  borderBottomLeftRadius: Dl,
  borderBottomRightRadius: Dl,
  boxShadow: $8
}, D8 = {
  measureLayout: k8
};
function A8(e, t, n) {
  n === void 0 && (n = {});
  var r = Vi(e) ? e : Ds(e);
  return Vy("", r, t, n), {
    stop: function() {
      return r.stop();
    },
    isAnimating: function() {
      return r.isAnimating();
    }
  };
}
var aT = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], C8 = aT.length, G1 = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, Y1 = function(e) {
  return typeof e == "number" || Ke.test(e);
};
function I8(e, t, n, r, i, o) {
  var a, s, l, u;
  i ? (e.opacity = qt(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (a = n.opacity) !== null && a !== void 0 ? a : 1,
    N8(r)
  ), e.opacityExit = qt((s = t.opacity) !== null && s !== void 0 ? s : 1, 0, R8(r))) : o && (e.opacity = qt((l = t.opacity) !== null && l !== void 0 ? l : 1, (u = n.opacity) !== null && u !== void 0 ? u : 1, r));
  for (var c = 0; c < C8; c++) {
    var f = "border".concat(aT[c], "Radius"), d = Q1(t, f), p = Q1(n, f);
    if (!(d === void 0 && p === void 0)) {
      d || (d = 0), p || (p = 0);
      var h = d === 0 || p === 0 || Y1(d) === Y1(p);
      h ? (e[f] = Math.max(qt(G1(d), G1(p), r), 0), (wi.test(p) || wi.test(d)) && (e[f] += "%")) : e[f] = p;
    }
  }
  (t.rotate || n.rotate) && (e.rotate = qt(t.rotate || 0, n.rotate || 0, r));
}
function Q1(e, t) {
  var n;
  return (n = e[t]) !== null && n !== void 0 ? n : e.borderRadius;
}
var N8 = sT(0, 0.5, My), R8 = sT(0.5, 0.95, Ny);
function sT(e, t, n) {
  return function(r) {
    return r < e ? 0 : r > t ? 1 : n(Tu(e, t, r));
  };
}
function J1(e, t) {
  e.min = t.min, e.max = t.max;
}
function jr(e, t) {
  J1(e.x, t.x), J1(e.y, t.y);
}
function X1(e, t, n, r, i) {
  return e -= t, e = td(e, 1 / n, r), i !== void 0 && (e = td(e, 1 / i, r)), e;
}
function M8(e, t, n, r, i, o, a) {
  if (t === void 0 && (t = 0), n === void 0 && (n = 1), r === void 0 && (r = 0.5), o === void 0 && (o = e), a === void 0 && (a = e), wi.test(t)) {
    t = parseFloat(t);
    var s = qt(a.min, a.max, t / 100);
    t = s - a.min;
  }
  if (typeof t == "number") {
    var l = qt(o.min, o.max, r);
    e === o && (l -= t), e.min = X1(e.min, t, n, l, i), e.max = X1(e.max, t, n, l, i);
  }
}
function ew(e, t, n, r, i) {
  var o = Bt(n, 3), a = o[0], s = o[1], l = o[2];
  M8(e, t[a], t[s], t[l], t.scale, r, i);
}
var j8 = ["x", "scaleX", "originX"], F8 = ["y", "scaleY", "originY"];
function tw(e, t, n, r) {
  ew(e.x, t, j8, n?.x, r?.x), ew(e.y, t, F8, n?.y, r?.y);
}
function nw(e) {
  return e.translate === 0 && e.scale === 1;
}
function lT(e) {
  return nw(e.x) && nw(e.y);
}
function uT(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
var z8 = (
  /** @class */
  (function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(t) {
      By(this.members, t), t.scheduleRender();
    }, e.prototype.remove = function(t) {
      if (Uy(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
        var n = this.members[this.members.length - 1];
        n && this.promote(n);
      }
    }, e.prototype.relegate = function(t) {
      var n = this.members.findIndex(function(a) {
        return t === a;
      });
      if (n === 0)
        return !1;
      for (var r, i = n; i >= 0; i--) {
        var o = this.members[i];
        if (o.isPresent !== !1) {
          r = o;
          break;
        }
      }
      return r ? (this.promote(r), !0) : !1;
    }, e.prototype.promote = function(t, n) {
      var r, i = this.lead;
      if (t !== i && (this.prevLead = i, this.lead = t, t.show(), i)) {
        i.instance && i.scheduleRender(), t.scheduleRender(), t.resumeFrom = i, n && (t.resumeFrom.preserveOpacity = !0), i.snapshot && (t.snapshot = i.snapshot, t.snapshot.latestValues = i.animationValues || i.latestValues, t.snapshot.isShared = !0), !((r = t.root) === null || r === void 0) && r.isUpdating && (t.isLayoutDirty = !0);
        var o = t.options.crossfade;
        o === !1 && i.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(t) {
        var n, r, i, o, a;
        (r = (n = t.options).onExitComplete) === null || r === void 0 || r.call(n), (a = (i = t.resumingFrom) === null || i === void 0 ? void 0 : (o = i.options).onExitComplete) === null || a === void 0 || a.call(o);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(t) {
        t.instance && t.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  })()
), L8 = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function rw(e, t, n) {
  var r = e.x.translate / t.x, i = e.y.translate / t.y, o = "translate3d(".concat(r, "px, ").concat(i, "px, 0) ");
  if (o += "scale(".concat(1 / t.x, ", ").concat(1 / t.y, ") "), n) {
    var a = n.rotate, s = n.rotateX, l = n.rotateY;
    a && (o += "rotate(".concat(a, "deg) ")), s && (o += "rotateX(".concat(s, "deg) ")), l && (o += "rotateY(".concat(l, "deg) "));
  }
  var u = e.x.scale * t.x, c = e.y.scale * t.y;
  return o += "scale(".concat(u, ", ").concat(c, ")"), o === L8 ? "none" : o;
}
var V8 = function(e, t) {
  return e.depth - t.depth;
}, B8 = (
  /** @class */
  (function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(t) {
      By(this.children, t), this.isDirty = !0;
    }, e.prototype.remove = function(t) {
      Uy(this.children, t), this.isDirty = !0;
    }, e.prototype.forEach = function(t) {
      this.isDirty && this.children.sort(V8), this.isDirty = !1, this.children.forEach(t);
    }, e;
  })()
), iw = 1e3;
function cT(e) {
  var t = e.attachResizeListener, n = e.defaultParent, r = e.measureScroll, i = e.checkIsScrollRoot, o = e.resetTransform;
  return (
    /** @class */
    (function() {
      function a(s, l, u) {
        var c = this;
        l === void 0 && (l = {}), u === void 0 && (u = n?.()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          c.isUpdating && (c.isUpdating = !1, c.clearAllSnapshots());
        }, this.updateProjection = function() {
          c.nodes.forEach(Z8), c.nodes.forEach(G8);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = s, this.latestValues = l, this.root = u ? u.root || u : this, this.path = u ? Zr(Zr([], Bt(u.path), !1), [u], !1) : [], this.parent = u, this.depth = u ? u.depth + 1 : 0, s && this.root.registerPotentialNode(s, this);
        for (var f = 0; f < this.path.length; f++)
          this.path[f].shouldResetTransform = !0;
        this.root === this && (this.nodes = new B8());
      }
      return a.prototype.addEventListener = function(s, l) {
        return this.eventHandlers.has(s) || this.eventHandlers.set(s, new iu()), this.eventHandlers.get(s).add(l);
      }, a.prototype.notifyListeners = function(s) {
        for (var l = [], u = 1; u < arguments.length; u++)
          l[u - 1] = arguments[u];
        var c = this.eventHandlers.get(s);
        c?.notify.apply(c, Zr([], Bt(l), !1));
      }, a.prototype.hasListeners = function(s) {
        return this.eventHandlers.has(s);
      }, a.prototype.registerPotentialNode = function(s, l) {
        this.potentialNodes.set(s, l);
      }, a.prototype.mount = function(s, l) {
        var u = this, c;
        if (l === void 0 && (l = !1), !this.instance) {
          this.isSVG = s instanceof SVGElement && s.tagName !== "svg", this.instance = s;
          var f = this.options, d = f.layoutId, p = f.layout, h = f.visualElement;
          if (h && !h.getInstance() && h.mount(s), this.root.nodes.add(this), (c = this.parent) === null || c === void 0 || c.children.add(this), this.id && this.root.potentialNodes.delete(this.id), l && (p || d) && (this.isLayoutDirty = !0), t) {
            var v, m = function() {
              return u.root.updateBlockedByResize = !1;
            };
            t(s, function() {
              u.root.updateBlockedByResize = !0, clearTimeout(v), v = window.setTimeout(m, 250), tu.hasAnimatedSinceResize && (tu.hasAnimatedSinceResize = !1, u.nodes.forEach(W8));
            });
          }
          d && this.root.registerSharedNode(d, this), this.options.animate !== !1 && h && (d || p) && this.addEventListener("didUpdate", function(g) {
            var y, w, x, S, O, P = g.delta, b = g.hasLayoutChanged, _ = g.hasRelativeTargetChanged, E = g.layout;
            if (u.isTreeAnimationBlocked()) {
              u.target = void 0, u.relativeTarget = void 0;
              return;
            }
            var A = (w = (y = u.options.transition) !== null && y !== void 0 ? y : h.getDefaultTransition()) !== null && w !== void 0 ? w : eF, k = h.getProps(), R = k.onLayoutAnimationStart, N = k.onLayoutAnimationComplete, U = !u.targetLayout || !uT(u.targetLayout, E) || _, H = !b && _;
            if (!((x = u.resumeFrom) === null || x === void 0) && x.instance || H || b && (U || !u.currentAnimation)) {
              u.resumeFrom && (u.resumingFrom = u.resumeFrom, u.resumingFrom.resumingFrom = void 0), u.setAnimationOrigin(P, H);
              var ee = we(we({}, Ly(A, "layout")), { onPlay: R, onComplete: N });
              h.shouldReduceMotion && (ee.delay = 0, ee.type = !1), u.startAnimation(ee);
            } else
              !b && u.animationProgress === 0 && u.finishAnimation(), u.isLead() && ((O = (S = u.options).onExitComplete) === null || O === void 0 || O.call(S));
            u.targetLayout = E;
          });
        }
      }, a.prototype.unmount = function() {
        var s, l;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (s = this.getStack()) === null || s === void 0 || s.remove(this), (l = this.parent) === null || l === void 0 || l.children.delete(this), this.instance = void 0, Ps.preRender(this.updateProjection);
      }, a.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, a.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, a.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, a.prototype.isTreeAnimationBlocked = function() {
        var s;
        return this.isAnimationBlocked || ((s = this.parent) === null || s === void 0 ? void 0 : s.isTreeAnimationBlocked()) || !1;
      }, a.prototype.startUpdate = function() {
        var s;
        this.isUpdateBlocked() || (this.isUpdating = !0, (s = this.nodes) === null || s === void 0 || s.forEach(Y8));
      }, a.prototype.willUpdate = function(s) {
        var l, u, c;
        if (s === void 0 && (s = !0), this.root.isUpdateBlocked()) {
          (u = (l = this.options).onExitComplete) === null || u === void 0 || u.call(l);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var f = 0; f < this.path.length; f++) {
            var d = this.path[f];
            d.shouldResetTransform = !0, d.updateScroll();
          }
          var p = this.options, h = p.layoutId, v = p.layout;
          if (!(h === void 0 && !v)) {
            var m = (c = this.options.visualElement) === null || c === void 0 ? void 0 : c.getProps().transformTemplate;
            this.prevTransformTemplateValue = m?.(this.latestValues, ""), this.updateSnapshot(), s && this.notifyListeners("willUpdate");
          }
        }
      }, a.prototype.didUpdate = function() {
        var s = this.isUpdateBlocked();
        if (s) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(ow);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(tF), this.potentialNodes.clear()), this.nodes.forEach(H8), this.nodes.forEach(U8), this.nodes.forEach(K8), this.clearAllSnapshots(), Th.update(), Th.preRender(), Th.render());
      }, a.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(q8), this.sharedNodes.forEach(Q8);
      }, a.prototype.scheduleUpdateProjection = function() {
        Gr.preRender(this.updateProjection, !1, !0);
      }, a.prototype.scheduleCheckAfterUnmount = function() {
        var s = this;
        Gr.postRender(function() {
          s.isLayoutDirty ? s.root.didUpdate() : s.root.checkUpdateFailed();
        });
      }, a.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var s = this.measure(), l = this.removeTransform(this.removeElementScroll(s));
          uw(l), this.snapshot = {
            measured: s,
            layout: l,
            latestValues: {}
          };
        }
      }, a.prototype.updateLayout = function() {
        var s;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var l = 0; l < this.path.length; l++) {
              var u = this.path[l];
              u.updateScroll();
            }
          var c = this.measure();
          uw(c);
          var f = this.layout;
          this.layout = {
            measured: c,
            actual: this.removeElementScroll(c)
          }, this.layoutCorrected = _n(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (s = this.options.visualElement) === null || s === void 0 || s.notifyLayoutMeasure(this.layout.actual, f?.actual);
        }
      }, a.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = i(this.instance), this.scroll = r(this.instance));
      }, a.prototype.resetTransform = function() {
        var s;
        if (o) {
          var l = this.isLayoutDirty || this.shouldResetTransform, u = this.projectionDelta && !lT(this.projectionDelta), c = (s = this.options.visualElement) === null || s === void 0 ? void 0 : s.getProps().transformTemplate, f = c?.(this.latestValues, ""), d = f !== this.prevTransformTemplateValue;
          l && (u || io(this.latestValues) || d) && (o(this.instance, f), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, a.prototype.measure = function() {
        var s = this.options.visualElement;
        if (!s)
          return _n();
        var l = s.measureViewportBox(), u = this.root.scroll;
        return u && (ao(l.x, u.x), ao(l.y, u.y)), l;
      }, a.prototype.removeElementScroll = function(s) {
        var l = _n();
        jr(l, s);
        for (var u = 0; u < this.path.length; u++) {
          var c = this.path[u], f = c.scroll, d = c.options, p = c.isScrollRoot;
          if (c !== this.root && f && d.layoutScroll) {
            if (p) {
              jr(l, s);
              var h = this.root.scroll;
              h && (ao(l.x, -h.x), ao(l.y, -h.y));
            }
            ao(l.x, f.x), ao(l.y, f.y);
          }
        }
        return l;
      }, a.prototype.applyTransform = function(s, l) {
        l === void 0 && (l = !1);
        var u = _n();
        jr(u, s);
        for (var c = 0; c < this.path.length; c++) {
          var f = this.path[c];
          !l && f.options.layoutScroll && f.scroll && f !== f.root && os(u, {
            x: -f.scroll.x,
            y: -f.scroll.y
          }), io(f.latestValues) && os(u, f.latestValues);
        }
        return io(this.latestValues) && os(u, this.latestValues), u;
      }, a.prototype.removeTransform = function(s) {
        var l, u = _n();
        jr(u, s);
        for (var c = 0; c < this.path.length; c++) {
          var f = this.path[c];
          if (f.instance && io(f.latestValues)) {
            Q$(f.latestValues) && f.updateSnapshot();
            var d = _n(), p = f.measure();
            jr(d, p), tw(u, f.latestValues, (l = f.snapshot) === null || l === void 0 ? void 0 : l.layout, d);
          }
        }
        return io(this.latestValues) && tw(u, this.latestValues), u;
      }, a.prototype.setTargetDelta = function(s) {
        this.targetDelta = s, this.root.scheduleUpdateProjection();
      }, a.prototype.setOptions = function(s) {
        var l;
        this.options = we(we(we({}, this.options), s), { crossfade: (l = s.crossfade) !== null && l !== void 0 ? l : !0 });
      }, a.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, a.prototype.resolveTargetDelta = function() {
        var s, l = this.options, u = l.layout, c = l.layoutId;
        !this.layout || !(u || c) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = _n(), this.relativeTargetOrigin = _n(), au(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), jr(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = _n(), this.targetWithTransforms = _n()), this.relativeTarget && this.relativeTargetOrigin && (!((s = this.relativeParent) === null || s === void 0) && s.target) ? Bj(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : jr(this.target, this.layout.actual), J$(this.target, this.targetDelta)) : jr(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = _n(), this.relativeTargetOrigin = _n(), au(this.relativeTargetOrigin, this.target, this.relativeParent.target), jr(this.relativeTarget, this.relativeTargetOrigin)))));
      }, a.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || io(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, a.prototype.calcProjection = function() {
        var s, l = this.options, u = l.layout, c = l.layoutId;
        if (this.isTreeAnimating = !!(!((s = this.parent) === null || s === void 0) && s.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(u || c))) {
          var f = this.getLead();
          jr(this.layoutCorrected, this.layout.actual), Qj(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== f);
          var d = f.target;
          if (d) {
            this.projectionDelta || (this.projectionDelta = su(), this.projectionDeltaWithTransform = su());
            var p = this.treeScale.x, h = this.treeScale.y, v = this.projectionTransform;
            ou(this.projectionDelta, this.layoutCorrected, d, this.latestValues), this.projectionTransform = rw(this.projectionDelta, this.treeScale), (this.projectionTransform !== v || this.treeScale.x !== p || this.treeScale.y !== h) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", d));
          }
        }
      }, a.prototype.hide = function() {
        this.isVisible = !1;
      }, a.prototype.show = function() {
        this.isVisible = !0;
      }, a.prototype.scheduleRender = function(s) {
        var l, u, c;
        s === void 0 && (s = !0), (u = (l = this.options).scheduleRender) === null || u === void 0 || u.call(l), s && ((c = this.getStack()) === null || c === void 0 || c.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, a.prototype.setAnimationOrigin = function(s, l) {
        var u = this, c;
        l === void 0 && (l = !1);
        var f = this.snapshot, d = f?.latestValues || {}, p = we({}, this.latestValues), h = su();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !l;
        var v = _n(), m = f?.isShared, g = (((c = this.getStack()) === null || c === void 0 ? void 0 : c.members.length) || 0) <= 1, y = !!(m && !g && this.options.crossfade === !0 && !this.path.some(X8));
        this.animationProgress = 0, this.mixTargetDelta = function(w) {
          var x, S = w / 1e3;
          aw(h.x, s.x, S), aw(h.y, s.y, S), u.setTargetDelta(h), u.relativeTarget && u.relativeTargetOrigin && u.layout && (!((x = u.relativeParent) === null || x === void 0) && x.layout) && (au(v, u.layout.actual, u.relativeParent.layout.actual), J8(u.relativeTarget, u.relativeTargetOrigin, v, S)), m && (u.animationValues = p, I8(p, d, u.latestValues, S, y, g)), u.root.scheduleUpdateProjection(), u.scheduleRender(), u.animationProgress = S;
        }, this.mixTargetDelta(0);
      }, a.prototype.startAnimation = function(s) {
        var l = this, u, c;
        this.notifyListeners("animationStart"), (u = this.currentAnimation) === null || u === void 0 || u.stop(), this.resumingFrom && ((c = this.resumingFrom.currentAnimation) === null || c === void 0 || c.stop()), this.pendingAnimation && (Ps.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = Gr.update(function() {
          tu.hasAnimatedSinceResize = !0, l.currentAnimation = A8(0, iw, we(we({}, s), { onUpdate: function(f) {
            var d;
            l.mixTargetDelta(f), (d = s.onUpdate) === null || d === void 0 || d.call(s, f);
          }, onComplete: function() {
            var f;
            (f = s.onComplete) === null || f === void 0 || f.call(s), l.completeAnimation();
          } })), l.resumingFrom && (l.resumingFrom.currentAnimation = l.currentAnimation), l.pendingAnimation = void 0;
        });
      }, a.prototype.completeAnimation = function() {
        var s;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (s = this.getStack()) === null || s === void 0 || s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, a.prototype.finishAnimation = function() {
        var s;
        this.currentAnimation && ((s = this.mixTargetDelta) === null || s === void 0 || s.call(this, iw), this.currentAnimation.stop()), this.completeAnimation();
      }, a.prototype.applyTransformsToTarget = function() {
        var s = this.getLead(), l = s.targetWithTransforms, u = s.target, c = s.layout, f = s.latestValues;
        !l || !u || !c || (jr(l, u), os(l, f), ou(this.projectionDeltaWithTransform, this.layoutCorrected, l, f));
      }, a.prototype.registerSharedNode = function(s, l) {
        var u, c, f;
        this.sharedNodes.has(s) || this.sharedNodes.set(s, new z8());
        var d = this.sharedNodes.get(s);
        d.add(l), l.promote({
          transition: (u = l.options.initialPromotionConfig) === null || u === void 0 ? void 0 : u.transition,
          preserveFollowOpacity: (f = (c = l.options.initialPromotionConfig) === null || c === void 0 ? void 0 : c.shouldPreserveFollowOpacity) === null || f === void 0 ? void 0 : f.call(c, l)
        });
      }, a.prototype.isLead = function() {
        var s = this.getStack();
        return s ? s.lead === this : !0;
      }, a.prototype.getLead = function() {
        var s, l = this.options.layoutId;
        return l ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
      }, a.prototype.getPrevLead = function() {
        var s, l = this.options.layoutId;
        return l ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
      }, a.prototype.getStack = function() {
        var s = this.options.layoutId;
        if (s)
          return this.root.sharedNodes.get(s);
      }, a.prototype.promote = function(s) {
        var l = s === void 0 ? {} : s, u = l.needsReset, c = l.transition, f = l.preserveFollowOpacity, d = this.getStack();
        d && d.promote(this, f), u && (this.projectionDelta = void 0, this.needsReset = !0), c && this.setOptions({ transition: c });
      }, a.prototype.relegate = function() {
        var s = this.getStack();
        return s ? s.relegate(this) : !1;
      }, a.prototype.resetRotation = function() {
        var s = this.options.visualElement;
        if (s) {
          for (var l = !1, u = {}, c = 0; c < dm.length; c++) {
            var f = dm[c], d = "rotate" + f;
            s.getStaticValue(d) && (l = !0, u[d] = s.getStaticValue(d), s.setStaticValue(d, 0));
          }
          if (l) {
            s?.syncRender();
            for (var d in u)
              s.setStaticValue(d, u[d]);
            s.scheduleRender();
          }
        }
      }, a.prototype.getProjectionStyles = function(s) {
        var l, u, c, f, d, p;
        s === void 0 && (s = {});
        var h = {};
        if (!this.instance || this.isSVG)
          return h;
        if (this.isVisible)
          h.visibility = "";
        else
          return { visibility: "hidden" };
        var v = (l = this.options.visualElement) === null || l === void 0 ? void 0 : l.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, h.opacity = "", h.pointerEvents = bf(s.pointerEvents) || "", h.transform = v ? v(this.latestValues, "") : "none", h;
        var m = this.getLead();
        if (!this.projectionDelta || !this.layout || !m.target) {
          var g = {};
          return this.options.layoutId && (g.opacity = (u = this.latestValues.opacity) !== null && u !== void 0 ? u : 1, g.pointerEvents = bf(s.pointerEvents) || ""), this.hasProjected && !io(this.latestValues) && (g.transform = v ? v({}, "") : "none", this.hasProjected = !1), g;
        }
        var y = m.animationValues || m.latestValues;
        this.applyTransformsToTarget(), h.transform = rw(this.projectionDeltaWithTransform, this.treeScale, y), v && (h.transform = v(y, h.transform));
        var w = this.projectionDelta, x = w.x, S = w.y;
        h.transformOrigin = "".concat(x.origin * 100, "% ").concat(S.origin * 100, "% 0"), m.animationValues ? h.opacity = m === this ? (f = (c = y.opacity) !== null && c !== void 0 ? c : this.latestValues.opacity) !== null && f !== void 0 ? f : 1 : this.preserveOpacity ? this.latestValues.opacity : y.opacityExit : h.opacity = m === this ? (d = y.opacity) !== null && d !== void 0 ? d : "" : (p = y.opacityExit) !== null && p !== void 0 ? p : 0;
        for (var O in Wf)
          if (y[O] !== void 0) {
            var P = Wf[O], b = P.correct, _ = P.applyTo, E = b(y[O], m);
            if (_)
              for (var A = _.length, k = 0; k < A; k++)
                h[_[k]] = E;
            else
              h[O] = E;
          }
        return this.options.layoutId && (h.pointerEvents = m === this ? bf(s.pointerEvents) || "" : "none"), h;
      }, a.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, a.prototype.resetTree = function() {
        this.root.nodes.forEach(function(s) {
          var l;
          return (l = s.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
        }), this.root.nodes.forEach(ow), this.root.sharedNodes.clear();
      }, a;
    })()
  );
}
function U8(e) {
  e.updateLayout();
}
function K8(e) {
  var t, n, r, i, o = (n = (t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) !== null && n !== void 0 ? n : e.snapshot;
  if (e.isLead() && e.layout && o && e.hasListeners("didUpdate")) {
    var a = e.layout, s = a.actual, l = a.measured;
    e.options.animationType === "size" ? hi(function(y) {
      var w = o.isShared ? o.measured[y] : o.layout[y], x = Ui(w);
      w.min = s[y].min, w.max = w.min + x;
    }) : e.options.animationType === "position" && hi(function(y) {
      var w = o.isShared ? o.measured[y] : o.layout[y], x = Ui(s[y]);
      w.max = w.min + x;
    });
    var u = su();
    ou(u, s, o.layout);
    var c = su();
    o.isShared ? ou(c, e.applyTransform(l, !0), o.measured) : ou(c, s, o.layout);
    var f = !lT(u), d = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var p = e.relativeParent, h = p.snapshot, v = p.layout;
      if (h && v) {
        var m = _n();
        au(m, o.layout, h.layout);
        var g = _n();
        au(g, s, v.actual), uT(m, g) || (d = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: s,
      snapshot: o,
      delta: c,
      layoutDelta: u,
      hasLayoutChanged: f,
      hasRelativeTargetChanged: d
    });
  } else e.isLead() && ((i = (r = e.options).onExitComplete) === null || i === void 0 || i.call(r));
  e.options.transition = void 0;
}
function q8(e) {
  e.clearSnapshot();
}
function ow(e) {
  e.clearMeasurements();
}
function H8(e) {
  var t = e.options.visualElement;
  t?.getProps().onBeforeLayoutMeasure && t.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function W8(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function Z8(e) {
  e.resolveTargetDelta();
}
function G8(e) {
  e.calcProjection();
}
function Y8(e) {
  e.resetRotation();
}
function Q8(e) {
  e.removeLeadSnapshot();
}
function aw(e, t, n) {
  e.translate = qt(t.translate, 0, n), e.scale = qt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function sw(e, t, n, r) {
  e.min = qt(t.min, n.min, r), e.max = qt(t.max, n.max, r);
}
function J8(e, t, n, r) {
  sw(e.x, t.x, n.x, r), sw(e.y, t.y, n.y, r);
}
function X8(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var eF = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function tF(e, t) {
  for (var n = e.root, r = e.path.length - 1; r >= 0; r--)
    if (e.path[r].instance) {
      n = e.path[r];
      break;
    }
  var i = n && n !== e.root ? n.instance : document, o = i.querySelector('[data-projection-id="'.concat(t, '"]'));
  o && e.mount(o, !0);
}
function lw(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function uw(e) {
  lw(e.x), lw(e.y);
}
var nF = cT({
  attachResizeListener: function(e, t) {
    return np(e, "resize", t);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), Ih = {
  current: void 0
}, rF = cT({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!Ih.current) {
      var e = new nF(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Ih.current = e;
    }
    return Ih.current;
  },
  resetTransform: function(e, t) {
    e.style.transform = t ?? "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), iF = we(we(we(we({}, zj), ij), a8), D8), In = /* @__PURE__ */ J5(function(e, t) {
  return jR(e, t, iF, O8, rF);
});
function fT() {
  var e = _e(!1);
  return Hf(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
function dT() {
  var e = fT(), t = Bt(Fe(0), 2), n = t[0], r = t[1], i = Me(function() {
    e.current && r(n + 1);
  }, [n]), o = Me(function() {
    return Gr.postRender(i);
  }, [i]);
  return [o, n];
}
var Nh = function(e) {
  var t = e.children, n = e.initial, r = e.isPresent, i = e.onExitComplete, o = e.custom, a = e.presenceAffectsLayout, s = Xs(oF), l = B$(), u = $e(
    function() {
      return {
        id: l,
        initial: n,
        isPresent: r,
        custom: o,
        onExitComplete: function(c) {
          var f, d;
          s.set(c, !0);
          try {
            for (var p = C5(s.values()), h = p.next(); !h.done; h = p.next()) {
              var v = h.value;
              if (!v)
                return;
            }
          } catch (m) {
            f = { error: m };
          } finally {
            try {
              h && !h.done && (d = p.return) && d.call(p);
            } finally {
              if (f) throw f.error;
            }
          }
          i?.();
        },
        register: function(c) {
          return s.set(c, !1), function() {
            return s.delete(c);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [r]
  );
  return $e(function() {
    s.forEach(function(c, f) {
      return s.set(f, !1);
    });
  }, [r]), ie.useEffect(function() {
    !r && !s.size && i?.();
  }, [r]), ie.createElement(nc.Provider, { value: u }, t);
};
function oF() {
  return /* @__PURE__ */ new Map();
}
var Qa = function(e) {
  return e.key || "";
};
function aF(e, t) {
  e.forEach(function(n) {
    var r = Qa(n);
    t.set(r, n);
  });
}
function sF(e) {
  var t = [];
  return hI.forEach(e, function(n) {
    ry(n) && t.push(n);
  }), t;
}
var km = function(e) {
  var t = e.children, n = e.custom, r = e.initial, i = r === void 0 ? !0 : r, o = e.onExitComplete, a = e.exitBeforeEnter, s = e.presenceAffectsLayout, l = s === void 0 ? !0 : s, u = Bt(dT(), 1), c = u[0], f = Ie(Eu).forceRender;
  f && (c = f);
  var d = fT(), p = sF(t), h = p, v = /* @__PURE__ */ new Set(), m = _e(h), g = _e(/* @__PURE__ */ new Map()).current, y = _e(!0);
  if (Hf(function() {
    y.current = !1, aF(p, g), m.current = h;
  }), Ay(function() {
    y.current = !0, g.clear(), v.clear();
  }), y.current)
    return ie.createElement(ie.Fragment, null, h.map(function(b) {
      return ie.createElement(Nh, { key: Qa(b), isPresent: !0, initial: i ? void 0 : !1, presenceAffectsLayout: l }, b);
    }));
  h = Zr([], Bt(h), !1);
  for (var w = m.current.map(Qa), x = p.map(Qa), S = w.length, O = 0; O < S; O++) {
    var P = w[O];
    x.indexOf(P) === -1 && v.add(P);
  }
  return a && v.size && (h = []), v.forEach(function(b) {
    if (x.indexOf(b) === -1) {
      var _ = g.get(b);
      if (_) {
        var E = w.indexOf(b), A = function() {
          g.delete(b), v.delete(b);
          var k = m.current.findIndex(function(R) {
            return R.key === b;
          });
          if (m.current.splice(k, 1), !v.size) {
            if (m.current = p, d.current === !1)
              return;
            c(), o && o();
          }
        };
        h.splice(E, 0, ie.createElement(Nh, { key: Qa(_), isPresent: !1, onExitComplete: A, custom: n, presenceAffectsLayout: l }, _));
      }
    }
  }), h = h.map(function(b) {
    var _ = b.key;
    return v.has(_) ? b : ie.createElement(Nh, { key: Qa(b), isPresent: !0, presenceAffectsLayout: l }, b);
  }), wy !== "production" && a && h.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), ie.createElement(ie.Fragment, null, v.size ? h : h.map(function(b) {
    return bu(b);
  }));
}, lF = Le(null), uF = function(e) {
  return !e.isLayoutDirty && e.willUpdate(!1);
};
function cw() {
  var e = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new WeakMap(), n = function() {
    return e.forEach(uF);
  };
  return {
    add: function(r) {
      e.add(r), t.set(r, r.addEventListener("willUpdate", n));
    },
    remove: function(r) {
      var i;
      e.delete(r), (i = t.get(r)) === null || i === void 0 || i(), t.delete(r), n();
    },
    dirty: n
  };
}
var pT = function(e) {
  return e === !0;
}, cF = function(e) {
  return pT(e === !0) || e === "id";
}, fF = function(e) {
  var t, n, r = e.children, i = e.id, o = e.inheritId, a = e.inherit, s = a === void 0 ? !0 : a;
  o !== void 0 && (s = o);
  var l = Ie(Eu), u = Ie(lF), c = Bt(dT(), 2), f = c[0], d = c[1], p = _e(null), h = (t = l.id) !== null && t !== void 0 ? t : u;
  p.current === null && (cF(s) && h && (i = i ? h + "-" + i : h), p.current = {
    id: i,
    group: pT(s) && (n = l?.group) !== null && n !== void 0 ? n : cw()
  });
  var v = $e(function() {
    return we(we({}, p.current), { forceRender: f });
  }, [d]);
  return ie.createElement(Eu.Provider, { value: v }, r);
}, dF = 0, pF = function(e) {
  var t = e.children;
  return ie.useEffect(function() {
    Qs(!1, "AnimateSharedLayout is deprecated: https://www.framer.com/docs/guide-upgrade/##shared-layout-animations");
  }, []), ie.createElement(fF, { id: Xs(function() {
    return "asl-".concat(dF++);
  }) }, t);
};
const Rh = [
  "Really?",
  "Sure?",
  "Certain?",
  "Positive?",
  "Confident?",
  "Right?",
  "Accurate?",
  "Correct?",
  "Definite?",
  "Absolutely?"
], hF = {
  y: "-200%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, vF = {
  y: "-50%",
  top: "50%",
  left: "50%",
  x: "-50%"
}, mF = Pr(
  [
    "relative",
    "cursor-pointer",
    "focus:ring-white",
    "hover:bg-red-500",
    "disabled:bg-red-400",
    "z-0",
    "px-4",
    "py-2",
    "text-sm",
    "text-white",
    "transition-all",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-opacity-75",
    "disabled:opacity-50",
    "disabled:cursor-default"
  ],
  {
    variants: {
      showConfirm: {
        true: ["bg-red-600"],
        false: ["bg-black"]
      }
    }
  }
), Ole = ({
  onDelete: e,
  numberOfQuestions: t = 1,
  className: n = ""
}) => {
  let r = t;
  t > Rh.length && (r = Rh.length), t < 1 && (r = 1);
  const [i, o] = Fe(!1), [a, s] = Fe(0);
  return /* @__PURE__ */ M.jsxs(
    In.button,
    {
      layout: !0,
      className: Un(mF({ showConfirm: i }), n),
      children: [
        /* @__PURE__ */ M.jsx("p", { className: "opacity-0", children: "Delete" }),
        /* @__PURE__ */ M.jsx(km, { children: /* @__PURE__ */ M.jsx(
          In.p,
          {
            className: "absolute text-white",
            onClick: () => o(!0),
            exit: hF,
            initial: vF,
            children: !i && "Delete"
          }
        ) }),
        /* @__PURE__ */ M.jsx(km, { children: i && /* @__PURE__ */ M.jsx(
          In.p,
          {
            className: "absolute text-white",
            onClick: () => {
              a < r - 1 ? s((l) => l + 1) : e();
            },
            initial: { y: "200%", top: "50%", left: "50%", x: "-50%" },
            animate: { y: "-50%", top: "50%", left: "50%", x: "-50%" },
            children: Rh[a]
          }
        ) })
      ]
    }
  );
}, $le = () => /* @__PURE__ */ M.jsx("hr", { className: "w-full h-px border-t-neutral-600" }), gF = Pr(
  [
    "w-48",
    "h-screen",
    "fixed",
    "top-0",
    "left-[100vw]",
    "bg-white",
    "transition-transform"
  ],
  {
    variants: {
      visible: {
        true: "-translate-x-full",
        false: ""
      }
    }
  }
), Tle = ({
  visible: e,
  children: t,
  onClose: n
}) => /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
  e && /* @__PURE__ */ M.jsx(
    "div",
    {
      className: "fixed top-0 left-0 w-screen h-screen bg-black opacity-50",
      onClick: () => n()
    }
  ),
  /* @__PURE__ */ M.jsx("div", { className: gF({ visible: e }), children: t })
] }), $n = 16, Pm = ({
  sideBarVisible: e,
  onClick: t,
  className: n = ""
}) => /* @__PURE__ */ M.jsxs(
  In.svg,
  {
    className: `my-auto cursor-pointer ${n}`,
    width: $n,
    height: $n,
    viewBox: `0 0 ${$n} ${$n}`,
    animate: e ? "open" : "closed",
    onClick: () => t(),
    children: [
      /* @__PURE__ */ M.jsx(
        In.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 1 L ${$n} 1` },
            open: { d: `M ${$n} 0 L 0 ${$n}` }
          }
        }
      ),
      /* @__PURE__ */ M.jsx(
        In.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          d: `M 0 ${$n / 2} L ${$n} ${$n / 2}`,
          variants: {
            closed: { opacity: 1 },
            open: { opacity: 0 }
          },
          transition: { duration: 0.1 }
        }
      ),
      /* @__PURE__ */ M.jsx(
        In.path,
        {
          className: "fill-transparent stroke-2 stroke-white",
          variants: {
            closed: { d: `M 0 ${$n - 1} L ${$n} ${$n - 1}` },
            open: { d: `M 0 0 L ${$n} ${$n}` }
          }
        }
      )
    ]
  }
);
Le(null);
Le(null);
Le(null);
Le(null);
Le(null);
Le({});
const Dm = Le(null), yF = Le(null), at = typeof document < "u" ? W.useLayoutEffect : () => {
};
function bF(e) {
  let [t, n] = Fe(e), r = _e(t), i = _e(null), o = _e(() => {
    if (!i.current) return;
    let s = i.current.next();
    if (s.done) {
      i.current = null;
      return;
    }
    r.current === s.value ? o.current() : n(s.value);
  });
  at(() => {
    r.current = t, i.current && o.current();
  });
  let a = Me((s) => {
    i.current = s(r.current), o.current();
  }, [
    o
  ]);
  return [
    t,
    a
  ];
}
const nd = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, hT = /* @__PURE__ */ W.createContext(nd), _F = /* @__PURE__ */ W.createContext(!1);
let wF = !!(typeof window < "u" && window.document && window.document.createElement), Mh = /* @__PURE__ */ new WeakMap();
function xF(e = !1) {
  let t = Ie(hT), n = _e(null);
  if (n.current === null && !e) {
    var r, i;
    let o = (i = W.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || i === void 0 || (r = i.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (o) {
      let a = Mh.get(o);
      a == null ? Mh.set(o, {
        id: t.current,
        state: o.memoizedState
      }) : o.memoizedState !== a.state && (t.current = a.id, Mh.delete(o));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function EF(e) {
  let t = Ie(hT);
  t === nd && !wF && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = xF(!!e), r = t === nd && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function SF(e) {
  let t = W.useId(), [n] = Fe(sc()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${nd.prefix}`;
  return e || `${r}-${t}`;
}
const OF = typeof W.useId == "function" ? SF : EF;
function $F() {
  return !1;
}
function TF() {
  return !0;
}
function kF(e) {
  return () => {
  };
}
function sc() {
  return typeof W.useSyncExternalStore == "function" ? W.useSyncExternalStore(kF, $F, TF) : Ie(_F);
}
let PF = !!(typeof window < "u" && window.document && window.document.createElement), _s = /* @__PURE__ */ new Map(), Bl;
typeof FinalizationRegistry < "u" && (Bl = new FinalizationRegistry((e) => {
  _s.delete(e);
}));
function Kn(e) {
  let [t, n] = Fe(e), r = _e(null), i = OF(t), o = _e(null);
  if (Bl && Bl.register(o, i), PF) {
    const a = _s.get(i);
    a && !a.includes(r) ? a.push(r) : _s.set(i, [
      r
    ]);
  }
  return at(() => {
    let a = i;
    return () => {
      Bl && Bl.unregister(o), _s.delete(a);
    };
  }, [
    i
  ]), Se(() => {
    let a = r.current;
    return a && n(a), () => {
      a && (r.current = null);
    };
  }), i;
}
function DF(e, t) {
  if (e === t) return e;
  let n = _s.get(e);
  if (n)
    return n.forEach((i) => i.current = t), t;
  let r = _s.get(t);
  return r ? (r.forEach((i) => i.current = e), e) : t;
}
function ua(e = []) {
  let t = Kn(), [n, r] = bF(t), i = Me(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return at(i, [
    t,
    i,
    ...e
  ]), n;
}
function Aa(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const Je = (e) => {
  var t;
  return (t = e?.ownerDocument) !== null && t !== void 0 ? t : document;
}, xn = (e) => e && "window" in e && e.window === e ? e : Je(e).defaultView || window;
function AF(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function CF(e) {
  return AF(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let IF = !1;
function Ci() {
  return IF;
}
function Ze(e, t) {
  if (!Ci()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : CF(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const Rt = (e = document) => {
  var t;
  if (!Ci()) return e.activeElement;
  let n = e.activeElement;
  for (; n && "shadowRoot" in n && (!((t = n.shadowRoot) === null || t === void 0) && t.activeElement); ) n = n.shadowRoot.activeElement;
  return n;
};
function Pe(e) {
  if (Ci() && e.target instanceof Element && e.target.shadowRoot) {
    var t, n;
    if ("composedPath" in e) return (t = e.composedPath()[0]) !== null && t !== void 0 ? t : null;
    if ("composedPath" in e.nativeEvent) return (n = e.nativeEvent.composedPath()[0]) !== null && n !== void 0 ? n : null;
  }
  return e.target;
}
function rd(e) {
  if (!e) return !1;
  let t = e.getRootNode(), n = xn(e);
  if (!(t instanceof n.Document || t instanceof n.ShadowRoot)) return !1;
  let r = t.activeElement;
  return r != null && e.contains(r);
}
class NF {
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(t) {
    if (!Ze(this.root, t)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = t, i = t;
    for (this._currentNode = t; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const a = r, s = this._doc.createTreeWalker(a, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(s), s.currentNode = i, this._currentSetFor.add(s), r = i = a.host;
    } else r = r.parentNode;
    const o = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(o), o.currentNode = i, this._currentSetFor.add(o), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let t = this.currentNode, n = this.nextNode();
    return Ze(t, n) ? (n && (this.currentNode = n), n) : (this.currentNode = t, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const t = this._walkerStack[0].nextNode();
    if (t) {
      if (t.shadowRoot) {
        var n;
        let i;
        if (typeof this.filter == "function" ? i = this.filter(t) : !((n = this.filter) === null || n === void 0) && n.acceptNode && (i = this.filter.acceptNode(t)), i === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = t, t;
        let o = this.nextNode();
        return o && (this.currentNode = o), o;
      }
      return t && (this.currentNode = t), t;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.nextNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  previousNode() {
    const t = this._walkerStack[0];
    if (t.currentNode === t.root) {
      if (this._currentSetFor.has(t))
        if (this._currentSetFor.delete(t), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let i = this.previousNode();
          return i && (this.currentNode = i), i;
        } else return null;
      return null;
    }
    const n = t.previousNode();
    if (n) {
      if (n.shadowRoot) {
        var r;
        let o;
        if (typeof this.filter == "function" ? o = this.filter(n) : !((r = this.filter) === null || r === void 0) && r.acceptNode && (o = this.filter.acceptNode(n)), o === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let a = this.lastChild();
        return a && (this.currentNode = a), a;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let i = this.previousNode();
      return i && (this.currentNode = i), i;
    } else return null;
  }
  /**
   * @deprecated
   */
  nextSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  previousSibling() {
    return null;
  }
  /**
   * @deprecated
   */
  parentNode() {
    return null;
  }
  constructor(t, n, r, i) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (a) => {
      if (a.nodeType === Node.ELEMENT_NODE) {
        const l = a.shadowRoot;
        if (l) {
          const u = this._doc.createTreeWalker(l, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(u), NodeFilter.FILTER_ACCEPT;
        } else {
          var s;
          if (typeof this.filter == "function") return this.filter(a);
          if (!((s = this.filter) === null || s === void 0) && s.acceptNode) return this.filter.acceptNode(a);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = t, this.root = n, this.filter = i ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(t.createTreeWalker(n, r, this._acceptNode));
    const o = n.shadowRoot;
    if (o) {
      const a = this._doc.createTreeWalker(o, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(a);
    }
  }
}
function vT(e, t, n, r) {
  return Ci() ? new NF(e, t, n, r) : e.createTreeWalker(t, n, r);
}
function qy(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = fw(i, t);
      return n || (n = typeof o == "function"), o;
    });
    if (n) return () => {
      r.forEach((i, o) => {
        typeof i == "function" ? i() : fw(e[o], null);
      });
    };
  };
}
function fw(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function rt(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let i in r) {
      let o = t[i], a = r[i];
      typeof o == "function" && typeof a == "function" && // This is a lot faster than a regex.
      i[0] === "o" && i[1] === "n" && i.charCodeAt(2) >= /* 'A' */
      65 && i.charCodeAt(2) <= /* 'Z' */
      90 ? t[i] = Aa(o, a) : (i === "className" || i === "UNSAFE_className") && typeof o == "string" && typeof a == "string" ? t[i] = Q2(o, a) : i === "id" && o && a ? t.id = DF(o, a) : i === "ref" && o && a ? t.ref = qy(o, a) : t[i] = a !== void 0 ? a : o;
    }
  }
  return t;
}
const RF = /* @__PURE__ */ new Set([
  "id"
]), MF = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), jF = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), FF = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), dw = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), zF = /^(data-.*)$/;
function bn(e, t = {}) {
  let { labelable: n, isLink: r, global: i, events: o = i, propNames: a } = t, s = {};
  for (const l in e) Object.prototype.hasOwnProperty.call(e, l) && (RF.has(l) || n && MF.has(l) || r && jF.has(l) || i && FF.has(l) || o && (dw.has(l) || l.endsWith("Capture") && dw.has(l.slice(0, -7))) || a?.has(l) || zF.test(l)) && (s[l] = e[l]);
  return s;
}
function Xr(e) {
  if (LF()) e.focus({
    preventScroll: !0
  });
  else {
    let t = VF(e);
    e.focus(), BF(t);
  }
}
let Vc = null;
function LF() {
  if (Vc == null) {
    Vc = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return Vc = !0, !0;
        }
      });
    } catch {
    }
  }
  return Vc;
}
function VF(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function BF(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function ap(e) {
  var t;
  if (typeof window > "u" || window.navigator == null) return !1;
  let n = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(n) && n.some((r) => e.test(r.brand)) || e.test(window.navigator.userAgent);
}
function Hy(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Qi(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const $o = Qi(function() {
  return Hy(/^Mac/i);
}), UF = Qi(function() {
  return Hy(/^iPhone/i);
}), mT = Qi(function() {
  return Hy(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  $o() && navigator.maxTouchPoints > 1;
}), lc = Qi(function() {
  return UF() || mT();
}), KF = Qi(function() {
  return $o() || lc();
}), Wy = Qi(function() {
  return ap(/AppleWebKit/i) && !Zy();
}), Zy = Qi(function() {
  return ap(/Chrome/i);
}), Gy = Qi(function() {
  return ap(/Android/i);
}), qF = Qi(function() {
  return ap(/Firefox/i);
}), HF = /* @__PURE__ */ Le({
  isNative: !0,
  open: GF,
  useHref: (e) => e
});
function sp() {
  return Ie(HF);
}
function WF(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function Ki(e, t, n = !0) {
  var r, i;
  let { metaKey: o, ctrlKey: a, altKey: s, shiftKey: l } = t;
  qF() && (!((i = window.event) === null || i === void 0 || (r = i.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && ($o() ? o = !0 : a = !0);
  let u = Wy() && $o() && !mT() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: o,
    ctrlKey: a,
    altKey: s,
    shiftKey: l
  }) : new MouseEvent("click", {
    metaKey: o,
    ctrlKey: a,
    altKey: s,
    shiftKey: l,
    detail: 1,
    bubbles: !0,
    cancelable: !0
  });
  Ki.isOpening = n, Xr(e), e.dispatchEvent(u), Ki.isOpening = !1;
}
Ki.isOpening = !1;
function ZF(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function GF(e, t) {
  ZF(e, (n) => Ki(n, t));
}
function gT(e) {
  let t = sp();
  var n;
  const r = t.useHref((n = e?.href) !== null && n !== void 0 ? n : "");
  return {
    href: e?.href ? r : void 0,
    target: e?.target,
    rel: e?.rel,
    download: e?.download,
    ping: e?.ping,
    referrerPolicy: e?.referrerPolicy
  };
}
function YF(e, t, n, r) {
  !t.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !e.isDefaultPrevented() && WF(e.currentTarget, e) && n && (e.preventDefault(), t.open(e.currentTarget, e, n, r));
}
let po = /* @__PURE__ */ new Map(), Am = /* @__PURE__ */ new Set();
function pw() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    let i = Pe(r);
    if (!e(r) || !i) return;
    let o = po.get(i);
    o || (o = /* @__PURE__ */ new Set(), po.set(i, o), i.addEventListener("transitioncancel", n, {
      once: !0
    })), o.add(r.propertyName);
  }, n = (r) => {
    let i = Pe(r);
    if (!e(r) || !i) return;
    let o = po.get(i);
    if (o && (o.delete(r.propertyName), o.size === 0 && (i.removeEventListener("transitioncancel", n), po.delete(i)), po.size === 0)) {
      for (let a of Am) a();
      Am.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? pw() : document.addEventListener("DOMContentLoaded", pw));
function QF() {
  for (const [e] of po)
    "isConnected" in e && !e.isConnected && po.delete(e);
}
function yT(e) {
  requestAnimationFrame(() => {
    QF(), po.size === 0 ? e() : Am.add(e);
  });
}
function lp() {
  let e = _e(/* @__PURE__ */ new Map()), t = Me((i, o, a, s) => {
    let l = s?.once ? (...u) => {
      e.current.delete(a), a(...u);
    } : a;
    e.current.set(a, {
      type: o,
      eventTarget: i,
      fn: l,
      options: s
    }), i.addEventListener(o, l, s);
  }, []), n = Me((i, o, a, s) => {
    var l;
    let u = ((l = e.current.get(a)) === null || l === void 0 ? void 0 : l.fn) || a;
    i.removeEventListener(o, u, s), e.current.delete(a);
  }, []), r = Me(() => {
    e.current.forEach((i, o) => {
      n(i.eventTarget, i.type, o, i.options);
    });
  }, [
    n
  ]);
  return Se(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function bT(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": i } = e;
  return n = Kn(n), i && r ? i = [
    .../* @__PURE__ */ new Set([
      n,
      ...i.trim().split(/\s+/)
    ])
  ].join(" ") : i && (i = i.trim().split(/\s+/).join(" ")), !r && !i && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": i
  };
}
function el(e) {
  const t = _e(null), n = _e(void 0), r = Me((i) => {
    if (typeof e == "function") {
      const o = e, a = o(i);
      return () => {
        typeof a == "function" ? a() : o(null);
      };
    } else if (e)
      return e.current = i, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return $e(() => ({
    get current() {
      return t.current;
    },
    set current(i) {
      t.current = i, n.current && (n.current(), n.current = void 0), i != null && (n.current = r(i));
    }
  }), [
    r
  ]);
}
var jh;
const JF = (jh = W.useInsertionEffect) !== null && jh !== void 0 ? jh : at;
function tr(e) {
  const t = _e(null);
  return JF(() => {
    t.current = e;
  }, [
    e
  ]), Me((...n) => {
    const r = t.current;
    return r?.(...n);
  }, []);
}
function hw(e, t) {
  const n = _e(!0), r = _e(null);
  at(() => (n.current = !0, () => {
    n.current = !1;
  }), []), at(() => {
    n.current ? n.current = !1 : (!r.current || t.some((i, o) => !Object.is(i, r[o]))) && e(), r.current = t;
  }, t);
}
function XF() {
  return typeof window.ResizeObserver < "u";
}
function id(e) {
  const { ref: t, box: n, onResize: r } = e;
  let i = tr(r);
  Se(() => {
    let o = t?.current;
    if (o)
      if (XF()) {
        const a = new window.ResizeObserver((s) => {
          s.length && i();
        });
        return a.observe(o, {
          box: n
        }), () => {
          o && a.unobserve(o);
        };
      } else
        return window.addEventListener("resize", i, !1), () => {
          window.removeEventListener("resize", i, !1);
        };
  }, [
    t,
    n
  ]);
}
function Yy(e, t) {
  at(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
function As(e, t) {
  if (!e) return !1;
  let n = window.getComputedStyle(e), r = document.scrollingElement || document.documentElement, i = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return e === r && n.overflow !== "hidden" && (i = !0), i && t && (i = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), i;
}
function Qy(e, t) {
  let n = e;
  for (As(n, t) && (n = n.parentElement); n && !As(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function vw(e, t) {
  let n = [], r = document.scrollingElement || document.documentElement;
  do
    As(e, t) && n.push(e), e = e.parentElement;
  while (e && e !== r);
  return n;
}
function Ja(e) {
  return $o() ? e.metaKey : e.ctrlKey;
}
const ez = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Fh(e) {
  return e instanceof HTMLInputElement && !ez.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
let tz = 0;
const zh = /* @__PURE__ */ new Map();
function nz(e) {
  let [t, n] = Fe();
  return at(() => {
    if (!e) return;
    let r = zh.get(e);
    if (r)
      n(r.element.id);
    else {
      let i = `react-aria-description-${tz++}`;
      n(i);
      let o = document.createElement("div");
      o.id = i, o.style.display = "none", o.textContent = e, document.body.appendChild(o), r = {
        refCount: 0,
        element: o
      }, zh.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), zh.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function Bc(e, t, n, r) {
  let i = tr(n), o = n == null;
  Se(() => {
    if (o || !e.current) return;
    let a = e.current;
    return a.addEventListener(t, i, r), () => {
      a.removeEventListener(t, i, r);
    };
  }, [
    e,
    t,
    r,
    o
  ]);
}
function Cm(e, t, n = {}) {
  let { block: r = "nearest", inline: i = "nearest" } = n;
  if (e === t) return;
  let o = e.scrollTop, a = e.scrollLeft, s = t.getBoundingClientRect(), l = e.getBoundingClientRect(), u = window.getComputedStyle(t), c = window.getComputedStyle(e), f = document.scrollingElement || document.documentElement, d = e === f ? 0 : l.top, p = e === f ? e.clientHeight : l.bottom, h = e === f ? 0 : l.left, v = e === f ? e.clientWidth : l.right, m = parseInt(u.scrollMarginTop, 10) || 0, g = parseInt(u.scrollMarginBottom, 10) || 0, y = parseInt(u.scrollMarginLeft, 10) || 0, w = parseInt(u.scrollMarginRight, 10) || 0, x = parseInt(c.scrollPaddingTop, 10) || 0, S = parseInt(c.scrollPaddingBottom, 10) || 0, O = parseInt(c.scrollPaddingLeft, 10) || 0, P = parseInt(c.scrollPaddingRight, 10) || 0, b = parseInt(c.borderTopWidth, 10) || 0, _ = parseInt(c.borderBottomWidth, 10) || 0, E = parseInt(c.borderLeftWidth, 10) || 0, A = parseInt(c.borderRightWidth, 10) || 0, k = s.top - m, R = s.bottom + g, N = s.left - y, U = s.right + w, H = e === f ? 0 : E + A, ee = e === f ? 0 : b + _, ue = e.offsetWidth - e.clientWidth - H, Q = e.offsetHeight - e.clientHeight - ee, $ = d + b + x, F = p - _ - S - Q, I = h + E + O, L = v - A - P;
  c.direction === "rtl" && !lc() ? I += ue : L -= ue;
  let K = k < $ || R > F, Y = N < I || U > L;
  if (K && r === "start") o += k - $;
  else if (K && r === "center") o += (k + R) / 2 - ($ + F) / 2;
  else if (K && r === "end") o += R - F;
  else if (K && r === "nearest") {
    let se = k - $, ve = R - F;
    o += Math.abs(se) <= Math.abs(ve) ? se : ve;
  }
  if (Y && i === "start") a += N - I;
  else if (Y && i === "center") a += (N + U) / 2 - (I + L) / 2;
  else if (Y && i === "end") a += U - L;
  else if (Y && i === "nearest") {
    let se = N - I, ve = U - L;
    a += Math.abs(se) <= Math.abs(ve) ? se : ve;
  }
  if (process.env.NODE_ENV === "test") {
    e.scrollLeft = a, e.scrollTop = o;
    return;
  }
  e.scrollTo({
    left: a,
    top: o
  });
}
function mw(e, t = {}) {
  let { containingElement: n } = t;
  if (e && e.isConnected) {
    let a = document.scrollingElement || document.documentElement;
    if (!(window.getComputedStyle(a).overflow === "hidden") && !Zy()) {
      var r;
      let { left: l, top: u } = e.getBoundingClientRect();
      e == null || (r = e.scrollIntoView) === null || r === void 0 || r.call(e, {
        block: "nearest"
      });
      let { left: c, top: f } = e.getBoundingClientRect();
      if (Math.abs(l - c) > 1 || Math.abs(u - f) > 1) {
        var i, o;
        n == null || (i = n.scrollIntoView) === null || i === void 0 || i.call(n, {
          block: "center",
          inline: "center"
        }), (o = e.scrollIntoView) === null || o === void 0 || o.call(e, {
          block: "nearest"
        });
      }
    } else {
      let { left: l, top: u } = e.getBoundingClientRect(), c = vw(e, !0);
      for (let p of c) Cm(p, e);
      let { left: f, top: d } = e.getBoundingClientRect();
      if (Math.abs(l - f) > 1 || Math.abs(u - d) > 1) {
        c = n ? vw(n, !0) : [];
        for (let p of c) Cm(p, n, {
          block: "center",
          inline: "center"
        });
      }
    }
  }
}
function Im(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : Gy() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function rz(e) {
  return !Gy() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function iz(e, t, n) {
  let r = tr(() => {
    n && n(t);
  });
  Se(() => {
    var i;
    let o = e == null || (i = e.current) === null || i === void 0 ? void 0 : i.form;
    return o?.addEventListener("reset", r), () => {
      o?.removeEventListener("reset", r);
    };
  }, [
    e
  ]);
}
function oz(e, t) {
  let { collection: n, onLoadMore: r, scrollOffset: i = 1 } = e, o = _e(null), a = tr((s) => {
    for (let l of s)
      l.isIntersecting && r && r();
  });
  at(() => (t.current && (o.current = new IntersectionObserver(a, {
    root: Qy(t?.current),
    rootMargin: `0px ${100 * i}% ${100 * i}% ${100 * i}%`
  }), o.current.observe(t.current)), () => {
    o.current && o.current.disconnect();
  }), [
    n,
    t,
    i
  ]);
}
function az(e) {
  const t = vI.split(".");
  return parseInt(t[0], 10) >= 19 ? e : e ? "true" : void 0;
}
const sz = "react-aria-clear-focus", lz = "react-aria-focus";
function uz(e, t = !0) {
  let [n, r] = Fe(!0), i = n && t;
  return at(() => {
    if (i && e.current && "getAnimations" in e.current)
      for (let o of e.current.getAnimations()) o instanceof CSSTransition && o.cancel();
  }, [
    e,
    i
  ]), _T(e, i, Me(() => r(!1), [])), i;
}
function cz(e, t) {
  let [n, r] = Fe(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let i = n === "exiting";
  return _T(e, i, Me(() => {
    r((o) => o === "exiting" ? "closed" : o);
  }, [])), i;
}
function _T(e, t, n) {
  at(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let i = !1;
      return Promise.all(r.map((o) => o.finished)).then(() => {
        i || oy(() => {
          n();
        });
      }).catch(() => {
      }), () => {
        i = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const fz = typeof Element < "u" && "checkVisibility" in Element.prototype;
function dz(e) {
  const t = xn(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, i = n !== "none" && r !== "hidden" && r !== "collapse";
  if (i) {
    const { getComputedStyle: o } = e.ownerDocument.defaultView;
    let { display: a, visibility: s } = o(e);
    i = a !== "none" && s !== "hidden" && s !== "collapse";
  }
  return i;
}
function pz(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function Jy(e, t) {
  return fz ? e.checkVisibility({
    visibilityProperty: !0
  }) && !e.closest("[data-react-aria-prevent-focus]") : e.nodeName !== "#comment" && dz(e) && pz(e, t) && (!e.parentElement || Jy(e.parentElement, e));
}
const Xy = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], hz = Xy.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Xy.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const vz = Xy.join(':not([hidden]):not([tabindex="-1"]),');
function wT(e) {
  return e.matches(hz) && Jy(e) && !ET(e);
}
function xT(e) {
  return e.matches(vz) && Jy(e) && !ET(e);
}
function ET(e) {
  let t = e;
  for (; t != null; ) {
    if (t instanceof t.ownerDocument.defaultView.HTMLElement && t.inert) return !0;
    t = t.parentElement;
  }
  return !1;
}
var Lh;
const mz = typeof document < "u" ? (Lh = W.useInsertionEffect) !== null && Lh !== void 0 ? Lh : W.useLayoutEffect : () => {
};
function up(e, t, n) {
  let [r, i] = Fe(e || t), o = _e(r), a = _e(e !== void 0), s = e !== void 0;
  Se(() => {
    let f = a.current;
    f !== s && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), a.current = s;
  }, [
    s
  ]);
  let l = s ? e : r;
  mz(() => {
    o.current = l;
  });
  let [, u] = B2(() => ({}), {}), c = Me((f, ...d) => {
    let p = typeof f == "function" ? f(o.current) : f;
    Object.is(o.current, p) || (o.current = p, i(p), u(), n?.(p, ...d));
  }, [
    n
  ]);
  return [
    l,
    c
  ];
}
function Nm(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
const eb = Symbol("default");
function Ca({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ W.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function Ar(e) {
  let { className: t, style: n, children: r, defaultClassName: i, defaultChildren: o, defaultStyle: a, values: s, render: l } = e;
  return $e(() => {
    let u, c, f;
    return typeof t == "function" ? u = t({
      ...s,
      defaultClassName: i
    }) : u = t, typeof n == "function" ? c = n({
      ...s,
      defaultStyle: a || {}
    }) : c = n, typeof r == "function" ? f = r({
      ...s,
      defaultChildren: o
    }) : r == null ? f = o : f = r, {
      className: u ?? i,
      style: c || a ? {
        ...a,
        ...c
      } : void 0,
      children: f ?? o,
      "data-rac": "",
      render: l ? (d) => l(d, s) : void 0
    };
  }, [
    t,
    n,
    r,
    i,
    o,
    a,
    s,
    l
  ]);
}
function cp(e, t) {
  let n = Ie(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || eb;
    if (!n.slots[r]) {
      let i = new Intl.ListFormat().format(Object.keys(n.slots).map((a) => `"${a}"`)), o = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${o} Valid slot names are ${i}.`);
    }
    return n.slots[r];
  }
  return n;
}
function $i(e, t, n) {
  let r = cp(n, e.slot) || {}, { ref: i, ...o } = r, a = el($e(() => qy(t, i), [
    t,
    i
  ])), s = rt(o, e);
  return "style" in o && o.style && "style" in e && e.style && (typeof o.style == "function" || typeof e.style == "function" ? s.style = (l) => {
    let u = typeof o.style == "function" ? o.style(l) : o.style, c = {
      ...l.defaultStyle,
      ...u
    }, f = typeof e.style == "function" ? e.style({
      ...l,
      defaultStyle: c
    }) : e.style;
    return {
      ...c,
      ...f
    };
  } : s.style = {
    ...o.style,
    ...e.style
  }), [
    s,
    a
  ];
}
function tb(e = !0) {
  let [t, n] = Fe(e), r = _e(!1), i = Me((o) => {
    r.current = !0, n(!!o);
  }, []);
  return at(() => {
    r.current || n(!1);
  }, []), [
    i,
    t
  ];
}
function gz(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
function yz(e, t, n) {
  let { render: r, ...i } = t, o = _e(null), a = $e(() => qy(n, o), [
    n,
    o
  ]);
  at(() => {
    process.env.NODE_ENV !== "production" && r && (o.current ? o.current.localName !== e && console.warn(`Unexpected DOM element returned by custom \`render\` function. Expected <${e}>, got <${o.current.localName}>. This may break the component behavior and accessibility.`) : console.warn("Ref was not connected to DOM element returned by custom `render` function. Did you forget to pass through or merge the `ref`?"));
  }, [
    e,
    r
  ]);
  let s = {
    ...i,
    ref: a
  };
  return r ? r(s, void 0) : /* @__PURE__ */ W.createElement(e, s);
}
const gw = {}, Rn = new Proxy({}, {
  get(e, t) {
    if (typeof t != "string") return;
    let n = gw[t];
    return n || (n = /* @__PURE__ */ Xt(yz.bind(null, t)), gw[t] = n), n;
  }
}), ST = 7e3;
let fi = null;
function yw(e, t = "assertive", n = ST) {
  fi ? fi.announce(e, t, n) : (fi = new bz(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? fi.announce(e, t, n) : setTimeout(() => {
    fi?.isAttached() && fi?.announce(e, t, n);
  }, 100));
}
class bz {
  isAttached() {
    var t;
    return (t = this.node) === null || t === void 0 ? void 0 : t.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = ST) {
    var i, o;
    if (!this.node) return;
    let a = document.createElement("div");
    typeof t == "object" ? (a.setAttribute("role", "img"), a.setAttribute("aria-labelledby", t["aria-labelledby"])) : a.textContent = t, n === "assertive" ? (i = this.assertiveLog) === null || i === void 0 || i.appendChild(a) : (o = this.politeLog) === null || o === void 0 || o.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
}
const hr = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, od = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, _z = {
  top: "left",
  left: "top"
}, Rm = {
  top: "height",
  left: "width"
}, OT = {
  width: "totalWidth",
  height: "totalHeight"
}, Uc = {};
let wz = () => typeof document < "u" ? window.visualViewport : null;
function bw(e, t) {
  let n = 0, r = 0, i = 0, o = 0, a = 0, s = 0, l = {};
  var u;
  let c = ((u = t?.scale) !== null && u !== void 0 ? u : 1) > 1;
  if (e.tagName === "BODY" || e.tagName === "HTML") {
    let v = document.documentElement;
    i = v.clientWidth, o = v.clientHeight;
    var f;
    n = (f = t?.width) !== null && f !== void 0 ? f : i;
    var d;
    r = (d = t?.height) !== null && d !== void 0 ? d : o, l.top = v.scrollTop || e.scrollTop, l.left = v.scrollLeft || e.scrollLeft, t && (a = t.offsetTop, s = t.offsetLeft);
  } else
    ({ width: n, height: r, top: a, left: s } = Pu(e, !1)), l.top = e.scrollTop, l.left = e.scrollLeft, i = n, o = r;
  if (Wy() && (e.tagName === "BODY" || e.tagName === "HTML") && c) {
    l.top = 0, l.left = 0;
    var p;
    a = (p = t?.pageTop) !== null && p !== void 0 ? p : 0;
    var h;
    s = (h = t?.pageLeft) !== null && h !== void 0 ? h : 0;
  }
  return {
    width: n,
    height: r,
    totalWidth: i,
    totalHeight: o,
    scroll: l,
    top: a,
    left: s
  };
}
function xz(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function _w(e, t, n, r, i, o, a) {
  var s;
  let l = (s = i.scroll[e]) !== null && s !== void 0 ? s : 0, u = r[Rm[e]], c = a[e] + r.scroll[hr[e]] + o, f = a[e] + r.scroll[hr[e]] + u - o, d = t - l + r.scroll[hr[e]] + a[e] - r[hr[e]], p = t - l + n + r.scroll[hr[e]] + a[e] - r[hr[e]];
  return d < c ? c - d : p > f ? Math.max(f - p, c - d) : 0;
}
function Ez(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function ww(e) {
  if (Uc[e]) return Uc[e];
  let [t, n] = e.split(" "), r = hr[t] || "right", i = _z[r];
  hr[n] || (n = "center");
  let o = Rm[r], a = Rm[i];
  return Uc[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: i,
    size: o,
    crossSize: a
  }, Uc[e];
}
function Vh(e, t, n, r, i, o, a, s, l, u, c) {
  let { placement: f, crossPlacement: d, axis: p, crossAxis: h, size: v, crossSize: m } = r, g = {};
  var y;
  g[h] = (y = e[h]) !== null && y !== void 0 ? y : 0;
  var w, x, S, O;
  d === "center" ? g[h] += (((w = e[m]) !== null && w !== void 0 ? w : 0) - ((x = n[m]) !== null && x !== void 0 ? x : 0)) / 2 : d !== h && (g[h] += ((S = e[m]) !== null && S !== void 0 ? S : 0) - ((O = n[m]) !== null && O !== void 0 ? O : 0)), g[h] += o;
  const P = e[h] - n[m] + l + u, b = e[h] + e[m] - l - u;
  if (g[h] = Nm(g[h], P, b), f === p) {
    let _ = s ? c[v] : c[OT[v]];
    g[od[p]] = Math.floor(_ - e[p] + i);
  } else g[p] = Math.floor(e[p] + e[v] + i);
  return g;
}
function Sz(e, t, n, r, i, o, a, s, l, u, c) {
  var f, d;
  let p = (e.top != null ? e.top : l[OT.height] - ((f = e.bottom) !== null && f !== void 0 ? f : 0) - a) - ((d = l.scroll.top) !== null && d !== void 0 ? d : 0), h = u ? n.top : 0;
  var v, m, g;
  let y = {
    // This should be boundary top in container coord system vs viewport top in container coord system
    // For the viewport top, there are several cases
    // 1. pinchzoom case where we want the viewports offset top as top here
    // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
    top: Math.max(t.top + h, ((v = c?.offsetTop) !== null && v !== void 0 ? v : t.top) + h),
    bottom: Math.min(t.top + t.height + h, ((m = c?.offsetTop) !== null && m !== void 0 ? m : 0) + ((g = c?.height) !== null && g !== void 0 ? g : 0))
  };
  var w, x, S, O;
  return s !== "top" ? (
    // We want the distance between the top of the overlay to the bottom of the boundary
    Math.max(0, y.bottom - p - (((w = i.top) !== null && w !== void 0 ? w : 0) + ((x = i.bottom) !== null && x !== void 0 ? x : 0) + o))
  ) : Math.max(0, p + a - y.top - (((S = i.top) !== null && S !== void 0 ? S : 0) + ((O = i.bottom) !== null && O !== void 0 ? O : 0) + o));
}
function xw(e, t, n, r, i, o, a, s) {
  let { placement: l, axis: u, size: c } = o;
  var f, d;
  if (l === u) return Math.max(0, n[u] - ((f = a.scroll[u]) !== null && f !== void 0 ? f : 0) - (e[u] + (s ? t[u] : 0)) - ((d = r[u]) !== null && d !== void 0 ? d : 0) - r[od[u]] - i);
  var p, h;
  return Math.max(0, e[c] + e[u] + (s ? t[u] : 0) - n[u] - n[c] + ((p = a.scroll[u]) !== null && p !== void 0 ? p : 0) - ((h = r[u]) !== null && h !== void 0 ? h : 0) - r[od[u]] - i);
}
function Oz(e, t, n, r, i, o, a, s, l, u, c, f, d, p, h, v, m, g) {
  let y = ww(e), { size: w, crossAxis: x, crossSize: S, placement: O, crossPlacement: P } = y, b = Vh(t, s, n, y, c, f, u, d, h, v, l), _ = c, E = xw(s, u, t, i, o + c, y, l, m);
  if (a && n[w] > E) {
    let T = ww(`${od[O]} ${P}`), D = Vh(t, s, n, T, c, f, u, d, h, v, l);
    xw(s, u, t, i, o + c, T, l, m) > E && (y = T, b = D, _ = c);
  }
  let A = "bottom";
  y.axis === "top" ? y.placement === "top" ? A = "top" : y.placement === "bottom" && (A = "bottom") : y.crossAxis === "top" && (y.crossPlacement === "top" ? A = "bottom" : y.crossPlacement === "bottom" && (A = "top"));
  let k = _w(x, b[x], n[S], s, l, o, u);
  b[x] += k;
  let R = Sz(b, s, u, d, i, o, n.height, A, l, m, g);
  p && p < R && (R = p), n.height = Math.min(n.height, R), b = Vh(t, s, n, y, _, f, u, d, h, v, l), k = _w(x, b[x], n[S], s, l, o, u), b[x] += k;
  let N = {}, U = t[x] - b[x] - i[hr[x]], H = U + 0.5 * t[S];
  const ee = h / 2 + v;
  var ue, Q, $, F;
  const I = hr[x] === "left" ? ((ue = i.left) !== null && ue !== void 0 ? ue : 0) + ((Q = i.right) !== null && Q !== void 0 ? Q : 0) : (($ = i.top) !== null && $ !== void 0 ? $ : 0) + ((F = i.bottom) !== null && F !== void 0 ? F : 0), L = n[S] - I - h / 2 - v, K = t[x] + h / 2 - (b[x] + i[hr[x]]), Y = t[x] + t[S] - h / 2 - (b[x] + i[hr[x]]), se = Nm(H, K, Y);
  N[x] = Nm(se, ee, L), { placement: O, crossPlacement: P } = y, h ? U = N[x] : P === "right" ? U += t[S] : P === "center" && (U += t[S] / 2);
  let ve = O === "left" || O === "top" ? n[w] : 0, B = {
    x: O === "top" || O === "bottom" ? U : ve,
    y: O === "left" || O === "right" ? U : ve
  };
  return {
    position: b,
    maxHeight: R,
    arrowOffsetLeft: N.left,
    arrowOffsetTop: N.top,
    placement: O,
    triggerAnchorPoint: B
  };
}
function $z(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: i, padding: o, shouldFlip: a, boundaryElement: s, offset: l, crossOffset: u, maxHeight: c, arrowSize: f = 0, arrowBoundaryOffset: d = 0 } = e, p = wz(), h = r instanceof HTMLElement ? Tz(r) : document.documentElement, v = h === document.documentElement;
  const m = window.getComputedStyle(h).position;
  let g = !!m && m !== "static", y = v ? Pu(n, !1) : Ew(n, h, !1);
  if (!v) {
    let { marginTop: N, marginLeft: U } = window.getComputedStyle(n);
    y.top += parseInt(N, 10) || 0, y.left += parseInt(U, 10) || 0;
  }
  let w = Pu(r, !0), x = Ez(r);
  var S, O;
  w.width += ((S = x.left) !== null && S !== void 0 ? S : 0) + ((O = x.right) !== null && O !== void 0 ? O : 0);
  var P, b;
  w.height += ((P = x.top) !== null && P !== void 0 ? P : 0) + ((b = x.bottom) !== null && b !== void 0 ? b : 0);
  let _ = xz(i), E = bw(s, p), A = bw(h, p), k;
  if ((s.tagName === "BODY" || s.tagName === "HTML") && !v) {
    let N = fp(h, !1);
    k = {
      top: -(N.top - E.top),
      left: -(N.left - E.left),
      width: 0,
      height: 0
    };
  } else (s.tagName === "BODY" || s.tagName === "HTML") && v ? k = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  } : k = Ew(s, h, !1);
  let R = Ze(s, h);
  return Oz(t, y, w, _, x, o, a, E, A, k, l, u, g, c, f, d, R, p);
}
function fp(e, t) {
  let { top: n, left: r, width: i, height: o } = e.getBoundingClientRect();
  return t && e instanceof e.ownerDocument.defaultView.HTMLElement && (i = e.offsetWidth, o = e.offsetHeight), {
    top: n,
    left: r,
    width: i,
    height: o
  };
}
function Pu(e, t) {
  let { top: n, left: r, width: i, height: o } = fp(e, t), { scrollTop: a, scrollLeft: s, clientTop: l, clientLeft: u } = document.documentElement;
  return {
    top: n + a - l,
    left: r + s - u,
    width: i,
    height: o
  };
}
function Ew(e, t, n) {
  let r = window.getComputedStyle(e), i;
  if (r.position === "fixed") i = fp(e, n);
  else {
    i = Pu(e, n);
    let o = Pu(t, n), a = window.getComputedStyle(t);
    o.top += (parseInt(a.borderTopWidth, 10) || 0) - t.scrollTop, o.left += (parseInt(a.borderLeftWidth, 10) || 0) - t.scrollLeft, i.top -= o.top, i.left -= o.left;
  }
  return i.top -= parseInt(r.marginTop, 10) || 0, i.left -= parseInt(r.marginLeft, 10) || 0, i;
}
function Tz(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !Sw(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !Sw(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function Sw(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const $T = /* @__PURE__ */ new WeakMap();
function kz(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  Se(() => {
    if (!n || r === null) return;
    let i = (o) => {
      let a = Pe(o);
      if (!t.current || a instanceof Node && !Ze(a, t.current) || a instanceof HTMLInputElement || a instanceof HTMLTextAreaElement) return;
      let s = r || $T.get(t.current);
      s && s();
    };
    return window.addEventListener("scroll", i, !0), () => {
      window.removeEventListener("scroll", i, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
const Pz = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Dz = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Az(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r) return r.direction === "rtl";
    if (n.script) return Pz.has(n.script);
  }
  let t = e.split("-")[0];
  return Dz.has(t);
}
const TT = Symbol.for("react-aria.i18n.locale");
function kT() {
  let e = typeof window < "u" && window[TT] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Az(e) ? "rtl" : "ltr"
  };
}
let Mm = kT(), Ul = /* @__PURE__ */ new Set();
function Ow() {
  Mm = kT();
  for (let e of Ul) e(Mm);
}
function Cz() {
  let e = sc(), [t, n] = Fe(Mm);
  return Se(() => (Ul.size === 0 && window.addEventListener("languagechange", Ow), Ul.add(n), () => {
    Ul.delete(n), Ul.size === 0 && window.removeEventListener("languagechange", Ow);
  }), []), e ? {
    locale: typeof window < "u" && window[TT] || "en-US",
    direction: "ltr"
  } : t;
}
const Iz = /* @__PURE__ */ W.createContext(null);
function tl() {
  let e = Cz();
  return Ie(Iz) || e;
}
const Nz = Symbol.for("react-aria.i18n.locale"), Rz = Symbol.for("react-aria.i18n.strings");
let qa;
class dp {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let i = this.getStringsForLocale(n)[t];
    if (!i) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return i;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = Mz(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[Nz];
    if (qa === void 0) {
      let i = window[Rz];
      if (!i) return null;
      qa = {};
      for (let o in i) qa[o] = new dp({
        [n]: i[o]
      }, n);
    }
    let r = qa?.[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
}
function Mz(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = jz(e);
  if (t[r]) return t[r];
  for (let i in t)
    if (i.startsWith(r + "-")) return t[i];
  return t[n];
}
function jz(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const $w = /* @__PURE__ */ new Map(), Tw = /* @__PURE__ */ new Map();
class Fz {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let i = n["=" + t];
    if (i) return typeof i == "function" ? i() : i;
    let o = this.locale + ":" + r, a = $w.get(o);
    a || (a = new Intl.PluralRules(this.locale, {
      type: r
    }), $w.set(o, a));
    let s = a.select(t);
    return i = n[s] || n.other, typeof i == "function" ? i() : i;
  }
  number(t) {
    let n = Tw.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), Tw.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
}
const kw = /* @__PURE__ */ new WeakMap();
function zz(e) {
  let t = kw.get(e);
  return t || (t = new dp(e), kw.set(e, t)), t;
}
function Lz(e, t) {
  return t && dp.getGlobalDictionaryForPackage(t) || zz(e);
}
function PT(e, t) {
  let { locale: n } = tl(), r = Lz(e, t);
  return $e(() => new Fz(n, r), [
    n,
    r
  ]);
}
function Vz(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Bz(e, t, n) {
  Vz(e, t), t.set(e, n);
}
let Bh = /* @__PURE__ */ new Map();
function nb(e) {
  let { locale: t } = tl(), n = t + (e ? Object.entries(e).sort((i, o) => i[0] < o[0] ? -1 : 1).join() : "");
  if (Bh.has(n)) return Bh.get(n);
  let r = new Intl.Collator(t, e);
  return Bh.set(n, r), r;
}
let Zt = typeof document < "u" ? window.visualViewport : null;
function Uz(e) {
  let { direction: t } = tl(), { arrowSize: n, targetRef: r, overlayRef: i, arrowRef: o, scrollRef: a = i, placement: s = "bottom", containerPadding: l = 12, shouldFlip: u = !0, boundaryElement: c = typeof document < "u" ? document.body : null, offset: f = 0, crossOffset: d = 0, shouldUpdatePosition: p = !0, isOpen: h = !0, onClose: v, maxHeight: m, arrowBoundaryOffset: g = 0 } = e, [y, w] = Fe(null), x = [
    p,
    s,
    i.current,
    r.current,
    o?.current,
    a.current,
    l,
    u,
    c,
    f,
    d,
    h,
    t,
    m,
    g,
    n
  ], S = _e(Zt?.scale);
  Se(() => {
    h && (S.current = Zt?.scale);
  }, [
    h
  ]);
  let O = Me(() => {
    if (p === !1 || !h || !i.current || !r.current || !c || Zt?.scale !== S.current) return;
    let k = null;
    if (a.current && rd(a.current)) {
      var R;
      let F = (R = Rt()) === null || R === void 0 ? void 0 : R.getBoundingClientRect(), I = a.current.getBoundingClientRect();
      var N;
      if (k = {
        type: "top",
        offset: ((N = F?.top) !== null && N !== void 0 ? N : 0) - I.top
      }, k.offset > I.height / 2) {
        k.type = "bottom";
        var U;
        k.offset = ((U = F?.bottom) !== null && U !== void 0 ? U : 0) - I.bottom;
      }
    }
    let H = i.current;
    if (!m && i.current) {
      var ee;
      H.style.top = "0px", H.style.bottom = "";
      var ue;
      H.style.maxHeight = ((ue = (ee = window.visualViewport) === null || ee === void 0 ? void 0 : ee.height) !== null && ue !== void 0 ? ue : window.innerHeight) + "px";
    }
    let Q = $z({
      placement: qz(s, t),
      overlayNode: i.current,
      targetNode: r.current,
      scrollNode: a.current || i.current,
      padding: l,
      shouldFlip: u,
      boundaryElement: c,
      offset: f,
      crossOffset: d,
      maxHeight: m,
      arrowSize: n ?? (o?.current ? fp(o.current, !0).width : 0),
      arrowBoundaryOffset: g
    });
    if (!Q.position) return;
    H.style.top = "", H.style.bottom = "", H.style.left = "", H.style.right = "", Object.keys(Q.position).forEach((F) => H.style[F] = Q.position[F] + "px"), H.style.maxHeight = Q.maxHeight != null ? Q.maxHeight + "px" : "";
    let $ = Rt();
    if (k && $ && a.current) {
      let F = $.getBoundingClientRect(), I = a.current.getBoundingClientRect(), L = F[k.type] - I[k.type];
      a.current.scrollTop += L - k.offset;
    }
    w(Q);
  }, x);
  at(O, x), Kz(O), id({
    ref: i,
    onResize: O
  }), id({
    ref: r,
    onResize: O
  });
  let P = _e(!1);
  at(() => {
    let k, R = () => {
      P.current = !0, clearTimeout(k), k = setTimeout(() => {
        P.current = !1;
      }, 500), O();
    }, N = () => {
      P.current && R();
    };
    return Zt?.addEventListener("resize", R), Zt?.addEventListener("scroll", N), () => {
      Zt?.removeEventListener("resize", R), Zt?.removeEventListener("scroll", N);
    };
  }, [
    O
  ]);
  let b = Me(() => {
    P.current || v?.();
  }, [
    v,
    P
  ]);
  kz({
    triggerRef: r,
    isOpen: h,
    onClose: v && b
  });
  var _, E, A;
  return {
    overlayProps: {
      style: {
        position: y ? "absolute" : "fixed",
        top: y ? void 0 : 0,
        left: y ? void 0 : 0,
        zIndex: 1e5,
        ...y?.position,
        maxHeight: (_ = y?.maxHeight) !== null && _ !== void 0 ? _ : "100vh"
      }
    },
    placement: (E = y?.placement) !== null && E !== void 0 ? E : null,
    triggerAnchorPoint: (A = y?.triggerAnchorPoint) !== null && A !== void 0 ? A : null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: y?.arrowOffsetLeft,
        top: y?.arrowOffsetTop
      }
    },
    updatePosition: O
  };
}
function Kz(e) {
  at(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function qz(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
function rb(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function DT(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function AT(e) {
  let t = _e({
    isFocused: !1,
    observer: null
  });
  return at(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []), Me((n) => {
    let r = Pe(n);
    if (r instanceof HTMLButtonElement || r instanceof HTMLInputElement || r instanceof HTMLTextAreaElement || r instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let i = r, o = (a) => {
        if (t.current.isFocused = !1, i.disabled) {
          let s = rb(a);
          e?.(s);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      i.addEventListener("focusout", o, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && i.disabled) {
          var a;
          (a = t.current.observer) === null || a === void 0 || a.disconnect();
          let s = i === Rt() ? null : Rt();
          i.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), i.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(i, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    e
  ]);
}
let ad = !1;
function Pw(e) {
  for (; e && !wT(e); ) e = e.parentElement;
  let t = xn(e), n = t.document.activeElement;
  if (!n || n === e) return;
  ad = !0;
  let r = !1, i = (c) => {
    (Pe(c) === n || r) && c.stopImmediatePropagation();
  }, o = (c) => {
    (Pe(c) === n || r) && (c.stopImmediatePropagation(), !e && !r && (r = !0, Xr(n), l()));
  }, a = (c) => {
    (Pe(c) === e || r) && c.stopImmediatePropagation();
  }, s = (c) => {
    (Pe(c) === e || r) && (c.stopImmediatePropagation(), r || (r = !0, Xr(n), l()));
  };
  t.addEventListener("blur", i, !0), t.addEventListener("focusout", o, !0), t.addEventListener("focusin", s, !0), t.addEventListener("focus", a, !0);
  let l = () => {
    cancelAnimationFrame(u), t.removeEventListener("blur", i, !0), t.removeEventListener("focusout", o, !0), t.removeEventListener("focusin", s, !0), t.removeEventListener("focus", a, !0), ad = !1, r = !1;
  }, u = requestAnimationFrame(l);
  return l;
}
let as = "default", jm = "", xf = /* @__PURE__ */ new WeakMap();
function Dw(e) {
  if (lc()) {
    if (as === "default") {
      const t = Je(e);
      jm = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    as = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    xf.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Uh(e) {
  if (lc()) {
    if (as !== "disabled") return;
    as = "restoring", setTimeout(() => {
      yT(() => {
        if (as === "restoring") {
          const t = Je(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = jm || ""), jm = "", as = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && xf.has(e)) {
    let t = xf.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), xf.delete(e);
  }
}
const Du = W.createContext({
  register: () => {
  }
});
Du.displayName = "PressResponderContext";
function Hz(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function CT(e, t, n) {
  if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function Wz(e, t) {
  var n = CT(e, t, "get");
  return Hz(e, n);
}
function Zz(e, t, n) {
  if (t.set) t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function Aw(e, t, n) {
  var r = CT(e, t, "set");
  return Zz(e, r, n), n;
}
function Gz(e) {
  let t = Ie(Du);
  if (t) {
    let { register: n, ref: r, ...i } = t;
    e = rt(i, e), n();
  }
  return Yy(t, e.ref), e;
}
var Kc = /* @__PURE__ */ new WeakMap();
class qc {
  continuePropagation() {
    Aw(this, Kc, !1);
  }
  get shouldStopPropagation() {
    return Wz(this, Kc);
  }
  constructor(t, n, r, i) {
    Bz(this, Kc, {
      writable: !0,
      value: void 0
    }), Aw(this, Kc, !0);
    var o;
    let a = (o = i?.target) !== null && o !== void 0 ? o : r.currentTarget;
    const s = a?.getBoundingClientRect();
    let l, u = 0, c, f = null;
    r.clientX != null && r.clientY != null && (c = r.clientX, f = r.clientY), s && (c != null && f != null ? (l = c - s.left, u = f - s.top) : (l = s.width / 2, u = s.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = l, this.y = u, this.key = r.key;
  }
}
const Cw = Symbol("linkClicked"), Iw = "react-aria-pressable-style", Nw = "data-react-aria-pressable";
function pp(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: i, onPressUp: o, onClick: a, isDisabled: s, isPressed: l, preventFocusOnPress: u, shouldCancelOnPointerExit: c, allowTextSelectionOnPress: f, ref: d, ...p } = Gz(e), [h, v] = Fe(!1), m = _e({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: g, removeAllGlobalListeners: y, removeGlobalListener: w } = lp(), x = Me(($, F) => {
    let I = m.current;
    if (s || I.didFirePressStart) return !1;
    let L = !0;
    if (I.isTriggeringEvent = !0, r) {
      let K = new qc("pressstart", F, $);
      r(K), L = K.shouldStopPropagation;
    }
    return n && n(!0), I.isTriggeringEvent = !1, I.didFirePressStart = !0, v(!0), L;
  }, [
    s,
    r,
    n
  ]), S = Me(($, F, I = !0) => {
    let L = m.current;
    if (!L.didFirePressStart) return !1;
    L.didFirePressStart = !1, L.isTriggeringEvent = !0;
    let K = !0;
    if (i) {
      let Y = new qc("pressend", F, $);
      i(Y), K = Y.shouldStopPropagation;
    }
    if (n && n(!1), v(!1), t && I && !s) {
      let Y = new qc("press", F, $);
      t(Y), K && (K = Y.shouldStopPropagation);
    }
    return L.isTriggeringEvent = !1, K;
  }, [
    s,
    i,
    n,
    t
  ]), O = tr(S), P = Me(($, F) => {
    let I = m.current;
    if (s) return !1;
    if (o) {
      I.isTriggeringEvent = !0;
      let L = new qc("pressup", F, $);
      return o(L), I.isTriggeringEvent = !1, L.shouldStopPropagation;
    }
    return !0;
  }, [
    s,
    o
  ]), b = tr(P), _ = Me(($) => {
    let F = m.current;
    if (F.isPressed && F.target) {
      F.didFirePressStart && F.pointerType != null && S(Go(F.target, $), F.pointerType, !1), F.isPressed = !1, ue(null), F.isOverTarget = !1, F.activePointerId = null, F.pointerType = null, y(), f || Uh(F.target);
      for (let I of F.disposables) I();
      F.disposables = [];
    }
  }, [
    f,
    y,
    S
  ]), E = tr(_), A = Me(($) => {
    c && _($);
  }, [
    c,
    _
  ]), k = Me(($) => {
    s || a?.($);
  }, [
    s,
    a
  ]), R = Me(($, F) => {
    if (!s && a) {
      let I = new MouseEvent("click", $);
      DT(I, F), a(rb(I));
    }
  }, [
    s,
    a
  ]), N = tr(R), [U, H] = Fe(!1);
  at(() => {
    let $ = m.current;
    if (U) {
      let F = (Y) => {
        var se;
        if ($.isPressed && $.target && Kh(Y, $.target)) {
          var ve;
          jw(Pe(Y), Y.key) && Y.preventDefault();
          let T = Pe(Y), D = Ze($.target, T);
          O(Go($.target, Y), "keyboard", D), D && N(Y, $.target), y(), Y.key !== "Enter" && ib($.target) && Ze($.target, T) && !Y[Cw] && (Y[Cw] = !0, Ki($.target, Y, !1)), $.isPressed = !1, H(!1), (ve = $.metaKeyEvents) === null || ve === void 0 || ve.delete(Y.key);
        } else if (Y.key === "Meta" && (!((se = $.metaKeyEvents) === null || se === void 0) && se.size)) {
          var B;
          let T = $.metaKeyEvents;
          $.metaKeyEvents = void 0;
          for (let D of T.values()) (B = $.target) === null || B === void 0 || B.dispatchEvent(new KeyboardEvent("keyup", D));
        }
      }, I = $.target, K = Aa((Y) => {
        I && Kh(Y, I) && !Y.repeat && Ze(I, Pe(Y)) && $.target && b(Go($.target, Y), "keyboard");
      }, F);
      return g(Je($.target), "keyup", K, !0), () => {
        w(Je($.target), "keyup", K, !0);
      };
    }
  }, [
    U,
    g,
    y,
    w
  ]);
  let [ee, ue] = Fe(null);
  at(() => {
    let $ = m.current;
    if (ee === "pointer") {
      let F = (L) => {
        if (L.pointerId === $.activePointerId && $.isPressed && L.button === 0 && $.target) {
          if (Ze($.target, Pe(L)) && $.pointerType != null) {
            let K = !1, Y = setTimeout(() => {
              $.isPressed && $.target instanceof HTMLElement && (K ? E(L) : (Xr($.target), $.target.click()));
            }, 80);
            L.currentTarget && g(L.currentTarget, "click", () => K = !0, !0), $.disposables.push(() => clearTimeout(Y));
          } else E(L);
          $.isOverTarget = !1;
        }
      }, I = (L) => {
        E(L);
      };
      return g(Je($.target), "pointerup", F, !1), g(Je($.target), "pointercancel", I, !1), () => {
        w(Je($.target), "pointerup", F, !1), w(Je($.target), "pointercancel", I, !1);
      };
    } else if (ee === "mouse" && process.env.NODE_ENV === "test") {
      let F = (I) => {
        if (I.button === 0) {
          if ($.ignoreEmulatedMouseEvents) {
            $.ignoreEmulatedMouseEvents = !1;
            return;
          }
          $.target && Ze($.target, I.target) && $.pointerType != null || E(I), $.isOverTarget = !1;
        }
      };
      return g(Je($.target), "mouseup", F, !1), () => {
        w(Je($.target), "mouseup", F, !1);
      };
    } else if (ee === "touch" && process.env.NODE_ENV === "test") {
      let F = (I) => {
        $.isPressed && Ze(Pe(I), $.target) && E({
          currentTarget: $.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      return g(xn($.target), "scroll", F, !0), () => {
        w(xn($.target), "scroll", F, !0);
      };
    }
  }, [
    ee,
    g,
    w
  ]);
  let Q = $e(() => {
    let $ = m.current, F = {
      onKeyDown(I) {
        if (Kh(I.nativeEvent, I.currentTarget) && Ze(I.currentTarget, Pe(I))) {
          var L;
          jw(Pe(I), I.key) && I.preventDefault();
          let K = !0;
          !$.isPressed && !I.repeat && ($.target = I.currentTarget, $.isPressed = !0, H(!0), $.pointerType = "keyboard", K = x(I, "keyboard")), K && I.stopPropagation(), I.metaKey && $o() && ((L = $.metaKeyEvents) === null || L === void 0 || L.set(I.key, I.nativeEvent));
        } else I.key === "Meta" && ($.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(I) {
        if (!(I && !Ze(I.currentTarget, Pe(I))) && I && I.button === 0 && !$.isTriggeringEvent && !Ki.isOpening) {
          let L = !0;
          if (s && I.preventDefault(), !$.ignoreEmulatedMouseEvents && !$.isPressed && ($.pointerType === "virtual" || Im(I.nativeEvent))) {
            let K = x(I, "virtual"), Y = P(I, "virtual"), se = S(I, "virtual");
            k(I), L = K && Y && se;
          } else if ($.isPressed && $.pointerType !== "keyboard") {
            let K = $.pointerType || I.nativeEvent.pointerType || "virtual", Y = P(Go(I.currentTarget, I), K), se = S(Go(I.currentTarget, I), K, !0);
            L = Y && se, $.isOverTarget = !1, k(I), _(I);
          }
          $.ignoreEmulatedMouseEvents = !1, L && I.stopPropagation();
        }
      }
    };
    return typeof PointerEvent < "u" ? (F.onPointerDown = (I) => {
      if (I.button !== 0 || !Ze(I.currentTarget, Pe(I))) return;
      if (rz(I.nativeEvent)) {
        $.pointerType = "virtual";
        return;
      }
      $.pointerType = I.pointerType;
      let L = !0;
      if (!$.isPressed) {
        $.isPressed = !0, ue("pointer"), $.isOverTarget = !0, $.activePointerId = I.pointerId, $.target = I.currentTarget, f || Dw($.target), L = x(I, $.pointerType);
        let K = Pe(I);
        "releasePointerCapture" in K && ("hasPointerCapture" in K ? K.hasPointerCapture(I.pointerId) && K.releasePointerCapture(I.pointerId) : K.releasePointerCapture(I.pointerId));
      }
      L && I.stopPropagation();
    }, F.onMouseDown = (I) => {
      if (Ze(I.currentTarget, Pe(I)) && I.button === 0) {
        if (u) {
          let L = Pw(I.target);
          L && $.disposables.push(L);
        }
        I.stopPropagation();
      }
    }, F.onPointerUp = (I) => {
      !Ze(I.currentTarget, Pe(I)) || $.pointerType === "virtual" || I.button === 0 && !$.isPressed && P(I, $.pointerType || I.pointerType);
    }, F.onPointerEnter = (I) => {
      I.pointerId === $.activePointerId && $.target && !$.isOverTarget && $.pointerType != null && ($.isOverTarget = !0, x(Go($.target, I), $.pointerType));
    }, F.onPointerLeave = (I) => {
      I.pointerId === $.activePointerId && $.target && $.isOverTarget && $.pointerType != null && ($.isOverTarget = !1, S(Go($.target, I), $.pointerType, !1), A(I));
    }, F.onDragStart = (I) => {
      Ze(I.currentTarget, Pe(I)) && _(I);
    }) : process.env.NODE_ENV === "test" && (F.onMouseDown = (I) => {
      if (I.button !== 0 || !Ze(I.currentTarget, Pe(I))) return;
      if ($.ignoreEmulatedMouseEvents) {
        I.stopPropagation();
        return;
      }
      if ($.isPressed = !0, ue("mouse"), $.isOverTarget = !0, $.target = I.currentTarget, $.pointerType = Im(I.nativeEvent) ? "virtual" : "mouse", oy(() => x(I, $.pointerType)) && I.stopPropagation(), u) {
        let K = Pw(I.target);
        K && $.disposables.push(K);
      }
    }, F.onMouseEnter = (I) => {
      if (!Ze(I.currentTarget, Pe(I))) return;
      let L = !0;
      $.isPressed && !$.ignoreEmulatedMouseEvents && $.pointerType != null && ($.isOverTarget = !0, L = x(I, $.pointerType)), L && I.stopPropagation();
    }, F.onMouseLeave = (I) => {
      if (!Ze(I.currentTarget, Pe(I))) return;
      let L = !0;
      $.isPressed && !$.ignoreEmulatedMouseEvents && $.pointerType != null && ($.isOverTarget = !1, L = S(I, $.pointerType, !1), A(I)), L && I.stopPropagation();
    }, F.onMouseUp = (I) => {
      Ze(I.currentTarget, Pe(I)) && !$.ignoreEmulatedMouseEvents && I.button === 0 && !$.isPressed && P(I, $.pointerType || "mouse");
    }, F.onTouchStart = (I) => {
      if (!Ze(I.currentTarget, Pe(I))) return;
      let L = Yz(I.nativeEvent);
      if (!L) return;
      $.activePointerId = L.identifier, $.ignoreEmulatedMouseEvents = !0, $.isOverTarget = !0, $.isPressed = !0, ue("touch"), $.target = I.currentTarget, $.pointerType = "touch", f || Dw($.target), x(no($.target, I), $.pointerType) && I.stopPropagation();
    }, F.onTouchMove = (I) => {
      if (!Ze(I.currentTarget, Pe(I))) return;
      if (!$.isPressed) {
        I.stopPropagation();
        return;
      }
      let L = Rw(I.nativeEvent, $.activePointerId), K = !0;
      L && Mw(L, I.currentTarget) ? !$.isOverTarget && $.pointerType != null && ($.isOverTarget = !0, K = x(no($.target, I), $.pointerType)) : $.isOverTarget && $.pointerType != null && ($.isOverTarget = !1, K = S(no($.target, I), $.pointerType, !1), A(no($.target, I))), K && I.stopPropagation();
    }, F.onTouchEnd = (I) => {
      if (!Ze(I.currentTarget, Pe(I))) return;
      if (!$.isPressed) {
        I.stopPropagation();
        return;
      }
      let L = Rw(I.nativeEvent, $.activePointerId), K = !0;
      L && Mw(L, I.currentTarget) && $.pointerType != null ? (P(no($.target, I), $.pointerType), K = S(no($.target, I), $.pointerType), R(I.nativeEvent, $.target)) : $.isOverTarget && $.pointerType != null && (K = S(no($.target, I), $.pointerType, !1)), K && I.stopPropagation(), $.isPressed = !1, ue(null), $.activePointerId = null, $.isOverTarget = !1, $.ignoreEmulatedMouseEvents = !0, $.target && !f && Uh($.target), y();
    }, F.onTouchCancel = (I) => {
      Ze(I.currentTarget, Pe(I)) && (I.stopPropagation(), $.isPressed && _(no($.target, I)));
    }, F.onDragStart = (I) => {
      Ze(I.currentTarget, Pe(I)) && _(I);
    }), F;
  }, [
    s,
    u,
    y,
    f,
    _,
    A,
    S,
    x,
    P,
    k,
    R
  ]);
  return Se(() => {
    if (!d || process.env.NODE_ENV === "test") return;
    const $ = Je(d.current);
    if (!$ || !$.head || $.getElementById(Iw)) return;
    const F = $.createElement("style");
    F.id = Iw, F.textContent = `
@layer {
  [${Nw}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), $.head.prepend(F);
  }, [
    d
  ]), Se(() => {
    let $ = m.current;
    return () => {
      var F;
      f || Uh((F = $.target) !== null && F !== void 0 ? F : void 0);
      for (let I of $.disposables) I();
      $.disposables = [];
    };
  }, [
    f
  ]), {
    isPressed: l || h,
    pressProps: rt(p, Q, {
      [Nw]: !0
    })
  };
}
function ib(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Kh(e, t) {
  const { key: n, code: r } = e, i = t, o = i.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(i instanceof xn(i).HTMLInputElement && !IT(i, n) || i instanceof xn(i).HTMLTextAreaElement || i.isContentEditable) && // Links should only trigger with Enter key
  !((o === "link" || !o && ib(i)) && n !== "Enter");
}
function Yz(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function Rw(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    if (i.identifier === t) return i;
  }
  return null;
}
function no(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function Go(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r,
    key: t.key
  };
}
function Qz(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function Jz(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function Mw(e, t) {
  let n = t.getBoundingClientRect(), r = Qz(e);
  return Jz(n, r);
}
function Xz(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !ib(e);
}
function jw(e, t) {
  return e instanceof HTMLInputElement ? !IT(e, t) : Xz(e);
}
const eL = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function IT(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : eL.has(e.type);
}
let Ia = null;
const Fm = /* @__PURE__ */ new Set();
let lu = /* @__PURE__ */ new Map(), va = !1, zm = !1;
const tL = {
  Tab: !0,
  Escape: !0
};
function hp(e, t) {
  for (let n of Fm) n(e, t);
}
function nL(e) {
  return !(e.metaKey || !$o() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function sd(e) {
  va = !0, !Ki.isOpening && nL(e) && (Ia = "keyboard", hp("keyboard", e));
}
function vr(e) {
  Ia = "pointer", "pointerType" in e && e.pointerType, (e.type === "mousedown" || e.type === "pointerdown") && (va = !0, hp("pointer", e));
}
function NT(e) {
  !Ki.isOpening && Im(e) && (va = !0, Ia = "virtual");
}
function RT(e) {
  Pe(e) === window || Pe(e) === document || ad || !e.isTrusted || (!va && !zm && (Ia = "virtual", hp("virtual", e)), va = !1, zm = !1);
}
function MT() {
  ad || (va = !1, zm = !0);
}
function Lm(e) {
  if (typeof window > "u" || typeof document > "u" || lu.get(xn(e))) return;
  const t = xn(e), n = Je(e);
  let r = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    va = !0, r.apply(this, arguments);
  }, n.addEventListener("keydown", sd, !0), n.addEventListener("keyup", sd, !0), n.addEventListener("click", NT, !0), t.addEventListener("focus", RT, !0), t.addEventListener("blur", MT, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", vr, !0), n.addEventListener("pointermove", vr, !0), n.addEventListener("pointerup", vr, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", vr, !0), n.addEventListener("mousemove", vr, !0), n.addEventListener("mouseup", vr, !0)), t.addEventListener("beforeunload", () => {
    jT(e);
  }, {
    once: !0
  }), lu.set(t, {
    focus: r
  });
}
const jT = (e, t) => {
  const n = xn(e), r = Je(e);
  t && r.removeEventListener("DOMContentLoaded", t), lu.has(n) && (n.HTMLElement.prototype.focus = lu.get(n).focus, r.removeEventListener("keydown", sd, !0), r.removeEventListener("keyup", sd, !0), r.removeEventListener("click", NT, !0), n.removeEventListener("focus", RT, !0), n.removeEventListener("blur", MT, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", vr, !0), r.removeEventListener("pointermove", vr, !0), r.removeEventListener("pointerup", vr, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", vr, !0), r.removeEventListener("mousemove", vr, !0), r.removeEventListener("mouseup", vr, !0)), lu.delete(n));
};
function rL(e) {
  const t = Je(e);
  let n;
  return t.readyState !== "loading" ? Lm(e) : (n = () => {
    Lm(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => jT(e, n);
}
typeof document < "u" && rL();
function ma() {
  return Ia !== "pointer";
}
function Au() {
  return Ia;
}
function ld(e) {
  Ia = e, hp(e, null);
}
const iL = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function oL(e, t, n) {
  let r = Je(n ? Pe(n) : void 0), i = n ? Pe(n) : void 0;
  const o = typeof window < "u" ? xn(i).HTMLInputElement : HTMLInputElement, a = typeof window < "u" ? xn(i).HTMLTextAreaElement : HTMLTextAreaElement, s = typeof window < "u" ? xn(i).HTMLElement : HTMLElement, l = typeof window < "u" ? xn(i).KeyboardEvent : KeyboardEvent;
  let u = Rt(r);
  return e = e || u instanceof o && !iL.has(u.type) || u instanceof a || u instanceof s && u.isContentEditable, !(e && t === "keyboard" && n instanceof l && !tL[n.key]);
}
function aL(e, t, n) {
  Lm(), Se(() => {
    if (n?.enabled === !1) return;
    let r = (i, o) => {
      oL(!!n?.isTextInput, i, o) && e(ma());
    };
    return Fm.add(r), () => {
      Fm.delete(r);
    };
  }, t);
}
function Cs(e) {
  if (!e.isConnected) return;
  const t = Je(e);
  if (Au() === "virtual") {
    let n = Rt(t);
    yT(() => {
      const r = Rt(t);
      (r === n || r === t.body) && e.isConnected && Xr(e);
    });
  } else Xr(e);
}
function ob(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: i } = e;
  const o = Me((l) => {
    if (Pe(l) === l.currentTarget)
      return r && r(l), i && i(!1), !0;
  }, [
    r,
    i
  ]), a = AT(o), s = Me((l) => {
    let u = Pe(l);
    const c = Je(u), f = c ? Rt(c) : Rt();
    u === l.currentTarget && u === f && (n && n(l), i && i(!0), a(l));
  }, [
    i,
    n,
    a
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || i || r) ? s : void 0,
      onBlur: !t && (r || i) ? o : void 0
    }
  };
}
function Fw(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1;
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function ab(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Fw(e.onKeyDown),
      onKeyUp: Fw(e.onKeyUp)
    }
  };
}
let Vm = /* @__PURE__ */ W.createContext(null);
function sL(e) {
  let t = Ie(Vm) || {};
  Yy(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function FT(e, t) {
  let { focusProps: n } = ob(e), { keyboardProps: r } = ab(e), i = rt(n, r), o = sL(t), a = e.isDisabled ? {} : o, s = _e(e.autoFocus);
  Se(() => {
    s.current && t.current && Cs(t.current), s.current = !1;
  }, [
    t
  ]);
  let l = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (l = void 0), {
    focusableProps: rt({
      ...i,
      tabIndex: l
    }, a)
  };
}
const zT = /* @__PURE__ */ W.forwardRef(({ children: e, ...t }, n) => {
  let r = _e(!1), i = Ie(Du), o = rt(i || {}, {
    ...t,
    register() {
      r.current = !0, i && i.register();
    }
  });
  return o.ref = el(n || i?.ref), Yy(i, o.ref), Se(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ W.createElement(Du.Provider, {
    value: o
  }, e);
});
function lL({ children: e }) {
  let t = $e(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ W.createElement(Du.Provider, {
    value: t
  }, e);
}
function vp(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: i } = e, o = _e({
    isFocusWithin: !1
  }), { addGlobalListener: a, removeAllGlobalListeners: s } = lp(), l = Me((f) => {
    Ze(f.currentTarget, Pe(f)) && o.current.isFocusWithin && !Ze(f.currentTarget, f.relatedTarget) && (o.current.isFocusWithin = !1, s(), n && n(f), i && i(!1));
  }, [
    n,
    i,
    o,
    s
  ]), u = AT(l), c = Me((f) => {
    if (!Ze(f.currentTarget, Pe(f))) return;
    let d = Pe(f);
    const p = Je(d), h = Rt(p);
    if (!o.current.isFocusWithin && h === d) {
      r && r(f), i && i(!0), o.current.isFocusWithin = !0, u(f);
      let v = f.currentTarget;
      a(p, "focus", (m) => {
        let g = Pe(m);
        if (o.current.isFocusWithin && !Ze(v, g)) {
          let y = new p.defaultView.FocusEvent("blur", {
            relatedTarget: g
          });
          DT(y, v);
          let w = rb(y);
          l(w);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    i,
    u,
    a,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: c,
      onBlur: l
    }
  };
}
let ud = !1, Hc = 0;
function Bm() {
  ud = !0, setTimeout(() => {
    ud = !1;
  }, 50);
}
function zw(e) {
  e.pointerType === "touch" && Bm();
}
function uL() {
  if (!(typeof document > "u"))
    return Hc === 0 && (typeof PointerEvent < "u" ? document.addEventListener("pointerup", zw) : process.env.NODE_ENV === "test" && document.addEventListener("touchend", Bm)), Hc++, () => {
      Hc--, !(Hc > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", zw) : process.env.NODE_ENV === "test" && document.removeEventListener("touchend", Bm));
    };
}
function nl(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: i } = e, [o, a] = Fe(!1), s = _e({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  Se(uL, []);
  let { addGlobalListener: l, removeAllGlobalListeners: u } = lp(), { hoverProps: c, triggerHoverEnd: f } = $e(() => {
    let d = (v, m) => {
      if (s.pointerType = m, i || m === "touch" || s.isHovered || !Ze(v.currentTarget, Pe(v))) return;
      s.isHovered = !0;
      let g = v.currentTarget;
      s.target = g, l(Je(Pe(v)), "pointerover", (y) => {
        s.isHovered && s.target && !Ze(s.target, Pe(y)) && p(y, y.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: g,
        pointerType: m
      }), n && n(!0), a(!0);
    }, p = (v, m) => {
      let g = s.target;
      s.pointerType = "", s.target = null, !(m === "touch" || !s.isHovered || !g) && (s.isHovered = !1, u(), r && r({
        type: "hoverend",
        target: g,
        pointerType: m
      }), n && n(!1), a(!1));
    }, h = {};
    return typeof PointerEvent < "u" ? (h.onPointerEnter = (v) => {
      ud && v.pointerType === "mouse" || d(v, v.pointerType);
    }, h.onPointerLeave = (v) => {
      !i && Ze(v.currentTarget, Pe(v)) && p(v, v.pointerType);
    }) : process.env.NODE_ENV === "test" && (h.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, h.onMouseEnter = (v) => {
      !s.ignoreEmulatedMouseEvents && !ud && d(v, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, h.onMouseLeave = (v) => {
      !i && Ze(v.currentTarget, Pe(v)) && p(v, "mouse");
    }), {
      hoverProps: h,
      triggerHoverEnd: p
    };
  }, [
    t,
    n,
    r,
    i,
    s,
    l,
    u
  ]);
  return Se(() => {
    i && f({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    i
  ]), {
    hoverProps: c,
    isHovered: o
  };
}
function cL(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: i } = e, o = _e({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), a = tr((l) => {
    n && Wc(l, t) && (i && i(l), o.current.isPointerDown = !0);
  }), s = tr((l) => {
    n && n(l);
  });
  Se(() => {
    let l = o.current;
    if (r) return;
    const u = t.current, c = Je(u);
    if (typeof PointerEvent < "u") {
      let f = (d) => {
        l.isPointerDown && Wc(d, t) && s(d), l.isPointerDown = !1;
      };
      return c.addEventListener("pointerdown", a, !0), c.addEventListener("click", f, !0), () => {
        c.removeEventListener("pointerdown", a, !0), c.removeEventListener("click", f, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let f = (p) => {
        l.ignoreEmulatedMouseEvents ? l.ignoreEmulatedMouseEvents = !1 : l.isPointerDown && Wc(p, t) && s(p), l.isPointerDown = !1;
      }, d = (p) => {
        l.ignoreEmulatedMouseEvents = !0, l.isPointerDown && Wc(p, t) && s(p), l.isPointerDown = !1;
      };
      return c.addEventListener("mousedown", a, !0), c.addEventListener("mouseup", f, !0), c.addEventListener("touchstart", a, !0), c.addEventListener("touchend", d, !0), () => {
        c.removeEventListener("mousedown", a, !0), c.removeEventListener("mouseup", f, !0), c.removeEventListener("touchstart", a, !0), c.removeEventListener("touchend", d, !0);
      };
    }
  }, [
    t,
    r
  ]);
}
function Wc(e, t) {
  if (e.button > 0) return !1;
  let n = Pe(e);
  if (n) {
    const r = n.ownerDocument;
    if (!r || !Ze(r.documentElement, n) || n.closest("[data-react-aria-top-layer]")) return !1;
  }
  return t.current ? !e.composedPath().includes(t.current) : !1;
}
const fL = 500;
function LT(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: i, threshold: o = fL, accessibilityDescription: a } = e;
  const s = _e(void 0);
  let { addGlobalListener: l, removeGlobalListener: u } = lp(), { pressProps: c } = pp({
    isDisabled: t,
    onPressStart(d) {
      if (d.continuePropagation(), (d.pointerType === "mouse" || d.pointerType === "touch") && (n && n({
        ...d,
        type: "longpressstart"
      }), s.current = setTimeout(() => {
        d.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), Je(d.target).activeElement !== d.target && Xr(d.target), i && i({
          ...d,
          type: "longpress"
        }), s.current = void 0;
      }, o), d.pointerType === "touch")) {
        let p = (h) => {
          h.preventDefault();
        };
        l(d.target, "contextmenu", p, {
          once: !0
        }), l(window, "pointerup", () => {
          setTimeout(() => {
            u(d.target, "contextmenu", p);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(d) {
      s.current && clearTimeout(s.current), r && (d.pointerType === "mouse" || d.pointerType === "touch") && r({
        ...d,
        type: "longpressend"
      });
    }
  }), f = nz(i && !t ? a : void 0);
  return {
    longPressProps: rt(c, f)
  };
}
const Lw = /* @__PURE__ */ W.createContext(null), Um = "react-aria-focus-scope-restore";
let wt = null;
function sb(e) {
  let { children: t, contain: n, restoreFocus: r, autoFocus: i } = e, o = _e(null), a = _e(null), s = _e([]), { parentNode: l } = Ie(Lw) || {}, u = $e(() => new qm({
    scopeRef: s
  }), [
    s
  ]);
  at(() => {
    let d = l || on.root;
    if (on.getTreeNode(d.scopeRef) && wt && !cd(wt, d.scopeRef)) {
      let p = on.getTreeNode(wt);
      p && (d = p);
    }
    d.addChild(u), on.addNode(u);
  }, [
    u,
    l
  ]), at(() => {
    let d = on.getTreeNode(s);
    d && (d.contain = !!n);
  }, [
    n
  ]), at(() => {
    var d;
    let p = (d = o.current) === null || d === void 0 ? void 0 : d.nextSibling, h = [], v = (m) => m.stopPropagation();
    for (; p && p !== a.current; )
      h.push(p), p.addEventListener(Um, v), p = p.nextSibling;
    return s.current = h, () => {
      for (let m of h) m.removeEventListener(Um, v);
    };
  }, [
    t
  ]), yL(s, r, n), vL(s, n), bL(s, r, n), gL(s, i), Se(() => {
    const d = Rt(Je(s.current ? s.current[0] : void 0));
    let p = null;
    if ($r(d, s.current)) {
      for (let h of on.traverse()) h.scopeRef && $r(d, h.scopeRef.current) && (p = h);
      p === on.getTreeNode(s) && (wt = p.scopeRef);
    }
  }, [
    s
  ]), at(() => () => {
    var d, p, h;
    let v = (h = (p = on.getTreeNode(s)) === null || p === void 0 || (d = p.parent) === null || d === void 0 ? void 0 : d.scopeRef) !== null && h !== void 0 ? h : null;
    (s === wt || cd(s, wt)) && (!v || on.getTreeNode(v)) && (wt = v), on.removeTreeNode(s);
  }, [
    s
  ]);
  let c = $e(() => dL(s), []), f = $e(() => ({
    focusManager: c,
    parentNode: u
  }), [
    u,
    c
  ]);
  return /* @__PURE__ */ W.createElement(Lw.Provider, {
    value: f
  }, /* @__PURE__ */ W.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: o
  }), t, /* @__PURE__ */ W.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: a
  }));
}
function dL(e) {
  return {
    focusNext(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t;
      var s;
      let l = r || Rt(Je((s = n[0]) !== null && s !== void 0 ? s : void 0)), u = n[0].previousElementSibling, c = aa(n), f = Mi(c, {
        tabbable: i,
        accept: a
      }, n);
      f.currentNode = $r(l, n) ? l : u;
      let d = f.nextNode();
      return !d && o && (f.currentNode = u, d = f.nextNode()), d && Ri(d, !0), d;
    },
    focusPrevious(t = {}) {
      let n = e.current, { from: r, tabbable: i, wrap: o, accept: a } = t;
      var s;
      let l = r || Rt(Je((s = n[0]) !== null && s !== void 0 ? s : void 0)), u = n[n.length - 1].nextElementSibling, c = aa(n), f = Mi(c, {
        tabbable: i,
        accept: a
      }, n);
      f.currentNode = $r(l, n) ? l : u;
      let d = f.previousNode();
      return !d && o && (f.currentNode = u, d = f.previousNode()), d && Ri(d, !0), d;
    },
    focusFirst(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = aa(n), a = Mi(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[0].previousElementSibling;
      let s = a.nextNode();
      return s && Ri(s, !0), s;
    },
    focusLast(t = {}) {
      let n = e.current, { tabbable: r, accept: i } = t, o = aa(n), a = Mi(o, {
        tabbable: r,
        accept: i
      }, n);
      a.currentNode = n[n.length - 1].nextElementSibling;
      let s = a.previousNode();
      return s && Ri(s, !0), s;
    }
  };
}
function aa(e) {
  return e[0].parentElement;
}
function Kl(e) {
  let t = on.getTreeNode(wt);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain) return !1;
    t = t.parent;
  }
  return !0;
}
function pL(e) {
  if (!e.form)
    return Array.from(Je(e).querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]`)).filter((r) => !r.form);
  const t = e.form.elements.namedItem(e.name);
  let n = xn(e);
  return t instanceof n.RadioNodeList ? Array.from(t).filter((r) => r instanceof n.HTMLInputElement) : t instanceof n.HTMLInputElement ? [
    t
  ] : [];
}
function hL(e) {
  if (e.checked) return !0;
  const t = pL(e);
  return t.length > 0 && !t.some((n) => n.checked);
}
function vL(e, t) {
  let n = _e(void 0), r = _e(void 0);
  at(() => {
    let i = e.current;
    if (!t) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const o = Je(i ? i[0] : void 0);
    let a = (u) => {
      if (u.key !== "Tab" || u.altKey || u.ctrlKey || u.metaKey || !Kl(e) || u.isComposing) return;
      let c = Rt(o), f = e.current;
      if (!f || !$r(c, f)) return;
      let d = aa(f), p = Mi(d, {
        tabbable: !0
      }, f);
      if (!c) return;
      p.currentNode = c;
      let h = u.shiftKey ? p.previousNode() : p.nextNode();
      h || (p.currentNode = u.shiftKey ? f[f.length - 1].nextElementSibling : f[0].previousElementSibling, h = u.shiftKey ? p.previousNode() : p.nextNode()), u.preventDefault(), h && Ri(h, !0);
    }, s = (u) => {
      (!wt || cd(wt, e)) && $r(Pe(u), e.current) ? (wt = e, n.current = Pe(u)) : Kl(e) && !yo(Pe(u), e) ? n.current ? n.current.focus() : wt && wt.current && Km(wt.current) : Kl(e) && (n.current = Pe(u));
    }, l = (u) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let c = Au(), f = (c === "virtual" || c === null) && Gy() && Zy(), d = Rt(o);
        if (!f && d && Kl(e) && !yo(d, e)) {
          wt = e;
          let h = Pe(u);
          if (h && h.isConnected) {
            var p;
            n.current = h, (p = n.current) === null || p === void 0 || p.focus();
          } else wt.current && Km(wt.current);
        }
      });
    };
    return o.addEventListener("keydown", a, !1), o.addEventListener("focusin", s, !1), i?.forEach((u) => u.addEventListener("focusin", s, !1)), i?.forEach((u) => u.addEventListener("focusout", l, !1)), () => {
      o.removeEventListener("keydown", a, !1), o.removeEventListener("focusin", s, !1), i?.forEach((u) => u.removeEventListener("focusin", s, !1)), i?.forEach((u) => u.removeEventListener("focusout", l, !1));
    };
  }, [
    e,
    t
  ]), at(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function VT(e) {
  return yo(e);
}
function $r(e, t) {
  return !e || !t ? !1 : t.some((n) => Ze(n, e));
}
function yo(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of on.traverse(on.getTreeNode(t)))
    if (n && $r(e, n.current)) return !0;
  return !1;
}
function mL(e) {
  return yo(e, wt);
}
function cd(e, t) {
  var n;
  let r = (n = on.getTreeNode(t)) === null || n === void 0 ? void 0 : n.parent;
  for (; r; ) {
    if (r.scopeRef === e) return !0;
    r = r.parent;
  }
  return !1;
}
function Ri(e, t = !1) {
  if (e != null && !t) try {
    Cs(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function BT(e, t = !0) {
  let n = e[0].previousElementSibling, r = aa(e), i = Mi(r, {
    tabbable: t
  }, e);
  i.currentNode = n;
  let o = i.nextNode();
  return t && !o && (r = aa(e), i = Mi(r, {
    tabbable: !1
  }, e), i.currentNode = n, o = i.nextNode()), o;
}
function Km(e, t = !0) {
  Ri(BT(e, t));
}
function gL(e, t) {
  const n = W.useRef(t);
  Se(() => {
    if (n.current) {
      wt = e;
      const r = Je(e.current ? e.current[0] : void 0);
      !$r(Rt(r), wt.current) && e.current && Km(e.current);
    }
    n.current = !1;
  }, [
    e
  ]);
}
function yL(e, t, n) {
  at(() => {
    if (t || n) return;
    let r = e.current;
    const i = Je(r ? r[0] : void 0);
    let o = (a) => {
      let s = Pe(a);
      $r(s, e.current) ? wt = e : VT(s) || (wt = null);
    };
    return i.addEventListener("focusin", o, !1), r?.forEach((a) => a.addEventListener("focusin", o, !1)), () => {
      i.removeEventListener("focusin", o, !1), r?.forEach((a) => a.removeEventListener("focusin", o, !1));
    };
  }, [
    e,
    t,
    n
  ]);
}
function Vw(e) {
  let t = on.getTreeNode(wt);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore) return !1;
    t = t.parent;
  }
  return t?.scopeRef === e;
}
function bL(e, t, n) {
  const r = _e(typeof document < "u" ? Rt(Je(e.current ? e.current[0] : void 0)) : null);
  at(() => {
    let i = e.current;
    const o = Je(i ? i[0] : void 0);
    if (!t || n) return;
    let a = () => {
      (!wt || cd(wt, e)) && $r(Rt(o), e.current) && (wt = e);
    };
    return o.addEventListener("focusin", a, !1), i?.forEach((s) => s.addEventListener("focusin", a, !1)), () => {
      o.removeEventListener("focusin", a, !1), i?.forEach((s) => s.removeEventListener("focusin", a, !1));
    };
  }, [
    e,
    n
  ]), at(() => {
    const i = Je(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = (a) => {
      if (a.key !== "Tab" || a.altKey || a.ctrlKey || a.metaKey || !Kl(e) || a.isComposing) return;
      let s = i.activeElement;
      if (!yo(s, e) || !Vw(e)) return;
      let l = on.getTreeNode(e);
      if (!l) return;
      let u = l.nodeToRestore, c = Mi(i.body, {
        tabbable: !0
      });
      c.currentNode = s;
      let f = a.shiftKey ? c.previousNode() : c.nextNode();
      if ((!u || !u.isConnected || u === i.body) && (u = void 0, l.nodeToRestore = void 0), (!f || !yo(f, e)) && u) {
        c.currentNode = u;
        do
          f = a.shiftKey ? c.previousNode() : c.nextNode();
        while (yo(f, e));
        a.preventDefault(), a.stopPropagation(), f ? Ri(f, !0) : VT(u) ? Ri(u, !0) : s.blur();
      }
    };
    return n || i.addEventListener("keydown", o, !0), () => {
      n || i.removeEventListener("keydown", o, !0);
    };
  }, [
    e,
    t,
    n
  ]), at(() => {
    const i = Je(e.current ? e.current[0] : void 0);
    if (!t) return;
    let o = on.getTreeNode(e);
    if (o) {
      var a;
      return o.nodeToRestore = (a = r.current) !== null && a !== void 0 ? a : void 0, () => {
        let s = on.getTreeNode(e);
        if (!s) return;
        let l = s.nodeToRestore, u = Rt(i);
        if (t && l && (u && yo(u, e) || u === i.body && Vw(e))) {
          let c = on.clone();
          requestAnimationFrame(() => {
            if (i.activeElement === i.body) {
              let f = c.getTreeNode(e);
              for (; f; ) {
                if (f.nodeToRestore && f.nodeToRestore.isConnected) {
                  Bw(f.nodeToRestore);
                  return;
                }
                f = f.parent;
              }
              for (f = c.getTreeNode(e); f; ) {
                if (f.scopeRef && f.scopeRef.current && on.getTreeNode(f.scopeRef)) {
                  let d = BT(f.scopeRef.current, !0);
                  Bw(d);
                  return;
                }
                f = f.parent;
              }
            }
          });
        }
      };
    }
  }, [
    e,
    t
  ]);
}
function Bw(e) {
  e.dispatchEvent(new CustomEvent(Um, {
    bubbles: !0,
    cancelable: !0
  })) && Ri(e);
}
function Mi(e, t, n) {
  let r = t?.tabbable ? xT : wT, i = e?.nodeType === Node.ELEMENT_NODE ? e : null, o = Je(i), a = vT(o, e || o, NodeFilter.SHOW_ELEMENT, {
    acceptNode(s) {
      return Ze(t?.from, s) || t?.tabbable && s.tagName === "INPUT" && s.getAttribute("type") === "radio" && (!hL(s) || a.currentNode.tagName === "INPUT" && a.currentNode.type === "radio" && a.currentNode.name === s.name) ? NodeFilter.FILTER_REJECT : r(s) && (!n || $r(s, n)) && (!t?.accept || t.accept(s)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t?.from && (a.currentNode = t.from), a;
}
class lb {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let i = this.fastMap.get(n ?? null);
    if (!i) return;
    let o = new qm({
      scopeRef: t
    });
    i.addChild(o), o.parent = i, this.fastMap.set(t, o), r && (o.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let o of this.traverse()) o !== n && n.nodeToRestore && o.nodeToRestore && n.scopeRef && n.scopeRef.current && $r(o.nodeToRestore, n.scopeRef.current) && (o.nodeToRestore = n.nodeToRestore);
    let i = n.children;
    r && (r.removeChild(n), i.size > 0 && i.forEach((o) => r && r.addChild(o))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    var t;
    let n = new lb();
    var r;
    for (let i of this.traverse()) n.addTreeNode(i.scopeRef, (r = (t = i.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, i.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new qm({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class qm {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
let on = new lb();
function mp(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, i = _e({
    isFocused: !1,
    isFocusVisible: t || ma()
  }), [o, a] = Fe(!1), [s, l] = Fe(() => i.current.isFocused && i.current.isFocusVisible), u = Me(() => l(i.current.isFocused && i.current.isFocusVisible), []), c = Me((p) => {
    i.current.isFocused = p, i.current.isFocusVisible = ma(), a(p), u();
  }, [
    u
  ]);
  aL((p) => {
    i.current.isFocusVisible = p, u();
  }, [
    n,
    o
  ], {
    enabled: o,
    isTextInput: n
  });
  let { focusProps: f } = ob({
    isDisabled: r,
    onFocusChange: c
  }), { focusWithinProps: d } = vp({
    isDisabled: !r,
    onFocusWithinChange: c
  });
  return {
    isFocused: o,
    isFocusVisible: s,
    focusProps: r ? d : f
  };
}
function UT(e) {
  let t = wL(Je(e));
  t !== e && (t && _L(t, e), e && KT(e, t));
}
function _L(e, t) {
  e.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function KT(e, t) {
  e.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function wL(e) {
  let t = Rt(e), n = t?.getAttribute("aria-activedescendant");
  return n && e.getElementById(n) || t;
}
const di = [];
function xL(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: i, isDismissable: o = !1, isKeyboardDismissDisabled: a = !1, shouldCloseOnInteractOutside: s } = e, l = _e(void 0);
  Se(() => {
    if (i && !di.includes(t))
      return di.push(t), () => {
        let v = di.indexOf(t);
        v >= 0 && di.splice(v, 1);
      };
  }, [
    i,
    t
  ]);
  let u = () => {
    di[di.length - 1] === t && n && n();
  }, c = (v) => {
    const m = di[di.length - 1];
    l.current = m, (!s || s(Pe(v))) && m === t && (v.stopPropagation(), v.preventDefault());
  }, f = (v) => {
    (!s || s(Pe(v))) && (di[di.length - 1] === t && (v.stopPropagation(), v.preventDefault()), l.current === t && u()), l.current = void 0;
  }, d = (v) => {
    v.key === "Escape" && !a && !v.nativeEvent.isComposing && (v.stopPropagation(), v.preventDefault(), u());
  };
  cL({
    ref: t,
    onInteractOutside: o && i ? f : void 0,
    onInteractOutsideStart: c
  });
  let { focusWithinProps: p } = vp({
    isDisabled: !r,
    onBlurWithin: (v) => {
      !v.relatedTarget || mL(v.relatedTarget) || (!s || s(v.relatedTarget)) && n?.();
    }
  }), h = (v) => {
    Pe(v) === v.currentTarget && v.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: d,
      ...p
    },
    underlayProps: {
      onPointerDown: h
    }
  };
}
function EL(e, t, n) {
  let { type: r } = e, { isOpen: i } = t;
  Se(() => {
    n && n.current && $T.set(n.current, t.close);
  });
  let o;
  r === "menu" ? o = !0 : r === "listbox" && (o = "listbox");
  let a = Kn();
  return {
    triggerProps: {
      "aria-haspopup": o,
      "aria-expanded": i,
      "aria-controls": i ? a : void 0,
      onPress: t.toggle
    },
    overlayProps: {
      id: a
    }
  };
}
const uu = typeof document < "u" && window.visualViewport;
let Zc = 0, qh;
function SL(e = {}) {
  let { isDisabled: t } = e;
  at(() => {
    if (!t)
      return Zc++, Zc === 1 && (lc() ? qh = $L() : qh = OL()), () => {
        Zc--, Zc === 0 && qh();
      };
  }, [
    t
  ]);
}
function OL() {
  let e = window.innerWidth - document.documentElement.clientWidth;
  return Aa(e > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? Ef(document.documentElement, "scrollbarGutter", "stable") : Ef(document.documentElement, "paddingRight", `${e}px`)), Ef(document.documentElement, "overflow", "hidden"));
}
function $L() {
  let e = Ef(document.documentElement, "overflow", "hidden"), t, n = !1, r = (u) => {
    let c = Pe(u);
    t = As(c) ? c : Qy(c, !0), n = !1;
    let f = c.ownerDocument.defaultView.getSelection();
    f && !f.isCollapsed && f.containsNode(c, !0) && (n = !0), u.composedPath().some((d) => d instanceof HTMLInputElement && d.type === "range") && (n = !0), "selectionStart" in c && "selectionEnd" in c && c.selectionStart < c.selectionEnd && c.ownerDocument.activeElement === c && (n = !0);
  }, i = document.createElement("style");
  i.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(i);
  let o = (u) => {
    if (!(u.touches.length === 2 || n)) {
      if (!t || t === document.documentElement || t === document.body) {
        u.preventDefault();
        return;
      }
      t.scrollHeight === t.clientHeight && t.scrollWidth === t.clientWidth && u.preventDefault();
    }
  }, a = (u) => {
    let c = Pe(u), f = u.relatedTarget;
    if (f && Fh(f))
      f.focus({
        preventScroll: !0
      }), Uw(f, Fh(c));
    else if (!f) {
      var d;
      let p = (d = c.parentElement) === null || d === void 0 ? void 0 : d.closest("[tabindex]");
      p?.focus({
        preventScroll: !0
      });
    }
  }, s = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(u) {
    let c = Rt(), f = c != null && Fh(c);
    s.call(this, {
      ...u,
      preventScroll: !0
    }), (!u || !u.preventScroll) && Uw(this, f);
  };
  let l = Aa(Hh(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), Hh(document, "touchmove", o, {
    passive: !1,
    capture: !0
  }), Hh(document, "blur", a, !0));
  return () => {
    e(), l(), i.remove(), HTMLElement.prototype.focus = s;
  };
}
function Ef(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function Hh(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function Uw(e, t) {
  t || !uu ? Kw(e) : uu.addEventListener("resize", () => Kw(e), {
    once: !0
  });
}
function Kw(e) {
  let t = document.scrollingElement || document.documentElement, n = e;
  for (; n && n !== t; ) {
    let r = Qy(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let i = r.getBoundingClientRect(), o = n.getBoundingClientRect();
      if (o.top < i.top || o.bottom > i.top + n.clientHeight) {
        let a = i.bottom;
        uu && (a = Math.min(a, uu.offsetTop + uu.height));
        let s = o.top - i.top - ((a - i.top) / 2 - o.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + s)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
const TL = /* @__PURE__ */ Le({});
function kL() {
  var e;
  return (e = Ie(TL)) !== null && e !== void 0 ? e : {};
}
var qT = {};
qT = {
  dismiss: "تجاهل"
};
var HT = {};
HT = {
  dismiss: "Отхвърляне"
};
var WT = {};
WT = {
  dismiss: "Odstranit"
};
var ZT = {};
ZT = {
  dismiss: "Luk"
};
var GT = {};
GT = {
  dismiss: "Schließen"
};
var YT = {};
YT = {
  dismiss: "Απόρριψη"
};
var QT = {};
QT = {
  dismiss: "Dismiss"
};
var JT = {};
JT = {
  dismiss: "Descartar"
};
var XT = {};
XT = {
  dismiss: "Lõpeta"
};
var ek = {};
ek = {
  dismiss: "Hylkää"
};
var tk = {};
tk = {
  dismiss: "Rejeter"
};
var nk = {};
nk = {
  dismiss: "התעלם"
};
var rk = {};
rk = {
  dismiss: "Odbaci"
};
var ik = {};
ik = {
  dismiss: "Elutasítás"
};
var ok = {};
ok = {
  dismiss: "Ignora"
};
var ak = {};
ak = {
  dismiss: "閉じる"
};
var sk = {};
sk = {
  dismiss: "무시"
};
var lk = {};
lk = {
  dismiss: "Atmesti"
};
var uk = {};
uk = {
  dismiss: "Nerādīt"
};
var ck = {};
ck = {
  dismiss: "Lukk"
};
var fk = {};
fk = {
  dismiss: "Negeren"
};
var dk = {};
dk = {
  dismiss: "Zignoruj"
};
var pk = {};
pk = {
  dismiss: "Descartar"
};
var hk = {};
hk = {
  dismiss: "Dispensar"
};
var vk = {};
vk = {
  dismiss: "Revocare"
};
var mk = {};
mk = {
  dismiss: "Пропустить"
};
var gk = {};
gk = {
  dismiss: "Zrušiť"
};
var yk = {};
yk = {
  dismiss: "Opusti"
};
var bk = {};
bk = {
  dismiss: "Odbaci"
};
var _k = {};
_k = {
  dismiss: "Avvisa"
};
var wk = {};
wk = {
  dismiss: "Kapat"
};
var xk = {};
xk = {
  dismiss: "Скасувати"
};
var Ek = {};
Ek = {
  dismiss: "取消"
};
var Sk = {};
Sk = {
  dismiss: "關閉"
};
var Ok = {};
Ok = {
  "ar-AE": qT,
  "bg-BG": HT,
  "cs-CZ": WT,
  "da-DK": ZT,
  "de-DE": GT,
  "el-GR": YT,
  "en-US": QT,
  "es-ES": JT,
  "et-EE": XT,
  "fi-FI": ek,
  "fr-FR": tk,
  "he-IL": nk,
  "hr-HR": rk,
  "hu-HU": ik,
  "it-IT": ok,
  "ja-JP": ak,
  "ko-KR": sk,
  "lt-LT": lk,
  "lv-LV": uk,
  "nb-NO": ck,
  "nl-NL": fk,
  "pl-PL": dk,
  "pt-BR": pk,
  "pt-PT": hk,
  "ro-RO": vk,
  "ru-RU": mk,
  "sk-SK": gk,
  "sl-SI": yk,
  "sr-SP": bk,
  "sv-SE": _k,
  "tr-TR": wk,
  "uk-UA": xk,
  "zh-CN": Ek,
  "zh-TW": Sk
};
const qw = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function $k(e = {}) {
  let { style: t, isFocusable: n } = e, [r, i] = Fe(!1), { focusWithinProps: o } = vp({
    isDisabled: !n,
    onFocusWithinChange: (s) => i(s)
  }), a = $e(() => r ? t : t ? {
    ...qw,
    ...t
  } : qw, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...o,
      style: a
    }
  };
}
function PL(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: i, ...o } = e, { visuallyHiddenProps: a } = $k(e);
  return /* @__PURE__ */ W.createElement(n, rt(o, a), t);
}
function DL(e) {
  return e && e.__esModule ? e.default : e;
}
function Hw(e) {
  let { onDismiss: t, ...n } = e, r = PT(DL(Ok), "@react-aria/overlays"), i = bT(n, r.format("dismiss")), o = () => {
    t && t();
  };
  return /* @__PURE__ */ W.createElement(PL, null, /* @__PURE__ */ W.createElement("button", {
    ...i,
    tabIndex: -1,
    onClick: o,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const AL = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
let Al = /* @__PURE__ */ new WeakMap(), zn = [];
function CL(e, t) {
  let n = xn(e?.[0]), r = t instanceof n.Element ? {
    root: t
  } : t;
  var i;
  let o = (i = r?.root) !== null && i !== void 0 ? i : document.body, a = r?.shouldUseInert && AL, s = new Set(e), l = /* @__PURE__ */ new Set(), u = (g) => a && g instanceof n.HTMLElement ? g.inert : g.getAttribute("aria-hidden") === "true", c = (g, y) => {
    a && g instanceof n.HTMLElement ? g.inert = y : y ? g.setAttribute("aria-hidden", "true") : (g.removeAttribute("aria-hidden"), g instanceof n.HTMLElement && (g.inert = !1));
  }, f = /* @__PURE__ */ new Set();
  if (Ci())
    for (let g of e) {
      let y = g;
      for (; y && y !== o; ) {
        let w = y.getRootNode();
        "shadowRoot" in w && f.add(w.shadowRoot), y = w.parentNode;
      }
    }
  let d = (g) => {
    for (let S of g.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) s.add(S);
    let y = (S) => {
      if (l.has(S) || s.has(S) || S.parentElement && l.has(S.parentElement) && S.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let O of s)
        if (Ze(S, O)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, w = vT(Je(g), g, NodeFilter.SHOW_ELEMENT, {
      acceptNode: y
    }), x = y(g);
    if (x === NodeFilter.FILTER_ACCEPT && p(g), x !== NodeFilter.FILTER_REJECT) {
      let S = w.nextNode();
      for (; S != null; )
        p(S), S = w.nextNode();
    }
  }, p = (g) => {
    var y;
    let w = (y = Al.get(g)) !== null && y !== void 0 ? y : 0;
    u(g) && w === 0 || (w === 0 && c(g, !0), l.add(g), Al.set(g, w + 1));
  };
  zn.length && zn[zn.length - 1].disconnect(), d(o);
  let h = new MutationObserver((g) => {
    for (let y of g)
      if (y.type === "childList") {
        if (y.target.isConnected && ![
          ...s,
          ...l
        ].some((w) => Ze(w, y.target))) for (let w of y.addedNodes)
          (w instanceof HTMLElement || w instanceof SVGElement) && (w.dataset.liveAnnouncer === "true" || w.dataset.reactAriaTopLayer === "true") ? s.add(w) : w instanceof Element && d(w);
        if (Ci()) {
          for (let w of f) if (!w.isConnected) {
            h.disconnect();
            break;
          }
        }
      }
  });
  h.observe(o, {
    childList: !0,
    subtree: !0
  });
  let v = /* @__PURE__ */ new Set();
  if (Ci()) for (let g of f) {
    let y = new MutationObserver((w) => {
      for (let x of w)
        if (x.type === "childList") {
          if (x.target.isConnected && ![
            ...s,
            ...l
          ].some((S) => Ze(S, x.target))) for (let S of x.addedNodes)
            (S instanceof HTMLElement || S instanceof SVGElement) && (S.dataset.liveAnnouncer === "true" || S.dataset.reactAriaTopLayer === "true") ? s.add(S) : S instanceof Element && d(S);
          if (Ci()) {
            for (let S of f) if (!S.isConnected) {
              h.disconnect();
              break;
            }
          }
        }
    });
    y.observe(g, {
      childList: !0,
      subtree: !0
    }), v.add(y);
  }
  let m = {
    visibleNodes: s,
    hiddenNodes: l,
    observe() {
      h.observe(o, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      h.disconnect();
    }
  };
  return zn.push(m), () => {
    if (h.disconnect(), Ci()) for (let g of v) g.disconnect();
    for (let g of l) {
      let y = Al.get(g);
      y != null && (y === 1 ? (c(g, !1), Al.delete(g)) : Al.set(g, y - 1));
    }
    m === zn[zn.length - 1] ? (zn.pop(), zn.length && zn[zn.length - 1].observe()) : zn.splice(zn.indexOf(m), 1);
  };
}
function IL(e) {
  let t = zn[zn.length - 1];
  if (t && !t.visibleNodes.has(e))
    return t.visibleNodes.add(e), () => {
      t.visibleNodes.delete(e);
    };
}
function NL(e, t) {
  let { triggerRef: n, popoverRef: r, groupRef: i, isNonModal: o, isKeyboardDismissDisabled: a, shouldCloseOnInteractOutside: s, ...l } = e, u = l.trigger === "SubmenuTrigger", { overlayProps: c, underlayProps: f } = xL({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !o || u,
    isKeyboardDismissDisabled: a,
    shouldCloseOnInteractOutside: s
  }, i ?? r), { overlayProps: d, arrowProps: p, placement: h, triggerAnchorPoint: v } = Uz({
    ...l,
    targetRef: n,
    overlayRef: r,
    isOpen: t.isOpen,
    onClose: o && !u ? t.close : null
  });
  return SL({
    isDisabled: o || !t.isOpen
  }), Se(() => {
    if (t.isOpen && r.current) {
      var m, g;
      return o ? IL((m = i?.current) !== null && m !== void 0 ? m : r.current) : CL([
        (g = i?.current) !== null && g !== void 0 ? g : r.current
      ], {
        shouldUseInert: !0
      });
    }
  }, [
    o,
    t.isOpen,
    r,
    i
  ]), {
    popoverProps: rt(c, d),
    arrowProps: p,
    underlayProps: f,
    placement: h,
    triggerAnchorPoint: v
  };
}
const RL = /* @__PURE__ */ W.createContext(null);
function Ww(e) {
  let t = sc(), { portalContainer: n = t ? null : document.body, isExiting: r } = e, [i, o] = Fe(!1), a = $e(() => ({
    contain: i,
    setContain: o
  }), [
    i,
    o
  ]), { getContainer: s } = kL();
  if (!e.portalContainer && s && (n = s()), !n) return null;
  let l = e.children;
  return e.disableFocusManagement || (l = /* @__PURE__ */ W.createElement(sb, {
    restoreFocus: !0,
    contain: (e.shouldContainFocus || i) && !r
  }, l)), l = /* @__PURE__ */ W.createElement(RL.Provider, {
    value: a
  }, /* @__PURE__ */ W.createElement(lL, null, l)), /* @__PURE__ */ yI.createPortal(l, n);
}
const ub = /* @__PURE__ */ new WeakMap();
function ML(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function jL(e, t) {
  let n = ub.get(e);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${ML(t)}`;
}
function Tk(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": i, labelElementType: o = "label" } = e;
  t = Kn(t);
  let a = Kn(), s = {};
  n ? (r = r ? `${a} ${r}` : a, s = {
    id: a,
    htmlFor: o === "label" ? t : void 0
  }) : !r && !i && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let l = bT({
    id: t,
    "aria-label": i,
    "aria-labelledby": r
  });
  return {
    labelProps: s,
    fieldProps: l
  };
}
function FL(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: i } = e, { labelProps: o, fieldProps: a } = Tk(e), s = ua([
    !!t,
    !!n,
    r,
    i
  ]), l = ua([
    !!t,
    !!n,
    r,
    i
  ]);
  return a = rt(a, {
    "aria-describedby": [
      s,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      l,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: o,
    fieldProps: a,
    descriptionProps: {
      id: s
    },
    errorMessageProps: {
      id: l
    }
  };
}
function Hm(e) {
  return KF() ? e.altKey : e.ctrlKey;
}
function Sf(e, t) {
  var n, r;
  let i = `[data-key="${CSS.escape(String(t))}"]`, o = (n = e.current) === null || n === void 0 ? void 0 : n.dataset.collection;
  return o && (i = `[data-collection="${CSS.escape(o)}"]${i}`), (r = e.current) === null || r === void 0 ? void 0 : r.querySelector(i);
}
const kk = /* @__PURE__ */ new WeakMap();
function zL(e) {
  let t = Kn();
  return kk.set(e, t), t;
}
function LL(e) {
  return kk.get(e);
}
const VL = 1e3;
function Pk(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, i = _e({
    search: "",
    timeout: void 0
  }).current, o = (a) => {
    let s = BL(a.key);
    if (!(!s || a.ctrlKey || a.metaKey || !Ze(a.currentTarget, Pe(a)) || i.search.length === 0 && s === " ")) {
      if (s === " " && i.search.trim().length > 0 && (a.preventDefault(), "continuePropagation" in a || a.stopPropagation()), i.search += s, t.getKeyForSearch != null) {
        let l = t.getKeyForSearch(i.search, n.focusedKey);
        l == null && (l = t.getKeyForSearch(i.search)), l != null && (n.setFocusedKey(l), r && r(l));
      }
      clearTimeout(i.timeout), i.timeout = setTimeout(() => {
        i.search = "";
      }, VL);
    }
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? o : void 0
    }
  };
}
function BL(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function UL(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: i = !1, shouldFocusWrap: o = !1, disallowEmptySelection: a = !1, disallowSelectAll: s = !1, escapeKeyBehavior: l = "clearSelection", selectOnFocus: u = t.selectionBehavior === "replace", disallowTypeAhead: c = !1, shouldUseVirtualFocus: f, allowsTabNavigation: d = !1, scrollRef: p = r, linkBehavior: h = "action" } = e, { direction: v } = tl(), m = sp(), g = (N) => {
    if (N.altKey && N.key === "Tab" && N.preventDefault(), !r.current || !Ze(r.current, Pe(N))) return;
    const U = (B, T) => {
      if (B != null) {
        if (t.isLink(B) && h === "selection" && u && !Hm(N)) {
          oy(() => {
            t.setFocusedKey(B, T);
          });
          let D = Sf(r, B), C = t.getItemProps(B);
          D && m.open(D, N, C.href, C.routerOptions);
          return;
        }
        if (t.setFocusedKey(B, T), t.isLink(B) && h === "override") return;
        N.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(B) : u && !Hm(N) && t.replaceSelection(B);
      }
    };
    switch (N.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          var H, ee, ue;
          let B = t.focusedKey != null ? (H = n.getKeyBelow) === null || H === void 0 ? void 0 : H.call(n, t.focusedKey) : (ee = n.getFirstKey) === null || ee === void 0 ? void 0 : ee.call(n);
          B == null && o && (B = (ue = n.getFirstKey) === null || ue === void 0 ? void 0 : ue.call(n, t.focusedKey)), B != null && (N.preventDefault(), U(B));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          var Q, $, F;
          let B = t.focusedKey != null ? (Q = n.getKeyAbove) === null || Q === void 0 ? void 0 : Q.call(n, t.focusedKey) : ($ = n.getLastKey) === null || $ === void 0 ? void 0 : $.call(n);
          B == null && o && (B = (F = n.getLastKey) === null || F === void 0 ? void 0 : F.call(n, t.focusedKey)), B != null && (N.preventDefault(), U(B));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          var I, L, K;
          let B = t.focusedKey != null ? (I = n.getKeyLeftOf) === null || I === void 0 ? void 0 : I.call(n, t.focusedKey) : null;
          B == null && o && (B = v === "rtl" ? (L = n.getFirstKey) === null || L === void 0 ? void 0 : L.call(n, t.focusedKey) : (K = n.getLastKey) === null || K === void 0 ? void 0 : K.call(n, t.focusedKey)), B != null && (N.preventDefault(), U(B, v === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          var Y, se, ve;
          let B = t.focusedKey != null ? (Y = n.getKeyRightOf) === null || Y === void 0 ? void 0 : Y.call(n, t.focusedKey) : null;
          B == null && o && (B = v === "rtl" ? (se = n.getLastKey) === null || se === void 0 ? void 0 : se.call(n, t.focusedKey) : (ve = n.getFirstKey) === null || ve === void 0 ? void 0 : ve.call(n, t.focusedKey)), B != null && (N.preventDefault(), U(B, v === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (t.focusedKey === null && N.shiftKey) return;
          N.preventDefault();
          let B = n.getFirstKey(t.focusedKey, Ja(N));
          t.setFocusedKey(B), B != null && (Ja(N) && N.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(B) : u && t.replaceSelection(B));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (t.focusedKey === null && N.shiftKey) return;
          N.preventDefault();
          let B = n.getLastKey(t.focusedKey, Ja(N));
          t.setFocusedKey(B), B != null && (Ja(N) && N.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(B) : u && t.replaceSelection(B));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && t.focusedKey != null) {
          let B = n.getKeyPageBelow(t.focusedKey);
          B != null && (N.preventDefault(), U(B));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && t.focusedKey != null) {
          let B = n.getKeyPageAbove(t.focusedKey);
          B != null && (N.preventDefault(), U(B));
        }
        break;
      case "a":
        Ja(N) && t.selectionMode === "multiple" && s !== !0 && (N.preventDefault(), t.selectAll());
        break;
      case "Escape":
        l === "clearSelection" && !a && t.selectedKeys.size !== 0 && (N.stopPropagation(), N.preventDefault(), t.clearSelection());
        break;
      case "Tab":
        if (!d) {
          if (N.shiftKey) r.current.focus();
          else {
            let B = Mi(r.current, {
              tabbable: !0
            }), T, D;
            do
              D = B.lastChild(), D && (T = D);
            while (D);
            let C = Rt();
            T && (!rd(T) || C && !xT(C)) && Xr(T);
          }
          break;
        }
    }
  }, y = _e({
    top: 0,
    left: 0
  });
  Bc(p, "scroll", () => {
    var N, U, H, ee;
    y.current = {
      top: (H = (N = p.current) === null || N === void 0 ? void 0 : N.scrollTop) !== null && H !== void 0 ? H : 0,
      left: (ee = (U = p.current) === null || U === void 0 ? void 0 : U.scrollLeft) !== null && ee !== void 0 ? ee : 0
    };
  });
  let w = (N) => {
    if (t.isFocused) {
      Ze(N.currentTarget, Pe(N)) || t.setFocused(!1);
      return;
    }
    if (Ze(N.currentTarget, Pe(N))) {
      if (t.setFocused(!0), t.focusedKey == null) {
        var U, H;
        let Q = (F) => {
          F != null && (t.setFocusedKey(F), u && !t.isSelected(F) && t.replaceSelection(F));
        }, $ = N.relatedTarget;
        var ee, ue;
        $ && N.currentTarget.compareDocumentPosition($) & Node.DOCUMENT_POSITION_FOLLOWING ? Q((ee = t.lastSelectedKey) !== null && ee !== void 0 ? ee : (U = n.getLastKey) === null || U === void 0 ? void 0 : U.call(n)) : Q((ue = t.firstSelectedKey) !== null && ue !== void 0 ? ue : (H = n.getFirstKey) === null || H === void 0 ? void 0 : H.call(n));
      } else p.current && (p.current.scrollTop = y.current.top, p.current.scrollLeft = y.current.left);
      if (t.focusedKey != null && p.current) {
        let Q = Sf(r, t.focusedKey);
        Q instanceof HTMLElement && (!rd(Q) && !f && Xr(Q), Au() === "keyboard" && mw(Q, {
          containingElement: r.current
        }));
      }
    }
  }, x = (N) => {
    Ze(N.currentTarget, N.relatedTarget) || t.setFocused(!1);
  }, S = _e(!1);
  Bc(r, lz, f ? (N) => {
    let { detail: U } = N;
    N.stopPropagation(), t.setFocused(!0), U?.focusStrategy === "first" && (S.current = !0);
  } : void 0), hw(() => {
    if (S.current) {
      var N, U;
      let H = (U = (N = n.getFirstKey) === null || N === void 0 ? void 0 : N.call(n)) !== null && U !== void 0 ? U : null;
      if (H == null) {
        let ee = Rt();
        UT(r.current), KT(ee, null), t.collection.size > 0 && (S.current = !1);
      } else
        t.setFocusedKey(H), S.current = !1;
    }
  }, [
    t.collection
  ]), hw(() => {
    t.collection.size > 0 && (S.current = !1);
  }, [
    t.focusedKey
  ]), Bc(r, sz, f ? (N) => {
    var U;
    N.stopPropagation(), t.setFocused(!1), !((U = N.detail) === null || U === void 0) && U.clearFocusKey && t.setFocusedKey(null);
  } : void 0);
  const O = _e(i), P = _e(!1);
  Se(() => {
    if (O.current) {
      var N, U;
      let ue = null;
      var H;
      i === "first" && (ue = (H = (N = n.getFirstKey) === null || N === void 0 ? void 0 : N.call(n)) !== null && H !== void 0 ? H : null);
      var ee;
      i === "last" && (ue = (ee = (U = n.getLastKey) === null || U === void 0 ? void 0 : U.call(n)) !== null && ee !== void 0 ? ee : null);
      let Q = t.selectedKeys;
      if (Q.size) {
        for (let $ of Q) if (t.canSelectItem($)) {
          ue = $;
          break;
        }
      }
      t.setFocused(!0), t.setFocusedKey(ue), ue == null && !f && r.current && Cs(r.current), t.collection.size > 0 && (O.current = !1, P.current = !0);
    }
  });
  let b = _e(t.focusedKey), _ = _e(null);
  Se(() => {
    if (t.isFocused && t.focusedKey != null && (t.focusedKey !== b.current || P.current) && p.current && r.current) {
      let N = Au(), U = Sf(r, t.focusedKey);
      if (!(U instanceof HTMLElement))
        return;
      (N === "keyboard" || P.current) && (_.current && cancelAnimationFrame(_.current), _.current = requestAnimationFrame(() => {
        p.current && (Cm(p.current, U), N !== "virtual" && mw(U, {
          containingElement: r.current
        }));
      }));
    }
    !f && t.isFocused && t.focusedKey == null && b.current != null && r.current && Cs(r.current), b.current = t.focusedKey, P.current = !1;
  }), Se(() => () => {
    _.current && cancelAnimationFrame(_.current);
  }, []), Bc(r, "react-aria-focus-scope-restore", (N) => {
    N.preventDefault(), t.setFocused(!0);
  });
  let E = {
    onKeyDown: g,
    onFocus: w,
    onBlur: x,
    onMouseDown(N) {
      p.current === Pe(N) && N.preventDefault();
    }
  }, { typeSelectProps: A } = Pk({
    keyboardDelegate: n,
    selectionManager: t
  });
  c || (E = rt(A, E));
  let k;
  f || (k = t.focusedKey == null ? 0 : -1);
  let R = zL(t.collection);
  return {
    collectionProps: rt(E, {
      tabIndex: k,
      "data-collection": R
    })
  };
}
function Dk(e) {
  let { id: t, selectionManager: n, key: r, ref: i, shouldSelectOnPressUp: o, shouldUseVirtualFocus: a, focus: s, isDisabled: l, onAction: u, allowsDifferentPressOrigin: c, linkBehavior: f = "action" } = e, d = sp();
  t = Kn(t);
  let p = ($) => {
    if ($.pointerType === "keyboard" && Hm($)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (f === "selection" && i.current) {
          let F = n.getItemProps(r);
          d.open(i.current, $, F.href, F.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (f === "override" || f === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : $ && $.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || $ && (Ja($) || $.pointerType === "touch" || $.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  Se(() => {
    r === n.focusedKey && n.isFocused && (a ? UT(i.current) : s ? s() : Rt() !== i.current && i.current && Cs(i.current));
  }, [
    i,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    a
  ]), l = l || n.isDisabled(r);
  let h = {};
  !a && !l ? h = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus($) {
      Pe($) === i.current && n.setFocusedKey(r);
    }
  } : l && (h.onMouseDown = ($) => {
    $.preventDefault();
  }), Se(() => {
    l && n.focusedKey === r && n.setFocusedKey(null);
  }, [
    n,
    l,
    r
  ]);
  let v = n.isLink(r) && f === "override", m = u && e.UNSTABLE_itemBehavior === "action", g = n.isLink(r) && f !== "selection" && f !== "none", y = !l && n.canSelectItem(r) && !v && !m, w = (u || g) && !l, x = w && (n.selectionBehavior === "replace" ? !y : !y || n.isEmpty), S = w && y && n.selectionBehavior === "replace", O = x || S, P = _e(null), b = O && y, _ = _e(!1), E = _e(!1), A = n.getItemProps(r), k = ($) => {
    if (u) {
      var F;
      u(), (F = i.current) === null || F === void 0 || F.dispatchEvent(new CustomEvent("react-aria-item-action", {
        bubbles: !0
      }));
    }
    g && i.current && d.open(i.current, $, A.href, A.routerOptions);
  }, R = {
    ref: i
  };
  if (o ? (R.onPressStart = ($) => {
    P.current = $.pointerType, _.current = b, $.pointerType === "keyboard" && (!O || Gw($.key)) && p($);
  }, c ? (R.onPressUp = x ? void 0 : ($) => {
    $.pointerType === "mouse" && y && p($);
  }, R.onPress = x ? k : ($) => {
    $.pointerType !== "keyboard" && $.pointerType !== "mouse" && y && p($);
  }) : R.onPress = ($) => {
    if (x || S && $.pointerType !== "mouse") {
      if ($.pointerType === "keyboard" && !Zw($.key)) return;
      k($);
    } else $.pointerType !== "keyboard" && y && p($);
  }) : (R.onPressStart = ($) => {
    P.current = $.pointerType, _.current = b, E.current = x, y && ($.pointerType === "mouse" && !x || $.pointerType === "keyboard" && (!w || Gw($.key))) && p($);
  }, R.onPress = ($) => {
    ($.pointerType === "touch" || $.pointerType === "pen" || $.pointerType === "virtual" || $.pointerType === "keyboard" && O && Zw($.key) || $.pointerType === "mouse" && E.current) && (O ? k($) : y && p($));
  }), h["data-collection"] = LL(n.collection), h["data-key"] = r, R.preventFocusOnPress = a, a && (R = rt(R, {
    onPressStart($) {
      $.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress($) {
      $.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), A)
    for (let $ of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) A[$] && (R[$] = Aa(R[$], A[$]));
  let { pressProps: N, isPressed: U } = pp(R), H = S ? ($) => {
    P.current === "mouse" && ($.stopPropagation(), $.preventDefault(), k($));
  } : void 0, { longPressProps: ee } = LT({
    isDisabled: !b,
    onLongPress($) {
      $.pointerType === "touch" && (p($), n.setSelectionBehavior("toggle"));
    }
  }), ue = ($) => {
    P.current === "touch" && _.current && $.preventDefault();
  }, Q = f !== "none" && n.isLink(r) ? ($) => {
    Ki.isOpening || $.preventDefault();
  } : void 0;
  return {
    itemProps: rt(
      h,
      y || x || a && !l ? N : {},
      b ? ee : {},
      {
        onDoubleClick: H,
        onDragStartCapture: ue,
        onClick: Q,
        id: t
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      a ? {
        onMouseDown: ($) => $.preventDefault()
      } : void 0
    ),
    isPressed: U,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: l,
    allowsSelection: y,
    hasAction: O
  };
}
function Zw(e) {
  return e === "Enter";
}
function Gw(e) {
  return e === " ";
}
class Yw {
  getItemRect(t) {
    let n = this.ref.current;
    if (!n) return null;
    let r = t != null ? Sf(this.ref, t) : null;
    if (!r) return null;
    let i = n.getBoundingClientRect(), o = r.getBoundingClientRect();
    return {
      x: o.left - i.left - n.clientLeft + n.scrollLeft,
      y: o.top - i.top - n.clientTop + n.scrollTop,
      width: o.width,
      height: o.height
    };
  }
  getContentSize() {
    let t = this.ref.current;
    var n, r;
    return {
      width: (n = t?.scrollWidth) !== null && n !== void 0 ? n : 0,
      height: (r = t?.scrollHeight) !== null && r !== void 0 ? r : 0
    };
  }
  getVisibleRect() {
    let t = this.ref.current;
    var n, r, i, o;
    return {
      x: (n = t?.scrollLeft) !== null && n !== void 0 ? n : 0,
      y: (r = t?.scrollTop) !== null && r !== void 0 ? r : 0,
      width: (i = t?.clientWidth) !== null && i !== void 0 ? i : 0,
      height: (o = t?.clientHeight) !== null && o !== void 0 ? o : 0
    };
  }
  constructor(t) {
    this.ref = t;
  }
}
class cb {
  isDisabled(t) {
    var n;
    return this.disabledBehavior === "all" && (((n = t.props) === null || n === void 0 ? void 0 : n.isDisabled) || this.disabledKeys.has(t.key));
  }
  findNextNonDisabled(t, n) {
    let r = t;
    for (; r != null; ) {
      let i = this.collection.getItem(r);
      if (i?.type === "item" && !this.isDisabled(i)) return r;
      r = n(r);
    }
    return null;
  }
  getNextKey(t) {
    let n = t;
    return n = this.collection.getKeyAfter(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyAfter(r));
  }
  getPreviousKey(t) {
    let n = t;
    return n = this.collection.getKeyBefore(n), this.findNextNonDisabled(n, (r) => this.collection.getKeyBefore(r));
  }
  findKey(t, n, r) {
    let i = t, o = this.layoutDelegate.getItemRect(i);
    if (!o || i == null) return null;
    let a = o;
    do {
      if (i = n(i), i == null) break;
      o = this.layoutDelegate.getItemRect(i);
    } while (o && r(a, o) && i != null);
    return i;
  }
  isSameRow(t, n) {
    return t.y === n.y || t.x !== n.x;
  }
  isSameColumn(t, n) {
    return t.x === n.x || t.y !== n.y;
  }
  getKeyBelow(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getNextKey(n), this.isSameRow) : this.getNextKey(t);
  }
  getKeyAbove(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getPreviousKey(n), this.isSameRow) : this.getPreviousKey(t);
  }
  getNextColumn(t, n) {
    return n ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  getKeyRightOf(t) {
    let n = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[n] ? (t = this.layoutDelegate[n](t), this.findNextNonDisabled(t, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl") : null;
  }
  getKeyLeftOf(t) {
    let n = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[n] ? (t = this.layoutDelegate[n](t), this.findNextNonDisabled(t, (r) => this.layoutDelegate[n](r))) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr") : this.findKey(t, (r) => this.getNextColumn(r, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    if (n && !As(n)) return this.getFirstKey();
    let i = t;
    if (this.orientation === "horizontal") {
      let o = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > o && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let o = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y > o && i != null; )
        i = this.getKeyAbove(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getFirstKey();
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    if (n && !As(n)) return this.getLastKey();
    let i = t;
    if (this.orientation === "horizontal") {
      let o = Math.min(this.layoutDelegate.getContentSize().width, r.y - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < o && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    } else {
      let o = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < o && i != null; )
        i = this.getKeyBelow(i), r = i == null ? null : this.layoutDelegate.getItemRect(i);
    }
    return i ?? this.getLastKey();
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, i = n || this.getFirstKey();
    for (; i != null; ) {
      let o = r.getItem(i);
      if (!o) return null;
      let a = o.textValue.slice(0, t.length);
      if (o.textValue && this.collator.compare(a, t) === 0) return i;
      i = this.getNextKey(i);
    }
    return null;
  }
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new Yw(n.ref);
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new Yw(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function Ak(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: i, keyboardDelegate: o, layoutDelegate: a } = e, s = nb({
    usage: "search",
    sensitivity: "base"
  }), l = t.disabledBehavior, u = $e(() => o || new cb({
    collection: n,
    disabledKeys: r,
    disabledBehavior: l,
    ref: i,
    collator: s,
    layoutDelegate: a
  }), [
    o,
    a,
    n,
    r,
    i,
    s,
    l
  ]), { collectionProps: c } = UL({
    ...e,
    ref: i,
    selectionManager: t,
    keyboardDelegate: u
  });
  return {
    listProps: c
  };
}
function KL(e, t, n) {
  let r = bn(e, {
    labelable: !0
  }), i = e.selectionBehavior || "toggle", o = e.linkBehavior || (i === "replace" ? "action" : "override");
  i === "toggle" && o === "action" && (o = "override");
  let { listProps: a } = Ak({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: o
  }), { focusWithinProps: s } = vp({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), l = Kn(e.id);
  ub.set(t, {
    id: l,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: o,
    // @ts-ignore
    UNSTABLE_itemBehavior: e.UNSTABLE_itemBehavior
  });
  let { labelProps: u, fieldProps: c } = Tk({
    ...e,
    id: l,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: u,
    listBoxProps: rt(r, s, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ...rt(c, a)
    })
  };
}
class qL {
  build(t, n) {
    return this.context = n, Qw(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (W.isValidElement(n) && n.type === W.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let i = 0;
      for (let o of r)
        yield* this.getFullNode({
          value: o,
          index: i
        }, {
          renderer: n
        }), i++;
    } else {
      let i = [];
      W.Children.forEach(n, (a) => {
        a && i.push(a);
      });
      let o = 0;
      for (let a of i) {
        let s = this.getFullNode({
          element: a,
          index: o
        }, {});
        for (let l of s)
          o++, yield l;
      }
    }
  }
  getKey(t, n, r, i) {
    if (t.key != null) return t.key;
    if (n.type === "cell" && n.key != null) return `${i}${n.key}`;
    let o = n.value;
    if (o != null) {
      var a;
      let s = (a = o.key) !== null && a !== void 0 ? a : o.id;
      if (s == null) throw new Error("No key found for item");
      return s;
    }
    return i ? `${i}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, i) {
    if (W.isValidElement(t.element) && t.element.type === W.Fragment) {
      let m = [];
      W.Children.forEach(t.element.props.children, (y) => {
        m.push(y);
      });
      var o;
      let g = (o = t.index) !== null && o !== void 0 ? o : 0;
      for (const y of m) yield* this.getFullNode({
        element: y,
        index: g++
      }, n, r, i);
      return;
    }
    let a = t.element;
    if (!a && t.value && n && n.renderer) {
      let m = this.cache.get(t.value);
      if (m && (!m.shouldInvalidate || !m.shouldInvalidate(this.context))) {
        m.index = t.index, m.parentKey = i ? i.key : null, yield m;
        return;
      }
      a = n.renderer(t.value);
    }
    if (W.isValidElement(a)) {
      let m = a.type;
      if (typeof m != "function" && typeof m.getCollectionNode != "function") {
        let x = a.type;
        throw new Error(`Unknown element <${x}> in collection.`);
      }
      let g = m.getCollectionNode(a.props, this.context);
      var s;
      let y = (s = t.index) !== null && s !== void 0 ? s : 0, w = g.next();
      for (; !w.done && w.value; ) {
        let x = w.value;
        t.index = y;
        var l;
        let S = (l = x.key) !== null && l !== void 0 ? l : null;
        S == null && (S = x.element ? null : this.getKey(a, t, n, r));
        let P = [
          ...this.getFullNode({
            ...x,
            key: S,
            index: y,
            wrapper: HL(t.wrapper, x.wrapper)
          }, this.getChildState(n, x), r ? `${r}${a.key}` : a.key, i)
        ];
        for (let b of P) {
          var u, c;
          b.value = (c = (u = x.value) !== null && u !== void 0 ? u : t.value) !== null && c !== void 0 ? c : null, b.value && this.cache.set(b.value, b);
          var f;
          if (t.type && b.type !== t.type) throw new Error(`Unsupported type <${Wh(b.type)}> in <${Wh((f = i?.type) !== null && f !== void 0 ? f : "unknown parent type")}>. Only <${Wh(t.type)}> is supported.`);
          y++, yield b;
        }
        w = g.next(P);
      }
      return;
    }
    if (t.key == null || t.type == null) return;
    let d = this;
    var p, h;
    let v = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: i ? i.key : null,
      value: (p = t.value) !== null && p !== void 0 ? p : null,
      level: i ? i.level + 1 : 0,
      index: t.index,
      rendered: t.rendered,
      textValue: (h = t.textValue) !== null && h !== void 0 ? h : "",
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes || !1,
      childNodes: Qw(function* () {
        if (!t.hasChildNodes || !t.childNodes) return;
        let m = 0;
        for (let g of t.childNodes()) {
          g.key != null && (g.key = `${v.key}${g.key}`);
          let y = d.getFullNode({
            ...g,
            index: m
          }, d.getChildState(n, g), v.key, v);
          for (let w of y)
            m++, yield w;
        }
      })
    };
    yield v;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function Qw(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t) yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function HL(e, t) {
  if (e && t) return (n) => e(t(n));
  if (e) return e;
  if (t) return t;
}
function Wh(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function Ck(e, t, n) {
  let r = $e(() => new qL(), []), { children: i, items: o, collection: a } = e;
  return $e(() => {
    if (a) return a;
    let l = r.build({
      children: i,
      items: o
    }, n);
    return t(l);
  }, [
    r,
    i,
    o,
    a,
    n,
    t
  ]);
}
function Ik(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function WL(e) {
  return ZL(e);
}
function ZL(e, t) {
  for (let n of e)
    return n;
}
function Zh(e, t, n) {
  if (t.parentKey === n.parentKey) return t.index - n.index;
  let r = [
    ...Jw(e, t),
    t
  ], i = [
    ...Jw(e, n),
    n
  ], o = r.slice(0, i.length).findIndex((a, s) => a !== i[s]);
  return o !== -1 ? (t = r[o], n = i[o], t.index - n.index) : r.findIndex((a) => a === n) >= 0 ? 1 : (i.findIndex((a) => a === t) >= 0, -1);
}
function Jw(e, t) {
  let n = [], r = t;
  for (; r?.parentKey != null; )
    r = e.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const Xw = /* @__PURE__ */ new WeakMap();
function Nk(e) {
  let t = Xw.get(e);
  if (t != null) return t;
  let n = 0, r = (i) => {
    for (let o of i)
      o.type === "section" ? r(Ik(o, e)) : o.type === "item" && n++;
  };
  return r(e), Xw.set(e, n), n;
}
function GL(e, t, n) {
  var r, i;
  let { key: o } = e, a = ub.get(t);
  var s;
  let l = (s = e.isDisabled) !== null && s !== void 0 ? s : t.selectionManager.isDisabled(o);
  var u;
  let c = (u = e.isSelected) !== null && u !== void 0 ? u : t.selectionManager.isSelected(o);
  var f;
  let d = (f = e.shouldSelectOnPressUp) !== null && f !== void 0 ? f : a?.shouldSelectOnPressUp;
  var p;
  let h = (p = e.shouldFocusOnHover) !== null && p !== void 0 ? p : a?.shouldFocusOnHover;
  var v;
  let m = (v = e.shouldUseVirtualFocus) !== null && v !== void 0 ? v : a?.shouldUseVirtualFocus;
  var g;
  let y = (g = e.isVirtualized) !== null && g !== void 0 ? g : a?.isVirtualized, w = ua(), x = ua(), S = {
    role: "option",
    "aria-disabled": l || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? c : void 0
  };
  $o() && Wy() || (S["aria-label"] = e["aria-label"], S["aria-labelledby"] = w, S["aria-describedby"] = x);
  let O = t.collection.getItem(o);
  if (y) {
    let ee = Number(O?.index);
    S["aria-posinset"] = Number.isNaN(ee) ? void 0 : ee + 1, S["aria-setsize"] = Nk(t.collection);
  }
  let P = a?.onAction ? () => {
    var ee;
    return a == null || (ee = a.onAction) === null || ee === void 0 ? void 0 : ee.call(a, o);
  } : void 0, b = jL(t, o), { itemProps: _, isPressed: E, isFocused: A, hasAction: k, allowsSelection: R } = Dk({
    selectionManager: t.selectionManager,
    key: o,
    ref: n,
    shouldSelectOnPressUp: d,
    allowsDifferentPressOrigin: d && h,
    isVirtualized: y,
    shouldUseVirtualFocus: m,
    isDisabled: l,
    onAction: P || !(O == null || (r = O.props) === null || r === void 0) && r.onAction ? Aa(O == null || (i = O.props) === null || i === void 0 ? void 0 : i.onAction, P) : void 0,
    linkBehavior: a?.linkBehavior,
    // @ts-ignore
    UNSTABLE_itemBehavior: a?.UNSTABLE_itemBehavior,
    id: b
  }), { hoverProps: N } = nl({
    isDisabled: l || !h,
    onHoverStart() {
      ma() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(o));
    }
  }), U = bn(O?.props);
  delete U.id;
  let H = gT(O?.props);
  return {
    optionProps: {
      ...S,
      ...rt(U, _, N, H),
      id: b
    },
    labelProps: {
      id: w
    },
    descriptionProps: {
      id: x
    },
    isFocused: A,
    isFocusVisible: A && t.selectionManager.isFocused && ma(),
    isSelected: c,
    isDisabled: l,
    isPressed: E,
    allowsSelection: R,
    hasAction: k
  };
}
function YL(e) {
  let { heading: t, "aria-label": n } = e, r = Kn();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Technically, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation",
      onMouseDown: (i) => {
        i.preventDefault();
      }
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
const Rk = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, Mk = {
  ...Rk,
  customError: !0,
  valid: !1
}, Cl = {
  isInvalid: !1,
  validationDetails: Rk,
  validationErrors: []
}, QL = Le({}), ex = "__formValidationState" + Date.now();
function JL(e) {
  if (e[ex]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: i, commitValidation: o } = e[ex];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: i,
      commitValidation: o
    };
  }
  return XL(e);
}
function XL(e) {
  let { isInvalid: t, validationState: n, name: r, value: i, builtinValidation: o, validate: a, validationBehavior: s = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let l = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: Mk
  } : null, u = $e(() => {
    if (!a || i == null) return null;
    let E = e9(a, i);
    return tx(E);
  }, [
    a,
    i
  ]);
  o?.validationDetails.valid && (o = void 0);
  let c = Ie(QL), f = $e(() => r ? Array.isArray(r) ? r.flatMap((E) => Wm(c[E])) : Wm(c[r]) : [], [
    c,
    r
  ]), [d, p] = Fe(c), [h, v] = Fe(!1);
  c !== d && (p(c), v(!1));
  let m = $e(() => tx(h ? [] : f), [
    h,
    f
  ]), g = _e(Cl), [y, w] = Fe(Cl), x = _e(Cl), S = () => {
    if (!O) return;
    P(!1);
    let E = u || o || g.current;
    Gh(E, x.current) || (x.current = E, w(E));
  }, [O, P] = Fe(!1);
  return Se(S), {
    realtimeValidation: l || m || u || o || Cl,
    displayValidation: s === "native" ? l || m || y : l || m || u || o || y,
    updateValidation(E) {
      s === "aria" && !Gh(y, E) ? w(E) : g.current = E;
    },
    resetValidation() {
      let E = Cl;
      Gh(E, x.current) || (x.current = E, w(E)), s === "native" && P(!1), v(!0);
    },
    commitValidation() {
      s === "native" && P(!0), v(!0);
    }
  };
}
function Wm(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function e9(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return Wm(n);
  }
  return [];
}
function tx(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: Mk
  } : null;
}
function Gh(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
var jk = {};
jk = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var Fk = {};
Fk = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var zk = {};
zk = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var Lk = {};
Lk = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var Vk = {};
Vk = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var Bk = {};
Bk = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var Uk = {};
Uk = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var Kk = {};
Kk = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var qk = {};
qk = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var Hk = {};
Hk = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var Wk = {};
Wk = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var Zk = {};
Zk = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var Gk = {};
Gk = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Yk = {};
Yk = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var Qk = {};
Qk = {
  longPressMessage: "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
};
var Jk = {};
Jk = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var Xk = {};
Xk = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var eP = {};
eP = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var tP = {};
tP = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var nP = {};
nP = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var rP = {};
rP = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var iP = {};
iP = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var oP = {};
oP = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var aP = {};
aP = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var sP = {};
sP = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var lP = {};
lP = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var uP = {};
uP = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var cP = {};
cP = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var fP = {};
fP = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var dP = {};
dP = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var pP = {};
pP = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var hP = {};
hP = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var vP = {};
vP = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var mP = {};
mP = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var gP = {};
gP = {
  "ar-AE": jk,
  "bg-BG": Fk,
  "cs-CZ": zk,
  "da-DK": Lk,
  "de-DE": Vk,
  "el-GR": Bk,
  "en-US": Uk,
  "es-ES": Kk,
  "et-EE": qk,
  "fi-FI": Hk,
  "fr-FR": Wk,
  "he-IL": Zk,
  "hr-HR": Gk,
  "hu-HU": Yk,
  "it-IT": Qk,
  "ja-JP": Jk,
  "ko-KR": Xk,
  "lt-LT": eP,
  "lv-LV": tP,
  "nb-NO": nP,
  "nl-NL": rP,
  "pl-PL": iP,
  "pt-BR": oP,
  "pt-PT": aP,
  "ro-RO": sP,
  "ru-RU": lP,
  "sk-SK": uP,
  "sl-SI": cP,
  "sr-SP": fP,
  "sv-SE": dP,
  "tr-TR": pP,
  "uk-UA": hP,
  "zh-CN": vP,
  "zh-TW": mP
};
function t9(e) {
  return e && e.__esModule ? e.default : e;
}
function yP(e, t, n) {
  let { type: r = "menu", isDisabled: i, trigger: o = "press" } = e, a = Kn(), { triggerProps: s, overlayProps: l } = EL({
    type: r
  }, t, n), u = (p) => {
    if (!i && !(o === "longPress" && !p.altKey) && n && n.current)
      switch (p.key) {
        case "Enter":
        case " ":
          if (o === "longPress" || p.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in p || p.stopPropagation(), p.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in p && p.continuePropagation();
      }
  }, c = PT(t9(gP), "@react-aria/menu"), { longPressProps: f } = LT({
    isDisabled: i || o !== "longPress",
    accessibilityDescription: c.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), d = {
    preventFocusOnPress: !0,
    onPressStart(p) {
      p.pointerType !== "touch" && p.pointerType !== "keyboard" && !i && (Xr(p.target), t.open(p.pointerType === "virtual" ? "first" : null));
    },
    onPress(p) {
      p.pointerType === "touch" && !i && (Xr(p.target), t.toggle());
    }
  };
  return delete s.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...s,
      ...o === "press" ? d : f,
      id: a,
      onKeyDown: u
    },
    menuProps: {
      ...l,
      "aria-labelledby": a,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
const bP = /* @__PURE__ */ new WeakMap();
function n9(e, t, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: i, onKeyUp: o, ...a } = e;
  !e["aria-label"] && !e["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let s = bn(e, {
    labelable: !0
  }), { listProps: l } = Ak({
    ...a,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return bP.set(t, {
    onClose: e.onClose,
    onAction: e.onAction,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus
  }), {
    menuProps: rt(s, {
      onKeyDown: i,
      onKeyUp: o
    }, {
      role: "menu",
      ...l,
      onKeyDown: (u) => {
        var c;
        (u.key !== "Escape" || e.shouldUseVirtualFocus) && ((c = l.onKeyDown) === null || c === void 0 || c.call(l, u));
      }
    })
  };
}
function r9(e, t, n) {
  let { id: r, key: i, closeOnSelect: o, shouldCloseOnSelect: a, isVirtualized: s, "aria-haspopup": l, onPressStart: u, onPressUp: c, onPress: f, onPressChange: d, onPressEnd: p, onClick: h, onHoverStart: v, onHoverChange: m, onHoverEnd: g, onKeyDown: y, onKeyUp: w, onFocus: x, onFocusChange: S, onBlur: O, selectionManager: P = t.selectionManager } = e, b = !!l, _ = b && e["aria-expanded"] === "true";
  var E;
  let A = (E = e.isDisabled) !== null && E !== void 0 ? E : P.isDisabled(i);
  var k;
  let R = (k = e.isSelected) !== null && k !== void 0 ? k : P.isSelected(i), N = bP.get(t), U = t.collection.getItem(i), H = e.onClose || N.onClose, ee = sp(), ue = () => {
    var re;
    if (!b && (!(U == null || (re = U.props) === null || re === void 0) && re.onAction ? U.props.onAction() : e.onAction && e.onAction(i), N.onAction)) {
      let xe = N.onAction;
      xe(i);
    }
  }, Q = "menuitem";
  b || (P.selectionMode === "single" ? Q = "menuitemradio" : P.selectionMode === "multiple" && (Q = "menuitemcheckbox"));
  let $ = ua(), F = ua(), I = ua(), L = {
    id: r,
    "aria-disabled": A || void 0,
    role: Q,
    "aria-label": e["aria-label"],
    "aria-labelledby": $,
    "aria-describedby": [
      e["aria-describedby"],
      F,
      I
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": e["aria-controls"],
    "aria-haspopup": l,
    "aria-expanded": e["aria-expanded"]
  };
  if (P.selectionMode !== "none" && !b && (L["aria-checked"] = R), s) {
    let re = Number(U?.index);
    L["aria-posinset"] = Number.isNaN(re) ? void 0 : re + 1, L["aria-setsize"] = Nk(t.collection);
  }
  let K = _e(!1), Y = (re) => {
    d?.(re), K.current = re;
  }, se = _e(null), ve = (re) => {
    re.pointerType !== "keyboard" && (se.current = {
      pointerType: re.pointerType
    }), re.pointerType === "mouse" && (K.current || re.target.click()), c?.(re);
  }, B = (re) => {
    var xe, De;
    h?.(re), ue(), YF(re, ee, U.props.href, U?.props.routerOptions);
    let pe = ((xe = se.current) === null || xe === void 0 ? void 0 : xe.pointerType) === "keyboard" ? ((De = se.current) === null || De === void 0 ? void 0 : De.key) === "Enter" || P.selectionMode === "none" || P.isLink(i) : P.selectionMode !== "multiple" || P.isLink(i);
    var j;
    pe = (j = a ?? o) !== null && j !== void 0 ? j : pe, H && !b && pe && H(), se.current = null;
  }, { itemProps: T, isFocused: D } = Dk({
    id: r,
    selectionManager: P,
    key: i,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: N.shouldUseVirtualFocus
  }), { pressProps: C, isPressed: z } = pp({
    onPressStart: u,
    onPress: f,
    onPressUp: ve,
    onPressChange: Y,
    onPressEnd: p,
    isDisabled: A
  }), { hoverProps: Z } = nl({
    isDisabled: A,
    onHoverStart(re) {
      !ma() && !(_ && l) && (P.setFocused(!0), P.setFocusedKey(i)), v?.(re);
    },
    onHoverChange: m,
    onHoverEnd: g
  }), { keyboardProps: ne } = ab({
    onKeyDown: (re) => {
      if (re.repeat) {
        re.continuePropagation();
        return;
      }
      switch (re.key) {
        case " ":
          se.current = {
            pointerType: "keyboard",
            key: " "
          }, Pe(re).click(), ld("keyboard");
          break;
        case "Enter":
          se.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, Pe(re).tagName !== "A" && Pe(re).click(), ld("keyboard");
          break;
        default:
          b || re.continuePropagation(), y?.(re);
          break;
      }
    },
    onKeyUp: w
  }), { focusableProps: de } = FT({
    onBlur: O,
    onFocus: x,
    onFocusChange: S
  }, n), fe = bn(U?.props);
  delete fe.id;
  let Ee = gT(U?.props);
  return {
    menuItemProps: {
      ...L,
      ...rt(
        fe,
        Ee,
        b ? {
          onFocus: T.onFocus,
          "data-collection": T["data-collection"],
          "data-key": T["data-key"]
        } : T,
        C,
        Z,
        ne,
        de,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        N.shouldUseVirtualFocus || b ? {
          onMouseDown: (re) => re.preventDefault()
        } : void 0,
        A ? void 0 : {
          onClick: B
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: T.tabIndex != null && _ && !N.shouldUseVirtualFocus ? -1 : T.tabIndex
    },
    labelProps: {
      id: $
    },
    descriptionProps: {
      id: F
    },
    keyboardShortcutProps: {
      id: I
    },
    isFocused: D,
    isFocusVisible: D && P.isFocused && ma() && !_,
    isSelected: R,
    isPressed: z,
    isDisabled: A
  };
}
function i9(e) {
  let { heading: t, "aria-label": n } = e, r = Kn();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function o9(e, t, n) {
  let { validationBehavior: r, focus: i } = e;
  at(() => {
    if (r === "native" && n?.current && !n.current.disabled) {
      let u = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(u), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(s9(n.current));
    }
  });
  let o = _e(!1), a = tr(() => {
    o.current || t.resetValidation();
  }), s = tr((u) => {
    var c;
    t.displayValidation.isInvalid || t.commitValidation();
    let f = n == null || (c = n.current) === null || c === void 0 ? void 0 : c.form;
    if (!u.defaultPrevented && n && f && l9(f) === n.current) {
      var d;
      i ? i() : (d = n.current) === null || d === void 0 || d.focus(), ld("keyboard");
    }
    u.preventDefault();
  }), l = tr(() => {
    t.commitValidation();
  });
  Se(() => {
    let u = n?.current;
    if (!u) return;
    let c = u.form, f = c?.reset;
    return c && (c.reset = () => {
      o.current = !window.event || window.event.type === "message" && Pe(window.event) instanceof MessagePort, f?.call(c), o.current = !1;
    }), u.addEventListener("invalid", s), u.addEventListener("change", l), c?.addEventListener("reset", a), () => {
      u.removeEventListener("invalid", s), u.removeEventListener("change", l), c?.removeEventListener("reset", a), c && (c.reset = f);
    };
  }, [
    n,
    r
  ]);
}
function a9(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function s9(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: a9(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function l9(e) {
  for (let n = 0; n < e.elements.length; n++) {
    var t;
    let r = e.elements[n];
    if (((t = r.validity) === null || t === void 0 ? void 0 : t.valid) === !1) return r;
  }
  return null;
}
class rl {
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new this.constructor(this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t.render = this.render, t.colSpan = this.colSpan, t.colIndex = this.colIndex, t;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  filter(t, n, r) {
    let i = this.clone();
    return n.addDescendants(i, t), i;
  }
  constructor(t) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = t;
  }
}
class _P extends rl {
  filter(t, n, r) {
    let [i, o] = xP(t, n, this.firstChildKey, r), a = this.clone();
    return a.firstChildKey = i, a.lastChildKey = o, a;
  }
}
class u9 extends rl {
}
u9.type = "header";
class wP extends rl {
}
wP.type = "loader";
class fb extends _P {
  filter(t, n, r) {
    if (r(this.textValue, this)) {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
}
fb.type = "item";
class c9 extends _P {
  filter(t, n, r) {
    let i = super.filter(t, n, r);
    if (i && i.lastChildKey !== null) {
      let o = t.getItem(i.lastChildKey);
      if (o && o.type !== "header") return i;
    }
    return null;
  }
}
c9.type = "section";
class f9 {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(t), i = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; i; )
          yield i, i = i.nextKey != null ? n.get(i.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      var r;
      return (r = n?.key) !== null && r !== void 0 ? r : null;
    }
    return n.parentKey;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; t?.lastChildKey != null; ) t = this.keyMap.get(t.lastChildKey);
    var n;
    return (n = t?.key) !== null && n !== void 0 ? n : null;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, n = new t();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(t) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    t.type === "item" && this.keyMap.get(t.key) == null && this.itemCount++, this.keyMap.set(t.key, t);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(t, n) {
    this.addNode(t);
    let r = n.getChildren(t.key);
    for (let i of r) this.addDescendants(i, n);
  }
  removeNode(t) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(t);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(t);
  }
  commit(t, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = n, this.frozen = !r;
  }
  filter(t) {
    let n = new this.constructor(), [r, i] = xP(this, n, this.firstKey, t);
    return n?.commit(r, i), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function xP(e, t, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let i = null, o = null, a = e.getItem(n);
  for (; a != null; ) {
    let u = a.filter(e, t, r);
    u != null && (u.nextKey = null, o && (u.prevKey = o.key, o.nextKey = u.key), i == null && (i = u), t.addNode(u), o = u), a = a.nextKey ? e.getItem(a.nextKey) : null;
  }
  if (o && o.type === "separator") {
    let u = o.prevKey;
    t.removeNode(o.key), u ? (o = t.getItem(u), o.nextKey = null) : o = null;
  }
  var s, l;
  return [
    (s = i?.key) !== null && s !== void 0 ? s : null,
    (l = o?.key) !== null && l !== void 0 ? l : null
  ];
}
class EP {
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    var t;
    return ((t = this.parentNode) === null || t === void 0 ? void 0 : t.isConnected) || !1;
  }
  invalidateChildIndices(t) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || t.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = t, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let t = this._minInvalidChildIndex;
    for (; t; )
      t.index = t.previousSibling ? t.previousSibling.index + 1 : 0, t = t.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(t) {
    t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(t, n) {
    if (n == null) return this.appendChild(t);
    t.parentNode && t.parentNode.removeChild(t), t.nextSibling = n, t.previousSibling = n.previousSibling, t.index = n.index - 1, this.firstChild === n ? this.firstChild = t : n.previousSibling && (n.previousSibling.nextSibling = t), n.previousSibling = t, t.parentNode = n.parentNode, this.invalidateChildIndices(t), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    t.parentNode === this && (this._minInvalidChildIndex === t && (this._minInvalidChildIndex = null), t.nextSibling && (this.invalidateChildIndices(t.nextSibling), t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.markDirty(t), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let t = this.previousSibling;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  get nextVisibleSibling() {
    let t = this.nextSibling;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get firstVisibleChild() {
    let t = this.firstChild;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get lastVisibleChild() {
    let t = this.lastChild;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = t;
  }
}
class ws extends EP {
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    var t;
    return this.parentNode instanceof ws ? this.parentNode.level + (((t = this.parentNode.node) === null || t === void 0 ? void 0 : t.type) === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    var t, n, r, i, o, a, s, l;
    let u = this.nextVisibleSibling, c = this.getMutableNode();
    if (c != null) {
      c.index = this.index, c.level = this.level;
      var f;
      c.parentKey = this.parentNode instanceof ws && (f = (t = this.parentNode.node) === null || t === void 0 ? void 0 : t.key) !== null && f !== void 0 ? f : null;
      var d;
      c.prevKey = (d = (r = this.previousVisibleSibling) === null || r === void 0 || (n = r.node) === null || n === void 0 ? void 0 : n.key) !== null && d !== void 0 ? d : null;
      var p;
      c.nextKey = (p = u == null || (i = u.node) === null || i === void 0 ? void 0 : i.key) !== null && p !== void 0 ? p : null, c.hasChildNodes = !!this.firstChild;
      var h;
      c.firstChildKey = (h = (a = this.firstVisibleChild) === null || a === void 0 || (o = a.node) === null || o === void 0 ? void 0 : o.key) !== null && h !== void 0 ? h : null;
      var v;
      if (c.lastChildKey = (v = (l = this.lastVisibleChild) === null || l === void 0 || (s = l.node) === null || s === void 0 ? void 0 : s.key) !== null && v !== void 0 ? v : null, (c.colSpan != null || c.colIndex != null) && u) {
        var m, g;
        let y = ((m = c.colIndex) !== null && m !== void 0 ? m : c.index) + ((g = c.colSpan) !== null && g !== void 0 ? g : 1);
        if (u.node != null && y !== u.node.colIndex) {
          let w = u.getMutableNode();
          w.colIndex = y;
        }
      }
    }
  }
  setProps(t, n, r, i, o) {
    let a, { value: s, textValue: l, id: u, ...c } = t;
    if (this.node == null ? (a = new r(u ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = a) : a = this.getMutableNode(), c.ref = n, a.props = c, a.rendered = i, a.render = o, a.value = s, t["aria-label"] && (a["aria-label"] = t["aria-label"]), a.textValue = l || (typeof c.children == "string" ? c.children : "") || t["aria-label"] || "", u != null && u !== a.key) throw new Error("Cannot change the id of an item");
    c.colSpan != null && (a.colSpan = c.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let t = this;
    return {
      get display() {
        return t.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (t.isHidden !== r) {
          var i, o;
          (((i = t.parentNode) === null || i === void 0 ? void 0 : i.firstVisibleChild) === t || ((o = t.parentNode) === null || o === void 0 ? void 0 : o.lastVisibleChild) === t) && t.ownerDocument.markDirty(t.parentNode);
          let a = t.previousVisibleSibling, s = t.nextVisibleSibling;
          a && t.ownerDocument.markDirty(a), s && t.ownerDocument.markDirty(s), t.isHidden = r, t.ownerDocument.markDirty(t);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
  constructor(t, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
}
class d9 extends EP {
  get isConnected() {
    return !0;
  }
  createElement(t) {
    return new ws(t, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  addNode(t) {
    if (t.isHidden || t.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(t.node.key)) for (let r of t) this.addNode(r);
    n.addNode(t.node);
  }
  removeNode(t) {
    for (let n of t) this.removeNode(n);
    t.node && this.getMutableCollection().removeNode(t.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let s of this.dirtyNodes) s instanceof ws && (!s.isConnected || s.isHidden) ? this.removeNode(s) : s.updateChildIndices();
    for (let s of this.dirtyNodes) s instanceof ws ? (s.isConnected && !s.isHidden && (s.updateNode(), this.addNode(s)), s.node && this.dirtyNodes.delete(s), s.isMutated = !1) : this.dirtyNodes.delete(s);
    if (this.nextCollection) {
      var t, n, r, i, o, a;
      this.nextCollection.commit((o = (n = this.firstVisibleChild) === null || n === void 0 || (t = n.node) === null || t === void 0 ? void 0 : t.key) !== null && o !== void 0 ? o : null, (a = (i = this.lastVisibleChild) === null || i === void 0 || (r = i.node) === null || r === void 0 ? void 0 : r.key) !== null && a !== void 0 ? a : null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null);
    }
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0, this.isSSR || (this.collection = this.collection.clone());
      for (let t of this.subscriptions) t();
      this.inSubscription = !1;
    }
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = t, this.nextCollection = t;
  }
}
function SP(e) {
  let { children: t, items: n, idScope: r, addIdAndValue: i, dependencies: o = [] } = e, a = $e(() => /* @__PURE__ */ new WeakMap(), o);
  return $e(() => {
    if (n && typeof t == "function") {
      let u = [];
      for (let c of n) {
        let f = a.get(c);
        if (!f) {
          f = t(c);
          var s, l;
          let d = (l = (s = f.props.id) !== null && s !== void 0 ? s : c.key) !== null && l !== void 0 ? l : c.id;
          if (d == null) throw new Error("Could not determine key for item");
          r != null && (d = r + ":" + d), f = bu(f, i ? {
            key: d,
            id: d,
            value: c
          } : {
            key: d
          }), a.set(c, f);
        }
        u.push(f);
      }
      return u;
    } else if (typeof t != "function") return t;
  }, [
    t,
    n,
    a,
    r,
    i
  ]);
}
typeof HTMLTemplateElement < "u" && (Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
  configurable: !0,
  enumerable: !0,
  get: function() {
    return this.content.firstChild;
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "appendChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.appendChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "removeChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.removeChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "insertBefore", {
  configurable: !0,
  enumerable: !0,
  value: function(e, t) {
    return this.content.insertBefore(e, t);
  }
}));
const fd = /* @__PURE__ */ Le(!1);
function p9(e) {
  if (Ie(fd))
    return /* @__PURE__ */ W.createElement(W.Fragment, null, e.children);
  let n = /* @__PURE__ */ W.createElement(fd.Provider, {
    value: !0
  }, e.children);
  return /* @__PURE__ */ W.createElement("template", null, n);
}
function db(e) {
  let t = (n, r) => Ie(fd) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, Xt(t);
}
function h9() {
  return Ie(fd);
}
var Gc = { exports: {} }, Yh = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nx;
function v9() {
  if (nx) return Yh;
  nx = 1;
  var e = W;
  function t(f, d) {
    return f === d && (f !== 0 || 1 / f === 1 / d) || f !== f && d !== d;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(f, d) {
    var p = d(), h = r({ inst: { value: p, getSnapshot: d } }), v = h[0].inst, m = h[1];
    return o(
      function() {
        v.value = p, v.getSnapshot = d, l(v) && m({ inst: v });
      },
      [f, p, d]
    ), i(
      function() {
        return l(v) && m({ inst: v }), f(function() {
          l(v) && m({ inst: v });
        });
      },
      [f]
    ), a(p), p;
  }
  function l(f) {
    var d = f.getSnapshot;
    f = f.value;
    try {
      var p = d();
      return !n(f, p);
    } catch {
      return !0;
    }
  }
  function u(f, d) {
    return d();
  }
  var c = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return Yh.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : c, Yh;
}
var Qh = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rx;
function m9() {
  return rx || (rx = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(p, h) {
      return p === h && (p !== 0 || 1 / p === 1 / h) || p !== p && h !== h;
    }
    function t(p, h) {
      c || i.startTransition === void 0 || (c = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = h();
      if (!f) {
        var m = h();
        o(v, m) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      m = a({
        inst: { value: v, getSnapshot: h }
      });
      var g = m[0].inst, y = m[1];
      return l(
        function() {
          g.value = v, g.getSnapshot = h, n(g) && y({ inst: g });
        },
        [p, v, h]
      ), s(
        function() {
          return n(g) && y({ inst: g }), p(function() {
            n(g) && y({ inst: g });
          });
        },
        [p]
      ), u(v), v;
    }
    function n(p) {
      var h = p.getSnapshot;
      p = p.value;
      try {
        var v = h();
        return !o(p, v);
      } catch {
        return !0;
      }
    }
    function r(p, h) {
      return h();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = W, o = typeof Object.is == "function" ? Object.is : e, a = i.useState, s = i.useEffect, l = i.useLayoutEffect, u = i.useDebugValue, c = !1, f = !1, d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Qh.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : d, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Qh;
}
var ix;
function g9() {
  return ix || (ix = 1, process.env.NODE_ENV === "production" ? Gc.exports = v9() : Gc.exports = m9()), Gc.exports;
}
var OP = g9();
const $P = /* @__PURE__ */ Le(!1), Cu = /* @__PURE__ */ Le(null);
function pb(e) {
  if (Ie(Cu))
    return e.content;
  let { collection: n, document: r } = w9(e.createCollection);
  return /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement(p9, null, /* @__PURE__ */ W.createElement(Cu.Provider, {
    value: r
  }, e.content)), /* @__PURE__ */ W.createElement(y9, {
    render: e.children,
    collection: n
  }));
}
function y9({ collection: e, render: t }) {
  return t(e);
}
function b9(e, t, n) {
  let r = sc(), i = _e(r);
  i.current = r;
  let o = Me(() => i.current ? n() : t(), [
    t,
    n
  ]);
  return OP.useSyncExternalStore(e, o);
}
const _9 = typeof W.useSyncExternalStore == "function" ? W.useSyncExternalStore : b9;
function w9(e) {
  let [t] = Fe(() => new d9(e?.() || new f9())), n = Me((a) => t.subscribe(a), [
    t
  ]), r = Me(() => {
    let a = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), a;
  }, [
    t
  ]), i = Me(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]);
  return {
    collection: _9(n, r, i),
    document: t
  };
}
const Zm = /* @__PURE__ */ Le(null);
function x9(e) {
  var t;
  return t = class extends rl {
  }, t.type = e, t;
}
function E9(e, t, n, r, i, o) {
  typeof e == "string" && (e = x9(e));
  let a = Me((l) => {
    l?.setProps(t, n, e, r, o);
  }, [
    t,
    n,
    r,
    o,
    e
  ]), s = Ie(Zm);
  if (s) {
    let l = s.ownerDocument.nodesByProps.get(t);
    return l || (l = s.ownerDocument.createElement(e.type), l.setProps(t, n, e, r, o), s.appendChild(l), s.ownerDocument.updateCollection(), s.ownerDocument.nodesByProps.set(t, l)), i ? /* @__PURE__ */ W.createElement(Zm.Provider, {
      value: l
    }, i) : null;
  }
  return /* @__PURE__ */ W.createElement(e.type, {
    ref: a
  }, i);
}
function hb(e, t) {
  let n = ({ node: i }) => t(i.props, i.props.ref, i), r = Xt((i, o) => {
    let a = Ie(Vm);
    if (!Ie($P)) {
      if (t.length >= 3) throw new Error(t.name + " cannot be rendered outside a collection.");
      return t(i, o);
    }
    return E9(e, i, o, "children" in i ? i.children : null, null, (l) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ W.createElement(Vm.Provider, {
        value: a
      }, /* @__PURE__ */ W.createElement(n, {
        node: l
      }))
    ));
  });
  return r.displayName = t.name, r;
}
function S9(e) {
  return SP({
    ...e,
    addIdAndValue: !0
  });
}
const ox = /* @__PURE__ */ Le(null);
function TP(e) {
  let t = Ie(ox), n = (t?.dependencies || []).concat(e.dependencies);
  var r;
  let i = (r = e.idScope) !== null && r !== void 0 ? r : t?.idScope, o = S9({
    ...e,
    idScope: i,
    dependencies: n
  });
  return Ie(Cu) && (o = /* @__PURE__ */ W.createElement(O9, null, o)), t = $e(() => ({
    dependencies: n,
    idScope: i
  }), [
    i,
    ...n
  ]), /* @__PURE__ */ W.createElement(ox.Provider, {
    value: t
  }, o);
}
function O9({ children: e }) {
  let t = Ie(Cu), n = $e(() => /* @__PURE__ */ W.createElement(Cu.Provider, {
    value: null
  }, /* @__PURE__ */ W.createElement($P.Provider, {
    value: !0
  }, e)), [
    e
  ]);
  return sc() ? /* @__PURE__ */ W.createElement(Zm.Provider, {
    value: t
  }, n) : /* @__PURE__ */ da(n, t);
}
const kP = /* @__PURE__ */ Le(null), $9 = {
  CollectionRoot({ collection: e, renderDropIndicator: t }) {
    return ax(e, null, t);
  },
  CollectionBranch({ collection: e, parent: t, renderDropIndicator: n }) {
    return ax(e, t, n);
  }
};
function ax(e, t, n) {
  return SP({
    items: t ? e.getChildren(t.key) : e,
    dependencies: [
      n
    ],
    children(r) {
      if (r.type === "content") return /* @__PURE__ */ W.createElement(W.Fragment, null);
      let i = r.render(r);
      return !n || r.type !== "item" ? i : /* @__PURE__ */ W.createElement(W.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), i, T9(e, r, n));
    }
  });
}
function T9(e, t, n) {
  let r = t.key, i = e.getKeyAfter(r), o = i != null ? e.getItem(i) : null;
  for (; o != null && o.type !== "item"; )
    i = e.getKeyAfter(o.key), o = i != null ? e.getItem(i) : null;
  let a = t.nextKey != null ? e.getItem(t.nextKey) : null;
  for (; a != null && a.type !== "item"; ) a = a.nextKey != null ? e.getItem(a.nextKey) : null;
  let s = [];
  if (a == null) {
    let l = t;
    for (; l?.type === "item" && (!o || l.parentKey !== o.parentKey && o.level < l.level); ) {
      let u = n({
        type: "item",
        key: l.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ ry(u) && s.push(/* @__PURE__ */ bu(u, {
        key: `${l.key}-after`
      })), l = l.parentKey != null ? e.getItem(l.parentKey) : null;
    }
  }
  return s;
}
const il = /* @__PURE__ */ Le($9);
function k9(e) {
  return $e(() => e != null ? /* @__PURE__ */ new Set([
    e
  ]) : null, [
    e
  ]);
}
function P9(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: i, onPressStart: o, onPressEnd: a, onPressUp: s, onPressChange: l, preventFocusOnPress: u, allowFocusWhenDisabled: c, onClick: f, href: d, target: p, rel: h, type: v = "button" } = e, m;
  n === "button" ? m = {
    type: v,
    disabled: r,
    form: e.form,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formMethod: e.formMethod,
    formNoValidate: e.formNoValidate,
    formTarget: e.formTarget,
    name: e.name,
    value: e.value
  } : m = {
    role: "button",
    href: n === "a" && !r ? d : void 0,
    target: n === "a" ? p : void 0,
    type: n === "input" ? v : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? h : void 0
  };
  let { pressProps: g, isPressed: y } = pp({
    onPressStart: o,
    onPressEnd: a,
    onPressChange: l,
    onPress: i,
    onPressUp: s,
    onClick: f,
    isDisabled: r,
    preventFocusOnPress: u,
    ref: t
  }), { focusableProps: w } = FT(e, t);
  c && (w.tabIndex = r ? -1 : w.tabIndex);
  let x = rt(w, g, bn(e, {
    labelable: !0
  }));
  return {
    isPressed: y,
    buttonProps: rt(m, x, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"],
      "aria-disabled": e["aria-disabled"]
    })
  };
}
const vb = /* @__PURE__ */ new WeakMap();
function D9(e, t, n) {
  let { keyboardDelegate: r, isDisabled: i, isRequired: o, name: a, form: s, validationBehavior: l = "aria" } = e, u = nb({
    usage: "search",
    sensitivity: "base"
  }), c = $e(() => r || new cb(t.collection, t.disabledKeys, n, u), [
    r,
    t.collection,
    t.disabledKeys,
    u,
    n
  ]), { menuTriggerProps: f, menuProps: d } = yP({
    isDisabled: i,
    type: "listbox"
  }, t, n), p = (_) => {
    if (t.selectionManager.selectionMode !== "multiple")
      switch (_.key) {
        case "ArrowLeft": {
          var E, A;
          _.preventDefault();
          let N = t.selectedKey != null ? (E = c.getKeyAbove) === null || E === void 0 ? void 0 : E.call(c, t.selectedKey) : (A = c.getFirstKey) === null || A === void 0 ? void 0 : A.call(c);
          N && t.setSelectedKey(N);
          break;
        }
        case "ArrowRight": {
          var k, R;
          _.preventDefault();
          let N = t.selectedKey != null ? (k = c.getKeyBelow) === null || k === void 0 ? void 0 : k.call(c, t.selectedKey) : (R = c.getFirstKey) === null || R === void 0 ? void 0 : R.call(c);
          N && t.setSelectedKey(N);
          break;
        }
      }
  }, { typeSelectProps: h } = Pk({
    keyboardDelegate: c,
    selectionManager: t.selectionManager,
    onTypeSelect(_) {
      t.setSelectedKey(_);
    }
  }), { isInvalid: v, validationErrors: m, validationDetails: g } = t.displayValidation, { labelProps: y, fieldProps: w, descriptionProps: x, errorMessageProps: S } = FL({
    ...e,
    labelElementType: "span",
    isInvalid: v,
    errorMessage: e.errorMessage || m
  });
  h.onKeyDown = h.onKeyDownCapture, delete h.onKeyDownCapture, t.selectionManager.selectionMode === "multiple" && (h = {});
  let O = bn(e, {
    labelable: !0
  }), P = rt(h, f, w), b = Kn();
  return vb.set(t, {
    isDisabled: i,
    isRequired: o,
    name: a,
    form: s,
    validationBehavior: l
  }), {
    labelProps: {
      ...y,
      onClick: () => {
        if (!e.isDisabled) {
          var _;
          (_ = n.current) === null || _ === void 0 || _.focus(), ld("keyboard");
        }
      }
    },
    triggerProps: rt(O, {
      ...P,
      isDisabled: i,
      onKeyDown: Aa(P.onKeyDown, p, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        b,
        P["aria-labelledby"],
        P["aria-label"] && !P["aria-labelledby"] ? P.id : null
      ].filter(Boolean).join(" "),
      onFocus(_) {
        t.isFocused || (e.onFocus && e.onFocus(_), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(_) {
        t.isOpen || (e.onBlur && e.onBlur(_), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: b
    },
    menuProps: {
      ...d,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (_) => {
        Ze(_.currentTarget, _.relatedTarget) || (e.onBlur && e.onBlur(_), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        w["aria-labelledby"],
        P["aria-label"] && !w["aria-labelledby"] ? P.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: x,
    errorMessageProps: S,
    isInvalid: v,
    validationErrors: m,
    validationDetails: g,
    hiddenSelectProps: {
      isDisabled: i,
      name: a,
      label: e.label,
      state: t,
      triggerRef: n,
      form: s
    }
  };
}
function A9(e, t, n) {
  let r = vb.get(t) || {}, { autoComplete: i, name: o = r.name, form: a = r.form, isDisabled: s = r.isDisabled } = e, { validationBehavior: l, isRequired: u } = r, { visuallyHiddenProps: c } = $k({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  });
  iz(e.selectRef, t.defaultValue, t.setValue), o9({
    validationBehavior: l,
    focus: () => {
      var h;
      return (h = n.current) === null || h === void 0 ? void 0 : h.focus();
    }
  }, t, e.selectRef);
  let f = t.setValue, d = Me((h) => {
    let v = Pe(h);
    v.multiple ? f(Array.from(v.selectedOptions, (m) => m.value)) : f(h.currentTarget.value);
  }, [
    f
  ]);
  var p;
  return {
    containerProps: {
      ...c,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: i,
      disabled: s,
      multiple: t.selectionManager.selectionMode === "multiple",
      required: l === "native" && u,
      name: o,
      form: a,
      value: (p = t.value) !== null && p !== void 0 ? p : "",
      onChange: d,
      onInput: d
    }
  };
}
function C9(e) {
  let { state: t, triggerRef: n, label: r, name: i, form: o, isDisabled: a } = e, s = _e(null), l = _e(null), { containerProps: u, selectProps: c } = A9({
    ...e,
    selectRef: t.collection.size <= 300 ? s : l
  }, t, n), f = Array.isArray(t.value) ? t.value : [
    t.value
  ];
  if (t.collection.size <= 300) return /* @__PURE__ */ W.createElement("div", {
    ...u,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ W.createElement("label", null, r, /* @__PURE__ */ W.createElement("select", {
    ...c,
    ref: s
  }, /* @__PURE__ */ W.createElement("option", null), [
    ...t.collection.getKeys()
  ].map((d) => {
    let p = t.collection.getItem(d);
    if (p && p.type === "item") return /* @__PURE__ */ W.createElement("option", {
      key: p.key,
      value: p.key
    }, p.textValue);
  }), t.collection.size === 0 && i && f.map((d, p) => /* @__PURE__ */ W.createElement("option", {
    key: p,
    value: d ?? ""
  })))));
  if (i) {
    let d = vb.get(t) || {}, { validationBehavior: p } = d;
    f.length === 0 && (f = [
      null
    ]);
    let h = f.map((v, m) => {
      let g = {
        type: "hidden",
        autoComplete: c.autoComplete,
        name: i,
        form: o,
        disabled: a,
        value: v ?? ""
      };
      return p === "native" ? /* @__PURE__ */ W.createElement("input", {
        key: m,
        ...g,
        ref: m === 0 ? l : null,
        style: {
          display: "none"
        },
        type: "text",
        required: m === 0 ? c.required : !1,
        onChange: () => {
        }
      }) : /* @__PURE__ */ W.createElement("input", {
        key: m,
        ...g,
        ref: m === 0 ? l : null
      });
    });
    return /* @__PURE__ */ W.createElement(W.Fragment, null, h);
  }
  return null;
}
const mb = /* @__PURE__ */ Le({}), I9 = /* @__PURE__ */ db(function(t, n) {
  [t, n] = $i(t, n, mb);
  let { elementType: r = "label", ...i } = t, o = Rn[r];
  return /* @__PURE__ */ W.createElement(o, {
    className: "react-aria-Label",
    ...i,
    ref: n
  });
}), N9 = /* @__PURE__ */ Le(null), gb = /* @__PURE__ */ Le({}), yb = /* @__PURE__ */ db(function(t, n) {
  [t, n] = $i(t, n, gb);
  let r = t, { isPending: i } = r, { buttonProps: o, isPressed: a } = P9(t, n);
  o = M9(o, i);
  let { focusProps: s, isFocused: l, isFocusVisible: u } = mp(t), { hoverProps: c, isHovered: f } = nl({
    ...t,
    isDisabled: t.isDisabled || i
  }), d = {
    isHovered: f,
    isPressed: (r.isPressed || a) && !i,
    isFocused: l,
    isFocusVisible: u,
    isDisabled: t.isDisabled || !1,
    isPending: i ?? !1
  }, p = Ar({
    ...t,
    values: d,
    defaultClassName: "react-aria-Button"
  }), h = Kn(o.id), v = Kn(), m = o["aria-labelledby"];
  i && (m ? m = `${m} ${v}` : o["aria-label"] && (m = `${h} ${v}`));
  let g = _e(i);
  Se(() => {
    let w = {
      "aria-labelledby": m || h
    };
    (!g.current && l && i || g.current && l && !i) && yw(w, "assertive"), g.current = i;
  }, [
    i,
    l,
    m,
    h
  ]);
  let y = bn(t, {
    global: !0
  });
  return delete y.onClick, /* @__PURE__ */ W.createElement(Rn.button, {
    ...rt(y, p, o, s, c),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: o.type === "submit" && i ? "button" : o.type,
    id: h,
    ref: n,
    "aria-labelledby": m,
    slot: t.slot || void 0,
    "aria-disabled": i ? "true" : o["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-hovered": f || void 0,
    "data-focused": l || void 0,
    "data-pending": i || void 0,
    "data-focus-visible": u || void 0
  }, /* @__PURE__ */ W.createElement(N9.Provider, {
    value: {
      id: v
    }
  }, p.children));
}), R9 = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function M9(e, t) {
  if (t) {
    for (const n in e) n.startsWith("on") && !R9.test(n) && (e[n] = void 0);
    e.href = void 0, e.target = void 0;
  }
  return e;
}
const gp = /* @__PURE__ */ Le({});
class sx {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    let n = this.keyMap.get(t);
    return n?.childNodes || [];
  }
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t;
    let n = (s) => {
      if (this.keyMap.set(s.key, s), s.childNodes && s.type === "section") for (let l of s.childNodes) n(l);
    };
    for (let s of t) n(s);
    let r = null, i = 0, o = 0;
    for (let [s, l] of this.keyMap)
      r ? (r.nextKey = s, l.prevKey = r.key) : (this.firstKey = s, l.prevKey = void 0), l.type === "item" && (l.index = i++), (l.type === "section" || l.type === "item") && o++, r = l, r.nextKey = void 0;
    this._size = o;
    var a;
    this.lastKey = (a = r?.key) !== null && a !== void 0 ? a : null;
  }
}
class Br extends Set {
  constructor(t, n, r) {
    super(t), t instanceof Br ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function j9(e, t) {
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
function bb(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: i = "toggle", disabledBehavior: o = "all" } = e, a = _e(!1), [, s] = Fe(!1), l = _e(null), u = _e(null), [, c] = Fe(null), f = $e(() => lx(e.selectedKeys), [
    e.selectedKeys
  ]), d = $e(() => lx(e.defaultSelectedKeys, new Br()), [
    e.defaultSelectedKeys
  ]), [p, h] = up(f, d, e.onSelectionChange), v = $e(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [m, g] = Fe(i);
  i === "replace" && m === "toggle" && typeof p == "object" && p.size === 0 && g("replace");
  let y = _e(i);
  return Se(() => {
    i !== y.current && (g(i), y.current = i);
  }, [
    i
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: m,
    setSelectionBehavior: g,
    get isFocused() {
      return a.current;
    },
    setFocused(w) {
      a.current = w, s(w);
    },
    get focusedKey() {
      return l.current;
    },
    get childFocusStrategy() {
      return u.current;
    },
    setFocusedKey(w, x = "first") {
      l.current = w, u.current = x, c(w);
    },
    selectedKeys: p,
    setSelectedKeys(w) {
      (r || !j9(w, p)) && h(w);
    },
    disabledKeys: v,
    disabledBehavior: o
  };
}
function lx(e, t) {
  return e ? e === "all" ? "all" : new Br(e) : t;
}
class uc {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(t);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let i = this.collection.getItem(r);
      (!t || i && Zh(this.collection, i, t) < 0) && (t = i);
    }
    var n;
    return (n = t?.key) !== null && n !== void 0 ? n : null;
  }
  get lastSelectedKey() {
    let t = null;
    for (let r of this.state.selectedKeys) {
      let i = this.collection.getItem(r);
      (!t || i && Zh(this.collection, i, t) > 0) && (t = i);
    }
    var n;
    return (n = t?.key) !== null && n !== void 0 ? n : null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new Br([
      n
    ], n, n);
    else {
      let a = this.state.selectedKeys;
      var i;
      let s = (i = a.anchorKey) !== null && i !== void 0 ? i : n;
      r = new Br(a, s, n);
      var o;
      for (let l of this.getKeyRange(s, (o = a.currentKey) !== null && o !== void 0 ? o : n)) r.delete(l);
      for (let l of this.getKeyRange(n, s)) this.canSelectItem(l) && r.add(l);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), i = this.collection.getItem(n);
    return r && i ? Zh(this.collection, r, i) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    var r;
    if (!((r = this.layoutDelegate) === null || r === void 0) && r.getKeyRange) return this.layoutDelegate.getKeyRange(t, n);
    let i = [], o = t;
    for (; o != null; ) {
      let a = this.collection.getItem(o);
      if (a && (a.type === "item" || a.type === "cell" && this.allowsCellSelection) && i.push(o), o === n) return i;
      o = this.collection.getKeyAfter(o);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection) return t;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r = new Br(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(t);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new Br([
      n
    ], n, n) : new Br();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none") return;
    let n = new Br();
    for (let r of t) {
      let i = this.getKey(r);
      if (i != null && (n.add(i), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = [], n = (r) => {
      for (; r != null; ) {
        if (this.canSelectItem(r)) {
          var i;
          let a = this.collection.getItem(r);
          a?.type === "item" && t.push(r);
          var o;
          a?.hasChildNodes && (this.allowsCellSelection || a.type !== "item") && n((o = (i = WL(Ik(a, this.collection))) === null || i === void 0 ? void 0 : i.key) !== null && o !== void 0 ? o : null);
        }
        r = this.collection.getKeyAfter(r);
      }
    };
    return n(this.collection.getFirstKey()), t;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new Br());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size) return !1;
    for (let r of t)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!t.has(r)) return !1;
    return !0;
  }
  canSelectItem(t) {
    var n;
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t)) return !1;
    let r = this.collection.getItem(t);
    return !(!r || !(r == null || (n = r.props) === null || n === void 0) && n.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    var n, r;
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(t) || !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.isDisabled));
  }
  isLink(t) {
    var n, r;
    return !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.href);
  }
  getItemProps(t) {
    var n;
    return (n = this.collection.getItem(t)) === null || n === void 0 ? void 0 : n.props;
  }
  withCollection(t) {
    return new uc(t, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0
    });
  }
  constructor(t, n, r) {
    this.collection = t, this.state = n;
    var i;
    this.allowsCellSelection = (i = r?.allowsCellSelection) !== null && i !== void 0 ? i : !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null;
  }
}
function PP(e) {
  let { filter: t, layoutDelegate: n } = e, r = bb(e), i = $e(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), o = Me((u) => t ? new sx(t(u)) : new sx(u), [
    t
  ]), a = $e(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), s = Ck(e, o, a), l = $e(() => new uc(s, r, {
    layoutDelegate: n
  }), [
    s,
    r,
    n
  ]);
  return DP(s, l), {
    collection: s,
    disabledKeys: i,
    selectionManager: l
  };
}
function F9(e, t) {
  let n = $e(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return DP(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: e.disabledKeys
  };
}
function DP(e, t) {
  const n = _e(null);
  Se(() => {
    if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
      const c = n.current.getItem(t.focusedKey), f = [
        ...n.current.getKeys()
      ].map((g) => {
        const y = n.current.getItem(g);
        return y?.type === "item" ? y : null;
      }).filter((g) => g !== null), d = [
        ...e.getKeys()
      ].map((g) => {
        const y = e.getItem(g);
        return y?.type === "item" ? y : null;
      }).filter((g) => g !== null);
      var r, i;
      const p = ((r = f?.length) !== null && r !== void 0 ? r : 0) - ((i = d?.length) !== null && i !== void 0 ? i : 0);
      var o, a, s;
      let h = Math.min(p > 1 ? Math.max(((o = c?.index) !== null && o !== void 0 ? o : 0) - p + 1, 0) : (a = c?.index) !== null && a !== void 0 ? a : 0, ((s = d?.length) !== null && s !== void 0 ? s : 0) - 1), v = null, m = !1;
      for (; h >= 0; ) {
        if (!t.isDisabled(d[h].key)) {
          v = d[h];
          break;
        }
        if (h < d.length - 1 && !m) h++;
        else {
          m = !0;
          var l, u;
          h > ((l = c?.index) !== null && l !== void 0 ? l : 0) && (h = (u = c?.index) !== null && u !== void 0 ? u : 0), h--;
        }
      }
      t.setFocusedKey(v ? v.key : null);
    }
    n.current = e;
  }, [
    e,
    t
  ]);
}
function _b(e) {
  let [t, n] = up(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = Me(() => {
    n(!0);
  }, [
    n
  ]), i = Me(() => {
    n(!1);
  }, [
    n
  ]), o = Me(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: i,
    toggle: o
  };
}
function AP(e) {
  let t = _b(e), [n, r] = Fe(null), [i, o] = Fe([]), a = () => {
    o([]), t.close();
  };
  return {
    focusStrategy: n,
    ...t,
    open(u = null) {
      r(u), t.open();
    },
    toggle(u = null) {
      r(u), t.toggle();
    },
    close() {
      a();
    },
    expandedKeysStack: i,
    openSubmenu: (u, c) => {
      o((f) => c > f.length ? f : [
        ...f.slice(0, c),
        u
      ]);
    },
    closeSubmenu: (u, c) => {
      o((f) => f[c] === u ? f.slice(0, c) : f);
    }
  };
}
function z9(e) {
  let { selectionMode: t = "single" } = e, n = _b(e), [r, i] = Fe(null), o = $e(() => {
    var x;
    return e.defaultValue !== void 0 ? e.defaultValue : t === "single" ? (x = e.defaultSelectedKey) !== null && x !== void 0 ? x : null : [];
  }, [
    e.defaultValue,
    e.defaultSelectedKey,
    t
  ]), a = $e(() => e.value !== void 0 ? e.value : t === "single" ? e.selectedKey : void 0, [
    e.value,
    e.selectedKey,
    t
  ]), [s, l] = up(a, o, e.onChange), u = t === "single" && Array.isArray(s) ? s[0] : s, c = (x) => {
    if (t === "single") {
      var S, O;
      let P = Array.isArray(x) ? (O = x[0]) !== null && O !== void 0 ? O : null : x;
      l(P), P !== u && ((S = e.onSelectionChange) === null || S === void 0 || S.call(e, P));
    } else {
      let P = [];
      Array.isArray(x) ? P = x : x != null && (P = [
        x
      ]), l(P);
    }
  }, f = PP({
    ...e,
    selectionMode: t,
    disallowEmptySelection: t === "single",
    allowDuplicateSelectionEvents: !0,
    selectedKeys: $e(() => L9(u), [
      u
    ]),
    onSelectionChange: (x) => {
      if (x !== "all") {
        if (t === "single") {
          var S;
          let O = (S = x.values().next().value) !== null && S !== void 0 ? S : null;
          c(O), n.close();
        } else c([
          ...x
        ]);
        h.commitValidation();
      }
    }
  }), d = f.selectionManager.firstSelectedKey, p = $e(() => [
    ...f.selectionManager.selectedKeys
  ].map((x) => f.collection.getItem(x)).filter((x) => x != null), [
    f.selectionManager.selectedKeys,
    f.collection
  ]), h = JL({
    ...e,
    value: Array.isArray(u) && u.length === 0 ? null : u
  }), [v, m] = Fe(!1), [g] = Fe(u);
  var y, w;
  return {
    ...h,
    ...f,
    ...n,
    value: u,
    defaultValue: o ?? g,
    setValue: c,
    selectedKey: d,
    setSelectedKey: c,
    selectedItem: (y = p[0]) !== null && y !== void 0 ? y : null,
    selectedItems: p,
    defaultSelectedKey: (w = e.defaultSelectedKey) !== null && w !== void 0 ? w : e.selectionMode === "single" ? g : null,
    focusStrategy: r,
    open(x = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (i(x), n.open());
    },
    toggle(x = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (i(x), n.toggle());
    },
    isFocused: v,
    setFocused: m
  };
}
function L9(e) {
  if (e !== void 0)
    return e === null ? [] : Array.isArray(e) ? e : [
      e
    ];
}
class V9 {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.prevKey) !== null && r !== void 0 ? r : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    var r;
    return n && (r = n.nextKey) !== null && r !== void 0 ? r : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    var n;
    return (n = this.keyMap.get(t)) !== null && n !== void 0 ? n : null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  constructor(t, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t, n = n || /* @__PURE__ */ new Set();
    let r = (s) => {
      if (this.keyMap.set(s.key, s), s.childNodes && (s.type === "section" || n.has(s.key))) for (let l of s.childNodes) r(l);
    };
    for (let s of t) r(s);
    let i = null, o = 0;
    for (let [s, l] of this.keyMap)
      i ? (i.nextKey = s, l.prevKey = i.key) : (this.firstKey = s, l.prevKey = void 0), l.type === "item" && (l.index = o++), i = l, i.nextKey = void 0;
    var a;
    this.lastKey = (a = i?.key) !== null && a !== void 0 ? a : null;
  }
}
function B9(e) {
  let { onExpandedChange: t } = e, [n, r] = up(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t), i = bb(e), o = $e(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), a = Ck(e, Me((l) => new V9(l, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return Se(() => {
    i.focusedKey != null && !a.getItem(i.focusedKey) && i.setFocusedKey(null);
  }, [
    a,
    i.focusedKey
  ]), {
    collection: a,
    expandedKeys: n,
    disabledKeys: o,
    toggleKey: (l) => {
      r(U9(n, l));
    },
    setExpandedKeys: r,
    selectionManager: new uc(a, i)
  };
}
function U9(e, t) {
  let n = new Set(e);
  return n.has(t) ? n.delete(t) : n.add(t), n;
}
const K9 = /* @__PURE__ */ Le(null), q9 = /* @__PURE__ */ Le(null), H9 = /* @__PURE__ */ Le({});
let W9 = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...i } = e;
  return i;
};
const Z9 = /* @__PURE__ */ db(function(t, n) {
  [t, n] = $i(t, n, H9);
  let { hoverProps: r, isHovered: i } = nl({
    ...t,
    isDisabled: t.disabled
  }), { isFocused: o, isFocusVisible: a, focusProps: s } = mp({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), l = !!t["aria-invalid"] && t["aria-invalid"] !== "false", u = Ar({
    ...t,
    values: {
      isHovered: i,
      isFocused: o,
      isFocusVisible: a,
      isDisabled: t.disabled || !1,
      isInvalid: l
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ W.createElement(Rn.input, {
    ...rt(W9(t), s, r),
    ...u,
    ref: n,
    "data-focused": o || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": i || void 0,
    "data-focus-visible": a || void 0,
    "data-invalid": l || void 0
  });
}), yp = /* @__PURE__ */ Le({}), CP = /* @__PURE__ */ Le(null), G9 = /* @__PURE__ */ Xt(function(t, n) {
  let { render: r } = Ie(CP);
  return /* @__PURE__ */ W.createElement(W.Fragment, null, r(t, n));
});
function IP(e, t) {
  var n;
  let r = e?.renderDropIndicator, i = e == null || (n = e.isVirtualDragging) === null || n === void 0 ? void 0 : n.call(e), o = Me((a) => {
    if (i || t?.isDropTarget(a)) return r ? r(a) : /* @__PURE__ */ W.createElement(G9, {
      target: a
    });
  }, [
    t?.target,
    i,
    r
  ]);
  return e?.useDropIndicator ? o : void 0;
}
function Y9(e, t, n) {
  var r, i;
  let o = e.focusedKey, a = null;
  if (!(t == null || (r = t.isVirtualDragging) === null || r === void 0) && r.call(t) && (n == null || (i = n.target) === null || i === void 0 ? void 0 : i.type) === "item" && (a = n.target.key, n.target.dropPosition === "after")) {
    let f = n.collection.getKeyAfter(a), d = null;
    if (f != null) {
      var s, l;
      let p = (l = (s = n.collection.getItem(a)) === null || s === void 0 ? void 0 : s.level) !== null && l !== void 0 ? l : 0;
      for (; f; ) {
        let h = n.collection.getItem(f);
        if (!h) break;
        if (h.type !== "item") {
          f = n.collection.getKeyAfter(f);
          continue;
        }
        var u;
        if (((u = h.level) !== null && u !== void 0 ? u : 0) <= p) break;
        d = f, f = n.collection.getKeyAfter(f);
      }
    }
    var c;
    a = (c = f ?? d) !== null && c !== void 0 ? c : a;
  }
  return $e(() => new Set([
    o,
    a
  ].filter((f) => f != null)), [
    o,
    a
  ]);
}
const NP = /* @__PURE__ */ Le({}), Q9 = /* @__PURE__ */ Le(null);
function RP(e) {
  let t = _e({});
  return /* @__PURE__ */ W.createElement(Q9.Provider, {
    value: t
  }, e.children);
}
const MP = /* @__PURE__ */ Le({
  isSelected: !1
}), jP = /* @__PURE__ */ Le({});
class J9 extends rl {
  filter(t, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
}
J9.type = "separator";
const wb = /* @__PURE__ */ Le(null), ol = /* @__PURE__ */ Le(null), X9 = /* @__PURE__ */ Xt(function(t, n) {
  [t, n] = $i(t, n, wb);
  let r = Ie(ol);
  return r ? /* @__PURE__ */ W.createElement(FP, {
    state: r,
    props: t,
    listBoxRef: n
  }) : /* @__PURE__ */ W.createElement(pb, {
    content: /* @__PURE__ */ W.createElement(TP, t)
  }, (i) => /* @__PURE__ */ W.createElement(e7, {
    props: t,
    listBoxRef: n,
    collection: i
  }));
});
function e7({ props: e, listBoxRef: t, collection: n }) {
  e = {
    ...e,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = Ie(il), i = PP({
    ...e,
    layoutDelegate: r
  });
  return /* @__PURE__ */ W.createElement(FP, {
    state: i,
    props: e,
    listBoxRef: t
  });
}
function FP({ state: e, props: t, listBoxRef: n }) {
  [t, n] = $i(t, n, Dm);
  let { dragAndDropHooks: r, layout: i = "stack", orientation: o = "vertical", filter: a } = t, s = F9(e, a), { collection: l, selectionManager: u } = s, c = !!r?.useDraggableCollectionState, f = !!r?.useDroppableCollectionState, { direction: d } = tl(), { disabledBehavior: p, disabledKeys: h } = u, v = nb({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: m, layoutDelegate: g, dropTargetDelegate: y, CollectionRoot: w } = Ie(il), x = $e(() => t.keyboardDelegate || new cb({
    collection: l,
    collator: v,
    ref: n,
    disabledKeys: h,
    disabledBehavior: p,
    layout: i,
    orientation: o,
    direction: d,
    layoutDelegate: g
  }), [
    l,
    v,
    n,
    p,
    h,
    o,
    d,
    t.keyboardDelegate,
    i,
    g
  ]), { listBoxProps: S } = KL({
    ...t,
    shouldSelectOnPressUp: c || t.shouldSelectOnPressUp,
    keyboardDelegate: x,
    isVirtualized: m
  }, s, n), O = _e(c), P = _e(f);
  Se(() => {
    process.env.NODE_ENV !== "production" && (O.current !== c && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), P.current !== f && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    c,
    f
  ]);
  let b, _, E, A = !1, k = null, R = _e(null);
  if (c && r) {
    b = r.useDraggableCollectionState({
      collection: l,
      selectionManager: u,
      preview: r.renderDragPreview ? R : void 0
    }), r.useDraggableCollection({}, b, n);
    let I = r.DragPreview;
    k = r.renderDragPreview ? /* @__PURE__ */ W.createElement(I, {
      ref: R
    }, r.renderDragPreview) : null;
  }
  if (f && r) {
    _ = r.useDroppableCollectionState({
      collection: l,
      selectionManager: u
    });
    let I = r.dropTargetDelegate || y || new r.ListDropTargetDelegate(l, n, {
      orientation: o,
      layout: i,
      direction: d
    });
    E = r.useDroppableCollection({
      keyboardDelegate: x,
      dropTargetDelegate: I
    }, _, n), A = _.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: N, isFocused: U, isFocusVisible: H } = mp(), ee = s.collection.size === 0, ue = {
    isDropTarget: A,
    isEmpty: ee,
    isFocused: U,
    isFocusVisible: H,
    layout: t.layout || "stack",
    state: s
  }, Q = Ar({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ListBox",
    values: ue
  }), $ = null;
  ee && t.renderEmptyState && ($ = /* @__PURE__ */ W.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(ue)));
  let F = bn(t, {
    global: !0
  });
  return /* @__PURE__ */ W.createElement(sb, null, /* @__PURE__ */ W.createElement(Rn.div, {
    ...rt(F, Q, S, N, E?.collectionProps),
    ref: n,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": A || void 0,
    "data-empty": ee || void 0,
    "data-focused": U || void 0,
    "data-focus-visible": H || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": t.orientation || "vertical"
  }, /* @__PURE__ */ W.createElement(Ca, {
    values: [
      [
        wb,
        t
      ],
      [
        ol,
        s
      ],
      [
        yp,
        {
          dragAndDropHooks: r,
          dragState: b,
          dropState: _
        }
      ],
      [
        jP,
        {
          elementType: "div"
        }
      ],
      [
        CP,
        {
          render: r7
        }
      ],
      [
        kP,
        {
          name: "ListBoxSection",
          render: t7
        }
      ]
    ]
  }, /* @__PURE__ */ W.createElement(RP, null, /* @__PURE__ */ W.createElement(w, {
    collection: l,
    scrollRef: n,
    persistedKeys: Y9(u, r, _),
    renderDropIndicator: IP(r, _)
  }))), $, k));
}
function t7(e, t, n, r = "react-aria-ListBoxSection") {
  let i = Ie(ol), { dragAndDropHooks: o, dropState: a } = Ie(yp), { CollectionBranch: s } = Ie(il), [l, u] = tb();
  var c;
  let { headingProps: f, groupProps: d } = YL({
    heading: u,
    "aria-label": (c = e["aria-label"]) !== null && c !== void 0 ? c : void 0
  }), p = Ar({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    values: void 0
  }), h = bn(e, {
    global: !0
  });
  return delete h.id, /* @__PURE__ */ W.createElement(Rn.section, {
    ...rt(h, p, d),
    ref: t
  }, /* @__PURE__ */ W.createElement(NP.Provider, {
    value: {
      ...f,
      ref: l
    }
  }, /* @__PURE__ */ W.createElement(s, {
    collection: i.collection,
    parent: n,
    renderDropIndicator: IP(o, a)
  })));
}
const n7 = /* @__PURE__ */ hb(fb, function(t, n, r) {
  let i = el(n), o = Ie(ol), { dragAndDropHooks: a, dragState: s, dropState: l } = Ie(yp), { optionProps: u, labelProps: c, descriptionProps: f, ...d } = GL({
    key: r.key,
    "aria-label": t?.["aria-label"]
  }, o, i), { hoverProps: p, isHovered: h } = nl({
    isDisabled: !d.allowsSelection && !d.hasAction,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { keyboardProps: v } = ab(t), { focusProps: m } = ob(t), g = null;
  s && a && (g = a.useDraggableItem({
    key: r.key,
    hasAction: d.hasAction
  }, s));
  let y = null;
  l && a && (y = a.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, l, i));
  let w = s && s.isDragging(r.key), x = Ar({
    ...t,
    id: void 0,
    children: t.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...d,
      isHovered: h,
      selectionMode: o.selectionManager.selectionMode,
      selectionBehavior: o.selectionManager.selectionBehavior,
      allowsDragging: !!s,
      isDragging: w,
      isDropTarget: y?.isDropTarget
    }
  });
  Se(() => {
    !r.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let S = t.href ? Rn.a : Rn.div, O = bn(t, {
    global: !0
  });
  return delete O.id, delete O.onClick, t.href && u.tabIndex == null && (u.tabIndex = -1), /* @__PURE__ */ W.createElement(S, {
    ...rt(O, x, u, p, v, m, g?.dragProps, y?.dropProps),
    ref: i,
    "data-allows-dragging": !!s || void 0,
    "data-selected": d.isSelected || void 0,
    "data-disabled": d.isDisabled || void 0,
    "data-hovered": h || void 0,
    "data-focused": d.isFocused || void 0,
    "data-focus-visible": d.isFocusVisible || void 0,
    "data-pressed": d.isPressed || void 0,
    "data-dragging": w || void 0,
    "data-drop-target": y?.isDropTarget || void 0,
    "data-selection-mode": o.selectionManager.selectionMode === "none" ? void 0 : o.selectionManager.selectionMode
  }, /* @__PURE__ */ W.createElement(Ca, {
    values: [
      [
        gp,
        {
          slots: {
            [eb]: c,
            label: c,
            description: f
          }
        }
      ],
      [
        MP,
        {
          isSelected: d.isSelected
        }
      ]
    ]
  }, x.children));
});
function r7(e, t) {
  t = el(t);
  let { dragAndDropHooks: n, dropState: r } = Ie(yp), { dropIndicatorProps: i, isHidden: o, isDropTarget: a } = n.useDropIndicator(e, r, t);
  return o ? null : /* @__PURE__ */ W.createElement(o7, {
    ...e,
    dropIndicatorProps: i,
    isDropTarget: a,
    ref: t
  });
}
function i7(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, ...i } = e, o = Ar({
    ...i,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ W.createElement(Rn.div, {
    ...n,
    ...o,
    role: "option",
    ref: t,
    "data-drop-target": r || void 0
  });
}
const o7 = /* @__PURE__ */ Xt(i7);
hb(wP, function(t, n, r) {
  let i = Ie(ol), { isLoading: o, onLoadMore: a, scrollOffset: s, ...l } = t, u = _e(null), c = $e(() => ({
    onLoadMore: a,
    collection: i?.collection,
    sentinelRef: u,
    scrollOffset: s
  }), [
    a,
    s,
    i?.collection
  ]);
  oz(c, u);
  let f = Ar({
    ...l,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: void 0
  }), d = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: az(!0)
  }, /* @__PURE__ */ W.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: u,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), o && f.children && /* @__PURE__ */ W.createElement(Rn.div, {
    ...rt(bn(t, {
      global: !0
    }), d),
    ...f,
    // aria-selected isn't needed here since this option is not selectable.
    role: "option",
    ref: n
  }, f.children));
});
const a7 = /* @__PURE__ */ Le({
  placement: "bottom"
}), xb = /* @__PURE__ */ Le(null), ux = /* @__PURE__ */ Le(null), zP = /* @__PURE__ */ Xt(function(t, n) {
  [t, n] = $i(t, n, xb);
  let r = Ie(Sb), i = _b(t), o = t.isOpen != null || t.defaultOpen != null || !r ? i : r, a = cz(n, o.isOpen) || t.isExiting || !1, s = h9(), { direction: l } = tl();
  if (s) {
    let u = t.children;
    return typeof u == "function" && (u = u({
      trigger: t.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ W.createElement(W.Fragment, null, u);
  }
  return o && !o.isOpen && !a ? null : /* @__PURE__ */ W.createElement(s7, {
    ...t,
    triggerRef: t.triggerRef,
    state: o,
    popoverRef: n,
    isExiting: a,
    dir: l
  });
});
function s7({ state: e, isExiting: t, UNSTABLE_portalContainer: n, clearContexts: r, ...i }) {
  let o = _e(null), a = _e(null), s = Ie(ux), l = s && i.trigger === "SubmenuTrigger";
  var u;
  let { popoverProps: c, underlayProps: f, arrowProps: d, placement: p, triggerAnchorPoint: h } = NL({
    ...i,
    offset: (u = i.offset) !== null && u !== void 0 ? u : 8,
    arrowRef: o,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: l ? s : a
  }, e), v = i.popoverRef, m = uz(v, !!p) || i.isEntering || !1, g = Ar({
    ...i,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: i.trigger || null,
      placement: p,
      isEntering: m,
      isExiting: t
    }
  }), y = !i.isNonModal || i.trigger === "SubmenuTrigger", [w, x] = Fe(!1);
  at(() => {
    v.current && x(y && !v.current.querySelector("[role=dialog]"));
  }, [
    v,
    y
  ]), Se(() => {
    w && (i.trigger !== "SubmenuTrigger" || Au() !== "pointer") && v.current && !rd(v.current) && Cs(v.current);
  }, [
    w,
    v,
    i.trigger
  ]);
  let S = $e(() => {
    let _ = g.children;
    if (r) for (let E of r) _ = /* @__PURE__ */ W.createElement(E.Provider, {
      value: null
    }, _);
    return _;
  }, [
    g.children,
    r
  ]), O = {
    ...c.style,
    "--trigger-anchor-point": h ? `${h.x}px ${h.y}px` : void 0,
    ...g.style
  }, P = /* @__PURE__ */ W.createElement(Rn.div, {
    ...rt(bn(i, {
      global: !0
    }), c),
    ...g,
    role: w ? "dialog" : void 0,
    tabIndex: w ? -1 : void 0,
    "aria-label": i["aria-label"],
    "aria-labelledby": i["aria-labelledby"],
    ref: v,
    slot: i.slot || void 0,
    style: O,
    dir: i.dir,
    "data-trigger": i.trigger,
    "data-placement": p,
    "data-entering": m || void 0,
    "data-exiting": t || void 0
  }, !i.isNonModal && /* @__PURE__ */ W.createElement(Hw, {
    onDismiss: e.close
  }), /* @__PURE__ */ W.createElement(a7.Provider, {
    value: {
      ...d,
      placement: p,
      ref: o
    }
  }, S), /* @__PURE__ */ W.createElement(Hw, {
    onDismiss: e.close
  }));
  if (!l) return /* @__PURE__ */ W.createElement(Ww, {
    ...i,
    shouldContainFocus: w,
    isExiting: t,
    portalContainer: n
  }, !i.isNonModal && e.isOpen && /* @__PURE__ */ W.createElement("div", {
    "data-testid": "underlay",
    ...f,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ W.createElement("div", {
    ref: a,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ W.createElement(ux.Provider, {
    value: a
  }, P)));
  var b;
  return /* @__PURE__ */ W.createElement(Ww, {
    ...i,
    shouldContainFocus: w,
    isExiting: t,
    portalContainer: (b = n ?? s?.current) !== null && b !== void 0 ? b : void 0
  }, P);
}
const l7 = /* @__PURE__ */ Le({}), LP = /* @__PURE__ */ Le(null), Eb = /* @__PURE__ */ Le(null), Gm = /* @__PURE__ */ Le(null), dd = /* @__PURE__ */ Le(null);
function u7(e) {
  let t = AP(e), n = _e(null), { menuTriggerProps: r, menuProps: i } = yP({
    ...e,
    type: "menu"
  }, t, n), [o, a] = Fe(null), s = Me(() => {
    n.current && a(n.current.offsetWidth + "px");
  }, [
    n
  ]);
  id({
    ref: n,
    onResize: s
  });
  let l = _e(null);
  return /* @__PURE__ */ W.createElement(Ca, {
    values: [
      [
        LP,
        {
          ...i,
          ref: l
        }
      ],
      [
        Sb,
        t
      ],
      [
        Gm,
        t
      ],
      [
        xb,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: l,
          placement: "bottom start",
          style: {
            "--trigger-width": o
          },
          "aria-labelledby": i["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ W.createElement(zT, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const c7 = /* @__PURE__ */ Le(null);
class f7 extends rl {
  filter(t, n, r) {
    let i = t.getItem(this.firstChildKey);
    if (i && r(i.textValue, this)) {
      let o = this.clone();
      return n.addDescendants(o, t), o;
    }
    return null;
  }
}
f7.type = "submenutrigger";
const d7 = /* @__PURE__ */ Xt(function(t, n) {
  return [t, n] = $i(t, n, LP), /* @__PURE__ */ W.createElement(pb, {
    content: /* @__PURE__ */ W.createElement(TP, t)
  }, (r) => /* @__PURE__ */ W.createElement(p7, {
    props: t,
    collection: r,
    menuRef: n
  }));
});
function p7({ props: e, collection: t, menuRef: n }) {
  [e, n] = $i(e, n, Dm);
  let { filter: r, ...i } = e, o = $e(() => r ? t.filter(r) : t, [
    t,
    r
  ]), a = B9({
    ...e,
    collection: o,
    children: void 0
  }), s = Ie(Gm), { isVirtualized: l, CollectionRoot: u } = Ie(il), { menuProps: c } = n9({
    ...e,
    isVirtualized: l,
    onClose: e.onClose || s?.close
  }, a, n), f = Ar({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Menu",
    values: {
      isEmpty: a.collection.size === 0
    }
  }), d = null;
  a.collection.size === 0 && e.renderEmptyState && (d = /* @__PURE__ */ W.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState()));
  let p = bn(e, {
    global: !0
  });
  return /* @__PURE__ */ W.createElement(sb, null, /* @__PURE__ */ W.createElement(Rn.div, {
    ...rt(p, f, c),
    ref: n,
    slot: e.slot || void 0,
    "data-empty": a.collection.size === 0 || void 0,
    onScroll: e.onScroll
  }, /* @__PURE__ */ W.createElement(Ca, {
    values: [
      [
        Eb,
        a
      ],
      [
        jP,
        {
          elementType: "div"
        }
      ],
      [
        kP,
        {
          name: "MenuSection",
          render: v7
        }
      ],
      [
        c7,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: i?.shouldUseVirtualFocus
        }
      ],
      [
        Iu,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect
        }
      ],
      [
        Dm,
        null
      ],
      [
        yF,
        null
      ],
      [
        dd,
        a.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        Gm,
        s ?? AP({})
      ]
    ]
  }, /* @__PURE__ */ W.createElement(RP, null, /* @__PURE__ */ W.createElement(u, {
    collection: a.collection,
    persistedKeys: k9(a.selectionManager.focusedKey),
    scrollRef: n
  }))), d));
}
class h7 extends uc {
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(t, n) {
    return this.parent.setFocusedKey(t, n);
  }
  setFocused(t) {
    this.parent.setFocused(t);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
  constructor(t, n) {
    super(t.collection, n), this.parent = t;
  }
}
function v7(e, t, n, r = "react-aria-MenuSection") {
  var i, o, a;
  let s = Ie(Eb), { CollectionBranch: l } = Ie(il), [u, c] = tb();
  var f;
  let { headingProps: d, groupProps: p } = i9({
    heading: c,
    "aria-label": (f = n.props["aria-label"]) !== null && f !== void 0 ? f : void 0
  }), h = Ar({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    className: (i = n.props) === null || i === void 0 ? void 0 : i.className,
    style: (o = n.props) === null || o === void 0 ? void 0 : o.style,
    values: void 0
  }), v = Ie(dd), m = bb(e), g = e.selectionMode != null ? new h7(v, m) : v, y = (a = cp(Iu)) === null || a === void 0 ? void 0 : a.shouldCloseOnSelect, w = bn(e, {
    global: !0
  });
  delete w.id;
  var x;
  return /* @__PURE__ */ W.createElement(Rn.section, {
    ...rt(w, h, p),
    ref: t
  }, /* @__PURE__ */ W.createElement(Ca, {
    values: [
      [
        NP,
        {
          ...d,
          ref: u
        }
      ],
      [
        dd,
        g
      ],
      [
        Iu,
        {
          shouldCloseOnSelect: (x = e.shouldCloseOnSelect) !== null && x !== void 0 ? x : y
        }
      ]
    ]
  }, /* @__PURE__ */ W.createElement(l, {
    collection: s.collection,
    parent: n
  })));
}
const Iu = /* @__PURE__ */ Le(null), m7 = /* @__PURE__ */ hb(fb, function(t, n, r) {
  var i;
  [t, n] = $i(t, n, Iu);
  let o = (i = cp(Iu)) === null || i === void 0 ? void 0 : i.id, a = Ie(Eb), s = el(n), l = Ie(dd), { isVirtualized: u } = Ie(il), { menuItemProps: c, labelProps: f, descriptionProps: d, keyboardShortcutProps: p, ...h } = r9({
    ...t,
    id: o,
    key: r.key,
    selectionManager: l,
    isVirtualized: u
  }, a, s), { hoverProps: v, isHovered: m } = nl({
    isDisabled: h.isDisabled
  }), g = Ar({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...h,
      isHovered: m,
      isFocusVisible: h.isFocusVisible,
      selectionMode: l.selectionMode,
      selectionBehavior: l.selectionBehavior,
      hasSubmenu: !!t["aria-haspopup"],
      isOpen: t["aria-expanded"] === "true"
    }
  }), y = t.href ? Rn.a : Rn.div, w = bn(t, {
    global: !0
  });
  return delete w.id, delete w.onClick, /* @__PURE__ */ W.createElement(y, {
    ...rt(w, g, c, v),
    ref: s,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": m || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-selected": h.isSelected || void 0,
    "data-selection-mode": l.selectionMode === "none" ? void 0 : l.selectionMode,
    "data-has-submenu": !!t["aria-haspopup"] || void 0,
    "data-open": t["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ W.createElement(Ca, {
    values: [
      [
        gp,
        {
          slots: {
            [eb]: f,
            label: f,
            description: d
          }
        }
      ],
      [
        l7,
        p
      ],
      [
        MP,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, g.children));
}), Sb = /* @__PURE__ */ Le(null), g7 = /* @__PURE__ */ Xt(function(t, n) {
  let { onSelect: r, acceptedFileTypes: i, allowsMultiple: o, defaultCamera: a, children: s, acceptDirectory: l, ...u } = t, c = el(n), f = bn(u, {
    global: !0
  });
  return /* @__PURE__ */ W.createElement(W.Fragment, null, /* @__PURE__ */ W.createElement(zT, {
    onPress: () => {
      var d, p;
      !((d = c.current) === null || d === void 0) && d.value && (c.current.value = ""), (p = c.current) === null || p === void 0 || p.click();
    }
  }, s), /* @__PURE__ */ W.createElement(Z9, {
    ...f,
    className: "",
    type: "file",
    ref: c,
    style: {
      display: "none"
    },
    accept: i?.toString(),
    onChange: (d) => r?.(Pe(d).files),
    capture: a,
    multiple: o,
    // @ts-expect-error
    webkitdirectory: l ? "" : void 0
  }));
}), VP = /* @__PURE__ */ Le(null), y7 = /* @__PURE__ */ Le(null), b7 = /* @__PURE__ */ Xt(function(t, n) {
  [t, n] = $i(t, n, VP);
  let { children: r, isDisabled: i = !1, isInvalid: o = !1, isRequired: a = !1 } = t, s = $e(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: i,
    isInvalid: o,
    isRequired: a,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    i,
    o,
    a
  ]);
  return /* @__PURE__ */ W.createElement(pb, {
    content: s
  }, (l) => /* @__PURE__ */ W.createElement(w7, {
    props: t,
    collection: l,
    selectRef: n
  }));
}), _7 = [
  mb,
  gb,
  gp
];
function w7({ props: e, selectRef: t, collection: n }) {
  let { validationBehavior: r } = cp(q9) || {};
  var i, o;
  let a = (o = (i = e.validationBehavior) !== null && i !== void 0 ? i : r) !== null && o !== void 0 ? o : "native", s = z9({
    ...e,
    collection: n,
    children: void 0,
    validationBehavior: a
  }), { isFocusVisible: l, focusProps: u } = mp({
    within: !0
  }), c = _e(null), [f, d] = tb(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: p, triggerProps: h, valueProps: v, menuProps: m, descriptionProps: g, errorMessageProps: y, hiddenSelectProps: w, ...x } = D9({
    ...gz(e),
    label: d,
    validationBehavior: a
  }, s, c), [S, O] = Fe(null), P = Me(() => {
    c.current && O(c.current.offsetWidth + "px");
  }, [
    c
  ]);
  id({
    ref: c,
    onResize: P
  });
  let b = $e(() => ({
    isOpen: s.isOpen,
    isFocused: s.isFocused,
    isFocusVisible: l,
    isDisabled: e.isDisabled || !1,
    isInvalid: x.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    s.isOpen,
    s.isFocused,
    l,
    e.isDisabled,
    x.isInvalid,
    e.isRequired
  ]), _ = Ar({
    ...e,
    values: b,
    defaultClassName: "react-aria-Select"
  }), E = bn(e, {
    global: !0
  });
  delete E.id;
  let A = _e(null);
  return /* @__PURE__ */ W.createElement(Ca, {
    values: [
      [
        VP,
        e
      ],
      [
        y7,
        s
      ],
      [
        x7,
        v
      ],
      [
        mb,
        {
          ...p,
          ref: f,
          elementType: "span"
        }
      ],
      [
        gb,
        {
          ...h,
          ref: c,
          isPressed: s.isOpen,
          autoFocus: e.autoFocus
        }
      ],
      [
        Sb,
        s
      ],
      [
        xb,
        {
          trigger: "Select",
          triggerRef: c,
          scrollRef: A,
          placement: "bottom start",
          style: {
            "--trigger-width": S
          },
          "aria-labelledby": m["aria-labelledby"],
          clearContexts: _7
        }
      ],
      [
        wb,
        {
          ...m,
          ref: A
        }
      ],
      [
        ol,
        s
      ],
      [
        gp,
        {
          slots: {
            description: g,
            errorMessage: y
          }
        }
      ],
      [
        K9,
        x
      ]
    ]
  }, /* @__PURE__ */ W.createElement(Rn.div, {
    ...rt(E, _, u),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": s.isFocused || void 0,
    "data-focus-visible": l || void 0,
    "data-open": s.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": x.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }, _.children, /* @__PURE__ */ W.createElement(C9, {
    ...w,
    autoComplete: e.autoComplete
  })));
}
const x7 = /* @__PURE__ */ Le(null), kle = ({
  options: e,
  onSelect: t,
  label: n,
  className: r = ""
}) => /* @__PURE__ */ M.jsxs(
  b7,
  {
    className: r,
    onSelectionChange: (i) => {
      t(i);
    },
    children: [
      /* @__PURE__ */ M.jsx(yb, { children: /* @__PURE__ */ M.jsxs("span", { "aria-hidden": "true", children: [
        n && /* @__PURE__ */ M.jsx(I9, { children: n }),
        /* @__PURE__ */ M.jsx(ar, { className: "px-2", icon: J2, size: "sm" })
      ] }) }),
      /* @__PURE__ */ M.jsx(zP, { className: "bg-white border border-black", children: /* @__PURE__ */ M.jsx(X9, { children: e.map((i) => /* @__PURE__ */ M.jsx(n7, { id: i.id, children: /* @__PURE__ */ M.jsx("span", { className: "p-1 bg-white w-full block cursor-auto focus:outline-2 focus:outline-neutral-800 ", children: i.label }) }, `dropdown-${i.id}`)) }) })
    ]
  }
), pd = Xt(({ className: e, ...t }, n) => /* @__PURE__ */ M.jsx("input", { ref: n, className: Un(
  "bg-neutral-200 p-2 block h-auto max-h-8 my-2 border-black border dark:bg-neutral-500 dark:text-neutral-100 placeholder-neutral-400 dark:placeholder-neutral-400",
  e
), ...t })), E7 = Xt(({ className: e, ...t }, n) => /* @__PURE__ */ M.jsx("select", { ref: n, ...t, className: Un("bg-neutral-200 rounded-md p-2 block h-auto", e) })), Ple = Xt(({ field: e, onChange: t, other: n, ...r }, i) => {
  const [o, a] = Fe(!1);
  switch (e.type) {
    case "textarea":
      return /* @__PURE__ */ M.jsx(
        "textarea",
        {
          ref: i,
          onChange: t,
          ...r
        }
      );
    case "select":
      return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
        /* @__PURE__ */ M.jsxs(
          E7,
          {
            ref: i,
            required: !e.optional,
            onChange: (s) => {
              s.target.value === "other" ? a(!0) : a(!1), t && t(s);
            },
            ...r,
            children: [
              e.options.map((s, l) => /* @__PURE__ */ M.jsx("option", { value: s, children: s }, l)),
              e?.allowOther && /* @__PURE__ */ M.jsx("option", { value: "other", children: "Other" })
            ]
          }
        ),
        o && n?.()
      ] });
    case "submit":
      return /* @__PURE__ */ M.jsx(
        ly,
        {
          ref: i,
          onChange: t,
          ...r,
          type: "submit",
          children: e.text
        }
      );
    case "email":
      return /* @__PURE__ */ M.jsx(
        pd,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          type: "email",
          ...r
        }
      );
    default:
      return /* @__PURE__ */ M.jsx(
        pd,
        {
          required: !e.optional,
          ref: i,
          onChange: t,
          ...r
        }
      );
  }
}), S7 = wI`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
`, Jh = _I.span`
  animation: ${S7} 3s linear infinite;
  animation-delay: ${({ index: e }) => e * 0.1}s;
`, Dle = () => /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
  /* @__PURE__ */ M.jsx(Jh, { index: 0, children: "." }),
  /* @__PURE__ */ M.jsx(Jh, { index: 1, children: "." }),
  /* @__PURE__ */ M.jsx(Jh, { index: 2, children: "." })
] }), O7 = (e) => /* @__PURE__ */ M.jsx("p", { ...e, className: "text-red-500 text-sm" });
class Ale extends iy {
  constructor() {
    super(...arguments);
    ci(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0 };
  }
  componentDidCatch(n, r) {
    console.error("Uncaught error:", n, r);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ M.jsx("h1", { children: "Sorry.. there was an error" }) : this.props.children;
  }
}
var An = /* @__PURE__ */ ((e) => (e.ALL = "all", e.NONE = "none", e.FILE = "file", e.DIR = "dir", e.FILE_LIST = "file_list", e.DIR_LIST = "dir_list", e))(An || {});
function ae(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
let xs = class extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}, BP = class extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
};
const UP = {};
function To(e) {
  return UP;
}
function KP(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function Ym(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Ob(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function $b(e) {
  return e == null;
}
function Tb(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function $7(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const cx = Symbol("evaluating");
function nt(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== cx)
        return r === void 0 && (r = cx, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Na(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Mo(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function fx(e) {
  return JSON.stringify(e);
}
function T7(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const qP = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function hd(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const k7 = Ob(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Is(e) {
  if (hd(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(hd(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function HP(e) {
  return Is(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const P7 = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Ns(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function jo(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Be(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function D7(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const A7 = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function C7(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = Mo(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return Na(this, "shape", o), o;
    },
    checks: []
  });
  return jo(e, i);
}
function I7(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = Mo(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return Na(this, "shape", o), o;
    },
    checks: []
  });
  return jo(e, i);
}
function N7(e, t) {
  if (!Is(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = Mo(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Na(this, "shape", i), i;
    }
  });
  return jo(e, r);
}
function R7(e, t) {
  if (!Is(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Mo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Na(this, "shape", r), r;
    }
  });
  return jo(e, n);
}
function M7(e, t) {
  const n = Mo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Na(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return jo(e, n);
}
function j7(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = Mo(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return Na(this, "shape", a), a;
    },
    checks: []
  });
  return jo(t, i);
}
function F7(e, t, n) {
  const r = Mo(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return Na(this, "shape", o), o;
    }
  });
  return jo(t, r);
}
function ss(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function ls(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function Yc(e) {
  return typeof e == "string" ? e : e?.message;
}
function ko(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = Yc((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? Yc((a = t?.error) == null ? void 0 : a.call(t, e)) ?? Yc((s = n.customError) == null ? void 0 : s.call(n, e)) ?? Yc((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function kb(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Nu(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const WP = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Ym, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, ZP = ae("$ZodError", WP), GP = ae("$ZodError", WP, { Parent: Error });
function z7(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function L7(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const Pb = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new xs();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => ko(l, o, To())));
    throw qP(s, i?.callee), s;
  }
  return a.value;
}, Db = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => ko(l, o, To())));
    throw qP(s, i?.callee), s;
  }
  return a.value;
}, bp = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new xs();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? ZP)(o.issues.map((a) => ko(a, i, To())))
  } : { success: !0, data: o.value };
}, V7 = /* @__PURE__ */ bp(GP), _p = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => ko(a, i, To())))
  } : { success: !0, data: o.value };
}, B7 = /* @__PURE__ */ _p(GP), U7 = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Pb(e)(t, n, i);
}, K7 = (e) => (t, n, r) => Pb(e)(t, n, r), q7 = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return Db(e)(t, n, i);
}, H7 = (e) => async (t, n, r) => Db(e)(t, n, r), W7 = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return bp(e)(t, n, i);
}, Z7 = (e) => (t, n, r) => bp(e)(t, n, r), G7 = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return _p(e)(t, n, i);
}, Y7 = (e) => async (t, n, r) => _p(e)(t, n, r), Q7 = /^[cC][^\s-]{8,}$/, J7 = /^[0-9a-z]+$/, X7 = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, eV = /^[0-9a-vA-V]{20}$/, tV = /^[A-Za-z0-9]{27}$/, nV = /^[a-zA-Z0-9_-]{21}$/, rV = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, iV = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, dx = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, oV = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, aV = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function sV() {
  return new RegExp(aV, "u");
}
const lV = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, uV = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, cV = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, fV = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, dV = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, YP = /^[A-Za-z0-9_-]*$/, pV = /^\+[1-9]\d{6,14}$/, QP = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", hV = /* @__PURE__ */ new RegExp(`^${QP}$`);
function JP(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function vV(e) {
  return new RegExp(`^${JP(e)}$`);
}
function mV(e) {
  const t = JP({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${QP}T(?:${r})$`);
}
const gV = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, yV = /^-?\d+$/, XP = /^-?\d+(?:\.\d+)?$/, bV = /^(?:true|false)$/i, _V = /^[^A-Z]*$/, wV = /^[^a-z]*$/, Gn = /* @__PURE__ */ ae("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), eD = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, tD = /* @__PURE__ */ ae("$ZodCheckLessThan", (e, t) => {
  Gn.init(e, t);
  const n = eD[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), nD = /* @__PURE__ */ ae("$ZodCheckGreaterThan", (e, t) => {
  Gn.init(e, t);
  const n = eD[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), xV = /* @__PURE__ */ ae("$ZodCheckMultipleOf", (e, t) => {
  Gn.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : $7(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), EV = /* @__PURE__ */ ae("$ZodCheckNumberFormat", (e, t) => {
  var n;
  Gn.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = A7[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = yV);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), SV = /* @__PURE__ */ ae("$ZodCheckMaxLength", (e, t) => {
  var n;
  Gn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !$b(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = kb(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), OV = /* @__PURE__ */ ae("$ZodCheckMinLength", (e, t) => {
  var n;
  Gn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !$b(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = kb(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), $V = /* @__PURE__ */ ae("$ZodCheckLengthEquals", (e, t) => {
  var n;
  Gn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !$b(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = kb(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), wp = /* @__PURE__ */ ae("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  Gn.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), TV = /* @__PURE__ */ ae("$ZodCheckRegex", (e, t) => {
  wp.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), kV = /* @__PURE__ */ ae("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = _V), wp.init(e, t);
}), PV = /* @__PURE__ */ ae("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = wV), wp.init(e, t);
}), DV = /* @__PURE__ */ ae("$ZodCheckIncludes", (e, t) => {
  Gn.init(e, t);
  const n = Ns(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), AV = /* @__PURE__ */ ae("$ZodCheckStartsWith", (e, t) => {
  Gn.init(e, t);
  const n = new RegExp(`^${Ns(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), CV = /* @__PURE__ */ ae("$ZodCheckEndsWith", (e, t) => {
  Gn.init(e, t);
  const n = new RegExp(`.*${Ns(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), IV = /* @__PURE__ */ ae("$ZodCheckOverwrite", (e, t) => {
  Gn.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
let NV = class {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
};
const RV = {
  major: 4,
  minor: 3,
  patch: 6
}, At = /* @__PURE__ */ ae("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = RV;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = ss(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new xs();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = ss(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = ss(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (ss(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new xs();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new xs();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  nt(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = V7(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return B7(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), Ab = /* @__PURE__ */ ae("$ZodString", (e, t) => {
  var n;
  At.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? gV(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), jt = /* @__PURE__ */ ae("$ZodStringFormat", (e, t) => {
  wp.init(e, t), Ab.init(e, t);
}), MV = /* @__PURE__ */ ae("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = iV), jt.init(e, t);
}), jV = /* @__PURE__ */ ae("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = dx(n));
  } else
    t.pattern ?? (t.pattern = dx());
  jt.init(e, t);
}), FV = /* @__PURE__ */ ae("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = oV), jt.init(e, t);
}), zV = /* @__PURE__ */ ae("$ZodURL", (e, t) => {
  jt.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), LV = /* @__PURE__ */ ae("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = sV()), jt.init(e, t);
}), VV = /* @__PURE__ */ ae("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = nV), jt.init(e, t);
}), BV = /* @__PURE__ */ ae("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Q7), jt.init(e, t);
}), UV = /* @__PURE__ */ ae("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = J7), jt.init(e, t);
}), KV = /* @__PURE__ */ ae("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = X7), jt.init(e, t);
}), qV = /* @__PURE__ */ ae("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = eV), jt.init(e, t);
}), HV = /* @__PURE__ */ ae("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = tV), jt.init(e, t);
}), WV = /* @__PURE__ */ ae("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = mV(t)), jt.init(e, t);
}), ZV = /* @__PURE__ */ ae("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = hV), jt.init(e, t);
}), GV = /* @__PURE__ */ ae("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = vV(t)), jt.init(e, t);
}), YV = /* @__PURE__ */ ae("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = rV), jt.init(e, t);
}), QV = /* @__PURE__ */ ae("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = lV), jt.init(e, t), e._zod.bag.format = "ipv4";
}), JV = /* @__PURE__ */ ae("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = uV), jt.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), XV = /* @__PURE__ */ ae("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = cV), jt.init(e, t);
}), eB = /* @__PURE__ */ ae("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = fV), jt.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function rD(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const tB = /* @__PURE__ */ ae("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = dV), jt.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    rD(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function nB(e) {
  if (!YP.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return rD(n);
}
const rB = /* @__PURE__ */ ae("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = YP), jt.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    nB(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), iB = /* @__PURE__ */ ae("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = pV), jt.init(e, t);
});
function oB(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const aB = /* @__PURE__ */ ae("$ZodJWT", (e, t) => {
  jt.init(e, t), e._zod.check = (n) => {
    oB(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), iD = /* @__PURE__ */ ae("$ZodNumber", (e, t) => {
  At.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? XP, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), sB = /* @__PURE__ */ ae("$ZodNumberFormat", (e, t) => {
  EV.init(e, t), iD.init(e, t);
}), lB = /* @__PURE__ */ ae("$ZodBoolean", (e, t) => {
  At.init(e, t), e._zod.pattern = bV, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), uB = /* @__PURE__ */ ae("$ZodUnknown", (e, t) => {
  At.init(e, t), e._zod.parse = (n) => n;
}), cB = /* @__PURE__ */ ae("$ZodNever", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
}), fB = /* @__PURE__ */ ae("$ZodDate", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = new Date(n.value);
      } catch {
      }
    const i = n.value, o = i instanceof Date;
    return o && !Number.isNaN(i.getTime()) || n.issues.push({
      expected: "date",
      code: "invalid_type",
      input: i,
      ...o ? { received: "Invalid Date" } : {},
      inst: e
    }), n;
  };
});
function px(e, t, n) {
  e.issues.length && t.issues.push(...ls(n, e.issues)), t.value[n] = e.value;
}
const dB = /* @__PURE__ */ ae("$ZodArray", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => px(u, n, a))) : px(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function vd(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...ls(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function oD(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = D7(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function aD(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => vd(p, n, f, t, c))) : vd(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const pB = /* @__PURE__ */ ae("$ZodObject", (e, t) => {
  At.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = Ob(() => oD(t));
  nt(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = hd, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", v = p._zod.run({ value: u[d], issues: [] }, l);
      v instanceof Promise ? c.push(v.then((m) => vd(m, s, d, u, h))) : vd(v, s, d, u, h);
    }
    return o ? aD(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), hB = /* @__PURE__ */ ae("$ZodObjectJIT", (e, t) => {
  pB.init(e, t);
  const n = e._zod.parse, r = Ob(() => oD(t)), i = (f) => {
    var d;
    const p = new NV(["shape", "payload", "ctx"]), h = r.value, v = (w) => {
      const x = fx(w);
      return `shape[${x}]._zod.run({ value: input[${x}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const w of h.keys)
      m[w] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const w of h.keys) {
      const x = m[w], S = fx(w), O = f[w], P = ((d = O?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${x} = ${v(w)};`), P ? p.write(`
        if (${x}.issues.length) {
          if (${S} in input) {
            payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${S}, ...iss.path] : [${S}]
            })));
          }
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `) : p.write(`
        if (${x}.issues.length) {
          payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${S}, ...iss.path] : [${S}]
          })));
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const y = p.compile();
    return (w, x) => y(f, w, x);
  };
  let o;
  const a = hd, s = !UP.jitless, l = s && k7.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? aD([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function hx(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !ss(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => ko(a, r, To())))
  }), t);
}
const vB = /* @__PURE__ */ ae("$ZodUnion", (e, t) => {
  At.init(e, t), nt(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), nt(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), nt(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), nt(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Tb(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => hx(l, i, e, o)) : hx(s, i, e, o);
  };
}), mB = /* @__PURE__ */ ae("$ZodIntersection", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => vx(n, s, l)) : vx(n, o, a);
  };
});
function Qm(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Is(e) && Is(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = Qm(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = Qm(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function vx(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), ss(e))
    return e;
  const a = Qm(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const gB = /* @__PURE__ */ ae("$ZodRecord", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Is(i))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    const o = [], a = t.keyType._zod.values;
    if (a) {
      n.value = {};
      const s = /* @__PURE__ */ new Set();
      for (const u of a)
        if (typeof u == "string" || typeof u == "number" || typeof u == "symbol") {
          s.add(typeof u == "number" ? u.toString() : u);
          const c = t.valueType._zod.run({ value: i[u], issues: [] }, r);
          c instanceof Promise ? o.push(c.then((f) => {
            f.issues.length && n.issues.push(...ls(u, f.issues)), n.value[u] = f.value;
          })) : (c.issues.length && n.issues.push(...ls(u, c.issues)), n.value[u] = c.value);
        }
      let l;
      for (const u in i)
        s.has(u) || (l = l ?? [], l.push(u));
      l && l.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: i,
        inst: e,
        keys: l
      });
    } else {
      n.value = {};
      for (const s of Reflect.ownKeys(i)) {
        if (s === "__proto__")
          continue;
        let l = t.keyType._zod.run({ value: s, issues: [] }, r);
        if (l instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (typeof s == "string" && XP.test(s) && l.issues.length) {
          const c = t.keyType._zod.run({ value: Number(s), issues: [] }, r);
          if (c instanceof Promise)
            throw new Error("Async schemas not supported in object keys currently");
          c.issues.length === 0 && (l = c);
        }
        if (l.issues.length) {
          t.mode === "loose" ? n.value[s] = i[s] : n.issues.push({
            code: "invalid_key",
            origin: "record",
            issues: l.issues.map((c) => ko(c, r, To())),
            input: s,
            path: [s],
            inst: e
          });
          continue;
        }
        const u = t.valueType._zod.run({ value: i[s], issues: [] }, r);
        u instanceof Promise ? o.push(u.then((c) => {
          c.issues.length && n.issues.push(...ls(s, c.issues)), n.value[l.value] = c.value;
        })) : (u.issues.length && n.issues.push(...ls(s, u.issues)), n.value[l.value] = u.value);
      }
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
}), yB = /* @__PURE__ */ ae("$ZodEnum", (e, t) => {
  At.init(e, t);
  const n = KP(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => P7.has(typeof i)).map((i) => typeof i == "string" ? Ns(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), bB = /* @__PURE__ */ ae("$ZodLiteral", (e, t) => {
  if (At.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  const n = new Set(t.values);
  e._zod.values = n, e._zod.pattern = new RegExp(`^(${t.values.map((r) => typeof r == "string" ? Ns(r) : r ? Ns(r.toString()) : String(r)).join("|")})$`), e._zod.parse = (r, i) => {
    const o = r.value;
    return n.has(o) || r.issues.push({
      code: "invalid_value",
      values: t.values,
      input: o,
      inst: e
    }), r;
  };
}), _B = /* @__PURE__ */ ae("$ZodTransform", (e, t) => {
  At.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new BP(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new xs();
    return n.value = i, n;
  };
});
function mx(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const sD = /* @__PURE__ */ ae("$ZodOptional", (e, t) => {
  At.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", nt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), nt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Tb(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => mx(o, n.value)) : mx(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), wB = /* @__PURE__ */ ae("$ZodExactOptional", (e, t) => {
  sD.init(e, t), nt(e._zod, "values", () => t.innerType._zod.values), nt(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), xB = /* @__PURE__ */ ae("$ZodNullable", (e, t) => {
  At.init(e, t), nt(e._zod, "optin", () => t.innerType._zod.optin), nt(e._zod, "optout", () => t.innerType._zod.optout), nt(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Tb(n.source)}|null)$`) : void 0;
  }), nt(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), EB = /* @__PURE__ */ ae("$ZodDefault", (e, t) => {
  At.init(e, t), e._zod.optin = "optional", nt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => gx(o, t)) : gx(i, t);
  };
});
function gx(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const SB = /* @__PURE__ */ ae("$ZodPrefault", (e, t) => {
  At.init(e, t), e._zod.optin = "optional", nt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), OB = /* @__PURE__ */ ae("$ZodNonOptional", (e, t) => {
  At.init(e, t), nt(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => yx(o, e)) : yx(i, e);
  };
});
function yx(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const $B = /* @__PURE__ */ ae("$ZodCatch", (e, t) => {
  At.init(e, t), nt(e._zod, "optin", () => t.innerType._zod.optin), nt(e._zod, "optout", () => t.innerType._zod.optout), nt(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => ko(a, r, To()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => ko(o, r, To()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), TB = /* @__PURE__ */ ae("$ZodPipe", (e, t) => {
  At.init(e, t), nt(e._zod, "values", () => t.in._zod.values), nt(e._zod, "optin", () => t.in._zod.optin), nt(e._zod, "optout", () => t.out._zod.optout), nt(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => Qc(a, t.in, r)) : Qc(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => Qc(o, t.out, r)) : Qc(i, t.out, r);
  };
});
function Qc(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const kB = /* @__PURE__ */ ae("$ZodReadonly", (e, t) => {
  At.init(e, t), nt(e._zod, "propValues", () => t.innerType._zod.propValues), nt(e._zod, "values", () => t.innerType._zod.values), nt(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), nt(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(bx) : bx(i);
  };
});
function bx(e) {
  return e.value = Object.freeze(e.value), e;
}
const PB = /* @__PURE__ */ ae("$ZodLazy", (e, t) => {
  At.init(e, t), nt(e._zod, "innerType", () => t.getter()), nt(e._zod, "pattern", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.pattern;
  }), nt(e._zod, "propValues", () => {
    var n, r;
    return (r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.propValues;
  }), nt(e._zod, "optin", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin) ?? void 0;
  }), nt(e._zod, "optout", () => {
    var n, r;
    return ((r = (n = e._zod.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout) ?? void 0;
  }), e._zod.parse = (n, r) => e._zod.innerType._zod.run(n, r);
}), DB = /* @__PURE__ */ ae("$ZodCustom", (e, t) => {
  Gn.init(e, t), At.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => _x(o, n, r, e));
    _x(i, n, r, e);
  };
});
function _x(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Nu(i));
  }
}
var wx;
let AB = class {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
};
function CB() {
  return new AB();
}
(wx = globalThis).__zod_globalRegistry ?? (wx.__zod_globalRegistry = CB());
const ql = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function IB(e, t) {
  return new e({
    type: "string",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function NB(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xx(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function RB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function MB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function FB(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zB(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function LB(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function VB(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function BB(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function UB(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function KB(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function qB(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function HB(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function WB(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function ZB(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function GB(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function YB(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function QB(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function JB(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function XB(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function eU(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function tU(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function nU(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function rU(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function iU(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function oU(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function aU(e, t) {
  return new e({
    type: "number",
    coerce: !0,
    checks: [],
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function sU(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function lU(e, t) {
  return new e({
    type: "boolean",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function uU(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function cU(e, t) {
  return new e({
    type: "never",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fU(e, t) {
  return new e({
    type: "date",
    ...Be(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Ex(e, t) {
  return new tD({
    check: "less_than",
    ...Be(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Of(e, t) {
  return new tD({
    check: "less_than",
    ...Be(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Sx(e, t) {
  return new nD({
    check: "greater_than",
    ...Be(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function $f(e, t) {
  return new nD({
    check: "greater_than",
    ...Be(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function Ox(e, t) {
  return new xV({
    check: "multiple_of",
    ...Be(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function lD(e, t) {
  return new SV({
    check: "max_length",
    ...Be(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function md(e, t) {
  return new OV({
    check: "min_length",
    ...Be(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function uD(e, t) {
  return new $V({
    check: "length_equals",
    ...Be(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function dU(e, t) {
  return new TV({
    check: "string_format",
    format: "regex",
    ...Be(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function pU(e) {
  return new kV({
    check: "string_format",
    format: "lowercase",
    ...Be(e)
  });
}
// @__NO_SIDE_EFFECTS__
function hU(e) {
  return new PV({
    check: "string_format",
    format: "uppercase",
    ...Be(e)
  });
}
// @__NO_SIDE_EFFECTS__
function vU(e, t) {
  return new DV({
    check: "string_format",
    format: "includes",
    ...Be(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function mU(e, t) {
  return new AV({
    check: "string_format",
    format: "starts_with",
    ...Be(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function gU(e, t) {
  return new CV({
    check: "string_format",
    format: "ends_with",
    ...Be(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function al(e) {
  return new IV({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function yU(e) {
  return /* @__PURE__ */ al((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function bU() {
  return /* @__PURE__ */ al((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function _U() {
  return /* @__PURE__ */ al((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function wU() {
  return /* @__PURE__ */ al((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function xU() {
  return /* @__PURE__ */ al((e) => T7(e));
}
// @__NO_SIDE_EFFECTS__
function EU(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Be(n)
  });
}
// @__NO_SIDE_EFFECTS__
function SU(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Be(n)
  });
}
// @__NO_SIDE_EFFECTS__
function OU(e) {
  const t = /* @__PURE__ */ $U((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Nu(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Nu(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function $U(e, t) {
  const n = new Gn({
    check: "custom",
    ...Be(t)
  });
  return n._zod.check = e, n;
}
function cD(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? ql,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function Qt(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), Qt(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && Tn(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function fD(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const v = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, m = e.external.uri ?? ((y) => y);
      if (v)
        return { ref: m(v) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${m("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const v in h)
      delete h[v];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function dD(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const v = e.seen.get(p), m = v.schema;
      if (m.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(m)) : Object.assign(f, m), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (m.$ref && v.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in v.def && JSON.stringify(f[g]) === JSON.stringify(v.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const v = e.seen.get(h);
      if (v != null && v.schema.$ref && (f.$ref = v.schema.$ref, v.def))
        for (const m in f)
          m === "$ref" || m === "allOf" || m in v.def && JSON.stringify(f[m]) === JSON.stringify(v.def[m]) && delete f[m];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: gd(t, "input", e.processors),
          output: gd(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function Tn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return Tn(r.element, n);
  if (r.type === "set")
    return Tn(r.valueType, n);
  if (r.type === "lazy")
    return Tn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return Tn(r.innerType, n);
  if (r.type === "intersection")
    return Tn(r.left, n) || Tn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return Tn(r.keyType, n) || Tn(r.valueType, n);
  if (r.type === "pipe")
    return Tn(r.in, n) || Tn(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (Tn(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (Tn(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (Tn(i, n))
        return !0;
    return !!(r.rest && Tn(r.rest, n));
  }
  return !1;
}
const TU = (e, t = {}) => (n) => {
  const r = cD({ ...n, processors: t });
  return Qt(e, r), fD(r, e), dD(r, e);
}, gd = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = cD({ ...i ?? {}, target: o, io: t, processors: n });
  return Qt(e, a), fD(a, e), dD(a, e);
}, kU = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, PU = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = kU[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, DU = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, AU = (e, t, n, r) => {
  n.type = "boolean";
}, CU = (e, t, n, r) => {
  n.not = {};
}, IU = (e, t, n, r) => {
}, NU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Date cannot be represented in JSON Schema");
}, RU = (e, t, n, r) => {
  const i = e._zod.def, o = KP(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, MU = (e, t, n, r) => {
  const i = e._zod.def, o = [];
  for (const a of i.values)
    if (a === void 0) {
      if (t.unrepresentable === "throw")
        throw new Error("Literal `undefined` cannot be represented in JSON Schema");
    } else if (typeof a == "bigint") {
      if (t.unrepresentable === "throw")
        throw new Error("BigInt literals cannot be represented in JSON Schema");
      o.push(Number(a));
    } else
      o.push(a);
  if (o.length !== 0) if (o.length === 1) {
    const a = o[0];
    n.type = a === null ? "null" : typeof a, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [a] : n.const = a;
  } else
    o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), o.every((a) => typeof a == "boolean") && (n.type = "boolean"), o.every((a) => a === null) && (n.type = "null"), n.enum = o;
}, jU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, FU = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, zU = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = Qt(o.element, t, { ...r, path: [...r.path, "items"] });
}, LU = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = Qt(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = Qt(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, VU = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => Qt(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, BU = (e, t, n, r) => {
  const i = e._zod.def, o = Qt(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = Qt(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, UU = (e, t, n, r) => {
  const i = n, o = e._zod.def;
  i.type = "object";
  const a = o.keyType, s = a._zod.bag, l = s?.patterns;
  if (o.mode === "loose" && l && l.size > 0) {
    const c = Qt(o.valueType, t, {
      ...r,
      path: [...r.path, "patternProperties", "*"]
    });
    i.patternProperties = {};
    for (const f of l)
      i.patternProperties[f.source] = c;
  } else
    (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = Qt(o.keyType, t, {
      ...r,
      path: [...r.path, "propertyNames"]
    })), i.additionalProperties = Qt(o.valueType, t, {
      ...r,
      path: [...r.path, "additionalProperties"]
    });
  const u = a._zod.values;
  if (u) {
    const c = [...u].filter((f) => typeof f == "string" || typeof f == "number");
    c.length > 0 && (i.required = c);
  }
}, KU = (e, t, n, r) => {
  const i = e._zod.def, o = Qt(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, qU = (e, t, n, r) => {
  const i = e._zod.def;
  Qt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, HU = (e, t, n, r) => {
  const i = e._zod.def;
  Qt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, WU = (e, t, n, r) => {
  const i = e._zod.def;
  Qt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, ZU = (e, t, n, r) => {
  const i = e._zod.def;
  Qt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, GU = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  Qt(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, YU = (e, t, n, r) => {
  const i = e._zod.def;
  Qt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, pD = (e, t, n, r) => {
  const i = e._zod.def;
  Qt(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, QU = (e, t, n, r) => {
  const i = e._zod.innerType;
  Qt(i, t, r);
  const o = t.seen.get(e);
  o.ref = i;
}, JU = /* @__PURE__ */ ae("ZodISODateTime", (e, t) => {
  WV.init(e, t), Ut.init(e, t);
});
function XU(e) {
  return /* @__PURE__ */ tU(JU, e);
}
const eK = /* @__PURE__ */ ae("ZodISODate", (e, t) => {
  ZV.init(e, t), Ut.init(e, t);
});
function tK(e) {
  return /* @__PURE__ */ nU(eK, e);
}
const nK = /* @__PURE__ */ ae("ZodISOTime", (e, t) => {
  GV.init(e, t), Ut.init(e, t);
});
function rK(e) {
  return /* @__PURE__ */ rU(nK, e);
}
const iK = /* @__PURE__ */ ae("ZodISODuration", (e, t) => {
  YV.init(e, t), Ut.init(e, t);
});
function oK(e) {
  return /* @__PURE__ */ iU(iK, e);
}
const aK = (e, t) => {
  ZP.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => L7(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => z7(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Ym, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Ym, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Cr = ae("ZodError", aK, {
  Parent: Error
}), sK = /* @__PURE__ */ Pb(Cr), lK = /* @__PURE__ */ Db(Cr), uK = /* @__PURE__ */ bp(Cr), cK = /* @__PURE__ */ _p(Cr), fK = /* @__PURE__ */ U7(Cr), dK = /* @__PURE__ */ K7(Cr), pK = /* @__PURE__ */ q7(Cr), hK = /* @__PURE__ */ H7(Cr), vK = /* @__PURE__ */ W7(Cr), mK = /* @__PURE__ */ Z7(Cr), gK = /* @__PURE__ */ G7(Cr), yK = /* @__PURE__ */ Y7(Cr), Ct = /* @__PURE__ */ ae("ZodType", (e, t) => (At.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: gd(e, "input"),
    output: gd(e, "output")
  }
}), e.toJSONSchema = TU(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(Mo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => jo(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => sK(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => uK(e, n, r), e.parseAsync = async (n, r) => lK(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => cK(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => fK(e, n, r), e.decode = (n, r) => dK(e, n, r), e.encodeAsync = async (n, r) => pK(e, n, r), e.decodeAsync = async (n, r) => hK(e, n, r), e.safeEncode = (n, r) => vK(e, n, r), e.safeDecode = (n, r) => mK(e, n, r), e.safeEncodeAsync = async (n, r) => gK(e, n, r), e.safeDecodeAsync = async (n, r) => yK(e, n, r), e.refine = (n, r) => e.check(hq(n, r)), e.superRefine = (n) => e.check(vq(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ al(n)), e.optional = () => kx(e), e.exactOptional = () => eq(e), e.nullable = () => Px(e), e.nullish = () => kx(Px(e)), e.nonoptional = (n) => aq(e, n), e.array = () => qn(e), e.or = (n) => Ra([e, n]), e.and = (n) => ZK(e, n), e.transform = (n) => Dx(e, JK(n)), e.default = (n) => rq(e, n), e.prefault = (n) => oq(e, n), e.catch = (n) => lq(e, n), e.pipe = (n) => Dx(e, n), e.readonly = () => fq(e), e.describe = (n) => {
  const r = e.clone();
  return ql.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = ql.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return ql.get(e);
  const r = e.clone();
  return ql.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), hD = /* @__PURE__ */ ae("_ZodString", (e, t) => {
  Ab.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => PU(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ dU(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ vU(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ mU(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ gU(...r)), e.min = (...r) => e.check(/* @__PURE__ */ md(...r)), e.max = (...r) => e.check(/* @__PURE__ */ lD(...r)), e.length = (...r) => e.check(/* @__PURE__ */ uD(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ md(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ pU(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ hU(r)), e.trim = () => e.check(/* @__PURE__ */ bU()), e.normalize = (...r) => e.check(/* @__PURE__ */ yU(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ _U()), e.toUpperCase = () => e.check(/* @__PURE__ */ wU()), e.slugify = () => e.check(/* @__PURE__ */ xU());
}), bK = /* @__PURE__ */ ae("ZodString", (e, t) => {
  Ab.init(e, t), hD.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ NB(_K, n)), e.url = (n) => e.check(/* @__PURE__ */ zB(wK, n)), e.jwt = (n) => e.check(/* @__PURE__ */ eU(MK, n)), e.emoji = (n) => e.check(/* @__PURE__ */ LB(xK, n)), e.guid = (n) => e.check(/* @__PURE__ */ xx($x, n)), e.uuid = (n) => e.check(/* @__PURE__ */ RB(Jc, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ MB(Jc, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ jB(Jc, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ FB(Jc, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ VB(EK, n)), e.guid = (n) => e.check(/* @__PURE__ */ xx($x, n)), e.cuid = (n) => e.check(/* @__PURE__ */ BB(SK, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ UB(OK, n)), e.ulid = (n) => e.check(/* @__PURE__ */ KB($K, n)), e.base64 = (n) => e.check(/* @__PURE__ */ QB(IK, n)), e.base64url = (n) => e.check(/* @__PURE__ */ JB(NK, n)), e.xid = (n) => e.check(/* @__PURE__ */ qB(TK, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ HB(kK, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ WB(PK, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ ZB(DK, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ GB(AK, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ YB(CK, n)), e.e164 = (n) => e.check(/* @__PURE__ */ XB(RK, n)), e.datetime = (n) => e.check(XU(n)), e.date = (n) => e.check(tK(n)), e.time = (n) => e.check(rK(n)), e.duration = (n) => e.check(oK(n));
});
function je(e) {
  return /* @__PURE__ */ IB(bK, e);
}
const Ut = /* @__PURE__ */ ae("ZodStringFormat", (e, t) => {
  jt.init(e, t), hD.init(e, t);
}), _K = /* @__PURE__ */ ae("ZodEmail", (e, t) => {
  FV.init(e, t), Ut.init(e, t);
}), $x = /* @__PURE__ */ ae("ZodGUID", (e, t) => {
  MV.init(e, t), Ut.init(e, t);
}), Jc = /* @__PURE__ */ ae("ZodUUID", (e, t) => {
  jV.init(e, t), Ut.init(e, t);
}), wK = /* @__PURE__ */ ae("ZodURL", (e, t) => {
  zV.init(e, t), Ut.init(e, t);
}), xK = /* @__PURE__ */ ae("ZodEmoji", (e, t) => {
  LV.init(e, t), Ut.init(e, t);
}), EK = /* @__PURE__ */ ae("ZodNanoID", (e, t) => {
  VV.init(e, t), Ut.init(e, t);
}), SK = /* @__PURE__ */ ae("ZodCUID", (e, t) => {
  BV.init(e, t), Ut.init(e, t);
}), OK = /* @__PURE__ */ ae("ZodCUID2", (e, t) => {
  UV.init(e, t), Ut.init(e, t);
}), $K = /* @__PURE__ */ ae("ZodULID", (e, t) => {
  KV.init(e, t), Ut.init(e, t);
}), TK = /* @__PURE__ */ ae("ZodXID", (e, t) => {
  qV.init(e, t), Ut.init(e, t);
}), kK = /* @__PURE__ */ ae("ZodKSUID", (e, t) => {
  HV.init(e, t), Ut.init(e, t);
}), PK = /* @__PURE__ */ ae("ZodIPv4", (e, t) => {
  QV.init(e, t), Ut.init(e, t);
}), DK = /* @__PURE__ */ ae("ZodIPv6", (e, t) => {
  JV.init(e, t), Ut.init(e, t);
}), AK = /* @__PURE__ */ ae("ZodCIDRv4", (e, t) => {
  XV.init(e, t), Ut.init(e, t);
}), CK = /* @__PURE__ */ ae("ZodCIDRv6", (e, t) => {
  eB.init(e, t), Ut.init(e, t);
}), IK = /* @__PURE__ */ ae("ZodBase64", (e, t) => {
  tB.init(e, t), Ut.init(e, t);
}), NK = /* @__PURE__ */ ae("ZodBase64URL", (e, t) => {
  rB.init(e, t), Ut.init(e, t);
}), RK = /* @__PURE__ */ ae("ZodE164", (e, t) => {
  iB.init(e, t), Ut.init(e, t);
}), MK = /* @__PURE__ */ ae("ZodJWT", (e, t) => {
  aB.init(e, t), Ut.init(e, t);
}), Cb = /* @__PURE__ */ ae("ZodNumber", (e, t) => {
  iD.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => DU(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ Sx(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ $f(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ $f(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ Ex(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ Of(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Of(r, i)), e.int = (r) => e.check(Jm(r)), e.safe = (r) => e.check(Jm(r)), e.positive = (r) => e.check(/* @__PURE__ */ Sx(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ $f(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ Ex(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ Of(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ Ox(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ Ox(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function ca(e) {
  return /* @__PURE__ */ oU(Cb, e);
}
const jK = /* @__PURE__ */ ae("ZodNumberFormat", (e, t) => {
  sB.init(e, t), Cb.init(e, t);
});
function Jm(e) {
  return /* @__PURE__ */ sU(jK, e);
}
const FK = /* @__PURE__ */ ae("ZodBoolean", (e, t) => {
  lB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => AU(e, n, r);
});
function fn(e) {
  return /* @__PURE__ */ lU(FK, e);
}
const zK = /* @__PURE__ */ ae("ZodUnknown", (e, t) => {
  uB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => IU();
});
function Tx() {
  return /* @__PURE__ */ uU(zK);
}
const LK = /* @__PURE__ */ ae("ZodNever", (e, t) => {
  cB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => CU(e, n, r);
});
function VK(e) {
  return /* @__PURE__ */ cU(LK, e);
}
const BK = /* @__PURE__ */ ae("ZodDate", (e, t) => {
  fB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => NU(e, r), e.min = (r, i) => e.check(/* @__PURE__ */ $f(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Of(r, i));
  const n = e._zod.bag;
  e.minDate = n.minimum ? new Date(n.minimum) : null, e.maxDate = n.maximum ? new Date(n.maximum) : null;
});
function UK(e) {
  return /* @__PURE__ */ fU(BK, e);
}
const KK = /* @__PURE__ */ ae("ZodArray", (e, t) => {
  dB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => zU(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ md(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ md(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ lD(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ uD(n, r)), e.unwrap = () => e.element;
});
function qn(e, t) {
  return /* @__PURE__ */ EU(KK, e, t);
}
const qK = /* @__PURE__ */ ae("ZodObject", (e, t) => {
  hB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => LU(e, n, r, i), nt(e, "shape", () => t.shape), e.keyof = () => vD(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Tx() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Tx() }), e.strict = () => e.clone({ ...e._zod.def, catchall: VK() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => N7(e, n), e.safeExtend = (n) => R7(e, n), e.merge = (n) => M7(e, n), e.pick = (n) => C7(e, n), e.omit = (n) => I7(e, n), e.partial = (...n) => j7(mD, e, n[0]), e.required = (...n) => F7(gD, e, n[0]);
});
function Xe(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Be(t)
  };
  return new qK(n);
}
const HK = /* @__PURE__ */ ae("ZodUnion", (e, t) => {
  vB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => VU(e, n, r, i), e.options = t.options;
});
function Ra(e, t) {
  return new HK({
    type: "union",
    options: e,
    ...Be(t)
  });
}
const WK = /* @__PURE__ */ ae("ZodIntersection", (e, t) => {
  mB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => BU(e, n, r, i);
});
function ZK(e, t) {
  return new WK({
    type: "intersection",
    left: e,
    right: t
  });
}
const GK = /* @__PURE__ */ ae("ZodRecord", (e, t) => {
  gB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => UU(e, n, r, i), e.keyType = t.keyType, e.valueType = t.valueType;
});
function yd(e, t, n) {
  return new GK({
    type: "record",
    keyType: e,
    valueType: t,
    ...Be(n)
  });
}
const Xm = /* @__PURE__ */ ae("ZodEnum", (e, t) => {
  yB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (r, i, o) => RU(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new Xm({
      ...t,
      checks: [],
      ...Be(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new Xm({
      ...t,
      checks: [],
      ...Be(i),
      entries: o
    });
  };
});
function vD(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new Xm({
    type: "enum",
    entries: n,
    ...Be(t)
  });
}
const YK = /* @__PURE__ */ ae("ZodLiteral", (e, t) => {
  bB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => MU(e, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function Hn(e, t) {
  return new YK({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...Be(t)
  });
}
const QK = /* @__PURE__ */ ae("ZodTransform", (e, t) => {
  _B.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => FU(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new BP(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Nu(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Nu(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function JK(e) {
  return new QK({
    type: "transform",
    transform: e
  });
}
const mD = /* @__PURE__ */ ae("ZodOptional", (e, t) => {
  sD.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => pD(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function kx(e) {
  return new mD({
    type: "optional",
    innerType: e
  });
}
const XK = /* @__PURE__ */ ae("ZodExactOptional", (e, t) => {
  wB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => pD(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function eq(e) {
  return new XK({
    type: "optional",
    innerType: e
  });
}
const tq = /* @__PURE__ */ ae("ZodNullable", (e, t) => {
  xB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => KU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Px(e) {
  return new tq({
    type: "nullable",
    innerType: e
  });
}
const nq = /* @__PURE__ */ ae("ZodDefault", (e, t) => {
  EB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => HU(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function rq(e, t) {
  return new nq({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : HP(t);
    }
  });
}
const iq = /* @__PURE__ */ ae("ZodPrefault", (e, t) => {
  SB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => WU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function oq(e, t) {
  return new iq({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : HP(t);
    }
  });
}
const gD = /* @__PURE__ */ ae("ZodNonOptional", (e, t) => {
  OB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => qU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function aq(e, t) {
  return new gD({
    type: "nonoptional",
    innerType: e,
    ...Be(t)
  });
}
const sq = /* @__PURE__ */ ae("ZodCatch", (e, t) => {
  $B.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => ZU(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function lq(e, t) {
  return new sq({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const uq = /* @__PURE__ */ ae("ZodPipe", (e, t) => {
  TB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => GU(e, n, r, i), e.in = t.in, e.out = t.out;
});
function Dx(e, t) {
  return new uq({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const cq = /* @__PURE__ */ ae("ZodReadonly", (e, t) => {
  kB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => YU(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function fq(e) {
  return new cq({
    type: "readonly",
    innerType: e
  });
}
const dq = /* @__PURE__ */ ae("ZodLazy", (e, t) => {
  PB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => QU(e, n, r, i), e.unwrap = () => e._zod.def.getter();
});
function Ib(e) {
  return new dq({
    type: "lazy",
    getter: e
  });
}
const pq = /* @__PURE__ */ ae("ZodCustom", (e, t) => {
  DB.init(e, t), Ct.init(e, t), e._zod.processJSONSchema = (n, r, i) => jU(e, n);
});
function hq(e, t = {}) {
  return /* @__PURE__ */ SU(pq, e, t);
}
function vq(e) {
  return /* @__PURE__ */ OU(e);
}
function mq(e) {
  return /* @__PURE__ */ aU(Cb, e);
}
const gq = Xe({
  _type: Hn("string"),
  _validation: je().optional(),
  _value: je().optional(),
  _optional: fn().optional()
}), yq = Xe({
  _type: Hn("boolean"),
  _value: fn().optional(),
  _optional: fn().optional()
}), bq = Xe({
  _type: Hn("selection"),
  _options: qn(je()),
  _optional: fn().optional(),
  _value: je().optional()
}), yD = Xe({
  bucketId: ca(),
  isFolder: fn(),
  path: je()
}), _q = vD(An), ga = Ib(
  () => Ra([
    Eq,
    wq,
    bq,
    gq,
    xq,
    yq
  ])
), wq = Xe({
  _type: Hn("path"),
  _value: Ra([qn(yD), qn(je())]).optional(),
  // _value: z.array(s3PathSchema).optional(),
  _regexp: je().optional(),
  _optional: fn().optional(),
  _pathType: _q
}), xq = Ib(
  () => Xe({
    _type: Hn("list"),
    _value: qn(ga).optional(),
    _optional: fn().optional(),
    _schema: ga
  })
), Eq = Ib(
  () => Xe({
    _type: Hn("object"),
    _optional: fn().optional(),
    _fields: yd(je(), ga),
    _value: yd(je(), ga).optional(),
    _order: qn(je()).optional()
  })
);
yd(
  mq(),
  ga
);
yd(
  je(),
  ga
);
const Sq = Xe({
  type: Hn("pattern"),
  pattern: je()
}), Oq = Xe({
  type: Hn("value"),
  value: Ra([je(), ca(), fn(), qn(yD)])
}), $q = Xe({
  type: Hn("code"),
  codeBase64: je()
}), Tq = Ra([
  Sq,
  Oq,
  $q
]);
ga.and(
  Xe({
    _actionData: Tq.optional()
  })
);
const bD = Xe({
  permissions: je(),
  links: je(),
  owner: je(),
  group: je(),
  size: je(),
  month: je(),
  date: je(),
  yearOrTime: je(),
  name: je(),
  fullPath: je()
}), kq = qn(bD);
Xe({
  url: je()
});
Xe({
  socketId: je(),
  hasSavedSession: fn().nullish()
});
Xe({
  path: je()
});
Xe({
  directory: je(),
  contents: kq
});
Xe({
  syncPwd: fn()
});
Xe({
  defaultDirectory: je(),
  termState: je().nullish()
});
Xe({
  path: je()
});
Xe({
  query: je()
});
Xe({
  results: qn(bD),
  date: je(),
  query: je()
});
Xe({
  tinkerBoxId: ca(),
  rows: ca(),
  cols: ca(),
  syncPwd: fn().nullish()
});
Xe({
  path: je()
});
Xe({
  path: je()
});
Xe({
  termState: je()
});
const Pq = Xe({
  name: je(),
  type: Hn("select"),
  options: qn(je()),
  optional: fn().optional(),
  allowOther: fn().optional(),
  validate: je().optional(),
  question: je().optional()
}), Dq = Xe({
  name: je(),
  type: Ra([Hn("text"), Hn("textarea")]),
  optional: fn().optional(),
  validate: je().optional(),
  question: je().optional()
}), Aq = Xe({
  name: je(),
  type: Hn("email"),
  optional: fn().optional(),
  validate: je().optional(),
  question: je().optional()
}), Cq = Xe({
  name: je(),
  type: Hn("submit"),
  text: je().optional(),
  optional: fn().optional(),
  validate: je().optional(),
  question: je().optional()
});
qn(
  Xe({
    name: je(),
    value: je()
  })
);
Ra([
  Pq,
  Dq,
  Aq,
  Cq
]);
const Iq = Xe({
  id: ca(),
  name: je(),
  labId: ca(),
  status: je(),
  ipAddress: je().nullable(),
  lastLogin: UK().nullable()
});
Xe({
  tinkerboxes: qn(Iq)
});
const Nq = Xe({
  key: je(),
  name: je(),
  isFolder: fn(),
  bucket: je(),
  fullPath: je()
});
Xe({
  contents: qn(Nq)
});
Xe({
  buckets: qn(
    Xe({
      id: Jm(),
      bucket: je(),
      region: je(),
      prefix: je().nullish()
    })
  )
});
var Rq = {
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function(t, n) {
    return "Cannot apply '" + t + "' to '" + n.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function(t, n) {
    return "[mobx.array] Index out of bounds, " + t + " is larger than " + n;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function(t) {
    return "Cannot initialize from classes that inherit from Map: " + t.constructor.name;
  },
  20: function(t) {
    return "Cannot initialize map from " + t;
  },
  21: function(t) {
    return "Cannot convert to map from '" + t + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function(t) {
    return "Cannot obtain administration from " + t;
  },
  25: function(t, n) {
    return "the entry '" + t + "' does not exist in the observable map '" + n + "'";
  },
  26: "please specify a property",
  27: function(t, n) {
    return "no observable property '" + t.toString() + "' found on the observable object '" + n + "'";
  },
  28: function(t) {
    return "Cannot obtain atom from " + t;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function(t, n) {
    return "Cycle detected in computation " + t + ": " + n;
  },
  33: function(t) {
    return "The setter of computed value '" + t + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function(t) {
    return "[ComputedValue '" + t + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function(t) {
    return "[mobx] `observableArray." + t + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + t + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}, Mq = process.env.NODE_ENV !== "production" ? Rq : {};
function Te(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var i = typeof e == "string" ? e : Mq[e];
    throw typeof i == "function" && (i = i.apply(null, n)), new Error("[MobX] " + i);
  }
  throw new Error(typeof e == "number" ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
}
var jq = {};
function xp() {
  return typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : jq;
}
var _D = Object.assign, bd = Object.getOwnPropertyDescriptor, xi = Object.defineProperty, Ep = Object.prototype, _d = [];
Object.freeze(_d);
var wD = {};
Object.freeze(wD);
var Fq = typeof Proxy < "u", zq = /* @__PURE__ */ Object.toString();
function xD() {
  Fq || Te(process.env.NODE_ENV !== "production" ? "`Proxy` objects are not available in the current environment. Please configure MobX to enable a fallback implementation.`" : "Proxy not available");
}
function Il(e) {
  process.env.NODE_ENV !== "production" && me.verifyProxies && Te("MobX is currently configured to be able to run in ES5 mode, but in ES5 MobX won't be able to " + e);
}
function ri() {
  return ++me.mobxGuid;
}
function Nb(e) {
  var t = !1;
  return function() {
    if (!t)
      return t = !0, e.apply(this, arguments);
  };
}
var us = function() {
};
function un(e) {
  return typeof e == "function";
}
function ya(e) {
  var t = typeof e;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return !0;
  }
  return !1;
}
function Sp(e) {
  return e !== null && typeof e == "object";
}
function rr(e) {
  if (!Sp(e))
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t == null)
    return !0;
  var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n.toString() === zq;
}
function ED(e) {
  var t = e?.constructor;
  return t ? t.name === "GeneratorFunction" || t.displayName === "GeneratorFunction" : !1;
}
function cc(e, t, n) {
  xi(e, t, {
    enumerable: !1,
    writable: !0,
    configurable: !0,
    value: n
  });
}
function SD(e, t, n) {
  xi(e, t, {
    enumerable: !1,
    writable: !1,
    configurable: !0,
    value: n
  });
}
function Ma(e, t) {
  var n = "isMobX" + e;
  return t.prototype[n] = !0, function(r) {
    return Sp(r) && r[n] === !0;
  };
}
function sl(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Map]";
}
function Lq(e) {
  var t = Object.getPrototypeOf(e), n = Object.getPrototypeOf(t), r = Object.getPrototypeOf(n);
  return r === null;
}
function Ii(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Set]";
}
var OD = typeof Object.getOwnPropertySymbols < "u";
function Vq(e) {
  var t = Object.keys(e);
  if (!OD)
    return t;
  var n = Object.getOwnPropertySymbols(e);
  return n.length ? [].concat(t, n.filter(function(r) {
    return Ep.propertyIsEnumerable.call(e, r);
  })) : t;
}
var Rs = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : OD ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function eg(e) {
  return typeof e == "string" ? e : typeof e == "symbol" ? e.toString() : new String(e).toString();
}
function $D(e) {
  return e === null ? null : typeof e == "object" ? "" + e : e;
}
function Er(e, t) {
  return Ep.hasOwnProperty.call(e, t);
}
var Bq = Object.getOwnPropertyDescriptors || function(t) {
  var n = {};
  return Rs(t).forEach(function(r) {
    n[r] = bd(t, r);
  }), n;
};
function Jn(e, t) {
  return !!(e & t);
}
function Xn(e, t, n) {
  return n ? e |= t : e &= ~t, e;
}
function Ax(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Uq(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, qq(r.key), r);
  }
}
function ll(e, t, n) {
  return t && Uq(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function cs(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Hq(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function qi() {
  return qi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qi.apply(null, arguments);
}
function TD(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, tg(e, t);
}
function tg(e, t) {
  return tg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, tg(e, t);
}
function Kq(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function qq(e) {
  var t = Kq(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Hq(e, t) {
  if (e) {
    if (typeof e == "string") return Ax(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ax(e, t) : void 0;
  }
}
var Vn = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function Ei(e) {
  function t(n, r) {
    if (dc(r))
      return e.decorate_20223_(n, r);
    fc(n, r, e);
  }
  return Object.assign(t, e);
}
function fc(e, t, n) {
  if (Er(e, Vn) || cc(e, Vn, qi({}, e[Vn])), process.env.NODE_ENV !== "production" && xd(n) && !Er(e[Vn], t)) {
    var r = e.constructor.name + ".prototype." + t.toString();
    Te("'" + r + "' is decorated with 'override', but no such decorated member was found on prototype.");
  }
  Wq(e, n, t), xd(n) || (e[Vn][t] = n);
}
function Wq(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !xd(t) && Er(e[Vn], n)) {
    var r = e.constructor.name + ".prototype." + n.toString(), i = e[Vn][n].annotationType_, o = t.annotationType_;
    Te("Cannot apply '@" + o + "' to '" + r + "':" + (`
The field is already decorated with '@` + i + "'.") + `
Re-decorating fields is not allowed.
Use '@override' decorator for methods overridden by subclass.`);
  }
}
function Zq(e) {
  return Er(e, Vn) || cc(e, Vn, qi({}, e[Vn])), e[Vn];
}
function dc(e) {
  return typeof e == "object" && typeof e.kind == "string";
}
function Op(e, t) {
  process.env.NODE_ENV !== "production" && !t.includes(e.kind) && Te("The decorator applied to '" + String(e.name) + "' cannot be used on a " + e.kind + " element");
}
var qe = /* @__PURE__ */ Symbol("mobx administration"), Fo = /* @__PURE__ */ (function() {
  function e(n) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Atom@" + ri() : "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = /* @__PURE__ */ new Set(), this.lastAccessedBy_ = 0, this.lowestObserverState_ = ot.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = n;
  }
  var t = e.prototype;
  return t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.reportObserved = function() {
    return UD(this);
  }, t.reportChanged = function() {
    br(), KD(this), _r();
  }, t.toString = function() {
    return this.name_;
  }, ll(e, [{
    key: "isBeingObserved",
    get: function() {
      return Jn(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return Jn(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return Jn(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Fo.isBeingObservedMask_ = 1;
Fo.isPendingUnobservationMask_ = 2;
Fo.diffValueMask_ = 4;
var Rb = /* @__PURE__ */ Ma("Atom", Fo);
function kD(e, t, n) {
  t === void 0 && (t = us), n === void 0 && (n = us);
  var r = new Fo(e);
  return t !== us && lW(r, t), n !== us && YD(r, n), r;
}
function Gq(e, t) {
  return u4(e, t);
}
function Yq(e, t) {
  return Object.is ? Object.is(e, t) : e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var wd = {
  structural: Gq,
  default: Yq
};
function ba(e, t, n) {
  return ju(e) ? e : Array.isArray(e) ? ln.array(e, {
    name: n
  }) : rr(e) ? ln.object(e, void 0, {
    name: n
  }) : sl(e) ? ln.map(e, {
    name: n
  }) : Ii(e) ? ln.set(e, {
    name: n
  }) : typeof e == "function" && !xa(e) && !Mu(e) ? ED(e) ? Ms(e) : Ru(n, e) : e;
}
function Qq(e, t, n) {
  if (e == null || ul(e) || Cp(e) || zo(e) || mi(e))
    return e;
  if (Array.isArray(e))
    return ln.array(e, {
      name: n,
      deep: !1
    });
  if (rr(e))
    return ln.object(e, void 0, {
      name: n,
      deep: !1
    });
  if (sl(e))
    return ln.map(e, {
      name: n,
      deep: !1
    });
  if (Ii(e))
    return ln.set(e, {
      name: n,
      deep: !1
    });
  process.env.NODE_ENV !== "production" && Te("The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function $p(e) {
  return e;
}
function Jq(e, t) {
  return process.env.NODE_ENV !== "production" && ju(e) && Te("observable.struct should not be used with observable values"), u4(e, t) ? t : e;
}
var Xq = "override";
function xd(e) {
  return e.annotationType_ === Xq;
}
function pc(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: eH,
    extend_: tH,
    decorate_20223_: nH
  };
}
function eH(e, t, n, r) {
  var i;
  if ((i = this.options_) != null && i.bound)
    return this.extend_(e, t, n, !1) === null ? 0 : 1;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if (xa(n.value))
    return 1;
  var o = PD(e, this, t, n, !1);
  return xi(r, t, o), 2;
}
function tH(e, t, n, r) {
  var i = PD(e, this, t, n);
  return e.defineProperty_(t, i, r);
}
function nH(e, t) {
  process.env.NODE_ENV !== "production" && Op(t, ["method", "field"]);
  var n = t.kind, r = t.name, i = t.addInitializer, o = this, a = function(u) {
    var c, f, d, p;
    return _a((c = (f = o.options_) == null ? void 0 : f.name) != null ? c : r.toString(), u, (d = (p = o.options_) == null ? void 0 : p.autoAction) != null ? d : !1);
  };
  if (n == "field")
    return function(l) {
      var u, c = l;
      return xa(c) || (c = a(c)), (u = o.options_) != null && u.bound && (c = c.bind(this), c.isMobxAction = !0), c;
    };
  if (n == "method") {
    var s;
    return xa(e) || (e = a(e)), (s = this.options_) != null && s.bound && i(function() {
      var l = this, u = l[r].bind(l);
      u.isMobxAction = !0, l[r] = u;
    }), e;
  }
  Te("Cannot apply '" + o.annotationType_ + "' to '" + String(r) + "' (kind: " + n + "):" + (`
'` + o.annotationType_ + "' can only be used on properties with a function value."));
}
function rH(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !un(o) && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a function value."));
}
function PD(e, t, n, r, i) {
  var o, a, s, l, u, c, f;
  i === void 0 && (i = me.safeDescriptors), rH(e, t, n, r);
  var d = r.value;
  if ((o = t.options_) != null && o.bound) {
    var p;
    d = d.bind((p = e.proxy_) != null ? p : e.target_);
  }
  return {
    value: _a(
      (a = (s = t.options_) == null ? void 0 : s.name) != null ? a : n.toString(),
      d,
      (l = (u = t.options_) == null ? void 0 : u.autoAction) != null ? l : !1,
      // https://github.com/mobxjs/mobx/discussions/3140
      (c = t.options_) != null && c.bound ? (f = e.proxy_) != null ? f : e.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: i ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !i
  };
}
function DD(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: iH,
    extend_: oH,
    decorate_20223_: aH
  };
}
function iH(e, t, n, r) {
  var i;
  if (r === e.target_)
    return this.extend_(e, t, n, !1) === null ? 0 : 2;
  if ((i = this.options_) != null && i.bound && (!Er(e.target_, t) || !Mu(e.target_[t])) && this.extend_(e, t, n, !1) === null)
    return 0;
  if (Mu(n.value))
    return 1;
  var o = AD(e, this, t, n, !1, !1);
  return xi(r, t, o), 2;
}
function oH(e, t, n, r) {
  var i, o = AD(e, this, t, n, (i = this.options_) == null ? void 0 : i.bound);
  return e.defineProperty_(t, o, r);
}
function aH(e, t) {
  var n;
  process.env.NODE_ENV !== "production" && Op(t, ["method"]);
  var r = t.name, i = t.addInitializer;
  return Mu(e) || (e = Ms(e)), (n = this.options_) != null && n.bound && i(function() {
    var o = this, a = o[r].bind(o);
    a.isMobXFlow = !0, o[r] = a;
  }), e;
}
function sH(e, t, n, r) {
  var i = t.annotationType_, o = r.value;
  process.env.NODE_ENV !== "production" && !un(o) && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on properties with a generator function value."));
}
function AD(e, t, n, r, i, o) {
  o === void 0 && (o = me.safeDescriptors), sH(e, t, n, r);
  var a = r.value;
  if (Mu(a) || (a = Ms(a)), i) {
    var s;
    a = a.bind((s = e.proxy_) != null ? s : e.target_), a.isMobXFlow = !0;
  }
  return {
    value: a,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: o ? e.isPlainObject_ : !0,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: !1,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: !o
  };
}
function Mb(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: lH,
    extend_: uH,
    decorate_20223_: cH
  };
}
function lH(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function uH(e, t, n, r) {
  return fH(e, this, t, n), e.defineComputedProperty_(t, qi({}, this.options_, {
    get: n.get,
    set: n.set
  }), r);
}
function cH(e, t) {
  process.env.NODE_ENV !== "production" && Op(t, ["getter"]);
  var n = this, r = t.name, i = t.addInitializer;
  return i(function() {
    var o = Fa(this)[qe], a = qi({}, n.options_, {
      get: e,
      context: this
    });
    a.name || (a.name = process.env.NODE_ENV !== "production" ? o.name_ + "." + r.toString() : "ObservableObject." + r.toString()), o.values_.set(r, new Tr(a));
  }), function() {
    return this[qe].getObservablePropValue_(r);
  };
}
function fH(e, t, n, r) {
  var i = t.annotationType_, o = r.get;
  process.env.NODE_ENV !== "production" && !o && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' can only be used on getter(+setter) properties."));
}
function Tp(e, t) {
  return {
    annotationType_: e,
    options_: t,
    make_: dH,
    extend_: pH,
    decorate_20223_: hH
  };
}
function dH(e, t, n) {
  return this.extend_(e, t, n, !1) === null ? 0 : 1;
}
function pH(e, t, n, r) {
  var i, o;
  return vH(e, this, t, n), e.defineObservableProperty_(t, n.value, (i = (o = this.options_) == null ? void 0 : o.enhancer) != null ? i : ba, r);
}
function hH(e, t) {
  if (process.env.NODE_ENV !== "production") {
    if (t.kind === "field")
      throw Te("Please use `@observable accessor " + String(t.name) + "` instead of `@observable " + String(t.name) + "`");
    Op(t, ["accessor"]);
  }
  var n = this, r = t.kind, i = t.name, o = /* @__PURE__ */ new WeakSet();
  function a(s, l) {
    var u, c, f = Fa(s)[qe], d = new fa(l, (u = (c = n.options_) == null ? void 0 : c.enhancer) != null ? u : ba, process.env.NODE_ENV !== "production" ? f.name_ + "." + i.toString() : "ObservableObject." + i.toString(), !1);
    f.values_.set(i, d), o.add(s);
  }
  if (r == "accessor")
    return {
      get: function() {
        return o.has(this) || a(this, e.get.call(this)), this[qe].getObservablePropValue_(i);
      },
      set: function(l) {
        return o.has(this) || a(this, l), this[qe].setObservablePropValue_(i, l);
      },
      init: function(l) {
        return o.has(this) || a(this, l), l;
      }
    };
}
function vH(e, t, n, r) {
  var i = t.annotationType_;
  process.env.NODE_ENV !== "production" && !("value" in r) && Te("Cannot apply '" + i + "' to '" + e.name_ + "." + n.toString() + "':" + (`
'` + i + "' cannot be used on getter/setter properties"));
}
var mH = "true", gH = /* @__PURE__ */ CD();
function CD(e) {
  return {
    annotationType_: mH,
    options_: e,
    make_: yH,
    extend_: bH,
    decorate_20223_: _H
  };
}
function yH(e, t, n, r) {
  var i, o;
  if (n.get)
    return kp.make_(e, t, n, r);
  if (n.set) {
    var a = xa(n.set) ? n.set : _a(t.toString(), n.set);
    return r === e.target_ ? e.defineProperty_(t, {
      configurable: me.safeDescriptors ? e.isPlainObject_ : !0,
      set: a
    }) === null ? 0 : 2 : (xi(r, t, {
      configurable: !0,
      set: a
    }), 2);
  }
  if (r !== e.target_ && typeof n.value == "function") {
    var s;
    if (ED(n.value)) {
      var l, u = (l = this.options_) != null && l.autoBind ? Ms.bound : Ms;
      return u.make_(e, t, n, r);
    }
    var c = (s = this.options_) != null && s.autoBind ? Ru.bound : Ru;
    return c.make_(e, t, n, r);
  }
  var f = ((i = this.options_) == null ? void 0 : i.deep) === !1 ? ln.ref : ln;
  if (typeof n.value == "function" && (o = this.options_) != null && o.autoBind) {
    var d;
    n.value = n.value.bind((d = e.proxy_) != null ? d : e.target_);
  }
  return f.make_(e, t, n, r);
}
function bH(e, t, n, r) {
  var i, o;
  if (n.get)
    return kp.extend_(e, t, n, r);
  if (n.set)
    return e.defineProperty_(t, {
      configurable: me.safeDescriptors ? e.isPlainObject_ : !0,
      set: _a(t.toString(), n.set)
    }, r);
  if (typeof n.value == "function" && (i = this.options_) != null && i.autoBind) {
    var a;
    n.value = n.value.bind((a = e.proxy_) != null ? a : e.target_);
  }
  var s = ((o = this.options_) == null ? void 0 : o.deep) === !1 ? ln.ref : ln;
  return s.extend_(e, t, n, r);
}
function _H(e, t) {
  Te("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var wH = "observable", xH = "observable.ref", EH = "observable.shallow", SH = "observable.struct", ID = {
  deep: !0,
  name: void 0,
  defaultDecorator: void 0,
  proxy: !0
};
Object.freeze(ID);
function Xc(e) {
  return e || ID;
}
var ng = /* @__PURE__ */ Tp(wH), OH = /* @__PURE__ */ Tp(xH, {
  enhancer: $p
}), $H = /* @__PURE__ */ Tp(EH, {
  enhancer: Qq
}), TH = /* @__PURE__ */ Tp(SH, {
  enhancer: Jq
}), ND = /* @__PURE__ */ Ei(ng);
function ef(e) {
  return e.deep === !0 ? ba : e.deep === !1 ? $p : PH(e.defaultDecorator);
}
function kH(e) {
  var t;
  return e ? (t = e.defaultDecorator) != null ? t : CD(e) : void 0;
}
function PH(e) {
  var t, n;
  return e && (t = (n = e.options_) == null ? void 0 : n.enhancer) != null ? t : ba;
}
function RD(e, t, n) {
  if (dc(t))
    return ng.decorate_20223_(e, t);
  if (ya(t)) {
    fc(e, t, ng);
    return;
  }
  return ju(e) ? e : rr(e) ? ln.object(e, t, n) : Array.isArray(e) ? ln.array(e, t) : sl(e) ? ln.map(e, t) : Ii(e) ? ln.set(e, t) : typeof e == "object" && e !== null ? e : ln.box(e, t);
}
_D(RD, ND);
var DH = {
  box: function(t, n) {
    var r = Xc(n);
    return new fa(t, ef(r), r.name, !0, r.equals);
  },
  array: function(t, n) {
    var r = Xc(n);
    return (me.useProxies === !1 || r.proxy === !1 ? NW : SW)(t, ef(r), r.name);
  },
  map: function(t, n) {
    var r = Xc(n);
    return new r4(t, ef(r), r.name);
  },
  set: function(t, n) {
    var r = Xc(n);
    return new i4(t, ef(r), r.name);
  },
  object: function(t, n, r) {
    return Lo(function() {
      return JD(me.useProxies === !1 || r?.proxy === !1 ? Fa({}, r) : bW({}, r), t, n);
    });
  },
  ref: /* @__PURE__ */ Ei(OH),
  shallow: /* @__PURE__ */ Ei($H),
  deep: ND,
  struct: /* @__PURE__ */ Ei(TH)
}, ln = /* @__PURE__ */ _D(RD, DH), MD = "computed", AH = "computed.struct", rg = /* @__PURE__ */ Mb(MD), CH = /* @__PURE__ */ Mb(AH, {
  equals: wd.structural
}), kp = function(t, n) {
  if (dc(n))
    return rg.decorate_20223_(t, n);
  if (ya(n))
    return fc(t, n, rg);
  if (rr(t))
    return Ei(Mb(MD, t));
  process.env.NODE_ENV !== "production" && (un(t) || Te("First argument to `computed` should be an expression."), un(n) && Te("A setter as second argument is no longer supported, use `{ set: fn }` option instead"));
  var r = rr(n) ? n : {};
  return r.get = t, r.name || (r.name = t.name || ""), new Tr(r);
};
Object.assign(kp, rg);
kp.struct = /* @__PURE__ */ Ei(CH);
var Cx, Ix, Ed = 0, IH = 1, NH = (Cx = (Ix = /* @__PURE__ */ bd(function() {
}, "name")) == null ? void 0 : Ix.configurable) != null ? Cx : !1, Nx = {
  value: "action",
  configurable: !0,
  writable: !1,
  enumerable: !1
};
function _a(e, t, n, r) {
  n === void 0 && (n = !1), process.env.NODE_ENV !== "production" && (un(t) || Te("`action` can only be invoked on functions"), (typeof e != "string" || !e) && Te("actions should have valid names, got: '" + e + "'"));
  function i() {
    return RH(e, n, t, r || this, arguments);
  }
  return i.isMobxAction = !0, i.toString = function() {
    return t.toString();
  }, NH && (Nx.value = e, xi(i, "name", Nx)), i;
}
function RH(e, t, n, r, i) {
  var o = MH(e, t, r, i);
  try {
    return n.apply(r, i);
  } catch (a) {
    throw o.error_ = a, a;
  } finally {
    jH(o);
  }
}
function MH(e, t, n, r) {
  var i = process.env.NODE_ENV !== "production" && vn() && !!e, o = 0;
  if (process.env.NODE_ENV !== "production" && i) {
    o = Date.now();
    var a = r ? Array.from(r) : _d;
    ir({
      type: Fb,
      name: e,
      object: n,
      arguments: a
    });
  }
  var s = me.trackingDerivation, l = !t || !s;
  br();
  var u = me.allowStateChanges;
  l && (ja(), u = Pp(!0));
  var c = jb(!0), f = {
    runAsAction_: l,
    prevDerivation_: s,
    prevAllowStateChanges_: u,
    prevAllowStateReads_: c,
    notifySpy_: i,
    startTime_: o,
    actionId_: IH++,
    parentActionId_: Ed
  };
  return Ed = f.actionId_, f;
}
function jH(e) {
  Ed !== e.actionId_ && Te(30), Ed = e.parentActionId_, e.error_ !== void 0 && (me.suppressReactionErrors = !0), Dp(e.prevAllowStateChanges_), cu(e.prevAllowStateReads_), _r(), e.runAsAction_ && ji(e.prevDerivation_), process.env.NODE_ENV !== "production" && e.notifySpy_ && or({
    time: Date.now() - e.startTime_
  }), me.suppressReactionErrors = !1;
}
function FH(e, t) {
  var n = Pp(e);
  try {
    return t();
  } finally {
    Dp(n);
  }
}
function Pp(e) {
  var t = me.allowStateChanges;
  return me.allowStateChanges = e, t;
}
function Dp(e) {
  me.allowStateChanges = e;
}
var zH = "create", fa = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a, s) {
    var l;
    if (o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableValue@" + ri() : "ObservableValue"), a === void 0 && (a = !0), s === void 0 && (s = wd.default), l = e.call(this, o) || this, l.enhancer = void 0, l.name_ = void 0, l.equals = void 0, l.hasUnreportedChange_ = !1, l.interceptors_ = void 0, l.changeListeners_ = void 0, l.value_ = void 0, l.dehancer = void 0, l.enhancer = i, l.name_ = o, l.equals = s, l.value_ = i(r, void 0, o), process.env.NODE_ENV !== "production" && a && vn()) {
      var u;
      wa({
        type: zH,
        object: l,
        observableKind: "value",
        debugObjectName: l.name_,
        newValue: "" + ((u = l.value_) == null ? void 0 : u.toString())
      });
    }
    return l;
  }
  TD(t, e);
  var n = t.prototype;
  return n.dehanceValue = function(i) {
    return this.dehancer !== void 0 ? this.dehancer(i) : i;
  }, n.set = function(i) {
    var o = this.value_;
    if (i = this.prepareNewValue_(i), i !== me.UNCHANGED) {
      var a = vn();
      process.env.NODE_ENV !== "production" && a && ir({
        type: Wr,
        object: this,
        observableKind: "value",
        debugObjectName: this.name_,
        newValue: i,
        oldValue: o
      }), this.setNewValue_(i), process.env.NODE_ENV !== "production" && a && or();
    }
  }, n.prepareNewValue_ = function(i) {
    if (_i(this), gr(this)) {
      var o = yr(this, {
        object: this,
        type: Wr,
        newValue: i
      });
      if (!o)
        return me.UNCHANGED;
      i = o.newValue;
    }
    return i = this.enhancer(i, this.value_, this.name_), this.equals(this.value_, i) ? me.UNCHANGED : i;
  }, n.setNewValue_ = function(i) {
    var o = this.value_;
    this.value_ = i, this.reportChanged(), Yr(this) && Qr(this, {
      type: Wr,
      object: this,
      newValue: i,
      oldValue: o
    });
  }, n.get = function() {
    return this.reportObserved(), this.dehanceValue(this.value_);
  }, n.intercept_ = function(i) {
    return hc(this, i);
  }, n.observe_ = function(i, o) {
    return o && i({
      observableKind: "value",
      debugObjectName: this.name_,
      object: this,
      type: Wr,
      newValue: this.value_,
      oldValue: void 0
    }), vc(this, i);
  }, n.raw = function() {
    return this.value_;
  }, n.toJSON = function() {
    return this.get();
  }, n.toString = function() {
    return this.name_ + "[" + this.value_ + "]";
  }, n.valueOf = function() {
    return $D(this.get());
  }, n[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, t;
})(Fo), Tr = /* @__PURE__ */ (function() {
  function e(n) {
    this.dependenciesState_ = ot.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = /* @__PURE__ */ new Set(), this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = ot.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Sd(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = Sr.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, n.get || Te(31), this.derivation = n.get, this.name_ = n.name || (process.env.NODE_ENV !== "production" ? "ComputedValue@" + ri() : "ComputedValue"), n.set && (this.setter_ = _a(process.env.NODE_ENV !== "production" ? this.name_ + "-setter" : "ComputedValue-setter", n.set)), this.equals_ = n.equals || (n.compareStructural || n.struct ? wd.structural : wd.default), this.scope_ = n.context, this.requiresReaction_ = n.requiresReaction, this.keepAlive_ = !!n.keepAlive;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    WH(this);
  }, t.onBO = function() {
    this.onBOL && this.onBOL.forEach(function(r) {
      return r();
    });
  }, t.onBUO = function() {
    this.onBUOL && this.onBUOL.forEach(function(r) {
      return r();
    });
  }, t.get = function() {
    if (this.isComputing && Te(32, this.name_, this.derivation), me.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_)
      ig(this) && (this.warnAboutUntrackedRead_(), br(), this.value_ = this.computeValue_(!1), _r());
    else if (UD(this), ig(this)) {
      var r = me.trackingContext;
      this.keepAlive_ && !r && (me.trackingContext = this), this.trackAndCompute() && HH(this), me.trackingContext = r;
    }
    var i = this.value_;
    if (Tf(i))
      throw i.cause;
    return i;
  }, t.set = function(r) {
    if (this.setter_) {
      this.isRunningSetter && Te(33, this.name_), this.isRunningSetter = !0;
      try {
        this.setter_.call(this.scope_, r);
      } finally {
        this.isRunningSetter = !1;
      }
    } else
      Te(34, this.name_);
  }, t.trackAndCompute = function() {
    var r = this.value_, i = (
      /* see #1208 */
      this.dependenciesState_ === ot.NOT_TRACKING_
    ), o = this.computeValue_(!0), a = i || Tf(r) || Tf(o) || !this.equals_(r, o);
    return a && (this.value_ = o, process.env.NODE_ENV !== "production" && vn() && wa({
      observableKind: "computed",
      debugObjectName: this.name_,
      object: this.scope_,
      type: "update",
      oldValue: r,
      newValue: o
    })), a;
  }, t.computeValue_ = function(r) {
    this.isComputing = !0;
    var i = Pp(!1), o;
    if (r)
      o = jD(this, this.derivation, this.scope_);
    else if (me.disableErrorBoundaries === !0)
      o = this.derivation.call(this.scope_);
    else
      try {
        o = this.derivation.call(this.scope_);
      } catch (a) {
        o = new Sd(a);
      }
    return Dp(i), this.isComputing = !1, o;
  }, t.suspend_ = function() {
    this.keepAlive_ || (og(this), this.value_ = void 0, process.env.NODE_ENV !== "production" && this.isTracing_ !== Sr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' was suspended and it will recompute on the next access."));
  }, t.observe_ = function(r, i) {
    var o = this, a = !0, s = void 0;
    return rW(function() {
      var l = o.get();
      if (!a || i) {
        var u = ja();
        r({
          observableKind: "computed",
          debugObjectName: o.name_,
          type: Wr,
          object: o,
          newValue: l,
          oldValue: s
        }), ji(u);
      }
      a = !1, s = l;
    });
  }, t.warnAboutUntrackedRead_ = function() {
    process.env.NODE_ENV !== "production" && (this.isTracing_ !== Sr.NONE && console.log("[mobx.trace] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."), (typeof this.requiresReaction_ == "boolean" ? this.requiresReaction_ : me.computedRequiresReaction) && console.warn("[mobx] Computed value '" + this.name_ + "' is being read outside a reactive context. Doing a full recompute."));
  }, t.toString = function() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  }, t.valueOf = function() {
    return $D(this.get());
  }, t[Symbol.toPrimitive] = function() {
    return this.valueOf();
  }, ll(e, [{
    key: "isComputing",
    get: function() {
      return Jn(this.flags_, e.isComputingMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isComputingMask_, r);
    }
  }, {
    key: "isRunningSetter",
    get: function() {
      return Jn(this.flags_, e.isRunningSetterMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isRunningSetterMask_, r);
    }
  }, {
    key: "isBeingObserved",
    get: function() {
      return Jn(this.flags_, e.isBeingObservedMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isBeingObservedMask_, r);
    }
  }, {
    key: "isPendingUnobservation",
    get: function() {
      return Jn(this.flags_, e.isPendingUnobservationMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isPendingUnobservationMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return Jn(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Tr.isComputingMask_ = 1;
Tr.isRunningSetterMask_ = 2;
Tr.isBeingObservedMask_ = 4;
Tr.isPendingUnobservationMask_ = 8;
Tr.diffValueMask_ = 16;
var Ap = /* @__PURE__ */ Ma("ComputedValue", Tr), ot;
(function(e) {
  e[e.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e[e.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e[e.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e[e.STALE_ = 2] = "STALE_";
})(ot || (ot = {}));
var Sr;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.LOG = 1] = "LOG", e[e.BREAK = 2] = "BREAK";
})(Sr || (Sr = {}));
var Sd = function(t) {
  this.cause = void 0, this.cause = t;
};
function Tf(e) {
  return e instanceof Sd;
}
function ig(e) {
  switch (e.dependenciesState_) {
    case ot.UP_TO_DATE_:
      return !1;
    case ot.NOT_TRACKING_:
    case ot.STALE_:
      return !0;
    case ot.POSSIBLY_STALE_: {
      for (var t = jb(!0), n = ja(), r = e.observing_, i = r.length, o = 0; o < i; o++) {
        var a = r[o];
        if (Ap(a)) {
          if (me.disableErrorBoundaries)
            a.get();
          else
            try {
              a.get();
            } catch {
              return ji(n), cu(t), !0;
            }
          if (e.dependenciesState_ === ot.STALE_)
            return ji(n), cu(t), !0;
        }
      }
      return zD(e), ji(n), cu(t), !1;
    }
  }
}
function _i(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = e.observers_.size > 0;
    !me.allowStateChanges && (t || me.enforceActions === "always") && console.warn("[MobX] " + (me.enforceActions ? "Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed. Tried to modify: " : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, a computed value or the render function of a React component? You can wrap side effects in 'runInAction' (or decorate functions with 'action') if needed. Tried to modify: ") + e.name_);
  }
}
function LH(e) {
  process.env.NODE_ENV !== "production" && !me.allowStateReads && me.observableRequiresReaction && console.warn("[mobx] Observable '" + e.name_ + "' being read outside a reactive context.");
}
function jD(e, t, n) {
  var r = jb(!0);
  zD(e), e.newObserving_ = new Array(
    // Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    e.runId_ === 0 ? 100 : e.observing_.length
  ), e.unboundDepsCount_ = 0, e.runId_ = ++me.runId;
  var i = me.trackingDerivation;
  me.trackingDerivation = e, me.inBatch++;
  var o;
  if (me.disableErrorBoundaries === !0)
    o = t.call(n);
  else
    try {
      o = t.call(n);
    } catch (a) {
      o = new Sd(a);
    }
  return me.inBatch--, me.trackingDerivation = i, BH(e), VH(e), cu(r), o;
}
function VH(e) {
  process.env.NODE_ENV !== "production" && e.observing_.length === 0 && (typeof e.requiresObservable_ == "boolean" ? e.requiresObservable_ : me.reactionRequiresObservable) && console.warn("[mobx] Derivation '" + e.name_ + "' is created/updated without reading any observable value.");
}
function BH(e) {
  for (var t = e.observing_, n = e.observing_ = e.newObserving_, r = ot.UP_TO_DATE_, i = 0, o = e.unboundDepsCount_, a = 0; a < o; a++) {
    var s = n[a];
    s.diffValue === 0 && (s.diffValue = 1, i !== a && (n[i] = s), i++), s.dependenciesState_ > r && (r = s.dependenciesState_);
  }
  for (n.length = i, e.newObserving_ = null, o = t.length; o--; ) {
    var l = t[o];
    l.diffValue === 0 && VD(l, e), l.diffValue = 0;
  }
  for (; i--; ) {
    var u = n[i];
    u.diffValue === 1 && (u.diffValue = 0, qH(u, e));
  }
  r !== ot.UP_TO_DATE_ && (e.dependenciesState_ = r, e.onBecomeStale_());
}
function og(e) {
  var t = e.observing_;
  e.observing_ = [];
  for (var n = t.length; n--; )
    VD(t[n], e);
  e.dependenciesState_ = ot.NOT_TRACKING_;
}
function FD(e) {
  var t = ja();
  try {
    return e();
  } finally {
    ji(t);
  }
}
function ja() {
  var e = me.trackingDerivation;
  return me.trackingDerivation = null, e;
}
function ji(e) {
  me.trackingDerivation = e;
}
function jb(e) {
  var t = me.allowStateReads;
  return me.allowStateReads = e, t;
}
function cu(e) {
  me.allowStateReads = e;
}
function zD(e) {
  if (e.dependenciesState_ !== ot.UP_TO_DATE_) {
    e.dependenciesState_ = ot.UP_TO_DATE_;
    for (var t = e.observing_, n = t.length; n--; )
      t[n].lowestObserverState_ = ot.UP_TO_DATE_;
  }
}
var kf = function() {
  this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
}, Pf = !0, LD = !1, me = /* @__PURE__ */ (function() {
  var e = /* @__PURE__ */ xp();
  return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (Pf = !1), e.__mobxGlobals && e.__mobxGlobals.version !== new kf().version && (Pf = !1), Pf ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = /* @__PURE__ */ new kf()) : (setTimeout(function() {
    LD || Te(35);
  }, 1), new kf());
})();
function UH() {
  if ((me.pendingReactions.length || me.inBatch || me.isRunningReactions) && Te(36), LD = !0, Pf) {
    var e = xp();
    --e.__mobxInstanceCount === 0 && (e.__mobxGlobals = void 0), me = new kf();
  }
}
function KH() {
  return me;
}
function qH(e, t) {
  e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
}
function VD(e, t) {
  e.observers_.delete(t), e.observers_.size === 0 && BD(e);
}
function BD(e) {
  e.isPendingUnobservation === !1 && (e.isPendingUnobservation = !0, me.pendingUnobservations.push(e));
}
function br() {
  me.inBatch++;
}
function _r() {
  if (--me.inBatch === 0) {
    WD();
    for (var e = me.pendingUnobservations, t = 0; t < e.length; t++) {
      var n = e[t];
      n.isPendingUnobservation = !1, n.observers_.size === 0 && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof Tr && n.suspend_());
    }
    me.pendingUnobservations = [];
  }
}
function UD(e) {
  LH(e);
  var t = me.trackingDerivation;
  return t !== null ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && me.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (e.observers_.size === 0 && me.inBatch > 0 && BD(e), !1);
}
function KD(e) {
  e.lowestObserverState_ !== ot.STALE_ && (e.lowestObserverState_ = ot.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === ot.UP_TO_DATE_ && (process.env.NODE_ENV !== "production" && t.isTracing_ !== Sr.NONE && qD(t, e), t.onBecomeStale_()), t.dependenciesState_ = ot.STALE_;
  }));
}
function HH(e) {
  e.lowestObserverState_ !== ot.STALE_ && (e.lowestObserverState_ = ot.STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === ot.POSSIBLY_STALE_ ? (t.dependenciesState_ = ot.STALE_, process.env.NODE_ENV !== "production" && t.isTracing_ !== Sr.NONE && qD(t, e)) : t.dependenciesState_ === ot.UP_TO_DATE_ && (e.lowestObserverState_ = ot.UP_TO_DATE_);
  }));
}
function WH(e) {
  e.lowestObserverState_ === ot.UP_TO_DATE_ && (e.lowestObserverState_ = ot.POSSIBLY_STALE_, e.observers_.forEach(function(t) {
    t.dependenciesState_ === ot.UP_TO_DATE_ && (t.dependenciesState_ = ot.POSSIBLY_STALE_, t.onBecomeStale_());
  }));
}
function qD(e, t) {
  if (console.log("[mobx.trace] '" + e.name_ + "' is invalidated due to a change in: '" + t.name_ + "'"), e.isTracing_ === Sr.BREAK) {
    var n = [];
    HD(XD(e), n, 1), new Function(`debugger;
/*
Tracing '` + e.name_ + `'

You are entering this break point because derivation '` + e.name_ + "' is being traced and '" + t.name_ + `' is now forcing it to update.
Just follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update
The stackframe you are looking for is at least ~6-8 stack-frames up.

` + (e instanceof Tr ? e.derivation.toString().replace(/[*]\//g, "/") : "") + `

The dependencies for this derivation are:

` + n.join(`
`) + `
*/
    `)();
  }
}
function HD(e, t, n) {
  if (t.length >= 1e3) {
    t.push("(and many more)");
    return;
  }
  t.push("" + "	".repeat(n - 1) + e.name), e.dependencies && e.dependencies.forEach(function(r) {
    return HD(r, t, n + 1);
  });
}
var Si = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "Reaction@" + ri() : "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = ot.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = Sr.NONE, this.name_ = n, this.onInvalidate_ = r, this.errorHandler_ = i, this.requiresObservable_ = o;
  }
  var t = e.prototype;
  return t.onBecomeStale_ = function() {
    this.schedule_();
  }, t.schedule_ = function() {
    this.isScheduled || (this.isScheduled = !0, me.pendingReactions.push(this), WD());
  }, t.runReaction_ = function() {
    if (!this.isDisposed) {
      br(), this.isScheduled = !1;
      var r = me.trackingContext;
      if (me.trackingContext = this, ig(this)) {
        this.isTrackPending = !0;
        try {
          this.onInvalidate_(), process.env.NODE_ENV !== "production" && this.isTrackPending && vn() && wa({
            name: this.name_,
            type: "scheduled-reaction"
          });
        } catch (i) {
          this.reportExceptionInDerivation_(i);
        }
      }
      me.trackingContext = r, _r();
    }
  }, t.track = function(r) {
    if (!this.isDisposed) {
      br();
      var i = vn(), o;
      process.env.NODE_ENV !== "production" && i && (o = Date.now(), ir({
        name: this.name_,
        type: "reaction"
      })), this.isRunning = !0;
      var a = me.trackingContext;
      me.trackingContext = this;
      var s = jD(this, r, void 0);
      me.trackingContext = a, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && og(this), Tf(s) && this.reportExceptionInDerivation_(s.cause), process.env.NODE_ENV !== "production" && i && or({
        time: Date.now() - o
      }), _r();
    }
  }, t.reportExceptionInDerivation_ = function(r) {
    var i = this;
    if (this.errorHandler_) {
      this.errorHandler_(r, this);
      return;
    }
    if (me.disableErrorBoundaries)
      throw r;
    var o = process.env.NODE_ENV !== "production" ? "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'" : "[mobx] uncaught error in '" + this + "'";
    me.suppressReactionErrors ? process.env.NODE_ENV !== "production" && console.warn("[mobx] (error in reaction '" + this.name_ + "' suppressed, fix error of causing action below)") : console.error(o, r), process.env.NODE_ENV !== "production" && vn() && wa({
      type: "error",
      name: this.name_,
      message: o,
      error: "" + r
    }), me.globalReactionErrorHandlers.forEach(function(a) {
      return a(r, i);
    });
  }, t.dispose = function() {
    this.isDisposed || (this.isDisposed = !0, this.isRunning || (br(), og(this), _r()));
  }, t.getDisposer_ = function(r) {
    var i = this, o = function a() {
      i.dispose(), r == null || r.removeEventListener == null || r.removeEventListener("abort", a);
    };
    return r == null || r.addEventListener == null || r.addEventListener("abort", o), o[qe] = this, "dispose" in Symbol && typeof Symbol.dispose == "symbol" && (o[Symbol.dispose] = o), o;
  }, t.toString = function() {
    return "Reaction[" + this.name_ + "]";
  }, t.trace = function(r) {
    r === void 0 && (r = !1), mW(this, r);
  }, ll(e, [{
    key: "isDisposed",
    get: function() {
      return Jn(this.flags_, e.isDisposedMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isDisposedMask_, r);
    }
  }, {
    key: "isScheduled",
    get: function() {
      return Jn(this.flags_, e.isScheduledMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isScheduledMask_, r);
    }
  }, {
    key: "isTrackPending",
    get: function() {
      return Jn(this.flags_, e.isTrackPendingMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isTrackPendingMask_, r);
    }
  }, {
    key: "isRunning",
    get: function() {
      return Jn(this.flags_, e.isRunningMask_);
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.isRunningMask_, r);
    }
  }, {
    key: "diffValue",
    get: function() {
      return Jn(this.flags_, e.diffValueMask_) ? 1 : 0;
    },
    set: function(r) {
      this.flags_ = Xn(this.flags_, e.diffValueMask_, r === 1);
    }
  }]);
})();
Si.isDisposedMask_ = 1;
Si.isScheduledMask_ = 2;
Si.isTrackPendingMask_ = 4;
Si.isRunningMask_ = 8;
Si.diffValueMask_ = 16;
var Rx = 100, ag = function(t) {
  return t();
};
function WD() {
  me.inBatch > 0 || me.isRunningReactions || ag(ZH);
}
function ZH() {
  me.isRunningReactions = !0;
  for (var e = me.pendingReactions, t = 0; e.length > 0; ) {
    ++t === Rx && (console.error(process.env.NODE_ENV !== "production" ? "Reaction doesn't converge to a stable state after " + Rx + " iterations." + (" Probably there is a cycle in the reactive function: " + e[0]) : "[mobx] cycle in reaction: " + e[0]), e.splice(0));
    for (var n = e.splice(0), r = 0, i = n.length; r < i; r++)
      n[r].runReaction_();
  }
  me.isRunningReactions = !1;
}
var Od = /* @__PURE__ */ Ma("Reaction", Si);
function GH(e) {
  var t = ag;
  ag = function(r) {
    return e(function() {
      return t(r);
    });
  };
}
function vn() {
  return process.env.NODE_ENV !== "production" && !!me.spyListeners.length;
}
function wa(e) {
  if (process.env.NODE_ENV !== "production" && me.spyListeners.length)
    for (var t = me.spyListeners, n = 0, r = t.length; n < r; n++)
      t[n](e);
}
function ir(e) {
  if (process.env.NODE_ENV !== "production") {
    var t = qi({}, e, {
      spyReportStart: !0
    });
    wa(t);
  }
}
var YH = {
  type: "report-end",
  spyReportEnd: !0
};
function or(e) {
  process.env.NODE_ENV !== "production" && wa(e ? qi({}, e, {
    type: "report-end",
    spyReportEnd: !0
  }) : YH);
}
function QH(e) {
  return process.env.NODE_ENV === "production" ? (console.warn("[mobx.spy] Is a no-op in production builds"), function() {
  }) : (me.spyListeners.push(e), Nb(function() {
    me.spyListeners = me.spyListeners.filter(function(t) {
      return t !== e;
    });
  }));
}
var Fb = "action", JH = "action.bound", ZD = "autoAction", XH = "autoAction.bound", eW = "<unnamed action>", sg = /* @__PURE__ */ pc(Fb), tW = /* @__PURE__ */ pc(JH, {
  bound: !0
}), lg = /* @__PURE__ */ pc(ZD, {
  autoAction: !0
}), nW = /* @__PURE__ */ pc(XH, {
  autoAction: !0,
  bound: !0
});
function GD(e) {
  var t = function(r, i) {
    if (un(r))
      return _a(r.name || eW, r, e);
    if (un(i))
      return _a(r, i, e);
    if (dc(i))
      return (e ? lg : sg).decorate_20223_(r, i);
    if (ya(i))
      return fc(r, i, e ? lg : sg);
    if (ya(r))
      return Ei(pc(e ? ZD : Fb, {
        name: r,
        autoAction: e
      }));
    process.env.NODE_ENV !== "production" && Te("Invalid arguments for `action`");
  };
  return t;
}
var fs = /* @__PURE__ */ GD(!1);
Object.assign(fs, sg);
var Ru = /* @__PURE__ */ GD(!0);
Object.assign(Ru, lg);
fs.bound = /* @__PURE__ */ Ei(tW);
Ru.bound = /* @__PURE__ */ Ei(nW);
function xa(e) {
  return un(e) && e.isMobxAction === !0;
}
function rW(e, t) {
  var n, r, i, o;
  t === void 0 && (t = wD), process.env.NODE_ENV !== "production" && (un(e) || Te("Autorun expects a function as first argument"), xa(e) && Te("Autorun does not accept actions since actions are untrackable"));
  var a = (n = (r = t) == null ? void 0 : r.name) != null ? n : process.env.NODE_ENV !== "production" ? e.name || "Autorun@" + ri() : "Autorun", s = !t.scheduler && !t.delay, l;
  if (s)
    l = new Si(a, function() {
      this.track(f);
    }, t.onError, t.requiresObservable);
  else {
    var u = oW(t), c = !1;
    l = new Si(a, function() {
      c || (c = !0, u(function() {
        c = !1, l.isDisposed || l.track(f);
      }));
    }, t.onError, t.requiresObservable);
  }
  function f() {
    e(l);
  }
  return (i = t) != null && (i = i.signal) != null && i.aborted || l.schedule_(), l.getDisposer_((o = t) == null ? void 0 : o.signal);
}
var iW = function(t) {
  return t();
};
function oW(e) {
  return e.scheduler ? e.scheduler : e.delay ? function(t) {
    return setTimeout(t, e.delay);
  } : iW;
}
var aW = "onBO", sW = "onBUO";
function lW(e, t, n) {
  return QD(aW, e, t, n);
}
function YD(e, t, n) {
  return QD(sW, e, t, n);
}
function QD(e, t, n, r) {
  var i = js(t), o = un(r) ? r : n, a = e + "L";
  return i[a] ? i[a].add(o) : i[a] = /* @__PURE__ */ new Set([o]), function() {
    var s = i[a];
    s && (s.delete(o), s.size === 0 && delete i[a]);
  };
}
var uW = "never", tf = "always", cW = "observed";
function fW(e) {
  e.isolateGlobalState === !0 && UH();
  var t = e.useProxies, n = e.enforceActions;
  if (t !== void 0 && (me.useProxies = t === tf ? !0 : t === uW ? !1 : typeof Proxy < "u"), t === "ifavailable" && (me.verifyProxies = !0), n !== void 0) {
    var r = n === tf ? tf : n === cW;
    me.enforceActions = r, me.allowStateChanges = !(r === !0 || r === tf);
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(i) {
    i in e && (me[i] = !!e[i]);
  }), me.allowStateReads = !me.observableRequiresReaction, process.env.NODE_ENV !== "production" && me.disableErrorBoundaries === !0 && console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."), e.reactionScheduler && GH(e.reactionScheduler);
}
function JD(e, t, n, r) {
  process.env.NODE_ENV !== "production" && (arguments.length > 4 && Te("'extendObservable' expected 2-4 arguments"), typeof e != "object" && Te("'extendObservable' expects an object as first argument"), zo(e) && Te("'extendObservable' should not be used on maps, use map.merge instead"), rr(t) || Te("'extendObservable' only accepts plain objects as second argument"), (ju(t) || ju(n)) && Te("Extending an object with another observable (object) is not supported"));
  var i = Bq(t);
  return Lo(function() {
    var o = Fa(e, r)[qe];
    Rs(i).forEach(function(a) {
      o.extend_(
        a,
        i[a],
        // must pass "undefined" for { key: undefined }
        n && a in n ? n[a] : !0
      );
    });
  }), e;
}
function XD(e, t) {
  return e4(js(e, t));
}
function e4(e) {
  var t = {
    name: e.name_
  };
  return e.observing_ && e.observing_.length > 0 && (t.dependencies = dW(e.observing_).map(e4)), t;
}
function dW(e) {
  return Array.from(new Set(e));
}
var pW = 0;
function t4() {
  this.message = "FLOW_CANCELLED";
}
t4.prototype = /* @__PURE__ */ Object.create(Error.prototype);
var Xh = /* @__PURE__ */ DD("flow"), hW = /* @__PURE__ */ DD("flow.bound", {
  bound: !0
}), Ms = /* @__PURE__ */ Object.assign(function(t, n) {
  if (dc(n))
    return Xh.decorate_20223_(t, n);
  if (ya(n))
    return fc(t, n, Xh);
  process.env.NODE_ENV !== "production" && arguments.length !== 1 && Te("Flow expects single argument with generator function");
  var r = t, i = r.name || "<unnamed flow>", o = function() {
    var s = this, l = arguments, u = ++pW, c = fs(i + " - runid: " + u + " - init", r).apply(s, l), f, d = void 0, p = new Promise(function(h, v) {
      var m = 0;
      f = v;
      function g(x) {
        d = void 0;
        var S;
        try {
          S = fs(i + " - runid: " + u + " - yield " + m++, c.next).call(c, x);
        } catch (O) {
          return v(O);
        }
        w(S);
      }
      function y(x) {
        d = void 0;
        var S;
        try {
          S = fs(i + " - runid: " + u + " - yield " + m++, c.throw).call(c, x);
        } catch (O) {
          return v(O);
        }
        w(S);
      }
      function w(x) {
        if (un(x?.then)) {
          x.then(w, v);
          return;
        }
        return x.done ? h(x.value) : (d = Promise.resolve(x.value), d.then(g, y));
      }
      g(void 0);
    });
    return p.cancel = fs(i + " - runid: " + u + " - cancel", function() {
      try {
        d && Mx(d);
        var h = c.return(void 0), v = Promise.resolve(h.value);
        v.then(us, us), Mx(v), f(new t4());
      } catch (m) {
        f(m);
      }
    }), p;
  };
  return o.isMobXFlow = !0, o;
}, Xh);
Ms.bound = /* @__PURE__ */ Ei(hW);
function Mx(e) {
  un(e.cancel) && e.cancel();
}
function Mu(e) {
  return e?.isMobXFlow === !0;
}
function vW(e, t) {
  return e ? ul(e) || !!e[qe] || Rb(e) || Od(e) || Ap(e) : !1;
}
function ju(e) {
  return process.env.NODE_ENV !== "production" && arguments.length !== 1 && Te("isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property"), vW(e);
}
function mW() {
  if (process.env.NODE_ENV !== "production") {
    for (var e = !1, t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    typeof n[n.length - 1] == "boolean" && (e = n.pop());
    var i = gW(n);
    if (!i)
      return Te("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    i.isTracing_ === Sr.NONE && console.log("[mobx.trace] '" + i.name_ + "' tracing enabled"), i.isTracing_ = e ? Sr.BREAK : Sr.LOG;
  }
}
function gW(e) {
  switch (e.length) {
    case 0:
      return me.trackingDerivation;
    case 1:
      return js(e[0]);
    case 2:
      return js(e[0], e[1]);
  }
}
function Ni(e, t) {
  t === void 0 && (t = void 0), br();
  try {
    return e.apply(t);
  } finally {
    _r();
  }
}
function Yo(e) {
  return e[qe];
}
var yW = {
  has: function(t, n) {
    return process.env.NODE_ENV !== "production" && me.trackingDerivation && Il("detect new properties using the 'in' operator. Use 'has' from 'mobx' instead."), Yo(t).has_(n);
  },
  get: function(t, n) {
    return Yo(t).get_(n);
  },
  set: function(t, n, r) {
    var i;
    return ya(n) ? (process.env.NODE_ENV !== "production" && !Yo(t).values_.has(n) && Il("add a new observable property through direct assignment. Use 'set' from 'mobx' instead."), (i = Yo(t).set_(n, r, !0)) != null ? i : !0) : !1;
  },
  deleteProperty: function(t, n) {
    var r;
    return process.env.NODE_ENV !== "production" && Il("delete properties from an observable object. Use 'remove' from 'mobx' instead."), ya(n) ? (r = Yo(t).delete_(n, !0)) != null ? r : !0 : !1;
  },
  defineProperty: function(t, n, r) {
    var i;
    return process.env.NODE_ENV !== "production" && Il("define property on an observable object. Use 'defineProperty' from 'mobx' instead."), (i = Yo(t).defineProperty_(n, r)) != null ? i : !0;
  },
  ownKeys: function(t) {
    return process.env.NODE_ENV !== "production" && me.trackingDerivation && Il("iterate keys to detect added / removed properties. Use 'keys' from 'mobx' instead."), Yo(t).ownKeys_();
  },
  preventExtensions: function(t) {
    Te(13);
  }
};
function bW(e, t) {
  var n, r;
  return xD(), e = Fa(e, t), (r = (n = e[qe]).proxy_) != null ? r : n.proxy_ = new Proxy(e, yW);
}
function gr(e) {
  return e.interceptors_ !== void 0 && e.interceptors_.length > 0;
}
function hc(e, t) {
  var n = e.interceptors_ || (e.interceptors_ = []);
  return n.push(t), Nb(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function yr(e, t) {
  var n = ja();
  try {
    for (var r = [].concat(e.interceptors_ || []), i = 0, o = r.length; i < o && (t = r[i](t), t && !t.type && Te(14), !!t); i++)
      ;
    return t;
  } finally {
    ji(n);
  }
}
function Yr(e) {
  return e.changeListeners_ !== void 0 && e.changeListeners_.length > 0;
}
function vc(e, t) {
  var n = e.changeListeners_ || (e.changeListeners_ = []);
  return n.push(t), Nb(function() {
    var r = n.indexOf(t);
    r !== -1 && n.splice(r, 1);
  });
}
function Qr(e, t) {
  var n = ja(), r = e.changeListeners_;
  if (r) {
    r = r.slice();
    for (var i = 0, o = r.length; i < o; i++)
      r[i](t);
    ji(n);
  }
}
function _W(e, t, n) {
  return Lo(function() {
    var r, i = Fa(e, n)[qe];
    process.env.NODE_ENV !== "production" && t && e[Vn] && Te("makeObservable second arg must be nullish when using decorators. Mixing @decorator syntax with annotations is not supported."), (r = t) != null || (t = Zq(e)), Rs(t).forEach(function(o) {
      return i.make_(o, t[o]);
    });
  }), e;
}
var ev = /* @__PURE__ */ Symbol("mobx-keys");
function wW(e, t, n) {
  return process.env.NODE_ENV !== "production" && (!rr(e) && !rr(Object.getPrototypeOf(e)) && Te("'makeAutoObservable' can only be used for classes that don't have a superclass"), ul(e) && Te("makeAutoObservable can only be used on objects not already made observable")), rr(e) ? JD(e, e, t, n) : (Lo(function() {
    var r = Fa(e, n)[qe];
    if (!e[ev]) {
      var i = Object.getPrototypeOf(e), o = new Set([].concat(Rs(e), Rs(i)));
      o.delete("constructor"), o.delete(qe), cc(i, ev, o);
    }
    e[ev].forEach(function(a) {
      return r.make_(
        a,
        // must pass "undefined" for { key: undefined }
        t && a in t ? t[a] : !0
      );
    });
  }), e);
}
var jx = "splice", Wr = "update", xW = 1e4, EW = {
  get: function(t, n) {
    var r = t[qe];
    return n === qe ? r : n === "length" ? r.getArrayLength_() : typeof n == "string" && !isNaN(n) ? r.get_(parseInt(n)) : Er($d, n) ? $d[n] : t[n];
  },
  set: function(t, n, r) {
    var i = t[qe];
    return n === "length" && i.setArrayLength_(r), typeof n == "symbol" || isNaN(n) ? t[n] = r : i.set_(parseInt(n), r), !0;
  },
  preventExtensions: function() {
    Te(15);
  }
}, zb = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ri() : "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = i, this.legacyMode_ = o, this.atom_ = new Fo(n), this.enhancer_ = function(a, s) {
      return r(a, s, process.env.NODE_ENV !== "production" ? n + "[..]" : "ObservableArray[..]");
    };
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.dehanceValues_ = function(r) {
    return this.dehancer !== void 0 && r.length > 0 ? r.map(this.dehancer) : r;
  }, t.intercept_ = function(r) {
    return hc(this, r);
  }, t.observe_ = function(r, i) {
    return i === void 0 && (i = !1), i && r({
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: "splice",
      index: 0,
      added: this.values_.slice(),
      addedCount: this.values_.length,
      removed: [],
      removedCount: 0
    }), vc(this, r);
  }, t.getArrayLength_ = function() {
    return this.atom_.reportObserved(), this.values_.length;
  }, t.setArrayLength_ = function(r) {
    (typeof r != "number" || isNaN(r) || r < 0) && Te("Out of range: " + r);
    var i = this.values_.length;
    if (r !== i)
      if (r > i) {
        for (var o = new Array(r - i), a = 0; a < r - i; a++)
          o[a] = void 0;
        this.spliceWithArray_(i, 0, o);
      } else
        this.spliceWithArray_(r, i - r);
  }, t.updateArrayLength_ = function(r, i) {
    r !== this.lastKnownLength_ && Te(16), this.lastKnownLength_ += i, this.legacyMode_ && i > 0 && s4(r + i + 1);
  }, t.spliceWithArray_ = function(r, i, o) {
    var a = this;
    _i(this.atom_);
    var s = this.values_.length;
    if (r === void 0 ? r = 0 : r > s ? r = s : r < 0 && (r = Math.max(0, s + r)), arguments.length === 1 ? i = s - r : i == null ? i = 0 : i = Math.max(0, Math.min(i, s - r)), o === void 0 && (o = _d), gr(this)) {
      var l = yr(this, {
        object: this.proxy_,
        type: jx,
        index: r,
        removedCount: i,
        added: o
      });
      if (!l)
        return _d;
      i = l.removedCount, o = l.added;
    }
    if (o = o.length === 0 ? o : o.map(function(f) {
      return a.enhancer_(f, void 0);
    }), this.legacyMode_ || process.env.NODE_ENV !== "production") {
      var u = o.length - i;
      this.updateArrayLength_(s, u);
    }
    var c = this.spliceItemsIntoValues_(r, i, o);
    return (i !== 0 || o.length !== 0) && this.notifyArraySplice_(r, o, c), this.dehanceValues_(c);
  }, t.spliceItemsIntoValues_ = function(r, i, o) {
    if (o.length < xW) {
      var a;
      return (a = this.values_).splice.apply(a, [r, i].concat(o));
    } else {
      var s = this.values_.slice(r, r + i), l = this.values_.slice(r + i);
      this.values_.length += o.length - i;
      for (var u = 0; u < o.length; u++)
        this.values_[r + u] = o[u];
      for (var c = 0; c < l.length; c++)
        this.values_[r + o.length + c] = l[c];
      return s;
    }
  }, t.notifyArrayChildUpdate_ = function(r, i, o) {
    var a = !this.owned_ && vn(), s = Yr(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      type: Wr,
      debugObjectName: this.atom_.name_,
      index: r,
      newValue: i,
      oldValue: o
    } : null;
    process.env.NODE_ENV !== "production" && a && ir(l), this.atom_.reportChanged(), s && Qr(this, l), process.env.NODE_ENV !== "production" && a && or();
  }, t.notifyArraySplice_ = function(r, i, o) {
    var a = !this.owned_ && vn(), s = Yr(this), l = s || a ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: jx,
      index: r,
      removed: o,
      added: i,
      removedCount: o.length,
      addedCount: i.length
    } : null;
    process.env.NODE_ENV !== "production" && a && ir(l), this.atom_.reportChanged(), s && Qr(this, l), process.env.NODE_ENV !== "production" && a && or();
  }, t.get_ = function(r) {
    if (this.legacyMode_ && r >= this.values_.length) {
      console.warn(process.env.NODE_ENV !== "production" ? "[mobx.array] Attempt to read an array index (" + r + ") that is out of bounds (" + this.values_.length + "). Please check length first. Out of bound indices will not be tracked by MobX" : "[mobx] Out of bounds read: " + r);
      return;
    }
    return this.atom_.reportObserved(), this.dehanceValue_(this.values_[r]);
  }, t.set_ = function(r, i) {
    var o = this.values_;
    if (this.legacyMode_ && r > o.length && Te(17, r, o.length), r < o.length) {
      _i(this.atom_);
      var a = o[r];
      if (gr(this)) {
        var s = yr(this, {
          type: Wr,
          object: this.proxy_,
          // since "this" is the real array we need to pass its proxy
          index: r,
          newValue: i
        });
        if (!s)
          return;
        i = s.newValue;
      }
      i = this.enhancer_(i, a);
      var l = i !== a;
      l && (o[r] = i, this.notifyArrayChildUpdate_(r, i, a));
    } else {
      for (var u = new Array(r + 1 - o.length), c = 0; c < u.length - 1; c++)
        u[c] = void 0;
      u[u.length - 1] = i, this.spliceWithArray_(o.length, 0, u);
    }
  }, e;
})();
function SW(e, t, n, r) {
  return n === void 0 && (n = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ri() : "ObservableArray"), r === void 0 && (r = !1), xD(), Lo(function() {
    var i = new zb(n, t, r, !1);
    SD(i.values_, qe, i);
    var o = new Proxy(i.values_, EW);
    return i.proxy_ = o, e && e.length && i.spliceWithArray_(0, 0, e), o;
  });
}
var $d = {
  clear: function() {
    return this.splice(0);
  },
  replace: function(t) {
    var n = this[qe];
    return n.spliceWithArray_(0, n.values_.length, t);
  },
  // Used by JSON.stringify
  toJSON: function() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function(t, n) {
    for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
      i[o - 2] = arguments[o];
    var a = this[qe];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return a.spliceWithArray_(t);
      case 2:
        return a.spliceWithArray_(t, n);
    }
    return a.spliceWithArray_(t, n, i);
  },
  spliceWithArray: function(t, n, r) {
    return this[qe].spliceWithArray_(t, n, r);
  },
  push: function() {
    for (var t = this[qe], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(t.values_.length, 0, r), t.values_.length;
  },
  pop: function() {
    return this.splice(Math.max(this[qe].values_.length - 1, 0), 1)[0];
  },
  shift: function() {
    return this.splice(0, 1)[0];
  },
  unshift: function() {
    for (var t = this[qe], n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return t.spliceWithArray_(0, 0, r), t.values_.length;
  },
  reverse: function() {
    return me.trackingDerivation && Te(37, "reverse"), this.replace(this.slice().reverse()), this;
  },
  sort: function() {
    me.trackingDerivation && Te(37, "sort");
    var t = this.slice();
    return t.sort.apply(t, arguments), this.replace(t), this;
  },
  remove: function(t) {
    var n = this[qe], r = n.dehanceValues_(n.values_).indexOf(t);
    return r > -1 ? (this.splice(r, 1), !0) : !1;
  }
};
St("at", cr);
St("concat", cr);
St("flat", cr);
St("includes", cr);
St("indexOf", cr);
St("join", cr);
St("lastIndexOf", cr);
St("slice", cr);
St("toString", cr);
St("toLocaleString", cr);
St("toSorted", cr);
St("toSpliced", cr);
St("with", cr);
St("every", ii);
St("filter", ii);
St("find", ii);
St("findIndex", ii);
St("findLast", ii);
St("findLastIndex", ii);
St("flatMap", ii);
St("forEach", ii);
St("map", ii);
St("some", ii);
St("toReversed", ii);
St("reduce", n4);
St("reduceRight", n4);
function St(e, t) {
  typeof Array.prototype[e] == "function" && ($d[e] = t(e));
}
function cr(e) {
  return function() {
    var t = this[qe];
    t.atom_.reportObserved();
    var n = t.dehanceValues_(t.values_);
    return n[e].apply(n, arguments);
  };
}
function ii(e) {
  return function(t, n) {
    var r = this, i = this[qe];
    i.atom_.reportObserved();
    var o = i.dehanceValues_(i.values_);
    return o[e](function(a, s) {
      return t.call(n, a, s, r);
    });
  };
}
function n4(e) {
  return function() {
    var t = this, n = this[qe];
    n.atom_.reportObserved();
    var r = n.dehanceValues_(n.values_), i = arguments[0];
    return arguments[0] = function(o, a, s) {
      return i(o, a, s, t);
    }, r[e].apply(r, arguments);
  };
}
var OW = /* @__PURE__ */ Ma("ObservableArrayAdministration", zb);
function Cp(e) {
  return Sp(e) && OW(e[qe]);
}
var $W = {}, bo = "add", Td = "delete", r4 = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = ba), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableMap@" + ri() : "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[qe] = $W, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = r, this.name_ = i, un(Map) || Te(18), Lo(function() {
      o.keysAtom_ = kD(process.env.NODE_ENV !== "production" ? o.name_ + ".keys()" : "ObservableMap.keys()"), o.data_ = /* @__PURE__ */ new Map(), o.hasMap_ = /* @__PURE__ */ new Map(), n && o.merge(n);
    });
  }
  var t = e.prototype;
  return t.has_ = function(r) {
    return this.data_.has(r);
  }, t.has = function(r) {
    var i = this;
    if (!me.trackingDerivation)
      return this.has_(r);
    var o = this.hasMap_.get(r);
    if (!o) {
      var a = o = new fa(this.has_(r), $p, process.env.NODE_ENV !== "production" ? this.name_ + "." + eg(r) + "?" : "ObservableMap.key?", !1);
      this.hasMap_.set(r, a), YD(a, function() {
        return i.hasMap_.delete(r);
      });
    }
    return o.get();
  }, t.set = function(r, i) {
    var o = this.has_(r);
    if (gr(this)) {
      var a = yr(this, {
        type: o ? Wr : bo,
        object: this,
        newValue: i,
        name: r
      });
      if (!a)
        return this;
      i = a.newValue;
    }
    return o ? this.updateValue_(r, i) : this.addValue_(r, i), this;
  }, t.delete = function(r) {
    var i = this;
    if (_i(this.keysAtom_), gr(this)) {
      var o = yr(this, {
        type: Td,
        object: this,
        name: r
      });
      if (!o)
        return !1;
    }
    if (this.has_(r)) {
      var a = vn(), s = Yr(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Td,
        object: this,
        oldValue: this.data_.get(r).value_,
        name: r
      } : null;
      return process.env.NODE_ENV !== "production" && a && ir(l), Ni(function() {
        var u;
        i.keysAtom_.reportChanged(), (u = i.hasMap_.get(r)) == null || u.setNewValue_(!1);
        var c = i.data_.get(r);
        c.setNewValue_(void 0), i.data_.delete(r);
      }), s && Qr(this, l), process.env.NODE_ENV !== "production" && a && or(), !0;
    }
    return !1;
  }, t.updateValue_ = function(r, i) {
    var o = this.data_.get(r);
    if (i = o.prepareNewValue_(i), i !== me.UNCHANGED) {
      var a = vn(), s = Yr(this), l = s || a ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: Wr,
        object: this,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && a && ir(l), o.setNewValue_(i), s && Qr(this, l), process.env.NODE_ENV !== "production" && a && or();
    }
  }, t.addValue_ = function(r, i) {
    var o = this;
    _i(this.keysAtom_), Ni(function() {
      var u, c = new fa(i, o.enhancer_, process.env.NODE_ENV !== "production" ? o.name_ + "." + eg(r) : "ObservableMap.key", !1);
      o.data_.set(r, c), i = c.value_, (u = o.hasMap_.get(r)) == null || u.setNewValue_(!0), o.keysAtom_.reportChanged();
    });
    var a = vn(), s = Yr(this), l = s || a ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: bo,
      object: this,
      name: r,
      newValue: i
    } : null;
    process.env.NODE_ENV !== "production" && a && ir(l), s && Qr(this, l), process.env.NODE_ENV !== "production" && a && or();
  }, t.get = function(r) {
    return this.has(r) ? this.dehanceValue_(this.data_.get(r).get()) : this.dehanceValue_(void 0);
  }, t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.keys = function() {
    return this.keysAtom_.reportObserved(), this.data_.keys();
  }, t.values = function() {
    var r = this, i = this.keys();
    return Fx({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : r.get(l)
        };
      }
    });
  }, t.entries = function() {
    var r = this, i = this.keys();
    return Fx({
      next: function() {
        var a = i.next(), s = a.done, l = a.value;
        return {
          done: s,
          value: s ? void 0 : [l, r.get(l)]
        };
      }
    });
  }, t[Symbol.iterator] = function() {
    return this.entries();
  }, t.forEach = function(r, i) {
    for (var o = cs(this), a; !(a = o()).done; ) {
      var s = a.value, l = s[0], u = s[1];
      r.call(i, u, l, this);
    }
  }, t.merge = function(r) {
    var i = this;
    return zo(r) && (r = new Map(r)), Ni(function() {
      rr(r) ? Vq(r).forEach(function(o) {
        return i.set(o, r[o]);
      }) : Array.isArray(r) ? r.forEach(function(o) {
        var a = o[0], s = o[1];
        return i.set(a, s);
      }) : sl(r) ? (Lq(r) || Te(19, r), r.forEach(function(o, a) {
        return i.set(a, o);
      })) : r != null && Te(20, r);
    }), this;
  }, t.clear = function() {
    var r = this;
    Ni(function() {
      FD(function() {
        for (var i = cs(r.keys()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.replace = function(r) {
    var i = this;
    return Ni(function() {
      for (var o = TW(r), a = /* @__PURE__ */ new Map(), s = !1, l = cs(i.data_.keys()), u; !(u = l()).done; ) {
        var c = u.value;
        if (!o.has(c)) {
          var f = i.delete(c);
          if (f)
            s = !0;
          else {
            var d = i.data_.get(c);
            a.set(c, d);
          }
        }
      }
      for (var p = cs(o.entries()), h; !(h = p()).done; ) {
        var v = h.value, m = v[0], g = v[1], y = i.data_.has(m);
        if (i.set(m, g), i.data_.has(m)) {
          var w = i.data_.get(m);
          a.set(m, w), y || (s = !0);
        }
      }
      if (!s)
        if (i.data_.size !== a.size)
          i.keysAtom_.reportChanged();
        else
          for (var x = i.data_.keys(), S = a.keys(), O = x.next(), P = S.next(); !O.done; ) {
            if (O.value !== P.value) {
              i.keysAtom_.reportChanged();
              break;
            }
            O = x.next(), P = S.next();
          }
      i.data_ = a;
    }), this;
  }, t.toString = function() {
    return "[object ObservableMap]";
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Te("`observe` doesn't support fireImmediately=true in combination with maps."), vc(this, r);
  }, t.intercept_ = function(r) {
    return hc(this, r);
  }, ll(e, [{
    key: "size",
    get: function() {
      return this.keysAtom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Map";
    }
  }]);
})(), zo = /* @__PURE__ */ Ma("ObservableMap", r4);
function Fx(e) {
  return e[Symbol.toStringTag] = "MapIterator", Vb(e);
}
function TW(e) {
  if (sl(e) || zo(e))
    return e;
  if (Array.isArray(e))
    return new Map(e);
  if (rr(e)) {
    var t = /* @__PURE__ */ new Map();
    for (var n in e)
      t.set(n, e[n]);
    return t;
  } else
    return Te(21, e);
}
var kW = {}, i4 = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    var o = this;
    r === void 0 && (r = ba), i === void 0 && (i = process.env.NODE_ENV !== "production" ? "ObservableSet@" + ri() : "ObservableSet"), this.name_ = void 0, this[qe] = kW, this.data_ = /* @__PURE__ */ new Set(), this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = i, un(Set) || Te(22), this.enhancer_ = function(a, s) {
      return r(a, s, i);
    }, Lo(function() {
      o.atom_ = kD(o.name_), n && o.replace(n);
    });
  }
  var t = e.prototype;
  return t.dehanceValue_ = function(r) {
    return this.dehancer !== void 0 ? this.dehancer(r) : r;
  }, t.clear = function() {
    var r = this;
    Ni(function() {
      FD(function() {
        for (var i = cs(r.data_.values()), o; !(o = i()).done; ) {
          var a = o.value;
          r.delete(a);
        }
      });
    });
  }, t.forEach = function(r, i) {
    for (var o = cs(this), a; !(a = o()).done; ) {
      var s = a.value;
      r.call(i, s, s, this);
    }
  }, t.add = function(r) {
    var i = this;
    if (_i(this.atom_), gr(this)) {
      var o = yr(this, {
        type: bo,
        object: this,
        newValue: r
      });
      if (!o)
        return this;
      r = o.newValue;
    }
    if (!this.has(r)) {
      Ni(function() {
        i.data_.add(i.enhancer_(r, void 0)), i.atom_.reportChanged();
      });
      var a = process.env.NODE_ENV !== "production" && vn(), s = Yr(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: bo,
        object: this,
        newValue: r
      } : null;
      a && process.env.NODE_ENV !== "production" && ir(l), s && Qr(this, l), a && process.env.NODE_ENV !== "production" && or();
    }
    return this;
  }, t.delete = function(r) {
    var i = this;
    if (gr(this)) {
      var o = yr(this, {
        type: Td,
        object: this,
        oldValue: r
      });
      if (!o)
        return !1;
    }
    if (this.has(r)) {
      var a = process.env.NODE_ENV !== "production" && vn(), s = Yr(this), l = s || a ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: Td,
        object: this,
        oldValue: r
      } : null;
      return a && process.env.NODE_ENV !== "production" && ir(l), Ni(function() {
        i.atom_.reportChanged(), i.data_.delete(r);
      }), s && Qr(this, l), a && process.env.NODE_ENV !== "production" && or(), !0;
    }
    return !1;
  }, t.has = function(r) {
    return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(r));
  }, t.entries = function() {
    var r = this.values();
    return zx({
      next: function() {
        var o = r.next(), a = o.value, s = o.done;
        return s ? {
          value: void 0,
          done: s
        } : {
          value: [a, a],
          done: s
        };
      }
    });
  }, t.keys = function() {
    return this.values();
  }, t.values = function() {
    this.atom_.reportObserved();
    var r = this, i = this.data_.values();
    return zx({
      next: function() {
        var a = i.next(), s = a.value, l = a.done;
        return l ? {
          value: void 0,
          done: l
        } : {
          value: r.dehanceValue_(s),
          done: l
        };
      }
    });
  }, t.intersection = function(r) {
    if (Ii(r) && !mi(r))
      return r.intersection(this);
    var i = new Set(this);
    return i.intersection(r);
  }, t.union = function(r) {
    if (Ii(r) && !mi(r))
      return r.union(this);
    var i = new Set(this);
    return i.union(r);
  }, t.difference = function(r) {
    return new Set(this).difference(r);
  }, t.symmetricDifference = function(r) {
    if (Ii(r) && !mi(r))
      return r.symmetricDifference(this);
    var i = new Set(this);
    return i.symmetricDifference(r);
  }, t.isSubsetOf = function(r) {
    return new Set(this).isSubsetOf(r);
  }, t.isSupersetOf = function(r) {
    return new Set(this).isSupersetOf(r);
  }, t.isDisjointFrom = function(r) {
    if (Ii(r) && !mi(r))
      return r.isDisjointFrom(this);
    var i = new Set(this);
    return i.isDisjointFrom(r);
  }, t.replace = function(r) {
    var i = this;
    return mi(r) && (r = new Set(r)), Ni(function() {
      Array.isArray(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : Ii(r) ? (i.clear(), r.forEach(function(o) {
        return i.add(o);
      })) : r != null && Te("Cannot initialize set from " + r);
    }), this;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Te("`observe` doesn't support fireImmediately=true in combination with sets."), vc(this, r);
  }, t.intercept_ = function(r) {
    return hc(this, r);
  }, t.toJSON = function() {
    return Array.from(this);
  }, t.toString = function() {
    return "[object ObservableSet]";
  }, t[Symbol.iterator] = function() {
    return this.values();
  }, ll(e, [{
    key: "size",
    get: function() {
      return this.atom_.reportObserved(), this.data_.size;
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Set";
    }
  }]);
})(), mi = /* @__PURE__ */ Ma("ObservableSet", i4);
function zx(e) {
  return e[Symbol.toStringTag] = "SetIterator", Vb(e);
}
var Lx = /* @__PURE__ */ Object.create(null), Vx = "remove", ug = /* @__PURE__ */ (function() {
  function e(n, r, i, o) {
    r === void 0 && (r = /* @__PURE__ */ new Map()), o === void 0 && (o = gH), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = n, this.values_ = r, this.name_ = i, this.defaultAnnotation_ = o, this.keysAtom_ = new Fo(process.env.NODE_ENV !== "production" ? this.name_ + ".keys" : "ObservableObject.keys"), this.isPlainObject_ = rr(this.target_), process.env.NODE_ENV !== "production" && !c4(this.defaultAnnotation_) && Te("defaultAnnotation must be valid annotation"), process.env.NODE_ENV !== "production" && (this.appliedAnnotations_ = {});
  }
  var t = e.prototype;
  return t.getObservablePropValue_ = function(r) {
    return this.values_.get(r).get();
  }, t.setObservablePropValue_ = function(r, i) {
    var o = this.values_.get(r);
    if (o instanceof Tr)
      return o.set(i), !0;
    if (gr(this)) {
      var a = yr(this, {
        type: Wr,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      });
      if (!a)
        return null;
      i = a.newValue;
    }
    if (i = o.prepareNewValue_(i), i !== me.UNCHANGED) {
      var s = Yr(this), l = process.env.NODE_ENV !== "production" && vn(), u = s || l ? {
        type: Wr,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: o.value_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && l && ir(u), o.setNewValue_(i), s && Qr(this, u), process.env.NODE_ENV !== "production" && l && or();
    }
    return !0;
  }, t.get_ = function(r) {
    return me.trackingDerivation && !Er(this.target_, r) && this.has_(r), this.target_[r];
  }, t.set_ = function(r, i, o) {
    return o === void 0 && (o = !1), Er(this.target_, r) ? this.values_.has(r) ? this.setObservablePropValue_(r, i) : o ? Reflect.set(this.target_, r, i) : (this.target_[r] = i, !0) : this.extend_(r, {
      value: i,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }, this.defaultAnnotation_, o);
  }, t.has_ = function(r) {
    if (!me.trackingDerivation)
      return r in this.target_;
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var i = this.pendingKeys_.get(r);
    return i || (i = new fa(r in this.target_, $p, process.env.NODE_ENV !== "production" ? this.name_ + "." + eg(r) + "?" : "ObservableObject.key?", !1), this.pendingKeys_.set(r, i)), i.get();
  }, t.make_ = function(r, i) {
    if (i === !0 && (i = this.defaultAnnotation_), i !== !1) {
      if (Kx(this, i, r), !(r in this.target_)) {
        var o;
        if ((o = this.target_[Vn]) != null && o[r])
          return;
        Te(1, i.annotationType_, this.name_ + "." + r.toString());
      }
      for (var a = this.target_; a && a !== Ep; ) {
        var s = bd(a, r);
        if (s) {
          var l = i.make_(this, r, s, a);
          if (l === 0)
            return;
          if (l === 1)
            break;
        }
        a = Object.getPrototypeOf(a);
      }
      Ux(this, i, r);
    }
  }, t.extend_ = function(r, i, o, a) {
    if (a === void 0 && (a = !1), o === !0 && (o = this.defaultAnnotation_), o === !1)
      return this.defineProperty_(r, i, a);
    Kx(this, o, r);
    var s = o.extend_(this, r, i, a);
    return s && Ux(this, o, r), s;
  }, t.defineProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), _i(this.keysAtom_);
    try {
      br();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (gr(this)) {
        var s = yr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: bo,
          newValue: i.value
        });
        if (!s)
          return null;
        var l = s.newValue;
        i.value !== l && (i = qi({}, i, {
          value: l
        }));
      }
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, i))
          return !1;
      } else
        xi(this.target_, r, i);
      this.notifyPropertyAddition_(r, i.value);
    } finally {
      _r();
    }
    return !0;
  }, t.defineObservableProperty_ = function(r, i, o, a) {
    a === void 0 && (a = !1), _i(this.keysAtom_);
    try {
      br();
      var s = this.delete_(r);
      if (!s)
        return s;
      if (gr(this)) {
        var l = yr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: bo,
          newValue: i
        });
        if (!l)
          return null;
        i = l.newValue;
      }
      var u = Bx(r), c = {
        configurable: me.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !0,
        get: u.get,
        set: u.set
      };
      if (a) {
        if (!Reflect.defineProperty(this.target_, r, c))
          return !1;
      } else
        xi(this.target_, r, c);
      var f = new fa(i, o, process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key", !1);
      this.values_.set(r, f), this.notifyPropertyAddition_(r, f.value_);
    } finally {
      _r();
    }
    return !0;
  }, t.defineComputedProperty_ = function(r, i, o) {
    o === void 0 && (o = !1), _i(this.keysAtom_);
    try {
      br();
      var a = this.delete_(r);
      if (!a)
        return a;
      if (gr(this)) {
        var s = yr(this, {
          object: this.proxy_ || this.target_,
          name: r,
          type: bo,
          newValue: void 0
        });
        if (!s)
          return null;
      }
      i.name || (i.name = process.env.NODE_ENV !== "production" ? this.name_ + "." + r.toString() : "ObservableObject.key"), i.context = this.proxy_ || this.target_;
      var l = Bx(r), u = {
        configurable: me.safeDescriptors ? this.isPlainObject_ : !0,
        enumerable: !1,
        get: l.get,
        set: l.set
      };
      if (o) {
        if (!Reflect.defineProperty(this.target_, r, u))
          return !1;
      } else
        xi(this.target_, r, u);
      this.values_.set(r, new Tr(i)), this.notifyPropertyAddition_(r, void 0);
    } finally {
      _r();
    }
    return !0;
  }, t.delete_ = function(r, i) {
    if (i === void 0 && (i = !1), _i(this.keysAtom_), !Er(this.target_, r))
      return !0;
    if (gr(this)) {
      var o = yr(this, {
        object: this.proxy_ || this.target_,
        name: r,
        type: Vx
      });
      if (!o)
        return null;
    }
    try {
      var a;
      br();
      var s = Yr(this), l = process.env.NODE_ENV !== "production" && vn(), u = this.values_.get(r), c = void 0;
      if (!u && (s || l)) {
        var f;
        c = (f = bd(this.target_, r)) == null ? void 0 : f.value;
      }
      if (i) {
        if (!Reflect.deleteProperty(this.target_, r))
          return !1;
      } else
        delete this.target_[r];
      if (process.env.NODE_ENV !== "production" && delete this.appliedAnnotations_[r], u && (this.values_.delete(r), u instanceof fa && (c = u.value_), KD(u)), this.keysAtom_.reportChanged(), (a = this.pendingKeys_) == null || (a = a.get(r)) == null || a.set(r in this.target_), s || l) {
        var d = {
          type: Vx,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: c,
          name: r
        };
        process.env.NODE_ENV !== "production" && l && ir(d), s && Qr(this, d), process.env.NODE_ENV !== "production" && l && or();
      }
    } finally {
      _r();
    }
    return !0;
  }, t.observe_ = function(r, i) {
    return process.env.NODE_ENV !== "production" && i === !0 && Te("`observe` doesn't support the fire immediately property for observable objects."), vc(this, r);
  }, t.intercept_ = function(r) {
    return hc(this, r);
  }, t.notifyPropertyAddition_ = function(r, i) {
    var o, a = Yr(this), s = process.env.NODE_ENV !== "production" && vn();
    if (a || s) {
      var l = a || s ? {
        type: bo,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: r,
        newValue: i
      } : null;
      process.env.NODE_ENV !== "production" && s && ir(l), a && Qr(this, l), process.env.NODE_ENV !== "production" && s && or();
    }
    (o = this.pendingKeys_) == null || (o = o.get(r)) == null || o.set(!0), this.keysAtom_.reportChanged();
  }, t.ownKeys_ = function() {
    return this.keysAtom_.reportObserved(), Rs(this.target_);
  }, t.keys_ = function() {
    return this.keysAtom_.reportObserved(), Object.keys(this.target_);
  }, e;
})();
function Fa(e, t) {
  var n;
  if (process.env.NODE_ENV !== "production" && t && ul(e) && Te("Options can't be provided for already observable objects."), Er(e, qe))
    return process.env.NODE_ENV !== "production" && !(l4(e) instanceof ug) && Te("Cannot convert '" + kd(e) + `' into observable object:
The target is already observable of different type.
Extending builtins is not supported.`), e;
  process.env.NODE_ENV !== "production" && !Object.isExtensible(e) && Te("Cannot make the designated object observable; it is not extensible");
  var r = (n = t?.name) != null ? n : process.env.NODE_ENV !== "production" ? (rr(e) ? "ObservableObject" : e.constructor.name) + "@" + ri() : "ObservableObject", i = new ug(e, /* @__PURE__ */ new Map(), String(r), kH(t));
  return cc(e, qe, i), e;
}
var PW = /* @__PURE__ */ Ma("ObservableObjectAdministration", ug);
function Bx(e) {
  return Lx[e] || (Lx[e] = {
    get: function() {
      return this[qe].getObservablePropValue_(e);
    },
    set: function(n) {
      return this[qe].setObservablePropValue_(e, n);
    }
  });
}
function ul(e) {
  return Sp(e) ? PW(e[qe]) : !1;
}
function Ux(e, t, n) {
  var r;
  process.env.NODE_ENV !== "production" && (e.appliedAnnotations_[n] = t), (r = e.target_[Vn]) == null || delete r[n];
}
function Kx(e, t, n) {
  if (process.env.NODE_ENV !== "production" && !c4(t) && Te("Cannot annotate '" + e.name_ + "." + n.toString() + "': Invalid annotation."), process.env.NODE_ENV !== "production" && !xd(t) && Er(e.appliedAnnotations_, n)) {
    var r = e.name_ + "." + n.toString(), i = e.appliedAnnotations_[n].annotationType_, o = t.annotationType_;
    Te("Cannot apply '" + o + "' to '" + r + "':" + (`
The field is already annotated with '` + i + "'.") + `
Re-annotating fields is not allowed.
Use 'override' annotation for methods overridden by subclass.`);
  }
}
var DW = /* @__PURE__ */ a4(0), AW = /* @__PURE__ */ (function() {
  var e = !1, t = {};
  return Object.defineProperty(t, "0", {
    set: function() {
      e = !0;
    }
  }), Object.create(t)[0] = 1, e === !1;
})(), tv = 0, o4 = function() {
};
function CW(e, t) {
  Object.setPrototypeOf ? Object.setPrototypeOf(e.prototype, t) : e.prototype.__proto__ !== void 0 ? e.prototype.__proto__ = t : e.prototype = t;
}
CW(o4, Array.prototype);
var Lb = /* @__PURE__ */ (function(e) {
  function t(r, i, o, a) {
    var s;
    return o === void 0 && (o = process.env.NODE_ENV !== "production" ? "ObservableArray@" + ri() : "ObservableArray"), a === void 0 && (a = !1), s = e.call(this) || this, Lo(function() {
      var l = new zb(o, i, a, !0);
      l.proxy_ = s, SD(s, qe, l), r && r.length && s.spliceWithArray(0, 0, r), AW && Object.defineProperty(s, "0", DW);
    }), s;
  }
  TD(t, e);
  var n = t.prototype;
  return n.concat = function() {
    this[qe].atom_.reportObserved();
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      o.map(function(s) {
        return Cp(s) ? s.slice() : s;
      })
    );
  }, n[Symbol.iterator] = function() {
    var r = this, i = 0;
    return Vb({
      next: function() {
        return i < r.length ? {
          value: r[i++],
          done: !1
        } : {
          done: !0,
          value: void 0
        };
      }
    });
  }, ll(t, [{
    key: "length",
    get: function() {
      return this[qe].getArrayLength_();
    },
    set: function(i) {
      this[qe].setArrayLength_(i);
    }
  }, {
    key: Symbol.toStringTag,
    get: function() {
      return "Array";
    }
  }]);
})(o4);
Object.entries($d).forEach(function(e) {
  var t = e[0], n = e[1];
  t !== "concat" && cc(Lb.prototype, t, n);
});
function a4(e) {
  return {
    enumerable: !1,
    configurable: !0,
    get: function() {
      return this[qe].get_(e);
    },
    set: function(n) {
      this[qe].set_(e, n);
    }
  };
}
function IW(e) {
  xi(Lb.prototype, "" + e, a4(e));
}
function s4(e) {
  if (e > tv) {
    for (var t = tv; t < e + 100; t++)
      IW(t);
    tv = e;
  }
}
s4(1e3);
function NW(e, t, n) {
  return new Lb(e, t, n);
}
function js(e, t) {
  if (typeof e == "object" && e !== null) {
    if (Cp(e))
      return t !== void 0 && Te(23), e[qe].atom_;
    if (mi(e))
      return e.atom_;
    if (zo(e)) {
      if (t === void 0)
        return e.keysAtom_;
      var n = e.data_.get(t) || e.hasMap_.get(t);
      return n || Te(25, t, kd(e)), n;
    }
    if (ul(e)) {
      if (!t)
        return Te(26);
      var r = e[qe].values_.get(t);
      return r || Te(27, t, kd(e)), r;
    }
    if (Rb(e) || Ap(e) || Od(e))
      return e;
  } else if (un(e) && Od(e[qe]))
    return e[qe];
  Te(28);
}
function l4(e, t) {
  if (e || Te(29), Rb(e) || Ap(e) || Od(e) || zo(e) || mi(e))
    return e;
  if (e[qe])
    return e[qe];
  Te(24, e);
}
function kd(e, t) {
  var n;
  if (t !== void 0)
    n = js(e, t);
  else {
    if (xa(e))
      return e.name;
    ul(e) || zo(e) || mi(e) ? n = l4(e) : n = js(e);
  }
  return n.name_;
}
function Lo(e) {
  var t = ja(), n = Pp(!0);
  br();
  try {
    return e();
  } finally {
    _r(), Dp(n), ji(t);
  }
}
var qx = Ep.toString;
function u4(e, t, n) {
  return n === void 0 && (n = -1), cg(e, t, n);
}
function cg(e, t, n, r, i) {
  if (e === t)
    return e !== 0 || 1 / e === 1 / t;
  if (e == null || t == null)
    return !1;
  if (e !== e)
    return t !== t;
  var o = typeof e;
  if (o !== "function" && o !== "object" && typeof t != "object")
    return !1;
  var a = qx.call(e);
  if (a !== qx.call(t))
    return !1;
  switch (a) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + e == "" + t;
    case "[object Number]":
      return +e != +e ? +t != +t : +e == 0 ? 1 / +e === 1 / t : +e == +t;
    case "[object Date]":
    case "[object Boolean]":
      return +e == +t;
    case "[object Symbol]":
      return typeof Symbol < "u" && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
    case "[object Map]":
    case "[object Set]":
      n >= 0 && n++;
      break;
  }
  e = Hx(e), t = Hx(t);
  var s = a === "[object Array]";
  if (!s) {
    if (typeof e != "object" || typeof t != "object")
      return !1;
    var l = e.constructor, u = t.constructor;
    if (l !== u && !(un(l) && l instanceof l && un(u) && u instanceof u) && "constructor" in e && "constructor" in t)
      return !1;
  }
  if (n === 0)
    return !1;
  n < 0 && (n = -1), r = r || [], i = i || [];
  for (var c = r.length; c--; )
    if (r[c] === e)
      return i[c] === t;
  if (r.push(e), i.push(t), s) {
    if (c = e.length, c !== t.length)
      return !1;
    for (; c--; )
      if (!cg(e[c], t[c], n - 1, r, i))
        return !1;
  } else {
    var f = Object.keys(e), d = f.length;
    if (Object.keys(t).length !== d)
      return !1;
    for (var p = 0; p < d; p++) {
      var h = f[p];
      if (!(Er(t, h) && cg(e[h], t[h], n - 1, r, i)))
        return !1;
    }
  }
  return r.pop(), i.pop(), !0;
}
function Hx(e) {
  return Cp(e) ? e.slice() : sl(e) || zo(e) || Ii(e) || mi(e) ? Array.from(e.entries()) : e;
}
var Wx, RW = ((Wx = xp().Iterator) == null ? void 0 : Wx.prototype) || {};
function Vb(e) {
  return e[Symbol.iterator] = MW, Object.assign(Object.create(RW), e);
}
function MW() {
  return this;
}
function c4(e) {
  return (
    // Can be function
    e instanceof Object && typeof e.annotationType_ == "string" && un(e.make_) && un(e.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(e) {
  var t = xp();
  typeof t[e] > "u" && Te("MobX requires global '" + e + "' to be available or polyfilled");
});
typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ == "object" && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
  spy: QH,
  extras: {
    getDebugName: kd
  },
  $mobx: qe
});
if (!Fe)
  throw new Error("mobx-react-lite requires React with Hooks support");
if (!_W)
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
function jW(e) {
  e();
}
function FW(e) {
  e || (e = jW, process.env.NODE_ENV !== "production" && console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native")), fW({ reactionScheduler: e });
}
function zW(e) {
  return XD(e);
}
var LW = 1e4, VW = 1e4, BW = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      Object.defineProperty(this, "finalize", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
      }), Object.defineProperty(this, "registrations", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: /* @__PURE__ */ new Map()
      }), Object.defineProperty(this, "sweepTimeout", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: void 0
      }), Object.defineProperty(this, "sweep", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(r) {
          r === void 0 && (r = LW), clearTimeout(n.sweepTimeout), n.sweepTimeout = void 0;
          var i = Date.now();
          n.registrations.forEach(function(o, a) {
            i - o.registeredAt >= r && (n.finalize(o.value), n.registrations.delete(a));
          }), n.registrations.size > 0 && n.scheduleSweep();
        }
      }), Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function() {
          n.sweep(0);
        }
      });
    }
    return Object.defineProperty(e.prototype, "register", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t, n, r) {
        this.registrations.set(r, {
          value: n,
          registeredAt: Date.now()
        }), this.scheduleSweep();
      }
    }), Object.defineProperty(e.prototype, "unregister", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function(t) {
        this.registrations.delete(t);
      }
    }), Object.defineProperty(e.prototype, "scheduleSweep", {
      enumerable: !1,
      configurable: !0,
      writable: !0,
      value: function() {
        this.sweepTimeout === void 0 && (this.sweepTimeout = setTimeout(this.sweep, VW));
      }
    }), e;
  })()
), UW = typeof FinalizationRegistry < "u" ? FinalizationRegistry : BW, Fu = new UW(function(e) {
  var t;
  (t = e.reaction) === null || t === void 0 || t.dispose(), e.reaction = null;
});
function Zx(e) {
  e.reaction = new Si("observer".concat(e.name), function() {
    var t;
    e.stateVersion = Symbol(), (t = e.onStoreChange) === null || t === void 0 || t.call(e);
  });
}
function KW(e, t) {
  t === void 0 && (t = "observed");
  var n = W.useRef(null);
  if (!n.current) {
    var r = {
      reaction: null,
      onStoreChange: null,
      stateVersion: Symbol(),
      name: t,
      subscribe: function(s) {
        return Fu.unregister(r), r.onStoreChange = s, r.reaction || (Zx(r), r.stateVersion = Symbol()), function() {
          var l;
          r.onStoreChange = null, (l = r.reaction) === null || l === void 0 || l.dispose(), r.reaction = null;
        };
      },
      getSnapshot: function() {
        return r.stateVersion;
      }
    };
    n.current = r;
  }
  var i = n.current;
  i.reaction || (Zx(i), Fu.register(n, i, i)), W.useDebugValue(i.reaction, zW), OP.useSyncExternalStore(
    // Both of these must be stable, otherwise it would keep resubscribing every render.
    i.subscribe,
    i.getSnapshot,
    i.getSnapshot
  );
  var o, a;
  if (i.reaction.track(function() {
    try {
      o = e();
    } catch (s) {
      a = s;
    }
  }), a)
    throw a;
  return o;
}
var nv, rv, qW = !0, Gx = !0, f4 = typeof Symbol == "function" && Symbol.for, HW = (rv = (nv = Object.getOwnPropertyDescriptor(function() {
}, "name")) === null || nv === void 0 ? void 0 : nv.configurable) !== null && rv !== void 0 ? rv : !1, Yx = f4 ? Symbol.for("react.forward_ref") : typeof Xt == "function" && Xt(function(e) {
  return null;
}).$$typeof, Qx = f4 ? Symbol.for("react.memo") : typeof Bf == "function" && Bf(function(e) {
  return null;
}).$$typeof;
function WW(e, t) {
  var n;
  if (process.env.NODE_ENV, Qx && e.$$typeof === Qx)
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  var r = (n = void 0) !== null && n !== void 0 ? n : !1, i = e, o = e.displayName || e.name;
  if (Yx && e.$$typeof === Yx && (r = !0, i = e.render, typeof i != "function"))
    throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
  var a = function(s, l) {
    return KW(function() {
      return i(s, l);
    }, o);
  };
  return a.displayName = e.displayName, HW && Object.defineProperty(a, "name", {
    value: e.name,
    writable: !0,
    configurable: !0
  }), e.contextTypes && (a.contextTypes = e.contextTypes, process.env.NODE_ENV !== "production" && Gx && (Gx = !1, console.warn("[mobx-react-lite] Support for Legacy Context in function components will be removed in the next major release."))), r && (a = Xt(a)), a = Bf(a), GW(e, a), process.env.NODE_ENV !== "production" && Object.defineProperty(a, "contextTypes", {
    set: function() {
      var s, l;
      throw new Error("[mobx-react-lite] `".concat(this.displayName || ((s = this.type) === null || s === void 0 ? void 0 : s.displayName) || ((l = this.type) === null || l === void 0 ? void 0 : l.name) || "Component", ".contextTypes` must be set before applying `observer`."));
    }
  }), a;
}
var ZW = {
  $$typeof: !0,
  render: !0,
  compare: !0,
  type: !0,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: !0
};
function GW(e, t) {
  Object.keys(e).forEach(function(n) {
    ZW[n] || Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(e, n));
  });
}
process.env.NODE_ENV;
function YW(e, t) {
  return Fe(function() {
    return ln(e(), t, { autoBind: !0 });
  })[0];
}
var iv;
FW(bI);
iv = Fu.finalizeAllImmediately;
function QW(e, t) {
  if (Jx(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (var i = 0; i < n.length; i++)
    if (!Object.hasOwnProperty.call(t, n[i]) || !Jx(e[n[i]], t[n[i]]))
      return !1;
  return !0;
}
function Jx(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
var Xx = /* @__PURE__ */ Symbol("patchMixins"), d4 = /* @__PURE__ */ Symbol("patchedDefinition");
function JW(e, t) {
  var n = e[Xx] = e[Xx] || {}, r = n[t] = n[t] || {};
  return r.locks = r.locks || 0, r.methods = r.methods || [], r;
}
function eE(e, t) {
  for (var n = this, r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), o = 2; o < r; o++)
    i[o - 2] = arguments[o];
  t.locks++;
  try {
    var a;
    return e != null && (a = e.apply(this, i)), a;
  } finally {
    t.locks--, t.locks === 0 && t.methods.forEach(function(s) {
      s.apply(n, i);
    });
  }
}
function tE(e, t) {
  var n = function() {
    for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++)
      o[a] = arguments[a];
    eE.call.apply(eE, [this, e, t].concat(o));
  };
  return n;
}
function XW(e, t, n) {
  var r = JW(e, t);
  r.methods.indexOf(n) < 0 && r.methods.push(n);
  var i = Object.getOwnPropertyDescriptor(e, t);
  if (!(i && i[d4])) {
    var o = e[t], a = p4(e, t, i ? i.enumerable : void 0, r, o);
    Object.defineProperty(e, t, a);
  }
}
function p4(e, t, n, r, i) {
  var o, a = tE(i, r);
  return o = {}, o[d4] = !0, o.get = function() {
    return a;
  }, o.set = function(l) {
    if (this === e)
      a = tE(l, r);
    else {
      var u = p4(this, t, n, r, l);
      Object.defineProperty(this, t, u);
    }
  }, o.configurable = !0, o.enumerable = n, o;
}
var nE = /* @__PURE__ */ Symbol("ObserverAdministration"), rE = /* @__PURE__ */ Symbol("isMobXReactObserver"), h4;
process.env.NODE_ENV !== "production" && (h4 = {
  props: /* @__PURE__ */ ov("props"),
  state: /* @__PURE__ */ ov("state"),
  context: /* @__PURE__ */ ov("context")
});
function zu(e) {
  var t;
  return (t = e[nE]) != null ? t : e[nE] = {
    reaction: null,
    mounted: !1,
    reactionInvalidatedBeforeMount: !1,
    forceUpdate: null,
    name: Df(e.constructor),
    state: void 0,
    props: void 0,
    context: void 0
  };
}
function eZ(e) {
  var t = e.prototype;
  if (e[rE]) {
    var n = Df(e);
    throw new Error("The provided component class (" + n + ") has already been declared as an observer component.");
  } else
    e[rE] = !0;
  if (t.componentWillReact)
    throw new Error("The componentWillReact life-cycle event is no longer supported");
  if (e.__proto__ !== U2) {
    if (!t.shouldComponentUpdate)
      t.shouldComponentUpdate = iE;
    else if (t.shouldComponentUpdate !== iE)
      throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
  }
  process.env.NODE_ENV !== "production" && Object.defineProperties(t, h4);
  var r = t.render;
  if (typeof r != "function") {
    var i = Df(e);
    throw new Error("[mobx-react] class component (" + i + ") is missing `render` method.\n`observer` requires `render` being a function defined on prototype.\n`render = () => {}` or `render = function() {}` is not supported.");
  }
  t.render = function() {
    return Object.defineProperty(this, "render", {
      // There is no safe way to replace render, therefore it's forbidden.
      configurable: !1,
      writable: !1,
      value: tZ.call(this, r)
    }), this.render();
  };
  var o = t.componentDidMount;
  return t.componentDidMount = function() {
    var a = this;
    if (process.env.NODE_ENV !== "production" && this.componentDidMount !== Object.getPrototypeOf(this).componentDidMount) {
      var s = Df(e);
      throw new Error("[mobx-react] `observer(" + s + ").componentDidMount` must be defined on prototype.\n`componentDidMount = () => {}` or `componentDidMount = function() {}` is not supported.");
    }
    var l = zu(this);
    return l.mounted = !0, Fu.unregister(this), l.forceUpdate = function() {
      return a.forceUpdate();
    }, (!l.reaction || l.reactionInvalidatedBeforeMount) && l.forceUpdate(), o?.apply(this, arguments);
  }, XW(t, "componentWillUnmount", function() {
    var a, s = zu(this);
    (a = s.reaction) == null || a.dispose(), s.reaction = null, s.forceUpdate = null, s.mounted = !1, s.reactionInvalidatedBeforeMount = !1;
  }), e;
}
function Df(e) {
  return e.displayName || e.name || "<component>";
}
function tZ(e) {
  var t = e.bind(this), n = zu(this);
  function r() {
    n.reaction || (n.reaction = nZ(n), n.mounted || Fu.register(this, n, this));
    var i = void 0, o = void 0;
    if (n.reaction.track(function() {
      try {
        o = FH(!1, t);
      } catch (a) {
        i = a;
      }
    }), i)
      throw i;
    return o;
  }
  return r;
}
function nZ(e) {
  return new Si(e.name + ".render()", function() {
    if (!e.mounted) {
      e.reactionInvalidatedBeforeMount = !0;
      return;
    }
    try {
      e.forceUpdate == null || e.forceUpdate();
    } catch {
      var t;
      (t = e.reaction) == null || t.dispose(), e.reaction = null;
    }
  });
}
function iE(e, t) {
  return this.state !== t ? !0 : !QW(this.props, e);
}
function ov(e) {
  return {
    configurable: !0,
    enumerable: !0,
    get: function() {
      var n = zu(this), r = KH().trackingDerivation;
      if (r && r !== n.reaction)
        throw new Error('[mobx-react] Cannot read "' + n.name + "." + e + `" in a reactive context, as it isn't observable.
                    Please use component lifecycle method to copy the value into a local observable first.
                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations`);
      return n[e];
    },
    set: function(n) {
      zu(this)[e] = n;
    }
  };
}
function v4(e, t) {
  return e.isMobxInjector === !0 && console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`"), Object.prototype.isPrototypeOf.call(iy, e) || Object.prototype.isPrototypeOf.call(U2, e) ? eZ(e) : WW(e);
}
W.version.split(".")[0];
if (!iy)
  throw new Error("mobx-react requires React to be available");
if (!ln)
  throw new Error("mobx-react requires mobx to be available");
const m4 = Le({
  dragDropManager: void 0
});
function dr(e) {
  return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
}
var oE = (function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
})(), aE = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, sE = {
  INIT: "@@redux/INIT" + aE(),
  REPLACE: "@@redux/REPLACE" + aE()
};
function rZ(e) {
  if (typeof e != "object" || e === null) return !1;
  for (var t = e; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function iZ(e) {
  if (e === void 0) return "undefined";
  if (e === null) return "null";
  var t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e)) return "array";
  if (sZ(e)) return "date";
  if (aZ(e)) return "error";
  var n = oZ(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return t.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function oZ(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function aZ(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function sZ(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function Ha(e) {
  var t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = iZ(e)), t;
}
function g4(e, t, n) {
  var r;
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? dr(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? dr(1) : "Expected the enhancer to be a function. Instead, received: '" + Ha(n) + "'");
    return n(g4)(e, t);
  }
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? dr(2) : "Expected the root reducer to be a function. Instead, received: '" + Ha(e) + "'");
  var i = e, o = t, a = [], s = a, l = !1;
  function u() {
    s === a && (s = a.slice());
  }
  function c() {
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? dr(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return o;
  }
  function f(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? dr(4) : "Expected the listener to be a function. Instead, received: '" + Ha(v) + "'");
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? dr(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    var m = !0;
    return u(), s.push(v), function() {
      if (m) {
        if (l)
          throw new Error(process.env.NODE_ENV === "production" ? dr(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        m = !1, u();
        var y = s.indexOf(v);
        s.splice(y, 1), a = null;
      }
    };
  }
  function d(v) {
    if (!rZ(v))
      throw new Error(process.env.NODE_ENV === "production" ? dr(7) : "Actions must be plain objects. Instead, the actual type was: '" + Ha(v) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    if (typeof v.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? dr(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (l)
      throw new Error(process.env.NODE_ENV === "production" ? dr(9) : "Reducers may not dispatch actions.");
    try {
      l = !0, o = i(o, v);
    } finally {
      l = !1;
    }
    for (var m = a = s, g = 0; g < m.length; g++) {
      var y = m[g];
      y();
    }
    return v;
  }
  function p(v) {
    if (typeof v != "function")
      throw new Error(process.env.NODE_ENV === "production" ? dr(10) : "Expected the nextReducer to be a function. Instead, received: '" + Ha(v));
    i = v, d({
      type: sE.REPLACE
    });
  }
  function h() {
    var v, m = f;
    return v = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(y) {
        if (typeof y != "object" || y === null)
          throw new Error(process.env.NODE_ENV === "production" ? dr(11) : "Expected the observer to be an object. Instead, received: '" + Ha(y) + "'");
        function w() {
          y.next && y.next(c());
        }
        w();
        var x = m(w);
        return {
          unsubscribe: x
        };
      }
    }, v[oE] = function() {
      return this;
    }, v;
  }
  return d({
    type: sE.INIT
  }), r = {
    dispatch: d,
    subscribe: f,
    getState: c,
    replaceReducer: p
  }, r[oE] = h, r;
}
function Ge(e, t, ...n) {
  if (lZ() && t === void 0)
    throw new Error("invariant requires an error message argument");
  if (!e) {
    let r;
    if (t === void 0)
      r = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let i = 0;
      r = new Error(t.replace(/%s/g, function() {
        return n[i++];
      })), r.name = "Invariant Violation";
    }
    throw r.framesToPop = 1, r;
  }
}
function lZ() {
  return typeof process < "u" && process.env.NODE_ENV === "production";
}
function uZ(e, t, n) {
  return t.split(".").reduce(
    (r, i) => r && r[i] ? r[i] : n || null,
    e
  );
}
function cZ(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function y4(e) {
  return typeof e == "object";
}
function fZ(e, t) {
  const n = /* @__PURE__ */ new Map(), r = (o) => {
    n.set(o, n.has(o) ? n.get(o) + 1 : 1);
  };
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach((o, a) => {
    o === 1 && i.push(a);
  }), i;
}
function dZ(e, t) {
  return e.filter(
    (n) => t.indexOf(n) > -1
  );
}
const Bb = "dnd-core/INIT_COORDS", Ip = "dnd-core/BEGIN_DRAG", Ub = "dnd-core/PUBLISH_DRAG_SOURCE", Np = "dnd-core/HOVER", Rp = "dnd-core/DROP", Mp = "dnd-core/END_DRAG";
function lE(e, t) {
  return {
    type: Bb,
    payload: {
      sourceClientOffset: t || null,
      clientOffset: e || null
    }
  };
}
const pZ = {
  type: Bb,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function hZ(e) {
  return function(n = [], r = {
    publishSource: !0
  }) {
    const { publishSource: i = !0, clientOffset: o, getSourceClientOffset: a } = r, s = e.getMonitor(), l = e.getRegistry();
    e.dispatch(lE(o)), vZ(n, s, l);
    const u = yZ(n, s);
    if (u == null) {
      e.dispatch(pZ);
      return;
    }
    let c = null;
    if (o) {
      if (!a)
        throw new Error("getSourceClientOffset must be defined");
      mZ(a), c = a(u);
    }
    e.dispatch(lE(o, c));
    const d = l.getSource(u).beginDrag(s, u);
    if (d == null)
      return;
    gZ(d), l.pinSource(u);
    const p = l.getSourceType(u);
    return {
      type: Ip,
      payload: {
        itemType: p,
        item: d,
        sourceId: u,
        clientOffset: o || null,
        sourceClientOffset: c || null,
        isSourcePublic: !!i
      }
    };
  };
}
function vZ(e, t, n) {
  Ge(!t.isDragging(), "Cannot call beginDrag while dragging."), e.forEach(function(r) {
    Ge(n.getSource(r), "Expected sourceIds to be registered.");
  });
}
function mZ(e) {
  Ge(typeof e == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function gZ(e) {
  Ge(y4(e), "Item must be an object.");
}
function yZ(e, t) {
  let n = null;
  for (let r = e.length - 1; r >= 0; r--)
    if (t.canDragSource(e[r])) {
      n = e[r];
      break;
    }
  return n;
}
function bZ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function _Z(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      bZ(e, i, n[i]);
    });
  }
  return e;
}
function wZ(e) {
  return function(n = {}) {
    const r = e.getMonitor(), i = e.getRegistry();
    xZ(r), OZ(r).forEach((a, s) => {
      const l = EZ(a, s, i, r), u = {
        type: Rp,
        payload: {
          dropResult: _Z({}, n, l)
        }
      };
      e.dispatch(u);
    });
  };
}
function xZ(e) {
  Ge(e.isDragging(), "Cannot call drop while not dragging."), Ge(!e.didDrop(), "Cannot call drop twice during one drag operation.");
}
function EZ(e, t, n, r) {
  const i = n.getTarget(e);
  let o = i ? i.drop(r, e) : void 0;
  return SZ(o), typeof o > "u" && (o = t === 0 ? {} : r.getDropResult()), o;
}
function SZ(e) {
  Ge(typeof e > "u" || y4(e), "Drop result must either be an object or undefined.");
}
function OZ(e) {
  const t = e.getTargetIds().filter(e.canDropOnTarget, e);
  return t.reverse(), t;
}
function $Z(e) {
  return function() {
    const n = e.getMonitor(), r = e.getRegistry();
    TZ(n);
    const i = n.getSourceId();
    return i != null && (r.getSource(i, !0).endDrag(n, i), r.unpinSource()), {
      type: Mp
    };
  };
}
function TZ(e) {
  Ge(e.isDragging(), "Cannot call endDrag while not dragging.");
}
function fg(e, t) {
  return t === null ? e === null : Array.isArray(e) ? e.some(
    (n) => n === t
  ) : e === t;
}
function kZ(e) {
  return function(n, { clientOffset: r } = {}) {
    PZ(n);
    const i = n.slice(0), o = e.getMonitor(), a = e.getRegistry(), s = o.getItemType();
    return AZ(i, a, s), DZ(i, o, a), CZ(i, o, a), {
      type: Np,
      payload: {
        targetIds: i,
        clientOffset: r || null
      }
    };
  };
}
function PZ(e) {
  Ge(Array.isArray(e), "Expected targetIds to be an array.");
}
function DZ(e, t, n) {
  Ge(t.isDragging(), "Cannot call hover while not dragging."), Ge(!t.didDrop(), "Cannot call hover after drop.");
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    Ge(e.lastIndexOf(i) === r, "Expected targetIds to be unique in the passed array.");
    const o = n.getTarget(i);
    Ge(o, "Expected targetIds to be registered.");
  }
}
function AZ(e, t, n) {
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r], o = t.getTargetType(i);
    fg(o, n) || e.splice(r, 1);
  }
}
function CZ(e, t, n) {
  e.forEach(function(r) {
    n.getTarget(r).hover(t, r);
  });
}
function IZ(e) {
  return function() {
    if (e.getMonitor().isDragging())
      return {
        type: Ub
      };
  };
}
function NZ(e) {
  return {
    beginDrag: hZ(e),
    publishDragSource: IZ(e),
    hover: kZ(e),
    drop: wZ(e),
    endDrag: $Z(e)
  };
}
class RZ {
  receiveBackend(t) {
    this.backend = t;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const t = this, { dispatch: n } = this.store;
    function r(o) {
      return (...a) => {
        const s = o.apply(t, a);
        typeof s < "u" && n(s);
      };
    }
    const i = NZ(this);
    return Object.keys(i).reduce((o, a) => {
      const s = i[a];
      return o[a] = r(s), o;
    }, {});
  }
  dispatch(t) {
    this.store.dispatch(t);
  }
  constructor(t, n) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const r = this.store.getState().refCount > 0;
      this.backend && (r && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !r && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = t, this.monitor = n, t.subscribe(this.handleRefCountChange);
  }
}
function MZ(e, t) {
  return {
    x: e.x + t.x,
    y: e.y + t.y
  };
}
function b4(e, t) {
  return {
    x: e.x - t.x,
    y: e.y - t.y
  };
}
function jZ(e) {
  const { clientOffset: t, initialClientOffset: n, initialSourceClientOffset: r } = e;
  return !t || !n || !r ? null : b4(MZ(t, r), n);
}
function FZ(e) {
  const { clientOffset: t, initialClientOffset: n } = e;
  return !t || !n ? null : b4(t, n);
}
const fu = [], Kb = [];
fu.__IS_NONE__ = !0;
Kb.__IS_ALL__ = !0;
function zZ(e, t) {
  return e === fu ? !1 : e === Kb || typeof t > "u" ? !0 : dZ(t, e).length > 0;
}
class LZ {
  subscribeToStateChange(t, n = {}) {
    const { handlerIds: r } = n;
    Ge(typeof t == "function", "listener must be a function."), Ge(typeof r > "u" || Array.isArray(r), "handlerIds, when specified, must be an array of strings.");
    let i = this.store.getState().stateId;
    const o = () => {
      const a = this.store.getState(), s = a.stateId;
      try {
        s === i || s === i + 1 && !zZ(a.dirtyHandlerIds, r) || t();
      } finally {
        i = s;
      }
    };
    return this.store.subscribe(o);
  }
  subscribeToOffsetChange(t) {
    Ge(typeof t == "function", "listener must be a function.");
    let n = this.store.getState().dragOffset;
    const r = () => {
      const i = this.store.getState().dragOffset;
      i !== n && (n = i, t());
    };
    return this.store.subscribe(r);
  }
  canDragSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t);
    return Ge(n, `Expected to find a valid source. sourceId=${t}`), this.isDragging() ? !1 : n.canDrag(this, t);
  }
  canDropOnTarget(t) {
    if (!t)
      return !1;
    const n = this.registry.getTarget(t);
    if (Ge(n, `Expected to find a valid target. targetId=${t}`), !this.isDragging() || this.didDrop())
      return !1;
    const r = this.registry.getTargetType(t), i = this.getItemType();
    return fg(r, i) && n.canDrop(this, t);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(t) {
    if (!t)
      return !1;
    const n = this.registry.getSource(t, !0);
    if (Ge(n, `Expected to find a valid source. sourceId=${t}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const r = this.registry.getSourceType(t), i = this.getItemType();
    return r !== i ? !1 : n.isDragging(this, t);
  }
  isOverTarget(t, n = {
    shallow: !1
  }) {
    if (!t)
      return !1;
    const { shallow: r } = n;
    if (!this.isDragging())
      return !1;
    const i = this.registry.getTargetType(t), o = this.getItemType();
    if (o && !fg(i, o))
      return !1;
    const a = this.getTargetIds();
    if (!a.length)
      return !1;
    const s = a.indexOf(t);
    return r ? s === a.length - 1 : s > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return jZ(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return FZ(this.store.getState().dragOffset);
  }
  constructor(t, n) {
    this.store = t, this.registry = n;
  }
}
const uE = typeof global < "u" ? global : self, _4 = uE.MutationObserver || uE.WebKitMutationObserver;
function w4(e) {
  return function() {
    const n = setTimeout(i, 0), r = setInterval(i, 50);
    function i() {
      clearTimeout(n), clearInterval(r), e();
    }
  };
}
function VZ(e) {
  let t = 1;
  const n = new _4(e), r = document.createTextNode("");
  return n.observe(r, {
    characterData: !0
  }), function() {
    t = -t, r.data = t;
  };
}
const BZ = typeof _4 == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  VZ
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  w4
);
class UZ {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(t) {
    const { queue: n, requestFlush: r } = this;
    n.length || (r(), this.flushing = !0), n[n.length] = t;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: t } = this;
      for (; this.index < t.length; ) {
        const n = this.index;
        if (this.index++, t[n].call(), this.index > this.capacity) {
          for (let r = 0, i = t.length - this.index; r < i; r++)
            t[r] = t[r + this.index];
          t.length -= this.index, this.index = 0;
        }
      }
      t.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (t) => {
      this.pendingErrors.push(t), this.requestErrorThrow();
    }, this.requestFlush = BZ(this.flush), this.requestErrorThrow = w4(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class KZ {
  call() {
    try {
      this.task && this.task();
    } catch (t) {
      this.onError(t);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(t, n) {
    this.onError = t, this.release = n, this.task = null;
  }
}
class qZ {
  create(t) {
    const n = this.freeTasks, r = n.length ? n.pop() : new KZ(
      this.onError,
      (i) => n[n.length] = i
    );
    return r.task = t, r;
  }
  constructor(t) {
    this.onError = t, this.freeTasks = [];
  }
}
const x4 = new UZ(), HZ = new qZ(x4.registerPendingError);
function WZ(e) {
  x4.enqueueTask(HZ.create(e));
}
const qb = "dnd-core/ADD_SOURCE", Hb = "dnd-core/ADD_TARGET", Wb = "dnd-core/REMOVE_SOURCE", jp = "dnd-core/REMOVE_TARGET";
function ZZ(e) {
  return {
    type: qb,
    payload: {
      sourceId: e
    }
  };
}
function GZ(e) {
  return {
    type: Hb,
    payload: {
      targetId: e
    }
  };
}
function YZ(e) {
  return {
    type: Wb,
    payload: {
      sourceId: e
    }
  };
}
function QZ(e) {
  return {
    type: jp,
    payload: {
      targetId: e
    }
  };
}
function JZ(e) {
  Ge(typeof e.canDrag == "function", "Expected canDrag to be a function."), Ge(typeof e.beginDrag == "function", "Expected beginDrag to be a function."), Ge(typeof e.endDrag == "function", "Expected endDrag to be a function.");
}
function XZ(e) {
  Ge(typeof e.canDrop == "function", "Expected canDrop to be a function."), Ge(typeof e.hover == "function", "Expected hover to be a function."), Ge(typeof e.drop == "function", "Expected beginDrag to be a function.");
}
function dg(e, t) {
  if (t && Array.isArray(e)) {
    e.forEach(
      (n) => dg(n, !1)
    );
    return;
  }
  Ge(typeof e == "string" || typeof e == "symbol", t ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var mr;
(function(e) {
  e.SOURCE = "SOURCE", e.TARGET = "TARGET";
})(mr || (mr = {}));
let eG = 0;
function tG() {
  return eG++;
}
function nG(e) {
  const t = tG().toString();
  switch (e) {
    case mr.SOURCE:
      return `S${t}`;
    case mr.TARGET:
      return `T${t}`;
    default:
      throw new Error(`Unknown Handler Role: ${e}`);
  }
}
function cE(e) {
  switch (e[0]) {
    case "S":
      return mr.SOURCE;
    case "T":
      return mr.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${e}`);
  }
}
function fE(e, t) {
  const n = e.entries();
  let r = !1;
  do {
    const { done: i, value: [, o] } = n.next();
    if (o === t)
      return !0;
    r = !!i;
  } while (!r);
  return !1;
}
class rG {
  addSource(t, n) {
    dg(t), JZ(n);
    const r = this.addHandler(mr.SOURCE, t, n);
    return this.store.dispatch(ZZ(r)), r;
  }
  addTarget(t, n) {
    dg(t, !0), XZ(n);
    const r = this.addHandler(mr.TARGET, t, n);
    return this.store.dispatch(GZ(r)), r;
  }
  containsHandler(t) {
    return fE(this.dragSources, t) || fE(this.dropTargets, t);
  }
  getSource(t, n = !1) {
    return Ge(this.isSourceId(t), "Expected a valid source ID."), n && t === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(t);
  }
  getTarget(t) {
    return Ge(this.isTargetId(t), "Expected a valid target ID."), this.dropTargets.get(t);
  }
  getSourceType(t) {
    return Ge(this.isSourceId(t), "Expected a valid source ID."), this.types.get(t);
  }
  getTargetType(t) {
    return Ge(this.isTargetId(t), "Expected a valid target ID."), this.types.get(t);
  }
  isSourceId(t) {
    return cE(t) === mr.SOURCE;
  }
  isTargetId(t) {
    return cE(t) === mr.TARGET;
  }
  removeSource(t) {
    Ge(this.getSource(t), "Expected an existing source."), this.store.dispatch(YZ(t)), WZ(() => {
      this.dragSources.delete(t), this.types.delete(t);
    });
  }
  removeTarget(t) {
    Ge(this.getTarget(t), "Expected an existing target."), this.store.dispatch(QZ(t)), this.dropTargets.delete(t), this.types.delete(t);
  }
  pinSource(t) {
    const n = this.getSource(t);
    Ge(n, "Expected an existing source."), this.pinnedSourceId = t, this.pinnedSource = n;
  }
  unpinSource() {
    Ge(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(t, n, r) {
    const i = nG(t);
    return this.types.set(i, n), t === mr.SOURCE ? this.dragSources.set(i, r) : t === mr.TARGET && this.dropTargets.set(i, r), i;
  }
  constructor(t) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = t;
  }
}
const iG = (e, t) => e === t;
function oG(e, t) {
  return !e && !t ? !0 : !e || !t ? !1 : e.x === t.x && e.y === t.y;
}
function aG(e, t, n = iG) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; ++r)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function sG(e = fu, t) {
  switch (t.type) {
    case Np:
      break;
    case qb:
    case Hb:
    case jp:
    case Wb:
      return fu;
    case Ip:
    case Ub:
    case Mp:
    case Rp:
    default:
      return Kb;
  }
  const { targetIds: n = [], prevTargetIds: r = [] } = t.payload, i = fZ(n, r);
  if (!(i.length > 0 || !aG(n, r)))
    return fu;
  const a = r[r.length - 1], s = n[n.length - 1];
  return a !== s && (a && i.push(a), s && i.push(s)), i;
}
function lG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function uG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      lG(e, i, n[i]);
    });
  }
  return e;
}
const dE = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function cG(e = dE, t) {
  const { payload: n } = t;
  switch (t.type) {
    case Bb:
    case Ip:
      return {
        initialSourceClientOffset: n.sourceClientOffset,
        initialClientOffset: n.clientOffset,
        clientOffset: n.clientOffset
      };
    case Np:
      return oG(e.clientOffset, n.clientOffset) ? e : uG({}, e, {
        clientOffset: n.clientOffset
      });
    case Mp:
    case Rp:
      return dE;
    default:
      return e;
  }
}
function fG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Wa(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      fG(e, i, n[i]);
    });
  }
  return e;
}
const dG = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function pG(e = dG, t) {
  const { payload: n } = t;
  switch (t.type) {
    case Ip:
      return Wa({}, e, {
        itemType: n.itemType,
        item: n.item,
        sourceId: n.sourceId,
        isSourcePublic: n.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case Ub:
      return Wa({}, e, {
        isSourcePublic: !0
      });
    case Np:
      return Wa({}, e, {
        targetIds: n.targetIds
      });
    case jp:
      return e.targetIds.indexOf(n.targetId) === -1 ? e : Wa({}, e, {
        targetIds: cZ(e.targetIds, n.targetId)
      });
    case Rp:
      return Wa({}, e, {
        dropResult: n.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case Mp:
      return Wa({}, e, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return e;
  }
}
function hG(e = 0, t) {
  switch (t.type) {
    case qb:
    case Hb:
      return e + 1;
    case Wb:
    case jp:
      return e - 1;
    default:
      return e;
  }
}
function vG(e = 0) {
  return e + 1;
}
function mG(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function gG(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      mG(e, i, n[i]);
    });
  }
  return e;
}
function yG(e = {}, t) {
  return {
    dirtyHandlerIds: sG(e.dirtyHandlerIds, {
      type: t.type,
      payload: gG({}, t.payload, {
        prevTargetIds: uZ(e, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: cG(e.dragOffset, t),
    refCount: hG(e.refCount, t),
    dragOperation: pG(e.dragOperation, t),
    stateId: vG(e.stateId)
  };
}
function bG(e, t = void 0, n = {}, r = !1) {
  const i = _G(r), o = new LZ(i, new rG(i)), a = new RZ(i, o), s = e(a, t, n);
  return a.receiveBackend(s), a;
}
function _G(e) {
  const t = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return g4(yG, e && t && t({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function wG(e, t) {
  if (e == null) return {};
  var n = xG(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function xG(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
let pE = 0;
const Af = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var EG = /* @__PURE__ */ Bf(function(t) {
  var { children: n } = t, r = wG(t, [
    "children"
  ]);
  const [i, o] = SG(r);
  return Se(() => {
    if (o) {
      const a = E4();
      return ++pE, () => {
        --pE === 0 && (a[Af] = null);
      };
    }
  }, []), /* @__PURE__ */ M.jsx(m4.Provider, {
    value: i,
    children: n
  });
});
function SG(e) {
  if ("manager" in e)
    return [
      {
        dragDropManager: e.manager
      },
      !1
    ];
  const t = OG(e.backend, e.context, e.options, e.debugMode), n = !e.context;
  return [
    t,
    n
  ];
}
function OG(e, t = E4(), n, r) {
  const i = t;
  return i[Af] || (i[Af] = {
    dragDropManager: bG(e, t, n, r)
  }), i[Af];
}
function E4() {
  return typeof global < "u" ? global : window;
}
var av, hE;
function $G() {
  return hE || (hE = 1, av = function e(t, n) {
    if (t === n) return !0;
    if (t && n && typeof t == "object" && typeof n == "object") {
      if (t.constructor !== n.constructor) return !1;
      var r, i, o;
      if (Array.isArray(t)) {
        if (r = t.length, r != n.length) return !1;
        for (i = r; i-- !== 0; )
          if (!e(t[i], n[i])) return !1;
        return !0;
      }
      if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
      if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
      if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
      if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length) return !1;
      for (i = r; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
      for (i = r; i-- !== 0; ) {
        var a = o[i];
        if (!e(t[a], n[a])) return !1;
      }
      return !0;
    }
    return t !== t && n !== n;
  }), av;
}
var TG = $G();
const kG = /* @__PURE__ */ Wd(TG), Ea = typeof window < "u" ? V2 : Se;
function PG(e, t, n) {
  const [r, i] = Fe(
    () => t(e)
  ), o = Me(() => {
    const a = t(e);
    kG(r, a) || (i(a), n && n());
  }, [
    r,
    e,
    n
  ]);
  return Ea(o), [
    r,
    o
  ];
}
function DG(e, t, n) {
  const [r, i] = PG(e, t, n);
  return Ea(function() {
    const a = e.getHandlerId();
    if (a != null)
      return e.subscribeToStateChange(i, {
        handlerIds: [
          a
        ]
      });
  }, [
    e,
    i
  ]), r;
}
function S4(e, t, n) {
  return DG(
    t,
    e || (() => ({})),
    () => n.reconnect()
  );
}
function O4(e, t) {
  const n = [];
  return typeof e != "function" && n.push(e), $e(() => typeof e == "function" ? e() : e, n);
}
function AG(e) {
  return $e(
    () => e.hooks.dragSource(),
    [
      e
    ]
  );
}
function CG(e) {
  return $e(
    () => e.hooks.dragPreview(),
    [
      e
    ]
  );
}
let sv = !1, lv = !1;
class IG {
  receiveHandlerId(t) {
    this.sourceId = t;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    Ge(!sv, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return sv = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      sv = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    Ge(!lv, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return lv = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      lv = !1;
    }
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  isDraggingSource(t) {
    return this.internalMonitor.isDraggingSource(t);
  }
  isOverTarget(t, n) {
    return this.internalMonitor.isOverTarget(t, n);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(t) {
    return this.internalMonitor.subscribeToOffsetChange(t);
  }
  canDragSource(t) {
    return this.internalMonitor.canDragSource(t);
  }
  canDropOnTarget(t) {
    return this.internalMonitor.canDropOnTarget(t);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.sourceId = null, this.internalMonitor = t.getMonitor();
  }
}
let uv = !1;
class NG {
  receiveHandlerId(t) {
    this.targetId = t;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(t, n) {
    return this.internalMonitor.subscribeToStateChange(t, n);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    Ge(!uv, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return uv = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      uv = !1;
    }
  }
  isOver(t) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, t) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(t) {
    this.targetId = null, this.internalMonitor = t.getMonitor();
  }
}
function RG(e, t, n) {
  const r = n.getRegistry(), i = r.addTarget(e, t);
  return [
    i,
    () => r.removeTarget(i)
  ];
}
function MG(e, t, n) {
  const r = n.getRegistry(), i = r.addSource(e, t);
  return [
    i,
    () => r.removeSource(i)
  ];
}
function pg(e, t, n, r) {
  let i;
  if (i !== void 0)
    return !!i;
  if (e === t)
    return !0;
  if (typeof e != "object" || !e || typeof t != "object" || !t)
    return !1;
  const o = Object.keys(e), a = Object.keys(t);
  if (o.length !== a.length)
    return !1;
  const s = Object.prototype.hasOwnProperty.bind(t);
  for (let l = 0; l < o.length; l++) {
    const u = o[l];
    if (!s(u))
      return !1;
    const c = e[u], f = t[u];
    if (i = void 0, i === !1 || i === void 0 && c !== f)
      return !1;
  }
  return !0;
}
function hg(e) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    e !== null && typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current")
  );
}
function jG(e) {
  if (typeof e.type == "string")
    return;
  const t = e.type.displayName || e.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${t} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function FG(e) {
  return (t = null, n = null) => {
    if (!ry(t)) {
      const o = t;
      return e(o, n), o;
    }
    const r = t;
    return jG(r), zG(r, n ? (o) => e(o, n) : e);
  };
}
function $4(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    if (n.endsWith("Ref"))
      t[n] = e[n];
    else {
      const i = FG(r);
      t[n] = () => i;
    }
  }), t;
}
function vE(e, t) {
  typeof e == "function" ? e(t) : e.current = t;
}
function zG(e, t) {
  const n = e.ref;
  return Ge(typeof n != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), n ? bu(e, {
    ref: (r) => {
      vE(n, r), vE(t, r);
    }
  }) : bu(e, {
    ref: t
  });
}
class LG {
  receiveHandlerId(t) {
    this.handlerId !== t && (this.handlerId = t, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(t) {
    this.dragSourceOptionsInternal = t;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(t) {
    this.dragPreviewOptionsInternal = t;
  }
  reconnect() {
    const t = this.reconnectDragSource();
    this.reconnectDragPreview(t);
  }
  reconnectDragSource() {
    const t = this.dragSource, n = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return n && this.disconnectDragSource(), this.handlerId ? t ? (n && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = t, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, t, this.dragSourceOptions)), n) : (this.lastConnectedDragSource = t, n) : n;
  }
  reconnectDragPreview(t = !1) {
    const n = this.dragPreview, r = t || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (r && this.disconnectDragPreview(), !!this.handlerId) {
      if (!n) {
        this.lastConnectedDragPreview = n;
        return;
      }
      r && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = n, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, n, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !pg(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !pg(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(t) {
    this.hooks = $4({
      dragSource: (n, r) => {
        this.clearDragSource(), this.dragSourceOptions = r || null, hg(n) ? this.dragSourceRef = n : this.dragSourceNode = n, this.reconnectDragSource();
      },
      dragPreview: (n, r) => {
        this.clearDragPreview(), this.dragPreviewOptions = r || null, hg(n) ? this.dragPreviewRef = n : this.dragPreviewNode = n, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = t;
  }
}
class VG {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const t = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    t && this.disconnectDropTarget();
    const n = this.dropTarget;
    if (this.handlerId) {
      if (!n) {
        this.lastConnectedDropTarget = n;
        return;
      }
      t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = n, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, n, this.dropTargetOptions));
    }
  }
  receiveHandlerId(t) {
    t !== this.handlerId && (this.handlerId = t, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(t) {
    this.dropTargetOptionsInternal = t;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !pg(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(t) {
    this.hooks = $4({
      dropTarget: (n, r) => {
        this.clearDropTarget(), this.dropTargetOptions = r, hg(n) ? this.dropTargetRef = n : this.dropTargetNode = n, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = t;
  }
}
function cl() {
  const { dragDropManager: e } = Ie(m4);
  return Ge(e != null, "Expected drag drop context"), e;
}
function BG(e, t) {
  const n = cl(), r = $e(
    () => new LG(n.getBackend()),
    [
      n
    ]
  );
  return Ea(() => (r.dragSourceOptions = e || null, r.reconnect(), () => r.disconnectDragSource()), [
    r,
    e
  ]), Ea(() => (r.dragPreviewOptions = t || null, r.reconnect(), () => r.disconnectDragPreview()), [
    r,
    t
  ]), r;
}
function UG() {
  const e = cl();
  return $e(
    () => new IG(e),
    [
      e
    ]
  );
}
class KG {
  beginDrag() {
    const t = this.spec, n = this.monitor;
    let r = null;
    return typeof t.item == "object" ? r = t.item : typeof t.item == "function" ? r = t.item(n) : r = {}, r ?? null;
  }
  canDrag() {
    const t = this.spec, n = this.monitor;
    return typeof t.canDrag == "boolean" ? t.canDrag : typeof t.canDrag == "function" ? t.canDrag(n) : !0;
  }
  isDragging(t, n) {
    const r = this.spec, i = this.monitor, { isDragging: o } = r;
    return o ? o(i) : n === t.getSourceId();
  }
  endDrag() {
    const t = this.spec, n = this.monitor, r = this.connector, { end: i } = t;
    i && i(n.getItem(), n), r.reconnect();
  }
  constructor(t, n, r) {
    this.spec = t, this.monitor = n, this.connector = r;
  }
}
function qG(e, t, n) {
  const r = $e(
    () => new KG(e, t, n),
    [
      t,
      n
    ]
  );
  return Se(() => {
    r.spec = e;
  }, [
    e
  ]), r;
}
function HG(e) {
  return $e(() => {
    const t = e.type;
    return Ge(t != null, "spec.type must be defined"), t;
  }, [
    e
  ]);
}
function WG(e, t, n) {
  const r = cl(), i = qG(e, t, n), o = HG(e);
  Ea(function() {
    if (o != null) {
      const [s, l] = MG(o, i, r);
      return t.receiveHandlerId(s), n.receiveHandlerId(s), l;
    }
  }, [
    r,
    t,
    n,
    i,
    o
  ]);
}
function T4(e, t) {
  const n = O4(e);
  Ge(!n.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const r = UG(), i = BG(n.options, n.previewOptions);
  return WG(n, r, i), [
    S4(n.collect, r, i),
    AG(i),
    CG(i)
  ];
}
function ZG(e) {
  return $e(
    () => e.hooks.dropTarget(),
    [
      e
    ]
  );
}
function GG(e) {
  const t = cl(), n = $e(
    () => new VG(t.getBackend()),
    [
      t
    ]
  );
  return Ea(() => (n.dropTargetOptions = e || null, n.reconnect(), () => n.disconnectDropTarget()), [
    e
  ]), n;
}
function YG() {
  const e = cl();
  return $e(
    () => new NG(e),
    [
      e
    ]
  );
}
function QG(e) {
  const { accept: t } = e;
  return $e(() => (Ge(e.accept != null, "accept must be defined"), Array.isArray(t) ? t : [
    t
  ]), [
    t
  ]);
}
class JG {
  canDrop() {
    const t = this.spec, n = this.monitor;
    return t.canDrop ? t.canDrop(n.getItem(), n) : !0;
  }
  hover() {
    const t = this.spec, n = this.monitor;
    t.hover && t.hover(n.getItem(), n);
  }
  drop() {
    const t = this.spec, n = this.monitor;
    if (t.drop)
      return t.drop(n.getItem(), n);
  }
  constructor(t, n) {
    this.spec = t, this.monitor = n;
  }
}
function XG(e, t) {
  const n = $e(
    () => new JG(e, t),
    [
      t
    ]
  );
  return Se(() => {
    n.spec = e;
  }, [
    e
  ]), n;
}
function eY(e, t, n) {
  const r = cl(), i = XG(e, t), o = QG(e);
  Ea(function() {
    const [s, l] = RG(o, i, r);
    return t.receiveHandlerId(s), n.receiveHandlerId(s), l;
  }, [
    r,
    t,
    i,
    n,
    o.map(
      (a) => a.toString()
    ).join("|")
  ]);
}
function tY(e, t) {
  const n = O4(e), r = YG(), i = GG(n.options);
  return eY(n, r, i), [
    S4(n.collect, r, i),
    ZG(i)
  ];
}
function k4(e) {
  let t = null;
  return () => (t == null && (t = e()), t);
}
function nY(e, t) {
  return e.filter(
    (n) => n !== t
  );
}
function rY(e, t) {
  const n = /* @__PURE__ */ new Set(), r = (o) => n.add(o);
  e.forEach(r), t.forEach(r);
  const i = [];
  return n.forEach(
    (o) => i.push(o)
  ), i;
}
class iY {
  enter(t) {
    const n = this.entered.length, r = (i) => this.isNodeInDocument(i) && (!i.contains || i.contains(t));
    return this.entered = rY(this.entered.filter(r), [
      t
    ]), n === 0 && this.entered.length > 0;
  }
  leave(t) {
    const n = this.entered.length;
    return this.entered = nY(this.entered.filter(this.isNodeInDocument), t), n > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(t) {
    this.entered = [], this.isNodeInDocument = t;
  }
}
class oY {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((t) => {
      Object.defineProperty(this.item, t, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${t}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(t) {
    if (t) {
      const n = {};
      Object.keys(this.config.exposeProperties).forEach((r) => {
        const i = this.config.exposeProperties[r];
        i != null && (n[r] = {
          value: i(t, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, n);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(t, n) {
    return n === t.getSourceId();
  }
  endDrag() {
  }
  constructor(t) {
    this.config = t, this.item = {}, this.initializeExposedProperties();
  }
}
const P4 = "__NATIVE_FILE__", D4 = "__NATIVE_URL__", A4 = "__NATIVE_TEXT__", C4 = "__NATIVE_HTML__", mE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE: P4,
  HTML: C4,
  TEXT: A4,
  URL: D4
}, Symbol.toStringTag, { value: "Module" }));
function cv(e, t, n) {
  const r = t.reduce(
    (i, o) => i || e.getData(o),
    ""
  );
  return r ?? n;
}
const vg = {
  [P4]: {
    exposeProperties: {
      files: (e) => Array.prototype.slice.call(e.files),
      items: (e) => e.items,
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Files"
    ]
  },
  [C4]: {
    exposeProperties: {
      html: (e, t) => cv(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [D4]: {
    exposeProperties: {
      urls: (e, t) => cv(e, t, "").split(`
`),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [A4]: {
    exposeProperties: {
      text: (e, t) => cv(e, t, ""),
      dataTransfer: (e) => e
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function aY(e, t) {
  const n = vg[e];
  if (!n)
    throw new Error(`native type ${e} has no configuration`);
  const r = new oY(n);
  return r.loadDataTransfer(t), r;
}
function fv(e) {
  if (!e)
    return null;
  const t = Array.prototype.slice.call(e.types || []);
  return Object.keys(vg).filter((n) => {
    const r = vg[n];
    return r?.matchesTypes ? r.matchesTypes.some(
      (i) => t.indexOf(i) > -1
    ) : !1;
  })[0] || null;
}
const sY = k4(
  () => /firefox/i.test(navigator.userAgent)
), I4 = k4(
  () => !!window.safari
);
class gE {
  interpolate(t) {
    const { xs: n, ys: r, c1s: i, c2s: o, c3s: a } = this;
    let s = n.length - 1;
    if (t === n[s])
      return r[s];
    let l = 0, u = a.length - 1, c;
    for (; l <= u; ) {
      c = Math.floor(0.5 * (l + u));
      const p = n[c];
      if (p < t)
        l = c + 1;
      else if (p > t)
        u = c - 1;
      else
        return r[c];
    }
    s = Math.max(0, u);
    const f = t - n[s], d = f * f;
    return r[s] + i[s] * f + o[s] * d + a[s] * f * d;
  }
  constructor(t, n) {
    const { length: r } = t, i = [];
    for (let p = 0; p < r; p++)
      i.push(p);
    i.sort(
      (p, h) => t[p] < t[h] ? -1 : 1
    );
    const o = [], a = [];
    let s, l;
    for (let p = 0; p < r - 1; p++)
      s = t[p + 1] - t[p], l = n[p + 1] - n[p], o.push(s), a.push(l / s);
    const u = [
      a[0]
    ];
    for (let p = 0; p < o.length - 1; p++) {
      const h = a[p], v = a[p + 1];
      if (h * v <= 0)
        u.push(0);
      else {
        s = o[p];
        const m = o[p + 1], g = s + m;
        u.push(3 * g / ((g + m) / h + (g + s) / v));
      }
    }
    u.push(a[a.length - 1]);
    const c = [], f = [];
    let d;
    for (let p = 0; p < u.length - 1; p++) {
      d = a[p];
      const h = u[p], v = 1 / o[p], m = h + u[p + 1] - d - d;
      c.push((d - h - m) * v), f.push(m * v * v);
    }
    this.xs = t, this.ys = n, this.c1s = u, this.c2s = c, this.c3s = f;
  }
}
const lY = 1;
function N4(e) {
  const t = e.nodeType === lY ? e : e.parentElement;
  if (!t)
    return null;
  const { top: n, left: r } = t.getBoundingClientRect();
  return {
    x: r,
    y: n
  };
}
function nf(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function uY(e) {
  var t;
  return e.nodeName === "IMG" && (sY() || !(!((t = document.documentElement) === null || t === void 0) && t.contains(e)));
}
function cY(e, t, n, r) {
  let i = e ? t.width : n, o = e ? t.height : r;
  return I4() && e && (o /= window.devicePixelRatio, i /= window.devicePixelRatio), {
    dragPreviewWidth: i,
    dragPreviewHeight: o
  };
}
function fY(e, t, n, r, i) {
  const o = uY(t), s = N4(o ? e : t), l = {
    x: n.x - s.x,
    y: n.y - s.y
  }, { offsetWidth: u, offsetHeight: c } = e, { anchorX: f, anchorY: d } = r, { dragPreviewWidth: p, dragPreviewHeight: h } = cY(o, t, u, c), v = () => {
    let O = new gE([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      l.y,
      // Align at the center
      l.y / c * h,
      // Dock to the bottom
      l.y + h - c
    ]).interpolate(d);
    return I4() && o && (O += (window.devicePixelRatio - 1) * h), O;
  }, m = () => new gE([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    l.x,
    // Align at the center
    l.x / u * p,
    // Dock to the right
    l.x + p - u
  ]).interpolate(f), { offsetX: g, offsetY: y } = i, w = g === 0 || g, x = y === 0 || y;
  return {
    x: w ? g : m(),
    y: x ? y : v()
  };
}
class dY {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var t;
    return !((t = this.globalContext) === null || t === void 0) && t.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var t;
    return ((t = this.optionsArgs) === null || t === void 0 ? void 0 : t.rootElement) || this.window;
  }
  constructor(t, n) {
    this.ownerDocument = null, this.globalContext = t, this.optionsArgs = n;
  }
}
function pY(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function yE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    }))), r.forEach(function(i) {
      pY(e, i, n[i]);
    });
  }
  return e;
}
class hY {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var t, n;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((t = this.dragStartSourceIds) === null || t === void 0 ? void 0 : t.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((n = this.dragOverTargetIds) === null || n === void 0 ? void 0 : n.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const t = this.rootElement;
    if (t !== void 0) {
      if (t.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      t.__isReactDndBackendSetUp = !0, this.addEventListeners(t);
    }
  }
  teardown() {
    const t = this.rootElement;
    if (t !== void 0 && (t.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var n;
      (n = this.window) === null || n === void 0 || n.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(t, n, r) {
    return this.sourcePreviewNodeOptions.set(t, r), this.sourcePreviewNodes.set(t, n), () => {
      this.sourcePreviewNodes.delete(t), this.sourcePreviewNodeOptions.delete(t);
    };
  }
  connectDragSource(t, n, r) {
    this.sourceNodes.set(t, n), this.sourceNodeOptions.set(t, r);
    const i = (a) => this.handleDragStart(a, t), o = (a) => this.handleSelectStart(a);
    return n.setAttribute("draggable", "true"), n.addEventListener("dragstart", i), n.addEventListener("selectstart", o), () => {
      this.sourceNodes.delete(t), this.sourceNodeOptions.delete(t), n.removeEventListener("dragstart", i), n.removeEventListener("selectstart", o), n.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(t, n) {
    const r = (a) => this.handleDragEnter(a, t), i = (a) => this.handleDragOver(a, t), o = (a) => this.handleDrop(a, t);
    return n.addEventListener("dragenter", r), n.addEventListener("dragover", i), n.addEventListener("drop", o), () => {
      n.removeEventListener("dragenter", r), n.removeEventListener("dragover", i), n.removeEventListener("drop", o);
    };
  }
  addEventListeners(t) {
    t.addEventListener && (t.addEventListener("dragstart", this.handleTopDragStart), t.addEventListener("dragstart", this.handleTopDragStartCapture, !0), t.addEventListener("dragend", this.handleTopDragEndCapture, !0), t.addEventListener("dragenter", this.handleTopDragEnter), t.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.addEventListener("dragover", this.handleTopDragOver), t.addEventListener("dragover", this.handleTopDragOverCapture, !0), t.addEventListener("drop", this.handleTopDrop), t.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(t) {
    t.removeEventListener && (t.removeEventListener("dragstart", this.handleTopDragStart), t.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), t.removeEventListener("dragend", this.handleTopDragEndCapture, !0), t.removeEventListener("dragenter", this.handleTopDragEnter), t.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), t.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), t.removeEventListener("dragover", this.handleTopDragOver), t.removeEventListener("dragover", this.handleTopDragOverCapture, !0), t.removeEventListener("drop", this.handleTopDrop), t.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourceNodeOptions.get(t);
    return yE({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, n || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const t = this.monitor.getSourceId(), n = this.sourcePreviewNodeOptions.get(t);
    return yE({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, n || {});
  }
  isDraggingNativeItem() {
    const t = this.monitor.getItemType();
    return Object.keys(mE).some(
      (n) => mE[n] === t
    );
  }
  beginDragNativeItem(t, n) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = aY(t, n), this.currentNativeHandle = this.registry.addSource(t, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(t) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = t;
    const n = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var r;
      return (r = this.rootElement) === null || r === void 0 ? void 0 : r.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, n);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var t;
        (t = this.window) === null || t === void 0 || t.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(t, n) {
    t.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(n));
  }
  handleDragEnter(t, n) {
    this.dragEnterTargetIds.unshift(n);
  }
  handleDragOver(t, n) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(n);
  }
  handleDrop(t, n) {
    this.dropTargetIds.unshift(n);
  }
  constructor(t, n, r) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && N4(o) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (i) => !!(i && this.document && this.document.body && this.document.body.contains(i)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const i = this.currentDragSourceNode;
      i == null || this.isNodeInDocument(i) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (i) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(i || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (i) => {
      if (i.defaultPrevented)
        return;
      const { dragStartSourceIds: o } = this;
      this.dragStartSourceIds = null;
      const a = nf(i);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(o || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: a
      });
      const { dataTransfer: s } = i, l = fv(s);
      if (this.monitor.isDragging()) {
        if (s && typeof s.setDragImage == "function") {
          const c = this.monitor.getSourceId(), f = this.sourceNodes.get(c), d = this.sourcePreviewNodes.get(c) || f;
          if (d) {
            const { anchorX: p, anchorY: h, offsetX: v, offsetY: m } = this.getCurrentSourcePreviewNodeOptions(), w = fY(f, d, a, {
              anchorX: p,
              anchorY: h
            }, {
              offsetX: v,
              offsetY: m
            });
            s.setDragImage(d, w.x, w.y);
          }
        }
        try {
          s?.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(i.target);
        const { captureDraggingState: u } = this.getCurrentSourcePreviewNodeOptions();
        u ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (l)
        this.beginDragNativeItem(l);
      else {
        if (s && !s.types && (i.target && !i.target.hasAttribute || !i.target.hasAttribute("draggable")))
          return;
        i.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (i) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(i.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: s } = i, l = fv(s);
      l && this.beginDragNativeItem(l, s);
    }, this.handleTopDragEnter = (i) => {
      const { dragEnterTargetIds: o } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = i.altKey, o.length > 0 && this.actions.hover(o, {
        clientOffset: nf(i)
      }), o.some(
        (s) => this.monitor.canDropOnTarget(s)
      ) && (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (i) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
    }, this.handleTopDragOver = (i) => {
      const { dragOverTargetIds: o } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = i.altKey, this.lastClientOffset = nf(i), this.scheduleHover(o), (o || []).some(
        (s) => this.monitor.canDropOnTarget(s)
      ) ? (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? i.preventDefault() : (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (i) => {
      this.isDraggingNativeItem() && i.preventDefault(), this.enterLeaveCounter.leave(i.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (i) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        i.preventDefault(), (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      } else fv(i.dataTransfer) && i.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (i) => {
      const { dropTargetIds: o } = this;
      this.dropTargetIds = [], this.actions.hover(o, {
        clientOffset: nf(i)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (i) => {
      const o = i.target;
      typeof o.dragDrop == "function" && (o.tagName === "INPUT" || o.tagName === "SELECT" || o.tagName === "TEXTAREA" || o.isContentEditable || (i.preventDefault(), o.dragDrop()));
    }, this.options = new dY(n, r), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.registry = t.getRegistry(), this.enterLeaveCounter = new iY(this.isNodeInDocument);
  }
}
const vY = function(t, n, r) {
  return new hY(t, n, r);
}, mY = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function Fs(e, t, n) {
  const r = gY(e), { webkitRelativePath: i } = e, o = typeof t == "string" ? t : typeof i == "string" && i.length > 0 ? i : `./${e.name}`;
  return typeof r.path != "string" && bE(r, "path", o), bE(r, "relativePath", o), r;
}
function gY(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), i = mY.get(r);
    i && Object.defineProperty(e, "type", {
      value: i,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function bE(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const yY = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function bY(e) {
  return Pa(this, void 0, void 0, function* () {
    return Pd(e) && _Y(e.dataTransfer) ? SY(e.dataTransfer, e.type) : wY(e) ? xY(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? EY(e) : [];
  });
}
function _Y(e) {
  return Pd(e);
}
function wY(e) {
  return Pd(e) && Pd(e.target);
}
function Pd(e) {
  return typeof e == "object" && e !== null;
}
function xY(e) {
  return mg(e.target.files).map((t) => Fs(t));
}
function EY(e) {
  return Pa(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => Fs(n));
  });
}
function SY(e, t) {
  return Pa(this, void 0, void 0, function* () {
    if (e.items) {
      const n = mg(e.items).filter((i) => i.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(OY));
      return _E(R4(r));
    }
    return _E(mg(e.files).map((n) => Fs(n)));
  });
}
function _E(e) {
  return e.filter((t) => yY.indexOf(t.name) === -1);
}
function mg(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function OY(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return wE(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? M4(t) : wE(e, t);
}
function R4(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? R4(n) : [n]
  ], []);
}
function wE(e, t) {
  return Pa(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const o = yield e.getAsFileSystemHandle();
      if (o === null)
        throw new Error(`${e} is not a File`);
      if (o !== void 0) {
        const a = yield o.getFile();
        return a.handle = o, Fs(a);
      }
    }
    const r = e.getAsFile();
    if (!r)
      throw new Error(`${e} is not a File`);
    return Fs(r, (n = t?.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function $Y(e) {
  return Pa(this, void 0, void 0, function* () {
    return e.isDirectory ? M4(e) : TY(e);
  });
}
function M4(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const i = [];
    function o() {
      t.readEntries((a) => Pa(this, void 0, void 0, function* () {
        if (a.length) {
          const s = Promise.all(a.map($Y));
          i.push(s), o();
        } else
          try {
            const s = yield Promise.all(i);
            n(s);
          } catch (s) {
            r(s);
          }
      }), (a) => {
        r(a);
      });
    }
    o();
  });
}
function TY(e) {
  return Pa(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const i = Fs(r, e.fullPath);
        t(i);
      }, (r) => {
        n(r);
      });
    });
  });
}
var rf = {}, xE;
function kY() {
  return xE || (xE = 1, rf.__esModule = !0, rf.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", i = (e.type || "").toLowerCase(), o = i.replace(/\/.*$/, "");
      return n.some(function(a) {
        var s = a.trim().toLowerCase();
        return s.charAt(0) === "." ? r.toLowerCase().endsWith(s) : s.endsWith("/*") ? o === s.replace(/\/.*$/, "") : i === s;
      });
    }
    return !0;
  }), rf;
}
var PY = kY();
const dv = /* @__PURE__ */ Wd(PY);
function EE(e) {
  return CY(e) || AY(e) || F4(e) || DY();
}
function DY() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function AY(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function CY(e) {
  if (Array.isArray(e)) return gg(e);
}
function SE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function OE(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? SE(Object(n), !0).forEach(function(r) {
      j4(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : SE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function j4(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Lu(e, t) {
  return RY(e) || NY(e, t) || F4(e, t) || IY();
}
function IY() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function F4(e, t) {
  if (e) {
    if (typeof e == "string") return gg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return gg(e, t);
  }
}
function gg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function NY(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function RY(e) {
  if (Array.isArray(e)) return e;
}
var MY = typeof dv == "function" ? dv : dv.default, jY = "file-invalid-type", FY = "file-too-large", zY = "file-too-small", LY = "too-many-files", VY = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: jY,
    message: "File type must be ".concat(r)
  };
}, $E = function(t) {
  return {
    code: FY,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, TE = function(t) {
  return {
    code: zY,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, BY = {
  code: LY,
  message: "Too many files"
};
function UY(e) {
  return e.type === "" && typeof e.getAsFile == "function";
}
function z4(e, t) {
  var n = e.type === "application/x-moz-file" || MY(e, t) || UY(e);
  return [n, n ? null : VY(t)];
}
function L4(e, t, n) {
  if (Xo(e.size))
    if (Xo(t) && Xo(n)) {
      if (e.size > n) return [!1, $E(n)];
      if (e.size < t) return [!1, TE(t)];
    } else {
      if (Xo(t) && e.size < t) return [!1, TE(t)];
      if (Xo(n) && e.size > n) return [!1, $E(n)];
    }
  return [!0, null];
}
function Xo(e) {
  return e != null;
}
function KY(e) {
  var t = e.files, n = e.accept, r = e.minSize, i = e.maxSize, o = e.multiple, a = e.maxFiles, s = e.validator;
  return !o && t.length > 1 || o && a >= 1 && t.length > a ? !1 : t.every(function(l) {
    var u = z4(l, n), c = Lu(u, 1), f = c[0], d = L4(l, r, i), p = Lu(d, 1), h = p[0], v = s ? s(l) : null;
    return f && h && !v;
  });
}
function Dd(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function Nl(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function kE(e) {
  e.preventDefault();
}
function qY(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function HY(e) {
  return e.indexOf("Edge/") !== -1;
}
function WY() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return qY(e) || HY(e);
}
function pi() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
      o[a - 1] = arguments[a];
    return t.some(function(s) {
      return !Dd(r) && s && s.apply(void 0, [r].concat(o)), Dd(r);
    });
  };
}
function ZY() {
  return "showOpenFilePicker" in window;
}
function GY(e) {
  if (Xo(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Lu(n, 2), i = r[0], o = r[1], a = !0;
      return V4(i) || (console.warn('Skipped "'.concat(i, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), a = !1), (!Array.isArray(o) || !o.every(B4)) && (console.warn('Skipped "'.concat(i, '" because an invalid file extension was provided.')), a = !1), a;
    }).reduce(function(n, r) {
      var i = Lu(r, 2), o = i[0], a = i[1];
      return OE(OE({}, n), {}, j4({}, o, a));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function YY(e) {
  if (Xo(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Lu(n, 2), i = r[0], o = r[1];
      return [].concat(EE(t), [i], EE(o));
    }, []).filter(function(t) {
      return V4(t) || B4(t);
    }).join(",");
}
function QY(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function JY(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function V4(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function B4(e) {
  return /^.*\.[\w]+$/.test(e);
}
var XY = ["children"], eQ = ["open"], tQ = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], nQ = ["refKey", "onChange", "onClick"];
function PE(e) {
  return oQ(e) || iQ(e) || U4(e) || rQ();
}
function rQ() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iQ(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function oQ(e) {
  if (Array.isArray(e)) return yg(e);
}
function pv(e, t) {
  return lQ(e) || sQ(e, t) || U4(e, t) || aQ();
}
function aQ() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function U4(e, t) {
  if (e) {
    if (typeof e == "string") return yg(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return yg(e, t);
  }
}
function yg(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function sQ(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], i = !0, o = !1, a, s;
    try {
      for (n = n.call(e); !(i = (a = n.next()).done) && (r.push(a.value), !(t && r.length === t)); i = !0)
        ;
    } catch (l) {
      o = !0, s = l;
    } finally {
      try {
        !i && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
    return r;
  }
}
function lQ(e) {
  if (Array.isArray(e)) return e;
}
function DE(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Tt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? DE(Object(n), !0).forEach(function(r) {
      bg(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : DE(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function bg(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ad(e, t) {
  if (e == null) return {};
  var n = uQ(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function uQ(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Zb = /* @__PURE__ */ Xt(function(e, t) {
  var n = e.children, r = Ad(e, XY), i = q4(r), o = i.open, a = Ad(i, eQ);
  return mI(t, function() {
    return {
      open: o
    };
  }, [o]), /* @__PURE__ */ W.createElement(gI, null, n(Tt(Tt({}, a), {}, {
    open: o
  })));
});
Zb.displayName = "Dropzone";
var K4 = {
  disabled: !1,
  getFilesFromEvent: bY,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
Zb.defaultProps = K4;
Zb.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: Re.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: Re.objectOf(Re.arrayOf(Re.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: Re.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: Re.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: Re.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: Re.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: Re.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: Re.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: Re.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: Re.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: Re.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: Re.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: Re.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: Re.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: Re.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: Re.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: Re.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: Re.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: Re.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: Re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: Re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: Re.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: Re.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: Re.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: Re.func
};
var _g = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  isDragGlobal: !1,
  acceptedFiles: [],
  fileRejections: []
};
function q4() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = Tt(Tt({}, K4), e), n = t.accept, r = t.disabled, i = t.getFilesFromEvent, o = t.maxSize, a = t.minSize, s = t.multiple, l = t.maxFiles, u = t.onDragEnter, c = t.onDragLeave, f = t.onDragOver, d = t.onDrop, p = t.onDropAccepted, h = t.onDropRejected, v = t.onFileDialogCancel, m = t.onFileDialogOpen, g = t.useFsAccessApi, y = t.autoFocus, w = t.preventDropOnDocument, x = t.noClick, S = t.noKeyboard, O = t.noDrag, P = t.noDragEventsBubbling, b = t.onError, _ = t.validator, E = $e(function() {
    return YY(n);
  }, [n]), A = $e(function() {
    return GY(n);
  }, [n]), k = $e(function() {
    return typeof m == "function" ? m : AE;
  }, [m]), R = $e(function() {
    return typeof v == "function" ? v : AE;
  }, [v]), N = _e(null), U = _e(null), H = B2(cQ, _g), ee = pv(H, 2), ue = ee[0], Q = ee[1], $ = ue.isFocused, F = ue.isFileDialogActive, I = _e(typeof window < "u" && window.isSecureContext && g && ZY()), L = function() {
    !I.current && F && setTimeout(function() {
      if (U.current) {
        var te = U.current.files;
        te.length || (Q({
          type: "closeDialog"
        }), R());
      }
    }, 300);
  };
  Se(function() {
    return window.addEventListener("focus", L, !1), function() {
      window.removeEventListener("focus", L, !1);
    };
  }, [U, F, R, I]);
  var K = _e([]), Y = _e([]), se = function(te) {
    N.current && N.current.contains(te.target) || (te.preventDefault(), K.current = []);
  };
  Se(function() {
    return w && (document.addEventListener("dragover", kE, !1), document.addEventListener("drop", se, !1)), function() {
      w && (document.removeEventListener("dragover", kE), document.removeEventListener("drop", se));
    };
  }, [N, w]), Se(function() {
    var X = function(He) {
      Y.current = [].concat(PE(Y.current), [He.target]), Nl(He) && Q({
        isDragGlobal: !0,
        type: "setDragGlobal"
      });
    }, te = function(He) {
      Y.current = Y.current.filter(function(it) {
        return it !== He.target && it !== null;
      }), !(Y.current.length > 0) && Q({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, le = function() {
      Y.current = [], Q({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    }, ye = function() {
      Y.current = [], Q({
        isDragGlobal: !1,
        type: "setDragGlobal"
      });
    };
    return document.addEventListener("dragenter", X, !1), document.addEventListener("dragleave", te, !1), document.addEventListener("dragend", le, !1), document.addEventListener("drop", ye, !1), function() {
      document.removeEventListener("dragenter", X), document.removeEventListener("dragleave", te), document.removeEventListener("dragend", le), document.removeEventListener("drop", ye);
    };
  }, [N]), Se(function() {
    return !r && y && N.current && N.current.focus(), function() {
    };
  }, [N, y, r]);
  var ve = Me(function(X) {
    b ? b(X) : console.error(X);
  }, [b]), B = Me(function(X) {
    X.preventDefault(), X.persist(), pe(X), K.current = [].concat(PE(K.current), [X.target]), Nl(X) && Promise.resolve(i(X)).then(function(te) {
      if (!(Dd(X) && !P)) {
        var le = te.length, ye = le > 0 && KY({
          files: te,
          accept: E,
          minSize: a,
          maxSize: o,
          multiple: s,
          maxFiles: l,
          validator: _
        }), Ce = le > 0 && !ye;
        Q({
          isDragAccept: ye,
          isDragReject: Ce,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(X);
      }
    }).catch(function(te) {
      return ve(te);
    });
  }, [i, u, ve, P, E, a, o, s, l, _]), T = Me(function(X) {
    X.preventDefault(), X.persist(), pe(X);
    var te = Nl(X);
    if (te && X.dataTransfer)
      try {
        X.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return te && f && f(X), !1;
  }, [f, P]), D = Me(function(X) {
    X.preventDefault(), X.persist(), pe(X);
    var te = K.current.filter(function(ye) {
      return N.current && N.current.contains(ye);
    }), le = te.indexOf(X.target);
    le !== -1 && te.splice(le, 1), K.current = te, !(te.length > 0) && (Q({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), Nl(X) && c && c(X));
  }, [N, c, P]), C = Me(function(X, te) {
    var le = [], ye = [];
    X.forEach(function(Ce) {
      var He = z4(Ce, E), it = pv(He, 2), vt = it[0], bt = it[1], si = L4(Ce, a, o), li = pv(si, 2), Di = li[0], qo = li[1], ui = _ ? _(Ce) : null;
      if (vt && Di && !ui)
        le.push(Ce);
      else {
        var Xi = [bt, qo];
        ui && (Xi = Xi.concat(ui)), ye.push({
          file: Ce,
          errors: Xi.filter(function(Rr) {
            return Rr;
          })
        });
      }
    }), (!s && le.length > 1 || s && l >= 1 && le.length > l) && (le.forEach(function(Ce) {
      ye.push({
        file: Ce,
        errors: [BY]
      });
    }), le.splice(0)), Q({
      acceptedFiles: le,
      fileRejections: ye,
      isDragReject: ye.length > 0,
      type: "setFiles"
    }), d && d(le, ye, te), ye.length > 0 && h && h(ye, te), le.length > 0 && p && p(le, te);
  }, [Q, s, E, a, o, l, d, p, h, _]), z = Me(function(X) {
    X.preventDefault(), X.persist(), pe(X), K.current = [], Nl(X) && Promise.resolve(i(X)).then(function(te) {
      Dd(X) && !P || C(te, X);
    }).catch(function(te) {
      return ve(te);
    }), Q({
      type: "reset"
    });
  }, [i, C, ve, P]), Z = Me(function() {
    if (I.current) {
      Q({
        type: "openDialog"
      }), k();
      var X = {
        multiple: s,
        types: A
      };
      window.showOpenFilePicker(X).then(function(te) {
        return i(te);
      }).then(function(te) {
        C(te, null), Q({
          type: "closeDialog"
        });
      }).catch(function(te) {
        QY(te) ? (R(te), Q({
          type: "closeDialog"
        })) : JY(te) ? (I.current = !1, U.current ? (U.current.value = null, U.current.click()) : ve(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : ve(te);
      });
      return;
    }
    U.current && (Q({
      type: "openDialog"
    }), k(), U.current.value = null, U.current.click());
  }, [Q, k, R, g, C, ve, A, s]), ne = Me(function(X) {
    !N.current || !N.current.isEqualNode(X.target) || (X.key === " " || X.key === "Enter" || X.keyCode === 32 || X.keyCode === 13) && (X.preventDefault(), Z());
  }, [N, Z]), de = Me(function() {
    Q({
      type: "focus"
    });
  }, []), fe = Me(function() {
    Q({
      type: "blur"
    });
  }, []), Ee = Me(function() {
    x || (WY() ? setTimeout(Z, 0) : Z());
  }, [x, Z]), re = function(te) {
    return r ? null : te;
  }, xe = function(te) {
    return S ? null : re(te);
  }, De = function(te) {
    return O ? null : re(te);
  }, pe = function(te) {
    P && te.stopPropagation();
  }, j = $e(function() {
    return function() {
      var X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, te = X.refKey, le = te === void 0 ? "ref" : te, ye = X.role, Ce = X.onKeyDown, He = X.onFocus, it = X.onBlur, vt = X.onClick, bt = X.onDragEnter, si = X.onDragOver, li = X.onDragLeave, Di = X.onDrop, qo = Ad(X, tQ);
      return Tt(Tt(bg({
        onKeyDown: xe(pi(Ce, ne)),
        onFocus: xe(pi(He, de)),
        onBlur: xe(pi(it, fe)),
        onClick: re(pi(vt, Ee)),
        onDragEnter: De(pi(bt, B)),
        onDragOver: De(pi(si, T)),
        onDragLeave: De(pi(li, D)),
        onDrop: De(pi(Di, z)),
        role: typeof ye == "string" && ye !== "" ? ye : "presentation"
      }, le, N), !r && !S ? {
        tabIndex: 0
      } : {}), qo);
    };
  }, [N, ne, de, fe, Ee, B, T, D, z, S, O, r]), q = Me(function(X) {
    X.stopPropagation();
  }, []), J = $e(function() {
    return function() {
      var X = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, te = X.refKey, le = te === void 0 ? "ref" : te, ye = X.onChange, Ce = X.onClick, He = Ad(X, nQ), it = bg({
        accept: E,
        multiple: s,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: re(pi(ye, z)),
        onClick: re(pi(Ce, q)),
        tabIndex: -1
      }, le, U);
      return Tt(Tt({}, it), He);
    };
  }, [U, n, s, z, r]);
  return Tt(Tt({}, ue), {}, {
    isFocused: $ && !r,
    getRootProps: j,
    getInputProps: J,
    rootRef: N,
    inputRef: U,
    open: re(Z)
  });
}
function cQ(e, t) {
  switch (t.type) {
    case "focus":
      return Tt(Tt({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return Tt(Tt({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return Tt(Tt({}, _g), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return Tt(Tt({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return Tt(Tt({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return Tt(Tt({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "setDragGlobal":
      return Tt(Tt({}, e), {}, {
        isDragGlobal: t.isDragGlobal
      });
    case "reset":
      return Tt({}, _g);
    default:
      return e;
  }
}
function AE() {
}
const H4 = (e) => /* @__PURE__ */ M.jsx("input", { type: "checkbox", ...e, className: "bg-neutral-600 checkbox" });
var mc = (e) => e.type === "checkbox", sa = (e) => e instanceof Date, Ln = (e) => e == null;
const W4 = (e) => typeof e == "object";
var Yt = (e) => !Ln(e) && !Array.isArray(e) && W4(e) && !sa(e), fQ = (e) => Yt(e) && e.target ? mc(e.target) ? e.target.checked : e.target.value : e, Z4 = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, dQ = (e, t) => e.has(Z4(t)), pQ = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Yt(t) && t.hasOwnProperty("isPrototypeOf");
}, Gb = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function sn(e) {
  if (e instanceof Date)
    return new Date(e);
  const t = typeof FileList < "u" && e instanceof FileList;
  if (Gb && (e instanceof Blob || t))
    return e;
  const n = Array.isArray(e);
  if (!n && !(Yt(e) && pQ(e)))
    return e;
  const r = n ? [] : Object.create(Object.getPrototypeOf(e));
  for (const i in e)
    Object.prototype.hasOwnProperty.call(e, i) && (r[i] = sn(e[i]));
  return r;
}
var Fp = (e) => /^\w*$/.test(e), Lt = (e) => e === void 0, Yb = (e) => Array.isArray(e) ? e.filter(Boolean) : [], Qb = (e) => Yb(e.replace(/["|']|\]/g, "").split(/\.|\[/)), ze = (e, t, n) => {
  if (!t || !Yt(e))
    return n;
  const r = (Fp(t) ? [t] : Qb(t)).reduce((i, o) => Ln(i) ? i : i[o], e);
  return Lt(r) || r === e ? Lt(e[t]) ? n : e[t] : r;
}, vi = (e) => typeof e == "boolean", Kr = (e) => typeof e == "function", $t = (e, t, n) => {
  let r = -1;
  const i = Fp(t) ? [t] : Qb(t), o = i.length, a = o - 1;
  for (; ++r < o; ) {
    const s = i[r];
    let l = n;
    if (r !== a) {
      const u = e[s];
      l = Yt(u) || Array.isArray(u) ? u : isNaN(+i[r + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    e[s] = l, e = e[s];
  }
};
const Za = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  SUBMIT: "submit",
  TRIGGER: "trigger",
  VALID: "valid"
}, qr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Lr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, hv = "form", G4 = "root", hQ = W.createContext(null);
hQ.displayName = "HookFormControlContext";
var vQ = (e, t, n, r = !0) => {
  const i = {
    defaultValues: t._defaultValues
  };
  for (const o in e)
    Object.defineProperty(i, o, {
      get: () => {
        const a = o;
        return t._proxyFormState[a] !== qr.all && (t._proxyFormState[a] = !r || qr.all), e[a];
      }
    });
  return i;
};
const mQ = typeof window < "u" ? W.useLayoutEffect : W.useEffect;
var Cn = (e) => typeof e == "string", gQ = (e, t, n, r, i) => Cn(e) ? (r && t.watch.add(e), ze(n, e, i)) : Array.isArray(e) ? e.map((o) => (r && t.watch.add(o), ze(n, o))) : (r && (t.watchAll = !0), n), wg = (e) => Ln(e) || !W4(e);
function ho(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (wg(e) || wg(t))
    return Object.is(e, t);
  if (sa(e) && sa(t))
    return Object.is(e.getTime(), t.getTime());
  const r = Object.keys(e), i = Object.keys(t);
  if (r.length !== i.length)
    return !1;
  if (n.has(e) || n.has(t))
    return !0;
  n.add(e), n.add(t);
  for (const o of r) {
    const a = e[o];
    if (!i.includes(o))
      return !1;
    if (o !== "ref") {
      const s = t[o];
      if (sa(a) && sa(s) || Yt(a) && Yt(s) || Array.isArray(a) && Array.isArray(s) ? !ho(a, s, n) : !Object.is(a, s))
        return !1;
    }
  }
  return !0;
}
const yQ = W.createContext(null);
yQ.displayName = "HookFormContext";
var bQ = (e, t, n, r, i) => t ? {
  ...n[e],
  types: {
    ...n[e] && n[e].types ? n[e].types : {},
    [r]: i || !0
  }
} : {}, du = (e) => Array.isArray(e) ? e : [e], CE = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (i) => {
      for (const o of e)
        o.next && o.next(i);
    },
    subscribe: (i) => (e.push(i), {
      unsubscribe: () => {
        e = e.filter((o) => o !== i);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
};
function Y4(e, t) {
  const n = {};
  for (const r in e)
    if (e.hasOwnProperty(r)) {
      const i = e[r], o = t[r];
      if (i && Yt(i) && o) {
        const a = Y4(i, o);
        Yt(a) && (n[r] = a);
      } else e[r] && (n[r] = o);
    }
  return n;
}
var Pn = (e) => Yt(e) && !Object.keys(e).length, Jb = (e) => e.type === "file", Cd = (e) => {
  if (!Gb)
    return !1;
  const t = e ? e.ownerDocument : 0;
  return e instanceof (t && t.defaultView ? t.defaultView.HTMLElement : HTMLElement);
}, Q4 = (e) => e.type === "select-multiple", Xb = (e) => e.type === "radio", _Q = (e) => Xb(e) || mc(e), vv = (e) => Cd(e) && e.isConnected;
function wQ(e, t) {
  const n = t.slice(0, -1).length;
  let r = 0;
  for (; r < n; )
    e = Lt(e) ? r++ : e[t[r++]];
  return e;
}
function xQ(e) {
  for (const t in e)
    if (e.hasOwnProperty(t) && !Lt(e[t]))
      return !1;
  return !0;
}
function rn(e, t) {
  const n = Array.isArray(t) ? t : Fp(t) ? [t] : Qb(t), r = n.length === 1 ? e : wQ(e, n), i = n.length - 1, o = n[i];
  return r && delete r[o], i !== 0 && (Yt(r) && Pn(r) || Array.isArray(r) && xQ(r)) && rn(e, n.slice(0, -1)), e;
}
var EQ = (e) => {
  for (const t in e)
    if (Kr(e[t]))
      return !0;
  return !1;
};
function J4(e) {
  return Array.isArray(e) || Yt(e) && !EQ(e);
}
function xg(e, t = {}) {
  for (const n in e) {
    const r = e[n];
    J4(r) ? (t[n] = Array.isArray(r) ? [] : {}, xg(r, t[n])) : Lt(r) || (t[n] = !0);
  }
  return t;
}
function Xa(e, t, n) {
  n || (n = xg(t));
  for (const r in e) {
    const i = e[r];
    if (J4(i))
      Lt(t) || wg(n[r]) ? n[r] = xg(i, Array.isArray(i) ? [] : {}) : Xa(i, Ln(t) ? {} : t[r], n[r]);
    else {
      const o = t[r];
      n[r] = !ho(i, o);
    }
  }
  return n;
}
const IE = {
  value: !1,
  isValid: !1
}, NE = { value: !0, isValid: !0 };
var X4 = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const t = e.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: t, isValid: !!t.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !Lt(e[0].attributes.value) ? Lt(e[0].value) || e[0].value === "" ? NE : { value: e[0].value, isValid: !0 } : NE
    ) : IE;
  }
  return IE;
}, eA = (e, { valueAsNumber: t, valueAsDate: n, setValueAs: r }) => Lt(e) ? e : t ? e === "" ? NaN : e && +e : n && Cn(e) ? new Date(e) : r ? r(e) : e;
const RE = {
  isValid: !1,
  value: null
};
var tA = (e) => Array.isArray(e) ? e.reduce((t, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : t, RE) : RE;
function ME(e) {
  const t = e.ref;
  return Jb(t) ? t.files : Xb(t) ? tA(e.refs).value : Q4(t) ? [...t.selectedOptions].map(({ value: n }) => n) : mc(t) ? X4(e.refs).value : eA(Lt(t.value) ? e.ref.value : t.value, e);
}
var SQ = (e, t, n, r) => {
  const i = {};
  for (const o of e) {
    const a = ze(t, o);
    a && $t(i, o, a._f);
  }
  return {
    criteriaMode: n,
    names: [...e],
    fields: i,
    shouldUseNativeValidation: r
  };
}, Id = (e) => e instanceof RegExp, Rl = (e) => Lt(e) ? e : Id(e) ? e.source : Yt(e) ? Id(e.value) ? e.value.source : e.value : e, jE = (e) => ({
  isOnSubmit: !e || e === qr.onSubmit,
  isOnBlur: e === qr.onBlur,
  isOnChange: e === qr.onChange,
  isOnAll: e === qr.all,
  isOnTouch: e === qr.onTouched
});
const FE = "AsyncFunction";
var OQ = (e) => !!e && !!e.validate && !!(Kr(e.validate) && e.validate.constructor.name === FE || Yt(e.validate) && Object.values(e.validate).find((t) => t.constructor.name === FE)), $Q = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), zE = (e, t, n) => !n && (t.watchAll || t.watch.has(e) || [...t.watch].some((r) => e.startsWith(r) && /^\.\w+/.test(e.slice(r.length))));
const pu = (e, t, n, r) => {
  for (const i of n || Object.keys(e)) {
    const o = ze(e, i);
    if (o) {
      const { _f: a, ...s } = o;
      if (a) {
        if (a.refs && a.refs[0] && t(a.refs[0], i) && !r)
          return !0;
        if (a.ref && t(a.ref, a.name) && !r)
          return !0;
        if (pu(s, t))
          break;
      } else if (Yt(s) && pu(s, t))
        break;
    }
  }
};
function LE(e, t, n) {
  const r = ze(e, n);
  if (r || Fp(n))
    return {
      error: r,
      name: n
    };
  const i = n.split(".");
  for (; i.length; ) {
    const o = i.join("."), a = ze(t, o), s = ze(e, o);
    if (a && !Array.isArray(a) && n !== o)
      return { name: n };
    if (s && s.type)
      return {
        name: o,
        error: s
      };
    if (s && s.root && s.root.type)
      return {
        name: `${o}.root`,
        error: s.root
      };
    i.pop();
  }
  return {
    name: n
  };
}
var TQ = (e, t, n, r) => {
  n(e);
  const { name: i, ...o } = e;
  return Pn(o) || Object.keys(o).length >= Object.keys(t).length || Object.keys(o).find((a) => t[a] === (!r || qr.all));
}, kQ = (e, t, n) => !e || !t || e === t || du(e).some((r) => r && (n ? r === t : r.startsWith(t) || t.startsWith(r))), PQ = (e, t, n, r, i) => i.isOnAll ? !1 : !n && i.isOnTouch ? !(t || e) : (n ? r.isOnBlur : i.isOnBlur) ? !e : (n ? r.isOnChange : i.isOnChange) ? e : !0, DQ = (e, t) => !Yb(ze(e, t)).length && rn(e, t), AQ = (e, t, n) => {
  const r = du(ze(e, n));
  return $t(r, G4, t[n]), $t(e, n, r), e;
};
function VE(e, t, n = "validate") {
  if (Cn(e) || Array.isArray(e) && e.every(Cn) || vi(e) && !e)
    return {
      type: n,
      message: Cn(e) ? e : "",
      ref: t
    };
}
var Ga = (e) => Yt(e) && !Id(e) ? e : {
  value: e,
  message: ""
}, BE = async (e, t, n, r, i, o) => {
  const { ref: a, refs: s, required: l, maxLength: u, minLength: c, min: f, max: d, pattern: p, validate: h, name: v, valueAsNumber: m, mount: g } = e._f, y = ze(n, v);
  if (!g || t.has(v))
    return {};
  const w = s ? s[0] : a, x = (k) => {
    i && w.reportValidity && (w.setCustomValidity(vi(k) ? "" : k || ""), w.reportValidity());
  }, S = {}, O = Xb(a), P = mc(a), b = O || P, _ = (m || Jb(a)) && Lt(a.value) && Lt(y) || Cd(a) && a.value === "" || y === "" || Array.isArray(y) && !y.length, E = bQ.bind(null, v, r, S), A = (k, R, N, U = Lr.maxLength, H = Lr.minLength) => {
    const ee = k ? R : N;
    S[v] = {
      type: k ? U : H,
      message: ee,
      ref: a,
      ...E(k ? U : H, ee)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : l && (!b && (_ || Ln(y)) || vi(y) && !y || P && !X4(s).isValid || O && !tA(s).isValid)) {
    const { value: k, message: R } = Cn(l) ? { value: !!l, message: l } : Ga(l);
    if (k && (S[v] = {
      type: Lr.required,
      message: R,
      ref: w,
      ...E(Lr.required, R)
    }, !r))
      return x(R), S;
  }
  if (!_ && (!Ln(f) || !Ln(d))) {
    let k, R;
    const N = Ga(d), U = Ga(f);
    if (!Ln(y) && !isNaN(y)) {
      const H = a.valueAsNumber || y && +y;
      Ln(N.value) || (k = H > N.value), Ln(U.value) || (R = H < U.value);
    } else {
      const H = a.valueAsDate || new Date(y), ee = ($) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + $), ue = a.type == "time", Q = a.type == "week";
      Cn(N.value) && y && (k = ue ? ee(y) > ee(N.value) : Q ? y > N.value : H > new Date(N.value)), Cn(U.value) && y && (R = ue ? ee(y) < ee(U.value) : Q ? y < U.value : H < new Date(U.value));
    }
    if ((k || R) && (A(!!k, N.message, U.message, Lr.max, Lr.min), !r))
      return x(S[v].message), S;
  }
  if ((u || c) && !_ && (Cn(y) || o && Array.isArray(y))) {
    const k = Ga(u), R = Ga(c), N = !Ln(k.value) && y.length > +k.value, U = !Ln(R.value) && y.length < +R.value;
    if ((N || U) && (A(N, k.message, R.message), !r))
      return x(S[v].message), S;
  }
  if (p && !_ && Cn(y)) {
    const { value: k, message: R } = Ga(p);
    if (Id(k) && !y.match(k) && (S[v] = {
      type: Lr.pattern,
      message: R,
      ref: a,
      ...E(Lr.pattern, R)
    }, !r))
      return x(R), S;
  }
  if (h) {
    if (Kr(h)) {
      const k = await h(y, n), R = VE(k, w);
      if (R && (S[v] = {
        ...R,
        ...E(Lr.validate, R.message)
      }, !r))
        return x(R.message), S;
    } else if (Yt(h)) {
      let k = {};
      for (const R in h) {
        if (!Pn(k) && !r)
          break;
        const N = VE(await h[R](y, n), w, R);
        N && (k = {
          ...N,
          ...E(R, N.message)
        }, x(N.message), r && (S[v] = k));
      }
      if (!Pn(k) && (S[v] = {
        ref: w,
        ...k
      }, !r))
        return S;
    }
  }
  return x(!0), S;
};
const CQ = {
  mode: qr.onSubmit,
  reValidateMode: qr.onChange,
  shouldFocusError: !0
};
function IQ(e = {}) {
  let t = {
    ...CQ,
    ...e
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: Kr(t.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1
  }, r = {}, i = Yt(t.defaultValues) || Yt(t.values) ? sn(t.defaultValues || t.values) || {} : {}, o = t.shouldUnregister ? {} : sn(i), a = {
    action: !1,
    mount: !1,
    watch: !1,
    keepIsValid: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, u = 0;
  const c = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    ...c
  };
  let d = {
    ...f
  };
  const p = {
    array: CE(),
    state: CE()
  }, h = t.criteriaMode === qr.all, v = (j) => (q) => {
    clearTimeout(u), u = setTimeout(j, q);
  }, m = async (j) => {
    if (!a.keepIsValid && !t.disabled && (f.isValid || d.isValid || j)) {
      let q;
      t.resolver ? (q = Pn((await b()).errors), g()) : q = await A({
        fields: r,
        onlyCheckValid: !0,
        eventType: Za.VALID
      }), q !== n.isValid && p.state.next({
        isValid: q
      });
    }
  }, g = (j, q) => {
    !t.disabled && (f.isValidating || f.validatingFields || d.isValidating || d.validatingFields) && ((j || Array.from(s.mount)).forEach((J) => {
      J && (q ? $t(n.validatingFields, J, q) : rn(n.validatingFields, J));
    }), p.state.next({
      validatingFields: n.validatingFields,
      isValidating: !Pn(n.validatingFields)
    }));
  }, y = (j, q = [], J, X, te = !0, le = !0) => {
    if (X && J && !t.disabled) {
      if (a.action = !0, le && Array.isArray(ze(r, j))) {
        const ye = J(ze(r, j), X.argA, X.argB);
        te && $t(r, j, ye);
      }
      if (le && Array.isArray(ze(n.errors, j))) {
        const ye = J(ze(n.errors, j), X.argA, X.argB);
        te && $t(n.errors, j, ye), DQ(n.errors, j);
      }
      if ((f.touchedFields || d.touchedFields) && le && Array.isArray(ze(n.touchedFields, j))) {
        const ye = J(ze(n.touchedFields, j), X.argA, X.argB);
        te && $t(n.touchedFields, j, ye);
      }
      if (f.dirtyFields || d.dirtyFields) {
        const ye = Xa(i, o), Ce = Z4(j);
        $t(n.dirtyFields, Ce, ze(ye, Ce));
      }
      p.state.next({
        name: j,
        isDirty: R(j, q),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      $t(o, j, q);
  }, w = (j, q) => {
    $t(n.errors, j, q), p.state.next({
      errors: n.errors
    });
  }, x = (j) => {
    n.errors = j, p.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, S = (j, q, J, X) => {
    const te = ze(r, j);
    if (te) {
      const le = ze(o, j, Lt(J) ? ze(i, j) : J);
      Lt(le) || X && X.defaultChecked || q ? $t(o, j, q ? le : ME(te._f)) : H(j, le), a.mount && !a.action && m();
    }
  }, O = (j, q, J, X, te) => {
    let le = !1, ye = !1;
    const Ce = {
      name: j
    };
    if (!t.disabled) {
      if (!J || X) {
        (f.isDirty || d.isDirty) && (ye = n.isDirty, n.isDirty = Ce.isDirty = R(), le = ye !== Ce.isDirty);
        const He = ho(ze(i, j), q);
        ye = !!ze(n.dirtyFields, j), He ? rn(n.dirtyFields, j) : $t(n.dirtyFields, j, !0), Ce.dirtyFields = n.dirtyFields, le = le || (f.dirtyFields || d.dirtyFields) && ye !== !He;
      }
      if (J) {
        const He = ze(n.touchedFields, j);
        He || ($t(n.touchedFields, j, J), Ce.touchedFields = n.touchedFields, le = le || (f.touchedFields || d.touchedFields) && He !== J);
      }
      le && te && p.state.next(Ce);
    }
    return le ? Ce : {};
  }, P = (j, q, J, X) => {
    const te = ze(n.errors, j), le = (f.isValid || d.isValid) && vi(q) && n.isValid !== q;
    if (t.delayError && J ? (l = v(() => w(j, J)), l(t.delayError)) : (clearTimeout(u), l = null, J ? $t(n.errors, j, J) : rn(n.errors, j)), (J ? !ho(te, J) : te) || !Pn(X) || le) {
      const ye = {
        ...X,
        ...le && vi(q) ? { isValid: q } : {},
        errors: n.errors,
        name: j
      };
      n = {
        ...n,
        ...ye
      }, p.state.next(ye);
    }
  }, b = async (j) => (g(j, !0), await t.resolver(o, t.context, SQ(j || s.mount, r, t.criteriaMode, t.shouldUseNativeValidation))), _ = async (j) => {
    const { errors: q } = await b(j);
    if (g(j), j)
      for (const J of j) {
        const X = ze(q, J);
        X ? $t(n.errors, J, X) : rn(n.errors, J);
      }
    else
      n.errors = q;
    return q;
  }, E = async ({ name: j, eventType: q }) => {
    if (e.validate) {
      const J = await e.validate({
        formValues: o,
        formState: n,
        name: j,
        eventType: q
      });
      if (Yt(J))
        for (const X in J)
          J[X] && Y(`${hv}.${X}`, {
            message: Cn(J.message) ? J.message : "",
            type: Lr.validate
          });
      else Cn(J) || !J ? Y(hv, {
        message: J || "",
        type: Lr.validate
      }) : K(hv);
      return J;
    }
    return !0;
  }, A = async ({ fields: j, onlyCheckValid: q, name: J, eventType: X, context: te = {
    valid: !0,
    runRootValidation: !1
  } }) => {
    if (e.validate && (te.runRootValidation = !0, !await E({
      name: J,
      eventType: X
    }) && (te.valid = !1, q)))
      return te.valid;
    for (const le in j) {
      const ye = j[le];
      if (ye) {
        const { _f: Ce, ...He } = ye;
        if (Ce) {
          const it = s.array.has(Ce.name), vt = ye._f && OQ(ye._f);
          vt && f.validatingFields && g([Ce.name], !0);
          const bt = await BE(ye, s.disabled, o, h, t.shouldUseNativeValidation && !q, it);
          if (vt && f.validatingFields && g([Ce.name]), bt[Ce.name] && (te.valid = !1, q) || (!q && (ze(bt, Ce.name) ? it ? AQ(n.errors, bt, Ce.name) : $t(n.errors, Ce.name, bt[Ce.name]) : rn(n.errors, Ce.name)), e.shouldUseNativeValidation && bt[Ce.name]))
            break;
        }
        !Pn(He) && await A({
          context: te,
          onlyCheckValid: q,
          fields: He,
          name: le,
          eventType: X
        });
      }
    }
    return te.valid;
  }, k = () => {
    for (const j of s.unMount) {
      const q = ze(r, j);
      q && (q._f.refs ? q._f.refs.every((J) => !vv(J)) : !vv(q._f.ref)) && T(j);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, R = (j, q) => !t.disabled && (j && q && $t(o, j, q), !ho(I(), i)), N = (j, q, J) => gQ(j, s, {
    ...a.mount ? o : Lt(q) ? i : Cn(j) ? { [j]: q } : q
  }, J, q), U = (j) => Yb(ze(a.mount ? o : i, j, t.shouldUnregister ? ze(i, j, []) : [])), H = (j, q, J = {}) => {
    const X = ze(r, j);
    let te = q;
    if (X) {
      const le = X._f;
      le && (!le.disabled && $t(o, j, eA(q, le)), te = Cd(le.ref) && Ln(q) ? "" : q, Q4(le.ref) ? [...le.ref.options].forEach((ye) => ye.selected = te.includes(ye.value)) : le.refs ? mc(le.ref) ? le.refs.forEach((ye) => {
        (!ye.defaultChecked || !ye.disabled) && (Array.isArray(te) ? ye.checked = !!te.find((Ce) => Ce === ye.value) : ye.checked = te === ye.value || !!te);
      }) : le.refs.forEach((ye) => ye.checked = ye.value === te) : Jb(le.ref) ? le.ref.value = "" : (le.ref.value = te, le.ref.type || p.state.next({
        name: j,
        values: sn(o)
      })));
    }
    (J.shouldDirty || J.shouldTouch) && O(j, te, J.shouldTouch, J.shouldDirty, !0), J.shouldValidate && F(j);
  }, ee = (j, q, J) => {
    for (const X in q) {
      if (!q.hasOwnProperty(X))
        return;
      const te = q[X], le = j + "." + X, ye = ze(r, le);
      (s.array.has(j) || Yt(te) || ye && !ye._f) && !sa(te) ? ee(le, te, J) : H(le, te, J);
    }
  }, ue = (j, q, J = {}) => {
    const X = ze(r, j), te = s.array.has(j), le = sn(q);
    $t(o, j, le), te ? (p.array.next({
      name: j,
      values: sn(o)
    }), (f.isDirty || f.dirtyFields || d.isDirty || d.dirtyFields) && J.shouldDirty && p.state.next({
      name: j,
      dirtyFields: Xa(i, o),
      isDirty: R(j, le)
    })) : X && !X._f && !Ln(le) ? ee(j, le, J) : H(j, le, J), zE(j, s) ? p.state.next({
      ...n,
      name: j,
      values: sn(o)
    }) : p.state.next({
      name: a.mount ? j : void 0,
      values: sn(o)
    });
  }, Q = async (j) => {
    a.mount = !0;
    const q = j.target;
    let J = q.name, X = !0;
    const te = ze(r, J), le = (He) => {
      X = Number.isNaN(He) || sa(He) && isNaN(He.getTime()) || ho(He, ze(o, J, He));
    }, ye = jE(t.mode), Ce = jE(t.reValidateMode);
    if (te) {
      let He, it;
      const vt = q.type ? ME(te._f) : fQ(j), bt = j.type === Za.BLUR || j.type === Za.FOCUS_OUT, si = !$Q(te._f) && !e.validate && !t.resolver && !ze(n.errors, J) && !te._f.deps || PQ(bt, ze(n.touchedFields, J), n.isSubmitted, Ce, ye), li = zE(J, s, bt);
      $t(o, J, vt), bt ? (!q || !q.readOnly) && (te._f.onBlur && te._f.onBlur(j), l && l(0)) : te._f.onChange && te._f.onChange(j);
      const Di = O(J, vt, bt), qo = !Pn(Di) || li;
      if (!bt && p.state.next({
        name: J,
        type: j.type,
        values: sn(o)
      }), si)
        return (f.isValid || d.isValid) && (t.mode === "onBlur" ? bt && m() : bt || m()), qo && p.state.next({ name: J, ...li ? {} : Di });
      if (!t.resolver && e.validate && await E({
        name: J,
        eventType: j.type
      }), !bt && li && p.state.next({ ...n }), t.resolver) {
        const { errors: ui } = await b([J]);
        if (g([J]), le(vt), X) {
          const Xi = LE(n.errors, r, J), Rr = LE(ui, r, Xi.name || J);
          He = Rr.error, J = Rr.name, it = Pn(ui);
        }
      } else
        g([J], !0), He = (await BE(te, s.disabled, o, h, t.shouldUseNativeValidation))[J], g([J]), le(vt), X && (He ? it = !1 : (f.isValid || d.isValid) && (it = await A({
          fields: r,
          onlyCheckValid: !0,
          name: J,
          eventType: j.type
        })));
      X && (te._f.deps && (!Array.isArray(te._f.deps) || te._f.deps.length > 0) && F(te._f.deps), P(J, it, He, Di));
    }
  }, $ = (j, q) => {
    if (ze(n.errors, q) && j.focus)
      return j.focus(), 1;
  }, F = async (j, q = {}) => {
    let J, X;
    const te = du(j);
    if (t.resolver) {
      const le = await _(Lt(j) ? j : te);
      J = Pn(le), X = j ? !te.some((ye) => ze(le, ye)) : J;
    } else j ? (X = (await Promise.all(te.map(async (le) => {
      const ye = ze(r, le);
      return await A({
        fields: ye && ye._f ? { [le]: ye } : ye,
        eventType: Za.TRIGGER
      });
    }))).every(Boolean), !(!X && !n.isValid) && m()) : X = J = await A({
      fields: r,
      name: j,
      eventType: Za.TRIGGER
    });
    return p.state.next({
      ...!Cn(j) || (f.isValid || d.isValid) && J !== n.isValid ? {} : { name: j },
      ...t.resolver || !j ? { isValid: J } : {},
      errors: n.errors
    }), q.shouldFocus && !X && pu(r, $, j ? te : s.mount), X;
  }, I = (j, q) => {
    let J = {
      ...a.mount ? o : i
    };
    return q && (J = Y4(q.dirtyFields ? n.dirtyFields : n.touchedFields, J)), Lt(j) ? J : Cn(j) ? ze(J, j) : j.map((X) => ze(J, X));
  }, L = (j, q) => ({
    invalid: !!ze((q || n).errors, j),
    isDirty: !!ze((q || n).dirtyFields, j),
    error: ze((q || n).errors, j),
    isValidating: !!ze(n.validatingFields, j),
    isTouched: !!ze((q || n).touchedFields, j)
  }), K = (j) => {
    const q = j ? du(j) : void 0;
    q?.forEach((J) => rn(n.errors, J)), q ? q.forEach((J) => {
      p.state.next({
        name: J,
        errors: n.errors
      });
    }) : p.state.next({
      errors: {}
    });
  }, Y = (j, q, J) => {
    const X = (ze(r, j, { _f: {} })._f || {}).ref, te = ze(n.errors, j) || {}, { ref: le, message: ye, type: Ce, ...He } = te;
    $t(n.errors, j, {
      ...He,
      ...q,
      ref: X
    }), p.state.next({
      name: j,
      errors: n.errors,
      isValid: !1
    }), J && J.shouldFocus && X && X.focus && X.focus();
  }, se = (j, q) => Kr(j) ? p.state.subscribe({
    next: (J) => "values" in J && j(N(void 0, q), J)
  }) : N(j, q, !0), ve = (j) => p.state.subscribe({
    next: (q) => {
      kQ(j.name, q.name, j.exact) && TQ(q, j.formState || f, xe, j.reRenderRoot) && j.callback({
        values: { ...o },
        ...n,
        ...q,
        defaultValues: i
      });
    }
  }).unsubscribe, B = (j) => (a.mount = !0, d = {
    ...d,
    ...j.formState
  }, ve({
    ...j,
    formState: {
      ...c,
      ...j.formState
    }
  })), T = (j, q = {}) => {
    for (const J of j ? du(j) : s.mount)
      s.mount.delete(J), s.array.delete(J), q.keepValue || (rn(r, J), rn(o, J)), !q.keepError && rn(n.errors, J), !q.keepDirty && rn(n.dirtyFields, J), !q.keepTouched && rn(n.touchedFields, J), !q.keepIsValidating && rn(n.validatingFields, J), !t.shouldUnregister && !q.keepDefaultValue && rn(i, J);
    p.state.next({
      values: sn(o)
    }), p.state.next({
      ...n,
      ...q.keepDirty ? { isDirty: R() } : {}
    }), !q.keepIsValid && m();
  }, D = ({ disabled: j, name: q }) => {
    if (vi(j) && a.mount || j || s.disabled.has(q)) {
      const te = s.disabled.has(q) !== !!j;
      j ? s.disabled.add(q) : s.disabled.delete(q), te && a.mount && !a.action && m();
    }
  }, C = (j, q = {}) => {
    let J = ze(r, j);
    const X = vi(q.disabled) || vi(t.disabled);
    return $t(r, j, {
      ...J || {},
      _f: {
        ...J && J._f ? J._f : { ref: { name: j } },
        name: j,
        mount: !0,
        ...q
      }
    }), s.mount.add(j), J ? D({
      disabled: vi(q.disabled) ? q.disabled : t.disabled,
      name: j
    }) : S(j, !0, q.value), {
      ...X ? { disabled: q.disabled || t.disabled } : {},
      ...t.progressive ? {
        required: !!q.required,
        min: Rl(q.min),
        max: Rl(q.max),
        minLength: Rl(q.minLength),
        maxLength: Rl(q.maxLength),
        pattern: Rl(q.pattern)
      } : {},
      name: j,
      onChange: Q,
      onBlur: Q,
      ref: (te) => {
        if (te) {
          C(j, q), J = ze(r, j);
          const le = Lt(te.value) && te.querySelectorAll && te.querySelectorAll("input,select,textarea")[0] || te, ye = _Q(le), Ce = J._f.refs || [];
          if (ye ? Ce.find((He) => He === le) : le === J._f.ref)
            return;
          $t(r, j, {
            _f: {
              ...J._f,
              ...ye ? {
                refs: [
                  ...Ce.filter(vv),
                  le,
                  ...Array.isArray(ze(i, j)) ? [{}] : []
                ],
                ref: { type: le.type, name: j }
              } : { ref: le }
            }
          }), S(j, !1, void 0, le);
        } else
          J = ze(r, j, {}), J._f && (J._f.mount = !1), (t.shouldUnregister || q.shouldUnregister) && !(dQ(s.array, j) && a.action) && s.unMount.add(j);
      }
    };
  }, z = () => t.shouldFocusError && pu(r, $, s.mount), Z = (j) => {
    vi(j) && (p.state.next({ disabled: j }), pu(r, (q, J) => {
      const X = ze(r, J);
      X && (q.disabled = X._f.disabled || j, Array.isArray(X._f.refs) && X._f.refs.forEach((te) => {
        te.disabled = X._f.disabled || j;
      }));
    }, 0, !1));
  }, ne = (j, q) => async (J) => {
    let X;
    J && (J.preventDefault && J.preventDefault(), J.persist && J.persist());
    let te = sn(o);
    if (p.state.next({
      isSubmitting: !0
    }), t.resolver) {
      const { errors: le, values: ye } = await b();
      g(), n.errors = le, te = sn(ye);
    } else
      await A({
        fields: r,
        eventType: Za.SUBMIT
      });
    if (s.disabled.size)
      for (const le of s.disabled)
        rn(te, le);
    if (rn(n.errors, G4), Pn(n.errors)) {
      p.state.next({
        errors: {}
      });
      try {
        await j(te, J);
      } catch (le) {
        X = le;
      }
    } else
      q && await q({ ...n.errors }, J), z(), setTimeout(z);
    if (p.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Pn(n.errors) && !X,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), X)
      throw X;
  }, de = (j, q = {}) => {
    ze(r, j) && (Lt(q.defaultValue) ? ue(j, sn(ze(i, j))) : (ue(j, q.defaultValue), $t(i, j, sn(q.defaultValue))), q.keepTouched || rn(n.touchedFields, j), q.keepDirty || (rn(n.dirtyFields, j), n.isDirty = q.defaultValue ? R(j, sn(ze(i, j))) : R()), q.keepError || (rn(n.errors, j), f.isValid && m()), p.state.next({ ...n }));
  }, fe = (j, q = {}) => {
    const J = j ? sn(j) : i, X = sn(J), te = Pn(j), le = te ? i : X;
    if (q.keepDefaultValues || (i = J), !q.keepValues) {
      if (q.keepDirtyValues) {
        const ye = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(Xa(i, o))
        ]);
        for (const Ce of Array.from(ye)) {
          const He = ze(n.dirtyFields, Ce), it = ze(o, Ce), vt = ze(le, Ce);
          He && !Lt(it) ? $t(le, Ce, it) : !He && !Lt(vt) && ue(Ce, vt);
        }
      } else {
        if (Gb && Lt(j))
          for (const ye of s.mount) {
            const Ce = ze(r, ye);
            if (Ce && Ce._f) {
              const He = Array.isArray(Ce._f.refs) ? Ce._f.refs[0] : Ce._f.ref;
              if (Cd(He)) {
                const it = He.closest("form");
                if (it) {
                  it.reset();
                  break;
                }
              }
            }
          }
        if (q.keepFieldsRef)
          for (const ye of s.mount)
            ue(ye, ze(le, ye));
        else
          r = {};
      }
      o = t.shouldUnregister ? q.keepDefaultValues ? sn(i) : {} : sn(le), p.array.next({
        values: { ...le }
      }), p.state.next({
        values: { ...le }
      });
    }
    s = {
      mount: q.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, a.mount = !f.isValid || !!q.keepIsValid || !!q.keepDirtyValues || !t.shouldUnregister && !Pn(le), a.watch = !!t.shouldUnregister, a.keepIsValid = !!q.keepIsValid, a.action = !1, q.keepErrors || (n.errors = {}), p.state.next({
      submitCount: q.keepSubmitCount ? n.submitCount : 0,
      isDirty: te ? !1 : q.keepDirty ? n.isDirty : !!(q.keepDefaultValues && !ho(j, i)),
      isSubmitted: q.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: te ? {} : q.keepDirtyValues ? q.keepDefaultValues && o ? Xa(i, o) : n.dirtyFields : q.keepDefaultValues && j ? Xa(i, j) : q.keepDirty ? n.dirtyFields : {},
      touchedFields: q.keepTouched ? n.touchedFields : {},
      errors: q.keepErrors ? n.errors : {},
      isSubmitSuccessful: q.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: i
    });
  }, Ee = (j, q) => fe(Kr(j) ? j(o) : j, { ...t.resetOptions, ...q }), re = (j, q = {}) => {
    const J = ze(r, j), X = J && J._f;
    if (X) {
      const te = X.refs ? X.refs[0] : X.ref;
      te.focus && setTimeout(() => {
        te.focus(), q.shouldSelect && Kr(te.select) && te.select();
      });
    }
  }, xe = (j) => {
    n = {
      ...n,
      ...j
    };
  }, pe = {
    control: {
      register: C,
      unregister: T,
      getFieldState: L,
      handleSubmit: ne,
      setError: Y,
      _subscribe: ve,
      _runSchema: b,
      _updateIsValidating: g,
      _focusError: z,
      _getWatch: N,
      _getDirty: R,
      _setValid: m,
      _setFieldArray: y,
      _setDisabledField: D,
      _setErrors: x,
      _getFieldArray: U,
      _reset: fe,
      _resetDefaultValues: () => Kr(t.defaultValues) && t.defaultValues().then((j) => {
        Ee(j, t.resetOptions), p.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: k,
      _disableForm: Z,
      _subjects: p,
      _proxyFormState: f,
      get _fields() {
        return r;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return a;
      },
      set _state(j) {
        a = j;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return s;
      },
      set _names(j) {
        s = j;
      },
      get _formState() {
        return n;
      },
      get _options() {
        return t;
      },
      set _options(j) {
        t = {
          ...t,
          ...j
        };
      }
    },
    subscribe: B,
    trigger: F,
    register: C,
    handleSubmit: ne,
    watch: se,
    setValue: ue,
    getValues: I,
    reset: Ee,
    resetField: de,
    clearErrors: K,
    unregister: T,
    setError: Y,
    setFocus: re,
    getFieldState: L
  };
  return {
    ...pe,
    formControl: pe
  };
}
function NQ(e = {}) {
  const t = W.useRef(void 0), n = W.useRef(void 0), [r, i] = W.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Kr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    isReady: !1,
    defaultValues: Kr(e.defaultValues) ? void 0 : e.defaultValues
  });
  if (!t.current)
    if (e.formControl)
      t.current = {
        ...e.formControl,
        formState: r
      }, e.defaultValues && !Kr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions);
    else {
      const { formControl: a, ...s } = IQ(e);
      t.current = {
        ...s,
        formState: r
      };
    }
  const o = t.current.control;
  return o._options = e, mQ(() => {
    const a = o._subscribe({
      formState: o._proxyFormState,
      callback: () => i({ ...o._formState }),
      reRenderRoot: !0
    });
    return i((s) => ({
      ...s,
      isReady: !0
    })), o._formState.isReady = !0, a;
  }, [o]), W.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), W.useEffect(() => {
    e.mode && (o._options.mode = e.mode), e.reValidateMode && (o._options.reValidateMode = e.reValidateMode);
  }, [o, e.mode, e.reValidateMode]), W.useEffect(() => {
    e.errors && (o._setErrors(e.errors), o._focusError());
  }, [o, e.errors]), W.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [o, e.shouldUnregister]), W.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const a = o._getDirty();
      a !== r.isDirty && o._subjects.state.next({
        isDirty: a
      });
    }
  }, [o, r.isDirty]), W.useEffect(() => {
    var a;
    e.values && !ho(e.values, n.current) ? (o._reset(e.values, {
      keepFieldsRef: !0,
      ...o._options.resetOptions
    }), !((a = o._options.resetOptions) === null || a === void 0) && a.keepIsValid || o._setValid(), n.current = e.values, i((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [o, e.values]), W.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), t.current.formState = W.useMemo(() => vQ(r, o), [o, r]), t.current;
}
const RQ = Xt(
  ({ className: e, ...t }, n) => /* @__PURE__ */ M.jsx(
    "input",
    {
      ref: n,
      ...t,
      className: Un(
        "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
        e
      )
    }
  )
), MQ = (e, t) => {
  const n = (r) => {
    e.current && !e.current.contains(r.target) && t();
  };
  Se(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
};
function jQ(e, t, n = 250) {
  const [r, i] = Fe(0);
  return Se(() => {
    const o = setTimeout(() => {
      i(0);
    }, n);
    return r === 2 && t(), () => clearTimeout(o);
  }, [r]), () => i((o) => o + 1);
}
var gc = "delete", kt = 5, wr = 1 << kt, Nn = wr - 1, et = {};
function Eg() {
  return { value: !1 };
}
function xr(e) {
  e && (e.value = !0);
}
function e0() {
}
function zs(e) {
  return e.size === void 0 && (e.size = e.__iterate(nA)), e.size;
}
function Po(e, t) {
  if (typeof t != "number") {
    var n = t >>> 0;
    if ("" + n !== t || n === 4294967295)
      return NaN;
    t = n;
  }
  return t < 0 ? zs(e) + t : t;
}
function nA() {
  return !0;
}
function zp(e, t, n) {
  return (e === 0 && !iA(e) || n !== void 0 && e <= -n) && (t === void 0 || n !== void 0 && t >= n);
}
function yc(e, t) {
  return rA(e, t, 0);
}
function Lp(e, t) {
  return rA(e, t, t);
}
function rA(e, t, n) {
  return e === void 0 ? n : iA(e) ? t === 1 / 0 ? t : Math.max(0, t + e) | 0 : t === void 0 || t === e ? e : Math.min(t, e) | 0;
}
function iA(e) {
  return e < 0 || e === 0 && 1 / e === -1 / 0;
}
var oA = "@@__IMMUTABLE_ITERABLE__@@";
function Wn(e) {
  return !!(e && e[oA]);
}
var aA = "@@__IMMUTABLE_KEYED__@@";
function It(e) {
  return !!(e && e[aA]);
}
var sA = "@@__IMMUTABLE_INDEXED__@@";
function Bn(e) {
  return !!(e && e[sA]);
}
function Vp(e) {
  return It(e) || Bn(e);
}
var Jt = function(e) {
  return Wn(e) ? e : sr(e);
}, Ir = /* @__PURE__ */ (function(e) {
  function t(n) {
    return It(n) ? n : Vo(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(Jt), za = /* @__PURE__ */ (function(e) {
  function t(n) {
    return Bn(n) ? n : oi(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(Jt), fl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return Wn(n) && !Vp(n) ? n : vl(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
})(Jt);
Jt.Keyed = Ir;
Jt.Indexed = za;
Jt.Set = fl;
var lA = "@@__IMMUTABLE_SEQ__@@";
function t0(e) {
  return !!(e && e[lA]);
}
var uA = "@@__IMMUTABLE_RECORD__@@";
function dl(e) {
  return !!(e && e[uA]);
}
function Ti(e) {
  return Wn(e) || dl(e);
}
var pl = "@@__IMMUTABLE_ORDERED__@@";
function Jr(e) {
  return !!(e && e[pl]);
}
var bc = 0, ei = 1, kr = 2, Sg = typeof Symbol == "function" && Symbol.iterator, cA = "@@iterator", Bp = Sg || cA, lt = function(e) {
  this.next = e;
};
lt.prototype.toString = function() {
  return "[Iterator]";
};
lt.KEYS = bc;
lt.VALUES = ei;
lt.ENTRIES = kr;
lt.prototype.inspect = lt.prototype.toSource = function() {
  return this.toString();
};
lt.prototype[Bp] = function() {
  return this;
};
function Mt(e, t, n, r) {
  var i = e === 0 ? t : e === 1 ? n : [t, n];
  return r ? r.value = i : r = {
    value: i,
    done: !1
  }, r;
}
function Zn() {
  return { value: void 0, done: !0 };
}
function fA(e) {
  return Array.isArray(e) ? !0 : !!Up(e);
}
function UE(e) {
  return e && typeof e.next == "function";
}
function Og(e) {
  var t = Up(e);
  return t && t.call(e);
}
function Up(e) {
  var t = e && (Sg && e[Sg] || e[cA]);
  if (typeof t == "function")
    return t;
}
function FQ(e) {
  var t = Up(e);
  return t && t === e.entries;
}
function zQ(e) {
  var t = Up(e);
  return t && t === e.keys;
}
var hl = Object.prototype.hasOwnProperty;
function dA(e) {
  return Array.isArray(e) || typeof e == "string" ? !0 : e && typeof e == "object" && Number.isInteger(e.length) && e.length >= 0 && (e.length === 0 ? Object.keys(e).length === 1 : e.hasOwnProperty(e.length - 1));
}
var sr = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? r0() : Ti(n) ? n.toSeq() : VQ(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq {", "}");
  }, t.prototype.cacheResult = function() {
    return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
  }, t.prototype.__iterate = function(n, r) {
    var i = this._cache;
    if (i) {
      for (var o = i.length, a = 0; a !== o; ) {
        var s = i[r ? o - ++a : a++];
        if (n(s[1], s[0], this) === !1)
          break;
      }
      return a;
    }
    return this.__iterateUncached(n, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._cache;
    if (i) {
      var o = i.length, a = 0;
      return new lt(function() {
        if (a === o)
          return Zn();
        var s = i[r ? o - ++a : a++];
        return Mt(n, s[0], s[1]);
      });
    }
    return this.__iteratorUncached(n, r);
  }, t;
})(Jt), Vo = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? r0().toKeyedSeq() : Wn(n) ? It(n) ? n.toSeq() : n.fromEntrySeq() : dl(n) ? n.toSeq() : i0(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toKeyedSeq = function() {
    return this;
  }, t;
})(sr), oi = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? r0() : Wn(n) ? It(n) ? n.entrySeq() : n.toIndexedSeq() : dl(n) ? n.toSeq().entrySeq() : pA(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toIndexedSeq = function() {
    return this;
  }, t.prototype.toString = function() {
    return this.__toString("Seq [", "]");
  }, t;
})(sr), vl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return (Wn(n) && !Vp(n) ? n : oi(n)).toSetSeq();
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return t(arguments);
  }, t.prototype.toSetSeq = function() {
    return this;
  }, t;
})(sr);
sr.isSeq = t0;
sr.Keyed = Vo;
sr.Set = vl;
sr.Indexed = oi;
sr.prototype[lA] = !0;
var Sa = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._array = n, this.size = n.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this.has(n) ? this._array[Po(this, n)] : r;
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._array, o = i.length, a = 0; a !== o; ) {
      var s = r ? o - ++a : a++;
      if (n(i[s], s, this) === !1)
        break;
    }
    return a;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._array, o = i.length, a = 0;
    return new lt(function() {
      if (a === o)
        return Zn();
      var s = r ? o - ++a : a++;
      return Mt(n, s, i[s]);
    });
  }, t;
})(oi), n0 = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = Object.keys(n).concat(
      Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(n) : []
    );
    this._object = n, this._keys = r, this.size = r.length;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return r !== void 0 && !this.has(n) ? r : this._object[n];
  }, t.prototype.has = function(n) {
    return hl.call(this._object, n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this._object, o = this._keys, a = o.length, s = 0; s !== a; ) {
      var l = o[r ? a - ++s : s++];
      if (n(i[l], l, this) === !1)
        break;
    }
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this._object, o = this._keys, a = o.length, s = 0;
    return new lt(function() {
      if (s === a)
        return Zn();
      var l = o[r ? a - ++s : s++];
      return Mt(n, l, i[l]);
    });
  }, t;
})(Vo);
n0.prototype[pl] = !0;
var LQ = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._collection = n, this.size = n.length || n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.__iterateUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterate(n, r);
    var i = this._collection, o = Og(i), a = 0;
    if (UE(o))
      for (var s; !(s = o.next()).done && n(s.value, a++, this) !== !1; )
        ;
    return a;
  }, t.prototype.__iteratorUncached = function(n, r) {
    if (r)
      return this.cacheResult().__iterator(n, r);
    var i = this._collection, o = Og(i);
    if (!UE(o))
      return new lt(Zn);
    var a = 0;
    return new lt(function() {
      var s = o.next();
      return s.done ? s : Mt(n, a++, s.value);
    });
  }, t;
})(oi), KE;
function r0() {
  return KE || (KE = new Sa([]));
}
function i0(e) {
  var t = o0(e);
  if (t)
    return t.fromEntrySeq();
  if (typeof e == "object")
    return new n0(e);
  throw new TypeError(
    "Expected Array or collection object of [k, v] entries, or keyed object: " + e
  );
}
function pA(e) {
  var t = o0(e);
  if (t)
    return t;
  throw new TypeError(
    "Expected Array or collection object of values: " + e
  );
}
function VQ(e) {
  var t = o0(e);
  if (t)
    return FQ(e) ? t.fromEntrySeq() : zQ(e) ? t.toSetSeq() : t;
  if (typeof e == "object")
    return new n0(e);
  throw new TypeError(
    "Expected Array or collection object of values, or keyed object: " + e
  );
}
function o0(e) {
  return dA(e) ? new Sa(e) : fA(e) ? new LQ(e) : void 0;
}
var hA = "@@__IMMUTABLE_MAP__@@";
function a0(e) {
  return !!(e && e[hA]);
}
function vA(e) {
  return a0(e) && Jr(e);
}
function qE(e) {
  return !!(e && typeof e.equals == "function" && typeof e.hashCode == "function");
}
function nr(e, t) {
  if (e === t || e !== e && t !== t)
    return !0;
  if (!e || !t)
    return !1;
  if (typeof e.valueOf == "function" && typeof t.valueOf == "function") {
    if (e = e.valueOf(), t = t.valueOf(), e === t || e !== e && t !== t)
      return !0;
    if (!e || !t)
      return !1;
  }
  return !!(qE(e) && qE(t) && e.equals(t));
}
var Ml = typeof Math.imul == "function" && Math.imul(4294967295, 2) === -2 ? Math.imul : function(e, t) {
  e |= 0, t |= 0;
  var n = e & 65535, r = t & 65535;
  return n * r + ((e >>> 16) * r + n * (t >>> 16) << 16 >>> 0) | 0;
};
function Kp(e) {
  return e >>> 1 & 1073741824 | e & 3221225471;
}
var BQ = Object.prototype.valueOf;
function Qn(e) {
  if (e == null)
    return HE(e);
  if (typeof e.hashCode == "function")
    return Kp(e.hashCode(e));
  var t = ZQ(e);
  if (t == null)
    return HE(t);
  switch (typeof t) {
    case "boolean":
      return t ? 1108378657 : 1108378656;
    case "number":
      return UQ(t);
    case "string":
      return t.length > GQ ? KQ(t) : $g(t);
    case "object":
    case "function":
      return HQ(t);
    case "symbol":
      return qQ(t);
    default:
      if (typeof t.toString == "function")
        return $g(t.toString());
      throw new Error("Value type " + typeof t + " cannot be hashed.");
  }
}
function HE(e) {
  return e === null ? 1108378658 : 1108378659;
}
function UQ(e) {
  if (e !== e || e === 1 / 0)
    return 0;
  var t = e | 0;
  for (t !== e && (t ^= e * 4294967295); e > 4294967295; )
    e /= 4294967295, t ^= e;
  return Kp(t);
}
function KQ(e) {
  var t = yv[e];
  return t === void 0 && (t = $g(e), gv === YQ && (gv = 0, yv = {}), gv++, yv[e] = t), t;
}
function $g(e) {
  for (var t = 0, n = 0; n < e.length; n++)
    t = 31 * t + e.charCodeAt(n) | 0;
  return Kp(t);
}
function qQ(e) {
  var t = GE[e];
  return t !== void 0 || (t = mA(), GE[e] = t), t;
}
function HQ(e) {
  var t;
  if (Tg && (t = kg.get(e), t !== void 0) || (t = e[ea], t !== void 0) || !ZE && (t = e.propertyIsEnumerable && e.propertyIsEnumerable[ea], t !== void 0 || (t = WQ(e), t !== void 0)))
    return t;
  if (t = mA(), Tg)
    kg.set(e, t);
  else {
    if (WE !== void 0 && WE(e) === !1)
      throw new Error("Non-extensible objects are not allowed as keys.");
    if (ZE)
      Object.defineProperty(e, ea, {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: t
      });
    else if (e.propertyIsEnumerable !== void 0 && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable)
      e.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(
          this,
          arguments
        );
      }, e.propertyIsEnumerable[ea] = t;
    else if (e.nodeType !== void 0)
      e[ea] = t;
    else
      throw new Error("Unable to set a non-enumerable property on object.");
  }
  return t;
}
var WE = Object.isExtensible, ZE = (function() {
  try {
    return Object.defineProperty({}, "@", {}), !0;
  } catch {
    return !1;
  }
})();
function WQ(e) {
  if (e && e.nodeType > 0)
    switch (e.nodeType) {
      case 1:
        return e.uniqueID;
      case 9:
        return e.documentElement && e.documentElement.uniqueID;
    }
}
function ZQ(e) {
  return e.valueOf !== BQ && typeof e.valueOf == "function" ? e.valueOf(e) : e;
}
function mA() {
  var e = ++mv;
  return mv & 1073741824 && (mv = 0), e;
}
var Tg = typeof WeakMap == "function", kg;
Tg && (kg = /* @__PURE__ */ new WeakMap());
var GE = /* @__PURE__ */ Object.create(null), mv = 0, ea = "__immutablehash__";
typeof Symbol == "function" && (ea = Symbol(ea));
var GQ = 16, YQ = 255, gv = 0, yv = {}, qp = /* @__PURE__ */ (function(e) {
  function t(n, r) {
    this._iter = n, this._useKeys = r, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function(n, r) {
    return this._iter.get(n, r);
  }, t.prototype.has = function(n) {
    return this._iter.has(n);
  }, t.prototype.valueSeq = function() {
    return this._iter.valueSeq();
  }, t.prototype.reverse = function() {
    var n = this, r = s0(this, !0);
    return this._useKeys || (r.valueSeq = function() {
      return n._iter.toSeq().reverse();
    }), r;
  }, t.prototype.map = function(n, r) {
    var i = this, o = wA(this, n, r);
    return this._useKeys || (o.valueSeq = function() {
      return i._iter.toSeq().map(n, r);
    }), o;
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o, a) {
      return n(o, a, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._iter.__iterator(n, r);
  }, t;
})(Vo);
qp.prototype[pl] = !0;
var gA = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.includes = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return r && zs(this), this._iter.__iterate(
      function(a) {
        return n(a, r ? i.size - ++o : o++, i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = this, o = this._iter.__iterator(ei, r), a = 0;
    return r && zs(this), new lt(function() {
      var s = o.next();
      return s.done ? s : Mt(
        n,
        r ? i.size - ++a : a++,
        s.value,
        s
      );
    });
  }, t;
})(oi), yA = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.has = function(n) {
    return this._iter.includes(n);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(ei, r);
    return new lt(function() {
      var o = i.next();
      return o.done ? o : Mt(n, o.value, o.value, o);
    });
  }, t;
})(vl), bA = /* @__PURE__ */ (function(e) {
  function t(n) {
    this._iter = n, this.size = n.size;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.entrySeq = function() {
    return this._iter.toSeq();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._iter.__iterate(function(o) {
      if (o) {
        QE(o);
        var a = Wn(o);
        return n(
          a ? o.get(1) : o[1],
          a ? o.get(0) : o[0],
          i
        );
      }
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    var i = this._iter.__iterator(ei, r);
    return new lt(function() {
      for (; ; ) {
        var o = i.next();
        if (o.done)
          return o;
        var a = o.value;
        if (a) {
          QE(a);
          var s = Wn(a);
          return Mt(
            n,
            s ? a.get(0) : a[0],
            s ? a.get(1) : a[1],
            o
          );
        }
      }
    });
  }, t;
})(Vo);
gA.prototype.cacheResult = qp.prototype.cacheResult = yA.prototype.cacheResult = bA.prototype.cacheResult = c0;
function _A(e) {
  var t = ki(e);
  return t._iter = e, t.size = e.size, t.flip = function() {
    return e;
  }, t.reverse = function() {
    var n = e.reverse.apply(this);
    return n.flip = function() {
      return e.reverse();
    }, n;
  }, t.has = function(n) {
    return e.includes(n);
  }, t.includes = function(n) {
    return e.has(n);
  }, t.cacheResult = c0, t.__iterateUncached = function(n, r) {
    var i = this;
    return e.__iterate(function(o, a) {
      return n(a, o, i) !== !1;
    }, r);
  }, t.__iteratorUncached = function(n, r) {
    if (n === kr) {
      var i = e.__iterator(n, r);
      return new lt(function() {
        var o = i.next();
        if (!o.done) {
          var a = o.value[0];
          o.value[0] = o.value[1], o.value[1] = a;
        }
        return o;
      });
    }
    return e.__iterator(
      n === ei ? bc : ei,
      r
    );
  }, t;
}
function wA(e, t, n) {
  var r = ki(e);
  return r.size = e.size, r.has = function(i) {
    return e.has(i);
  }, r.get = function(i, o) {
    var a = e.get(i, et);
    return a === et ? o : t.call(n, a, i, e);
  }, r.__iterateUncached = function(i, o) {
    var a = this;
    return e.__iterate(
      function(s, l, u) {
        return i(t.call(n, s, l, u), l, a) !== !1;
      },
      o
    );
  }, r.__iteratorUncached = function(i, o) {
    var a = e.__iterator(kr, o);
    return new lt(function() {
      var s = a.next();
      if (s.done)
        return s;
      var l = s.value, u = l[0];
      return Mt(
        i,
        u,
        t.call(n, l[1], u, e),
        s
      );
    });
  }, r;
}
function s0(e, t) {
  var n = this, r = ki(e);
  return r._iter = e, r.size = e.size, r.reverse = function() {
    return e;
  }, e.flip && (r.flip = function() {
    var i = _A(e);
    return i.reverse = function() {
      return e.flip();
    }, i;
  }), r.get = function(i, o) {
    return e.get(t ? i : -1 - i, o);
  }, r.has = function(i) {
    return e.has(t ? i : -1 - i);
  }, r.includes = function(i) {
    return e.includes(i);
  }, r.cacheResult = c0, r.__iterate = function(i, o) {
    var a = this, s = 0;
    return o && zs(e), e.__iterate(
      function(l, u) {
        return i(l, t ? u : o ? a.size - ++s : s++, a);
      },
      !o
    );
  }, r.__iterator = function(i, o) {
    var a = 0;
    o && zs(e);
    var s = e.__iterator(kr, !o);
    return new lt(function() {
      var l = s.next();
      if (l.done)
        return l;
      var u = l.value;
      return Mt(
        i,
        t ? u[0] : o ? n.size - ++a : a++,
        u[1],
        l
      );
    });
  }, r;
}
function xA(e, t, n, r) {
  var i = ki(e);
  return r && (i.has = function(o) {
    var a = e.get(o, et);
    return a !== et && !!t.call(n, a, o, e);
  }, i.get = function(o, a) {
    var s = e.get(o, et);
    return s !== et && t.call(n, s, o, e) ? s : a;
  }), i.__iterateUncached = function(o, a) {
    var s = this, l = 0;
    return e.__iterate(function(u, c, f) {
      if (t.call(n, u, c, f))
        return l++, o(u, r ? c : l - 1, s);
    }, a), l;
  }, i.__iteratorUncached = function(o, a) {
    var s = e.__iterator(kr, a), l = 0;
    return new lt(function() {
      for (; ; ) {
        var u = s.next();
        if (u.done)
          return u;
        var c = u.value, f = c[0], d = c[1];
        if (t.call(n, d, f, e))
          return Mt(o, r ? f : l++, d, u);
      }
    });
  }, i;
}
function QQ(e, t, n) {
  var r = gl().asMutable();
  return e.__iterate(function(i, o) {
    r.update(t.call(n, i, o, e), 0, function(a) {
      return a + 1;
    });
  }), r.asImmutable();
}
function JQ(e, t, n) {
  var r = It(e), i = (Jr(e) ? Wi() : gl()).asMutable();
  e.__iterate(function(a, s) {
    i.update(
      t.call(n, a, s, e),
      function(l) {
        return l = l || [], l.push(r ? [s, a] : a), l;
      }
    );
  });
  var o = u0(e);
  return i.map(function(a) {
    return gt(e, o(a));
  }).asImmutable();
}
function XQ(e, t, n) {
  var r = It(e), i = [[], []];
  e.__iterate(function(a, s) {
    i[t.call(n, a, s, e) ? 1 : 0].push(
      r ? [s, a] : a
    );
  });
  var o = u0(e);
  return i.map(function(a) {
    return gt(e, o(a));
  });
}
function l0(e, t, n, r) {
  var i = e.size;
  if (zp(t, n, i))
    return e;
  if (typeof i > "u" && (t < 0 || n < 0))
    return l0(e.toSeq().cacheResult(), t, n, r);
  var o = yc(t, i), a = Lp(n, i), s = a - o, l;
  s === s && (l = s < 0 ? 0 : s);
  var u = ki(e);
  return u.size = l === 0 ? l : e.size && l || void 0, !r && t0(e) && l >= 0 && (u.get = function(c, f) {
    return c = Po(this, c), c >= 0 && c < l ? e.get(c + o, f) : f;
  }), u.__iterateUncached = function(c, f) {
    var d = this;
    if (l === 0)
      return 0;
    if (f)
      return this.cacheResult().__iterate(c, f);
    var p = 0, h = !0, v = 0;
    return e.__iterate(function(m, g) {
      if (!(h && (h = p++ < o)))
        return v++, c(m, r ? g : v - 1, d) !== !1 && v !== l;
    }), v;
  }, u.__iteratorUncached = function(c, f) {
    if (l !== 0 && f)
      return this.cacheResult().__iterator(c, f);
    if (l === 0)
      return new lt(Zn);
    var d = e.__iterator(c, f), p = 0, h = 0;
    return new lt(function() {
      for (; p++ < o; )
        d.next();
      if (++h > l)
        return Zn();
      var v = d.next();
      return r || c === ei || v.done ? v : c === bc ? Mt(c, h - 1, void 0, v) : Mt(c, h - 1, v.value[1], v);
    });
  }, u;
}
function eJ(e, t, n) {
  var r = ki(e);
  return r.__iterateUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterate(i, o);
    var s = 0;
    return e.__iterate(
      function(l, u, c) {
        return t.call(n, l, u, c) && ++s && i(l, u, a);
      }
    ), s;
  }, r.__iteratorUncached = function(i, o) {
    var a = this;
    if (o)
      return this.cacheResult().__iterator(i, o);
    var s = e.__iterator(kr, o), l = !0;
    return new lt(function() {
      if (!l)
        return Zn();
      var u = s.next();
      if (u.done)
        return u;
      var c = u.value, f = c[0], d = c[1];
      return t.call(n, d, f, a) ? i === kr ? u : Mt(i, f, d, u) : (l = !1, Zn());
    });
  }, r;
}
function EA(e, t, n, r) {
  var i = ki(e);
  return i.__iterateUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterate(o, a);
    var l = !0, u = 0;
    return e.__iterate(function(c, f, d) {
      if (!(l && (l = t.call(n, c, f, d))))
        return u++, o(c, r ? f : u - 1, s);
    }), u;
  }, i.__iteratorUncached = function(o, a) {
    var s = this;
    if (a)
      return this.cacheResult().__iterator(o, a);
    var l = e.__iterator(kr, a), u = !0, c = 0;
    return new lt(function() {
      var f, d, p;
      do {
        if (f = l.next(), f.done)
          return r || o === ei ? f : o === bc ? Mt(o, c++, void 0, f) : Mt(o, c++, f.value[1], f);
        var h = f.value;
        d = h[0], p = h[1], u && (u = t.call(n, p, d, s));
      } while (u);
      return o === kr ? f : Mt(o, d, p, f);
    });
  }, i;
}
function tJ(e, t) {
  var n = It(e), r = [e].concat(t).map(function(a) {
    return Wn(a) ? n && (a = Ir(a)) : a = n ? i0(a) : pA(Array.isArray(a) ? a : [a]), a;
  }).filter(function(a) {
    return a.size !== 0;
  });
  if (r.length === 0)
    return e;
  if (r.length === 1) {
    var i = r[0];
    if (i === e || n && It(i) || Bn(e) && Bn(i))
      return i;
  }
  var o = new Sa(r);
  return n ? o = o.toKeyedSeq() : Bn(e) || (o = o.toSetSeq()), o = o.flatten(!0), o.size = r.reduce(function(a, s) {
    if (a !== void 0) {
      var l = s.size;
      if (l !== void 0)
        return a + l;
    }
  }, 0), o;
}
function SA(e, t, n) {
  var r = ki(e);
  return r.__iterateUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterate(i, o);
    var a = 0, s = !1;
    function l(u, c) {
      u.__iterate(function(f, d) {
        return (!t || c < t) && Wn(f) ? l(f, c + 1) : (a++, i(f, n ? d : a - 1, r) === !1 && (s = !0)), !s;
      }, o);
    }
    return l(e, 0), a;
  }, r.__iteratorUncached = function(i, o) {
    if (o)
      return this.cacheResult().__iterator(i, o);
    var a = e.__iterator(i, o), s = [], l = 0;
    return new lt(function() {
      for (; a; ) {
        var u = a.next();
        if (u.done !== !1) {
          a = s.pop();
          continue;
        }
        var c = u.value;
        if (i === kr && (c = c[1]), (!t || s.length < t) && Wn(c))
          s.push(a), a = c.__iterator(i, o);
        else
          return n ? u : Mt(i, l++, c, u);
      }
      return Zn();
    });
  }, r;
}
function nJ(e, t, n) {
  var r = u0(e);
  return e.toSeq().map(function(i, o) {
    return r(t.call(n, i, o, e));
  }).flatten(!0);
}
function rJ(e, t) {
  var n = ki(e);
  return n.size = e.size && e.size * 2 - 1, n.__iterateUncached = function(r, i) {
    var o = this, a = 0;
    return e.__iterate(
      function(s) {
        return (!a || r(t, a++, o) !== !1) && r(s, a++, o) !== !1;
      },
      i
    ), a;
  }, n.__iteratorUncached = function(r, i) {
    var o = e.__iterator(ei, i), a = 0, s;
    return new lt(function() {
      return (!s || a % 2) && (s = o.next(), s.done) ? s : a % 2 ? Mt(r, a++, t) : Mt(r, a++, s.value, s);
    });
  }, n;
}
function Ls(e, t, n) {
  t || (t = OA);
  var r = It(e), i = 0, o = e.toSeq().map(function(a, s) {
    return [s, a, i++, n ? n(a, s, e) : a];
  }).valueSeq().toArray();
  return o.sort(function(a, s) {
    return t(a[3], s[3]) || a[2] - s[2];
  }).forEach(
    r ? function(a, s) {
      o[s].length = 2;
    } : function(a, s) {
      o[s] = a[1];
    }
  ), r ? Vo(o) : Bn(e) ? oi(o) : vl(o);
}
function of(e, t, n) {
  if (t || (t = OA), n) {
    var r = e.toSeq().map(function(i, o) {
      return [i, n(i, o, e)];
    }).reduce(function(i, o) {
      return YE(t, i[1], o[1]) ? o : i;
    });
    return r && r[0];
  }
  return e.reduce(function(i, o) {
    return YE(t, i, o) ? o : i;
  });
}
function YE(e, t, n) {
  var r = e(n, t);
  return r === 0 && n !== t && (n == null || n !== n) || r > 0;
}
function af(e, t, n, r) {
  var i = ki(e), o = new Sa(n).map(function(a) {
    return a.size;
  });
  return i.size = r ? o.max() : o.min(), i.__iterate = function(a, s) {
    for (var l = this.__iterator(ei, s), u, c = 0; !(u = l.next()).done && a(u.value, c++, this) !== !1; )
      ;
    return c;
  }, i.__iteratorUncached = function(a, s) {
    var l = n.map(
      function(f) {
        return f = Jt(f), Og(s ? f.reverse() : f);
      }
    ), u = 0, c = !1;
    return new lt(function() {
      var f;
      return c || (f = l.map(function(d) {
        return d.next();
      }), c = r ? f.every(function(d) {
        return d.done;
      }) : f.some(function(d) {
        return d.done;
      })), c ? Zn() : Mt(
        a,
        u++,
        t.apply(
          null,
          f.map(function(d) {
            return d.value;
          })
        )
      );
    });
  }, i;
}
function gt(e, t) {
  return e === t ? e : t0(e) ? t : e.constructor(t);
}
function QE(e) {
  if (e !== Object(e))
    throw new TypeError("Expected [K, V] tuple: " + e);
}
function u0(e) {
  return It(e) ? Ir : Bn(e) ? za : fl;
}
function ki(e) {
  return Object.create(
    (It(e) ? Vo : Bn(e) ? oi : vl).prototype
  );
}
function c0() {
  return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : sr.prototype.cacheResult.call(this);
}
function OA(e, t) {
  return e === void 0 && t === void 0 ? 0 : e === void 0 ? 1 : t === void 0 ? -1 : e > t ? 1 : e < t ? -1 : 0;
}
function gi(e, t) {
  t = t || 0;
  for (var n = Math.max(0, e.length - t), r = new Array(n), i = 0; i < n; i++)
    r[i] = e[i + t];
  return r;
}
function f0(e, t) {
  if (!e)
    throw new Error(t);
}
function er(e) {
  f0(
    e !== 1 / 0,
    "Cannot perform this action with an infinite size."
  );
}
function $A(e) {
  if (dA(e) && typeof e != "string")
    return e;
  if (Jr(e))
    return e.toArray();
  throw new TypeError(
    "Invalid keyPath: expected Ordered Collection or Array: " + e
  );
}
var iJ = Object.prototype.toString;
function oJ(e) {
  if (!e || typeof e != "object" || iJ.call(e) !== "[object Object]")
    return !1;
  var t = Object.getPrototypeOf(e);
  if (t === null)
    return !0;
  for (var n = t, r = Object.getPrototypeOf(t); r !== null; )
    n = r, r = Object.getPrototypeOf(n);
  return n === t;
}
function Do(e) {
  return typeof e == "object" && (Ti(e) || Array.isArray(e) || oJ(e));
}
function Vu(e) {
  try {
    return typeof e == "string" ? JSON.stringify(e) : String(e);
  } catch {
    return JSON.stringify(e);
  }
}
function aJ(e, t) {
  return Ti(e) ? e.has(t) : Do(e) && hl.call(e, t);
}
function TA(e, t, n) {
  return Ti(e) ? e.get(t, n) : aJ(e, t) ? typeof e.get == "function" ? e.get(t) : e[t] : n;
}
function _c(e) {
  return typeof e == "string" && (e === "__proto__" || e === "constructor");
}
function Nd(e) {
  if (Array.isArray(e))
    return gi(e);
  var t = {};
  for (var n in e)
    _c(n) || hl.call(e, n) && (t[n] = e[n]);
  return t;
}
function sJ(e, t) {
  if (!Do(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Ti(e)) {
    if (!e.remove)
      throw new TypeError(
        "Cannot update immutable value without .remove() method: " + e
      );
    return e.remove(t);
  }
  if (!hl.call(e, t))
    return e;
  var n = Nd(e);
  return Array.isArray(n) ? n.splice(t, 1) : delete n[t], n;
}
function lJ(e, t, n) {
  if (_c(t))
    return e;
  if (!Do(e))
    throw new TypeError(
      "Cannot update non-data-structure value: " + e
    );
  if (Ti(e)) {
    if (!e.set)
      throw new TypeError(
        "Cannot update immutable value without .set() method: " + e
      );
    return e.set(t, n);
  }
  if (hl.call(e, t) && n === e[t])
    return e;
  var r = Nd(e);
  return r[t] = n, r;
}
function ml(e, t, n, r) {
  r || (r = n, n = void 0);
  var i = kA(
    Ti(e),
    e,
    $A(t),
    0,
    n,
    r
  );
  return i === et ? n : i;
}
function kA(e, t, n, r, i, o) {
  var a = t === et;
  if (r === n.length) {
    var s = a ? i : t, l = o(s);
    return l === s ? t : l;
  }
  if (!a && !Do(t))
    throw new TypeError(
      "Cannot update within non-data-structure value in path [" + n.slice(0, r).map(Vu) + "]: " + t
    );
  var u = n[r], c = a ? et : TA(t, u, et), f = kA(
    c === et ? e : Ti(c),
    c,
    n,
    r + 1,
    i,
    o
  );
  return f === c ? t : f === et ? sJ(t, u) : lJ(
    a ? e ? Hr() : {} : t,
    u,
    f
  );
}
function uJ(e, t, n) {
  return ml(e, t, et, function() {
    return n;
  });
}
function d0(e, t) {
  return uJ(this, e, t);
}
function cJ(e, t) {
  return ml(e, t, function() {
    return et;
  });
}
function p0(e) {
  return cJ(this, e);
}
function PA(e, t, n, r) {
  return ml(e, [t], n, r);
}
function h0(e, t, n) {
  return arguments.length === 1 ? e(this) : PA(this, e, t, n);
}
function v0(e, t, n) {
  return ml(this, e, t, n);
}
function DA() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return CA(this, e);
}
function AA(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  if (typeof e != "function")
    throw new TypeError("Invalid merger function: " + e);
  return CA(this, t, e);
}
function CA(e, t, n) {
  for (var r = [], i = 0; i < t.length; i++) {
    var o = Ir(t[i]);
    o.size !== 0 && r.push(o);
  }
  return r.length === 0 ? e : e.toSeq().size === 0 && !e.__ownerID && r.length === 1 ? e.constructor(r[0]) : e.withMutations(function(a) {
    for (var s = n ? function(u, c) {
      PA(
        a,
        c,
        et,
        function(f) {
          return f === et ? u : n(f, u, c);
        }
      );
    } : function(u, c) {
      a.set(c, u);
    }, l = 0; l < r.length; l++)
      r[l].forEach(s);
  });
}
function m0(e, t, n) {
  return g0(e, t, fJ(n));
}
function g0(e, t, n) {
  if (!Do(e))
    throw new TypeError(
      "Cannot merge into non-data-structure value: " + e
    );
  if (Ti(e))
    return typeof n == "function" && e.mergeWith ? e.mergeWith.apply(e, [n].concat(t)) : e.merge ? e.merge.apply(e, t) : e.concat.apply(e, t);
  for (var r = Array.isArray(e), i = e, o = r ? za : Ir, a = r ? function(l) {
    i === e && (i = Nd(i)), i.push(l);
  } : function(l, u) {
    if (!_c(u)) {
      var c = hl.call(i, u), f = c && n ? n(i[u], l, u) : l;
      (!c || f !== i[u]) && (i === e && (i = Nd(i)), i[u] = f);
    }
  }, s = 0; s < t.length; s++)
    o(t[s]).forEach(a);
  return i;
}
function fJ(e) {
  function t(n, r, i) {
    return Do(n) && Do(r) && dJ(n, r) ? g0(n, [r], t) : e ? e(n, r, i) : r;
  }
  return t;
}
function dJ(e, t) {
  var n = sr(e), r = sr(t);
  return Bn(n) === Bn(r) && It(n) === It(r);
}
function IA() {
  for (var e = [], t = arguments.length; t--; )
    e[t] = arguments[t];
  return m0(this, e);
}
function NA(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return m0(this, t, e);
}
function y0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return ml(this, e, Hr(), function(r) {
    return g0(r, t);
  });
}
function b0(e) {
  for (var t = [], n = arguments.length - 1; n-- > 0; )
    t[n] = arguments[n + 1];
  return ml(
    this,
    e,
    Hr(),
    function(r) {
      return m0(r, t);
    }
  );
}
function wc(e) {
  var t = this.asMutable();
  return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
}
function xc() {
  return this.__ownerID ? this : this.__ensureOwner(new e0());
}
function Ec() {
  return this.__ensureOwner();
}
function _0() {
  return this.__altered;
}
var gl = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Hr() : a0(n) && !Jr(n) ? n : Hr().withMutations(function(r) {
      var i = e(n);
      er(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return Hr().withMutations(function(i) {
      for (var o = 0; o < n.length; o += 2) {
        if (o + 1 >= n.length)
          throw new Error("Missing value for key: " + n[o]);
        i.set(n[o], n[o + 1]);
      }
    });
  }, t.prototype.toString = function() {
    return this.__toString("Map {", "}");
  }, t.prototype.get = function(n, r) {
    return this._root ? this._root.get(0, void 0, n, r) : r;
  }, t.prototype.set = function(n, r) {
    return eS(this, n, r);
  }, t.prototype.remove = function(n) {
    return eS(this, n, et);
  }, t.prototype.deleteAll = function(n) {
    var r = Jt(n);
    return r.size === 0 ? this : this.withMutations(function(i) {
      r.forEach(function(o) {
        return i.remove(o);
      });
    });
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : Hr();
  }, t.prototype.sort = function(n) {
    return Wi(Ls(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Wi(Ls(this, r, n));
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      o.forEach(function(a, s) {
        o.set(s, n.call(r, a, s, i));
      });
    });
  }, t.prototype.__iterator = function(n, r) {
    return new pJ(this, n, r);
  }, t.prototype.__iterate = function(n, r) {
    var i = this, o = 0;
    return this._root && this._root.iterate(function(a) {
      return o++, n(a[1], a[0], i);
    }, r), o;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? w0(this.size, this._root, n, this.__hash) : this.size === 0 ? Hr() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(Ir);
gl.isMap = a0;
var Dt = gl.prototype;
Dt[hA] = !0;
Dt[gc] = Dt.remove;
Dt.removeAll = Dt.deleteAll;
Dt.setIn = d0;
Dt.removeIn = Dt.deleteIn = p0;
Dt.update = h0;
Dt.updateIn = v0;
Dt.merge = Dt.concat = DA;
Dt.mergeWith = AA;
Dt.mergeDeep = IA;
Dt.mergeDeepWith = NA;
Dt.mergeIn = y0;
Dt.mergeDeepIn = b0;
Dt.withMutations = wc;
Dt.wasAltered = _0;
Dt.asImmutable = Ec;
Dt["@@transducer/init"] = Dt.asMutable = xc;
Dt["@@transducer/step"] = function(e, t) {
  return e.set(t[0], t[1]);
};
Dt["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var Bu = function(e, t) {
  this.ownerID = e, this.entries = t;
};
Bu.prototype.get = function(e, t, n, r) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++)
    if (nr(n, i[o][0]))
      return i[o][1];
  return r;
};
Bu.prototype.update = function(e, t, n, r, i, o, a) {
  for (var s = i === et, l = this.entries, u = 0, c = l.length; u < c && !nr(r, l[u][0]); u++)
    ;
  var f = u < c;
  if (f ? l[u][1] === i : s)
    return this;
  if (xr(a), (s || !f) && xr(o), !(s && l.length === 1)) {
    if (!f && !s && l.length >= bJ)
      return hJ(e, l, r, i);
    var d = e && e === this.ownerID, p = d ? l : gi(l);
    return f ? s ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [r, i] : p.push([r, i]), d ? (this.entries = p, this) : new Bu(e, p);
  }
};
var Vs = function(e, t, n) {
  this.ownerID = e, this.bitmap = t, this.nodes = n;
};
Vs.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = Qn(n));
  var i = 1 << ((e === 0 ? t : t >>> e) & Nn), o = this.bitmap;
  return (o & i) === 0 ? r : this.nodes[RA(o & i - 1)].get(
    e + kt,
    t,
    n,
    r
  );
};
Vs.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = Qn(r));
  var s = (t === 0 ? n : n >>> t) & Nn, l = 1 << s, u = this.bitmap, c = (u & l) !== 0;
  if (!c && i === et)
    return this;
  var f = RA(u & l - 1), d = this.nodes, p = c ? d[f] : void 0, h = x0(
    p,
    e,
    t + kt,
    n,
    r,
    i,
    o,
    a
  );
  if (h === p)
    return this;
  if (!c && h && d.length >= _J)
    return mJ(e, d, u, s, h);
  if (c && !h && d.length === 2 && tS(d[f ^ 1]))
    return d[f ^ 1];
  if (c && h && d.length === 1 && tS(h))
    return h;
  var v = e && e === this.ownerID, m = c ? h ? u : u ^ l : u | l, g = c ? h ? MA(d, f, h, v) : yJ(d, f, v) : gJ(d, f, h, v);
  return v ? (this.bitmap = m, this.nodes = g, this) : new Vs(e, m, g);
};
var Uu = function(e, t, n) {
  this.ownerID = e, this.count = t, this.nodes = n;
};
Uu.prototype.get = function(e, t, n, r) {
  t === void 0 && (t = Qn(n));
  var i = (e === 0 ? t : t >>> e) & Nn, o = this.nodes[i];
  return o ? o.get(e + kt, t, n, r) : r;
};
Uu.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = Qn(r));
  var s = (t === 0 ? n : n >>> t) & Nn, l = i === et, u = this.nodes, c = u[s];
  if (l && !c)
    return this;
  var f = x0(
    c,
    e,
    t + kt,
    n,
    r,
    i,
    o,
    a
  );
  if (f === c)
    return this;
  var d = this.count;
  if (!c)
    d++;
  else if (!f && (d--, d < wJ))
    return vJ(e, u, d, s);
  var p = e && e === this.ownerID, h = MA(u, s, f, p);
  return p ? (this.count = d, this.nodes = h, this) : new Uu(e, d, h);
};
var Bs = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entries = n;
};
Bs.prototype.get = function(e, t, n, r) {
  for (var i = this.entries, o = 0, a = i.length; o < a; o++)
    if (nr(n, i[o][0]))
      return i[o][1];
  return r;
};
Bs.prototype.update = function(e, t, n, r, i, o, a) {
  n === void 0 && (n = Qn(r));
  var s = i === et;
  if (n !== this.keyHash)
    return s ? this : (xr(a), xr(o), E0(this, e, t, n, [r, i]));
  for (var l = this.entries, u = 0, c = l.length; u < c && !nr(r, l[u][0]); u++)
    ;
  var f = u < c;
  if (f ? l[u][1] === i : s)
    return this;
  if (xr(a), (s || !f) && xr(o), s && c === 2)
    return new Hi(e, this.keyHash, l[u ^ 1]);
  var d = e && e === this.ownerID, p = d ? l : gi(l);
  return f ? s ? u === c - 1 ? p.pop() : p[u] = p.pop() : p[u] = [r, i] : p.push([r, i]), d ? (this.entries = p, this) : new Bs(e, this.keyHash, p);
};
var Hi = function(e, t, n) {
  this.ownerID = e, this.keyHash = t, this.entry = n;
};
Hi.prototype.get = function(e, t, n, r) {
  return nr(n, this.entry[0]) ? this.entry[1] : r;
};
Hi.prototype.update = function(e, t, n, r, i, o, a) {
  var s = i === et, l = nr(r, this.entry[0]);
  if (l ? i === this.entry[1] : s)
    return this;
  if (xr(a), s) {
    xr(o);
    return;
  }
  return l ? e && e === this.ownerID ? (this.entry[1] = i, this) : new Hi(e, this.keyHash, [r, i]) : (xr(o), E0(this, e, t, Qn(r), [r, i]));
};
Bu.prototype.iterate = Bs.prototype.iterate = function(e, t) {
  for (var n = this.entries, r = 0, i = n.length - 1; r <= i; r++)
    if (e(n[t ? i - r : r]) === !1)
      return !1;
};
Vs.prototype.iterate = Uu.prototype.iterate = function(e, t) {
  for (var n = this.nodes, r = 0, i = n.length - 1; r <= i; r++) {
    var o = n[t ? i - r : r];
    if (o && o.iterate(e, t) === !1)
      return !1;
  }
};
Hi.prototype.iterate = function(e, t) {
  return e(this.entry);
};
var pJ = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    this._type = r, this._reverse = i, this._stack = n._root && JE(n._root);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.next = function() {
    for (var n = this._type, r = this._stack; r; ) {
      var i = r.node, o = r.index++, a = void 0;
      if (i.entry) {
        if (o === 0)
          return bv(n, i.entry);
      } else if (i.entries) {
        if (a = i.entries.length - 1, o <= a)
          return bv(
            n,
            i.entries[this._reverse ? a - o : o]
          );
      } else if (a = i.nodes.length - 1, o <= a) {
        var s = i.nodes[this._reverse ? a - o : o];
        if (s) {
          if (s.entry)
            return bv(n, s.entry);
          r = this._stack = JE(s, r);
        }
        continue;
      }
      r = this._stack = this._stack.__prev;
    }
    return Zn();
  }, t;
})(lt);
function bv(e, t) {
  return Mt(e, t[0], t[1]);
}
function JE(e, t) {
  return {
    node: e,
    index: 0,
    __prev: t
  };
}
function w0(e, t, n, r) {
  var i = Object.create(Dt);
  return i.size = e, i._root = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var XE;
function Hr() {
  return XE || (XE = w0(0));
}
function eS(e, t, n) {
  var r, i;
  if (e._root) {
    var o = Eg(), a = Eg();
    if (r = x0(
      e._root,
      e.__ownerID,
      0,
      void 0,
      t,
      n,
      o,
      a
    ), !a.value)
      return e;
    i = e.size + (o.value ? n === et ? -1 : 1 : 0);
  } else {
    if (n === et)
      return e;
    i = 1, r = new Bu(e.__ownerID, [[t, n]]);
  }
  return e.__ownerID ? (e.size = i, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? w0(i, r) : Hr();
}
function x0(e, t, n, r, i, o, a, s) {
  return e ? e.update(
    t,
    n,
    r,
    i,
    o,
    a,
    s
  ) : o === et ? e : (xr(s), xr(a), new Hi(t, r, [i, o]));
}
function tS(e) {
  return e.constructor === Hi || e.constructor === Bs;
}
function E0(e, t, n, r, i) {
  if (e.keyHash === r)
    return new Bs(t, r, [e.entry, i]);
  var o = (n === 0 ? e.keyHash : e.keyHash >>> n) & Nn, a = (n === 0 ? r : r >>> n) & Nn, s, l = o === a ? [E0(e, t, n + kt, r, i)] : (s = new Hi(t, r, i), o < a ? [e, s] : [s, e]);
  return new Vs(t, 1 << o | 1 << a, l);
}
function hJ(e, t, n, r) {
  e || (e = new e0());
  for (var i = new Hi(e, Qn(n), [n, r]), o = 0; o < t.length; o++) {
    var a = t[o];
    i = i.update(e, 0, void 0, a[0], a[1]);
  }
  return i;
}
function vJ(e, t, n, r) {
  for (var i = 0, o = 0, a = new Array(n), s = 0, l = 1, u = t.length; s < u; s++, l <<= 1) {
    var c = t[s];
    c !== void 0 && s !== r && (i |= l, a[o++] = c);
  }
  return new Vs(e, i, a);
}
function mJ(e, t, n, r, i) {
  for (var o = 0, a = new Array(wr), s = 0; n !== 0; s++, n >>>= 1)
    a[s] = n & 1 ? t[o++] : void 0;
  return a[r] = i, new Uu(e, o + 1, a);
}
function RA(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), e = e + (e >> 4) & 252645135, e += e >> 8, e += e >> 16, e & 127;
}
function MA(e, t, n, r) {
  var i = r ? e : gi(e);
  return i[t] = n, i;
}
function gJ(e, t, n, r) {
  var i = e.length + 1;
  if (r && t + 1 === i)
    return e[t] = n, e;
  for (var o = new Array(i), a = 0, s = 0; s < i; s++)
    s === t ? (o[s] = n, a = -1) : o[s] = e[s + a];
  return o;
}
function yJ(e, t, n) {
  var r = e.length - 1;
  if (n && t === r)
    return e.pop(), e;
  for (var i = new Array(r), o = 0, a = 0; a < r; a++)
    a === t && (o = 1), i[a] = e[a + o];
  return i;
}
var bJ = wr / 4, _J = wr / 2, wJ = wr / 4, jA = "@@__IMMUTABLE_LIST__@@";
function FA(e) {
  return !!(e && e[jA]);
}
var Hp = /* @__PURE__ */ (function(e) {
  function t(n) {
    var r = Cf();
    if (n == null)
      return r;
    if (FA(n))
      return n;
    var i = e(n), o = i.size;
    return o === 0 ? r : (er(o), o > 0 && o < wr ? Ku(0, o, kt, null, new wo(i.toArray())) : r.withMutations(function(a) {
      a.setSize(o), i.forEach(function(s, l) {
        return a.set(l, s);
      });
    }));
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("List [", "]");
  }, t.prototype.get = function(n, r) {
    if (n = Po(this, n), n >= 0 && n < this.size) {
      n += this._origin;
      var i = zA(this, n);
      return i && i.array[n & Nn];
    }
    return r;
  }, t.prototype.set = function(n, r) {
    return xJ(this, n, r);
  }, t.prototype.remove = function(n) {
    return this.has(n) ? n === 0 ? this.shift() : n === this.size - 1 ? this.pop() : this.splice(n, 1) : this;
  }, t.prototype.insert = function(n, r) {
    return this.splice(n, 0, r);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = kt, this._root = this._tail = this.__hash = void 0, this.__altered = !0, this) : Cf();
  }, t.prototype.push = function() {
    var n = arguments, r = this.size;
    return this.withMutations(function(i) {
      so(i, 0, r + n.length);
      for (var o = 0; o < n.length; o++)
        i.set(r + o, n[o]);
    });
  }, t.prototype.pop = function() {
    return so(this, 0, -1);
  }, t.prototype.unshift = function() {
    var n = arguments;
    return this.withMutations(function(r) {
      so(r, -n.length);
      for (var i = 0; i < n.length; i++)
        r.set(i, n[i]);
    });
  }, t.prototype.shift = function() {
    return so(this, 1);
  }, t.prototype.concat = function() {
    for (var n = arguments, r = [], i = 0; i < arguments.length; i++) {
      var o = n[i], a = e(
        typeof o != "string" && fA(o) ? o : [o]
      );
      a.size !== 0 && r.push(a);
    }
    return r.length === 0 ? this : this.size === 0 && !this.__ownerID && r.length === 1 ? this.constructor(r[0]) : this.withMutations(function(s) {
      r.forEach(function(l) {
        return l.forEach(function(u) {
          return s.push(u);
        });
      });
    });
  }, t.prototype.setSize = function(n) {
    return so(this, 0, n);
  }, t.prototype.map = function(n, r) {
    var i = this;
    return this.withMutations(function(o) {
      for (var a = 0; a < i.size; a++)
        o.set(a, n.call(r, o.get(a), a, i));
    });
  }, t.prototype.slice = function(n, r) {
    var i = this.size;
    return zp(n, r, i) ? this : so(
      this,
      yc(n, i),
      Lp(r, i)
    );
  }, t.prototype.__iterator = function(n, r) {
    var i = r ? this.size : 0, o = nS(this, r);
    return new lt(function() {
      var a = o();
      return a === hu ? Zn() : Mt(n, r ? --i : i++, a);
    });
  }, t.prototype.__iterate = function(n, r) {
    for (var i = r ? this.size : 0, o = nS(this, r), a; (a = o()) !== hu && n(a, r ? --i : i++, this) !== !1; )
      ;
    return i;
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Ku(
      this._origin,
      this._capacity,
      this._level,
      this._root,
      this._tail,
      n,
      this.__hash
    ) : this.size === 0 ? Cf() : (this.__ownerID = n, this.__altered = !1, this);
  }, t;
})(za);
Hp.isList = FA;
var an = Hp.prototype;
an[jA] = !0;
an[gc] = an.remove;
an.merge = an.concat;
an.setIn = d0;
an.deleteIn = an.removeIn = p0;
an.update = h0;
an.updateIn = v0;
an.mergeIn = y0;
an.mergeDeepIn = b0;
an.withMutations = wc;
an.wasAltered = _0;
an.asImmutable = Ec;
an["@@transducer/init"] = an.asMutable = xc;
an["@@transducer/step"] = function(e, t) {
  return e.push(t);
};
an["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
var wo = function(e, t) {
  this.array = e, this.ownerID = t;
};
wo.prototype.removeBefore = function(e, t, n) {
  if (n === t ? 1 << t : this.array.length === 0)
    return this;
  var r = n >>> t & Nn;
  if (r >= this.array.length)
    return new wo([], e);
  var i = r === 0, o;
  if (t > 0) {
    var a = this.array[r];
    if (o = a && a.removeBefore(e, t - kt, n), o === a && i)
      return this;
  }
  if (i && !o)
    return this;
  var s = Us(this, e);
  if (!i)
    for (var l = 0; l < r; l++)
      s.array[l] = void 0;
  return o && (s.array[r] = o), s;
};
wo.prototype.removeAfter = function(e, t, n) {
  if (n === (t ? 1 << t : 0) || this.array.length === 0)
    return this;
  var r = n - 1 >>> t & Nn;
  if (r >= this.array.length)
    return this;
  var i;
  if (t > 0) {
    var o = this.array[r];
    if (i = o && o.removeAfter(e, t - kt, n), i === o && r === this.array.length - 1)
      return this;
  }
  var a = Us(this, e);
  return a.array.splice(r + 1), i && (a.array[r] = i), a;
};
var hu = {};
function nS(e, t) {
  var n = e._origin, r = e._capacity, i = qu(r), o = e._tail;
  return a(e._root, e._level, 0);
  function a(u, c, f) {
    return c === 0 ? s(u, f) : l(u, c, f);
  }
  function s(u, c) {
    var f = c === i ? o && o.array : u && u.array, d = c > n ? 0 : n - c, p = r - c;
    return p > wr && (p = wr), function() {
      if (d === p)
        return hu;
      var h = t ? --p : d++;
      return f && f[h];
    };
  }
  function l(u, c, f) {
    var d, p = u && u.array, h = f > n ? 0 : n - f >> c, v = (r - f >> c) + 1;
    return v > wr && (v = wr), function() {
      for (; ; ) {
        if (d) {
          var m = d();
          if (m !== hu)
            return m;
          d = null;
        }
        if (h === v)
          return hu;
        var g = t ? --v : h++;
        d = a(
          p && p[g],
          c - kt,
          f + (g << c)
        );
      }
    };
  }
}
function Ku(e, t, n, r, i, o, a) {
  var s = Object.create(an);
  return s.size = t - e, s._origin = e, s._capacity = t, s._level = n, s._root = r, s._tail = i, s.__ownerID = o, s.__hash = a, s.__altered = !1, s;
}
var rS;
function Cf() {
  return rS || (rS = Ku(0, 0, kt));
}
function xJ(e, t, n) {
  if (t = Po(e, t), t !== t)
    return e;
  if (t >= e.size || t < 0)
    return e.withMutations(function(a) {
      t < 0 ? so(a, t).set(0, n) : so(a, 0, t + 1).set(t, n);
    });
  t += e._origin;
  var r = e._tail, i = e._root, o = Eg();
  return t >= qu(e._capacity) ? r = Pg(r, e.__ownerID, 0, t, n, o) : i = Pg(
    i,
    e.__ownerID,
    e._level,
    t,
    n,
    o
  ), o.value ? e.__ownerID ? (e._root = i, e._tail = r, e.__hash = void 0, e.__altered = !0, e) : Ku(e._origin, e._capacity, e._level, i, r) : e;
}
function Pg(e, t, n, r, i, o) {
  var a = r >>> n & Nn, s = e && a < e.array.length;
  if (!s && i === void 0)
    return e;
  var l;
  if (n > 0) {
    var u = e && e.array[a], c = Pg(
      u,
      t,
      n - kt,
      r,
      i,
      o
    );
    return c === u ? e : (l = Us(e, t), l.array[a] = c, l);
  }
  return s && e.array[a] === i ? e : (o && xr(o), l = Us(e, t), i === void 0 && a === l.array.length - 1 ? l.array.pop() : l.array[a] = i, l);
}
function Us(e, t) {
  return t && e && t === e.ownerID ? e : new wo(e ? e.array.slice() : [], t);
}
function zA(e, t) {
  if (t >= qu(e._capacity))
    return e._tail;
  if (t < 1 << e._level + kt) {
    for (var n = e._root, r = e._level; n && r > 0; )
      n = n.array[t >>> r & Nn], r -= kt;
    return n;
  }
}
function so(e, t, n) {
  t !== void 0 && (t |= 0), n !== void 0 && (n |= 0);
  var r = e.__ownerID || new e0(), i = e._origin, o = e._capacity, a = i + t, s = n === void 0 ? o : n < 0 ? o + n : i + n;
  if (a === i && s === o)
    return e;
  if (a >= s)
    return e.clear();
  for (var l = e._level, u = e._root, c = 0; a + c < 0; )
    u = new wo(
      u && u.array.length ? [void 0, u] : [],
      r
    ), l += kt, c += 1 << l;
  c && (a += c, i += c, s += c, o += c);
  for (var f = qu(o), d = qu(s); d >= 1 << l + kt; )
    u = new wo(
      u && u.array.length ? [u] : [],
      r
    ), l += kt;
  var p = e._tail, h = d < f ? zA(e, s - 1) : d > f ? new wo([], r) : p;
  if (p && d > f && a < o && p.array.length) {
    u = Us(u, r);
    for (var v = u, m = l; m > kt; m -= kt) {
      var g = f >>> m & Nn;
      v = v.array[g] = Us(v.array[g], r);
    }
    v.array[f >>> kt & Nn] = p;
  }
  if (s < o && (h = h && h.removeAfter(r, 0, s)), a >= d)
    a -= d, s -= d, l = kt, u = null, h = h && h.removeBefore(r, 0, a);
  else if (a > i || d < f) {
    for (c = 0; u; ) {
      var y = a >>> l & Nn;
      if (y !== d >>> l & Nn)
        break;
      y && (c += (1 << l) * y), l -= kt, u = u.array[y];
    }
    u && a > i && (u = u.removeBefore(r, l, a - c)), u && d < f && (u = u.removeAfter(
      r,
      l,
      d - c
    )), c && (a -= c, s -= c);
  }
  return e.__ownerID ? (e.size = s - a, e._origin = a, e._capacity = s, e._level = l, e._root = u, e._tail = h, e.__hash = void 0, e.__altered = !0, e) : Ku(a, s, l, u, h);
}
function qu(e) {
  return e < wr ? 0 : e - 1 >>> kt << kt;
}
var Wi = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Hl() : vA(n) ? n : Hl().withMutations(function(r) {
      var i = Ir(n);
      er(i.size), i.forEach(function(o, a) {
        return r.set(a, o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("OrderedMap {", "}");
  }, t.prototype.get = function(n, r) {
    var i = this._map.get(n);
    return i !== void 0 ? this._list.get(i)[1] : r;
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this.__altered = !0, this) : Hl();
  }, t.prototype.set = function(n, r) {
    return oS(this, n, r);
  }, t.prototype.remove = function(n) {
    return oS(this, n, et);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._list.__iterate(
      function(o) {
        return o && n(o[1], o[0], i);
      },
      r
    );
  }, t.prototype.__iterator = function(n, r) {
    return this._list.fromEntrySeq().__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n), i = this._list.__ensureOwner(n);
    return n ? S0(r, i, n, this.__hash) : this.size === 0 ? Hl() : (this.__ownerID = n, this.__altered = !1, this._map = r, this._list = i, this);
  }, t;
})(gl);
Wi.isOrderedMap = vA;
Wi.prototype[pl] = !0;
Wi.prototype[gc] = Wi.prototype.remove;
function S0(e, t, n, r) {
  var i = Object.create(Wi.prototype);
  return i.size = e ? e.size : 0, i._map = e, i._list = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var iS;
function Hl() {
  return iS || (iS = S0(Hr(), Cf()));
}
function oS(e, t, n) {
  var r = e._map, i = e._list, o = r.get(t), a = o !== void 0, s, l;
  if (n === et) {
    if (!a)
      return e;
    i.size >= wr && i.size >= r.size * 2 ? (l = i.filter(function(u, c) {
      return u !== void 0 && o !== c;
    }), s = l.toKeyedSeq().map(function(u) {
      return u[0];
    }).flip().toMap(), e.__ownerID && (s.__ownerID = l.__ownerID = e.__ownerID)) : (s = r.remove(t), l = o === i.size - 1 ? i.pop() : i.set(o, void 0));
  } else if (a) {
    if (n === i.get(o)[1])
      return e;
    s = r, l = i.set(o, [t, n]);
  } else
    s = r.set(t, i.size), l = i.set(i.size, [t, n]);
  return e.__ownerID ? (e.size = s.size, e._map = s, e._list = l, e.__hash = void 0, e.__altered = !0, e) : S0(s, l);
}
var LA = "@@__IMMUTABLE_STACK__@@";
function Dg(e) {
  return !!(e && e[LA]);
}
var O0 = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? sf() : Dg(n) ? n : sf().pushAll(n);
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.prototype.toString = function() {
    return this.__toString("Stack [", "]");
  }, t.prototype.get = function(n, r) {
    var i = this._head;
    for (n = Po(this, n); i && n--; )
      i = i.next;
    return i ? i.value : r;
  }, t.prototype.peek = function() {
    return this._head && this._head.value;
  }, t.prototype.push = function() {
    var n = arguments;
    if (arguments.length === 0)
      return this;
    for (var r = this.size + arguments.length, i = this._head, o = arguments.length - 1; o >= 0; o--)
      i = {
        value: n[o],
        next: i
      };
    return this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Wl(r, i);
  }, t.prototype.pushAll = function(n) {
    if (n = e(n), n.size === 0)
      return this;
    if (this.size === 0 && Dg(n))
      return n;
    er(n.size);
    var r = this.size, i = this._head;
    return n.__iterate(function(o) {
      r++, i = {
        value: o,
        next: i
      };
    }, !0), this.__ownerID ? (this.size = r, this._head = i, this.__hash = void 0, this.__altered = !0, this) : Wl(r, i);
  }, t.prototype.pop = function() {
    return this.slice(1);
  }, t.prototype.clear = function() {
    return this.size === 0 ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : sf();
  }, t.prototype.slice = function(n, r) {
    if (zp(n, r, this.size))
      return this;
    var i = yc(n, this.size), o = Lp(r, this.size);
    if (o !== this.size)
      return e.prototype.slice.call(this, n, r);
    for (var a = this.size - i, s = this._head; i--; )
      s = s.next;
    return this.__ownerID ? (this.size = a, this._head = s, this.__hash = void 0, this.__altered = !0, this) : Wl(a, s);
  }, t.prototype.__ensureOwner = function(n) {
    return n === this.__ownerID ? this : n ? Wl(this.size, this._head, n, this.__hash) : this.size === 0 ? sf() : (this.__ownerID = n, this.__altered = !1, this);
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    if (r)
      return new Sa(this.toArray()).__iterate(
        function(s, l) {
          return n(s, l, i);
        },
        r
      );
    for (var o = 0, a = this._head; a && n(a.value, o++, this) !== !1; )
      a = a.next;
    return o;
  }, t.prototype.__iterator = function(n, r) {
    if (r)
      return new Sa(this.toArray()).__iterator(n, r);
    var i = 0, o = this._head;
    return new lt(function() {
      if (o) {
        var a = o.value;
        return o = o.next, Mt(n, i++, a);
      }
      return Zn();
    });
  }, t;
})(za);
O0.isStack = Dg;
var Mn = O0.prototype;
Mn[LA] = !0;
Mn.shift = Mn.pop;
Mn.unshift = Mn.push;
Mn.unshiftAll = Mn.pushAll;
Mn.withMutations = wc;
Mn.wasAltered = _0;
Mn.asImmutable = Ec;
Mn["@@transducer/init"] = Mn.asMutable = xc;
Mn["@@transducer/step"] = function(e, t) {
  return e.unshift(t);
};
Mn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
function Wl(e, t, n, r) {
  var i = Object.create(Mn);
  return i.size = e, i._head = t, i.__ownerID = n, i.__hash = r, i.__altered = !1, i;
}
var aS;
function sf() {
  return aS || (aS = Wl(0));
}
var VA = "@@__IMMUTABLE_SET__@@";
function $0(e) {
  return !!(e && e[VA]);
}
function BA(e) {
  return $0(e) && Jr(e);
}
function UA(e, t) {
  if (e === t)
    return !0;
  if (!Wn(t) || e.size !== void 0 && t.size !== void 0 && e.size !== t.size || e.__hash !== void 0 && t.__hash !== void 0 && e.__hash !== t.__hash || It(e) !== It(t) || Bn(e) !== Bn(t) || Jr(e) !== Jr(t))
    return !1;
  if (e.size === 0 && t.size === 0)
    return !0;
  var n = !Vp(e);
  if (Jr(e)) {
    var r = e.entries();
    return t.every(function(l, u) {
      var c = r.next().value;
      return c && nr(c[1], l) && (n || nr(c[0], u));
    }) && r.next().done;
  }
  var i = !1;
  if (e.size === void 0)
    if (t.size === void 0)
      typeof e.cacheResult == "function" && e.cacheResult();
    else {
      i = !0;
      var o = e;
      e = t, t = o;
    }
  var a = !0, s = t.__iterate(function(l, u) {
    if (n ? !e.has(l) : i ? !nr(l, e.get(u, et)) : !nr(e.get(u, et), l))
      return a = !1, !1;
  });
  return a && e.size === s;
}
function La(e, t) {
  var n = function(r) {
    e.prototype[r] = t[r];
  };
  return Object.keys(t).forEach(n), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(n), e;
}
function Rd(e) {
  if (!e || typeof e != "object")
    return e;
  if (!Wn(e)) {
    if (!Do(e))
      return e;
    e = sr(e);
  }
  if (It(e)) {
    var t = {};
    return e.__iterate(function(r, i) {
      _c(i) || (t[i] = Rd(r));
    }), t;
  }
  var n = [];
  return e.__iterate(function(r) {
    n.push(Rd(r));
  }), n;
}
var Wp = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Zl() : $0(n) && !Jr(n) ? n : Zl().withMutations(function(r) {
      var i = e(n);
      er(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(Ir(n).keySeq());
  }, t.intersect = function(n) {
    return n = Jt(n).toArray(), n.length ? mn.intersect.apply(t(n.pop()), n) : Zl();
  }, t.union = function(n) {
    return n = Jt(n).toArray(), n.length ? mn.union.apply(t(n.pop()), n) : Zl();
  }, t.prototype.toString = function() {
    return this.__toString("Set {", "}");
  }, t.prototype.has = function(n) {
    return this._map.has(n);
  }, t.prototype.add = function(n) {
    return lf(this, this._map.set(n, n));
  }, t.prototype.remove = function(n) {
    return lf(this, this._map.remove(n));
  }, t.prototype.clear = function() {
    return lf(this, this._map.clear());
  }, t.prototype.map = function(n, r) {
    var i = this, o = !1, a = lf(
      this,
      this._map.mapEntries(function(s) {
        var l = s[1], u = n.call(r, l, l, i);
        return u !== l && (o = !0), [u, u];
      }, r)
    );
    return o ? a : this;
  }, t.prototype.union = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    return n = n.filter(function(i) {
      return i.size !== 0;
    }), n.length === 0 ? this : this.size === 0 && !this.__ownerID && n.length === 1 ? this.constructor(n[0]) : this.withMutations(function(i) {
      for (var o = 0; o < n.length; o++)
        typeof n[o] == "string" ? i.add(n[o]) : e(n[o]).forEach(function(a) {
          return i.add(a);
        });
    });
  }, t.prototype.intersect = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.every(function(a) {
        return a.includes(o);
      }) || i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.subtract = function() {
    for (var n = [], r = arguments.length; r--; )
      n[r] = arguments[r];
    if (n.length === 0)
      return this;
    n = n.map(function(o) {
      return e(o);
    });
    var i = [];
    return this.forEach(function(o) {
      n.some(function(a) {
        return a.includes(o);
      }) && i.push(o);
    }), this.withMutations(function(o) {
      i.forEach(function(a) {
        o.remove(a);
      });
    });
  }, t.prototype.sort = function(n) {
    return Hu(Ls(this, n));
  }, t.prototype.sortBy = function(n, r) {
    return Hu(Ls(this, r, n));
  }, t.prototype.wasAltered = function() {
    return this._map.wasAltered();
  }, t.prototype.__iterate = function(n, r) {
    var i = this;
    return this._map.__iterate(function(o) {
      return n(o, o, i);
    }, r);
  }, t.prototype.__iterator = function(n, r) {
    return this._map.__iterator(n, r);
  }, t.prototype.__ensureOwner = function(n) {
    if (n === this.__ownerID)
      return this;
    var r = this._map.__ensureOwner(n);
    return n ? this.__make(r, n) : this.size === 0 ? this.__empty() : (this.__ownerID = n, this._map = r, this);
  }, t;
})(fl);
Wp.isSet = $0;
var mn = Wp.prototype;
mn[VA] = !0;
mn[gc] = mn.remove;
mn.merge = mn.concat = mn.union;
mn.withMutations = wc;
mn.asImmutable = Ec;
mn["@@transducer/init"] = mn.asMutable = xc;
mn["@@transducer/step"] = function(e, t) {
  return e.add(t);
};
mn["@@transducer/result"] = function(e) {
  return e.asImmutable();
};
mn.__empty = Zl;
mn.__make = KA;
function lf(e, t) {
  return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : t.size === 0 ? e.__empty() : e.__make(t);
}
function KA(e, t) {
  var n = Object.create(mn);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var sS;
function Zl() {
  return sS || (sS = KA(Hr()));
}
var EJ = /* @__PURE__ */ (function(e) {
  function t(n, r, i) {
    if (!(this instanceof t))
      return new t(n, r, i);
    if (f0(i !== 0, "Cannot step a Range by 0"), n = n || 0, r === void 0 && (r = 1 / 0), i = i === void 0 ? 1 : Math.abs(i), r < n && (i = -i), this._start = n, this._end = r, this._step = i, this.size = Math.max(0, Math.ceil((r - n) / i - 1) + 1), this.size === 0) {
      if (_v)
        return _v;
      _v = this;
    }
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toString = function() {
    return this.size === 0 ? "Range []" : "Range [ " + this._start + "..." + this._end + (this._step !== 1 ? " by " + this._step : "") + " ]";
  }, t.prototype.get = function(n, r) {
    return this.has(n) ? this._start + Po(this, n) * this._step : r;
  }, t.prototype.includes = function(n) {
    var r = (n - this._start) / this._step;
    return r >= 0 && r < this.size && r === Math.floor(r);
  }, t.prototype.slice = function(n, r) {
    return zp(n, r, this.size) ? this : (n = yc(n, this.size), r = Lp(r, this.size), r <= n ? new t(0, 0) : new t(
      this.get(n, this._end),
      this.get(r, this._end),
      this._step
    ));
  }, t.prototype.indexOf = function(n) {
    var r = n - this._start;
    if (r % this._step === 0) {
      var i = r / this._step;
      if (i >= 0 && i < this.size)
        return i;
    }
    return -1;
  }, t.prototype.lastIndexOf = function(n) {
    return this.indexOf(n);
  }, t.prototype.__iterate = function(n, r) {
    for (var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0; s !== i && n(a, r ? i - ++s : s++, this) !== !1; )
      a += r ? -o : o;
    return s;
  }, t.prototype.__iterator = function(n, r) {
    var i = this.size, o = this._step, a = r ? this._start + (i - 1) * o : this._start, s = 0;
    return new lt(function() {
      if (s === i)
        return Zn();
      var l = a;
      return a += r ? -o : o, Mt(n, r ? i - ++s : s++, l);
    });
  }, t.prototype.equals = function(n) {
    return n instanceof t ? this._start === n._start && this._end === n._end && this._step === n._step : UA(this, n);
  }, t;
})(oi), _v;
function qA(e, t, n) {
  for (var r = $A(t), i = 0; i !== r.length; )
    if (e = TA(e, r[i++], et), e === et)
      return n;
  return e;
}
function HA(e, t) {
  return qA(this, e, t);
}
function SJ(e, t) {
  return qA(e, t, et) !== et;
}
function OJ(e) {
  return SJ(this, e);
}
function WA() {
  er(this.size);
  var e = {};
  return this.__iterate(function(t, n) {
    _c(n) || (e[n] = t);
  }), e;
}
Jt.isIterable = Wn;
Jt.isKeyed = It;
Jt.isIndexed = Bn;
Jt.isAssociative = Vp;
Jt.isOrdered = Jr;
Jt.Iterator = lt;
La(Jt, {
  toArray: function() {
    er(this.size);
    var e = new Array(this.size || 0), t = It(this), n = 0;
    return this.__iterate(function(r, i) {
      e[n++] = t ? [i, r] : r;
    }), e;
  },
  toIndexedSeq: function() {
    return new gA(this);
  },
  toJS: function() {
    return Rd(this);
  },
  toKeyedSeq: function() {
    return new qp(this, !0);
  },
  toMap: function() {
    return gl(this.toKeyedSeq());
  },
  toObject: WA,
  toOrderedMap: function() {
    return Wi(this.toKeyedSeq());
  },
  toOrderedSet: function() {
    return Hu(It(this) ? this.valueSeq() : this);
  },
  toSet: function() {
    return Wp(It(this) ? this.valueSeq() : this);
  },
  toSetSeq: function() {
    return new yA(this);
  },
  toSeq: function() {
    return Bn(this) ? this.toIndexedSeq() : It(this) ? this.toKeyedSeq() : this.toSetSeq();
  },
  toStack: function() {
    return O0(It(this) ? this.valueSeq() : this);
  },
  toList: function() {
    return Hp(It(this) ? this.valueSeq() : this);
  },
  toString: function() {
    return "[Collection]";
  },
  __toString: function(e, t) {
    return this.size === 0 ? e + t : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + t;
  },
  concat: function() {
    for (var e = [], t = arguments.length; t--; )
      e[t] = arguments[t];
    return gt(this, tJ(this, e));
  },
  includes: function(e) {
    return this.some(function(t) {
      return nr(t, e);
    });
  },
  entries: function() {
    return this.__iterator(kr);
  },
  every: function(e, t) {
    er(this.size);
    var n = !0;
    return this.__iterate(function(r, i, o) {
      if (!e.call(t, r, i, o))
        return n = !1, !1;
    }), n;
  },
  filter: function(e, t) {
    return gt(this, xA(this, e, t, !0));
  },
  partition: function(e, t) {
    return XQ(this, e, t);
  },
  find: function(e, t, n) {
    var r = this.findEntry(e, t);
    return r ? r[1] : n;
  },
  forEach: function(e, t) {
    return er(this.size), this.__iterate(t ? e.bind(t) : e);
  },
  join: function(e) {
    er(this.size), e = e !== void 0 ? "" + e : ",";
    var t = "", n = !0;
    return this.__iterate(function(r) {
      n ? n = !1 : t += e, t += r != null ? r.toString() : "";
    }), t;
  },
  keys: function() {
    return this.__iterator(bc);
  },
  map: function(e, t) {
    return gt(this, wA(this, e, t));
  },
  reduce: function(e, t, n) {
    return lS(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !1
    );
  },
  reduceRight: function(e, t, n) {
    return lS(
      this,
      e,
      t,
      n,
      arguments.length < 2,
      !0
    );
  },
  reverse: function() {
    return gt(this, s0(this, !0));
  },
  slice: function(e, t) {
    return gt(this, l0(this, e, t, !0));
  },
  some: function(e, t) {
    er(this.size);
    var n = !1;
    return this.__iterate(function(r, i, o) {
      if (e.call(t, r, i, o))
        return n = !0, !1;
    }), n;
  },
  sort: function(e) {
    return gt(this, Ls(this, e));
  },
  values: function() {
    return this.__iterator(ei);
  },
  butLast: function() {
    return this.slice(0, -1);
  },
  isEmpty: function() {
    return this.size !== void 0 ? this.size === 0 : !this.some(function() {
      return !0;
    });
  },
  count: function(e, t) {
    return zs(
      e ? this.toSeq().filter(e, t) : this
    );
  },
  countBy: function(e, t) {
    return QQ(this, e, t);
  },
  equals: function(e) {
    return UA(this, e);
  },
  entrySeq: function() {
    var e = this;
    if (e._cache)
      return new Sa(e._cache);
    var t = e.toSeq().map(TJ).toIndexedSeq();
    return t.fromEntrySeq = function() {
      return e.toSeq();
    }, t;
  },
  filterNot: function(e, t) {
    return this.filter(wv(e), t);
  },
  findEntry: function(e, t, n) {
    var r = n;
    return this.__iterate(function(i, o, a) {
      if (e.call(t, i, o, a))
        return r = [o, i], !1;
    }), r;
  },
  findKey: function(e, t) {
    var n = this.findEntry(e, t);
    return n && n[0];
  },
  findLast: function(e, t, n) {
    return this.toKeyedSeq().reverse().find(e, t, n);
  },
  findLastEntry: function(e, t, n) {
    return this.toKeyedSeq().reverse().findEntry(e, t, n);
  },
  findLastKey: function(e, t) {
    return this.toKeyedSeq().reverse().findKey(e, t);
  },
  first: function(e) {
    return this.find(nA, null, e);
  },
  flatMap: function(e, t) {
    return gt(this, nJ(this, e, t));
  },
  flatten: function(e) {
    return gt(this, SA(this, e, !0));
  },
  fromEntrySeq: function() {
    return new bA(this);
  },
  get: function(e, t) {
    return this.find(function(n, r) {
      return nr(r, e);
    }, void 0, t);
  },
  getIn: HA,
  groupBy: function(e, t) {
    return JQ(this, e, t);
  },
  has: function(e) {
    return this.get(e, et) !== et;
  },
  hasIn: OJ,
  isSubset: function(e) {
    return e = typeof e.includes == "function" ? e : Jt(e), this.every(function(t) {
      return e.includes(t);
    });
  },
  isSuperset: function(e) {
    return e = typeof e.isSubset == "function" ? e : Jt(e), e.isSubset(this);
  },
  keyOf: function(e) {
    return this.findKey(function(t) {
      return nr(t, e);
    });
  },
  keySeq: function() {
    return this.toSeq().map($J).toIndexedSeq();
  },
  last: function(e) {
    return this.toSeq().reverse().first(e);
  },
  lastKeyOf: function(e) {
    return this.toKeyedSeq().reverse().keyOf(e);
  },
  max: function(e) {
    return of(this, e);
  },
  maxBy: function(e, t) {
    return of(this, t, e);
  },
  min: function(e) {
    return of(
      this,
      e ? uS(e) : fS
    );
  },
  minBy: function(e, t) {
    return of(
      this,
      t ? uS(t) : fS,
      e
    );
  },
  rest: function() {
    return this.slice(1);
  },
  skip: function(e) {
    return e === 0 ? this : this.slice(Math.max(0, e));
  },
  skipLast: function(e) {
    return e === 0 ? this : this.slice(0, -Math.max(0, e));
  },
  skipWhile: function(e, t) {
    return gt(this, EA(this, e, t, !0));
  },
  skipUntil: function(e, t) {
    return this.skipWhile(wv(e), t);
  },
  sortBy: function(e, t) {
    return gt(this, Ls(this, t, e));
  },
  take: function(e) {
    return this.slice(0, Math.max(0, e));
  },
  takeLast: function(e) {
    return this.slice(-Math.max(0, e));
  },
  takeWhile: function(e, t) {
    return gt(this, eJ(this, e, t));
  },
  takeUntil: function(e, t) {
    return this.takeWhile(wv(e), t);
  },
  update: function(e) {
    return e(this);
  },
  valueSeq: function() {
    return this.toIndexedSeq();
  },
  hashCode: function() {
    return this.__hash || (this.__hash = kJ(this));
  }
});
var Sn = Jt.prototype;
Sn[oA] = !0;
Sn[Bp] = Sn.values;
Sn.toJSON = Sn.toArray;
Sn.__toStringMapper = Vu;
Sn.inspect = Sn.toSource = function() {
  return this.toString();
};
Sn.chain = Sn.flatMap;
Sn.contains = Sn.includes;
La(Ir, {
  flip: function() {
    return gt(this, _A(this));
  },
  mapEntries: function(e, t) {
    var n = this, r = 0;
    return gt(
      this,
      this.toSeq().map(function(i, o) {
        return e.call(t, [o, i], r++, n);
      }).fromEntrySeq()
    );
  },
  mapKeys: function(e, t) {
    var n = this;
    return gt(
      this,
      this.toSeq().flip().map(function(r, i) {
        return e.call(t, r, i, n);
      }).flip()
    );
  }
});
var Sc = Ir.prototype;
Sc[aA] = !0;
Sc[Bp] = Sn.entries;
Sc.toJSON = WA;
Sc.__toStringMapper = function(e, t) {
  return Vu(t) + ": " + Vu(e);
};
La(za, {
  toKeyedSeq: function() {
    return new qp(this, !1);
  },
  filter: function(e, t) {
    return gt(this, xA(this, e, t, !1));
  },
  findIndex: function(e, t) {
    var n = this.findEntry(e, t);
    return n ? n[0] : -1;
  },
  indexOf: function(e) {
    var t = this.keyOf(e);
    return t === void 0 ? -1 : t;
  },
  lastIndexOf: function(e) {
    var t = this.lastKeyOf(e);
    return t === void 0 ? -1 : t;
  },
  reverse: function() {
    return gt(this, s0(this, !1));
  },
  slice: function(e, t) {
    return gt(this, l0(this, e, t, !1));
  },
  splice: function(e, t) {
    var n = arguments.length;
    if (t = Math.max(t || 0, 0), n === 0 || n === 2 && !t)
      return this;
    e = yc(e, e < 0 ? this.count() : this.size);
    var r = this.slice(0, e);
    return gt(
      this,
      n === 1 ? r : r.concat(gi(arguments, 2), this.slice(e + t))
    );
  },
  findLastIndex: function(e, t) {
    var n = this.findLastEntry(e, t);
    return n ? n[0] : -1;
  },
  first: function(e) {
    return this.get(0, e);
  },
  flatten: function(e) {
    return gt(this, SA(this, e, !1));
  },
  get: function(e, t) {
    return e = Po(this, e), e < 0 || this.size === 1 / 0 || this.size !== void 0 && e > this.size ? t : this.find(function(n, r) {
      return r === e;
    }, void 0, t);
  },
  has: function(e) {
    return e = Po(this, e), e >= 0 && (this.size !== void 0 ? this.size === 1 / 0 || e < this.size : this.indexOf(e) !== -1);
  },
  interpose: function(e) {
    return gt(this, rJ(this, e));
  },
  interleave: function() {
    var e = [this].concat(gi(arguments)), t = af(this.toSeq(), oi.of, e), n = t.flatten(!0);
    return t.size && (n.size = t.size * e.length), gt(this, n);
  },
  keySeq: function() {
    return EJ(0, this.size);
  },
  last: function(e) {
    return this.get(-1, e);
  },
  skipWhile: function(e, t) {
    return gt(this, EA(this, e, t, !1));
  },
  zip: function() {
    var e = [this].concat(gi(arguments));
    return gt(this, af(this, cS, e));
  },
  zipAll: function() {
    var e = [this].concat(gi(arguments));
    return gt(this, af(this, cS, e, !0));
  },
  zipWith: function(e) {
    var t = gi(arguments);
    return t[0] = this, gt(this, af(this, e, t));
  }
});
var yl = za.prototype;
yl[sA] = !0;
yl[pl] = !0;
La(fl, {
  get: function(e, t) {
    return this.has(e) ? e : t;
  },
  includes: function(e) {
    return this.has(e);
  },
  keySeq: function() {
    return this.valueSeq();
  }
});
var Ks = fl.prototype;
Ks.has = Sn.includes;
Ks.contains = Ks.includes;
Ks.keys = Ks.values;
La(Vo, Sc);
La(oi, yl);
La(vl, Ks);
function lS(e, t, n, r, i, o) {
  return er(e.size), e.__iterate(function(a, s, l) {
    i ? (i = !1, n = a) : n = t.call(r, n, a, s, l);
  }, o), n;
}
function $J(e, t) {
  return t;
}
function TJ(e, t) {
  return [t, e];
}
function wv(e) {
  return function() {
    return !e.apply(this, arguments);
  };
}
function uS(e) {
  return function() {
    return -e.apply(this, arguments);
  };
}
function cS() {
  return gi(arguments);
}
function fS(e, t) {
  return e < t ? 1 : e > t ? -1 : 0;
}
function kJ(e) {
  if (e.size === 1 / 0)
    return 0;
  var t = Jr(e), n = It(e), r = t ? 1 : 0, i = e.__iterate(
    n ? t ? function(o, a) {
      r = 31 * r + dS(Qn(o), Qn(a)) | 0;
    } : function(o, a) {
      r = r + dS(Qn(o), Qn(a)) | 0;
    } : t ? function(o) {
      r = 31 * r + Qn(o) | 0;
    } : function(o) {
      r = r + Qn(o) | 0;
    }
  );
  return PJ(i, r);
}
function PJ(e, t) {
  return t = Ml(t, 3432918353), t = Ml(t << 15 | t >>> -15, 461845907), t = Ml(t << 13 | t >>> -13, 5), t = (t + 3864292196 | 0) ^ e, t = Ml(t ^ t >>> 16, 2246822507), t = Ml(t ^ t >>> 13, 3266489909), t = Kp(t ^ t >>> 16), t;
}
function dS(e, t) {
  return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
}
var Hu = /* @__PURE__ */ (function(e) {
  function t(n) {
    return n == null ? Ag() : BA(n) ? n : Ag().withMutations(function(r) {
      var i = fl(n);
      er(i.size), i.forEach(function(o) {
        return r.add(o);
      });
    });
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function() {
    return this(arguments);
  }, t.fromKeys = function(n) {
    return this(Ir(n).keySeq());
  }, t.prototype.toString = function() {
    return this.__toString("OrderedSet {", "}");
  }, t;
})(Wp);
Hu.isOrderedSet = BA;
var Va = Hu.prototype;
Va[pl] = !0;
Va.zip = yl.zip;
Va.zipWith = yl.zipWith;
Va.zipAll = yl.zipAll;
Va.__empty = Ag;
Va.__make = ZA;
function ZA(e, t) {
  var n = Object.create(Va);
  return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
}
var pS;
function Ag() {
  return pS || (pS = ZA(Hl()));
}
function DJ(e) {
  if (dl(e))
    throw new Error(
      "Can not call `Record` with an immutable Record as default values. Use a plain javascript object instead."
    );
  if (Ti(e))
    throw new Error(
      "Can not call `Record` with an immutable Collection as default values. Use a plain javascript object instead."
    );
  if (e === null || typeof e != "object")
    throw new Error(
      "Can not call `Record` with a non-object as default values. Use a plain javascript object instead."
    );
}
var dn = function(e, t) {
  var n;
  DJ(e);
  var r = function(o) {
    var a = this;
    if (o instanceof r)
      return o;
    if (!(this instanceof r))
      return new r(o);
    if (!n) {
      n = !0;
      var s = Object.keys(e), l = i._indices = {};
      i._name = t, i._keys = s, i._defaultValues = e;
      for (var u = 0; u < s.length; u++) {
        var c = s[u];
        l[c] = u, i[c] ? typeof console == "object" && console.warn && console.warn(
          "Cannot define " + k0(this) + ' with property "' + c + '" since that property name is part of the Record API.'
        ) : AJ(i, c);
      }
    }
    return this.__ownerID = void 0, this._values = Hp().withMutations(function(f) {
      f.setSize(a._keys.length), Ir(o).forEach(function(d, p) {
        f.set(a._indices[p], d === a._defaultValues[p] ? void 0 : d);
      });
    }), this;
  }, i = r.prototype = Object.create(Et);
  return i.constructor = r, t && (r.displayName = t), r;
};
dn.prototype.toString = function() {
  for (var e = k0(this) + " { ", t = this._keys, n, r = 0, i = t.length; r !== i; r++)
    n = t[r], e += (r ? ", " : "") + n + ": " + Vu(this.get(n));
  return e + " }";
};
dn.prototype.equals = function(e) {
  return this === e || dl(e) && qs(this).equals(qs(e));
};
dn.prototype.hashCode = function() {
  return qs(this).hashCode();
};
dn.prototype.has = function(e) {
  return this._indices.hasOwnProperty(e);
};
dn.prototype.get = function(e, t) {
  if (!this.has(e))
    return t;
  var n = this._indices[e], r = this._values.get(n);
  return r === void 0 ? this._defaultValues[e] : r;
};
dn.prototype.set = function(e, t) {
  if (this.has(e)) {
    var n = this._values.set(
      this._indices[e],
      t === this._defaultValues[e] ? void 0 : t
    );
    if (n !== this._values && !this.__ownerID)
      return T0(this, n);
  }
  return this;
};
dn.prototype.remove = function(e) {
  return this.set(e);
};
dn.prototype.clear = function() {
  var e = this._values.clear().setSize(this._keys.length);
  return this.__ownerID ? this : T0(this, e);
};
dn.prototype.wasAltered = function() {
  return this._values.wasAltered();
};
dn.prototype.toSeq = function() {
  return qs(this);
};
dn.prototype.toJS = function() {
  return Rd(this);
};
dn.prototype.entries = function() {
  return this.__iterator(kr);
};
dn.prototype.__iterator = function(e, t) {
  return qs(this).__iterator(e, t);
};
dn.prototype.__iterate = function(e, t) {
  return qs(this).__iterate(e, t);
};
dn.prototype.__ensureOwner = function(e) {
  if (e === this.__ownerID)
    return this;
  var t = this._values.__ensureOwner(e);
  return e ? T0(this, t, e) : (this.__ownerID = e, this._values = t, this);
};
dn.isRecord = dl;
dn.getDescriptiveName = k0;
var Et = dn.prototype;
Et[uA] = !0;
Et[gc] = Et.remove;
Et.deleteIn = Et.removeIn = p0;
Et.getIn = HA;
Et.hasIn = Sn.hasIn;
Et.merge = DA;
Et.mergeWith = AA;
Et.mergeIn = y0;
Et.mergeDeep = IA;
Et.mergeDeepWith = NA;
Et.mergeDeepIn = b0;
Et.setIn = d0;
Et.update = h0;
Et.updateIn = v0;
Et.withMutations = wc;
Et.asMutable = xc;
Et.asImmutable = Ec;
Et[Bp] = Et.entries;
Et.toJSON = Et.toObject = Sn.toObject;
Et.inspect = Et.toSource = function() {
  return this.toString();
};
function T0(e, t, n) {
  var r = Object.create(Object.getPrototypeOf(e));
  return r._values = t, r.__ownerID = n, r;
}
function k0(e) {
  return e.constructor.displayName || e.constructor.name || "Record";
}
function qs(e) {
  return i0(e._keys.map(function(t) {
    return [t, e.get(t)];
  }));
}
function AJ(e, t) {
  try {
    Object.defineProperty(e, t, {
      get: function() {
        return this.get(t);
      },
      set: function(n) {
        f0(this.__ownerID, "Cannot set on an immutable record."), this.set(t, n);
      }
    });
  } catch {
  }
}
const GA = (e, t) => {
  Se(() => (document.addEventListener("keydown", (n) => {
    e[n.key] && e[n.key]();
  }), () => {
    document.removeEventListener("keydown", () => null);
  }), t || []);
}, CJ = Pr(
  [
    "dark:bg-neutral-900",
    "dark:text-neutral-200",
    "absolute",
    "transform",
    "shadow-sm",
    "border",
    "border-black",
    "top-1/2",
    "left-1/2",
    "bg-neutral-100",
    "max-h-[75vh]",
    "z-50"
  ],
  {
    variants: {
      size: {
        fit: ["w-auto", "h-auto"],
        sm: ["w-sm", "h-[50vh]"],
        md: ["w-md", "h-[50vh]"],
        lg: ["w-lg", "h-[50vh]"]
      }
    }
  }
), IJ = ({
  children: e,
  visible: t,
  onClose: n,
  className: r,
  containerClassName: i = "modal-root",
  variant: o = "lg"
}) => {
  const a = _e(null), { root: s } = NJ();
  return GA({
    Escape: n
  }), s ? t ? da(
    /* @__PURE__ */ M.jsx(km, { children: /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx(
        In.div,
        {
          className: Un(
            "fixed top-0 left-0 w-screen h-screen opacity-80 bg-neutral-700 z-40 overlay",
            r
          ),
          onClick: () => n(),
          initial: { opacity: 0 },
          animate: { opacity: 0.8 }
        }
      ),
      /* @__PURE__ */ M.jsx(
        In.div,
        {
          className: Un(
            CJ({ size: o }),
            i
          ),
          ref: a,
          initial: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "100vh"
          },
          animate: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) translateY(-50%)",
            top: "50vh"
          },
          exit: {
            left: "50vw",
            opacity: 1,
            transform: "translateX(-50%) ",
            top: "100vh"
          },
          children: e
        }
      )
    ] }) }),
    s
  ) : null : (console.error("No root element found"), null);
}, YA = Le({ root: null }), NJ = () => W.useContext(YA), Mle = ({
  className: e = "modal-root",
  children: t
}) => {
  const [n, r] = W.useState(null);
  return /* @__PURE__ */ M.jsxs(YA.Provider, { value: { root: n }, children: [
    t,
    /* @__PURE__ */ M.jsx("div", { ref: r, className: e })
  ] });
}, RJ = ({
  visible: e,
  onClose: t,
  onCreateFolder: n
}) => {
  const { register: r, handleSubmit: i, reset: o } = NQ({ defaultValues: { name: "" } }), { ref: a, ...s } = r("name"), [l, u] = Fe(null);
  return Se(() => {
    l && l.focus();
  }, [l]), /* @__PURE__ */ M.jsx(
    IJ,
    {
      visible: e,
      onClose: () => t(!1),
      variant: "fit",
      children: /* @__PURE__ */ M.jsxs("div", { className: "border-black border w-full h-full bg-white p-4", children: [
        /* @__PURE__ */ M.jsx("h1", { children: "create folder" }),
        /* @__PURE__ */ M.jsxs(
          "form",
          {
            className: "flex flex-col items-center justify-center gap-4",
            onSubmit: i((c) => {
              o(), n(c.name);
            }),
            children: [
              /* @__PURE__ */ M.jsx(
                RQ,
                {
                  ref: (c) => {
                    a(c), u(c);
                  },
                  className: "block",
                  ...s,
                  type: "text",
                  placeholder: "folder name"
                }
              ),
              /* @__PURE__ */ M.jsx(ly, { children: "Create" })
            ]
          }
        )
      ] })
    }
  );
}, MJ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216.49,79.52l-56-56A12,12,0,0,0,152,20H56A20,20,0,0,0,36,40V216a20,20,0,0,0,20,20H200a20,20,0,0,0,20-20V88A12,12,0,0,0,216.49,79.52ZM160,57l23,23H160ZM60,212V44h76V92a12,12,0,0,0,12,12h48V212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M208,88H152V32Z", opacity: "0.2" }), /* @__PURE__ */ ie.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM152,88V44l44,44Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M212.24,83.76l-56-56A6,6,0,0,0,152,26H56A14,14,0,0,0,42,40V216a14,14,0,0,0,14,14H200a14,14,0,0,0,14-14V88A6,6,0,0,0,212.24,83.76ZM158,46.48,193.52,82H158ZM200,218H56a2,2,0,0,1-2-2V40a2,2,0,0,1,2-2h90V88a6,6,0,0,0,6,6h50V216A2,2,0,0,1,200,218Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M210.83,85.17l-56-56A4,4,0,0,0,152,28H56A12,12,0,0,0,44,40V216a12,12,0,0,0,12,12H200a12,12,0,0,0,12-12V88A4,4,0,0,0,210.83,85.17ZM156,41.65,198.34,84H156ZM200,220H56a4,4,0,0,1-4-4V40a4,4,0,0,1,4-4h92V88a4,4,0,0,0,4,4h52V216A4,4,0,0,1,200,220Z" }))
  ]
]), jJ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM44,56H90.61l10.67,12H44ZM212,196H44V92H212Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM36,56a4,4,0,0,1,4-4H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4Z" }))
  ]
]), FJ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,68H133.39l-26-29.29a20,20,0,0,0-15-6.71H40A20,20,0,0,0,20,52V200.62A19.41,19.41,0,0,0,39.38,220H216.89A19.13,19.13,0,0,0,236,200.89V88A20,20,0,0,0,216,68ZM90.61,56l10.67,12H44V56ZM212,196H44V92H212Zm-72-76v12h12a12,12,0,0,1,0,24H140v12a12,12,0,0,1-24,0V156H104a12,12,0,0,1,0-24h12V120a12,12,0,0,1,24,0Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(
      "path",
      {
        d: "M128,80H32V56a8,8,0,0,1,8-8H92.69a8,8,0,0,1,5.65,2.34Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.88,15.88,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.41,15.41,0,0,0,39.39,216h177.5A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,74H130.49l-27.9-27.9a13.94,13.94,0,0,0-9.9-4.1H40A14,14,0,0,0,26,56V200.62A13.39,13.39,0,0,0,39.38,214H216.89A13.12,13.12,0,0,0,230,200.89V88A14,14,0,0,0,216,74ZM40,54H92.69a2,2,0,0,1,1.41.59L113.51,74H38V56A2,2,0,0,1,40,54ZM218,200.89a1.11,1.11,0,0,1-1.11,1.11H39.38A1.4,1.4,0,0,1,38,200.62V86H216a2,2,0,0,1,2,2ZM158,144a6,6,0,0,1-6,6H134v18a6,6,0,0,1-12,0V150H104a6,6,0,0,1,0-12h18V120a6,6,0,0,1,12,0v18h18A6,6,0,0,1,158,144Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,76H129.66L101.17,47.52A11.9,11.9,0,0,0,92.69,44H40A12,12,0,0,0,28,56V200.62A11.4,11.4,0,0,0,39.38,212H216.89A11.12,11.12,0,0,0,228,200.89V88A12,12,0,0,0,216,76ZM40,52H92.69a4,4,0,0,1,2.82,1.17L118.34,76H36V56A4,4,0,0,1,40,52ZM220,200.89a3.12,3.12,0,0,1-3.11,3.11H39.38A3.39,3.39,0,0,1,36,200.62V84H216a4,4,0,0,1,4,4ZM156,144a4,4,0,0,1-4,4H132v20a4,4,0,0,1-8,0V148H104a4,4,0,0,1,0-8h20V120a4,4,0,0,1,8,0v20h20A4,4,0,0,1,156,144Z" }))
  ]
]), zJ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M228,128a12,12,0,0,1-12,12H40a12,12,0,0,1,0-24H216A12,12,0,0,1,228,128ZM40,76H216a12,12,0,0,0,0-24H40a12,12,0,0,0,0,24ZM216,180H40a12,12,0,0,0,0,24H216a12,12,0,0,0,0-24Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M216,64V192H40V64Z", opacity: "0.2" }), /* @__PURE__ */ ie.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM192,184H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm0-48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M222,128a6,6,0,0,1-6,6H40a6,6,0,0,1,0-12H216A6,6,0,0,1,222,128ZM40,70H216a6,6,0,0,0,0-12H40a6,6,0,0,0,0,12ZM216,186H40a6,6,0,0,0,0,12H216a6,6,0,0,0,0-12Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M220,128a4,4,0,0,1-4,4H40a4,4,0,0,1,0-8H216A4,4,0,0,1,220,128ZM40,68H216a4,4,0,0,0,0-8H40a4,4,0,0,0,0,8ZM216,188H40a4,4,0,0,0,0,8H216a4,4,0,0,0,0-8Z" }))
  ]
]), LJ = /* @__PURE__ */ new Map([
  [
    "bold",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M228,144v64a12,12,0,0,1-12,12H40a12,12,0,0,1-12-12V144a12,12,0,0,1,24,0v52H204V144a12,12,0,0,1,24,0ZM96.49,80.49,116,61v83a12,12,0,0,0,24,0V61l19.51,19.52a12,12,0,1,0,17-17l-40-40a12,12,0,0,0-17,0l-40,40a12,12,0,1,0,17,17Z" }))
  ],
  [
    "duotone",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement(
      "path",
      {
        d: "M216,48V208H40V48A16,16,0,0,1,56,32H200A16,16,0,0,1,216,48Z",
        opacity: "0.2"
      }
    ), /* @__PURE__ */ ie.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "fill",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM88,80h32v64a8,8,0,0,0,16,0V80h32a8,8,0,0,0,5.66-13.66l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,88,80Z" }))
  ],
  [
    "light",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M222,144v64a6,6,0,0,1-6,6H40a6,6,0,0,1-6-6V144a6,6,0,0,1,12,0v58H210V144a6,6,0,0,1,12,0ZM92.24,76.24,122,46.49V144a6,6,0,0,0,12,0V46.49l29.76,29.75a6,6,0,0,0,8.48-8.48l-40-40a6,6,0,0,0-8.48,0l-40,40a6,6,0,0,0,8.48,8.48Z" }))
  ],
  [
    "regular",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z" }))
  ],
  [
    "thin",
    /* @__PURE__ */ ie.createElement(ie.Fragment, null, /* @__PURE__ */ ie.createElement("path", { d: "M220,144v64a4,4,0,0,1-4,4H40a4,4,0,0,1-4-4V144a4,4,0,0,1,8,0v60H212V144a4,4,0,0,1,8,0ZM90.83,74.83,124,41.66V144a4,4,0,0,0,8,0V41.66l33.17,33.17a4,4,0,1,0,5.66-5.66l-40-40a4,4,0,0,0-5.66,0l-40,40a4,4,0,0,0,5.66,5.66Z" }))
  ]
]), VJ = Le({
  color: "currentColor",
  size: "1em",
  weight: "regular",
  mirrored: !1
}), bl = ie.forwardRef(
  (e, t) => {
    const {
      alt: n,
      color: r,
      size: i,
      weight: o,
      mirrored: a,
      children: s,
      weights: l,
      ...u
    } = e, {
      color: c = "currentColor",
      size: f,
      weight: d = "regular",
      mirrored: p = !1,
      ...h
    } = ie.useContext(VJ);
    return /* @__PURE__ */ ie.createElement(
      "svg",
      {
        ref: t,
        xmlns: "http://www.w3.org/2000/svg",
        width: i ?? f,
        height: i ?? f,
        fill: r ?? c,
        viewBox: "0 0 256 256",
        transform: a || p ? "scale(-1, 1)" : void 0,
        ...h,
        ...u
      },
      !!n && /* @__PURE__ */ ie.createElement("title", null, n),
      s,
      l.get(o ?? d)
    );
  }
);
bl.displayName = "IconBase";
const QA = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(bl, { ref: t, ...e, weights: MJ }));
QA.displayName = "FileIcon";
const BJ = QA, JA = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(bl, { ref: t, ...e, weights: jJ }));
JA.displayName = "FolderIcon";
const UJ = JA, XA = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(bl, { ref: t, ...e, weights: FJ }));
XA.displayName = "FolderPlusIcon";
const KJ = XA, eC = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(bl, { ref: t, ...e, weights: zJ }));
eC.displayName = "ListIcon";
const qJ = eC, tC = ie.forwardRef((e, t) => /* @__PURE__ */ ie.createElement(bl, { ref: t, ...e, weights: LJ }));
tC.displayName = "UploadSimpleIcon";
const HJ = tC;
var xv, hS;
function WJ() {
  if (hS) return xv;
  hS = 1;
  function e(i) {
    if (typeof i != "string")
      throw new TypeError("Path must be a string. Received " + JSON.stringify(i));
  }
  function t(i, o) {
    for (var a = "", s = 0, l = -1, u = 0, c, f = 0; f <= i.length; ++f) {
      if (f < i.length)
        c = i.charCodeAt(f);
      else {
        if (c === 47)
          break;
        c = 47;
      }
      if (c === 47) {
        if (!(l === f - 1 || u === 1)) if (l !== f - 1 && u === 2) {
          if (a.length < 2 || s !== 2 || a.charCodeAt(a.length - 1) !== 46 || a.charCodeAt(a.length - 2) !== 46) {
            if (a.length > 2) {
              var d = a.lastIndexOf("/");
              if (d !== a.length - 1) {
                d === -1 ? (a = "", s = 0) : (a = a.slice(0, d), s = a.length - 1 - a.lastIndexOf("/")), l = f, u = 0;
                continue;
              }
            } else if (a.length === 2 || a.length === 1) {
              a = "", s = 0, l = f, u = 0;
              continue;
            }
          }
          o && (a.length > 0 ? a += "/.." : a = "..", s = 2);
        } else
          a.length > 0 ? a += "/" + i.slice(l + 1, f) : a = i.slice(l + 1, f), s = f - l - 1;
        l = f, u = 0;
      } else c === 46 && u !== -1 ? ++u : u = -1;
    }
    return a;
  }
  function n(i, o) {
    var a = o.dir || o.root, s = o.base || (o.name || "") + (o.ext || "");
    return a ? a === o.root ? a + s : a + i + s : s;
  }
  var r = {
    // path.resolve([from ...], to)
    resolve: function() {
      for (var o = "", a = !1, s, l = arguments.length - 1; l >= -1 && !a; l--) {
        var u;
        l >= 0 ? u = arguments[l] : (s === void 0 && (s = process.cwd()), u = s), e(u), u.length !== 0 && (o = u + "/" + o, a = u.charCodeAt(0) === 47);
      }
      return o = t(o, !a), a ? o.length > 0 ? "/" + o : "/" : o.length > 0 ? o : ".";
    },
    normalize: function(o) {
      if (e(o), o.length === 0) return ".";
      var a = o.charCodeAt(0) === 47, s = o.charCodeAt(o.length - 1) === 47;
      return o = t(o, !a), o.length === 0 && !a && (o = "."), o.length > 0 && s && (o += "/"), a ? "/" + o : o;
    },
    isAbsolute: function(o) {
      return e(o), o.length > 0 && o.charCodeAt(0) === 47;
    },
    join: function() {
      if (arguments.length === 0)
        return ".";
      for (var o, a = 0; a < arguments.length; ++a) {
        var s = arguments[a];
        e(s), s.length > 0 && (o === void 0 ? o = s : o += "/" + s);
      }
      return o === void 0 ? "." : r.normalize(o);
    },
    relative: function(o, a) {
      if (e(o), e(a), o === a || (o = r.resolve(o), a = r.resolve(a), o === a)) return "";
      for (var s = 1; s < o.length && o.charCodeAt(s) === 47; ++s)
        ;
      for (var l = o.length, u = l - s, c = 1; c < a.length && a.charCodeAt(c) === 47; ++c)
        ;
      for (var f = a.length, d = f - c, p = u < d ? u : d, h = -1, v = 0; v <= p; ++v) {
        if (v === p) {
          if (d > p) {
            if (a.charCodeAt(c + v) === 47)
              return a.slice(c + v + 1);
            if (v === 0)
              return a.slice(c + v);
          } else u > p && (o.charCodeAt(s + v) === 47 ? h = v : v === 0 && (h = 0));
          break;
        }
        var m = o.charCodeAt(s + v), g = a.charCodeAt(c + v);
        if (m !== g)
          break;
        m === 47 && (h = v);
      }
      var y = "";
      for (v = s + h + 1; v <= l; ++v)
        (v === l || o.charCodeAt(v) === 47) && (y.length === 0 ? y += ".." : y += "/..");
      return y.length > 0 ? y + a.slice(c + h) : (c += h, a.charCodeAt(c) === 47 && ++c, a.slice(c));
    },
    _makeLong: function(o) {
      return o;
    },
    dirname: function(o) {
      if (e(o), o.length === 0) return ".";
      for (var a = o.charCodeAt(0), s = a === 47, l = -1, u = !0, c = o.length - 1; c >= 1; --c)
        if (a = o.charCodeAt(c), a === 47) {
          if (!u) {
            l = c;
            break;
          }
        } else
          u = !1;
      return l === -1 ? s ? "/" : "." : s && l === 1 ? "//" : o.slice(0, l);
    },
    basename: function(o, a) {
      if (a !== void 0 && typeof a != "string") throw new TypeError('"ext" argument must be a string');
      e(o);
      var s = 0, l = -1, u = !0, c;
      if (a !== void 0 && a.length > 0 && a.length <= o.length) {
        if (a.length === o.length && a === o) return "";
        var f = a.length - 1, d = -1;
        for (c = o.length - 1; c >= 0; --c) {
          var p = o.charCodeAt(c);
          if (p === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else
            d === -1 && (u = !1, d = c + 1), f >= 0 && (p === a.charCodeAt(f) ? --f === -1 && (l = c) : (f = -1, l = d));
        }
        return s === l ? l = d : l === -1 && (l = o.length), o.slice(s, l);
      } else {
        for (c = o.length - 1; c >= 0; --c)
          if (o.charCodeAt(c) === 47) {
            if (!u) {
              s = c + 1;
              break;
            }
          } else l === -1 && (u = !1, l = c + 1);
        return l === -1 ? "" : o.slice(s, l);
      }
    },
    extname: function(o) {
      e(o);
      for (var a = -1, s = 0, l = -1, u = !0, c = 0, f = o.length - 1; f >= 0; --f) {
        var d = o.charCodeAt(f);
        if (d === 47) {
          if (!u) {
            s = f + 1;
            break;
          }
          continue;
        }
        l === -1 && (u = !1, l = f + 1), d === 46 ? a === -1 ? a = f : c !== 1 && (c = 1) : a !== -1 && (c = -1);
      }
      return a === -1 || l === -1 || // We saw a non-dot character immediately before the dot
      c === 0 || // The (right-most) trimmed path component is exactly '..'
      c === 1 && a === l - 1 && a === s + 1 ? "" : o.slice(a, l);
    },
    format: function(o) {
      if (o === null || typeof o != "object")
        throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof o);
      return n("/", o);
    },
    parse: function(o) {
      e(o);
      var a = { root: "", dir: "", base: "", ext: "", name: "" };
      if (o.length === 0) return a;
      var s = o.charCodeAt(0), l = s === 47, u;
      l ? (a.root = "/", u = 1) : u = 0;
      for (var c = -1, f = 0, d = -1, p = !0, h = o.length - 1, v = 0; h >= u; --h) {
        if (s = o.charCodeAt(h), s === 47) {
          if (!p) {
            f = h + 1;
            break;
          }
          continue;
        }
        d === -1 && (p = !1, d = h + 1), s === 46 ? c === -1 ? c = h : v !== 1 && (v = 1) : c !== -1 && (v = -1);
      }
      return c === -1 || d === -1 || // We saw a non-dot character immediately before the dot
      v === 0 || // The (right-most) trimmed path component is exactly '..'
      v === 1 && c === d - 1 && c === f + 1 ? d !== -1 && (f === 0 && l ? a.base = a.name = o.slice(1, d) : a.base = a.name = o.slice(f, d)) : (f === 0 && l ? (a.name = o.slice(1, c), a.base = o.slice(1, d)) : (a.name = o.slice(f, c), a.base = o.slice(f, d)), a.ext = o.slice(c, d)), f > 0 ? a.dir = o.slice(0, f - 1) : l && (a.dir = "/"), a;
    },
    sep: "/",
    delimiter: ":",
    win32: null,
    posix: null
  };
  return r.posix = r, xv = r, xv;
}
var Es = WJ();
const nC = Pr([
  "dark:hover:bg-neutral-300",
  "dark:hover:text-neutral-700",
  "hover:bg-neutral-100",
  "p-1",
  "items-center",
  "gap-2",
  "whitespace-nowrap",
  "w-full",
  "flex",
  "text-left",
  "text-sm",
  "disabled:text-neutral-500",
  "disabled:hover:bg-none",
  "cursor-default"
]);
function la({ className: e = "", ...t }) {
  return /* @__PURE__ */ M.jsx(m7, { ...t, className: nC({}) });
}
const ZJ = Pr([
  "bg-white",
  "text-black",
  "border-b",
  "border",
  "shadow-md",
  "p-2"
]);
function P0({ children: e, button: t, className: n, isOpen: r, setOpen: i }) {
  return /* @__PURE__ */ M.jsxs(u7, { isOpen: r, onOpenChange: i, children: [
    /* @__PURE__ */ M.jsx(yb, { children: t || /* @__PURE__ */ M.jsx(
      ar,
      {
        className: "dark:text-neutral-300 text-neutral-700",
        icon: n6
      }
    ) }),
    /* @__PURE__ */ M.jsx(zP, { children: /* @__PURE__ */ M.jsx(d7, { className: Un(ZJ({}), n), children: e }) })
  ] });
}
const GJ = v4(
  ({
    store: e,
    homeDirectory: t,
    searchDisabled: n,
    searchBarExtras: r
  }) => /* @__PURE__ */ M.jsxs("header", { className: "row-start-1 w-full", children: [
    /* @__PURE__ */ M.jsxs("div", { className: "px-2 flex w-full gap-4 border border-black", children: [
      /* @__PURE__ */ M.jsx("div", { className: "flex w-full", children: /* @__PURE__ */ M.jsx(
        "input",
        {
          disabled: n,
          value: e.searchQuery ?? "",
          onChange: (i) => e.setSearchQuery(i.target.value),
          className: "w-full p-1 rounded border-none h-6 my-auto flex-grow bg-white dark:bg-neutral-300 text-neutral-600 focus:outline-none",
          type: "text",
          placeholder: "search..."
        }
      ) }),
      /* @__PURE__ */ M.jsxs("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ M.jsx(
          g7,
          {
            onSelect: (i) => {
              i && e.onDrop(Array.from(i));
            },
            children: /* @__PURE__ */ M.jsx(yb, { className: nC(), children: /* @__PURE__ */ M.jsx(HJ, { size: 18 }) })
          }
        ),
        r && r(e.searchQuery ?? ""),
        /* @__PURE__ */ M.jsx(P0, { children: /* @__PURE__ */ M.jsxs(la, { onAction: () => {
          e.setCreateFolderModalVisible(!0);
        }, children: [
          /* @__PURE__ */ M.jsx(KJ, { size: 18 }),
          " Create Folder"
        ] }) })
      ] })
    ] }),
    /* @__PURE__ */ M.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300 hover:fill-neutral-300",
        onClick: () => e.popToRoot(),
        children: [
          t,
          "/"
        ]
      }
    ),
    e.currentPath.map((i, o) => /* @__PURE__ */ M.jsxs(
      "button",
      {
        className: "inline text-black pb-2 hover:text-neutral-300",
        onClick: () => {
          o !== e.currentPath.length - 1 && e.popFolderHistoryToIndex(o);
        },
        children: [
          Es.basename(i),
          "/"
        ]
      },
      `${i}-${o}`
    ))
  ] })
);
function YJ({ files: e }) {
  return /* @__PURE__ */ M.jsxs("div", { children: [
    /* @__PURE__ */ M.jsx("p", { className: "m-2", children: "Uploading:" }),
    /* @__PURE__ */ M.jsx("ul", { children: e.map((t) => /* @__PURE__ */ M.jsx("li", { className: "pl-4 list-none", children: t.name }, t.name)) })
  ] });
}
class QJ {
  constructor(t) {
    ci(this, "searchQuery", null);
    ci(this, "currentPath", []);
    ci(this, "searchResults", null);
    ci(this, "createFolderModalVisible", !1);
    ci(this, "onSearch");
    ci(this, "onUpload");
    ci(this, "onNavigate");
    ci(this, "searchLoading", !1);
    t ? this.currentPath = t : this.currentPath = [], wW(this), this.onDrop = this.onDrop.bind(this), this.pushPathPart = this.pushPathPart.bind(this), this.setCreateFolderModalVisible = this.setCreateFolderModalVisible.bind(this), this.setSearchQuery = this.setSearchQuery.bind(this), this.popFolderHistory = this.popFolderHistory.bind(this), this.popFolderHistoryToIndex = this.popFolderHistoryToIndex.bind(this), this.setSearchResults = this.setSearchResults.bind(this);
  }
  setCreateFolderModalVisible(t) {
    this.createFolderModalVisible = t;
  }
  pushPathPart(t) {
    this.currentPath.push(t);
  }
  popFolderHistory() {
    this.currentPath.pop(), this.onNavigate?.(
      this.currentPath
    );
  }
  popToRoot() {
    this.currentPath = [], this.onNavigate?.([]);
  }
  popFolderHistoryToIndex(t) {
    this.currentPath = this.currentPath.slice(0, t + 1), this.onNavigate?.(
      this.currentPath
    );
  }
  async setSearchResults(t) {
    this.searchResults = t;
  }
  async setSearchQuery(t) {
    if (this.searchQuery = t, t) {
      if (!this.onSearch)
        return;
    } else {
      this.searchResults = null, this.searchLoading = !1;
      return;
    }
    this.onSearch(t);
  }
  // get currentFolderPath() {
  //     if (this.currentPath.length === 0) {
  //         return "";
  //     }
  //     // return this.folderHistory.reduce((acc, f) => acc + f, "");
  //     return this.currentPath[this.currentPath.length - 1];
  // }
  async onDrop(t) {
    if (t[0].size / (1024 * 1024 * 1024) > 1)
      throw pr("File cannot be bigger than 1GB"), new Error("File cannot be bigger than 1GB");
    if (this.onUpload)
      try {
        const i = await this.onUpload(t);
        if (!i)
          return;
        const o = pr(/* @__PURE__ */ M.jsx(YJ, { files: t }), {
          progress: 0
        });
        i.subscribe({
          onProgress: (a) => {
            pr.update(o, {
              progress: a
            });
          },
          onError: (a) => {
            pr.error("Something went wrong!: " + a.message);
          },
          onComplete: () => {
            pr.dismiss(o);
          }
        });
      } catch (i) {
        pr.error("Something went wrong!: " + i);
      }
  }
}
function Gl(e, t) {
  return !!t.find(
    ({ path: n, isFolder: r }) => e.path === n && r === e.isFolder
  );
}
function JJ(e, t, n) {
  switch (n) {
    case An.ALL:
      return Gl(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case An.FILE:
      return t.isFolder ? e : Gl(t, e) ? [] : [t];
    case An.DIR:
      return t.isFolder ? Gl(t, e) ? [] : [t] : e;
    case An.FILE_LIST:
      return t.isFolder ? e : Gl(t, e) ? e.filter((r) => r.path !== t.path) : [...e, t];
    case An.NONE:
    default:
      return e;
  }
}
const Md = () => /* @__PURE__ */ M.jsx("div", { className: "flex-grow" });
function rC({
  onDelete: e,
  path: t,
  onPreview: n,
  onDownload: r,
  onMoveUpAFolder: i,
  className: o = "",
  isOpen: a,
  setOpen: s
}) {
  return /* @__PURE__ */ M.jsxs(
    P0,
    {
      button: /* @__PURE__ */ M.jsx(qJ, { className: o, size: 18, "data-testid": `path-actions-${t.path}` }),
      isOpen: a,
      setOpen: s,
      children: [
        !t.isFolder && r && /* @__PURE__ */ M.jsx(
          la,
          {
            onAction: async () => {
              r(t);
            },
            children: "Download"
          }
        ),
        i && /* @__PURE__ */ M.jsx(
          la,
          {
            onAction: async () => {
              const l = Es.dirname(Es.dirname(t.path)), u = Es.basename(t.path), c = `${l}/${u}`;
              i(l === "." ? null : { path: t, parent: l, newPath: c });
            },
            children: "Move Up a Folder"
          }
        ),
        e && /* @__PURE__ */ M.jsx(la, { onAction: () => e(), children: "Delete" }),
        !t.isFolder && n && /* @__PURE__ */ M.jsx(la, { onAction: () => n(t), children: "Preview" })
      ]
    }
  );
}
const XJ = Pr(
  [
    "relative",
    "flex",
    "gap-2",
    "p-1",
    "select-none",
    "hover:bg-neutral-200",
    "dark:hover:bg-neutral-600",
    "items-center",
    "w-full",
    "group"
  ],
  {
    variants: {
      selected: {
        true: ["text-blue-500", "hover:after:h-0"],
        false: ["text-neutral-800", "dark:text-neutral-200"]
      },
      isOver: {
        true: ["bg-neutral-300", "dark:bg-neutral-600"],
        false: ["bg-transparent"]
      }
    }
  }
), iC = Xt(
  (e, t) => {
    const {
      children: n,
      selected: r,
      showCheckbox: i = !0,
      style: o,
      onCheckboxValueChange: a,
      onClick: s,
      isOver: l,
      path: u
    } = e;
    return /* @__PURE__ */ M.jsxs(
      In.div,
      {
        "data-testid": `file-${u}`,
        className: XJ({ selected: r, isOver: l }),
        ref: t,
        style: o,
        onClick: (c) => {
          c.stopPropagation, s?.(c);
        },
        layout: !0,
        children: [
          i && /* @__PURE__ */ M.jsx(
            H4,
            {
              onClick: (c) => c.stopPropagation(),
              onChange: (c) => {
                a(c.currentTarget.checked);
              },
              className: "mr-2",
              checked: r
            }
          ),
          n
        ]
      }
    );
  }
), eX = ({
  path: e,
  onClick: t,
  selected: n,
  readOnly: r = !1,
  showFullPath: i = !1,
  onDelete: o,
  style: a,
  onPreview: s,
  onDownload: l,
  onMoveUpAFolder: u,
  showCheckbox: c = !0
}) => {
  const [, f] = T4({
    canDrag: !r,
    type: "S3File",
    item: { ...e },
    collect: (v) => ({
      isDragging: v.isDragging()
    })
  }), d = Es.basename(e.path), [p, h] = Fe(!1);
  return /* @__PURE__ */ M.jsxs(
    iC,
    {
      path: e.path,
      style: { ...a },
      onClick: (v) => {
        v.stopPropagation();
      },
      showCheckbox: c,
      onCheckboxValueChange: () => t(e),
      selected: n,
      ref: f,
      children: [
        /* @__PURE__ */ M.jsx(BJ, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ M.jsx("div", { className: "flex flex-col justify-around flex-shrink h-full overflow-hidden", children: /* @__PURE__ */ M.jsx("p", { children: i ? e.path : d }) }),
        /* @__PURE__ */ M.jsx(Md, {}),
        /* @__PURE__ */ M.jsx(
          rC,
          {
            className: `${p ? "" : "opacity-0 focus:opacity-100"} group-hover:opacity-100 focus:opacity-100`,
            onPreview: s,
            path: e,
            onDelete: o ? () => o?.(e) : void 0,
            onMoveUpAFolder: u,
            onDownload: l,
            isOpen: p,
            setOpen: h
          }
        )
      ]
    }
  );
}, tX = ({
  path: e,
  onClick: t,
  onDblClick: n,
  selected: r,
  onDrop: i,
  readOnly: o = !1,
  style: a,
  onDelete: s,
  showActions: l,
  onPreview: u,
  showFullPath: c,
  showCheckbox: f = !0
}) => {
  const d = jQ(
    () => {
    },
    () => n(e)
  ), [, p] = T4({
    canDrag: !o,
    type: "S3Folder",
    item: { ...e },
    collect: (g) => ({
      isDragging: g.isDragging()
    })
  }), [h] = Fe(!1), [{ isOver: v }, m] = tY({
    canDrop: () => !o,
    accept: ["S3Folder", "S3File"],
    drop: (g) => i(g),
    collect: (g) => ({
      isOver: g.isOver()
    })
  });
  return /* @__PURE__ */ M.jsx("div", { ref: m, style: a, children: /* @__PURE__ */ M.jsxs(
    iC,
    {
      path: e.path,
      selected: r,
      isOver: v,
      onClick: (g) => {
        g.stopPropagation(), d();
      },
      ref: p,
      showCheckbox: f,
      onCheckboxValueChange: () => t(e),
      children: [
        /* @__PURE__ */ M.jsx(UJ, { size: 18, className: "pr-1 flex-shrink-0" }),
        /* @__PURE__ */ M.jsx("div", { className: "flex flex-col justify-around h-full", children: /* @__PURE__ */ M.jsx("p", { children: c ? e.path : Es.basename(e.path) }) }),
        /* @__PURE__ */ M.jsx(Md, {}),
        l && u && s && h && /* @__PURE__ */ M.jsx(
          rC,
          {
            onPreview: u,
            path: e,
            onDelete: s ? () => s(e) : void 0
          }
        )
      ]
    }
  ) });
};
function nX(e, t) {
  Se(() => {
    for (const n in e)
      e.hasOwnProperty(n) && e[n] && (t[n] = e[n]);
  }, [e, t]);
}
const rX = v4(
  ({
    selectionMode: e = An.NONE,
    // files,
    selection: t,
    onSelectionChange: n,
    readOnly: r = !1,
    className: i,
    showActions: o = !0,
    onDownload: a,
    onMoveUpAFolder: s,
    style: l,
    onPreview: u,
    onDelete: c,
    onMove: f,
    onCreateFolder: d,
    loading: p = !1,
    onSearch: h,
    searchDisabled: v = !1,
    onNavigate: m,
    filePathHomeDirectory: g = "~",
    onUpload: y,
    searchBarExtras: w,
    files: x,
    // getFiles,
    path: S
  }) => {
    const O = YW(() => new QJ(S)), { getRootProps: P, getInputProps: b, isDragActive: _ } = q4({
      noClick: !0,
      onDrop: O.onDrop
    }), E = Me(
      (N) => JJ(t, N, e),
      [t, e]
    ), A = Me(async () => {
      O.searchLoading = !0;
      const N = O.searchQuery;
      if (!h || !N) {
        O.searchLoading = !1;
        return;
      }
      O.setSearchResults([]), setTimeout(async () => {
        if (O.searchQuery === N && N) {
          const U = await h(N);
          if (!U) return;
          O.setSearchResults(U), O.searchLoading = !1;
        }
      }, 500);
    }, [h, O.searchQuery]);
    Se(() => {
      O.onSearch = A;
    }, [A]), nX(
      {
        onUpload: y,
        onNavigate: m,
        currentPath: S
      },
      O
    );
    const k = O.searchResults || x || [], R = _e(null);
    return /* @__PURE__ */ M.jsxs(
      "div",
      {
        className: Un(
          "grid-rows-[2rem 1fr] box-border relative flex flex-col justify-start flex-grow w-full gap-2 overflow-auto text-neutral-800 bg-white",
          i
        ),
        style: l,
        ...P(),
        children: [
          _ && /* @__PURE__ */ M.jsx(
            "div",
            {
              style: { zIndex: 999 },
              className: "w-full h-full absolute top-0 left-0 flex justify-center items-center z-[999] bg-opacity-20 text-orange-2 pointer-events-none bg-white text-4xl",
              children: "Drop files here"
            }
          ),
          /* @__PURE__ */ M.jsx("input", { className: "z-50 bg-purple-500", ...b() }),
          /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsx(
            GJ,
            {
              searchDisabled: v,
              selection: t,
              store: O,
              homeDirectory: g,
              searchBarExtras: w
            }
          ) }),
          e !== An.NONE && /* @__PURE__ */ M.jsxs("div", { className: "mr-auto ml-1 flex items-center gap-2 text-neutral-400", children: [
            /* @__PURE__ */ M.jsx(
              H4,
              {
                checked: t.length > 0,
                onChange: () => {
                  k && (t.length === 0 ? n?.([...t, ...k]) : n?.([]));
                }
              }
            ),
            /* @__PURE__ */ M.jsxs("p", { className: "text-xs", children: [
              t.length,
              " file",
              t.length !== 1 && "s",
              " selected"
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(
            "div",
            {
              ref: R,
              className: "relative flex-grow overflow-auto",
              children: /* @__PURE__ */ M.jsx(EG, { backend: vY, children: /* @__PURE__ */ M.jsxs("div", { className: "row-start-2 row-span-1 flex-grow relative", children: [
                p ? /* @__PURE__ */ M.jsx("p", { className: "py-2 italic text-neutral-600", children: "Loading..." }) : null,
                k?.length === 0 && !O.searchLoading && !p && /* @__PURE__ */ M.jsx("p", { className: "py-2 italic text-neutral-600", children: "No files" }),
                O.searchLoading && /* @__PURE__ */ M.jsx("p", { className: "py-2 italic text-neutral-600", children: "Searching..." }),
                k && k.length > 0 && k.map((N) => {
                  const U = {
                    key: iX(N),
                    showActions: o,
                    readOnly: r,
                    onDelete: c ? () => {
                      c([N]), n?.([]);
                    } : void 0,
                    onClick: (H) => {
                      const ee = E(H);
                      n?.(ee);
                    },
                    showFullPath: !!O.searchQuery,
                    // show full path if searching
                    path: N,
                    selected: Gl(N, t),
                    onPreview: u
                  };
                  return N.isFolder ? /* @__PURE__ */ M.jsx(
                    tX,
                    {
                      ...U,
                      showCheckbox: e !== An.NONE && e !== An.FILE && e !== An.FILE_LIST,
                      onDblClick: (H) => {
                        const ee = H.path.split("/").filter(Boolean).pop();
                        ee && (O.pushPathPart(ee), m?.(O.currentPath));
                      },
                      onDrop: (H) => f?.(H, N)
                    }
                  ) : /* @__PURE__ */ M.jsx(
                    eX,
                    {
                      ...U,
                      showCheckbox: e !== An.NONE && e !== An.DIR && e !== An.DIR_LIST,
                      onMoveUpAFolder: s,
                      onDownload: a
                    }
                  );
                })
              ] }) })
            }
          ),
          /* @__PURE__ */ M.jsx(
            RJ,
            {
              visible: O.createFolderModalVisible,
              onClose: () => O.setCreateFolderModalVisible(!1),
              onCreateFolder: async (N) => {
                d?.(N, O.currentPath), O.setCreateFolderModalVisible(!1);
              }
            }
          )
        ]
      }
    );
  }
), iX = (e) => `${e.isFolder ? "folder" : "file"}-${e.path}`;
var oX = Object.defineProperty, aX = (e, t, n) => t in e ? oX(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, sX = (e, t, n) => aX(e, t + "", n), Cg = function(e, t) {
  return Cg = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, Cg(e, t);
};
function ai(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Cg(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var G = function() {
  return G = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, G.apply(this, arguments);
};
function Fi(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function lo(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(a) {
      a(o);
    });
  }
  return new (n || (n = Promise))(function(o, a) {
    function s(c) {
      try {
        u(r.next(c));
      } catch (f) {
        a(f);
      }
    }
    function l(c) {
      try {
        u(r.throw(c));
      } catch (f) {
        a(f);
      }
    }
    function u(c) {
      c.done ? o(c.value) : i(c.value).then(s, l);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function uo(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, a = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return a.next = s(0), a.throw = s(1), a.return = s(2), typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; a && (a = 0, u[0] && (n = 0)), n; ) try {
      if (r = 1, i && (o = u[0] & 2 ? i.return : u[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, u[1])).done) return o;
      switch (i = 0, o && (u = [u[0] & 2, o.value]), u[0]) {
        case 0:
        case 1:
          o = u;
          break;
        case 4:
          return n.label++, { value: u[1], done: !1 };
        case 5:
          n.label++, i = u[1], u = [0];
          continue;
        case 7:
          u = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            n = 0;
            continue;
          }
          if (u[0] === 3 && (!o || u[1] > o[0] && u[1] < o[3])) {
            n.label = u[1];
            break;
          }
          if (u[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = u;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(u);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      u = t.call(e, n);
    } catch (c) {
      u = [6, c], i = 0;
    } finally {
      r = o = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function gn(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, i = t.length, o; r < i; r++)
    (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Ev = "Invariant Violation", vS = Object.setPrototypeOf, lX = vS === void 0 ? function(e, t) {
  return e.__proto__ = t, e;
} : vS, oC = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n) {
      n === void 0 && (n = Ev);
      var r = e.call(this, typeof n == "number" ? Ev + ": " + n + " (see https://github.com/apollographql/invariant-packages)" : n) || this;
      return r.framesToPop = 1, r.name = Ev, lX(r, t.prototype), r;
    }
    return t;
  })(Error)
);
function ta(e, t) {
  if (!e)
    throw new oC(t);
}
var aC = ["debug", "log", "warn", "error", "silent"], uX = aC.indexOf("log");
function uf(e) {
  return function() {
    if (aC.indexOf(e) >= uX) {
      var t = console[e] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(e) {
  e.debug = uf("debug"), e.log = uf("log"), e.warn = uf("warn"), e.error = uf("error");
})(ta || (ta = {}));
var D0 = "3.14.1";
function Ur(e) {
  try {
    return e();
  } catch {
  }
}
const jd = Ur(function() {
  return globalThis;
}) || Ur(function() {
  return window;
}) || Ur(function() {
  return self;
}) || Ur(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Ur(function() {
  return Ur.constructor("return this")();
});
var mS = /* @__PURE__ */ new Map();
function Ig(e) {
  var t = mS.get(e) || 1;
  return mS.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function sC(e, t) {
  t === void 0 && (t = 0);
  var n = Ig("stringifyForDisplay");
  return JSON.stringify(e, function(r, i) {
    return i === void 0 ? n : i;
  }, t).split(JSON.stringify(n)).join("<undefined>");
}
function cf(e) {
  return function(t) {
    for (var n = [], r = 1; r < arguments.length; r++)
      n[r - 1] = arguments[r];
    if (typeof t == "number") {
      var i = t;
      t = A0(i), t || (t = C0(i, n), n = []);
    }
    e.apply(void 0, [t].concat(n));
  };
}
var Oe = Object.assign(function(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  e || ta(e, A0(t, n) || C0(t, n));
}, {
  debug: cf(ta.debug),
  log: cf(ta.log),
  warn: cf(ta.warn),
  error: cf(ta.error)
});
function jn(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return new oC(A0(e, t) || C0(e, t));
}
var gS = Symbol.for("ApolloErrorMessageHandler_" + D0);
function lC(e) {
  if (typeof e == "string")
    return e;
  try {
    return sC(e, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function A0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return jd[gS] && jd[gS](e, t.map(lC));
}
function C0(e, t) {
  if (t === void 0 && (t = []), !!e)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: D0,
      message: e,
      args: t.map(lC)
    })));
}
var Vt = Object.freeze({
  // Name
  NAME: "Name",
  // Document
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  // Fragments
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  // Values
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  // Directives
  DIRECTIVE: "Directive",
  // Types
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType",
  // Type System Definitions
  SCHEMA_DEFINITION: "SchemaDefinition",
  OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
  // Type Definitions
  SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
  OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
  FIELD_DEFINITION: "FieldDefinition",
  INPUT_VALUE_DEFINITION: "InputValueDefinition",
  INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
  UNION_TYPE_DEFINITION: "UnionTypeDefinition",
  ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
  ENUM_VALUE_DEFINITION: "EnumValueDefinition",
  INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
  // Directive Definitions
  DIRECTIVE_DEFINITION: "DirectiveDefinition",
  // Type System Extensions
  SCHEMA_EXTENSION: "SchemaExtension",
  // Type Extensions
  SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
  OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
  INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
  UNION_TYPE_EXTENSION: "UnionTypeExtension",
  ENUM_TYPE_EXTENSION: "EnumTypeExtension",
  INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
});
function cX(e, t) {
  throw new Error("Unexpected invariant triggered.");
}
var Ng = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : void 0;
function uC(e) {
  var t = e.prototype.toJSON;
  typeof t == "function" || cX(), e.prototype.inspect = t, Ng && (e.prototype[Ng] = t);
}
var fX = /* @__PURE__ */ (function() {
  function e(n, r, i) {
    this.start = n.start, this.end = r.end, this.startToken = n, this.endToken = r, this.source = i;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      start: this.start,
      end: this.end
    };
  }, e;
})();
uC(fX);
var dX = /* @__PURE__ */ (function() {
  function e(n, r, i, o, a, s, l) {
    this.kind = n, this.start = r, this.end = i, this.line = o, this.column = a, this.value = l, this.prev = s, this.next = null;
  }
  var t = e.prototype;
  return t.toJSON = function() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }, e;
})();
uC(dX);
function yS(e) {
  return e != null && typeof e.kind == "string";
}
function If(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? If = function(t) {
    return typeof t;
  } : If = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, If(e);
}
var pX = 10, cC = 2;
function hX(e) {
  return Zp(e, []);
}
function Zp(e, t) {
  switch (If(e)) {
    case "string":
      return JSON.stringify(e);
    case "function":
      return e.name ? "[function ".concat(e.name, "]") : "[function]";
    case "object":
      return e === null ? "null" : vX(e, t);
    default:
      return String(e);
  }
}
function vX(e, t) {
  if (t.indexOf(e) !== -1)
    return "[Circular]";
  var n = [].concat(t, [e]), r = yX(e);
  if (r !== void 0) {
    var i = r.call(e);
    if (i !== e)
      return typeof i == "string" ? i : Zp(i, n);
  } else if (Array.isArray(e))
    return gX(e, n);
  return mX(e, n);
}
function mX(e, t) {
  var n = Object.keys(e);
  if (n.length === 0)
    return "{}";
  if (t.length > cC)
    return "[" + bX(e) + "]";
  var r = n.map(function(i) {
    var o = Zp(e[i], t);
    return i + ": " + o;
  });
  return "{ " + r.join(", ") + " }";
}
function gX(e, t) {
  if (e.length === 0)
    return "[]";
  if (t.length > cC)
    return "[Array]";
  for (var n = Math.min(pX, e.length), r = e.length - n, i = [], o = 0; o < n; ++o)
    i.push(Zp(e[o], t));
  return r === 1 ? i.push("... 1 more item") : r > 1 && i.push("... ".concat(r, " more items")), "[" + i.join(", ") + "]";
}
function yX(e) {
  var t = e[String(Ng)];
  if (typeof t == "function")
    return t;
  if (typeof e.inspect == "function")
    return e.inspect;
}
function bX(e) {
  var t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
  if (t === "Object" && typeof e.constructor == "function") {
    var n = e.constructor.name;
    if (typeof n == "string" && n !== "")
      return n;
  }
  return t;
}
function _X(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = e.indexOf(`
`) === -1, i = e[0] === " " || e[0] === "	", o = e[e.length - 1] === '"', a = e[e.length - 1] === "\\", s = !r || o || a || n, l = "";
  return s && !(r && i) && (l += `
` + t), l += t ? e.replace(/\n/g, `
` + t) : e, s && (l += `
`), '"""' + l.replace(/"""/g, '\\"""') + '"""';
}
var wX = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are experimental and may be changed
    // or removed in the future.
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
  InterfaceTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, Gp = Object.freeze({});
function ti(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : wX, r = void 0, i = Array.isArray(e), o = [e], a = -1, s = [], l = void 0, u = void 0, c = void 0, f = [], d = [], p = e;
  do {
    a++;
    var h = a === o.length, v = h && s.length !== 0;
    if (h) {
      if (u = d.length === 0 ? void 0 : f[f.length - 1], l = c, c = d.pop(), v) {
        if (i)
          l = l.slice();
        else {
          for (var m = {}, g = 0, y = Object.keys(l); g < y.length; g++) {
            var w = y[g];
            m[w] = l[w];
          }
          l = m;
        }
        for (var x = 0, S = 0; S < s.length; S++) {
          var O = s[S][0], P = s[S][1];
          i && (O -= x), i && P === null ? (l.splice(O, 1), x++) : l[O] = P;
        }
      }
      a = r.index, o = r.keys, s = r.edits, i = r.inArray, r = r.prev;
    } else {
      if (u = c ? i ? a : o[a] : void 0, l = c ? c[u] : p, l == null)
        continue;
      c && f.push(u);
    }
    var b = void 0;
    if (!Array.isArray(l)) {
      if (!yS(l))
        throw new Error("Invalid AST Node: ".concat(hX(l), "."));
      var _ = xX(t, l.kind, h);
      if (_) {
        if (b = _.call(t, l, u, c, f, d), b === Gp)
          break;
        if (b === !1) {
          if (!h) {
            f.pop();
            continue;
          }
        } else if (b !== void 0 && (s.push([u, b]), !h))
          if (yS(b))
            l = b;
          else {
            f.pop();
            continue;
          }
      }
    }
    if (b === void 0 && v && s.push([u, l]), h)
      f.pop();
    else {
      var E;
      r = {
        inArray: i,
        index: a,
        keys: o,
        edits: s,
        prev: r
      }, i = Array.isArray(l), o = i ? l : (E = n[l.kind]) !== null && E !== void 0 ? E : [], a = -1, s = [], c && d.push(c), c = l;
    }
  } while (r !== void 0);
  return s.length !== 0 && (p = s[s.length - 1][1]), p;
}
function xX(e, t, n) {
  var r = e[t];
  if (r) {
    if (!n && typeof r == "function")
      return r;
    var i = n ? r.leave : r.enter;
    if (typeof i == "function")
      return i;
  } else {
    var o = n ? e.leave : e.enter;
    if (o) {
      if (typeof o == "function")
        return o;
      var a = o[t];
      if (typeof a == "function")
        return a;
    }
  }
}
function EX(e) {
  return ti(e, {
    leave: OX
  });
}
var SX = 80, OX = {
  Name: function(e) {
    return e.value;
  },
  Variable: function(e) {
    return "$" + e.name;
  },
  // Document
  Document: function(e) {
    return Ne(e.definitions, `

`) + `
`;
  },
  OperationDefinition: function(e) {
    var t = e.operation, n = e.name, r = zt("(", Ne(e.variableDefinitions, ", "), ")"), i = Ne(e.directives, " "), o = e.selectionSet;
    return !n && !i && !r && t === "query" ? o : Ne([t, Ne([n, r]), i, o], " ");
  },
  VariableDefinition: function(e) {
    var t = e.variable, n = e.type, r = e.defaultValue, i = e.directives;
    return t + ": " + n + zt(" = ", r) + zt(" ", Ne(i, " "));
  },
  SelectionSet: function(e) {
    var t = e.selections;
    return zr(t);
  },
  Field: function(e) {
    var t = e.alias, n = e.name, r = e.arguments, i = e.directives, o = e.selectionSet, a = zt("", t, ": ") + n, s = a + zt("(", Ne(r, ", "), ")");
    return s.length > SX && (s = a + zt(`(
`, Nf(Ne(r, `
`)), `
)`)), Ne([s, Ne(i, " "), o], " ");
  },
  Argument: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Fragments
  FragmentSpread: function(e) {
    var t = e.name, n = e.directives;
    return "..." + t + zt(" ", Ne(n, " "));
  },
  InlineFragment: function(e) {
    var t = e.typeCondition, n = e.directives, r = e.selectionSet;
    return Ne(["...", zt("on ", t), Ne(n, " "), r], " ");
  },
  FragmentDefinition: function(e) {
    var t = e.name, n = e.typeCondition, r = e.variableDefinitions, i = e.directives, o = e.selectionSet;
    return (
      // Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(t).concat(zt("(", Ne(r, ", "), ")"), " ") + "on ".concat(n, " ").concat(zt("", Ne(i, " "), " ")) + o
    );
  },
  // Value
  IntValue: function(e) {
    var t = e.value;
    return t;
  },
  FloatValue: function(e) {
    var t = e.value;
    return t;
  },
  StringValue: function(e, t) {
    var n = e.value, r = e.block;
    return r ? _X(n, t === "description" ? "" : "  ") : JSON.stringify(n);
  },
  BooleanValue: function(e) {
    var t = e.value;
    return t ? "true" : "false";
  },
  NullValue: function() {
    return "null";
  },
  EnumValue: function(e) {
    var t = e.value;
    return t;
  },
  ListValue: function(e) {
    var t = e.values;
    return "[" + Ne(t, ", ") + "]";
  },
  ObjectValue: function(e) {
    var t = e.fields;
    return "{" + Ne(t, ", ") + "}";
  },
  ObjectField: function(e) {
    var t = e.name, n = e.value;
    return t + ": " + n;
  },
  // Directive
  Directive: function(e) {
    var t = e.name, n = e.arguments;
    return "@" + t + zt("(", Ne(n, ", "), ")");
  },
  // Type
  NamedType: function(e) {
    var t = e.name;
    return t;
  },
  ListType: function(e) {
    var t = e.type;
    return "[" + t + "]";
  },
  NonNullType: function(e) {
    var t = e.type;
    return t + "!";
  },
  // Type System Definitions
  SchemaDefinition: Fr(function(e) {
    var t = e.directives, n = e.operationTypes;
    return Ne(["schema", Ne(t, " "), zr(n)], " ");
  }),
  OperationTypeDefinition: function(e) {
    var t = e.operation, n = e.type;
    return t + ": " + n;
  },
  ScalarTypeDefinition: Fr(function(e) {
    var t = e.name, n = e.directives;
    return Ne(["scalar", t, Ne(n, " ")], " ");
  }),
  ObjectTypeDefinition: Fr(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ne(["type", t, zt("implements ", Ne(n, " & ")), Ne(r, " "), zr(i)], " ");
  }),
  FieldDefinition: Fr(function(e) {
    var t = e.name, n = e.arguments, r = e.type, i = e.directives;
    return t + (bS(n) ? zt(`(
`, Nf(Ne(n, `
`)), `
)`) : zt("(", Ne(n, ", "), ")")) + ": " + r + zt(" ", Ne(i, " "));
  }),
  InputValueDefinition: Fr(function(e) {
    var t = e.name, n = e.type, r = e.defaultValue, i = e.directives;
    return Ne([t + ": " + n, zt("= ", r), Ne(i, " ")], " ");
  }),
  InterfaceTypeDefinition: Fr(function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ne(["interface", t, zt("implements ", Ne(n, " & ")), Ne(r, " "), zr(i)], " ");
  }),
  UnionTypeDefinition: Fr(function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return Ne(["union", t, Ne(n, " "), r && r.length !== 0 ? "= " + Ne(r, " | ") : ""], " ");
  }),
  EnumTypeDefinition: Fr(function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return Ne(["enum", t, Ne(n, " "), zr(r)], " ");
  }),
  EnumValueDefinition: Fr(function(e) {
    var t = e.name, n = e.directives;
    return Ne([t, Ne(n, " ")], " ");
  }),
  InputObjectTypeDefinition: Fr(function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return Ne(["input", t, Ne(n, " "), zr(r)], " ");
  }),
  DirectiveDefinition: Fr(function(e) {
    var t = e.name, n = e.arguments, r = e.repeatable, i = e.locations;
    return "directive @" + t + (bS(n) ? zt(`(
`, Nf(Ne(n, `
`)), `
)`) : zt("(", Ne(n, ", "), ")")) + (r ? " repeatable" : "") + " on " + Ne(i, " | ");
  }),
  SchemaExtension: function(e) {
    var t = e.directives, n = e.operationTypes;
    return Ne(["extend schema", Ne(t, " "), zr(n)], " ");
  },
  ScalarTypeExtension: function(e) {
    var t = e.name, n = e.directives;
    return Ne(["extend scalar", t, Ne(n, " ")], " ");
  },
  ObjectTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ne(["extend type", t, zt("implements ", Ne(n, " & ")), Ne(r, " "), zr(i)], " ");
  },
  InterfaceTypeExtension: function(e) {
    var t = e.name, n = e.interfaces, r = e.directives, i = e.fields;
    return Ne(["extend interface", t, zt("implements ", Ne(n, " & ")), Ne(r, " "), zr(i)], " ");
  },
  UnionTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.types;
    return Ne(["extend union", t, Ne(n, " "), r && r.length !== 0 ? "= " + Ne(r, " | ") : ""], " ");
  },
  EnumTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.values;
    return Ne(["extend enum", t, Ne(n, " "), zr(r)], " ");
  },
  InputObjectTypeExtension: function(e) {
    var t = e.name, n = e.directives, r = e.fields;
    return Ne(["extend input", t, Ne(n, " "), zr(r)], " ");
  }
};
function Fr(e) {
  return function(t) {
    return Ne([t.description, e(t)], `
`);
  };
}
function Ne(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return (t = e?.filter(function(r) {
    return r;
  }).join(n)) !== null && t !== void 0 ? t : "";
}
function zr(e) {
  return zt(`{
`, Nf(Ne(e, `
`)), `
}`);
}
function zt(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  return t != null && t !== "" ? e + t + n : "";
}
function Nf(e) {
  return zt("  ", e.replace(/\n/g, `
  `));
}
function $X(e) {
  return e.indexOf(`
`) !== -1;
}
function bS(e) {
  return e != null && e.some($X);
}
function _S(e) {
  return e.kind === Vt.FIELD || e.kind === Vt.FRAGMENT_SPREAD || e.kind === Vt.INLINE_FRAGMENT;
}
function Oc(e, t) {
  var n = e.directives;
  return !n || !n.length ? !0 : PX(n).every(function(r) {
    var i = r.directive, o = r.ifArgument, a = !1;
    return o.value.kind === "Variable" ? (a = t && t[o.value.name.value], Oe(a !== void 0, 105, i.name.value)) : a = o.value.value, i.name.value === "skip" ? !a : a;
  });
}
function Wu(e, t, n) {
  var r = new Set(e), i = r.size;
  return ti(t, {
    Directive: function(o) {
      if (r.delete(o.name.value) && (!n || !r.size))
        return Gp;
    }
  }), n ? !r.size : r.size < i;
}
function TX(e) {
  return e && Wu(["client", "export"], e, !0);
}
function kX(e) {
  var t = e.name.value;
  return t === "skip" || t === "include";
}
function PX(e) {
  var t = [];
  return e && e.length && e.forEach(function(n) {
    if (kX(n)) {
      var r = n.arguments, i = n.name.value;
      Oe(r && r.length === 1, 106, i);
      var o = r[0];
      Oe(o.name && o.name.value === "if", 107, i);
      var a = o.value;
      Oe(a && (a.kind === "Variable" || a.kind === "BooleanValue"), 108, i), t.push({ directive: n, ifArgument: o });
    }
  }), t;
}
function DX(e) {
  var t, n, r = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
    var a = o.name;
    return a.value === "unmask";
  });
  if (!r)
    return "mask";
  var i = (n = r.arguments) === null || n === void 0 ? void 0 : n.find(function(o) {
    var a = o.name;
    return a.value === "mode";
  });
  return globalThis.__DEV__ !== !1 && i && (i.value.kind === Vt.VARIABLE ? globalThis.__DEV__ !== !1 && Oe.warn(109) : i.value.kind !== Vt.STRING ? globalThis.__DEV__ !== !1 && Oe.warn(110) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && Oe.warn(111, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
}
const AX = () => /* @__PURE__ */ Object.create(null), { forEach: CX, slice: wS } = Array.prototype, { hasOwnProperty: IX } = Object.prototype;
class Ji {
  constructor(t = !0, n = AX) {
    this.weakness = t, this.makeData = n;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(t) {
    let n = this;
    return CX.call(t, (r) => n = n.getChildTrie(r)), IX.call(n, "data") ? n.data : n.data = this.makeData(wS.call(t));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(t) {
    let n = this;
    for (let r = 0, i = t.length; n && r < i; ++r) {
      const o = n.mapFor(t[r], !1);
      n = o && o.get(t[r]);
    }
    return n && n.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(t) {
    let n;
    if (t.length) {
      const r = t[0], i = this.mapFor(r, !1), o = i && i.get(r);
      o && (n = o.removeArray(wS.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(r));
    } else
      n = this.data, delete this.data;
    return n;
  }
  getChildTrie(t) {
    const n = this.mapFor(t, !0);
    let r = n.get(t);
    return r || n.set(t, r = new Ji(this.weakness, this.makeData)), r;
  }
  mapFor(t, n) {
    return this.weakness && NX(t) ? this.weak || (n ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (n ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
}
function NX(e) {
  switch (typeof e) {
    case "object":
      if (e === null)
        break;
    // Fall through to return true...
    case "function":
      return !0;
  }
  return !1;
}
var RX = Ur(function() {
  return navigator.product;
}) == "ReactNative", Ba = typeof WeakMap == "function" && !(RX && !global.HermesInternal), I0 = typeof WeakSet == "function", fC = typeof Symbol == "function" && typeof Symbol.for == "function", Yp = fC && Symbol.asyncIterator;
Ur(function() {
  return window.document.createElement;
});
Ur(function() {
  return navigator.userAgent.indexOf("jsdom") >= 0;
});
function Nt(e) {
  return e !== null && typeof e == "object";
}
function MX(e, t) {
  var n = t, r = [];
  e.definitions.forEach(function(o) {
    if (o.kind === "OperationDefinition")
      throw jn(
        112,
        o.operation,
        o.name ? " named '".concat(o.name.value, "'") : ""
      );
    o.kind === "FragmentDefinition" && r.push(o);
  }), typeof n > "u" && (Oe(r.length === 1, 113, r.length), n = r[0].name.value);
  var i = G(G({}, e), { definitions: gn([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: n
            }
          }
        ]
      }
    }
  ], e.definitions, !0) });
  return i;
}
function _l(e) {
  e === void 0 && (e = []);
  var t = {};
  return e.forEach(function(n) {
    t[n.name.value] = n;
  }), t;
}
function Qp(e, t) {
  switch (e.kind) {
    case "InlineFragment":
      return e;
    case "FragmentSpread": {
      var n = e.name.value;
      if (typeof t == "function")
        return t(n);
      var r = t && t[n];
      return Oe(r, 114, n), r || null;
    }
    default:
      return null;
  }
}
function jX(e) {
  var t = !0;
  return ti(e, {
    FragmentSpread: function(n) {
      if (t = !!n.directives && n.directives.some(function(r) {
        return r.name.value === "unmask";
      }), !t)
        return Gp;
    }
  }), t;
}
function FX() {
}
class Rg {
  constructor(t = 1 / 0, n = FX) {
    this.max = t, this.dispose = n, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.map.set(t, r), r.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (n === this.newest && (this.newest = n.older), n === this.oldest && (this.oldest = n.newer), n.newer && (n.newer.older = n.older), n.older && (n.older.newer = n.newer), this.map.delete(t), this.dispose(n.value, t), !0) : !1;
  }
}
function Mg() {
}
const zX = Mg, LX = typeof WeakRef < "u" ? WeakRef : function(e) {
  return { deref: () => e };
}, VX = typeof WeakMap < "u" ? WeakMap : Map, BX = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: Mg,
    unregister: Mg
  };
}, UX = 10024;
class Fd {
  constructor(t = 1 / 0, n = zX) {
    this.max = t, this.dispose = n, this.map = new VX(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const r = this.unfinalizedNodes.values();
      for (let i = 0; i < UX; i++) {
        const o = r.next().value;
        if (!o)
          break;
        this.unfinalizedNodes.delete(o);
        const a = o.key;
        delete o.key, o.keyRef = new LX(a), this.registry.register(a, o, o);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new BX(this.deleteNode.bind(this));
  }
  has(t) {
    return this.map.has(t);
  }
  get(t) {
    const n = this.getNode(t);
    return n && n.value;
  }
  getNode(t) {
    const n = this.map.get(t);
    if (n && n !== this.newest) {
      const { older: r, newer: i } = n;
      i && (i.older = r), r && (r.newer = i), n.older = this.newest, n.older.newer = n, n.newer = null, this.newest = n, n === this.oldest && (this.oldest = i);
    }
    return n;
  }
  set(t, n) {
    let r = this.getNode(t);
    return r ? r.value = n : (r = {
      key: t,
      value: n,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = r), this.newest = r, this.oldest = this.oldest || r, this.scheduleFinalization(r), this.map.set(t, r), this.size++, r.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(t) {
    t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
    const n = t.key || t.keyRef && t.keyRef.deref();
    this.dispose(t.value, n), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), n && this.map.delete(n);
  }
  delete(t) {
    const n = this.map.get(t);
    return n ? (this.deleteNode(n), !0) : !1;
  }
  scheduleFinalization(t) {
    this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var Sv = /* @__PURE__ */ new WeakSet();
function dC(e) {
  e.size <= (e.max || -1) || Sv.has(e) || (Sv.add(e), setTimeout(function() {
    e.clean(), Sv.delete(e);
  }, 100));
}
var pC = function(e, t) {
  var n = new Fd(e, t);
  return n.set = function(r, i) {
    var o = Fd.prototype.set.call(this, r, i);
    return dC(this), o;
  }, n;
}, KX = function(e, t) {
  var n = new Rg(e, t);
  return n.set = function(r, i) {
    var o = Rg.prototype.set.call(this, r, i);
    return dC(this), o;
  }, n;
}, qX = Symbol.for("apollo.cacheSize"), Zi = G({}, jd[qX]), Qo = {};
function hC(e, t) {
  Qo[e] = t;
}
var HX = globalThis.__DEV__ !== !1 ? YX : void 0, WX = globalThis.__DEV__ !== !1 ? QX : void 0, ZX = globalThis.__DEV__ !== !1 ? vC : void 0;
function GX() {
  var e = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(e).map(function(t) {
    var n = t[0], r = t[1];
    return [
      n,
      Zi[n] || r
    ];
  }));
}
function YX() {
  var e, t, n, r, i;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: GX(),
    sizes: G({ print: (e = Qo.print) === null || e === void 0 ? void 0 : e.call(Qo), parser: (t = Qo.parser) === null || t === void 0 ? void 0 : t.call(Qo), canonicalStringify: (n = Qo.canonicalStringify) === null || n === void 0 ? void 0 : n.call(Qo), links: Fg(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: gC(this.queryManager.documentTransform)
    } }, (i = (r = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(r))
  };
}
function vC() {
  return {
    cache: {
      fragmentQueryDocuments: co(this.getFragmentDoc)
    }
  };
}
function QX() {
  var e = this.config.fragments;
  return G(G({}, vC.apply(this)), { addTypenameDocumentTransform: gC(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: co(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: co(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: co(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: co(e?.findFragmentSpreads),
    lookup: co(e?.lookup),
    transform: co(e?.transform)
  } });
}
function JX(e) {
  return !!e && "dirtyKey" in e;
}
function co(e) {
  return JX(e) ? e.size : void 0;
}
function mC(e) {
  return e != null;
}
function gC(e) {
  return jg(e).map(function(t) {
    return { cache: t };
  });
}
function jg(e) {
  return e ? gn(gn([
    co(e?.performWork)
  ], jg(e?.left), !0), jg(e?.right), !0).filter(mC) : [];
}
function Fg(e) {
  var t;
  return e ? gn(gn([
    (t = e?.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
  ], Fg(e?.left), !0), Fg(e?.right), !0).filter(mC) : [];
}
var xo = Object.assign(function(e) {
  return JSON.stringify(e, XX);
}, {
  reset: function() {
    ds = new KX(
      Zi.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && hC("canonicalStringify", function() {
  return ds.size;
});
var ds;
xo.reset();
function XX(e, t) {
  if (t && typeof t == "object") {
    var n = Object.getPrototypeOf(t);
    if (n === Object.prototype || n === null) {
      var r = Object.keys(t);
      if (r.every(eee))
        return t;
      var i = JSON.stringify(r), o = ds.get(i);
      if (!o) {
        r.sort();
        var a = JSON.stringify(r);
        o = ds.get(a) || r, ds.set(i, o), ds.set(a, o);
      }
      var s = Object.create(n);
      return o.forEach(function(l) {
        s[l] = t[l];
      }), s;
    }
  }
  return t;
}
function eee(e, t, n) {
  return t === 0 || n[t - 1] <= e;
}
function Ss(e) {
  return { __ref: String(e) };
}
function pt(e) {
  return !!(e && typeof e == "object" && typeof e.__ref == "string");
}
function tee(e) {
  return Nt(e) && e.kind === "Document" && Array.isArray(e.definitions);
}
function nee(e) {
  return e.kind === "StringValue";
}
function ree(e) {
  return e.kind === "BooleanValue";
}
function iee(e) {
  return e.kind === "IntValue";
}
function oee(e) {
  return e.kind === "FloatValue";
}
function aee(e) {
  return e.kind === "Variable";
}
function see(e) {
  return e.kind === "ObjectValue";
}
function lee(e) {
  return e.kind === "ListValue";
}
function uee(e) {
  return e.kind === "EnumValue";
}
function cee(e) {
  return e.kind === "NullValue";
}
function Hs(e, t, n, r) {
  if (iee(n) || oee(n))
    e[t.value] = Number(n.value);
  else if (ree(n) || nee(n))
    e[t.value] = n.value;
  else if (see(n)) {
    var i = {};
    n.fields.map(function(a) {
      return Hs(i, a.name, a.value, r);
    }), e[t.value] = i;
  } else if (aee(n)) {
    var o = (r || {})[n.name.value];
    e[t.value] = o;
  } else if (lee(n))
    e[t.value] = n.values.map(function(a) {
      var s = {};
      return Hs(s, t, a, r), s[t.value];
    });
  else if (uee(n))
    e[t.value] = n.value;
  else if (cee(n))
    e[t.value] = null;
  else
    throw jn(123, t.value, n.kind);
}
function fee(e, t) {
  var n = null;
  e.directives && (n = {}, e.directives.forEach(function(i) {
    n[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
      var a = o.name, s = o.value;
      return Hs(n[i.name.value], a, s, t);
    });
  }));
  var r = null;
  return e.arguments && e.arguments.length && (r = {}, e.arguments.forEach(function(i) {
    var o = i.name, a = i.value;
    return Hs(r, o, a, t);
  })), yC(e.name.value, r, n);
}
var dee = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], jl = xo, yC = Object.assign(function(e, t, n) {
  if (t && n && n.connection && n.connection.key)
    if (n.connection.filter && n.connection.filter.length > 0) {
      var r = n.connection.filter ? n.connection.filter : [];
      r.sort();
      var i = {};
      return r.forEach(function(s) {
        i[s] = t[s];
      }), "".concat(n.connection.key, "(").concat(jl(i), ")");
    } else
      return n.connection.key;
  var o = e;
  if (t) {
    var a = jl(t);
    o += "(".concat(a, ")");
  }
  return n && Object.keys(n).forEach(function(s) {
    dee.indexOf(s) === -1 && (n[s] && Object.keys(n[s]).length ? o += "@".concat(s, "(").concat(jl(n[s]), ")") : o += "@".concat(s));
  }), o;
}, {
  setStringify: function(e) {
    var t = jl;
    return jl = e, t;
  }
});
function Jp(e, t) {
  if (e.arguments && e.arguments.length) {
    var n = {};
    return e.arguments.forEach(function(r) {
      var i = r.name, o = r.value;
      return Hs(n, i, o, t);
    }), n;
  }
  return null;
}
function Gi(e) {
  return e.alias ? e.alias.value : e.name.value;
}
function zg(e, t, n) {
  for (var r, i = 0, o = t.selections; i < o.length; i++) {
    var a = o[i];
    if (Ao(a)) {
      if (a.name.value === "__typename")
        return e[Gi(a)];
    } else r ? r.push(a) : r = [a];
  }
  if (typeof e.__typename == "string")
    return e.__typename;
  if (r)
    for (var s = 0, l = r; s < l.length; s++) {
      var a = l[s], u = zg(e, Qp(a, n).selectionSet, n);
      if (typeof u == "string")
        return u;
    }
}
function Ao(e) {
  return e.kind === "Field";
}
function pee(e) {
  return e.kind === "InlineFragment";
}
function wl(e) {
  Oe(e && e.kind === "Document", 115);
  var t = e.definitions.filter(function(n) {
    return n.kind !== "FragmentDefinition";
  }).map(function(n) {
    if (n.kind !== "OperationDefinition")
      throw jn(116, n.kind);
    return n;
  });
  return Oe(t.length <= 1, 117, t.length), e;
}
function Oa(e) {
  return wl(e), e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition";
  })[0];
}
function Yl(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
function xl(e) {
  return e.definitions.filter(function(t) {
    return t.kind === "FragmentDefinition";
  });
}
function bC(e) {
  var t = Oa(e);
  return Oe(t && t.operation === "query", 118), t;
}
function _C(e) {
  Oe(e.kind === "Document", 119), Oe(e.definitions.length <= 1, 120);
  var t = e.definitions[0];
  return Oe(t.kind === "FragmentDefinition", 121), t;
}
function $c(e) {
  wl(e);
  for (var t, n = 0, r = e.definitions; n < r.length; n++) {
    var i = r[n];
    if (i.kind === "OperationDefinition") {
      var o = i.operation;
      if (o === "query" || o === "mutation" || o === "subscription")
        return i;
    }
    i.kind === "FragmentDefinition" && !t && (t = i);
  }
  if (t)
    return t;
  throw jn(122);
}
function N0(e) {
  var t = /* @__PURE__ */ Object.create(null), n = e && e.variableDefinitions;
  return n && n.length && n.forEach(function(r) {
    r.defaultValue && Hs(t, r.variable.name, r.defaultValue);
  }), t;
}
let pn = null;
const xS = {};
let hee = 1;
const vee = () => class {
  constructor() {
    this.id = [
      "slot",
      hee++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = pn; e; e = e.parent)
      if (this.id in e.slots) {
        const t = e.slots[this.id];
        if (t === xS)
          break;
        return e !== pn && (pn.slots[this.id] = t), !0;
      }
    return pn && (pn.slots[this.id] = xS), !1;
  }
  getValue() {
    if (this.hasValue())
      return pn.slots[this.id];
  }
  withValue(e, t, n, r) {
    const i = {
      __proto__: null,
      [this.id]: e
    }, o = pn;
    pn = { parent: o, slots: i };
    try {
      return t.apply(r, n);
    } finally {
      pn = o;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const t = pn;
    return function() {
      const n = pn;
      try {
        return pn = t, e.apply(this, arguments);
      } finally {
        pn = n;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, t, n) {
    if (pn) {
      const r = pn;
      try {
        return pn = null, e.apply(n, t);
      } finally {
        pn = r;
      }
    } else
      return e.apply(n, t);
  }
};
function ES(e) {
  try {
    return e();
  } catch {
  }
}
const Ov = "@wry/context:Slot", mee = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  ES(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  ES(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), SS = mee, El = SS[Ov] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[Ov] || (function(e) {
  try {
    Object.defineProperty(SS, Ov, {
      value: e,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return e;
  }
})(vee()), { bind: jle, noContext: Fle } = El, Xp = new El(), { hasOwnProperty: gee } = Object.prototype, R0 = Array.from || function(e) {
  const t = [];
  return e.forEach((n) => t.push(n)), t;
};
function M0(e) {
  const { unsubscribe: t } = e;
  typeof t == "function" && (e.unsubscribe = void 0, t());
}
const Zu = [], yee = 100;
function Ws(e, t) {
  if (!e)
    throw new Error(t || "assertion failure");
}
function wC(e, t) {
  const n = e.length;
  return (
    // Unknown values are not equal to each other.
    n > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    n === t.length && // The underlying value or exception must be the same.
    e[n - 1] === t[n - 1]
  );
}
function xC(e) {
  switch (e.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return e[0];
    case 2:
      throw e[1];
  }
}
function EC(e) {
  return e.slice(0);
}
class eh {
  constructor(t) {
    this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++eh.count;
  }
  peek() {
    if (this.value.length === 1 && !Co(this))
      return OS(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(t) {
    return Ws(!this.recomputing, "already recomputing"), OS(this), Co(this) ? bee(this, t) : xC(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, SC(this), M0(this));
  }
  dispose() {
    this.setDirty(), PC(this), j0(this, (t, n) => {
      t.setDirty(), DC(t, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(t) {
    t.add(this), this.deps || (this.deps = Zu.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
  }
  forgetDeps() {
    this.deps && (R0(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), Zu.push(this.deps), this.deps = null);
  }
}
eh.count = 0;
function OS(e) {
  const t = Xp.getValue();
  if (t)
    return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Co(e) ? $C(t, e) : TC(t, e), t;
}
function bee(e, t) {
  return PC(e), Xp.withValue(e, _ee, [e, t]), xee(e, t) && wee(e), xC(e.value);
}
function _ee(e, t) {
  e.recomputing = !0;
  const { normalizeResult: n } = e;
  let r;
  n && e.value.length === 1 && (r = EC(e.value)), e.value.length = 0;
  try {
    if (e.value[0] = e.fn.apply(null, t), n && r && !wC(r, e.value))
      try {
        e.value[0] = n(e.value[0], r[0]);
      } catch {
      }
  } catch (i) {
    e.value[1] = i;
  }
  e.recomputing = !1;
}
function Co(e) {
  return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
}
function wee(e) {
  e.dirty = !1, !Co(e) && OC(e);
}
function SC(e) {
  j0(e, $C);
}
function OC(e) {
  j0(e, TC);
}
function j0(e, t) {
  const n = e.parents.size;
  if (n) {
    const r = R0(e.parents);
    for (let i = 0; i < n; ++i)
      t(r[i], e);
  }
}
function $C(e, t) {
  Ws(e.childValues.has(t)), Ws(Co(t));
  const n = !Co(e);
  if (!e.dirtyChildren)
    e.dirtyChildren = Zu.pop() || /* @__PURE__ */ new Set();
  else if (e.dirtyChildren.has(t))
    return;
  e.dirtyChildren.add(t), n && SC(e);
}
function TC(e, t) {
  Ws(e.childValues.has(t)), Ws(!Co(t));
  const n = e.childValues.get(t);
  n.length === 0 ? e.childValues.set(t, EC(t.value)) : wC(n, t.value) || e.setDirty(), kC(e, t), !Co(e) && OC(e);
}
function kC(e, t) {
  const n = e.dirtyChildren;
  n && (n.delete(t), n.size === 0 && (Zu.length < yee && Zu.push(n), e.dirtyChildren = null));
}
function PC(e) {
  e.childValues.size > 0 && e.childValues.forEach((t, n) => {
    DC(e, n);
  }), e.forgetDeps(), Ws(e.dirtyChildren === null);
}
function DC(e, t) {
  t.parents.delete(e), e.childValues.delete(t), kC(e, t);
}
function xee(e, t) {
  if (typeof e.subscribe == "function")
    try {
      M0(e), e.unsubscribe = e.subscribe.apply(null, t);
    } catch {
      return e.setDirty(), !1;
    }
  return !0;
}
const Eee = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function AC(e) {
  const t = /* @__PURE__ */ new Map();
  function n(r) {
    const i = Xp.getValue();
    if (i) {
      let o = t.get(r);
      o || t.set(r, o = /* @__PURE__ */ new Set()), i.dependOn(o);
    }
  }
  return n.dirty = function(r, i) {
    const o = t.get(r);
    if (o) {
      const a = i && gee.call(Eee, i) ? i : "setDirty";
      R0(o).forEach((s) => s[a]()), t.delete(r), M0(o);
    }
  }, n;
}
let $S;
function See(...e) {
  return ($S || ($S = new Ji(typeof WeakMap == "function"))).lookupArray(e);
}
const $v = /* @__PURE__ */ new Set();
function Gu(e, { max: t = Math.pow(2, 16), keyArgs: n, makeCacheKey: r = See, normalizeResult: i, subscribe: o, cache: a = Rg } = /* @__PURE__ */ Object.create(null)) {
  const s = typeof a == "function" ? new a(t, (d) => d.dispose()) : a, l = function() {
    const d = r.apply(null, n ? n.apply(null, arguments) : arguments);
    if (d === void 0)
      return e.apply(null, arguments);
    let p = s.get(d);
    p || (s.set(d, p = new eh(e)), p.normalizeResult = i, p.subscribe = o, p.forget = () => s.delete(d));
    const h = p.recompute(Array.prototype.slice.call(arguments));
    return s.set(d, p), $v.add(s), Xp.hasValue() || ($v.forEach((v) => v.clean()), $v.clear()), h;
  };
  Object.defineProperty(l, "size", {
    get: () => s.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(l.options = {
    max: t,
    keyArgs: n,
    makeCacheKey: r,
    normalizeResult: i,
    subscribe: o,
    cache: s
  });
  function u(d) {
    const p = d && s.get(d);
    p && p.setDirty();
  }
  l.dirtyKey = u, l.dirty = function() {
    u(r.apply(null, arguments));
  };
  function c(d) {
    const p = d && s.get(d);
    if (p)
      return p.peek();
  }
  l.peekKey = c, l.peek = function() {
    return c(r.apply(null, arguments));
  };
  function f(d) {
    return d ? s.delete(d) : !1;
  }
  return l.forgetKey = f, l.forget = function() {
    return f(r.apply(null, arguments));
  }, l.makeCacheKey = r, l.getKey = n ? function() {
    return r.apply(null, n.apply(null, arguments));
  } : r, Object.freeze(l);
}
function Oee(e) {
  return e;
}
var CC = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = /* @__PURE__ */ Object.create(null)), this.resultCache = I0 ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, n.getCacheKey && (this.getCacheKey = n.getCacheKey), this.cached = n.cache !== !1, this.resetCache();
    }
    return e.prototype.getCacheKey = function(t) {
      return [t];
    }, e.identity = function() {
      return new e(Oee, { cache: !1 });
    }, e.split = function(t, n, r) {
      return r === void 0 && (r = e.identity()), Object.assign(new e(
        function(i) {
          var o = t(i) ? n : r;
          return o.transformDocument(i);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: n, right: r });
    }, e.prototype.resetCache = function() {
      var t = this;
      if (this.cached) {
        var n = new Ji(Ba);
        this.performWork = Gu(e.prototype.performWork.bind(this), {
          makeCacheKey: function(r) {
            var i = t.getCacheKey(r);
            if (i)
              return Oe(Array.isArray(i), 104), n.lookupArray(i);
          },
          max: Zi["documentTransform.cache"],
          cache: Fd
        });
      }
    }, e.prototype.performWork = function(t) {
      return wl(t), this.transform(t);
    }, e.prototype.transformDocument = function(t) {
      if (this.resultCache.has(t))
        return t;
      var n = this.performWork(t);
      return this.resultCache.add(n), n;
    }, e.prototype.concat = function(t) {
      var n = this;
      return Object.assign(new e(
        function(r) {
          return t.transformDocument(n.transformDocument(r));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: t
      });
    }, e;
  })()
), vu, _o = Object.assign(function(e) {
  var t = vu.get(e);
  return t || (t = EX(e), vu.set(e, t)), t;
}, {
  reset: function() {
    vu = new pC(
      Zi.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
_o.reset();
globalThis.__DEV__ !== !1 && hC("print", function() {
  return vu ? vu.size : 0;
});
var Ht = Array.isArray;
function Oi(e) {
  return Array.isArray(e) && e.length > 0;
}
var TS = {
  kind: Vt.FIELD,
  name: {
    kind: Vt.NAME,
    value: "__typename"
  }
};
function IC(e, t) {
  return !e || e.selectionSet.selections.every(function(n) {
    return n.kind === Vt.FRAGMENT_SPREAD && IC(t[n.name.value], t);
  });
}
function $ee(e) {
  return IC(Oa(e) || _C(e), _l(xl(e))) ? null : e;
}
function Tee(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  return e.forEach(function(r) {
    r && (r.name ? t.set(r.name, r) : r.test && n.set(r.test, r));
  }), function(r) {
    var i = t.get(r.name.value);
    return !i && n.size && n.forEach(function(o, a) {
      a(r) && (i = o);
    }), i;
  };
}
function kS(e) {
  var t = /* @__PURE__ */ new Map();
  return function(n) {
    n === void 0 && (n = e);
    var r = t.get(n);
    return r || t.set(n, r = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), r;
  };
}
function NC(e, t) {
  wl(t);
  for (var n = kS(""), r = kS(""), i = function(g) {
    for (var y = 0, w = void 0; y < g.length && (w = g[y]); ++y)
      if (!Ht(w)) {
        if (w.kind === Vt.OPERATION_DEFINITION)
          return n(w.name && w.name.value);
        if (w.kind === Vt.FRAGMENT_DEFINITION)
          return r(w.name.value);
      }
    return globalThis.__DEV__ !== !1 && Oe.error(124), null;
  }, o = 0, a = t.definitions.length - 1; a >= 0; --a)
    t.definitions[a].kind === Vt.OPERATION_DEFINITION && ++o;
  var s = Tee(e), l = function(g) {
    return Oi(g) && g.map(s).some(function(y) {
      return y && y.remove;
    });
  }, u = /* @__PURE__ */ new Map(), c = !1, f = {
    enter: function(g) {
      if (l(g.directives))
        return c = !0, null;
    }
  }, d = ti(t, {
    // These two AST node types share the same implementation, defined above.
    Field: f,
    InlineFragment: f,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(g, y, w, x, S) {
        var O = i(S);
        O && O.variables.add(g.name.value);
      }
    },
    FragmentSpread: {
      enter: function(g, y, w, x, S) {
        if (l(g.directives))
          return c = !0, null;
        var O = i(S);
        O && O.fragmentSpreads.add(g.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(g, y, w, x) {
        u.set(JSON.stringify(x), g);
      },
      leave: function(g, y, w, x) {
        var S = u.get(JSON.stringify(x));
        if (g === S)
          return g;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          o > 0 && g.selectionSet.selections.every(function(O) {
            return O.kind === Vt.FIELD && O.name.value === "__typename";
          })
        )
          return r(g.name.value).removed = !0, c = !0, null;
      }
    },
    Directive: {
      leave: function(g) {
        if (s(g))
          return c = !0, null;
      }
    }
  });
  if (!c)
    return t;
  var p = function(g) {
    return g.transitiveVars || (g.transitiveVars = new Set(g.variables), g.removed || g.fragmentSpreads.forEach(function(y) {
      p(r(y)).transitiveVars.forEach(function(w) {
        g.transitiveVars.add(w);
      });
    })), g;
  }, h = /* @__PURE__ */ new Set();
  d.definitions.forEach(function(g) {
    g.kind === Vt.OPERATION_DEFINITION ? p(n(g.name && g.name.value)).fragmentSpreads.forEach(function(y) {
      h.add(y);
    }) : g.kind === Vt.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    o === 0 && !r(g.name.value).removed && h.add(g.name.value);
  }), h.forEach(function(g) {
    p(r(g)).fragmentSpreads.forEach(function(y) {
      h.add(y);
    });
  });
  var v = function(g) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!h.has(g) || r(g).removed);
  }, m = {
    enter: function(g) {
      if (v(g.name.value))
        return null;
    }
  };
  return $ee(ti(d, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: m,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: m,
    OperationDefinition: {
      leave: function(g) {
        if (g.variableDefinitions) {
          var y = p(
            // If an operation is anonymous, we use the empty string as its key.
            n(g.name && g.name.value)
          ).transitiveVars;
          if (y.size < g.variableDefinitions.length)
            return G(G({}, g), { variableDefinitions: g.variableDefinitions.filter(function(w) {
              return y.has(w.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var F0 = Object.assign(function(e) {
  return ti(e, {
    SelectionSet: {
      enter: function(t, n, r) {
        if (!(r && r.kind === Vt.OPERATION_DEFINITION)) {
          var i = t.selections;
          if (i) {
            var o = i.some(function(s) {
              return Ao(s) && (s.name.value === "__typename" || s.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!o) {
              var a = r;
              if (!(Ao(a) && a.directives && a.directives.some(function(s) {
                return s.name.value === "export";
              })))
                return G(G({}, t), { selections: gn(gn([], i, !0), [TS], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(e) {
    return e === TS;
  }
});
function kee(e) {
  var t = $c(e), n = t.operation;
  if (n === "query")
    return e;
  var r = ti(e, {
    OperationDefinition: {
      enter: function(i) {
        return G(G({}, i), { operation: "query" });
      }
    }
  });
  return r;
}
function RC(e) {
  wl(e);
  var t = NC([
    {
      test: function(n) {
        return n.name.value === "client";
      },
      remove: !0
    }
  ], e);
  return t;
}
function Pee(e) {
  return wl(e), ti(e, {
    FragmentSpread: function(t) {
      var n;
      if (!(!((n = t.directives) === null || n === void 0) && n.some(function(r) {
        return r.name.value === "unmask";
      })))
        return G(G({}, t), { directives: gn(gn([], t.directives || [], !0), [
          {
            kind: Vt.DIRECTIVE,
            name: { kind: Vt.NAME, value: "nonreactive" }
          }
        ], !1) });
    }
  });
}
var Dee = Object.prototype.hasOwnProperty;
function PS() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return th(e);
}
function th(e) {
  var t = e[0] || {}, n = e.length;
  if (n > 1)
    for (var r = new Io(), i = 1; i < n; ++i)
      t = r.merge(t, e[i]);
  return t;
}
var Aee = function(e, t, n) {
  return this.merge(e[n], t[n]);
}, Io = (
  /** @class */
  (function() {
    function e(t) {
      t === void 0 && (t = Aee), this.reconciler = t, this.isObject = Nt, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return e.prototype.merge = function(t, n) {
      for (var r = this, i = [], o = 2; o < arguments.length; o++)
        i[o - 2] = arguments[o];
      return Nt(n) && Nt(t) ? (Object.keys(n).forEach(function(a) {
        if (Dee.call(t, a)) {
          var s = t[a];
          if (n[a] !== s) {
            var l = r.reconciler.apply(r, gn([
              t,
              n,
              a
            ], i, !1));
            l !== s && (t = r.shallowCopyForMerge(t), t[a] = l);
          }
        } else
          t = r.shallowCopyForMerge(t), t[a] = n[a];
      }), t) : n;
    }, e.prototype.shallowCopyForMerge = function(t) {
      return Nt(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = G({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
    }, e;
  })()
);
function Cee(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n) return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = Iee(e)) || t) {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Iee(e, t) {
  if (e) {
    if (typeof e == "string") return DS(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return DS(e, t);
  }
}
function DS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function AS(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function z0(e, t, n) {
  return t && AS(e.prototype, t), n && AS(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
var L0 = function() {
  return typeof Symbol == "function";
}, V0 = function(e) {
  return L0() && !!Symbol[e];
}, B0 = function(e) {
  return V0(e) ? Symbol[e] : "@@" + e;
};
L0() && !V0("observable") && (Symbol.observable = Symbol("observable"));
var Nee = B0("iterator"), Lg = B0("observable"), MC = B0("species");
function zd(e, t) {
  var n = e[t];
  if (n != null) {
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    return n;
  }
}
function Fl(e) {
  var t = e.constructor;
  return t !== void 0 && (t = t[MC], t === null && (t = void 0)), t !== void 0 ? t : yt;
}
function Ree(e) {
  return e instanceof yt;
}
function Zs(e) {
  Zs.log ? Zs.log(e) : setTimeout(function() {
    throw e;
  });
}
function Rf(e) {
  Promise.resolve().then(function() {
    try {
      e();
    } catch (t) {
      Zs(t);
    }
  });
}
function jC(e) {
  var t = e._cleanup;
  if (t !== void 0 && (e._cleanup = void 0, !!t))
    try {
      if (typeof t == "function")
        t();
      else {
        var n = zd(t, "unsubscribe");
        n && n.call(t);
      }
    } catch (r) {
      Zs(r);
    }
}
function Vg(e) {
  e._observer = void 0, e._queue = void 0, e._state = "closed";
}
function Mee(e) {
  var t = e._queue;
  if (t) {
    e._queue = void 0, e._state = "ready";
    for (var n = 0; n < t.length && (FC(e, t[n].type, t[n].value), e._state !== "closed"); ++n)
      ;
  }
}
function FC(e, t, n) {
  e._state = "running";
  var r = e._observer;
  try {
    var i = zd(r, t);
    switch (t) {
      case "next":
        i && i.call(r, n);
        break;
      case "error":
        if (Vg(e), i) i.call(r, n);
        else throw n;
        break;
      case "complete":
        Vg(e), i && i.call(r);
        break;
    }
  } catch (o) {
    Zs(o);
  }
  e._state === "closed" ? jC(e) : e._state === "running" && (e._state = "ready");
}
function Tv(e, t, n) {
  if (e._state !== "closed") {
    if (e._state === "buffering") {
      e._queue.push({
        type: t,
        value: n
      });
      return;
    }
    if (e._state !== "ready") {
      e._state = "buffering", e._queue = [{
        type: t,
        value: n
      }], Rf(function() {
        return Mee(e);
      });
      return;
    }
    FC(e, t, n);
  }
}
var jee = /* @__PURE__ */ (function() {
  function e(n, r) {
    this._cleanup = void 0, this._observer = n, this._queue = void 0, this._state = "initializing";
    var i = new Fee(this);
    try {
      this._cleanup = r.call(void 0, i);
    } catch (o) {
      i.error(o);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var t = e.prototype;
  return t.unsubscribe = function() {
    this._state !== "closed" && (Vg(this), jC(this));
  }, z0(e, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), e;
})(), Fee = /* @__PURE__ */ (function() {
  function e(n) {
    this._subscription = n;
  }
  var t = e.prototype;
  return t.next = function(n) {
    Tv(this._subscription, "next", n);
  }, t.error = function(n) {
    Tv(this._subscription, "error", n);
  }, t.complete = function() {
    Tv(this._subscription, "complete");
  }, z0(e, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), e;
})(), yt = /* @__PURE__ */ (function() {
  function e(n) {
    if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
    if (typeof n != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = n;
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    return (typeof n != "object" || n === null) && (n = {
      next: n,
      error: arguments[1],
      complete: arguments[2]
    }), new jee(n, this._subscriber);
  }, t.forEach = function(n) {
    var r = this;
    return new Promise(function(i, o) {
      if (typeof n != "function") {
        o(new TypeError(n + " is not a function"));
        return;
      }
      function a() {
        s.unsubscribe(), i();
      }
      var s = r.subscribe({
        next: function(l) {
          try {
            n(l, a);
          } catch (u) {
            o(u), s.unsubscribe();
          }
        },
        error: o,
        complete: i
      });
    });
  }, t.map = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Fl(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            a = n(a);
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.filter = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Fl(this);
    return new i(function(o) {
      return r.subscribe({
        next: function(a) {
          try {
            if (!n(a)) return;
          } catch (s) {
            return o.error(s);
          }
          o.next(a);
        },
        error: function(a) {
          o.error(a);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, t.reduce = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Fl(this), o = arguments.length > 1, a = !1, s = arguments[1], l = s;
    return new i(function(u) {
      return r.subscribe({
        next: function(c) {
          var f = !a;
          if (a = !0, !f || o)
            try {
              l = n(l, c);
            } catch (d) {
              return u.error(d);
            }
          else
            l = c;
        },
        error: function(c) {
          u.error(c);
        },
        complete: function() {
          if (!a && !o) return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(l), u.complete();
        }
      });
    });
  }, t.concat = function() {
    for (var n = this, r = arguments.length, i = new Array(r), o = 0; o < r; o++)
      i[o] = arguments[o];
    var a = Fl(this);
    return new a(function(s) {
      var l, u = 0;
      function c(f) {
        l = f.subscribe({
          next: function(d) {
            s.next(d);
          },
          error: function(d) {
            s.error(d);
          },
          complete: function() {
            u === i.length ? (l = void 0, s.complete()) : c(a.from(i[u++]));
          }
        });
      }
      return c(n), function() {
        l && (l.unsubscribe(), l = void 0);
      };
    });
  }, t.flatMap = function(n) {
    var r = this;
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    var i = Fl(this);
    return new i(function(o) {
      var a = [], s = r.subscribe({
        next: function(u) {
          if (n)
            try {
              u = n(u);
            } catch (f) {
              return o.error(f);
            }
          var c = i.from(u).subscribe({
            next: function(f) {
              o.next(f);
            },
            error: function(f) {
              o.error(f);
            },
            complete: function() {
              var f = a.indexOf(c);
              f >= 0 && a.splice(f, 1), l();
            }
          });
          a.push(c);
        },
        error: function(u) {
          o.error(u);
        },
        complete: function() {
          l();
        }
      });
      function l() {
        s.closed && a.length === 0 && o.complete();
      }
      return function() {
        a.forEach(function(u) {
          return u.unsubscribe();
        }), s.unsubscribe();
      };
    });
  }, t[Lg] = function() {
    return this;
  }, e.from = function(n) {
    var r = typeof this == "function" ? this : e;
    if (n == null) throw new TypeError(n + " is not an object");
    var i = zd(n, Lg);
    if (i) {
      var o = i.call(n);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return Ree(o) && o.constructor === r ? o : new r(function(a) {
        return o.subscribe(a);
      });
    }
    if (V0("iterator") && (i = zd(n, Nee), i))
      return new r(function(a) {
        Rf(function() {
          if (!a.closed) {
            for (var s = Cee(i.call(n)), l; !(l = s()).done; ) {
              var u = l.value;
              if (a.next(u), a.closed) return;
            }
            a.complete();
          }
        });
      });
    if (Array.isArray(n))
      return new r(function(a) {
        Rf(function() {
          if (!a.closed) {
            for (var s = 0; s < n.length; ++s)
              if (a.next(n[s]), a.closed) return;
            a.complete();
          }
        });
      });
    throw new TypeError(n + " is not observable");
  }, e.of = function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    var o = typeof this == "function" ? this : e;
    return new o(function(a) {
      Rf(function() {
        if (!a.closed) {
          for (var s = 0; s < r.length; ++s)
            if (a.next(r[s]), a.closed) return;
          a.complete();
        }
      });
    });
  }, z0(e, null, [{
    key: MC,
    get: function() {
      return this;
    }
  }]), e;
})();
L0() && Object.defineProperty(yt, Symbol("extensions"), {
  value: {
    symbol: Lg,
    hostReportError: Zs
  },
  configurable: !0
});
function zee(e) {
  var t, n = e.Symbol;
  if (typeof n == "function")
    if (n.observable)
      t = n.observable;
    else {
      typeof n.for == "function" ? t = n.for("https://github.com/benlesh/symbol-observable") : t = n("https://github.com/benlesh/symbol-observable");
      try {
        n.observable = t;
      } catch {
      }
    }
  else
    t = "@@observable";
  return t;
}
var es;
typeof self < "u" ? es = self : typeof window < "u" ? es = window : typeof global < "u" ? es = global : typeof module < "u" ? es = module : es = Function("return this")();
zee(es);
var CS = yt.prototype, IS = "@@observable";
CS[IS] || (CS[IS] = function() {
  return this;
});
function Lee(e) {
  return e.catch(function() {
  }), e;
}
var Vee = Object.prototype.toString;
function zC(e) {
  return Bg(e);
}
function Bg(e, t) {
  switch (Vee.call(e)) {
    case "[object Array]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var n = e.slice(0);
      return t.set(e, n), n.forEach(function(i, o) {
        n[o] = Bg(i, t);
      }), n;
    }
    case "[object Object]": {
      if (t = t || /* @__PURE__ */ new Map(), t.has(e))
        return t.get(e);
      var r = Object.create(Object.getPrototypeOf(e));
      return t.set(e, r), Object.keys(e).forEach(function(i) {
        r[i] = Bg(e[i], t);
      }), r;
    }
    default:
      return e;
  }
}
function Bee(e) {
  var t = /* @__PURE__ */ new Set([e]);
  return t.forEach(function(n) {
    Nt(n) && Uee(n) === n && Object.getOwnPropertyNames(n).forEach(function(r) {
      Nt(n[r]) && t.add(n[r]);
    });
  }), e;
}
function Uee(e) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
    try {
      Object.freeze(e);
    } catch (t) {
      if (t instanceof TypeError)
        return null;
      throw t;
    }
  return e;
}
function Ld(e) {
  return globalThis.__DEV__ !== !1 && Bee(e), e;
}
function mu(e, t, n) {
  var r = [];
  e.forEach(function(i) {
    return i[t] && r.push(i);
  }), r.forEach(function(i) {
    return i[t](n);
  });
}
function kv(e, t, n) {
  return new yt(function(r) {
    var i = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(l) {
        return new Promise(function(u) {
          return u(l());
        });
      }
    };
    function o(l, u) {
      return function(c) {
        if (l) {
          var f = function() {
            return r.closed ? (
              /* will be swallowed */
              0
            ) : l(c);
          };
          i = i.then(f, f).then(function(d) {
            return r.next(d);
          }, function(d) {
            return r.error(d);
          });
        } else
          r[u](c);
      };
    }
    var a = {
      next: o(t, "next"),
      error: o(n, "error"),
      complete: function() {
        i.then(function() {
          return r.complete();
        });
      }
    }, s = e.subscribe(a);
    return function() {
      return s.unsubscribe();
    };
  });
}
function LC(e) {
  function t(n) {
    Object.defineProperty(e, n, { value: yt });
  }
  return fC && Symbol.species && t(Symbol.species), t("@@species"), e;
}
function NS(e) {
  return e && typeof e.then == "function";
}
var ts = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n) {
      var r = e.call(this, function(i) {
        return r.addObserver(i), function() {
          return r.removeObserver(i);
        };
      }) || this;
      return r.observers = /* @__PURE__ */ new Set(), r.promise = new Promise(function(i, o) {
        r.resolve = i, r.reject = o;
      }), r.handlers = {
        next: function(i) {
          r.sub !== null && (r.latest = ["next", i], r.notify("next", i), mu(r.observers, "next", i));
        },
        error: function(i) {
          var o = r.sub;
          o !== null && (o && setTimeout(function() {
            return o.unsubscribe();
          }), r.sub = null, r.latest = ["error", i], r.reject(i), r.notify("error", i), mu(r.observers, "error", i));
        },
        complete: function() {
          var i = r, o = i.sub, a = i.sources, s = a === void 0 ? [] : a;
          if (o !== null) {
            var l = s.shift();
            l ? NS(l) ? l.then(function(u) {
              return r.sub = u.subscribe(r.handlers);
            }, r.handlers.error) : r.sub = l.subscribe(r.handlers) : (o && setTimeout(function() {
              return o.unsubscribe();
            }), r.sub = null, r.latest && r.latest[0] === "next" ? r.resolve(r.latest[1]) : r.resolve(), r.notify("complete"), mu(r.observers, "complete"));
          }
        }
      }, r.nextResultListeners = /* @__PURE__ */ new Set(), r.cancel = function(i) {
        r.reject(i), r.sources = [], r.handlers.error(i);
      }, r.promise.catch(function(i) {
      }), typeof n == "function" && (n = [new yt(n)]), NS(n) ? n.then(function(i) {
        return r.start(i);
      }, r.handlers.error) : r.start(n), r;
    }
    return t.prototype.start = function(n) {
      this.sub === void 0 && (this.sources = Array.from(n), this.handlers.complete());
    }, t.prototype.deliverLastMessage = function(n) {
      if (this.latest) {
        var r = this.latest[0], i = n[r];
        i && i.call(n, this.latest[1]), this.sub === null && r === "next" && n.complete && n.complete();
      }
    }, t.prototype.addObserver = function(n) {
      this.observers.has(n) || (this.deliverLastMessage(n), this.observers.add(n));
    }, t.prototype.removeObserver = function(n) {
      this.observers.delete(n) && this.observers.size < 1 && this.handlers.complete();
    }, t.prototype.notify = function(n, r) {
      var i = this.nextResultListeners;
      i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
        return o(n, r);
      }));
    }, t.prototype.beforeNext = function(n) {
      var r = !1;
      this.nextResultListeners.add(function(i, o) {
        r || (r = !0, n(i, o));
      });
    }, t;
  })(yt)
);
LC(ts);
function Os(e) {
  return "incremental" in e;
}
function Kee(e) {
  return "hasNext" in e && "data" in e;
}
function qee(e) {
  return Os(e) || Kee(e);
}
function Hee(e) {
  return Nt(e) && "payload" in e;
}
function VC(e, t) {
  var n = e, r = new Io();
  return Os(t) && Oi(t.incremental) && t.incremental.forEach(function(i) {
    for (var o = i.data, a = i.path, s = a.length - 1; s >= 0; --s) {
      var l = a[s], u = !isNaN(+l), c = u ? [] : {};
      c[l] = o, o = c;
    }
    n = r.merge(n, o);
  }), n;
}
function Mf(e) {
  var t = Ug(e);
  return Oi(t);
}
function Ug(e) {
  var t = Oi(e.errors) ? e.errors.slice(0) : [];
  return Os(e) && Oi(e.incremental) && e.incremental.forEach(function(n) {
    n.errors && t.push.apply(t, n.errors);
  }), t;
}
function Gs() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = /* @__PURE__ */ Object.create(null);
  return e.forEach(function(r) {
    r && Object.keys(r).forEach(function(i) {
      var o = r[i];
      o !== void 0 && (n[i] = o);
    });
  }), n;
}
function Pv(e, t) {
  return Gs(e, t, t.variables && {
    variables: Gs(G(G({}, e && e.variables), t.variables))
  });
}
var Dv, Wee = Symbol.for("apollo.deprecations"), RS = Symbol.for("apollo.deprecations.slot"), Kg = jd, qg = (Dv = Kg[RS]) !== null && Dv !== void 0 ? Dv : Kg[RS] = new El();
function Zee(e) {
  return Kg[Wee] || (qg.getValue() || []).includes(e);
}
function wn(e) {
  for (var t = [], n = 1; n < arguments.length; n++)
    t[n - 1] = arguments[n];
  return qg.withValue.apply(qg, gn([Array.isArray(e) ? e : [e]], t, !1));
}
function Gt(e, t, n, r) {
  r === void 0 && (r = "Please remove this option."), na(t, function() {
    t in e && globalThis.__DEV__ !== !1 && Oe.warn(103, n, t, r);
  });
}
function na(e, t) {
  Zee(e) || t();
}
function Av(e) {
  return new yt(function(t) {
    t.error(e);
  });
}
var BC = function(e, t, n) {
  var r = new Error(n);
  throw r.name = "ServerError", r.response = e, r.statusCode = e.status, r.result = t, r;
};
function Gee(e) {
  for (var t = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], n = 0, r = Object.keys(e); n < r.length; n++) {
    var i = r[n];
    if (t.indexOf(i) < 0)
      throw jn(58, i);
  }
  return e;
}
function Yee(e, t) {
  var n = G({}, e), r = function(o) {
    typeof o == "function" ? n = G(G({}, n), o(n)) : n = G(G({}, n), o);
  }, i = function() {
    return G({}, n);
  };
  return Object.defineProperty(t, "setContext", {
    enumerable: !1,
    value: r
  }), Object.defineProperty(t, "getContext", {
    enumerable: !1,
    value: i
  }), t;
}
function Qee(e) {
  var t = {
    variables: e.variables || {},
    extensions: e.extensions || {},
    operationName: e.operationName,
    query: e.query
  };
  return t.operationName || (t.operationName = typeof t.query != "string" ? Yl(t.query) || void 0 : ""), t;
}
function Jee(e, t) {
  var n = G({}, e), r = new Set(Object.keys(e));
  return ti(t, {
    Variable: function(i, o, a) {
      a && a.kind !== "VariableDefinition" && r.delete(i.name.value);
    }
  }), r.forEach(function(i) {
    delete n[i];
  }), n;
}
function MS(e, t) {
  return t ? t(e) : yt.of();
}
function zl(e) {
  return typeof e == "function" ? new Bo(e) : e;
}
function ff(e) {
  return e.request.length <= 1;
}
var Bo = (
  /** @class */
  (function() {
    function e(t) {
      t && (this.request = t);
    }
    return e.empty = function() {
      return new e(function() {
        return yt.of();
      });
    }, e.from = function(t) {
      return t.length === 0 ? e.empty() : t.map(zl).reduce(function(n, r) {
        return n.concat(r);
      });
    }, e.split = function(t, n, r) {
      var i = zl(n), o = zl(r || new e(MS)), a;
      return ff(i) && ff(o) ? a = new e(function(s) {
        return t(s) ? i.request(s) || yt.of() : o.request(s) || yt.of();
      }) : a = new e(function(s, l) {
        return t(s) ? i.request(s, l) || yt.of() : o.request(s, l) || yt.of();
      }), Object.assign(a, { left: i, right: o });
    }, e.execute = function(t, n) {
      return t.request(Yee(n.context, Qee(Gee(n)))) || yt.of();
    }, e.concat = function(t, n) {
      var r = zl(t);
      if (ff(r))
        return globalThis.__DEV__ !== !1 && Oe.warn(47, r), r;
      var i = zl(n), o;
      return ff(i) ? o = new e(function(a) {
        return r.request(a, function(s) {
          return i.request(s) || yt.of();
        }) || yt.of();
      }) : o = new e(function(a, s) {
        return r.request(a, function(l) {
          return i.request(l, s) || yt.of();
        }) || yt.of();
      }), Object.assign(o, { left: r, right: i });
    }, e.prototype.split = function(t, n, r) {
      return this.concat(e.split(t, n, r || new e(MS)));
    }, e.prototype.concat = function(t) {
      return e.concat(this, t);
    }, e.prototype.request = function(t, n) {
      throw jn(48);
    }, e.prototype.onError = function(t, n) {
      if (globalThis.__DEV__ !== !1 && na("onError", function() {
        globalThis.__DEV__ !== !1 && Oe.warn(49);
      }), n && n.error)
        return n.error(t), !1;
      throw t;
    }, e.prototype.setOnError = function(t) {
      return globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Oe.warn(50), this.onError = t, this;
    }, e;
  })()
);
Bo.from;
Bo.split;
var Hg = Bo.execute;
function Xee(e) {
  var t, n = e[Symbol.asyncIterator]();
  return t = {
    next: function() {
      return n.next();
    }
  }, t[Symbol.asyncIterator] = function() {
    return this;
  }, t;
}
function ete(e) {
  var t = null, n = null, r = !1, i = [], o = [];
  function a(f) {
    if (!n) {
      if (o.length) {
        var d = o.shift();
        if (Array.isArray(d) && d[0])
          return d[0]({ value: f, done: !1 });
      }
      i.push(f);
    }
  }
  function s(f) {
    n = f;
    var d = o.slice();
    d.forEach(function(p) {
      p[1](f);
    }), !t || t();
  }
  function l() {
    r = !0;
    var f = o.slice();
    f.forEach(function(d) {
      d[0]({ value: void 0, done: !0 });
    }), !t || t();
  }
  t = function() {
    t = null, e.removeListener("data", a), e.removeListener("error", s), e.removeListener("end", l), e.removeListener("finish", l), e.removeListener("close", l);
  }, e.on("data", a), e.on("error", s), e.on("end", l), e.on("finish", l), e.on("close", l);
  function u() {
    return new Promise(function(f, d) {
      if (n)
        return d(n);
      if (i.length)
        return f({ value: i.shift(), done: !1 });
      if (r)
        return f({ value: void 0, done: !0 });
      o.push([f, d]);
    });
  }
  var c = {
    next: function() {
      return u();
    }
  };
  return Yp && (c[Symbol.asyncIterator] = function() {
    return this;
  }), c;
}
function tte(e) {
  var t = !1, n = {
    next: function() {
      return t ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (t = !0, new Promise(function(r, i) {
        e.then(function(o) {
          r({ value: o, done: !1 });
        }).catch(i);
      }));
    }
  };
  return Yp && (n[Symbol.asyncIterator] = function() {
    return this;
  }), n;
}
function jS(e) {
  var t = {
    next: function() {
      return e.read();
    }
  };
  return Yp && (t[Symbol.asyncIterator] = function() {
    return this;
  }), t;
}
function nte(e) {
  return !!e.body;
}
function rte(e) {
  return !!e.getReader;
}
function ite(e) {
  return !!(Yp && e[Symbol.asyncIterator]);
}
function ote(e) {
  return !!e.stream;
}
function ate(e) {
  return !!e.arrayBuffer;
}
function ste(e) {
  return !!e.pipe;
}
function lte(e) {
  var t = e;
  if (nte(e) && (t = e.body), ite(t))
    return Xee(t);
  if (rte(t))
    return jS(t.getReader());
  if (ote(t))
    return jS(t.stream().getReader());
  if (ate(t))
    return tte(t.arrayBuffer());
  if (ste(t))
    return ete(t);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var U0 = Symbol();
function ute(e) {
  return e.extensions ? Array.isArray(e.extensions[U0]) : !1;
}
function UC(e) {
  return e.hasOwnProperty("graphQLErrors");
}
var cte = function(e) {
  var t = gn(gn(gn([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
  return e.networkError && t.push(e.networkError), t.map(function(n) {
    return Nt(n) && n.message || "Error message not found.";
  }).join(`
`);
}, fo = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n) {
      var r = n.graphQLErrors, i = n.protocolErrors, o = n.clientErrors, a = n.networkError, s = n.errorMessage, l = n.extraInfo, u = e.call(this, s) || this;
      return u.name = "ApolloError", u.graphQLErrors = r || [], u.protocolErrors = i || [], u.clientErrors = o || [], u.networkError = a || null, u.message = s || cte(u), u.extraInfo = l, u.cause = gn(gn(gn([
        a
      ], r || [], !0), i || [], !0), o || [], !0).find(function(c) {
        return !!c;
      }) || null, u.__proto__ = t.prototype, u;
    }
    return t;
  })(Error)
), FS = Object.prototype.hasOwnProperty;
function fte(e, t) {
  return lo(this, void 0, void 0, function() {
    var n, r, i, o, a, s, l, u, c, f, d, p, h, v, m, g, y, w, x, S, O, P, b, _;
    return uo(this, function(E) {
      switch (E.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          n = new TextDecoder("utf-8"), r = (_ = e.headers) === null || _ === void 0 ? void 0 : _.get("content-type"), i = "boundary=", o = r != null && r.includes(i) ? r?.substring(r?.indexOf(i) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", a = `\r
--`.concat(o), s = "", l = lte(e), u = !0, E.label = 1;
        case 1:
          return u ? [4, l.next()] : [3, 3];
        case 2:
          for (c = E.sent(), f = c.value, d = c.done, p = typeof f == "string" ? f : n.decode(f), h = s.length - a.length + 1, u = !d, s += p, v = s.indexOf(a, h); v > -1; ) {
            if (m = void 0, P = [
              s.slice(0, v),
              s.slice(v + a.length)
            ], m = P[0], s = P[1], g = m.indexOf(`\r
\r
`), y = dte(m.slice(0, g)), w = y["content-type"], w && w.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (x = m.slice(g), x) {
              if (S = KC(e, x), Object.keys(S).length > 1 || "data" in S || "incremental" in S || "errors" in S || "payload" in S)
                if (Hee(S)) {
                  if (O = {}, "payload" in S) {
                    if (Object.keys(S).length === 1 && S.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    O = G({}, S.payload);
                  }
                  "errors" in S && (O = G(G({}, O), { extensions: G(G({}, "extensions" in O ? O.extensions : null), (b = {}, b[U0] = S.errors, b)) })), t(O);
                } else
                  t(S);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(S).length === 1 && "hasNext" in S && !S.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            v = s.indexOf(a);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function dte(e) {
  var t = {};
  return e.split(`
`).forEach(function(n) {
    var r = n.indexOf(":");
    if (r > -1) {
      var i = n.slice(0, r).trim().toLowerCase(), o = n.slice(r + 1).trim();
      t[i] = o;
    }
  }), t;
}
function KC(e, t) {
  if (e.status >= 300) {
    var n = function() {
      try {
        return JSON.parse(t);
      } catch {
        return t;
      }
    };
    BC(e, n(), "Response not successful: Received status code ".concat(e.status));
  }
  try {
    return JSON.parse(t);
  } catch (i) {
    var r = i;
    throw r.name = "ServerParseError", r.response = e, r.statusCode = e.status, r.bodyText = t, r;
  }
}
function pte(e, t) {
  e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
}
function hte(e) {
  return function(t) {
    return t.text().then(function(n) {
      return KC(t, n);
    }).then(function(n) {
      return !Array.isArray(n) && !FS.call(n, "data") && !FS.call(n, "errors") && BC(t, n, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(r) {
        return r.operationName;
      }) : e.operationName, "'.")), n;
    });
  };
}
var Wg = function(e, t) {
  var n;
  try {
    n = JSON.stringify(e);
  } catch (i) {
    var r = jn(54, t, i.message);
    throw r.parseError = i, r;
  }
  return n;
}, vte = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, mte = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, gte = {
  method: "POST"
}, yte = {
  http: vte,
  headers: mte,
  options: gte
}, bte = function(e, t) {
  return t(e);
};
function _te(e, t) {
  for (var n = [], r = 2; r < arguments.length; r++)
    n[r - 2] = arguments[r];
  var i = {}, o = {};
  n.forEach(function(f) {
    i = G(G(G({}, i), f.options), { headers: G(G({}, i.headers), f.headers) }), f.credentials && (i.credentials = f.credentials), o = G(G({}, o), f.http);
  }), i.headers && (i.headers = wte(i.headers, o.preserveHeaderCase));
  var a = e.operationName, s = e.extensions, l = e.variables, u = e.query, c = { operationName: a, variables: l };
  return o.includeExtensions && (c.extensions = s), o.includeQuery && (c.query = t(u, _o)), {
    options: i,
    body: c
  };
}
function wte(e, t) {
  if (!t) {
    var n = {};
    return Object.keys(Object(e)).forEach(function(o) {
      n[o.toLowerCase()] = e[o];
    }), n;
  }
  var r = {};
  Object.keys(Object(e)).forEach(function(o) {
    r[o.toLowerCase()] = {
      originalName: o,
      value: e[o]
    };
  });
  var i = {};
  return Object.keys(r).forEach(function(o) {
    i[r[o].originalName] = r[o].value;
  }), i;
}
var xte = function(e) {
  if (!e && typeof fetch > "u")
    throw jn(51);
}, Ete = function(e, t) {
  var n = e.getContext(), r = n.uri;
  return r || (typeof t == "function" ? t(e) : t || "/graphql");
};
function Ste(e, t) {
  var n = [], r = function(f, d) {
    n.push("".concat(f, "=").concat(encodeURIComponent(d)));
  };
  if ("query" in t && r("query", t.query), t.operationName && r("operationName", t.operationName), t.variables) {
    var i = void 0;
    try {
      i = Wg(t.variables, "Variables map");
    } catch (f) {
      return { parseError: f };
    }
    r("variables", i);
  }
  if (t.extensions) {
    var o = void 0;
    try {
      o = Wg(t.extensions, "Extensions map");
    } catch (f) {
      return { parseError: f };
    }
    r("extensions", o);
  }
  var a = "", s = e, l = e.indexOf("#");
  l !== -1 && (a = e.substr(l), s = e.substr(0, l));
  var u = s.indexOf("?") === -1 ? "?" : "&", c = s + u + n.join("&") + a;
  return { newURI: c };
}
var zS = Ur(function() {
  return fetch;
}), Ote = function(e) {
  e === void 0 && (e = {});
  var t = e.uri, n = t === void 0 ? "/graphql" : t, r = e.fetch, i = e.print, o = i === void 0 ? bte : i, a = e.includeExtensions, s = e.preserveHeaderCase, l = e.useGETForQueries, u = e.includeUnusedVariables, c = u === void 0 ? !1 : u, f = Fi(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && xte(r || zS);
  var d = {
    http: { includeExtensions: a, preserveHeaderCase: s },
    options: f.fetchOptions,
    credentials: f.credentials,
    headers: f.headers
  };
  return new Bo(function(p) {
    var h = Ete(p, n), v = p.getContext(), m = {};
    if (v.clientAwareness) {
      var g = v.clientAwareness, y = g.name, w = g.version;
      y && (m["apollographql-client-name"] = y), w && (m["apollographql-client-version"] = w);
    }
    var x = G(G({}, m), v.headers), S = {
      http: v.http,
      options: v.fetchOptions,
      credentials: v.credentials,
      headers: x
    };
    if (Wu(["client"], p.query)) {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Oe.warn(52);
      var O = RC(p.query);
      if (!O)
        return Av(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      p.query = O;
    }
    var P = _te(p, o, yte, d, S), b = P.options, _ = P.body;
    _.variables && !c && (_.variables = Jee(_.variables, p.query));
    var E;
    !b.signal && typeof AbortController < "u" && (E = new AbortController(), b.signal = E.signal);
    var A = function(Q) {
      return Q.kind === "OperationDefinition" && Q.operation === "mutation";
    }, k = function(Q) {
      return Q.kind === "OperationDefinition" && Q.operation === "subscription";
    }, R = k($c(p.query)), N = Wu(["defer"], p.query);
    if (l && !p.query.definitions.some(A) && (b.method = "GET"), N || R) {
      b.headers = b.headers || {};
      var U = "multipart/mixed;";
      R && N && globalThis.__DEV__ !== !1 && Oe.warn(53), R ? U += "boundary=graphql;subscriptionSpec=1.0,application/json" : N && (U += "deferSpec=20220824,application/json"), b.headers.accept = U;
    }
    if (b.method === "GET") {
      var H = Ste(h, _), ee = H.newURI, ue = H.parseError;
      if (ue)
        return Av(ue);
      h = ee;
    } else
      try {
        b.body = Wg(_, "Payload");
      } catch (Q) {
        return Av(Q);
      }
    return new yt(function(Q) {
      var $ = r || Ur(function() {
        return fetch;
      }) || zS, F = Q.next.bind(Q);
      return $(h, b).then(function(I) {
        var L;
        p.setContext({ response: I });
        var K = (L = I.headers) === null || L === void 0 ? void 0 : L.get("content-type");
        return K !== null && /^multipart\/mixed/i.test(K) ? fte(I, F) : hte(p)(I).then(F);
      }).then(function() {
        E = void 0, Q.complete();
      }).catch(function(I) {
        E = void 0, pte(I, Q);
      }), function() {
        E && E.abort();
      };
    });
  });
}, $te = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this, Ote(n).request) || this;
      return r.options = n, r;
    }
    return t;
  })(Bo)
);
const { toString: LS, hasOwnProperty: Tte } = Object.prototype, VS = Function.prototype.toString, Zg = /* @__PURE__ */ new Map();
function _t(e, t) {
  try {
    return Gg(e, t);
  } finally {
    Zg.clear();
  }
}
function Gg(e, t) {
  if (e === t)
    return !0;
  const n = LS.call(e), r = LS.call(t);
  if (n !== r)
    return !1;
  switch (n) {
    case "[object Array]":
      if (e.length !== t.length)
        return !1;
    // Fall through to object case...
    case "[object Object]": {
      if (US(e, t))
        return !0;
      const i = BS(e), o = BS(t), a = i.length;
      if (a !== o.length)
        return !1;
      for (let s = 0; s < a; ++s)
        if (!Tte.call(t, i[s]))
          return !1;
      for (let s = 0; s < a; ++s) {
        const l = i[s];
        if (!Gg(e[l], t[l]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return e.name === t.name && e.message === t.message;
    case "[object Number]":
      if (e !== e)
        return t !== t;
    // Fall through to shared +a === +b case...
    case "[object Boolean]":
    case "[object Date]":
      return +e == +t;
    case "[object RegExp]":
    case "[object String]":
      return e == `${t}`;
    case "[object Map]":
    case "[object Set]": {
      if (e.size !== t.size)
        return !1;
      if (US(e, t))
        return !0;
      const i = e.entries(), o = n === "[object Map]";
      for (; ; ) {
        const a = i.next();
        if (a.done)
          break;
        const [s, l] = a.value;
        if (!t.has(s) || o && !Gg(l, t.get(s)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    // Buffer, in Node.js.
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      e = new Uint8Array(e), t = new Uint8Array(t);
    // Fall through...
    case "[object DataView]": {
      let i = e.byteLength;
      if (i === t.byteLength)
        for (; i-- && e[i] === t[i]; )
          ;
      return i === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const i = VS.call(e);
      return i !== VS.call(t) ? !1 : !Dte(i, Pte);
    }
  }
  return !1;
}
function BS(e) {
  return Object.keys(e).filter(kte, e);
}
function kte(e) {
  return this[e] !== void 0;
}
const Pte = "{ [native code] }";
function Dte(e, t) {
  const n = e.length - t.length;
  return n >= 0 && e.indexOf(t, n) === n;
}
function US(e, t) {
  let n = Zg.get(e);
  if (n) {
    if (n.has(t))
      return !0;
  } else
    Zg.set(e, n = /* @__PURE__ */ new Set());
  return n.add(t), !1;
}
function qC(e, t, n, r) {
  var i = t.data, o = Fi(t, ["data"]), a = n.data, s = Fi(n, ["data"]);
  return _t(o, s) && jf($c(e).selectionSet, i, a, {
    fragmentMap: _l(xl(e)),
    variables: r
  });
}
function jf(e, t, n, r) {
  if (t === n)
    return !0;
  var i = /* @__PURE__ */ new Set();
  return e.selections.every(function(o) {
    if (i.has(o) || (i.add(o), !Oc(o, r.variables)) || KS(o))
      return !0;
    if (Ao(o)) {
      var a = Gi(o), s = t && t[a], l = n && n[a], u = o.selectionSet;
      if (!u)
        return _t(s, l);
      var c = Array.isArray(s), f = Array.isArray(l);
      if (c !== f)
        return !1;
      if (c && f) {
        var d = s.length;
        if (l.length !== d)
          return !1;
        for (var p = 0; p < d; ++p)
          if (!jf(u, s[p], l[p], r))
            return !1;
        return !0;
      }
      return jf(u, s, l, r);
    } else {
      var h = Qp(o, r.fragmentMap);
      if (h)
        return KS(h) ? !0 : jf(
          h.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          t,
          n,
          r
        );
    }
  });
}
function KS(e) {
  return !!e.directives && e.directives.some(Ate);
}
function Ate(e) {
  return e.name.value === "nonreactive";
}
var HC = Ba ? WeakMap : Map, WC = I0 ? WeakSet : Set, K0 = new El(), qS = !1;
function ZC() {
  qS || (qS = !0, globalThis.__DEV__ !== !1 && Oe.warn(64));
}
function GC(e, t, n) {
  return K0.withValue(!0, function() {
    var r = Ql(e, t, n, !1);
    return Object.isFrozen(e) && Ld(r), r;
  });
}
function Cte(e, t) {
  if (t.has(e))
    return t.get(e);
  var n = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
  return t.set(e, n), n;
}
function Ql(e, t, n, r, i) {
  var o, a = n.knownChanged, s = Cte(e, n.mutableTargets);
  if (Array.isArray(e)) {
    for (var l = 0, u = Array.from(e.entries()); l < u.length; l++) {
      var c = u[l], f = c[0], d = c[1];
      if (d === null) {
        s[f] = null;
        continue;
      }
      var p = Ql(d, t, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(f, "]") : void 0);
      a.has(p) && a.add(s), s[f] = p;
    }
    return a.has(s) ? s : e;
  }
  for (var h = 0, v = t.selections; h < v.length; h++) {
    var m = v[h], g = void 0;
    if (r && a.add(s), m.kind === Vt.FIELD) {
      var y = Gi(m), w = m.selectionSet;
      if (g = s[y] || e[y], g === void 0)
        continue;
      if (w && g !== null) {
        var p = Ql(e[y], w, n, r, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(y) : void 0);
        a.has(p) && (g = p);
      }
      globalThis.__DEV__ === !1 && (s[y] = g), globalThis.__DEV__ !== !1 && (r && y !== "__typename" && // either the field is not present in the memo object
      // or it has a `get` descriptor, not a `value` descriptor
      // => it is a warning accessor and we can overwrite it
      // with another accessor
      !(!((o = Object.getOwnPropertyDescriptor(s, y)) === null || o === void 0) && o.value) ? Object.defineProperty(s, y, Ite(y, g, i || "", n.operationName, n.operationType)) : (delete s[y], s[y] = g));
    }
    if (m.kind === Vt.INLINE_FRAGMENT && (!m.typeCondition || n.cache.fragmentMatches(m, e.__typename)) && (g = Ql(e, m.selectionSet, n, r, i)), m.kind === Vt.FRAGMENT_SPREAD) {
      var x = m.name.value, S = n.fragmentMap[x] || (n.fragmentMap[x] = n.cache.lookupFragment(x));
      Oe(S, 59, x);
      var O = DX(m);
      O !== "mask" && (g = Ql(e, S.selectionSet, n, O === "migrate", i));
    }
    a.has(g) && a.add(s);
  }
  return "__typename" in e && !("__typename" in s) && (s.__typename = e.__typename), Object.keys(s).length !== Object.keys(e).length && a.add(s), a.has(s) ? s : e;
}
function Ite(e, t, n, r, i) {
  var o = function() {
    return K0.getValue() || (globalThis.__DEV__ !== !1 && Oe.warn(60, r ? "".concat(i, " '").concat(r, "'") : "anonymous ".concat(i), "".concat(n, ".").concat(e).replace(/^\./, "")), o = function() {
      return t;
    }), t;
  };
  return {
    get: function() {
      return o();
    },
    set: function(a) {
      o = function() {
        return a;
      };
    },
    enumerable: !0,
    configurable: !0
  };
}
function YC(e, t, n, r) {
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && ZC(), e;
  var i = t.definitions.filter(function(a) {
    return a.kind === Vt.FRAGMENT_DEFINITION;
  });
  typeof r > "u" && (Oe(i.length === 1, 61, i.length), r = i[0].name.value);
  var o = i.find(function(a) {
    return a.name.value === r;
  });
  return Oe(!!o, 62, r), e == null || _t(e, {}) ? e : GC(e, o.selectionSet, {
    operationType: "fragment",
    operationName: o.name.value,
    fragmentMap: _l(xl(t)),
    cache: n,
    mutableTargets: new HC(),
    knownChanged: new WC()
  });
}
function Nte(e, t, n) {
  var r;
  if (!n.fragmentMatches)
    return globalThis.__DEV__ !== !1 && ZC(), e;
  var i = Oa(t);
  return Oe(i, 63), e == null ? e : GC(e, i.selectionSet, {
    operationType: i.operation,
    operationName: (r = i.name) === null || r === void 0 ? void 0 : r.value,
    fragmentMap: _l(xl(t)),
    cache: n,
    mutableTargets: new HC(),
    knownChanged: new WC()
  });
}
var QC = (
  /** @class */
  (function() {
    function e() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Gu(MX, {
        max: Zi["cache.fragmentQueryDocuments"] || 1e3,
        cache: Fd
      });
    }
    return e.prototype.lookupFragment = function(t) {
      return null;
    }, e.prototype.batch = function(t) {
      var n = this, r = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
      return this.performTransaction(function() {
        return i = t.update(n);
      }, r), i;
    }, e.prototype.recordOptimisticTransaction = function(t, n) {
      this.performTransaction(t, n);
    }, e.prototype.transformDocument = function(t) {
      return t;
    }, e.prototype.transformForLink = function(t) {
      return t;
    }, e.prototype.identify = function(t) {
    }, e.prototype.gc = function() {
      return [];
    }, e.prototype.modify = function(t) {
      return !1;
    }, e.prototype.readQuery = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && Gt(t, "canonizeResults", "cache.readQuery"), wn("canonizeResults", function() {
        return r.read(G(G({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: n }));
      });
    }, e.prototype.watchFragment = function(t) {
      var n = this, r = t.fragment, i = t.fragmentName, o = t.from, a = t.optimistic, s = a === void 0 ? !0 : a, l = Fi(t, ["fragment", "fragmentName", "from", "optimistic"]), u = this.getFragmentDoc(r, i), c = typeof o > "u" || typeof o == "string" ? o : this.identify(o), f = !!t[Symbol.for("apollo.dataMasking")];
      if (globalThis.__DEV__ !== !1) {
        var d = i || _C(r).name.value;
        c || globalThis.__DEV__ !== !1 && Oe.warn(1, d);
      }
      var p = G(G({}, l), { returnPartialData: !0, id: c, query: u, optimistic: s }), h;
      return new yt(function(v) {
        return n.watch(G(G({}, p), { immediate: !0, callback: function(m) {
          var g = f ? YC(m.result, r, n, i) : m.result;
          if (
            // Always ensure we deliver the first result
            !(h && qC(
              u,
              { data: h.result },
              { data: g },
              // TODO: Fix the type on WatchFragmentOptions so that TVars
              // extends OperationVariables
              t.variables
            ))
          ) {
            var y = {
              data: g,
              complete: !!m.complete
            };
            m.missing && (y.missing = th(m.missing.map(function(w) {
              return w.missing;
            }))), h = G(G({}, m), { result: g }), v.next(y);
          }
        } }));
      });
    }, e.prototype.readFragment = function(t, n) {
      var r = this;
      return n === void 0 && (n = !!t.optimistic), globalThis.__DEV__ !== !1 && Gt(t, "canonizeResults", "cache.readFragment"), wn("canonizeResults", function() {
        return r.read(G(G({}, t), { query: r.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: n }));
      });
    }, e.prototype.writeQuery = function(t) {
      var n = t.id, r = t.data, i = Fi(t, ["id", "data"]);
      return this.write(Object.assign(i, {
        dataId: n || "ROOT_QUERY",
        result: r
      }));
    }, e.prototype.writeFragment = function(t) {
      var n = t.id, r = t.data, i = t.fragment, o = t.fragmentName, a = Fi(t, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(a, {
        query: this.getFragmentDoc(i, o),
        dataId: n,
        result: r
      }));
    }, e.prototype.updateQuery = function(t, n) {
      return globalThis.__DEV__ !== !1 && Gt(t, "canonizeResults", "cache.updateQuery"), this.batch({
        update: function(r) {
          var i = wn("canonizeResults", function() {
            return r.readQuery(t);
          }), o = n(i);
          return o == null ? i : (r.writeQuery(G(G({}, t), { data: o })), o);
        }
      });
    }, e.prototype.updateFragment = function(t, n) {
      return globalThis.__DEV__ !== !1 && Gt(t, "canonizeResults", "cache.updateFragment"), this.batch({
        update: function(r) {
          var i = wn("canonizeResults", function() {
            return r.readFragment(t);
          }), o = n(i);
          return o == null ? i : (r.writeFragment(G(G({}, t), { data: o })), o);
        }
      });
    }, e;
  })()
);
globalThis.__DEV__ !== !1 && (QC.prototype.getMemoryInternals = ZX);
var JC = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n, r, i, o) {
      var a, s = e.call(this, n) || this;
      if (s.message = n, s.path = r, s.query = i, s.variables = o, Array.isArray(s.path)) {
        s.missing = s.message;
        for (var l = s.path.length - 1; l >= 0; --l)
          s.missing = (a = {}, a[s.path[l]] = s.missing, a);
      } else
        s.missing = s.path;
      return s.__proto__ = t.prototype, s;
    }
    return t;
  })(Error)
), cn = Object.prototype.hasOwnProperty;
function Ll(e) {
  return e == null;
}
function XC(e, t) {
  var n = e.__typename, r = e.id, i = e._id;
  if (typeof n == "string" && (t && (t.keyObject = Ll(r) ? Ll(i) ? void 0 : { _id: i } : { id: r }), Ll(r) && !Ll(i) && (r = i), !Ll(r)))
    return "".concat(n, ":").concat(typeof r == "number" || typeof r == "string" ? r : JSON.stringify(r));
}
var e3 = {
  dataIdFromObject: XC,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function Rte(e) {
  return Gs(e3, e);
}
function t3(e) {
  var t = e.canonizeResults;
  return t === void 0 ? e3.canonizeResults : t;
}
function Mte(e, t) {
  return pt(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
}
var n3 = /^[_a-z][_0-9a-z]*/i;
function No(e) {
  var t = e.match(n3);
  return t ? t[0] : e;
}
function Yg(e, t, n) {
  return Nt(t) ? Ht(t) ? t.every(function(r) {
    return Yg(e, r, n);
  }) : e.selections.every(function(r) {
    if (Ao(r) && Oc(r, n)) {
      var i = Gi(r);
      return cn.call(t, i) && (!r.selectionSet || Yg(r.selectionSet, t[i], n));
    }
    return !0;
  }) : !1;
}
function ps(e) {
  return Nt(e) && !pt(e) && !Ht(e);
}
function jte() {
  return new Io();
}
function r3(e, t) {
  var n = _l(xl(e));
  return {
    fragmentMap: n,
    lookupFragment: function(r) {
      var i = n[r];
      return !i && t && (i = t.lookup(r)), i || null;
    }
  };
}
var Ff = /* @__PURE__ */ Object.create(null), Cv = function() {
  return Ff;
}, HS = /* @__PURE__ */ Object.create(null), Yu = (
  /** @class */
  (function() {
    function e(t, n) {
      var r = this;
      this.policies = t, this.group = n, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
        return Ld(pt(i) ? r.get(i.__ref, o) : i && i[o]);
      }, this.canRead = function(i) {
        return pt(i) ? r.has(i.__ref) : typeof i == "object";
      }, this.toReference = function(i, o) {
        if (typeof i == "string")
          return Ss(i);
        if (pt(i))
          return i;
        var a = r.policies.identify(i)[0];
        if (a) {
          var s = Ss(a);
          return o && r.merge(a, i), s;
        }
      };
    }
    return e.prototype.toObject = function() {
      return G({}, this.data);
    }, e.prototype.has = function(t) {
      return this.lookup(t, !0) !== void 0;
    }, e.prototype.get = function(t, n) {
      if (this.group.depend(t, n), cn.call(this.data, t)) {
        var r = this.data[t];
        if (r && cn.call(r, n))
          return r[n];
      }
      if (n === "__typename" && cn.call(this.policies.rootTypenamesById, t))
        return this.policies.rootTypenamesById[t];
      if (this instanceof oo)
        return this.parent.get(t, n);
    }, e.prototype.lookup = function(t, n) {
      if (n && this.group.depend(t, "__exists"), cn.call(this.data, t))
        return this.data[t];
      if (this instanceof oo)
        return this.parent.lookup(t, n);
      if (this.policies.rootTypenamesById[t])
        return /* @__PURE__ */ Object.create(null);
    }, e.prototype.merge = function(t, n) {
      var r = this, i;
      pt(t) && (t = t.__ref), pt(n) && (n = n.__ref);
      var o = typeof t == "string" ? this.lookup(i = t) : t, a = typeof n == "string" ? this.lookup(i = n) : n;
      if (a) {
        Oe(typeof i == "string", 2);
        var s = new Io(zte).merge(o, a);
        if (this.data[i] = s, s !== o && (delete this.refs[i], this.group.caching)) {
          var l = /* @__PURE__ */ Object.create(null);
          o || (l.__exists = 1), Object.keys(a).forEach(function(u) {
            if (!o || o[u] !== s[u]) {
              l[u] = 1;
              var c = No(u);
              c !== u && !r.policies.hasKeyArgs(s.__typename, c) && (l[c] = 1), s[u] === void 0 && !(r instanceof oo) && delete s[u];
            }
          }), l.__typename && !(o && o.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[i] === s.__typename && delete l.__typename, Object.keys(l).forEach(function(u) {
            return r.group.dirty(i, u);
          });
        }
      }
    }, e.prototype.modify = function(t, n) {
      var r = this, i = this.lookup(t);
      if (i) {
        var o = /* @__PURE__ */ Object.create(null), a = !1, s = !0, l = {
          DELETE: Ff,
          INVALIDATE: HS,
          isReference: pt,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(u, c) {
            return r.policies.readField(typeof u == "string" ? {
              fieldName: u,
              from: c || Ss(t)
            } : u, { store: r });
          }
        };
        if (Object.keys(i).forEach(function(u) {
          var c = No(u), f = i[u];
          if (f !== void 0) {
            var d = typeof n == "function" ? n : n[u] || n[c];
            if (d) {
              var p = d === Cv ? Ff : d(Ld(f), G(G({}, l), { fieldName: c, storeFieldName: u, storage: r.getStorage(t, u) }));
              if (p === HS)
                r.group.dirty(t, u);
              else if (p === Ff && (p = void 0), p !== f && (o[u] = p, a = !0, f = p, globalThis.__DEV__ !== !1)) {
                var h = function(S) {
                  if (r.lookup(S.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && Oe.warn(3, S), !0;
                };
                if (pt(p))
                  h(p);
                else if (Array.isArray(p))
                  for (var v = !1, m = void 0, g = 0, y = p; g < y.length; g++) {
                    var w = y[g];
                    if (pt(w)) {
                      if (v = !0, h(w))
                        break;
                    } else if (typeof w == "object" && w) {
                      var x = r.policies.identify(w)[0];
                      x && (m = w);
                    }
                    if (v && m !== void 0) {
                      globalThis.__DEV__ !== !1 && Oe.warn(4, m);
                      break;
                    }
                  }
              }
            }
            f !== void 0 && (s = !1);
          }
        }), a)
          return this.merge(t, o), s && (this instanceof oo ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
      }
      return !1;
    }, e.prototype.delete = function(t, n, r) {
      var i, o = this.lookup(t);
      if (o) {
        var a = this.getFieldValue(o, "__typename"), s = n && r ? this.policies.getStoreFieldName({ typename: a, fieldName: n, args: r }) : n;
        return this.modify(t, s ? (i = {}, i[s] = Cv, i) : Cv);
      }
      return !1;
    }, e.prototype.evict = function(t, n) {
      var r = !1;
      return t.id && (cn.call(this.data, t.id) && (r = this.delete(t.id, t.fieldName, t.args)), this instanceof oo && this !== n && (r = this.parent.evict(t, n) || r), (t.fieldName || r) && this.group.dirty(t.id, t.fieldName || "__exists")), r;
    }, e.prototype.clear = function() {
      this.replace(null);
    }, e.prototype.extract = function() {
      var t = this, n = this.toObject(), r = [];
      return this.getRootIdSet().forEach(function(i) {
        cn.call(t.policies.rootTypenamesById, i) || r.push(i);
      }), r.length && (n.__META = { extraRootIds: r.sort() }), n;
    }, e.prototype.replace = function(t) {
      var n = this;
      if (Object.keys(this.data).forEach(function(o) {
        t && cn.call(t, o) || n.delete(o);
      }), t) {
        var r = t.__META, i = Fi(t, ["__META"]);
        Object.keys(i).forEach(function(o) {
          n.merge(o, i[o]);
        }), r && r.extraRootIds.forEach(this.retain, this);
      }
    }, e.prototype.retain = function(t) {
      return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
    }, e.prototype.release = function(t) {
      if (this.rootIds[t] > 0) {
        var n = --this.rootIds[t];
        return n || delete this.rootIds[t], n;
      }
      return 0;
    }, e.prototype.getRootIdSet = function(t) {
      return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof oo ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
    }, e.prototype.gc = function() {
      var t = this, n = this.getRootIdSet(), r = this.toObject();
      n.forEach(function(a) {
        cn.call(r, a) && (Object.keys(t.findChildRefIds(a)).forEach(n.add, n), delete r[a]);
      });
      var i = Object.keys(r);
      if (i.length) {
        for (var o = this; o instanceof oo; )
          o = o.parent;
        i.forEach(function(a) {
          return o.delete(a);
        });
      }
      return i;
    }, e.prototype.findChildRefIds = function(t) {
      if (!cn.call(this.refs, t)) {
        var n = this.refs[t] = /* @__PURE__ */ Object.create(null), r = this.data[t];
        if (!r)
          return n;
        var i = /* @__PURE__ */ new Set([r]);
        i.forEach(function(o) {
          pt(o) && (n[o.__ref] = !0), Nt(o) && Object.keys(o).forEach(function(a) {
            var s = o[a];
            Nt(s) && i.add(s);
          });
        });
      }
      return this.refs[t];
    }, e.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, e;
  })()
), i3 = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = null), this.caching = t, this.parent = n, this.d = null, this.resetCaching();
    }
    return e.prototype.resetCaching = function() {
      this.d = this.caching ? AC() : null, this.keyMaker = new Ji(Ba);
    }, e.prototype.depend = function(t, n) {
      if (this.d) {
        this.d(Iv(t, n));
        var r = No(n);
        r !== n && this.d(Iv(t, r)), this.parent && this.parent.depend(t, n);
      }
    }, e.prototype.dirty = function(t, n) {
      this.d && this.d.dirty(
        Iv(t, n),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        n === "__exists" ? "forget" : "setDirty"
      );
    }, e;
  })()
);
function Iv(e, t) {
  return t + "#" + e;
}
function WS(e, t) {
  gu(e) && e.group.depend(t, "__exists");
}
(function(e) {
  var t = (
    /** @class */
    (function(n) {
      ai(r, n);
      function r(i) {
        var o = i.policies, a = i.resultCaching, s = a === void 0 ? !0 : a, l = i.seed, u = n.call(this, o, new i3(s)) || this;
        return u.stump = new Fte(u), u.storageTrie = new Ji(Ba), l && u.replace(l), u;
      }
      return r.prototype.addLayer = function(i, o) {
        return this.stump.addLayer(i, o);
      }, r.prototype.removeLayer = function() {
        return this;
      }, r.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, r;
    })(e)
  );
  e.Root = t;
})(Yu || (Yu = {}));
var oo = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n, r, i, o) {
      var a = e.call(this, r.policies, o) || this;
      return a.id = n, a.parent = r, a.replay = i, a.group = o, i(a), a;
    }
    return t.prototype.addLayer = function(n, r) {
      return new t(n, this, r, this.group);
    }, t.prototype.removeLayer = function(n) {
      var r = this, i = this.parent.removeLayer(n);
      return n === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
        var a = r.data[o], s = i.lookup(o);
        s ? a ? a !== s && Object.keys(a).forEach(function(l) {
          _t(a[l], s[l]) || r.group.dirty(o, l);
        }) : (r.group.dirty(o, "__exists"), Object.keys(s).forEach(function(l) {
          r.group.dirty(o, l);
        })) : r.delete(o);
      }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
    }, t.prototype.toObject = function() {
      return G(G({}, this.parent.toObject()), this.data);
    }, t.prototype.findChildRefIds = function(n) {
      var r = this.parent.findChildRefIds(n);
      return cn.call(this.data, n) ? G(G({}, r), e.prototype.findChildRefIds.call(this, n)) : r;
    }, t.prototype.getStorage = function() {
      for (var n = this.parent; n.parent; )
        n = n.parent;
      return n.getStorage.apply(
        n,
        // @ts-expect-error
        arguments
      );
    }, t;
  })(Yu)
), Fte = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n) {
      return e.call(this, "EntityStore.Stump", n, function() {
      }, new i3(n.group.caching, n.group)) || this;
    }
    return t.prototype.removeLayer = function() {
      return this;
    }, t.prototype.merge = function(n, r) {
      return this.parent.merge(n, r);
    }, t;
  })(oo)
);
function zte(e, t, n) {
  var r = e[n], i = t[n];
  return _t(r, i) ? r : i;
}
function gu(e) {
  return !!(e instanceof Yu && e.group.caching);
}
function Lte(e) {
  return Nt(e) ? Ht(e) ? e.slice(0) : G({ __proto__: Object.getPrototypeOf(e) }, e) : e;
}
var ZS = (
  /** @class */
  (function() {
    function e() {
      this.known = new (I0 ? WeakSet : Set)(), this.pool = new Ji(Ba), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return e.prototype.isKnown = function(t) {
      return Nt(t) && this.known.has(t);
    }, e.prototype.pass = function(t) {
      if (Nt(t)) {
        var n = Lte(t);
        return this.passes.set(n, t), n;
      }
      return t;
    }, e.prototype.admit = function(t) {
      var n = this;
      if (Nt(t)) {
        var r = this.passes.get(t);
        if (r)
          return r;
        var i = Object.getPrototypeOf(t);
        switch (i) {
          case Array.prototype: {
            if (this.known.has(t))
              return t;
            var o = t.map(this.admit, this), a = this.pool.lookupArray(o);
            return a.array || (this.known.add(a.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), a.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(t))
              return t;
            var s = Object.getPrototypeOf(t), l = [s], u = this.sortedKeys(t);
            l.push(u.json);
            var c = l.length;
            u.sorted.forEach(function(p) {
              l.push(n.admit(t[p]));
            });
            var a = this.pool.lookupArray(l);
            if (!a.object) {
              var f = a.object = Object.create(s);
              this.known.add(f), u.sorted.forEach(function(p, h) {
                f[p] = l[c + h];
              }), globalThis.__DEV__ !== !1 && Object.freeze(f);
            }
            return a.object;
          }
        }
      }
      return t;
    }, e.prototype.sortedKeys = function(t) {
      var n = Object.keys(t), r = this.pool.lookupArray(n);
      if (!r.keys) {
        n.sort();
        var i = JSON.stringify(n);
        (r.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, r.keys = { sorted: n, json: i });
      }
      return r.keys;
    }, e;
  })()
);
function GS(e) {
  return [
    e.selectionSet,
    e.objectOrReference,
    e.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    e.context.canonizeResults
  ];
}
var Vte = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.knownResults = new (Ba ? WeakMap : Map)(), this.config = Gs(t, {
        addTypename: t.addTypename !== !1,
        canonizeResults: t3(t)
      }), this.canon = t.canon || new ZS(), this.executeSelectionSet = Gu(function(r) {
        var i, o = r.context.canonizeResults, a = GS(r);
        a[3] = !o;
        var s = (i = n.executeSelectionSet).peek.apply(i, a);
        return s ? o ? G(G({}, s), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: n.canon.admit(s.result)
        }) : s : (WS(r.context.store, r.enclosingRef.__ref), n.execSelectionSetImpl(r));
      }, {
        max: this.config.resultCacheMaxSize || Zi["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: GS,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(r, i, o, a) {
          if (gu(o.store))
            return o.store.makeCacheKey(r, pt(i) ? i.__ref : i, o.varString, a);
        }
      }), this.executeSubSelectedArray = Gu(function(r) {
        return WS(r.context.store, r.enclosingRef.__ref), n.execSubSelectedArrayImpl(r);
      }, {
        max: this.config.resultCacheMaxSize || Zi["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(r) {
          var i = r.field, o = r.array, a = r.context;
          if (gu(a.store))
            return a.store.makeCacheKey(i, o, a.varString);
        }
      });
    }
    return e.prototype.resetCanon = function() {
      this.canon = new ZS();
    }, e.prototype.diffQueryAgainstStore = function(t) {
      var n = t.store, r = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, a = t.variables, s = t.returnPartialData, l = s === void 0 ? !0 : s, u = t.canonizeResults, c = u === void 0 ? this.config.canonizeResults : u, f = this.config.cache.policies;
      a = G(G({}, N0(bC(r))), a);
      var d = Ss(o), p = this.executeSelectionSet({
        selectionSet: $c(r).selectionSet,
        objectOrReference: d,
        enclosingRef: d,
        context: G({ store: n, query: r, policies: f, variables: a, varString: xo(a), canonizeResults: c }, r3(r, this.config.fragments))
      }), h;
      if (p.missing && (h = [
        new JC(Bte(p.missing), p.missing, r, a)
      ], !l))
        throw h[0];
      return {
        result: p.result,
        complete: !h,
        missing: h
      };
    }, e.prototype.isFresh = function(t, n, r, i) {
      if (gu(i.store) && this.knownResults.get(t) === r) {
        var o = this.executeSelectionSet.peek(
          r,
          n,
          i,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(t)
        );
        if (o && t === o.result)
          return !0;
      }
      return !1;
    }, e.prototype.execSelectionSetImpl = function(t) {
      var n = this, r = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, a = t.context;
      if (pt(i) && !a.policies.rootTypenamesById[i.__ref] && !a.store.has(i.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(i.__ref, " object")
        };
      var s = a.variables, l = a.policies, u = a.store, c = u.getFieldValue(i, "__typename"), f = [], d, p = new Io();
      this.config.addTypename && typeof c == "string" && !l.rootIdsByTypename[c] && f.push({ __typename: c });
      function h(w, x) {
        var S;
        return w.missing && (d = p.merge(d, (S = {}, S[x] = w.missing, S))), w.result;
      }
      var v = new Set(r.selections);
      v.forEach(function(w) {
        var x, S;
        if (Oc(w, s))
          if (Ao(w)) {
            var O = l.readField({
              fieldName: w.name.value,
              field: w,
              variables: a.variables,
              from: i
            }, a), P = Gi(w);
            O === void 0 ? F0.added(w) || (d = p.merge(d, (x = {}, x[P] = "Can't find field '".concat(w.name.value, "' on ").concat(pt(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), x))) : Ht(O) ? O.length > 0 && (O = h(n.executeSubSelectedArray({
              field: w,
              array: O,
              enclosingRef: o,
              context: a
            }), P)) : w.selectionSet ? O != null && (O = h(n.executeSelectionSet({
              selectionSet: w.selectionSet,
              objectOrReference: O,
              enclosingRef: pt(O) ? O : o,
              context: a
            }), P)) : a.canonizeResults && (O = n.canon.pass(O)), O !== void 0 && f.push((S = {}, S[P] = O, S));
          } else {
            var b = Qp(w, a.lookupFragment);
            if (!b && w.kind === Vt.FRAGMENT_SPREAD)
              throw jn(10, w.name.value);
            b && l.fragmentMatches(b, c) && b.selectionSet.selections.forEach(v.add, v);
          }
      });
      var m = th(f), g = { result: m, missing: d }, y = a.canonizeResults ? this.canon.admit(g) : Ld(g);
      return y.result && this.knownResults.set(y.result, r), y;
    }, e.prototype.execSubSelectedArrayImpl = function(t) {
      var n = this, r = t.field, i = t.array, o = t.enclosingRef, a = t.context, s, l = new Io();
      function u(c, f) {
        var d;
        return c.missing && (s = l.merge(s, (d = {}, d[f] = c.missing, d))), c.result;
      }
      return r.selectionSet && (i = i.filter(a.store.canRead)), i = i.map(function(c, f) {
        return c === null ? null : Ht(c) ? u(n.executeSubSelectedArray({
          field: r,
          array: c,
          enclosingRef: o,
          context: a
        }), f) : r.selectionSet ? u(n.executeSelectionSet({
          selectionSet: r.selectionSet,
          objectOrReference: c,
          enclosingRef: pt(c) ? c : o,
          context: a
        }), f) : (globalThis.__DEV__ !== !1 && Ute(a.store, r, c), c);
      }), {
        result: a.canonizeResults ? this.canon.admit(i) : i,
        missing: s
      };
    }, e;
  })()
);
function Bte(e) {
  try {
    JSON.stringify(e, function(t, n) {
      if (typeof n == "string")
        throw n;
      return n;
    });
  } catch (t) {
    return t;
  }
}
function Ute(e, t, n) {
  if (!t.selectionSet) {
    var r = /* @__PURE__ */ new Set([n]);
    r.forEach(function(i) {
      Nt(i) && (Oe(
        !pt(i),
        11,
        Mte(e, i),
        t.name.value
      ), Object.values(i).forEach(r.add, r));
    });
  }
}
var q0 = new El(), YS = /* @__PURE__ */ new WeakMap();
function yu(e) {
  var t = YS.get(e);
  return t || YS.set(e, t = {
    vars: /* @__PURE__ */ new Set(),
    dep: AC()
  }), t;
}
function QS(e) {
  yu(e).vars.forEach(function(t) {
    return t.forgetCache(e);
  });
}
function Kte(e) {
  yu(e).vars.forEach(function(t) {
    return t.attachCache(e);
  });
}
function qte(e) {
  var t = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), r = function(o) {
    if (arguments.length > 0) {
      if (e !== o) {
        e = o, t.forEach(function(l) {
          yu(l).dep.dirty(r), Hte(l);
        });
        var a = Array.from(n);
        n.clear(), a.forEach(function(l) {
          return l(e);
        });
      }
    } else {
      var s = q0.getValue();
      s && (i(s), yu(s).dep(r));
    }
    return e;
  };
  r.onNextChange = function(o) {
    return n.add(o), function() {
      n.delete(o);
    };
  };
  var i = r.attachCache = function(o) {
    return t.add(o), yu(o).vars.add(r), r;
  };
  return r.forgetCache = function(o) {
    return t.delete(o);
  }, r;
}
function Hte(e) {
  e.broadcastWatches && e.broadcastWatches();
}
var JS = /* @__PURE__ */ Object.create(null);
function H0(e) {
  var t = JSON.stringify(e);
  return JS[t] || (JS[t] = /* @__PURE__ */ Object.create(null));
}
function XS(e) {
  var t = H0(e);
  return t.keyFieldsFn || (t.keyFieldsFn = function(n, r) {
    var i = function(a, s) {
      return r.readField(s, a);
    }, o = r.keyObject = W0(e, function(a) {
      var s = $s(
        r.storeObject,
        a,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        i
      );
      return s === void 0 && n !== r.storeObject && cn.call(n, a[0]) && (s = $s(n, a, a3)), Oe(s !== void 0, 5, a.join("."), n), s;
    });
    return "".concat(r.typename, ":").concat(JSON.stringify(o));
  });
}
function e2(e) {
  var t = H0(e);
  return t.keyArgsFn || (t.keyArgsFn = function(n, r) {
    var i = r.field, o = r.variables, a = r.fieldName, s = W0(e, function(u) {
      var c = u[0], f = c.charAt(0);
      if (f === "@") {
        if (i && Oi(i.directives)) {
          var d = c.slice(1), p = i.directives.find(function(g) {
            return g.name.value === d;
          }), h = p && Jp(p, o);
          return h && $s(
            h,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            u.slice(1)
          );
        }
        return;
      }
      if (f === "$") {
        var v = c.slice(1);
        if (o && cn.call(o, v)) {
          var m = u.slice(0);
          return m[0] = v, $s(o, m);
        }
        return;
      }
      if (n)
        return $s(n, u);
    }), l = JSON.stringify(s);
    return (n || l !== "{}") && (a += ":" + l), a;
  });
}
function W0(e, t) {
  var n = new Io();
  return o3(e).reduce(function(r, i) {
    var o, a = t(i);
    if (a !== void 0) {
      for (var s = i.length - 1; s >= 0; --s)
        a = (o = {}, o[i[s]] = a, o);
      r = n.merge(r, a);
    }
    return r;
  }, /* @__PURE__ */ Object.create(null));
}
function o3(e) {
  var t = H0(e);
  if (!t.paths) {
    var n = t.paths = [], r = [];
    e.forEach(function(i, o) {
      Ht(i) ? (o3(i).forEach(function(a) {
        return n.push(r.concat(a));
      }), r.length = 0) : (r.push(i), Ht(e[o + 1]) || (n.push(r.slice(0)), r.length = 0));
    });
  }
  return t.paths;
}
function a3(e, t) {
  return e[t];
}
function $s(e, t, n) {
  return n = n || a3, s3(t.reduce(function r(i, o) {
    return Ht(i) ? i.map(function(a) {
      return r(a, o);
    }) : i && n(i, o);
  }, e));
}
function s3(e) {
  return Nt(e) ? Ht(e) ? e.map(s3) : W0(Object.keys(e).sort(), function(t) {
    return $s(e, t);
  }) : e;
}
function Qg(e) {
  return e.args !== void 0 ? e.args : e.field ? Jp(e.field, e.variables) : null;
}
var Wte = function() {
}, t2 = function(e, t) {
  return t.fieldName;
}, n2 = function(e, t, n) {
  var r = n.mergeObjects;
  return r(e, t);
}, r2 = function(e, t) {
  return t;
}, Zte = (
  /** @class */
  (function() {
    function e(t) {
      this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = G({ dataIdFromObject: XC }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
    }
    return e.prototype.identify = function(t, n) {
      var r, i = this, o = n && (n.typename || ((r = n.storeObject) === null || r === void 0 ? void 0 : r.__typename)) || t.__typename;
      if (o === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      var a = n && n.storeObject || t, s = G(G({}, n), { typename: o, storeObject: a, readField: n && n.readField || function() {
        var f = Z0(arguments, a);
        return i.readField(f, {
          store: i.cache.data,
          variables: f.variables
        });
      } }), l, u = o && this.getTypePolicy(o), c = u && u.keyFn || this.config.dataIdFromObject;
      return K0.withValue(!0, function() {
        for (; c; ) {
          var f = c(G(G({}, t), a), s);
          if (Ht(f))
            c = XS(f);
          else {
            l = f;
            break;
          }
        }
      }), l = l ? String(l) : void 0, s.keyObject ? [l, s.keyObject] : [l];
    }, e.prototype.addTypePolicies = function(t) {
      var n = this;
      Object.keys(t).forEach(function(r) {
        var i = t[r], o = i.queryType, a = i.mutationType, s = i.subscriptionType, l = Fi(i, ["queryType", "mutationType", "subscriptionType"]);
        o && n.setRootTypename("Query", r), a && n.setRootTypename("Mutation", r), s && n.setRootTypename("Subscription", r), cn.call(n.toBeAdded, r) ? n.toBeAdded[r].push(l) : n.toBeAdded[r] = [l];
      });
    }, e.prototype.updateTypePolicy = function(t, n, r) {
      var i = this.getTypePolicy(t), o = n.keyFields, a = n.fields;
      function s(l, u) {
        l.merge = typeof u == "function" ? u : u === !0 ? n2 : u === !1 ? r2 : l.merge;
      }
      s(i, n.merge), i.keyFn = // Pass false to disable normalization for this typename.
      o === !1 ? Wte : Ht(o) ? XS(o) : typeof o == "function" ? o : i.keyFn, a && Object.keys(a).forEach(function(l) {
        var u = r[l];
        (!u || u?.typename !== t) && (u = r[l] = { typename: t });
        var c = a[l];
        if (typeof c == "function")
          u.read = c;
        else {
          var f = c.keyArgs, d = c.read, p = c.merge;
          u.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          f === !1 ? t2 : Ht(f) ? e2(f) : typeof f == "function" ? f : u.keyFn, typeof d == "function" && (u.read = d), s(u, p);
        }
        u.read && u.merge && (u.keyFn = u.keyFn || t2);
      });
    }, e.prototype.setRootTypename = function(t, n) {
      n === void 0 && (n = t);
      var r = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[r];
      n !== i && (Oe(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[n] = r, this.rootTypenamesById[r] = n);
    }, e.prototype.addPossibleTypes = function(t) {
      var n = this;
      this.usingPossibleTypes = !0, Object.keys(t).forEach(function(r) {
        n.getSupertypeSet(r, !0), t[r].forEach(function(i) {
          n.getSupertypeSet(i, !0).add(r);
          var o = i.match(n3);
          (!o || o[0] !== i) && n.fuzzySubtypes.set(i, new RegExp(i));
        });
      });
    }, e.prototype.getTypePolicy = function(t) {
      var n = this;
      if (!cn.call(this.typePolicies, t)) {
        var r = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
        r.fields = /* @__PURE__ */ Object.create(null);
        var i = this.supertypeMap.get(t);
        !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(a, s) {
          if (a.test(t)) {
            var l = n.supertypeMap.get(s);
            l && l.forEach(function(u) {
              return i.add(u);
            });
          }
        })), i && i.size && i.forEach(function(a) {
          var s = n.getTypePolicy(a), l = s.fields, u = Fi(s, ["fields"]);
          Object.assign(r, u), Object.assign(r.fields, l);
        });
      }
      var o = this.toBeAdded[t];
      return o && o.length && o.splice(0).forEach(function(a) {
        n.updateTypePolicy(t, a, n.typePolicies[t].fields);
      }), this.typePolicies[t];
    }, e.prototype.getFieldPolicy = function(t, n) {
      if (t)
        return this.getTypePolicy(t).fields[n];
    }, e.prototype.getSupertypeSet = function(t, n) {
      var r = this.supertypeMap.get(t);
      return !r && n && this.supertypeMap.set(t, r = /* @__PURE__ */ new Set()), r;
    }, e.prototype.fragmentMatches = function(t, n, r, i) {
      var o = this;
      if (!t.typeCondition)
        return !0;
      if (!n)
        return !1;
      var a = t.typeCondition.name.value;
      if (n === a)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(a))
        for (var s = this.getSupertypeSet(n, !0), l = [s], u = function(h) {
          var v = o.getSupertypeSet(h, !1);
          v && v.size && l.indexOf(v) < 0 && l.push(v);
        }, c = !!(r && this.fuzzySubtypes.size), f = !1, d = 0; d < l.length; ++d) {
          var p = l[d];
          if (p.has(a))
            return s.has(a) || (f && globalThis.__DEV__ !== !1 && Oe.warn(7, n, a), s.add(a)), !0;
          p.forEach(u), c && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          d === l.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          Yg(t.selectionSet, r, i) && (c = !1, f = !0, this.fuzzySubtypes.forEach(function(h, v) {
            var m = n.match(h);
            m && m[0] === n && u(v);
          }));
        }
      return !1;
    }, e.prototype.hasKeyArgs = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return !!(r && r.keyFn);
    }, e.prototype.getStoreFieldName = function(t) {
      var n = t.typename, r = t.fieldName, i = this.getFieldPolicy(n, r), o, a = i && i.keyFn;
      if (a && n)
        for (var s = {
          typename: n,
          fieldName: r,
          field: t.field || null,
          variables: t.variables
        }, l = Qg(t); a; ) {
          var u = a(l, s);
          if (Ht(u))
            a = e2(u);
          else {
            o = u || r;
            break;
          }
        }
      return o === void 0 && (o = t.field ? fee(t.field, t.variables) : yC(r, Qg(t))), o === !1 ? r : r === No(o) ? o : r + ":" + o;
    }, e.prototype.readField = function(t, n) {
      var r = t.from;
      if (r) {
        var i = t.field || t.fieldName;
        if (i) {
          if (t.typename === void 0) {
            var o = n.store.getFieldValue(r, "__typename");
            o && (t.typename = o);
          }
          var a = this.getStoreFieldName(t), s = No(a), l = n.store.getFieldValue(r, a), u = this.getFieldPolicy(t.typename, s), c = u && u.read;
          if (c) {
            var f = i2(this, r, t, n, n.store.getStorage(pt(r) ? r.__ref : r, a));
            return q0.withValue(this.cache, c, [
              l,
              f
            ]);
          }
          return l;
        }
      }
    }, e.prototype.getReadFunction = function(t, n) {
      var r = this.getFieldPolicy(t, n);
      return r && r.read;
    }, e.prototype.getMergeFunction = function(t, n, r) {
      var i = this.getFieldPolicy(t, n), o = i && i.merge;
      return !o && r && (i = this.getTypePolicy(r), o = i && i.merge), o;
    }, e.prototype.runMergeFunction = function(t, n, r, i, o) {
      var a = r.field, s = r.typename, l = r.merge;
      return l === n2 ? l3(i.store)(t, n) : l === r2 ? n : (i.overwrite && (t = void 0), l(t, n, i2(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: s,
          fieldName: a.name.value,
          field: a,
          variables: i.variables
        },
        i,
        o || /* @__PURE__ */ Object.create(null)
      )));
    }, e;
  })()
);
function i2(e, t, n, r, i) {
  var o = e.getStoreFieldName(n), a = No(o), s = n.variables || r.variables, l = r.store, u = l.toReference, c = l.canRead;
  return {
    args: Qg(n),
    field: n.field || null,
    fieldName: a,
    storeFieldName: o,
    variables: s,
    isReference: pt,
    toReference: u,
    storage: i,
    cache: e.cache,
    canRead: c,
    readField: function() {
      return e.readField(Z0(arguments, t, s), r);
    },
    mergeObjects: l3(r.store)
  };
}
function Z0(e, t, n) {
  var r = e[0], i = e[1], o = e.length, a;
  return typeof r == "string" ? a = {
    fieldName: r,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: o > 1 ? i : t
  } : (a = G({}, r), cn.call(a, "from") || (a.from = t)), globalThis.__DEV__ !== !1 && a.from === void 0 && globalThis.__DEV__ !== !1 && Oe.warn(8, sC(Array.from(e))), a.variables === void 0 && (a.variables = n), a;
}
function l3(e) {
  return function(t, n) {
    if (Ht(t) || Ht(n))
      throw jn(9);
    if (Nt(t) && Nt(n)) {
      var r = e.getFieldValue(t, "__typename"), i = e.getFieldValue(n, "__typename"), o = r && i && r !== i;
      if (o)
        return n;
      if (pt(t) && ps(n))
        return e.merge(t.__ref, n), t;
      if (ps(t) && pt(n))
        return e.merge(t, n.__ref), n;
      if (ps(t) && ps(n))
        return G(G({}, t), n);
    }
    return n;
  };
}
function Nv(e, t, n) {
  var r = "".concat(t).concat(n), i = e.flavors.get(r);
  return i || e.flavors.set(r, i = e.clientOnly === t && e.deferred === n ? e : G(G({}, e), { clientOnly: t, deferred: n })), i;
}
var Gte = (
  /** @class */
  (function() {
    function e(t, n, r) {
      this.cache = t, this.reader = n, this.fragments = r;
    }
    return e.prototype.writeToStore = function(t, n) {
      var r = this, i = n.query, o = n.result, a = n.dataId, s = n.variables, l = n.overwrite, u = Oa(i), c = jte();
      s = G(G({}, N0(u)), s);
      var f = G(G({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(p, h) {
        return c.merge(p, h);
      }, variables: s, varString: xo(s) }, r3(i, this.fragments)), { overwrite: !!l, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), d = this.processSelectionSet({
        result: o || /* @__PURE__ */ Object.create(null),
        dataId: a,
        selectionSet: u.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: f
      });
      if (!pt(d))
        throw jn(12, o);
      return f.incomingById.forEach(function(p, h) {
        var v = p.storeObject, m = p.mergeTree, g = p.fieldNodeSet, y = Ss(h);
        if (m && m.map.size) {
          var w = r.applyMerges(m, y, v, f);
          if (pt(w))
            return;
          v = w;
        }
        if (globalThis.__DEV__ !== !1 && !f.overwrite) {
          var x = /* @__PURE__ */ Object.create(null);
          g.forEach(function(P) {
            P.selectionSet && (x[P.name.value] = !0);
          });
          var S = function(P) {
            return x[No(P)] === !0;
          }, O = function(P) {
            var b = m && m.map.get(P);
            return !!(b && b.info && b.info.merge);
          };
          Object.keys(v).forEach(function(P) {
            S(P) && !O(P) && Yte(y, v, P, f.store);
          });
        }
        t.merge(h, v);
      }), t.retain(d.__ref), d;
    }, e.prototype.processSelectionSet = function(t) {
      var n = this, r = t.dataId, i = t.result, o = t.selectionSet, a = t.context, s = t.mergeTree, l = this.cache.policies, u = /* @__PURE__ */ Object.create(null), c = r && l.rootTypenamesById[r] || zg(i, o, a.fragmentMap) || r && a.store.get(r, "__typename");
      typeof c == "string" && (u.__typename = c);
      var f = function() {
        var w = Z0(arguments, u, a.variables);
        if (pt(w.from)) {
          var x = a.incomingById.get(w.from.__ref);
          if (x) {
            var S = l.readField(G(G({}, w), { from: x.storeObject }), a);
            if (S !== void 0)
              return S;
          }
        }
        return l.readField(w, a);
      }, d = /* @__PURE__ */ new Set();
      this.flattenFields(
        o,
        i,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        a,
        c
      ).forEach(function(w, x) {
        var S, O = Gi(x), P = i[O];
        if (d.add(x), P !== void 0) {
          var b = l.getStoreFieldName({
            typename: c,
            fieldName: x.name.value,
            field: x,
            variables: w.variables
          }), _ = o2(s, b), E = n.processFieldValue(
            P,
            x,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            x.selectionSet ? Nv(w, !1, !1) : w,
            _
          ), A = void 0;
          x.selectionSet && (pt(E) || ps(E)) && (A = f("__typename", E));
          var k = l.getMergeFunction(c, x.name.value, A);
          k ? _.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: x,
            typename: c,
            merge: k
          } : a2(s, b), u = w.merge(u, (S = {}, S[b] = E, S));
        } else globalThis.__DEV__ !== !1 && !w.clientOnly && !w.deferred && !F0.added(x) && // If the field has a read function, it may be a synthetic field or
        // provide a default value, so its absence from the written data should
        // not be cause for alarm.
        !l.getReadFunction(c, x.name.value) && globalThis.__DEV__ !== !1 && Oe.error(13, Gi(x), i);
      });
      try {
        var p = l.identify(i, {
          typename: c,
          selectionSet: o,
          fragmentMap: a.fragmentMap,
          storeObject: u,
          readField: f
        }), h = p[0], v = p[1];
        r = r || h, v && (u = a.merge(u, v));
      } catch (w) {
        if (!r)
          throw w;
      }
      if (typeof r == "string") {
        var m = Ss(r), g = a.written[r] || (a.written[r] = []);
        if (g.indexOf(o) >= 0 || (g.push(o), this.reader && this.reader.isFresh(i, m, o, a)))
          return m;
        var y = a.incomingById.get(r);
        return y ? (y.storeObject = a.merge(y.storeObject, u), y.mergeTree = Jg(y.mergeTree, s), d.forEach(function(w) {
          return y.fieldNodeSet.add(w);
        })) : a.incomingById.set(r, {
          storeObject: u,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: Vd(s) ? void 0 : s,
          fieldNodeSet: d
        }), m;
      }
      return u;
    }, e.prototype.processFieldValue = function(t, n, r, i) {
      var o = this;
      return !n.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? zC(t) : t : Ht(t) ? t.map(function(a, s) {
        var l = o.processFieldValue(a, n, r, o2(i, s));
        return a2(i, s), l;
      }) : this.processSelectionSet({
        result: t,
        selectionSet: n.selectionSet,
        context: r,
        mergeTree: i
      });
    }, e.prototype.flattenFields = function(t, n, r, i) {
      i === void 0 && (i = zg(n, t, r.fragmentMap));
      var o = /* @__PURE__ */ new Map(), a = this.cache.policies, s = new Ji(!1);
      return (function l(u, c) {
        var f = s.lookup(
          u,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          c.clientOnly,
          c.deferred
        );
        f.visited || (f.visited = !0, u.selections.forEach(function(d) {
          if (Oc(d, r.variables)) {
            var p = c.clientOnly, h = c.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(p && h) && Oi(d.directives) && d.directives.forEach(function(g) {
                var y = g.name.value;
                if (y === "client" && (p = !0), y === "defer") {
                  var w = Jp(g, r.variables);
                  (!w || w.if !== !1) && (h = !0);
                }
              }), Ao(d)
            ) {
              var v = o.get(d);
              v && (p = p && v.clientOnly, h = h && v.deferred), o.set(d, Nv(r, p, h));
            } else {
              var m = Qp(d, r.lookupFragment);
              if (!m && d.kind === Vt.FRAGMENT_SPREAD)
                throw jn(14, d.name.value);
              m && a.fragmentMatches(m, i, n, r.variables) && l(m.selectionSet, Nv(r, p, h));
            }
          }
        }));
      })(t, r), o;
    }, e.prototype.applyMerges = function(t, n, r, i, o) {
      var a, s = this;
      if (t.map.size && !pt(r)) {
        var l = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !Ht(r) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (pt(n) || ps(n)) ? n : void 0
        ), u = r;
        l && !o && (o = [pt(l) ? l.__ref : l]);
        var c, f = function(d, p) {
          return Ht(d) ? typeof p == "number" ? d[p] : void 0 : i.store.getFieldValue(d, String(p));
        };
        t.map.forEach(function(d, p) {
          var h = f(l, p), v = f(u, p);
          if (v !== void 0) {
            o && o.push(p);
            var m = s.applyMerges(d, h, v, i, o);
            m !== v && (c = c || /* @__PURE__ */ new Map(), c.set(p, m)), o && Oe(o.pop() === p);
          }
        }), c && (r = Ht(u) ? u.slice(0) : G({}, u), c.forEach(function(d, p) {
          r[p] = d;
        }));
      }
      return t.info ? this.cache.policies.runMergeFunction(n, r, t.info, i, o && (a = i.store).getStorage.apply(a, o)) : r;
    }, e;
  })()
), u3 = [];
function o2(e, t) {
  var n = e.map;
  return n.has(t) || n.set(t, u3.pop() || { map: /* @__PURE__ */ new Map() }), n.get(t);
}
function Jg(e, t) {
  if (e === t || !t || Vd(t))
    return e;
  if (!e || Vd(e))
    return t;
  var n = e.info && t.info ? G(G({}, e.info), t.info) : e.info || t.info, r = e.map.size && t.map.size, i = r ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: n, map: i };
  if (r) {
    var a = new Set(t.map.keys());
    e.map.forEach(function(s, l) {
      o.map.set(l, Jg(s, t.map.get(l))), a.delete(l);
    }), a.forEach(function(s) {
      o.map.set(s, Jg(t.map.get(s), e.map.get(s)));
    });
  }
  return o;
}
function Vd(e) {
  return !e || !(e.info || e.map.size);
}
function a2(e, t) {
  var n = e.map, r = n.get(t);
  r && Vd(r) && (u3.push(r), n.delete(t));
}
var s2 = /* @__PURE__ */ new Set();
function Yte(e, t, n, r) {
  var i = function(f) {
    var d = r.getFieldValue(f, n);
    return typeof d == "object" && d;
  }, o = i(e);
  if (o) {
    var a = i(t);
    if (a && !pt(o) && !_t(o, a) && !Object.keys(o).every(function(f) {
      return r.getFieldValue(a, f) !== void 0;
    })) {
      var s = r.getFieldValue(e, "__typename") || r.getFieldValue(t, "__typename"), l = No(n), u = "".concat(s, ".").concat(l);
      if (!s2.has(u)) {
        s2.add(u);
        var c = [];
        !Ht(o) && !Ht(a) && [o, a].forEach(function(f) {
          var d = r.getFieldValue(f, "__typename");
          typeof d == "string" && !c.includes(d) && c.push(d);
        }), globalThis.__DEV__ !== !1 && Oe.warn(15, l, s, c.length ? "either ensure all objects of type " + c.join(" and ") + " have an ID or a custom merge function, or " : "", u, G({}, o), G({}, a));
      }
    }
  }
}
var Qte = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n) {
      n === void 0 && (n = {});
      var r = e.call(this) || this;
      return r.watches = /* @__PURE__ */ new Set(), r.addTypenameTransform = new CC(F0), r.assumeImmutableResults = !0, r.makeVar = qte, r.txCount = 0, globalThis.__DEV__ !== !1 && (Gt(n, "addTypename", "InMemoryCache", "Please remove the `addTypename` option when initializing `InMemoryCache`."), Gt(n, "canonizeResults", "InMemoryCache", "Please remove the `canonizeResults` option when initializing `InMemoryCache`.")), r.config = Rte(n), r.addTypename = !!r.config.addTypename, r.policies = new Zte({
        cache: r,
        dataIdFromObject: r.config.dataIdFromObject,
        possibleTypes: r.config.possibleTypes,
        typePolicies: r.config.typePolicies
      }), r.init(), r;
    }
    return t.prototype.init = function() {
      var n = this.data = new Yu.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = n.stump, this.resetResultCache();
    }, t.prototype.resetResultCache = function(n) {
      var r = this, i = this.storeReader, o = this.config.fragments;
      this.addTypenameTransform.resetCache(), o?.resetCaches(), this.storeWriter = new Gte(this, this.storeReader = new Vte({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: t3(this.config),
        canon: n ? void 0 : i && i.canon,
        fragments: o
      }), o), this.maybeBroadcastWatch = Gu(function(a, s) {
        return r.broadcastWatch(a, s);
      }, {
        max: this.config.resultCacheMaxSize || Zi["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(a) {
          var s = a.optimistic ? r.optimisticData : r.data;
          if (gu(s)) {
            var l = a.optimistic, u = a.id, c = a.variables;
            return s.makeCacheKey(
              a.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              a.callback,
              xo({ optimistic: l, id: u, variables: c })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(a) {
        return a.resetCaching();
      });
    }, t.prototype.restore = function(n) {
      return this.init(), n && this.data.replace(n), this;
    }, t.prototype.extract = function(n) {
      return n === void 0 && (n = !1), (n ? this.optimisticData : this.data).extract();
    }, t.prototype.read = function(n) {
      globalThis.__DEV__ !== !1 && Gt(n, "canonizeResults", "cache.read");
      var r = n.returnPartialData, i = r === void 0 ? !1 : r;
      try {
        return this.storeReader.diffQueryAgainstStore(G(G({}, n), { store: n.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
      } catch (o) {
        if (o instanceof JC)
          return null;
        throw o;
      }
    }, t.prototype.write = function(n) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, n);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.modify = function(n) {
      if (cn.call(n, "id") && !n.id)
        return !1;
      var r = n.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, r.modify(n.id || "ROOT_QUERY", n.fields);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.diff = function(n) {
      return globalThis.__DEV__ !== !1 && Gt(n, "canonizeResults", "cache.diff"), this.storeReader.diffQueryAgainstStore(G(G({}, n), { store: n.optimistic ? this.optimisticData : this.data, rootId: n.id || "ROOT_QUERY", config: this.config }));
    }, t.prototype.watch = function(n) {
      var r = this;
      return this.watches.size || Kte(this), this.watches.add(n), n.immediate && this.maybeBroadcastWatch(n), function() {
        r.watches.delete(n) && !r.watches.size && QS(r), r.maybeBroadcastWatch.forget(n);
      };
    }, t.prototype.gc = function(n) {
      globalThis.__DEV__ !== !1 && Gt(n || {}, "resetResultIdentities", "cache.gc", "First ensure all usages of `canonizeResults` are removed, then remove this option."), xo.reset(), _o.reset();
      var r = this.optimisticData.gc();
      return n && !this.txCount && (n.resetResultCache ? this.resetResultCache(n.resetResultIdentities) : n.resetResultIdentities && this.storeReader.resetCanon()), r;
    }, t.prototype.retain = function(n, r) {
      return (r ? this.optimisticData : this.data).retain(n);
    }, t.prototype.release = function(n, r) {
      return (r ? this.optimisticData : this.data).release(n);
    }, t.prototype.identify = function(n) {
      if (pt(n))
        return n.__ref;
      try {
        return this.policies.identify(n)[0];
      } catch (r) {
        globalThis.__DEV__ !== !1 && Oe.warn(r);
      }
    }, t.prototype.evict = function(n) {
      if (!n.id) {
        if (cn.call(n, "id"))
          return !1;
        n = G(G({}, n), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(n, this.data);
      } finally {
        !--this.txCount && n.broadcast !== !1 && this.broadcastWatches();
      }
    }, t.prototype.reset = function(n) {
      var r = this;
      return this.init(), xo.reset(), n && n.discardWatches ? (this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch.forget(i);
      }), this.watches.clear(), QS(this)) : this.broadcastWatches(), Promise.resolve();
    }, t.prototype.removeOptimistic = function(n) {
      var r = this.optimisticData.removeLayer(n);
      r !== this.optimisticData && (this.optimisticData = r, this.broadcastWatches());
    }, t.prototype.batch = function(n) {
      var r = this, i = n.update, o = n.optimistic, a = o === void 0 ? !0 : o, s = n.removeOptimistic, l = n.onWatchUpdated, u, c = function(d) {
        var p = r, h = p.data, v = p.optimisticData;
        ++r.txCount, d && (r.data = r.optimisticData = d);
        try {
          return u = i(r);
        } finally {
          --r.txCount, r.data = h, r.optimisticData = v;
        }
      }, f = /* @__PURE__ */ new Set();
      return l && !this.txCount && this.broadcastWatches(G(G({}, n), { onWatchUpdated: function(d) {
        return f.add(d), !1;
      } })), typeof a == "string" ? this.optimisticData = this.optimisticData.addLayer(a, c) : a === !1 ? c(this.data) : c(), typeof s == "string" && (this.optimisticData = this.optimisticData.removeLayer(s)), l && f.size ? (this.broadcastWatches(G(G({}, n), { onWatchUpdated: function(d, p) {
        var h = l.call(this, d, p);
        return h !== !1 && f.delete(d), h;
      } })), f.size && f.forEach(function(d) {
        return r.maybeBroadcastWatch.dirty(d);
      })) : this.broadcastWatches(n), u;
    }, t.prototype.performTransaction = function(n, r) {
      return this.batch({
        update: n,
        optimistic: r || r !== null
      });
    }, t.prototype.transformDocument = function(n) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(n));
    }, t.prototype.fragmentMatches = function(n, r) {
      return this.policies.fragmentMatches(n, r);
    }, t.prototype.lookupFragment = function(n) {
      var r;
      return ((r = this.config.fragments) === null || r === void 0 ? void 0 : r.lookup(n)) || null;
    }, t.prototype.broadcastWatches = function(n) {
      var r = this;
      this.txCount || this.watches.forEach(function(i) {
        return r.maybeBroadcastWatch(i, n);
      });
    }, t.prototype.addFragmentsToDocument = function(n) {
      var r = this.config.fragments;
      return r ? r.transform(n) : n;
    }, t.prototype.addTypenameToDocument = function(n) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(n) : n;
    }, t.prototype.broadcastWatch = function(n, r) {
      var i = this, o = n.lastDiff, a = wn("canonizeResults", function() {
        return i.diff(n);
      });
      r && (n.optimistic && typeof r.optimistic == "string" && (a.fromOptimisticTransaction = !0), r.onWatchUpdated && r.onWatchUpdated.call(this, n, a, o) === !1) || (!o || !_t(o.result, a.result)) && n.callback(n.lastDiff = a, o);
    }, t;
  })(QC)
);
globalThis.__DEV__ !== !1 && (Qte.prototype.getMemoryInternals = WX);
var dt;
(function(e) {
  e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
})(dt || (dt = {}));
function hs(e) {
  return e ? e < 7 : !1;
}
var l2 = Object.assign, Jte = Object.hasOwnProperty, zf = (
  /** @class */
  (function(e) {
    ai(t, e);
    function t(n) {
      var r = n.queryManager, i = n.queryInfo, o = n.options, a = this, s = t.inactiveOnCreation.getValue();
      a = e.call(this, function(g) {
        a._getOrCreateQuery();
        try {
          var y = g._subscription._observer;
          y && !y.error && (y.error = Xte);
        } catch {
        }
        var w = !a.observers.size;
        a.observers.add(g);
        var x = a.last;
        return x && x.error ? g.error && g.error(x.error) : x && x.result && g.next && g.next(a.maskResult(x.result)), w && a.reobserve().catch(function() {
        }), function() {
          a.observers.delete(g) && !a.observers.size && a.tearDownQuery();
        };
      }) || this, a.observers = /* @__PURE__ */ new Set(), a.subscriptions = /* @__PURE__ */ new Set(), a.dirty = !1, a._getOrCreateQuery = function() {
        return s && (r.queries.set(a.queryId, i), s = !1), a.queryManager.getOrCreateQuery(a.queryId);
      }, a.queryInfo = i, a.queryManager = r, a.waitForOwnResult = Rv(o.fetchPolicy), a.isTornDown = !1, a.subscribeToMore = a.subscribeToMore.bind(a), a.maskResult = a.maskResult.bind(a);
      var l = r.defaultOptions.watchQuery, u = l === void 0 ? {} : l, c = u.fetchPolicy, f = c === void 0 ? "cache-first" : c, d = o.fetchPolicy, p = d === void 0 ? f : d, h = o.initialFetchPolicy, v = h === void 0 ? p === "standby" ? f : p : h;
      a.options = G(G({}, o), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: v,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: p
      }), a.queryId = i.queryId || r.generateQueryId();
      var m = Oa(a.query);
      return a.queryName = m && m.name && m.name.value, a;
    }
    return Object.defineProperty(t.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.result = function() {
      var n = this;
      return globalThis.__DEV__ !== !1 && na("observableQuery.result", function() {
        globalThis.__DEV__ !== !1 && Oe.warn(23);
      }), new Promise(function(r, i) {
        var o = {
          next: function(s) {
            r(s), n.observers.delete(o), n.observers.size || n.queryManager.removeQuery(n.queryId), setTimeout(function() {
              a.unsubscribe();
            }, 0);
          },
          error: i
        }, a = n.subscribe(o);
      });
    }, t.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, t.prototype.getCurrentFullResult = function(n) {
      var r = this;
      n === void 0 && (n = !0);
      var i = wn("getLastResult", function() {
        return r.getLastResult(!0);
      }), o = this.queryInfo.networkStatus || i && i.networkStatus || dt.ready, a = G(G({}, i), { loading: hs(o), networkStatus: o }), s = this.options.fetchPolicy, l = s === void 0 ? "cache-first" : s;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Rv(l) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      ) if (this.waitForOwnResult)
        this.queryInfo.updateWatch();
      else {
        var u = this.queryInfo.getDiff();
        (u.complete || this.options.returnPartialData) && (a.data = u.result), _t(a.data, {}) && (a.data = void 0), u.complete ? (delete a.partial, u.complete && a.networkStatus === dt.loading && (l === "cache-first" || l === "cache-only") && (a.networkStatus = dt.ready, a.loading = !1)) : a.partial = !0, a.networkStatus === dt.ready && (a.error || a.errors) && (a.networkStatus = dt.error), globalThis.__DEV__ !== !1 && !u.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && c3(u.missing);
      }
      return n && this.updateLastResult(a), a;
    }, t.prototype.getCurrentResult = function(n) {
      return n === void 0 && (n = !0), this.maskResult(this.getCurrentFullResult(n));
    }, t.prototype.isDifferentFromLastResult = function(n, r) {
      if (!this.last)
        return !0;
      var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, a = o ? i.nonReactiveQuery : this.query, s = o || i.hasNonreactiveDirective ? !qC(a, this.last.result, n, this.variables) : !_t(this.last.result, n);
      return s || r && !_t(this.last.variables, r);
    }, t.prototype.getLast = function(n, r) {
      var i = this.last;
      if (i && i[n] && (!r || _t(i.variables, this.variables)))
        return i[n];
    }, t.prototype.getLastResult = function(n) {
      return globalThis.__DEV__ !== !1 && na("getLastResult", function() {
        globalThis.__DEV__ !== !1 && Oe.warn(24);
      }), this.getLast("result", n);
    }, t.prototype.getLastError = function(n) {
      return globalThis.__DEV__ !== !1 && na("getLastError", function() {
        globalThis.__DEV__ !== !1 && Oe.warn(25);
      }), this.getLast("error", n);
    }, t.prototype.resetLastResults = function() {
      globalThis.__DEV__ !== !1 && na("resetLastResults", function() {
        globalThis.__DEV__ !== !1 && Oe.warn(26);
      }), delete this.last, this.isTornDown = !1;
    }, t.prototype.resetQueryStoreErrors = function() {
      globalThis.__DEV__ !== !1 && globalThis.__DEV__ !== !1 && Oe.warn(27), this.queryManager.resetErrors(this.queryId);
    }, t.prototype.refetch = function(n) {
      var r, i = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, o = this.options.fetchPolicy;
      if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && n && Jte.call(n, "variables")) {
        var a = bC(this.query), s = a.variableDefinitions;
        (!s || !s.some(function(l) {
          return l.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Oe.warn(
          28,
          n,
          ((r = a.name) === null || r === void 0 ? void 0 : r.value) || a
        );
      }
      return n && !_t(this.options.variables, n) && (i.variables = this.options.variables = G(G({}, this.options.variables), n)), this.queryInfo.resetLastWrite(), this.reobserve(i, dt.refetch);
    }, t.prototype.fetchMore = function(n) {
      var r = this, i = G(G({}, n.query ? n : G(G(G(G({}, this.options), { query: this.options.query }), n), { variables: G(G({}, this.options.variables), n.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      i.query = this.transformDocument(i.query);
      var o = this.queryManager.generateQueryId();
      this.lastQuery = n.query ? this.transformDocument(this.options.query) : i.query;
      var a = this.queryInfo, s = a.networkStatus;
      a.networkStatus = dt.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
      var l = /* @__PURE__ */ new Set(), u = n?.updateQuery, c = this.options.fetchPolicy !== "no-cache";
      return c || Oe(u, 29), this.queryManager.fetchQuery(o, i, dt.fetchMore).then(function(f) {
        if (r.queryManager.removeQuery(o), a.networkStatus === dt.fetchMore && (a.networkStatus = s), c)
          r.queryManager.cache.batch({
            update: function(h) {
              var v = n.updateQuery;
              v ? h.updateQuery({
                query: r.query,
                variables: r.variables,
                returnPartialData: !0,
                optimistic: !1
              }, function(m) {
                return v(m, {
                  fetchMoreResult: f.data,
                  variables: i.variables
                });
              }) : h.writeQuery({
                query: i.query,
                variables: i.variables,
                data: f.data
              });
            },
            onWatchUpdated: function(h) {
              l.add(h.query);
            }
          });
        else {
          var d = r.getLast("result"), p = u(d.data, {
            fetchMoreResult: f.data,
            variables: i.variables
          });
          r.reportResult(G(G({}, d), { networkStatus: s, loading: hs(s), data: p }), r.variables);
        }
        return r.maskResult(f);
      }).finally(function() {
        c && !l.has(r.query) && r.reobserveCacheFirst();
      });
    }, t.prototype.subscribeToMore = function(n) {
      var r = this, i = this.queryManager.startGraphQLSubscription({
        query: n.document,
        variables: n.variables,
        context: n.context
      }).subscribe({
        next: function(o) {
          var a = n.updateQuery;
          a && r.updateQuery(function(s, l) {
            return a(s, G({ subscriptionData: o }, l));
          });
        },
        error: function(o) {
          if (n.onError) {
            n.onError(o);
            return;
          }
          globalThis.__DEV__ !== !1 && Oe.error(30, o);
        }
      });
      return this.subscriptions.add(i), function() {
        r.subscriptions.delete(i) && i.unsubscribe();
      };
    }, t.prototype.setOptions = function(n) {
      return globalThis.__DEV__ !== !1 && (Gt(n, "canonizeResults", "setOptions"), na("setOptions", function() {
        globalThis.__DEV__ !== !1 && Oe.warn(31);
      })), this.reobserve(n);
    }, t.prototype.silentSetOptions = function(n) {
      var r = Gs(this.options, n || {});
      l2(this.options, r);
    }, t.prototype.setVariables = function(n) {
      var r = this;
      return _t(this.variables, n) ? this.observers.size ? wn("observableQuery.result", function() {
        return r.result();
      }) : Promise.resolve() : (this.options.variables = n, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: n
      }, dt.setVariables) : Promise.resolve());
    }, t.prototype.updateQuery = function(n) {
      var r = this.queryManager, i = r.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }), o = i.result, a = i.complete, s = n(o, {
        variables: this.variables,
        complete: !!a,
        previousData: o
      });
      s && (r.cache.writeQuery({
        query: this.options.query,
        data: s,
        variables: this.variables
      }), r.broadcastQueries());
    }, t.prototype.startPolling = function(n) {
      this.options.pollInterval = n, this.updatePolling();
    }, t.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, t.prototype.applyNextFetchPolicy = function(n, r) {
      if (r.nextFetchPolicy) {
        var i = r.fetchPolicy, o = i === void 0 ? "cache-first" : i, a = r.initialFetchPolicy, s = a === void 0 ? o : a;
        o === "standby" || (typeof r.nextFetchPolicy == "function" ? r.fetchPolicy = r.nextFetchPolicy(o, {
          reason: n,
          options: r,
          observable: this,
          initialFetchPolicy: s
        }) : n === "variables-changed" ? r.fetchPolicy = s : r.fetchPolicy = r.nextFetchPolicy);
      }
      return r.fetchPolicy;
    }, t.prototype.fetch = function(n, r, i) {
      var o = this._getOrCreateQuery();
      return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, n, r, i);
    }, t.prototype.updatePolling = function() {
      var n = this;
      if (!this.queryManager.ssrMode) {
        var r = this, i = r.pollingInfo, o = r.options.pollInterval;
        if (!o || !this.hasObservers()) {
          i && (clearTimeout(i.timeout), delete this.pollingInfo);
          return;
        }
        if (!(i && i.interval === o)) {
          Oe(o, 32);
          var a = i || (this.pollingInfo = {});
          a.interval = o;
          var s = function() {
            var u, c;
            n.pollingInfo && (!hs(n.queryInfo.networkStatus) && !(!((c = (u = n.options).skipPollAttempt) === null || c === void 0) && c.call(u)) ? n.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: n.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, dt.poll).then(l, l) : l());
          }, l = function() {
            var u = n.pollingInfo;
            u && (clearTimeout(u.timeout), u.timeout = setTimeout(s, u.interval));
          };
          l();
        }
      }
    }, t.prototype.updateLastResult = function(n, r) {
      var i = this;
      r === void 0 && (r = this.variables);
      var o = wn("getLastError", function() {
        return i.getLastError();
      });
      return o && this.last && !_t(r, this.last.variables) && (o = void 0), this.last = G({ result: this.queryManager.assumeImmutableResults ? n : zC(n), variables: r }, o ? { error: o } : null);
    }, t.prototype.reobserveAsConcast = function(n, r) {
      var i = this;
      this.isTornDown = !1;
      var o = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        r === dt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        r === dt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        r === dt.poll
      ), a = this.options.variables, s = this.options.fetchPolicy, l = Gs(this.options, n || {}), u = o ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        l
      ) : l2(this.options, l), c = this.transformDocument(u.query);
      this.lastQuery = c, o || (this.updatePolling(), n && n.variables && !_t(n.variables, a) && // Don't mess with the fetchPolicy if it's currently "standby".
      u.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      (u.fetchPolicy === s || // A `nextFetchPolicy` function has even higher priority, though,
      // so in that case `applyNextFetchPolicy` must be called.
      typeof u.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", u), r === void 0 && (r = dt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Rv(u.fetchPolicy));
      var f = function() {
        i.concast === h && (i.waitForOwnResult = !1);
      }, d = u.variables && G({}, u.variables), p = this.fetch(u, r, c), h = p.concast, v = p.fromLink, m = {
        next: function(g) {
          _t(i.variables, d) && (f(), i.reportResult(g, d));
        },
        error: function(g) {
          _t(i.variables, d) && (UC(g) || (g = new fo({ networkError: g })), f(), i.reportError(g, d));
        }
      };
      return !o && (v || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = h, this.observer = m), h.addObserver(m), h;
    }, t.prototype.reobserve = function(n, r) {
      return Lee(this.reobserveAsConcast(n, r).promise.then(this.maskResult));
    }, t.prototype.resubscribeAfterError = function() {
      for (var n = this, r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var o = this.last;
      wn("resetLastResults", function() {
        return n.resetLastResults();
      });
      var a = this.subscribe.apply(this, r);
      return this.last = o, a;
    }, t.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentFullResult(!1),
        this.variables
      );
    }, t.prototype.reportResult = function(n, r) {
      var i = this, o = wn("getLastError", function() {
        return i.getLastError();
      }), a = this.isDifferentFromLastResult(n, r);
      (o || !n.partial || this.options.returnPartialData) && this.updateLastResult(n, r), (o || a) && mu(this.observers, "next", this.maskResult(n));
    }, t.prototype.reportError = function(n, r) {
      var i = this, o = G(G({}, wn("getLastResult", function() {
        return i.getLastResult();
      })), { error: n, errors: n.graphQLErrors, networkStatus: dt.error, loading: !1 });
      this.updateLastResult(o, r), mu(this.observers, "error", this.last.error = n);
    }, t.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, t.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(n) {
        return n.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, t.prototype.transformDocument = function(n) {
      return this.queryManager.transform(n);
    }, t.prototype.maskResult = function(n) {
      return n && "data" in n ? G(G({}, n), { data: this.queryManager.maskOperation({
        document: this.query,
        data: n.data,
        fetchPolicy: this.options.fetchPolicy,
        id: this.queryId
      }) }) : n;
    }, t.prototype.resetNotifications = function() {
      this.cancelNotifyTimeout(), this.dirty = !1;
    }, t.prototype.cancelNotifyTimeout = function() {
      this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
    }, t.prototype.scheduleNotify = function() {
      var n = this;
      this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return n.notify();
      }, 0)));
    }, t.prototype.notify = function() {
      if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !hs(this.queryInfo.networkStatus))) {
        var n = this.queryInfo.getDiff();
        n.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
      }
      this.dirty = !1;
    }, t.prototype.reobserveCacheFirst = function() {
      var n = this.options, r = n.fetchPolicy, i = n.nextFetchPolicy;
      return r === "cache-and-network" || r === "network-only" ? this.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(o, a) {
          return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, a) : r;
        }
      }) : this.reobserve();
    }, t.inactiveOnCreation = new El(), t;
  })(yt)
);
LC(zf);
function Xte(e) {
  globalThis.__DEV__ !== !1 && Oe.error(33, e.message, e.stack);
}
function c3(e) {
  globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && Oe.debug(34, e);
}
function Rv(e) {
  return e === "network-only" || e === "no-cache" || e === "standby";
}
var vs = new (Ba ? WeakMap : Map)();
function Mv(e, t) {
  var n = e[t];
  typeof n == "function" && (e[t] = function() {
    return vs.set(
      e,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (vs.get(e) + 1) % 1e15
    ), n.apply(this, arguments);
  });
}
var jv = (
  /** @class */
  (function() {
    function e(t, n) {
      n === void 0 && (n = t.generateQueryId()), this.queryId = n, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
      var r = this.cache = t.cache;
      vs.has(r) || (vs.set(r, 0), Mv(r, "evict"), Mv(r, "modify"), Mv(r, "reset"));
    }
    return e.prototype.init = function(t) {
      var n = t.networkStatus || dt.loading;
      return this.variables && this.networkStatus !== dt.loading && !_t(this.variables, t.variables) && (n = dt.setVariables), _t(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
        document: t.document,
        variables: t.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: n
      }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
    }, e.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, e.prototype.getDiff = function() {
      var t = this, n = this.getDiffOptions();
      if (this.lastDiff && _t(n, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = wn("canonizeResults", function() {
        return t.cache.diff(n);
      });
      return this.updateLastDiff(i, n), i;
    }, e.prototype.updateLastDiff = function(t, n) {
      this.lastDiff = t ? {
        diff: t,
        options: n || this.getDiffOptions()
      } : void 0;
    }, e.prototype.getDiffOptions = function(t) {
      var n;
      return t === void 0 && (t = this.variables), {
        query: this.document,
        variables: t,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (n = this.observableQuery) === null || n === void 0 ? void 0 : n.options.canonizeResults
      };
    }, e.prototype.setDiff = function(t) {
      var n = this, r, i = this.lastDiff && this.lastDiff.diff;
      t && !t.complete && wn("getLastError", function() {
        var o;
        return (o = n.observableQuery) === null || o === void 0 ? void 0 : o.getLastError();
      }) || (this.updateLastDiff(t), _t(i && i.result, t && t.result) || (r = this.observableQuery) === null || r === void 0 || r.scheduleNotify());
    }, e.prototype.setObservableQuery = function(t) {
      t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
    }, e.prototype.stop = function() {
      var t;
      if (!this.stopped) {
        this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
        var n = this.observableQuery;
        n && n.stopPolling();
      }
    }, e.prototype.cancel = function() {
      var t;
      (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
    }, e.prototype.updateWatch = function(t) {
      var n = this;
      t === void 0 && (t = this.variables);
      var r = this.observableQuery;
      if (!(r && r.options.fetchPolicy === "no-cache")) {
        var i = G(G({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
          return n.setDiff(o);
        } });
        (!this.lastWatch || !_t(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
      }
    }, e.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, e.prototype.shouldWrite = function(t, n) {
      var r = this.lastWrite;
      return !(r && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      r.dmCount === vs.get(this.cache) && _t(n, r.variables) && _t(t.data, r.result.data));
    }, e.prototype.markResult = function(t, n, r, i) {
      var o = this, a, s = new Io(), l = Oi(t.errors) ? t.errors.slice(0) : [];
      if ((a = this.observableQuery) === null || a === void 0 || a.resetNotifications(), "incremental" in t && Oi(t.incremental)) {
        var u = VC(this.getDiff().result, t);
        t.data = u;
      } else if ("hasNext" in t && t.hasNext) {
        var c = this.getDiff();
        t.data = s.merge(c.result, t.data);
      }
      this.graphQLErrors = l, r.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(r.variables)) : i !== 0 && (Xg(t, r.errorPolicy) ? this.cache.performTransaction(function(f) {
        if (o.shouldWrite(t, r.variables))
          f.writeQuery({
            query: n,
            data: t.data,
            variables: r.variables,
            overwrite: i === 1
          }), o.lastWrite = {
            result: t,
            variables: r.variables,
            dmCount: vs.get(o.cache)
          };
        else if (o.lastDiff && o.lastDiff.diff.complete) {
          t.data = o.lastDiff.diff.result;
          return;
        }
        var d = o.getDiffOptions(r.variables), p = wn("canonizeResults", function() {
          return f.diff(d);
        });
        !o.stopped && _t(o.variables, r.variables) && o.updateWatch(r.variables), o.updateLastDiff(p, d), p.complete && (t.data = p.result);
      }) : this.lastWrite = void 0);
    }, e.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = dt.ready;
    }, e.prototype.markError = function(t) {
      var n;
      return this.networkStatus = dt.error, this.lastWrite = void 0, (n = this.observableQuery) === null || n === void 0 || n.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
    }, e;
  })()
);
function Xg(e, t) {
  t === void 0 && (t = "none");
  var n = t === "ignore" || t === "all", r = !Mf(e);
  return !r && n && e.data && (r = !0), r;
}
var ene = Object.prototype.hasOwnProperty, u2 = /* @__PURE__ */ Object.create(null), tne = (
  /** @class */
  (function() {
    function e(t) {
      var n = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new pC(
        Zi["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new Ji(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
      var r = new CC(
        function(o) {
          return n.cache.transformDocument(o);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
      var i = t.documentTransform;
      this.documentTransform = i ? r.concat(i).concat(r) : r, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return e.prototype.stop = function() {
      var t = this;
      this.queries.forEach(function(n, r) {
        t.stopQueryNoBroadcast(r);
      }), this.cancelPendingFetches(jn(35));
    }, e.prototype.cancelPendingFetches = function(t) {
      this.fetchCancelFns.forEach(function(n) {
        return n(t);
      }), this.fetchCancelFns.clear();
    }, e.prototype.mutate = function(t) {
      return lo(this, arguments, void 0, function(n) {
        var r, i, o, a, s, l, u, c = n.mutation, f = n.variables, d = n.optimisticResponse, p = n.updateQueries, h = n.refetchQueries, v = h === void 0 ? [] : h, m = n.awaitRefetchQueries, g = m === void 0 ? !1 : m, y = n.update, w = n.onQueryUpdated, x = n.fetchPolicy, S = x === void 0 ? ((l = this.defaultOptions.mutate) === null || l === void 0 ? void 0 : l.fetchPolicy) || "network-only" : x, O = n.errorPolicy, P = O === void 0 ? ((u = this.defaultOptions.mutate) === null || u === void 0 ? void 0 : u.errorPolicy) || "none" : O, b = n.keepRootFields, _ = n.context;
        return uo(this, function(E) {
          switch (E.label) {
            case 0:
              return Oe(c, 36), Oe(S === "network-only" || S === "no-cache", 37), r = this.generateMutationId(), c = this.cache.transformForLink(this.transform(c)), i = this.getDocumentInfo(c).hasClientExports, f = this.getVariables(c, f), i ? [4, this.localState.addExportedVariables(c, f, _)] : [3, 2];
            case 1:
              f = E.sent(), E.label = 2;
            case 2:
              return o = this.mutationStore && (this.mutationStore[r] = {
                mutation: c,
                variables: f,
                loading: !0,
                error: null
              }), a = d && this.markMutationOptimistic(d, {
                mutationId: r,
                document: c,
                variables: f,
                fetchPolicy: S,
                errorPolicy: P,
                context: _,
                updateQueries: p,
                update: y,
                keepRootFields: b
              }), this.broadcastQueries(), s = this, [2, new Promise(function(A, k) {
                return kv(s.getObservableFromLink(c, G(G({}, _), { optimisticResponse: a ? d : void 0 }), f, {}, !1), function(R) {
                  if (Mf(R) && P === "none")
                    throw new fo({
                      graphQLErrors: Ug(R)
                    });
                  o && (o.loading = !1, o.error = null);
                  var N = G({}, R);
                  return typeof v == "function" && (v = v(N)), P === "ignore" && Mf(N) && delete N.errors, s.markMutationResult({
                    mutationId: r,
                    result: N,
                    document: c,
                    variables: f,
                    fetchPolicy: S,
                    errorPolicy: P,
                    context: _,
                    update: y,
                    updateQueries: p,
                    awaitRefetchQueries: g,
                    refetchQueries: v,
                    removeOptimistic: a ? r : void 0,
                    onQueryUpdated: w,
                    keepRootFields: b
                  });
                }).subscribe({
                  next: function(R) {
                    s.broadcastQueries(), (!("hasNext" in R) || R.hasNext === !1) && A(G(G({}, R), { data: s.maskOperation({
                      document: c,
                      data: R.data,
                      fetchPolicy: S,
                      id: r
                    }) }));
                  },
                  error: function(R) {
                    o && (o.loading = !1, o.error = R), a && s.cache.removeOptimistic(r), s.broadcastQueries(), k(R instanceof fo ? R : new fo({
                      networkError: R
                    }));
                  }
                });
              })];
          }
        });
      });
    }, e.prototype.markMutationResult = function(t, n) {
      var r = this;
      n === void 0 && (n = this.cache);
      var i = t.result, o = [], a = t.fetchPolicy === "no-cache";
      if (!a && Xg(i, t.errorPolicy)) {
        if (Os(i) || o.push({
          result: i.data,
          dataId: "ROOT_MUTATION",
          query: t.document,
          variables: t.variables
        }), Os(i) && Oi(i.incremental)) {
          var s = n.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(t.document).asQuery,
            variables: t.variables,
            optimistic: !1,
            returnPartialData: !0
          }), l = void 0;
          s.result && (l = VC(s.result, i)), typeof l < "u" && (i.data = l, o.push({
            result: l,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }));
        }
        var u = t.updateQueries;
        u && this.queries.forEach(function(f, d) {
          var p = f.observableQuery, h = p && p.queryName;
          if (!(!h || !ene.call(u, h))) {
            var v = u[h], m = r.queries.get(d), g = m.document, y = m.variables, w = n.diff({
              query: g,
              variables: y,
              returnPartialData: !0,
              optimistic: !1
            }), x = w.result, S = w.complete;
            if (S && x) {
              var O = v(x, {
                mutationResult: i,
                queryName: g && Yl(g) || void 0,
                queryVariables: y
              });
              O && o.push({
                result: O,
                dataId: "ROOT_QUERY",
                query: g,
                variables: y
              });
            }
          }
        });
      }
      if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
        var c = [];
        if (this.refetchQueries({
          updateCache: function(f) {
            a || o.forEach(function(v) {
              return f.write(v);
            });
            var d = t.update, p = !qee(i) || Os(i) && !i.hasNext;
            if (d) {
              if (!a) {
                var h = f.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: r.getDocumentInfo(t.document).asQuery,
                  variables: t.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                h.complete && (i = G(G({}, i), { data: h.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
              }
              p && d(f, i, {
                context: t.context,
                variables: t.variables
              });
            }
            !a && !t.keepRootFields && p && f.modify({
              id: "ROOT_MUTATION",
              fields: function(v, m) {
                var g = m.fieldName, y = m.DELETE;
                return g === "__typename" ? v : y;
              }
            });
          },
          include: t.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: t.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: t.onQueryUpdated || null
        }).forEach(function(f) {
          return c.push(f);
        }), t.awaitRefetchQueries || t.onQueryUpdated)
          return Promise.all(c).then(function() {
            return i;
          });
      }
      return Promise.resolve(i);
    }, e.prototype.markMutationOptimistic = function(t, n) {
      var r = this, i = typeof t == "function" ? t(n.variables, { IGNORE: u2 }) : t;
      return i === u2 ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
        try {
          r.markMutationResult(G(G({}, n), { result: { data: i } }), o);
        } catch (a) {
          globalThis.__DEV__ !== !1 && Oe.error(a);
        }
      }, n.mutationId), !0);
    }, e.prototype.fetchQuery = function(t, n, r) {
      return this.fetchConcastWithInfo(this.getOrCreateQuery(t), n, r).concast.promise;
    }, e.prototype.getQueryStore = function() {
      var t = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(n, r) {
        t[r] = {
          variables: n.variables,
          networkStatus: n.networkStatus,
          networkError: n.networkError,
          graphQLErrors: n.graphQLErrors
        };
      }), t;
    }, e.prototype.resetErrors = function(t) {
      var n = this.queries.get(t);
      n && (n.networkError = void 0, n.graphQLErrors = []);
    }, e.prototype.transform = function(t) {
      return this.documentTransform.transformDocument(t);
    }, e.prototype.getDocumentInfo = function(t) {
      var n = this.transformCache;
      if (!n.has(t)) {
        var r = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: TX(t),
          hasForcedResolvers: this.localState.shouldForceResolvers(t),
          hasNonreactiveDirective: Wu(["nonreactive"], t),
          nonReactiveQuery: Pee(t),
          clientQuery: this.localState.clientQuery(t),
          serverQuery: NC([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" },
            { name: "unmask" }
          ], t),
          defaultVars: N0(Oa(t)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: G(G({}, t), { definitions: t.definitions.map(function(i) {
            return i.kind === "OperationDefinition" && i.operation !== "query" ? G(G({}, i), { operation: "query" }) : i;
          }) })
        };
        n.set(t, r);
      }
      return n.get(t);
    }, e.prototype.getVariables = function(t, n) {
      return G(G({}, this.getDocumentInfo(t).defaultVars), n);
    }, e.prototype.watchQuery = function(t) {
      var n = this.transform(t.query);
      t = G(G({}, t), { variables: this.getVariables(n, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
      var r = new jv(this), i = new zf({
        queryManager: this,
        queryInfo: r,
        options: t
      });
      return i.lastQuery = n, zf.inactiveOnCreation.getValue() || this.queries.set(i.queryId, r), r.init({
        document: n,
        observableQuery: i,
        variables: i.variables
      }), i;
    }, e.prototype.query = function(t, n) {
      var r = this;
      n === void 0 && (n = this.generateQueryId()), Oe(t.query, 38), Oe(t.query.kind === "Document", 39), Oe(!t.returnPartialData, 40), Oe(!t.pollInterval, 41);
      var i = this.transform(t.query);
      return this.fetchQuery(n, G(G({}, t), { query: i })).then(function(o) {
        return o && G(G({}, o), { data: r.maskOperation({
          document: i,
          data: o.data,
          fetchPolicy: t.fetchPolicy,
          id: n
        }) });
      }).finally(function() {
        return r.stopQuery(n);
      });
    }, e.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, e.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, e.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, e.prototype.stopQueryInStore = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
      var n = this.queries.get(t);
      n && n.stop();
    }, e.prototype.clearStore = function(t) {
      return t === void 0 && (t = {
        discardWatches: !0
      }), this.cancelPendingFetches(jn(42)), this.queries.forEach(function(n) {
        n.observableQuery ? n.networkStatus = dt.loading : n.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
    }, e.prototype.getObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = "active");
      var r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(t) && t.forEach(function(s) {
        if (typeof s == "string")
          i.set(s, s), o.set(s, !1);
        else if (tee(s)) {
          var l = _o(n.transform(s));
          i.set(l, Yl(s)), o.set(l, !1);
        } else Nt(s) && s.query && a.add(s);
      }), this.queries.forEach(function(s, l) {
        var u = s.observableQuery, c = s.document;
        if (u) {
          if (t === "all") {
            r.set(l, u);
            return;
          }
          var f = u.queryName, d = u.options.fetchPolicy;
          if (d === "standby" || t === "active" && !u.hasObservers())
            return;
          (t === "active" || f && o.has(f) || c && o.has(_o(c))) && (r.set(l, u), f && o.set(f, !0), c && o.set(_o(c), !0));
        }
      }), a.size && a.forEach(function(s) {
        var l = Ig("legacyOneTimeQuery"), u = n.getOrCreateQuery(l).init({
          document: s.query,
          variables: s.variables
        }), c = new zf({
          queryManager: n,
          queryInfo: u,
          options: G(G({}, s), { fetchPolicy: "network-only" })
        });
        Oe(c.queryId === l), u.setObservableQuery(c), r.set(l, c);
      }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(s, l) {
        if (!s) {
          var u = i.get(l);
          u ? globalThis.__DEV__ !== !1 && Oe.warn(43, u) : globalThis.__DEV__ !== !1 && Oe.warn(44);
        }
      }), r;
    }, e.prototype.reFetchObservableQueries = function(t) {
      var n = this;
      t === void 0 && (t = !1);
      var r = [];
      return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
        var a = i.options.fetchPolicy;
        wn("resetLastResults", function() {
          return i.resetLastResults();
        }), (t || a !== "standby" && a !== "cache-only") && r.push(i.refetch()), (n.queries.get(o) || i.queryInfo).setDiff(null);
      }), this.broadcastQueries(), Promise.all(r);
    }, e.prototype.startGraphQLSubscription = function(t) {
      var n = this, r = t.query, i = t.variables, o = t.fetchPolicy, a = t.errorPolicy, s = a === void 0 ? "none" : a, l = t.context, u = l === void 0 ? {} : l, c = t.extensions, f = c === void 0 ? {} : c;
      r = this.transform(r), i = this.getVariables(r, i);
      var d = function(h) {
        return n.getObservableFromLink(r, u, h, f).map(function(v) {
          o !== "no-cache" && (Xg(v, s) && n.cache.write({
            query: r,
            result: v.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: h
          }), n.broadcastQueries());
          var m = Mf(v), g = ute(v);
          if (m || g) {
            var y = {};
            if (m && (y.graphQLErrors = v.errors), g && (y.protocolErrors = v.extensions[U0]), s === "none" || g)
              throw new fo(y);
          }
          return s === "ignore" && delete v.errors, v;
        });
      };
      if (this.getDocumentInfo(r).hasClientExports) {
        var p = this.localState.addExportedVariables(r, i, u).then(d);
        return new yt(function(h) {
          var v = null;
          return p.then(function(m) {
            return v = m.subscribe(h);
          }, h.error), function() {
            return v && v.unsubscribe();
          };
        });
      }
      return d(i);
    }, e.prototype.stopQuery = function(t) {
      this.stopQueryNoBroadcast(t), this.broadcastQueries();
    }, e.prototype.stopQueryNoBroadcast = function(t) {
      this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
    }, e.prototype.removeQuery = function(t) {
      var n;
      this.fetchCancelFns.delete(t), this.queries.has(t) && ((n = this.queries.get(t)) === null || n === void 0 || n.stop(), this.queries.delete(t));
    }, e.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
        var n;
        return (n = t.observableQuery) === null || n === void 0 ? void 0 : n.notify();
      });
    }, e.prototype.getLocalState = function() {
      return this.localState;
    }, e.prototype.getObservableFromLink = function(t, n, r, i, o) {
      var a = this, s;
      o === void 0 && (o = (s = n?.queryDeduplication) !== null && s !== void 0 ? s : this.queryDeduplication);
      var l, u = this.getDocumentInfo(t), c = u.serverQuery, f = u.clientQuery;
      if (c) {
        var d = this, p = d.inFlightLinkObservables, h = d.link, v = {
          query: c,
          variables: r,
          operationName: Yl(c) || void 0,
          context: this.prepareContext(G(G({}, n), { forceFetch: !o })),
          extensions: i
        };
        if (n = v.context, o) {
          var m = _o(c), g = xo(r), y = p.lookup(m, g);
          if (l = y.observable, !l) {
            var w = new ts([
              Hg(h, v)
            ]);
            l = y.observable = w, w.beforeNext(function x(S, O) {
              S === "next" && "hasNext" in O && O.hasNext ? w.beforeNext(x) : p.remove(m, g);
            });
          }
        } else
          l = new ts([
            Hg(h, v)
          ]);
      } else
        l = new ts([yt.of({ data: {} })]), n = this.prepareContext(n);
      return f && (l = kv(l, function(x) {
        return a.localState.runResolvers({
          document: f,
          remoteResult: x,
          context: n,
          variables: r
        });
      })), l;
    }, e.prototype.getResultsFromLink = function(t, n, r) {
      var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(r.query);
      return kv(this.getObservableFromLink(o, r.context, r.variables), function(a) {
        var s = Ug(a), l = s.length > 0, u = r.errorPolicy;
        if (i >= t.lastRequestId) {
          if (l && u === "none")
            throw t.markError(new fo({
              graphQLErrors: s
            }));
          t.markResult(a, o, r, n), t.markReady();
        }
        var c = {
          data: a.data,
          loading: !1,
          networkStatus: dt.ready
        };
        return l && u === "none" && (c.data = void 0), l && u !== "ignore" && (c.errors = s, c.networkStatus = dt.error), c;
      }, function(a) {
        var s = UC(a) ? a : new fo({ networkError: a });
        throw i >= t.lastRequestId && t.markError(s), s;
      });
    }, e.prototype.fetchConcastWithInfo = function(t, n, r, i) {
      var o = this;
      r === void 0 && (r = dt.loading), i === void 0 && (i = n.query);
      var a = this.getVariables(i, n.variables), s = this.defaultOptions.watchQuery, l = n.fetchPolicy, u = l === void 0 ? s && s.fetchPolicy || "cache-first" : l, c = n.errorPolicy, f = c === void 0 ? s && s.errorPolicy || "none" : c, d = n.returnPartialData, p = d === void 0 ? !1 : d, h = n.notifyOnNetworkStatusChange, v = h === void 0 ? !1 : h, m = n.context, g = m === void 0 ? {} : m, y = Object.assign({}, n, {
        query: i,
        variables: a,
        fetchPolicy: u,
        errorPolicy: f,
        returnPartialData: p,
        notifyOnNetworkStatusChange: v,
        context: g
      }), w = function(b) {
        y.variables = b;
        var _ = o.fetchQueryByPolicy(t, y, r);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          y.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          _.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", n), _
        );
      }, x = function() {
        return o.fetchCancelFns.delete(t.queryId);
      };
      this.fetchCancelFns.set(t.queryId, function(b) {
        x(), setTimeout(function() {
          return S.cancel(b);
        });
      });
      var S, O;
      if (this.getDocumentInfo(y.query).hasClientExports)
        S = new ts(this.localState.addExportedVariables(y.query, y.variables, y.context).then(w).then(function(b) {
          return b.sources;
        })), O = !0;
      else {
        var P = w(y.variables);
        O = P.fromLink, S = new ts(P.sources);
      }
      return S.promise.then(x, x), {
        concast: S,
        fromLink: O
      };
    }, e.prototype.refetchQueries = function(t) {
      var n = this, r = t.updateCache, i = t.include, o = t.optimistic, a = o === void 0 ? !1 : o, s = t.removeOptimistic, l = s === void 0 ? a ? Ig("refetchQueries") : void 0 : s, u = t.onQueryUpdated, c = /* @__PURE__ */ new Map();
      i && this.getObservableQueries(i).forEach(function(d, p) {
        c.set(p, {
          oq: d,
          lastDiff: (n.queries.get(p) || d.queryInfo).getDiff()
        });
      });
      var f = /* @__PURE__ */ new Map();
      return r && this.cache.batch({
        update: r,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: a && l || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: l,
        onWatchUpdated: function(d, p, h) {
          var v = d.watcher instanceof jv && d.watcher.observableQuery;
          if (v) {
            if (u) {
              c.delete(v.queryId);
              var m = u(v, p, h);
              return m === !0 && (m = v.refetch()), m !== !1 && f.set(v, m), m;
            }
            u !== null && c.set(v.queryId, { oq: v, lastDiff: h, diff: p });
          }
        }
      }), c.size && c.forEach(function(d, p) {
        var h = d.oq, v = d.lastDiff, m = d.diff, g;
        u && (m || (m = wn("canonizeResults", function() {
          return n.cache.diff(h.queryInfo.getDiffOptions());
        })), g = u(h, m, v)), (!u || g === !0) && (g = h.refetch()), g !== !1 && f.set(h, g), p.indexOf("legacyOneTimeQuery") >= 0 && n.stopQueryNoBroadcast(p);
      }), l && this.cache.removeOptimistic(l), f;
    }, e.prototype.maskOperation = function(t) {
      var n, r, i, o = t.document, a = t.data;
      if (globalThis.__DEV__ !== !1) {
        var s = t.fetchPolicy, l = t.id, u = (n = Oa(o)) === null || n === void 0 ? void 0 : n.operation, c = ((r = u?.[0]) !== null && r !== void 0 ? r : "o") + l;
        this.dataMasking && s === "no-cache" && !jX(o) && !this.noCacheWarningsByQueryId.has(c) && (this.noCacheWarningsByQueryId.add(c), globalThis.__DEV__ !== !1 && Oe.warn(
          45,
          (i = Yl(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(u ?? "operation")
        ));
      }
      return this.dataMasking ? Nte(a, o, this.cache) : a;
    }, e.prototype.maskFragment = function(t) {
      var n = t.data, r = t.fragment, i = t.fragmentName;
      return this.dataMasking ? YC(n, r, this.cache, i) : n;
    }, e.prototype.fetchQueryByPolicy = function(t, n, r) {
      var i = this, o = n.query, a = n.variables, s = n.fetchPolicy, l = n.refetchWritePolicy, u = n.errorPolicy, c = n.returnPartialData, f = n.context, d = n.notifyOnNetworkStatusChange, p = t.networkStatus;
      t.init({
        document: o,
        variables: a,
        networkStatus: r
      });
      var h = function() {
        return t.getDiff();
      }, v = function(x, S) {
        S === void 0 && (S = t.networkStatus || dt.loading);
        var O = x.result;
        globalThis.__DEV__ !== !1 && !c && !_t(O, {}) && c3(x.missing);
        var P = function(b) {
          return yt.of(G({ data: b, loading: hs(S), networkStatus: S }, x.complete ? null : { partial: !0 }));
        };
        return O && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
          document: o,
          remoteResult: { data: O },
          context: f,
          variables: a,
          onlyRunForcedResolvers: !0
        }).then(function(b) {
          return P(b.data || void 0);
        }) : u === "none" && S === dt.refetch && Array.isArray(x.missing) ? P(void 0) : P(O);
      }, m = s === "no-cache" ? 0 : r === dt.refetch && l !== "merge" ? 1 : 2, g = function() {
        return i.getResultsFromLink(t, m, {
          query: o,
          variables: a,
          context: f,
          fetchPolicy: s,
          errorPolicy: u
        });
      }, y = d && typeof p == "number" && p !== r && hs(r);
      switch (s) {
        default:
        case "cache-first": {
          var w = h();
          return w.complete ? {
            fromLink: !1,
            sources: [v(w, t.markReady())]
          } : c || y ? {
            fromLink: !0,
            sources: [v(w), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-and-network": {
          var w = h();
          return w.complete || c || y ? {
            fromLink: !0,
            sources: [v(w), g()]
          } : { fromLink: !0, sources: [g()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [v(h(), t.markReady())]
          };
        case "network-only":
          return y ? {
            fromLink: !0,
            sources: [v(h()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "no-cache":
          return y ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [v(t.getDiff()), g()]
          } : { fromLink: !0, sources: [g()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, e.prototype.getOrCreateQuery = function(t) {
      return t && !this.queries.has(t) && this.queries.set(t, new jv(this, t)), this.queries.get(t);
    }, e.prototype.prepareContext = function(t) {
      t === void 0 && (t = {});
      var n = this.localState.prepareContext(t);
      return G(G(G({}, this.defaultContext), n), { clientAwareness: this.clientAwareness });
    }, e;
  })()
), nne = (
  /** @class */
  (function() {
    function e(t) {
      var n = t.cache, r = t.client, i = t.resolvers, o = t.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = n, r && (this.client = r), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
    }
    return e.prototype.addResolvers = function(t) {
      var n = this;
      this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(r) {
        n.resolvers = PS(n.resolvers, r);
      }) : this.resolvers = PS(this.resolvers, t);
    }, e.prototype.setResolvers = function(t) {
      this.resolvers = {}, this.addResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, e.prototype.runResolvers = function(t) {
      return lo(this, arguments, void 0, function(n) {
        var r = n.document, i = n.remoteResult, o = n.context, a = n.variables, s = n.onlyRunForcedResolvers, l = s === void 0 ? !1 : s;
        return uo(this, function(u) {
          return r ? [2, this.resolveDocument(r, i.data, o, a, this.fragmentMatcher, l).then(function(c) {
            return G(G({}, i), { data: c.result });
          })] : [2, i];
        });
      });
    }, e.prototype.setFragmentMatcher = function(t) {
      this.fragmentMatcher = t;
    }, e.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, e.prototype.clientQuery = function(t) {
      return Wu(["client"], t) && this.resolvers ? t : null;
    }, e.prototype.serverQuery = function(t) {
      return RC(t);
    }, e.prototype.prepareContext = function(t) {
      var n = this.cache;
      return G(G({}, t), {
        cache: n,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(r) {
          return n.identify(r);
        }
      });
    }, e.prototype.addExportedVariables = function(t) {
      return lo(this, arguments, void 0, function(n, r, i) {
        return r === void 0 && (r = {}), i === void 0 && (i = {}), uo(this, function(o) {
          return n ? [2, this.resolveDocument(n, this.buildRootValueFromCache(n, r) || {}, this.prepareContext(i), r).then(function(a) {
            return G(G({}, r), a.exportedVariables);
          })] : [2, G({}, r)];
        });
      });
    }, e.prototype.shouldForceResolvers = function(t) {
      var n = !1;
      return ti(t, {
        Directive: {
          enter: function(r) {
            if (r.name.value === "client" && r.arguments && (n = r.arguments.some(function(i) {
              return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
            }), n))
              return Gp;
          }
        }
      }), n;
    }, e.prototype.buildRootValueFromCache = function(t, n) {
      return this.cache.diff({
        query: kee(t),
        variables: n,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, e.prototype.resolveDocument = function(t, n) {
      return lo(this, arguments, void 0, function(r, i, o, a, s, l) {
        var u, c, f, d, p, h, v, m, g, y, w;
        return o === void 0 && (o = {}), a === void 0 && (a = {}), s === void 0 && (s = function() {
          return !0;
        }), l === void 0 && (l = !1), uo(this, function(x) {
          return u = $c(r), c = xl(r), f = _l(c), d = this.collectSelectionsToResolve(u, f), p = u.operation, h = p ? p.charAt(0).toUpperCase() + p.slice(1) : "Query", v = this, m = v.cache, g = v.client, y = {
            fragmentMap: f,
            context: G(G({}, o), { cache: m, client: g }),
            variables: a,
            fragmentMatcher: s,
            defaultOperationType: h,
            exportedVariables: {},
            selectionsToResolve: d,
            onlyRunForcedResolvers: l
          }, w = !1, [2, this.resolveSelectionSet(u.selectionSet, w, i, y).then(function(S) {
            return {
              result: S,
              exportedVariables: y.exportedVariables
            };
          })];
        });
      });
    }, e.prototype.resolveSelectionSet = function(t, n, r, i) {
      return lo(this, void 0, void 0, function() {
        var o, a, s, l, u, c = this;
        return uo(this, function(f) {
          return o = i.fragmentMap, a = i.context, s = i.variables, l = [r], u = function(d) {
            return lo(c, void 0, void 0, function() {
              var p, h;
              return uo(this, function(v) {
                return !n && !i.selectionsToResolve.has(d) ? [
                  2
                  /*return*/
                ] : Oc(d, s) ? Ao(d) ? [2, this.resolveField(d, n, r, i).then(function(m) {
                  var g;
                  typeof m < "u" && l.push((g = {}, g[Gi(d)] = m, g));
                })] : (pee(d) ? p = d : (p = o[d.name.value], Oe(p, 21, d.name.value)), p && p.typeCondition && (h = p.typeCondition.name.value, i.fragmentMatcher(r, h, a)) ? [2, this.resolveSelectionSet(p.selectionSet, n, r, i).then(function(m) {
                  l.push(m);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(t.selections.map(u)).then(function() {
            return th(l);
          })];
        });
      });
    }, e.prototype.resolveField = function(t, n, r, i) {
      return lo(this, void 0, void 0, function() {
        var o, a, s, l, u, c, f, d, p, h = this;
        return uo(this, function(v) {
          return r ? (o = i.variables, a = t.name.value, s = Gi(t), l = a !== s, u = r[s] || r[a], c = Promise.resolve(u), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (f = r.__typename || i.defaultOperationType, d = this.resolvers && this.resolvers[f], d && (p = d[l ? a : s], p && (c = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            q0.withValue(this.cache, p, [
              r,
              Jp(t, o),
              i.context,
              { field: t, fragmentMap: i.fragmentMap }
            ])
          )))), [2, c.then(function(m) {
            var g, y;
            if (m === void 0 && (m = u), t.directives && t.directives.forEach(function(x) {
              x.name.value === "export" && x.arguments && x.arguments.forEach(function(S) {
                S.name.value === "as" && S.value.kind === "StringValue" && (i.exportedVariables[S.value.value] = m);
              });
            }), !t.selectionSet || m == null)
              return m;
            var w = (y = (g = t.directives) === null || g === void 0 ? void 0 : g.some(function(x) {
              return x.name.value === "client";
            })) !== null && y !== void 0 ? y : !1;
            if (Array.isArray(m))
              return h.resolveSubSelectedArray(t, n || w, m, i);
            if (t.selectionSet)
              return h.resolveSelectionSet(t.selectionSet, n || w, m, i);
          })]) : [2, null];
        });
      });
    }, e.prototype.resolveSubSelectedArray = function(t, n, r, i) {
      var o = this;
      return Promise.all(r.map(function(a) {
        if (a === null)
          return null;
        if (Array.isArray(a))
          return o.resolveSubSelectedArray(t, n, a, i);
        if (t.selectionSet)
          return o.resolveSelectionSet(t.selectionSet, n, a, i);
      }));
    }, e.prototype.collectSelectionsToResolve = function(t, n) {
      var r = function(a) {
        return !Array.isArray(a);
      }, i = this.selectionsToResolveCache;
      function o(a) {
        if (!i.has(a)) {
          var s = /* @__PURE__ */ new Set();
          i.set(a, s), ti(a, {
            Directive: function(l, u, c, f, d) {
              l.name.value === "client" && d.forEach(function(p) {
                r(p) && _S(p) && s.add(p);
              });
            },
            FragmentSpread: function(l, u, c, f, d) {
              var p = n[l.name.value];
              Oe(p, 22, l.name.value);
              var h = o(p);
              h.size > 0 && (d.forEach(function(v) {
                r(v) && _S(v) && s.add(v);
              }), s.add(l), h.forEach(function(v) {
                s.add(v);
              }));
            }
          });
        }
        return i.get(a);
      }
      return o(t);
    }, e;
  })()
), c2 = !1, rne = (
  /** @class */
  (function() {
    function e(t) {
      var n = this, r, i, o;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
        throw jn(16);
      var a = t.uri, s = t.credentials, l = t.headers, u = t.cache, c = t.documentTransform, f = t.ssrMode, d = f === void 0 ? !1 : f, p = t.ssrForceFetchDelay, h = p === void 0 ? 0 : p, v = t.connectToDevTools, m = t.queryDeduplication, g = m === void 0 ? !0 : m, y = t.defaultOptions, w = t.defaultContext, x = t.assumeImmutableResults, S = x === void 0 ? u.assumeImmutableResults : x, O = t.resolvers, P = t.typeDefs, b = t.fragmentMatcher, _ = t.clientAwareness, E = t.name, A = t.version, k = t.devtools, R = t.dataMasking;
      globalThis.__DEV__ !== !1 && (Gt(t, "connectToDevTools", "ApolloClient", "Please use `devtools.enabled` instead."), Gt(t, "uri", "ApolloClient", "Please initialize an instance of `HttpLink` with `uri` instead."), Gt(t, "credentials", "ApolloClient", "Please initialize an instance of `HttpLink` with `credentials` instead."), Gt(t, "headers", "ApolloClient", "Please initialize an instance of `HttpLink` with `headers` instead."), Gt(t, "name", "ApolloClient", "Please use the `clientAwareness.name` option instead."), Gt(t, "version", "ApolloClient", "Please use the `clientAwareness.version` option instead."), Gt(t, "typeDefs", "ApolloClient"), t.link || globalThis.__DEV__ !== !1 && Oe.warn(17));
      var N = t.link;
      N || (N = a ? new $te({ uri: a, credentials: s, headers: l }) : Bo.empty()), this.link = N, this.cache = u, this.disableNetworkFetches = d || h > 0, this.queryDeduplication = g, this.defaultOptions = y || /* @__PURE__ */ Object.create(null), this.typeDefs = P, this.devtoolsConfig = G(G({}, k), { enabled: (r = k?.enabled) !== null && r !== void 0 ? r : v }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), h && setTimeout(function() {
        return n.disableNetworkFetches = !1;
      }, h), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = D0, this.localState = new nne({
        cache: u,
        client: this,
        resolvers: O,
        fragmentMatcher: b
      }), this.queryManager = new tne({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: w,
        documentTransform: c,
        queryDeduplication: g,
        ssrMode: d,
        dataMasking: !!R,
        clientAwareness: {
          name: (i = _?.name) !== null && i !== void 0 ? i : E,
          version: (o = _?.version) !== null && o !== void 0 ? o : A
        },
        localState: this.localState,
        assumeImmutableResults: S,
        onBroadcast: this.devtoolsConfig.enabled ? function() {
          n.devToolsHookCb && n.devToolsHookCb({
            action: {},
            state: {
              queries: n.queryManager.getQueryStore(),
              mutations: n.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: n.cache.extract(!0)
          });
        } : void 0
      }), this.devtoolsConfig.enabled && this.connectToDevTools();
    }
    return Object.defineProperty(e.prototype, "prioritizeCacheValues", {
      /**
       * Whether to prioritize cache values over network results when `query` or `watchQuery` is called.
       * This will essentially turn a `"network-only"` or `"cache-and-network"` fetchPolicy into a `"cache-first"` fetchPolicy,
       * but without influencing the `fetchPolicy` of the created `ObservableQuery` long-term.
       *
       * This can e.g. be used to prioritize the cache during the first render after SSR.
       */
      get: function() {
        return this.disableNetworkFetches;
      },
      set: function(t) {
        this.disableNetworkFetches = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.connectToDevTools = function() {
      if (!(typeof window > "u")) {
        var t = window, n = Symbol.for("apollo.devtools");
        (t[n] = t[n] || []).push(this), t.__APOLLO_CLIENT__ = this, !c2 && globalThis.__DEV__ !== !1 && (c2 = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
          if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
            var r = window.navigator, i = r && r.userAgent, o = void 0;
            typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && Oe.log("Download the Apollo DevTools for a better development experience: %s", o);
          }
        }, 1e4));
      }
    }, Object.defineProperty(e.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.stop = function() {
      this.queryManager.stop();
    }, e.prototype.watchQuery = function(t) {
      return this.defaultOptions.watchQuery && (t = Pv(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = G(G({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (Gt(t, "canonizeResults", "client.watchQuery"), Gt(t, "partialRefetch", "client.watchQuery")), this.queryManager.watchQuery(t);
    }, e.prototype.query = function(t) {
      return this.defaultOptions.query && (t = Pv(this.defaultOptions.query, t)), Oe(t.fetchPolicy !== "cache-and-network", 18), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = G(G({}, t), { fetchPolicy: "cache-first" })), globalThis.__DEV__ !== !1 && (Gt(t, "canonizeResults", "client.query"), Gt(t, "notifyOnNetworkStatusChange", "client.query", "This option does not affect `client.query` and can be safely removed."), t.fetchPolicy === "standby" && globalThis.__DEV__ !== !1 && Oe.warn(19)), this.queryManager.query(t);
    }, e.prototype.mutate = function(t) {
      return this.defaultOptions.mutate && (t = Pv(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
    }, e.prototype.subscribe = function(t) {
      var n = this, r = this.queryManager.generateQueryId();
      return this.queryManager.startGraphQLSubscription(t).map(function(i) {
        return G(G({}, i), { data: n.queryManager.maskOperation({
          document: t.query,
          data: i.data,
          fetchPolicy: t.fetchPolicy,
          id: r
        }) });
      });
    }, e.prototype.readQuery = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readQuery(t, n);
    }, e.prototype.watchFragment = function(t) {
      var n;
      return this.cache.watchFragment(G(G({}, t), (n = {}, n[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, n)));
    }, e.prototype.readFragment = function(t, n) {
      return n === void 0 && (n = !1), this.cache.readFragment(t, n);
    }, e.prototype.writeQuery = function(t) {
      var n = this.cache.writeQuery(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.writeFragment = function(t) {
      var n = this.cache.writeFragment(t);
      return t.broadcast !== !1 && this.queryManager.broadcastQueries(), n;
    }, e.prototype.__actionHookForDevTools = function(t) {
      this.devToolsHookCb = t;
    }, e.prototype.__requestRaw = function(t) {
      return Hg(this.link, t);
    }, e.prototype.resetStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(t.resetStoreCallbacks.map(function(n) {
          return n();
        }));
      }).then(function() {
        return t.reFetchObservableQueries();
      });
    }, e.prototype.clearStore = function() {
      var t = this;
      return Promise.resolve().then(function() {
        return t.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(t.clearStoreCallbacks.map(function(n) {
          return n();
        }));
      });
    }, e.prototype.onResetStore = function(t) {
      var n = this;
      return this.resetStoreCallbacks.push(t), function() {
        n.resetStoreCallbacks = n.resetStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.onClearStore = function(t) {
      var n = this;
      return this.clearStoreCallbacks.push(t), function() {
        n.clearStoreCallbacks = n.clearStoreCallbacks.filter(function(r) {
          return r !== t;
        });
      };
    }, e.prototype.reFetchObservableQueries = function(t) {
      return this.queryManager.reFetchObservableQueries(t);
    }, e.prototype.refetchQueries = function(t) {
      var n = this.queryManager.refetchQueries(t), r = [], i = [];
      n.forEach(function(a, s) {
        r.push(s), i.push(a);
      });
      var o = Promise.all(i);
      return o.queries = r, o.results = i, o.catch(function(a) {
        globalThis.__DEV__ !== !1 && Oe.debug(20, a);
      }), o;
    }, e.prototype.getObservableQueries = function(t) {
      return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
    }, e.prototype.extract = function(t) {
      return this.cache.extract(t);
    }, e.prototype.restore = function(t) {
      return this.cache.restore(t);
    }, e.prototype.addResolvers = function(t) {
      this.localState.addResolvers(t);
    }, e.prototype.setResolvers = function(t) {
      this.localState.setResolvers(t);
    }, e.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, e.prototype.setLocalStateFragmentMatcher = function(t) {
      this.localState.setFragmentMatcher(t);
    }, e.prototype.setLink = function(t) {
      this.link = this.queryManager.link = t;
    }, Object.defineProperty(e.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), e;
  })()
);
globalThis.__DEV__ !== !1 && (rne.prototype.getMemoryInternals = HX);
function ine(e) {
  return Nt(e) && "code" in e && "reason" in e;
}
function one(e) {
  var t;
  return Nt(e) && ((t = e.target) === null || t === void 0 ? void 0 : t.readyState) === WebSocket.CLOSED;
}
/** @class */
(function(e) {
  ai(t, e);
  function t(n) {
    var r = e.call(this) || this;
    return r.client = n, r;
  }
  return t.prototype.request = function(n) {
    var r = this;
    return new yt(function(i) {
      return r.client.subscribe(G(G({}, n), { query: _o(n.query) }), {
        next: i.next.bind(i),
        complete: i.complete.bind(i),
        error: function(o) {
          if (o instanceof Error)
            return i.error(o);
          var a = ine(o);
          return a || one(o) ? i.error(
            // reason will be available on clean closes
            new Error("Socket closed".concat(a ? " with event ".concat(o.code) : "").concat(a ? " ".concat(o.reason) : ""))
          ) : i.error(new fo({
            graphQLErrors: Array.isArray(o) ? o : [o]
          }));
        }
        // casting around a wrong type in graphql-ws, which incorrectly expects `Sink<ExecutionResult>`
      });
    });
  }, t;
})(Bo);
var f2;
(function(e) {
  e[e.InternalServerError = 4500] = "InternalServerError", e[e.InternalClientError = 4005] = "InternalClientError", e[e.BadRequest = 4400] = "BadRequest", e[e.BadResponse = 4004] = "BadResponse", e[e.Unauthorized = 4401] = "Unauthorized", e[e.Forbidden = 4403] = "Forbidden", e[e.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", e[e.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", e[e.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", e[e.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", e[e.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(f2 || (f2 = {}));
var d2;
(function(e) {
  e.ConnectionInit = "connection_init", e.ConnectionAck = "connection_ack", e.Ping = "ping", e.Pong = "pong", e.Subscribe = "subscribe", e.Next = "next", e.Error = "error", e.Complete = "complete";
})(d2 || (d2 = {}));
function ce(e, t, n) {
  function r(s, l) {
    if (s._zod || Object.defineProperty(s, "_zod", {
      value: {
        def: l,
        constr: a,
        traits: /* @__PURE__ */ new Set()
      },
      enumerable: !1
    }), s._zod.traits.has(e))
      return;
    s._zod.traits.add(e), t(s, l);
    const u = a.prototype, c = Object.keys(u);
    for (let f = 0; f < c.length; f++) {
      const d = c[f];
      d in s || (s[d] = u[d].bind(s));
    }
  }
  const i = n?.Parent ?? Object;
  class o extends i {
  }
  Object.defineProperty(o, "name", { value: e });
  function a(s) {
    var l;
    const u = n != null && n.Parent ? new o() : this;
    r(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const c of u._zod.deferred)
      c();
    return u;
  }
  return Object.defineProperty(a, "init", { value: r }), Object.defineProperty(a, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s?._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(a, "name", { value: e }), a;
}
class Ts extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class f3 extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const d3 = {};
function $a(e) {
  return d3;
}
function p3(e) {
  const t = Object.values(e).filter((n) => typeof n == "number");
  return Object.entries(e).filter(([n, r]) => t.indexOf(+n) === -1).map(([n, r]) => r);
}
function ey(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function G0(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Y0(e) {
  return e == null;
}
function Q0(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function ane(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = t.toString();
  let i = (r.split(".")[1] || "").length;
  if (i === 0 && /\d?e-\d?/.test(r)) {
    const l = r.match(/\d?e-(\d?)/);
    l != null && l[1] && (i = Number.parseInt(l[1]));
  }
  const o = n > i ? n : i, a = Number.parseInt(e.toFixed(o).replace(".", "")), s = Number.parseInt(t.toFixed(o).replace(".", ""));
  return a % s / 10 ** o;
}
const p2 = Symbol("evaluating");
function ht(e, t, n) {
  let r;
  Object.defineProperty(e, t, {
    get() {
      if (r !== p2)
        return r === void 0 && (r = p2, r = n()), r;
    },
    set(i) {
      Object.defineProperty(e, t, {
        value: i
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Ua(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Uo(...e) {
  const t = {};
  for (const n of e) {
    const r = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, r);
  }
  return Object.defineProperties({}, t);
}
function h2(e) {
  return JSON.stringify(e);
}
function sne(e) {
  return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
const h3 = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Bd(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const lne = G0(() => {
  var e;
  if (typeof navigator < "u" && (e = navigator?.userAgent) != null && e.includes("Cloudflare"))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Qu(e) {
  if (Bd(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0 || typeof t != "function")
    return !0;
  const n = t.prototype;
  return !(Bd(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function v3(e) {
  return Qu(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const une = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function nh(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Ko(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function Ue(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function cne(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const fne = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function dne(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  const i = Uo(e._zod.def, {
    get shape() {
      const o = {};
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && (o[a] = n.shape[a]);
      }
      return Ua(this, "shape", o), o;
    },
    checks: []
  });
  return Ko(e, i);
}
function pne(e, t) {
  const n = e._zod.def, r = n.checks;
  if (r && r.length > 0)
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  const i = Uo(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape };
      for (const a in t) {
        if (!(a in n.shape))
          throw new Error(`Unrecognized key: "${a}"`);
        t[a] && delete o[a];
      }
      return Ua(this, "shape", o), o;
    },
    checks: []
  });
  return Ko(e, i);
}
function hne(e, t) {
  if (!Qu(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0) {
    const i = e._zod.def.shape;
    for (const o in t)
      if (Object.getOwnPropertyDescriptor(i, o) !== void 0)
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
  }
  const r = Uo(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return Ua(this, "shape", i), i;
    }
  });
  return Ko(e, r);
}
function vne(e, t) {
  if (!Qu(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = Uo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return Ua(this, "shape", r), r;
    }
  });
  return Ko(e, n);
}
function mne(e, t) {
  const n = Uo(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape, ...t._zod.def.shape };
      return Ua(this, "shape", r), r;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Ko(e, n);
}
function gne(e, t, n) {
  const r = t._zod.def.checks;
  if (r && r.length > 0)
    throw new Error(".partial() cannot be used on object schemas containing refinements");
  const i = Uo(t._zod.def, {
    get shape() {
      const o = t._zod.def.shape, a = { ...o };
      if (n)
        for (const s in n) {
          if (!(s in o))
            throw new Error(`Unrecognized key: "${s}"`);
          n[s] && (a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s]);
        }
      else
        for (const s in o)
          a[s] = e ? new e({
            type: "optional",
            innerType: o[s]
          }) : o[s];
      return Ua(this, "shape", a), a;
    },
    checks: []
  });
  return Ko(t, i);
}
function yne(e, t, n) {
  const r = Uo(t._zod.def, {
    get shape() {
      const i = t._zod.def.shape, o = { ...i };
      if (n)
        for (const a in n) {
          if (!(a in o))
            throw new Error(`Unrecognized key: "${a}"`);
          n[a] && (o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          }));
        }
      else
        for (const a in i)
          o[a] = new e({
            type: "nonoptional",
            innerType: i[a]
          });
      return Ua(this, "shape", o), o;
    }
  });
  return Ko(t, r);
}
function ms(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let r = t; r < e.issues.length; r++)
    if (((n = e.issues[r]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function m3(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function df(e) {
  return typeof e == "string" ? e : e?.message;
}
function Ta(e, t, n) {
  var r, i, o, a, s, l;
  const u = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const c = df((o = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : o.call(i, e)) ?? df((a = t?.error) == null ? void 0 : a.call(t, e)) ?? df((s = n.customError) == null ? void 0 : s.call(n, e)) ?? df((l = n.localeError) == null ? void 0 : l.call(n, e)) ?? "Invalid input";
    u.message = c;
  }
  return delete u.inst, delete u.continue, t != null && t.reportInput || delete u.input, u;
}
function J0(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Ju(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const g3 = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, ey, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, y3 = ce("$ZodError", g3), b3 = ce("$ZodError", g3, { Parent: Error });
function bne(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const i of e.issues)
    i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
  return { formErrors: r, fieldErrors: n };
}
function _ne(e, t = (n) => n.message) {
  const n = { _errors: [] }, r = (i) => {
    for (const o of i.issues)
      if (o.code === "invalid_union" && o.errors.length)
        o.errors.map((a) => r({ issues: a }));
      else if (o.code === "invalid_key")
        r({ issues: o.issues });
      else if (o.code === "invalid_element")
        r({ issues: o.issues });
      else if (o.path.length === 0)
        n._errors.push(t(o));
      else {
        let a = n, s = 0;
        for (; s < o.path.length; ) {
          const l = o.path[s];
          s === o.path.length - 1 ? (a[l] = a[l] || { _errors: [] }, a[l]._errors.push(t(o))) : a[l] = a[l] || { _errors: [] }, a = a[l], s++;
        }
      }
  };
  return r(e), n;
}
const X0 = (e) => (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !1 }) : { async: !1 }, a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise)
    throw new Ts();
  if (a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Ta(l, o, $a())));
    throw h3(s, i?.callee), s;
  }
  return a.value;
}, e_ = (e) => async (t, n, r, i) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let a = t._zod.run({ value: n, issues: [] }, o);
  if (a instanceof Promise && (a = await a), a.issues.length) {
    const s = new (i?.Err ?? e)(a.issues.map((l) => Ta(l, o, $a())));
    throw h3(s, i?.callee), s;
  }
  return a.value;
}, rh = (e) => (t, n, r) => {
  const i = r ? { ...r, async: !1 } : { async: !1 }, o = t._zod.run({ value: n, issues: [] }, i);
  if (o instanceof Promise)
    throw new Ts();
  return o.issues.length ? {
    success: !1,
    error: new (e ?? y3)(o.issues.map((a) => Ta(a, i, $a())))
  } : { success: !0, data: o.value };
}, wne = /* @__PURE__ */ rh(b3), ih = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let o = t._zod.run({ value: n, issues: [] }, i);
  return o instanceof Promise && (o = await o), o.issues.length ? {
    success: !1,
    error: new e(o.issues.map((a) => Ta(a, i, $a())))
  } : { success: !0, data: o.value };
}, xne = /* @__PURE__ */ ih(b3), Ene = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return X0(e)(t, n, i);
}, Sne = (e) => (t, n, r) => X0(e)(t, n, r), One = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return e_(e)(t, n, i);
}, $ne = (e) => async (t, n, r) => e_(e)(t, n, r), Tne = (e) => (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return rh(e)(t, n, i);
}, kne = (e) => (t, n, r) => rh(e)(t, n, r), Pne = (e) => async (t, n, r) => {
  const i = r ? Object.assign(r, { direction: "backward" }) : { direction: "backward" };
  return ih(e)(t, n, i);
}, Dne = (e) => async (t, n, r) => ih(e)(t, n, r), Ane = /^[cC][^\s-]{8,}$/, Cne = /^[0-9a-z]+$/, Ine = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Nne = /^[0-9a-vA-V]{20}$/, Rne = /^[A-Za-z0-9]{27}$/, Mne = /^[a-zA-Z0-9_-]{21}$/, jne = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Fne = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, v2 = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, zne = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Lne = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Vne() {
  return new RegExp(Lne, "u");
}
const Bne = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Une = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Kne = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, qne = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Hne = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, _3 = /^[A-Za-z0-9_-]*$/, Wne = /^\+[1-9]\d{6,14}$/, w3 = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Zne = /* @__PURE__ */ new RegExp(`^${w3}$`);
function x3(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Gne(e) {
  return new RegExp(`^${x3(e)}$`);
}
function Yne(e) {
  const t = x3({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${w3}T(?:${r})$`);
}
const Qne = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Jne = /^-?\d+$/, Xne = /^-?\d+(?:\.\d+)?$/, ere = /^(?:true|false)$/i, tre = /^[^A-Z]*$/, nre = /^[^a-z]*$/, Yn = /* @__PURE__ */ ce("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), E3 = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, S3 = /* @__PURE__ */ ce("$ZodCheckLessThan", (e, t) => {
  Yn.init(e, t);
  const n = E3[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.maximum : i.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < o && (t.inclusive ? i.maximum = t.value : i.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), O3 = /* @__PURE__ */ ce("$ZodCheckGreaterThan", (e, t) => {
  Yn.init(e, t);
  const n = E3[typeof t.value];
  e._zod.onattach.push((r) => {
    const i = r._zod.bag, o = (t.inclusive ? i.minimum : i.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > o && (t.inclusive ? i.minimum = t.value : i.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), rre = /* @__PURE__ */ ce("$ZodCheckMultipleOf", (e, t) => {
  Yn.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : ane(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ire = /* @__PURE__ */ ce("$ZodCheckNumberFormat", (e, t) => {
  var n;
  Yn.init(e, t), t.format = t.format || "float64";
  const r = (n = t.format) == null ? void 0 : n.includes("int"), i = r ? "int" : "number", [o, a] = fne[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = o, l.maximum = a, r && (l.pattern = Jne);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (r) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: i,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: i,
          inclusive: !0,
          continue: !t.abort
        });
        return;
      }
    }
    l < o && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > a && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: a,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    });
  };
}), ore = /* @__PURE__ */ ce("$ZodCheckMaxLength", (e, t) => {
  var n;
  Yn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Y0(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < i && (r._zod.bag.maximum = t.maximum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length <= t.maximum)
      return;
    const o = J0(i);
    r.issues.push({
      origin: o,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), are = /* @__PURE__ */ ce("$ZodCheckMinLength", (e, t) => {
  var n;
  Yn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Y0(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > i && (r._zod.bag.minimum = t.minimum);
  }), e._zod.check = (r) => {
    const i = r.value;
    if (i.length >= t.minimum)
      return;
    const o = J0(i);
    r.issues.push({
      origin: o,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: i,
      inst: e,
      continue: !t.abort
    });
  };
}), sre = /* @__PURE__ */ ce("$ZodCheckLengthEquals", (e, t) => {
  var n;
  Yn.init(e, t), (n = e._zod.def).when ?? (n.when = (r) => {
    const i = r.value;
    return !Y0(i) && i.length !== void 0;
  }), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.minimum = t.length, i.maximum = t.length, i.length = t.length;
  }), e._zod.check = (r) => {
    const i = r.value, o = i.length;
    if (o === t.length)
      return;
    const a = J0(i), s = o > t.length;
    r.issues.push({
      origin: a,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), oh = /* @__PURE__ */ ce("$ZodCheckStringFormat", (e, t) => {
  var n, r;
  Yn.init(e, t), e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (i) => {
    t.pattern.lastIndex = 0, !t.pattern.test(i.value) && i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: i.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (r = e._zod).check ?? (r.check = () => {
  });
}), lre = /* @__PURE__ */ ce("$ZodCheckRegex", (e, t) => {
  oh.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), ure = /* @__PURE__ */ ce("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = tre), oh.init(e, t);
}), cre = /* @__PURE__ */ ce("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = nre), oh.init(e, t);
}), fre = /* @__PURE__ */ ce("$ZodCheckIncludes", (e, t) => {
  Yn.init(e, t);
  const n = nh(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((i) => {
    const o = i._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(r);
  }), e._zod.check = (i) => {
    i.value.includes(t.includes, t.position) || i.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: i.value,
      inst: e,
      continue: !t.abort
    });
  };
}), dre = /* @__PURE__ */ ce("$ZodCheckStartsWith", (e, t) => {
  Yn.init(e, t);
  const n = new RegExp(`^${nh(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), pre = /* @__PURE__ */ ce("$ZodCheckEndsWith", (e, t) => {
  Yn.init(e, t);
  const n = new RegExp(`.*${nh(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), hre = /* @__PURE__ */ ce("$ZodCheckOverwrite", (e, t) => {
  Yn.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class vre {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const n = t.split(`
`).filter((o) => o), r = Math.min(...n.map((o) => o.length - o.trimStart().length)), i = n.map((o) => o.slice(r)).map((o) => " ".repeat(this.indent * 2) + o);
    for (const o of i)
      this.content.push(o);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
}
const mre = {
  major: 4,
  minor: 3,
  patch: 6
}, en = /* @__PURE__ */ ce("$ZodType", (e, t) => {
  var n, r;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = mre;
  const i = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && i.unshift(e);
  for (const o of i)
    for (const a of o._zod.onattach)
      a(e);
  if (i.length === 0)
    (r = e._zod).deferred ?? (r.deferred = []), (n = e._zod.deferred) == null || n.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const o = (s, l, u) => {
      let c = ms(s), f;
      for (const d of l) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(s))
            continue;
        } else if (c)
          continue;
        const p = s.issues.length, h = d._zod.check(s);
        if (h instanceof Promise && u?.async === !1)
          throw new Ts();
        if (f || h instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await h, s.issues.length !== p && (c || (c = ms(s, p)));
          });
        else {
          if (s.issues.length === p)
            continue;
          c || (c = ms(s, p));
        }
      }
      return f ? f.then(() => s) : s;
    }, a = (s, l, u) => {
      if (ms(s))
        return s.aborted = !0, s;
      const c = o(l, i, u);
      if (c instanceof Promise) {
        if (u.async === !1)
          throw new Ts();
        return c.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(c, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const c = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return c instanceof Promise ? c.then((f) => a(f, s, l)) : a(c, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new Ts();
        return u.then((c) => o(c, i, l));
      }
      return o(u, i, l);
    };
  }
  ht(e, "~standard", () => ({
    validate: (o) => {
      var a;
      try {
        const s = wne(e, o);
        return s.success ? { value: s.data } : { issues: (a = s.error) == null ? void 0 : a.issues };
      } catch {
        return xne(e, o).then((s) => {
          var l;
          return s.success ? { value: s.data } : { issues: (l = s.error) == null ? void 0 : l.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  }));
}), t_ = /* @__PURE__ */ ce("$ZodString", (e, t) => {
  var n;
  en.init(e, t), e._zod.pattern = [...((n = e?._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? Qne(e._zod.bag), e._zod.parse = (r, i) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), Ft = /* @__PURE__ */ ce("$ZodStringFormat", (e, t) => {
  oh.init(e, t), t_.init(e, t);
}), gre = /* @__PURE__ */ ce("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Fne), Ft.init(e, t);
}), yre = /* @__PURE__ */ ce("$ZodUUID", (e, t) => {
  if (t.version) {
    const n = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (n === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = v2(n));
  } else
    t.pattern ?? (t.pattern = v2());
  Ft.init(e, t);
}), bre = /* @__PURE__ */ ce("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = zne), Ft.init(e, t);
}), _re = /* @__PURE__ */ ce("$ZodURL", (e, t) => {
  Ft.init(e, t), e._zod.check = (n) => {
    try {
      const r = n.value.trim(), i = new URL(r);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: t.hostname.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = i.href : n.value = r;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), wre = /* @__PURE__ */ ce("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Vne()), Ft.init(e, t);
}), xre = /* @__PURE__ */ ce("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Mne), Ft.init(e, t);
}), Ere = /* @__PURE__ */ ce("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = Ane), Ft.init(e, t);
}), Sre = /* @__PURE__ */ ce("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Cne), Ft.init(e, t);
}), Ore = /* @__PURE__ */ ce("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Ine), Ft.init(e, t);
}), $re = /* @__PURE__ */ ce("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = Nne), Ft.init(e, t);
}), Tre = /* @__PURE__ */ ce("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Rne), Ft.init(e, t);
}), kre = /* @__PURE__ */ ce("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Yne(t)), Ft.init(e, t);
}), Pre = /* @__PURE__ */ ce("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = Zne), Ft.init(e, t);
}), Dre = /* @__PURE__ */ ce("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Gne(t)), Ft.init(e, t);
}), Are = /* @__PURE__ */ ce("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = jne), Ft.init(e, t);
}), Cre = /* @__PURE__ */ ce("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Bne), Ft.init(e, t), e._zod.bag.format = "ipv4";
}), Ire = /* @__PURE__ */ ce("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Une), Ft.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Nre = /* @__PURE__ */ ce("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Kne), Ft.init(e, t);
}), Rre = /* @__PURE__ */ ce("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = qne), Ft.init(e, t), e._zod.check = (n) => {
    const r = n.value.split("/");
    try {
      if (r.length !== 2)
        throw new Error();
      const [i, o] = r;
      if (!o)
        throw new Error();
      const a = Number(o);
      if (`${a}` !== o)
        throw new Error();
      if (a < 0 || a > 128)
        throw new Error();
      new URL(`http://[${i}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function $3(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Mre = /* @__PURE__ */ ce("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Hne), Ft.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
    $3(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function jre(e) {
  if (!_3.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return $3(n);
}
const Fre = /* @__PURE__ */ ce("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = _3), Ft.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
    jre(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), zre = /* @__PURE__ */ ce("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Wne), Ft.init(e, t);
});
function Lre(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n;
    if (!r)
      return !1;
    const i = JSON.parse(atob(r));
    return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
  } catch {
    return !1;
  }
}
const Vre = /* @__PURE__ */ ce("$ZodJWT", (e, t) => {
  Ft.init(e, t), e._zod.check = (n) => {
    Lre(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), T3 = /* @__PURE__ */ ce("$ZodNumber", (e, t) => {
  en.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Xne, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const i = n.value;
    if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i))
      return n;
    const o = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: i,
      inst: e,
      ...o ? { received: o } : {}
    }), n;
  };
}), Bre = /* @__PURE__ */ ce("$ZodNumberFormat", (e, t) => {
  ire.init(e, t), T3.init(e, t);
}), Ure = /* @__PURE__ */ ce("$ZodBoolean", (e, t) => {
  en.init(e, t), e._zod.pattern = ere, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const i = n.value;
    return typeof i == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: i,
      inst: e
    }), n;
  };
}), Kre = /* @__PURE__ */ ce("$ZodUnknown", (e, t) => {
  en.init(e, t), e._zod.parse = (n) => n;
}), qre = /* @__PURE__ */ ce("$ZodNever", (e, t) => {
  en.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function m2(e, t, n) {
  e.issues.length && t.issues.push(...m3(n, e.issues)), t.value[n] = e.value;
}
const Hre = /* @__PURE__ */ ce("$ZodArray", (e, t) => {
  en.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value;
    if (!Array.isArray(i))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: i,
        inst: e
      }), n;
    n.value = Array(i.length);
    const o = [];
    for (let a = 0; a < i.length; a++) {
      const s = i[a], l = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      l instanceof Promise ? o.push(l.then((u) => m2(u, n, a))) : m2(l, n, a);
    }
    return o.length ? Promise.all(o).then(() => n) : n;
  };
});
function Ud(e, t, n, r, i) {
  if (e.issues.length) {
    if (i && !(n in r))
      return;
    t.issues.push(...m3(n, e.issues));
  }
  e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
function k3(e) {
  var t, n, r, i;
  const o = Object.keys(e.shape);
  for (const s of o)
    if (!((i = (r = (n = (t = e.shape) == null ? void 0 : t[s]) == null ? void 0 : n._zod) == null ? void 0 : r.traits) != null && i.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const a = cne(e.shape);
  return {
    ...e,
    keys: o,
    keySet: new Set(o),
    numKeys: o.length,
    optionalKeys: new Set(a)
  };
}
function P3(e, t, n, r, i, o) {
  const a = [], s = i.keySet, l = i.catchall._zod, u = l.def.type, c = l.optout === "optional";
  for (const f in t) {
    if (s.has(f))
      continue;
    if (u === "never") {
      a.push(f);
      continue;
    }
    const d = l.run({ value: t[f], issues: [] }, r);
    d instanceof Promise ? e.push(d.then((p) => Ud(p, n, f, t, c))) : Ud(d, n, f, t, c);
  }
  return a.length && n.issues.push({
    code: "unrecognized_keys",
    keys: a,
    input: t,
    inst: o
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const Wre = /* @__PURE__ */ ce("$ZodObject", (e, t) => {
  en.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const r = G0(() => k3(t));
  ht(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const c = s[u]._zod;
      if (c.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of c.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const i = Bd, o = t.catchall;
  let a;
  e._zod.parse = (s, l) => {
    a ?? (a = r.value);
    const u = s.value;
    if (!i(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const c = [], f = a.shape;
    for (const d of a.keys) {
      const p = f[d], h = p._zod.optout === "optional", v = p._zod.run({ value: u[d], issues: [] }, l);
      v instanceof Promise ? c.push(v.then((m) => Ud(m, s, d, u, h))) : Ud(v, s, d, u, h);
    }
    return o ? P3(c, u, s, l, r.value, e) : c.length ? Promise.all(c).then(() => s) : s;
  };
}), Zre = /* @__PURE__ */ ce("$ZodObjectJIT", (e, t) => {
  Wre.init(e, t);
  const n = e._zod.parse, r = G0(() => k3(t)), i = (f) => {
    var d;
    const p = new vre(["shape", "payload", "ctx"]), h = r.value, v = (w) => {
      const x = h2(w);
      return `shape[${x}]._zod.run({ value: input[${x}], issues: [] }, ctx)`;
    };
    p.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let g = 0;
    for (const w of h.keys)
      m[w] = `key_${g++}`;
    p.write("const newResult = {};");
    for (const w of h.keys) {
      const x = m[w], S = h2(w), O = f[w], P = ((d = O?._zod) == null ? void 0 : d.optout) === "optional";
      p.write(`const ${x} = ${v(w)};`), P ? p.write(`
        if (${x}.issues.length) {
          if (${S} in input) {
            payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${S}, ...iss.path] : [${S}]
            })));
          }
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `) : p.write(`
        if (${x}.issues.length) {
          payload.issues = payload.issues.concat(${x}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${S}, ...iss.path] : [${S}]
          })));
        }
        
        if (${x}.value === undefined) {
          if (${S} in input) {
            newResult[${S}] = undefined;
          }
        } else {
          newResult[${S}] = ${x}.value;
        }
        
      `);
    }
    p.write("payload.value = newResult;"), p.write("return payload;");
    const y = p.compile();
    return (w, x) => y(f, w, x);
  };
  let o;
  const a = Bd, s = !d3.jitless, l = s && lne.value, u = t.catchall;
  let c;
  e._zod.parse = (f, d) => {
    c ?? (c = r.value);
    const p = f.value;
    return a(p) ? s && l && d?.async === !1 && d.jitless !== !0 ? (o || (o = i(t.shape)), f = o(f, d), u ? P3([], p, f, d, c, e) : f) : n(f, d) : (f.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), f);
  };
});
function g2(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  const i = e.filter((o) => !ms(o));
  return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((a) => Ta(a, r, $a())))
  }), t);
}
const Gre = /* @__PURE__ */ ce("$ZodUnion", (e, t) => {
  en.init(e, t), ht(e._zod, "optin", () => t.options.some((i) => i._zod.optin === "optional") ? "optional" : void 0), ht(e._zod, "optout", () => t.options.some((i) => i._zod.optout === "optional") ? "optional" : void 0), ht(e._zod, "values", () => {
    if (t.options.every((i) => i._zod.values))
      return new Set(t.options.flatMap((i) => Array.from(i._zod.values)));
  }), ht(e._zod, "pattern", () => {
    if (t.options.every((i) => i._zod.pattern)) {
      const i = t.options.map((o) => o._zod.pattern);
      return new RegExp(`^(${i.map((o) => Q0(o.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, r = t.options[0]._zod.run;
  e._zod.parse = (i, o) => {
    if (n)
      return r(i, o);
    let a = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: i.value,
        issues: []
      }, o);
      if (u instanceof Promise)
        s.push(u), a = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return a ? Promise.all(s).then((l) => g2(l, i, e, o)) : g2(s, i, e, o);
  };
}), Yre = /* @__PURE__ */ ce("$ZodIntersection", (e, t) => {
  en.init(e, t), e._zod.parse = (n, r) => {
    const i = n.value, o = t.left._zod.run({ value: i, issues: [] }, r), a = t.right._zod.run({ value: i, issues: [] }, r);
    return o instanceof Promise || a instanceof Promise ? Promise.all([o, a]).then(([s, l]) => y2(n, s, l)) : y2(n, o, a);
  };
});
function ty(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Qu(e) && Qu(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((o) => n.indexOf(o) !== -1), i = { ...e, ...t };
    for (const o of r) {
      const a = ty(e[o], t[o]);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...a.mergeErrorPath]
        };
      i[o] = a.data;
    }
    return { valid: !0, data: i };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const i = e[r], o = t[r], a = ty(i, o);
      if (!a.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...a.mergeErrorPath]
        };
      n.push(a.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function y2(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  let i;
  for (const s of t.issues)
    if (s.code === "unrecognized_keys") {
      i ?? (i = s);
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).l = !0;
    } else
      e.issues.push(s);
  for (const s of n.issues)
    if (s.code === "unrecognized_keys")
      for (const l of s.keys)
        r.has(l) || r.set(l, {}), r.get(l).r = !0;
    else
      e.issues.push(s);
  const o = [...r].filter(([, s]) => s.l && s.r).map(([s]) => s);
  if (o.length && i && e.issues.push({ ...i, keys: o }), ms(e))
    return e;
  const a = ty(t.value, n.value);
  if (!a.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(a.mergeErrorPath)}`);
  return e.value = a.data, e;
}
const Qre = /* @__PURE__ */ ce("$ZodEnum", (e, t) => {
  en.init(e, t);
  const n = p3(t.entries), r = new Set(n);
  e._zod.values = r, e._zod.pattern = new RegExp(`^(${n.filter((i) => une.has(typeof i)).map((i) => typeof i == "string" ? nh(i) : i.toString()).join("|")})$`), e._zod.parse = (i, o) => {
    const a = i.value;
    return r.has(a) || i.issues.push({
      code: "invalid_value",
      values: n,
      input: a,
      inst: e
    }), i;
  };
}), Jre = /* @__PURE__ */ ce("$ZodTransform", (e, t) => {
  en.init(e, t), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new f3(e.constructor.name);
    const i = t.transform(n.value, n);
    if (r.async)
      return (i instanceof Promise ? i : Promise.resolve(i)).then((o) => (n.value = o, n));
    if (i instanceof Promise)
      throw new Ts();
    return n.value = i, n;
  };
});
function b2(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const D3 = /* @__PURE__ */ ce("$ZodOptional", (e, t) => {
  en.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", ht(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), ht(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Q0(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => {
    if (t.innerType._zod.optin === "optional") {
      const i = t.innerType._zod.run(n, r);
      return i instanceof Promise ? i.then((o) => b2(o, n.value)) : b2(i, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, r);
  };
}), Xre = /* @__PURE__ */ ce("$ZodExactOptional", (e, t) => {
  D3.init(e, t), ht(e._zod, "values", () => t.innerType._zod.values), ht(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (n, r) => t.innerType._zod.run(n, r);
}), eie = /* @__PURE__ */ ce("$ZodNullable", (e, t) => {
  en.init(e, t), ht(e._zod, "optin", () => t.innerType._zod.optin), ht(e._zod, "optout", () => t.innerType._zod.optout), ht(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Q0(n.source)}|null)$`) : void 0;
  }), ht(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), tie = /* @__PURE__ */ ce("$ZodDefault", (e, t) => {
  en.init(e, t), e._zod.optin = "optional", ht(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => _2(o, t)) : _2(i, t);
  };
});
function _2(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const nie = /* @__PURE__ */ ce("$ZodPrefault", (e, t) => {
  en.init(e, t), e._zod.optin = "optional", ht(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (r.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), rie = /* @__PURE__ */ ce("$ZodNonOptional", (e, t) => {
  en.init(e, t), ht(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => w2(o, e)) : w2(i, e);
  };
});
function w2(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const iie = /* @__PURE__ */ ce("$ZodCatch", (e, t) => {
  en.init(e, t), ht(e._zod, "optin", () => t.innerType._zod.optin), ht(e._zod, "optout", () => t.innerType._zod.optout), ht(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((a) => Ta(a, r, $a()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((o) => Ta(o, r, $a()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), oie = /* @__PURE__ */ ce("$ZodPipe", (e, t) => {
  en.init(e, t), ht(e._zod, "values", () => t.in._zod.values), ht(e._zod, "optin", () => t.in._zod.optin), ht(e._zod, "optout", () => t.out._zod.optout), ht(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, r) => {
    if (r.direction === "backward") {
      const o = t.out._zod.run(n, r);
      return o instanceof Promise ? o.then((a) => pf(a, t.in, r)) : pf(o, t.in, r);
    }
    const i = t.in._zod.run(n, r);
    return i instanceof Promise ? i.then((o) => pf(o, t.out, r)) : pf(i, t.out, r);
  };
});
function pf(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const aie = /* @__PURE__ */ ce("$ZodReadonly", (e, t) => {
  en.init(e, t), ht(e._zod, "propValues", () => t.innerType._zod.propValues), ht(e._zod, "values", () => t.innerType._zod.values), ht(e._zod, "optin", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optin;
  }), ht(e._zod, "optout", () => {
    var n, r;
    return (r = (n = t.innerType) == null ? void 0 : n._zod) == null ? void 0 : r.optout;
  }), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      return t.innerType._zod.run(n, r);
    const i = t.innerType._zod.run(n, r);
    return i instanceof Promise ? i.then(x2) : x2(i);
  };
});
function x2(e) {
  return e.value = Object.freeze(e.value), e;
}
const sie = /* @__PURE__ */ ce("$ZodCustom", (e, t) => {
  Yn.init(e, t), en.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, i = t.fn(r);
    if (i instanceof Promise)
      return i.then((o) => E2(o, n, r, e));
    E2(i, n, r, e);
  };
});
function E2(e, t, n, r) {
  if (!e) {
    const i = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (i.params = r._zod.def.params), t.issues.push(Ju(i));
  }
}
var S2;
class lie {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    return this._map.set(t, r), r && typeof r == "object" && "id" in r && this._idmap.set(r.id, t), this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      delete r.id;
      const i = { ...r, ...this._map.get(t) };
      return Object.keys(i).length ? i : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function uie() {
  return new lie();
}
(S2 = globalThis).__zod_globalRegistry ?? (S2.__zod_globalRegistry = uie());
const Jl = globalThis.__zod_globalRegistry;
// @__NO_SIDE_EFFECTS__
function cie(e, t) {
  return new e({
    type: "string",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function fie(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function O2(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function die(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function pie(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function hie(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function vie(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function mie(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function gie(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function yie(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function bie(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function _ie(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function wie(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function xie(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Eie(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Sie(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Oie(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $ie(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Tie(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function kie(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Pie(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Die(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Aie(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Cie(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Iie(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Nie(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Rie(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Mie(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function jie(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function Fie(e, t) {
  return new e({
    type: "boolean",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function zie(e) {
  return new e({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function Lie(e, t) {
  return new e({
    type: "never",
    ...Ue(t)
  });
}
// @__NO_SIDE_EFFECTS__
function $2(e, t) {
  return new S3({
    check: "less_than",
    ...Ue(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function Fv(e, t) {
  return new S3({
    check: "less_than",
    ...Ue(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function T2(e, t) {
  return new O3({
    check: "greater_than",
    ...Ue(t),
    value: e,
    inclusive: !1
  });
}
// @__NO_SIDE_EFFECTS__
function zv(e, t) {
  return new O3({
    check: "greater_than",
    ...Ue(t),
    value: e,
    inclusive: !0
  });
}
// @__NO_SIDE_EFFECTS__
function k2(e, t) {
  return new rre({
    check: "multiple_of",
    ...Ue(t),
    value: e
  });
}
// @__NO_SIDE_EFFECTS__
function A3(e, t) {
  return new ore({
    check: "max_length",
    ...Ue(t),
    maximum: e
  });
}
// @__NO_SIDE_EFFECTS__
function Kd(e, t) {
  return new are({
    check: "min_length",
    ...Ue(t),
    minimum: e
  });
}
// @__NO_SIDE_EFFECTS__
function C3(e, t) {
  return new sre({
    check: "length_equals",
    ...Ue(t),
    length: e
  });
}
// @__NO_SIDE_EFFECTS__
function Vie(e, t) {
  return new lre({
    check: "string_format",
    format: "regex",
    ...Ue(t),
    pattern: e
  });
}
// @__NO_SIDE_EFFECTS__
function Bie(e) {
  return new ure({
    check: "string_format",
    format: "lowercase",
    ...Ue(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Uie(e) {
  return new cre({
    check: "string_format",
    format: "uppercase",
    ...Ue(e)
  });
}
// @__NO_SIDE_EFFECTS__
function Kie(e, t) {
  return new fre({
    check: "string_format",
    format: "includes",
    ...Ue(t),
    includes: e
  });
}
// @__NO_SIDE_EFFECTS__
function qie(e, t) {
  return new dre({
    check: "string_format",
    format: "starts_with",
    ...Ue(t),
    prefix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Hie(e, t) {
  return new pre({
    check: "string_format",
    format: "ends_with",
    ...Ue(t),
    suffix: e
  });
}
// @__NO_SIDE_EFFECTS__
function Sl(e) {
  return new hre({
    check: "overwrite",
    tx: e
  });
}
// @__NO_SIDE_EFFECTS__
function Wie(e) {
  return /* @__PURE__ */ Sl((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function Zie() {
  return /* @__PURE__ */ Sl((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function Gie() {
  return /* @__PURE__ */ Sl((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function Yie() {
  return /* @__PURE__ */ Sl((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Qie() {
  return /* @__PURE__ */ Sl((e) => sne(e));
}
// @__NO_SIDE_EFFECTS__
function Jie(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...Ue(n)
  });
}
// @__NO_SIDE_EFFECTS__
function Xie(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...Ue(n)
  });
}
// @__NO_SIDE_EFFECTS__
function eoe(e) {
  const t = /* @__PURE__ */ toe((n) => (n.addIssue = (r) => {
    if (typeof r == "string")
      n.issues.push(Ju(r, n.value, t._zod.def));
    else {
      const i = r;
      i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = t), i.continue ?? (i.continue = !t._zod.def.abort), n.issues.push(Ju(i));
    }
  }, e(n.value, n)));
  return t;
}
// @__NO_SIDE_EFFECTS__
function toe(e, t) {
  const n = new Yn({
    check: "custom",
    ...Ue(t)
  });
  return n._zod.check = e, n;
}
function I3(e) {
  let t = e?.target ?? "draft-2020-12";
  return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
    processors: e.processors ?? {},
    metadataRegistry: e?.metadata ?? Jl,
    target: t,
    unrepresentable: e?.unrepresentable ?? "throw",
    override: e?.override ?? (() => {
    }),
    io: e?.io ?? "output",
    counter: 0,
    seen: /* @__PURE__ */ new Map(),
    cycles: e?.cycles ?? "ref",
    reused: e?.reused ?? "inline",
    external: e?.external ?? void 0
  };
}
function yn(e, t, n = { path: [], schemaPath: [] }) {
  var r, i, o;
  const a = e._zod.def, s = t.seen.get(e);
  if (s)
    return s.count++, n.schemaPath.includes(e) && (s.cycle = n.path), s.schema;
  const l = { schema: {}, count: 1, cycle: void 0, path: n.path };
  t.seen.set(e, l);
  const u = (i = (r = e._zod).toJSONSchema) == null ? void 0 : i.call(r);
  if (u)
    l.schema = u;
  else {
    const f = {
      ...n,
      schemaPath: [...n.schemaPath, e],
      path: n.path
    };
    if (e._zod.processJSONSchema)
      e._zod.processJSONSchema(t, l.schema, f);
    else {
      const p = l.schema, h = t.processors[a.type];
      if (!h)
        throw new Error(`[toJSONSchema]: Non-representable type encountered: ${a.type}`);
      h(e, t, p, f);
    }
    const d = e._zod.parent;
    d && (l.ref || (l.ref = d), yn(d, t, f), t.seen.get(d).isParent = !0);
  }
  const c = t.metadataRegistry.get(e);
  return c && Object.assign(l.schema, c), t.io === "input" && kn(e) && (delete l.schema.examples, delete l.schema.default), t.io === "input" && l.schema._prefault && ((o = l.schema).default ?? (o.default = l.schema._prefault)), delete l.schema._prefault, t.seen.get(e).schema;
}
function N3(e, t) {
  var n, r, i, o;
  const a = e.seen.get(t);
  if (!a)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const s = /* @__PURE__ */ new Map();
  for (const c of e.seen.entries()) {
    const f = (n = e.metadataRegistry.get(c[0])) == null ? void 0 : n.id;
    if (f) {
      const d = s.get(f);
      if (d && d !== c[0])
        throw new Error(`Duplicate schema id "${f}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
      s.set(f, c[0]);
    }
  }
  const l = (c) => {
    var f;
    const d = e.target === "draft-2020-12" ? "$defs" : "definitions";
    if (e.external) {
      const v = (f = e.external.registry.get(c[0])) == null ? void 0 : f.id, m = e.external.uri ?? ((y) => y);
      if (v)
        return { ref: m(v) };
      const g = c[1].defId ?? c[1].schema.id ?? `schema${e.counter++}`;
      return c[1].defId = g, { defId: g, ref: `${m("__shared")}#/${d}/${g}` };
    }
    if (c[1] === a)
      return { ref: "#" };
    const p = `#/${d}/`, h = c[1].schema.id ?? `__schema${e.counter++}`;
    return { defId: h, ref: p + h };
  }, u = (c) => {
    if (c[1].schema.$ref)
      return;
    const f = c[1], { ref: d, defId: p } = l(c);
    f.def = { ...f.schema }, p && (f.defId = p);
    const h = f.schema;
    for (const v in h)
      delete h[v];
    h.$ref = d;
  };
  if (e.cycles === "throw")
    for (const c of e.seen.entries()) {
      const f = c[1];
      if (f.cycle)
        throw new Error(`Cycle detected: #/${(r = f.cycle) == null ? void 0 : r.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
    }
  for (const c of e.seen.entries()) {
    const f = c[1];
    if (t === c[0]) {
      u(c);
      continue;
    }
    if (e.external) {
      const d = (i = e.external.registry.get(c[0])) == null ? void 0 : i.id;
      if (t !== c[0] && d) {
        u(c);
        continue;
      }
    }
    if ((o = e.metadataRegistry.get(c[0])) != null && o.id) {
      u(c);
      continue;
    }
    if (f.cycle) {
      u(c);
      continue;
    }
    if (f.count > 1 && e.reused === "ref") {
      u(c);
      continue;
    }
  }
}
function R3(e, t) {
  var n, r, i;
  const o = e.seen.get(t);
  if (!o)
    throw new Error("Unprocessed schema. This is a bug in Zod.");
  const a = (u) => {
    const c = e.seen.get(u);
    if (c.ref === null)
      return;
    const f = c.def ?? c.schema, d = { ...f }, p = c.ref;
    if (c.ref = null, p) {
      a(p);
      const v = e.seen.get(p), m = v.schema;
      if (m.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (f.allOf = f.allOf ?? [], f.allOf.push(m)) : Object.assign(f, m), Object.assign(f, d), u._zod.parent === p)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in d || delete f[g];
      if (m.$ref && v.def)
        for (const g in f)
          g === "$ref" || g === "allOf" || g in v.def && JSON.stringify(f[g]) === JSON.stringify(v.def[g]) && delete f[g];
    }
    const h = u._zod.parent;
    if (h && h !== p) {
      a(h);
      const v = e.seen.get(h);
      if (v != null && v.schema.$ref && (f.$ref = v.schema.$ref, v.def))
        for (const m in f)
          m === "$ref" || m === "allOf" || m in v.def && JSON.stringify(f[m]) === JSON.stringify(v.def[m]) && delete f[m];
    }
    e.override({
      zodSchema: u,
      jsonSchema: f,
      path: c.path ?? []
    });
  };
  for (const u of [...e.seen.entries()].reverse())
    a(u[0]);
  const s = {};
  if (e.target === "draft-2020-12" ? s.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? s.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? s.$schema = "http://json-schema.org/draft-04/schema#" : e.target, (n = e.external) != null && n.uri) {
    const u = (r = e.external.registry.get(t)) == null ? void 0 : r.id;
    if (!u)
      throw new Error("Schema is missing an `id` property");
    s.$id = e.external.uri(u);
  }
  Object.assign(s, o.def ?? o.schema);
  const l = ((i = e.external) == null ? void 0 : i.defs) ?? {};
  for (const u of e.seen.entries()) {
    const c = u[1];
    c.def && c.defId && (l[c.defId] = c.def);
  }
  e.external || Object.keys(l).length > 0 && (e.target === "draft-2020-12" ? s.$defs = l : s.definitions = l);
  try {
    const u = JSON.parse(JSON.stringify(s));
    return Object.defineProperty(u, "~standard", {
      value: {
        ...t["~standard"],
        jsonSchema: {
          input: qd(t, "input", e.processors),
          output: qd(t, "output", e.processors)
        }
      },
      enumerable: !1,
      writable: !1
    }), u;
  } catch {
    throw new Error("Error converting schema to JSON.");
  }
}
function kn(e, t) {
  const n = t ?? { seen: /* @__PURE__ */ new Set() };
  if (n.seen.has(e))
    return !1;
  n.seen.add(e);
  const r = e._zod.def;
  if (r.type === "transform")
    return !0;
  if (r.type === "array")
    return kn(r.element, n);
  if (r.type === "set")
    return kn(r.valueType, n);
  if (r.type === "lazy")
    return kn(r.getter(), n);
  if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault")
    return kn(r.innerType, n);
  if (r.type === "intersection")
    return kn(r.left, n) || kn(r.right, n);
  if (r.type === "record" || r.type === "map")
    return kn(r.keyType, n) || kn(r.valueType, n);
  if (r.type === "pipe")
    return kn(r.in, n) || kn(r.out, n);
  if (r.type === "object") {
    for (const i in r.shape)
      if (kn(r.shape[i], n))
        return !0;
    return !1;
  }
  if (r.type === "union") {
    for (const i of r.options)
      if (kn(i, n))
        return !0;
    return !1;
  }
  if (r.type === "tuple") {
    for (const i of r.items)
      if (kn(i, n))
        return !0;
    return !!(r.rest && kn(r.rest, n));
  }
  return !1;
}
const noe = (e, t = {}) => (n) => {
  const r = I3({ ...n, processors: t });
  return yn(e, r), N3(r, e), R3(r, e);
}, qd = (e, t, n = {}) => (r) => {
  const { libraryOptions: i, target: o } = r ?? {}, a = I3({ ...i ?? {}, target: o, io: t, processors: n });
  return yn(e, a), N3(a, e), R3(a, e);
}, roe = {
  guid: "uuid",
  url: "uri",
  datetime: "date-time",
  json_string: "json-string",
  regex: ""
  // do not set
}, ioe = (e, t, n, r) => {
  const i = n;
  i.type = "string";
  const { minimum: o, maximum: a, format: s, patterns: l, contentEncoding: u } = e._zod.bag;
  if (typeof o == "number" && (i.minLength = o), typeof a == "number" && (i.maxLength = a), s && (i.format = roe[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), u && (i.contentEncoding = u), l && l.size > 0) {
    const c = [...l];
    c.length === 1 ? i.pattern = c[0].source : c.length > 1 && (i.allOf = [
      ...c.map((f) => ({
        ...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
        pattern: f.source
      }))
    ]);
  }
}, ooe = (e, t, n, r) => {
  const i = n, { minimum: o, maximum: a, format: s, multipleOf: l, exclusiveMaximum: u, exclusiveMinimum: c } = e._zod.bag;
  typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number", typeof c == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.minimum = c, i.exclusiveMinimum = !0) : i.exclusiveMinimum = c), typeof o == "number" && (i.minimum = o, typeof c == "number" && t.target !== "draft-04" && (c >= o ? delete i.minimum : delete i.exclusiveMinimum)), typeof u == "number" && (t.target === "draft-04" || t.target === "openapi-3.0" ? (i.maximum = u, i.exclusiveMaximum = !0) : i.exclusiveMaximum = u), typeof a == "number" && (i.maximum = a, typeof u == "number" && t.target !== "draft-04" && (u <= a ? delete i.maximum : delete i.exclusiveMaximum)), typeof l == "number" && (i.multipleOf = l);
}, aoe = (e, t, n, r) => {
  n.type = "boolean";
}, soe = (e, t, n, r) => {
  n.not = {};
}, loe = (e, t, n, r) => {
}, uoe = (e, t, n, r) => {
  const i = e._zod.def, o = p3(i.entries);
  o.every((a) => typeof a == "number") && (n.type = "number"), o.every((a) => typeof a == "string") && (n.type = "string"), n.enum = o;
}, coe = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Custom types cannot be represented in JSON Schema");
}, foe = (e, t, n, r) => {
  if (t.unrepresentable === "throw")
    throw new Error("Transforms cannot be represented in JSON Schema");
}, doe = (e, t, n, r) => {
  const i = n, o = e._zod.def, { minimum: a, maximum: s } = e._zod.bag;
  typeof a == "number" && (i.minItems = a), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = yn(o.element, t, { ...r, path: [...r.path, "items"] });
}, poe = (e, t, n, r) => {
  var i;
  const o = n, a = e._zod.def;
  o.type = "object", o.properties = {};
  const s = a.shape;
  for (const c in s)
    o.properties[c] = yn(s[c], t, {
      ...r,
      path: [...r.path, "properties", c]
    });
  const l = new Set(Object.keys(s)), u = new Set([...l].filter((c) => {
    const f = a.shape[c]._zod;
    return t.io === "input" ? f.optin === void 0 : f.optout === void 0;
  }));
  u.size > 0 && (o.required = Array.from(u)), ((i = a.catchall) == null ? void 0 : i._zod.def.type) === "never" ? o.additionalProperties = !1 : a.catchall ? a.catchall && (o.additionalProperties = yn(a.catchall, t, {
    ...r,
    path: [...r.path, "additionalProperties"]
  })) : t.io === "output" && (o.additionalProperties = !1);
}, hoe = (e, t, n, r) => {
  const i = e._zod.def, o = i.inclusive === !1, a = i.options.map((s, l) => yn(s, t, {
    ...r,
    path: [...r.path, o ? "oneOf" : "anyOf", l]
  }));
  o ? n.oneOf = a : n.anyOf = a;
}, voe = (e, t, n, r) => {
  const i = e._zod.def, o = yn(i.left, t, {
    ...r,
    path: [...r.path, "allOf", 0]
  }), a = yn(i.right, t, {
    ...r,
    path: [...r.path, "allOf", 1]
  }), s = (u) => "allOf" in u && Object.keys(u).length === 1, l = [
    ...s(o) ? o.allOf : [o],
    ...s(a) ? a.allOf : [a]
  ];
  n.allOf = l;
}, moe = (e, t, n, r) => {
  const i = e._zod.def, o = yn(i.innerType, t, r), a = t.seen.get(e);
  t.target === "openapi-3.0" ? (a.ref = i.innerType, n.nullable = !0) : n.anyOf = [o, { type: "null" }];
}, goe = (e, t, n, r) => {
  const i = e._zod.def;
  yn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, yoe = (e, t, n, r) => {
  const i = e._zod.def;
  yn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, boe = (e, t, n, r) => {
  const i = e._zod.def;
  yn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, _oe = (e, t, n, r) => {
  const i = e._zod.def;
  yn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
  let a;
  try {
    a = i.catchValue(void 0);
  } catch {
    throw new Error("Dynamic catch values are not supported in JSON Schema");
  }
  n.default = a;
}, woe = (e, t, n, r) => {
  const i = e._zod.def, o = t.io === "input" ? i.in._zod.def.type === "transform" ? i.out : i.in : i.out;
  yn(o, t, r);
  const a = t.seen.get(e);
  a.ref = o;
}, xoe = (e, t, n, r) => {
  const i = e._zod.def;
  yn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType, n.readOnly = !0;
}, M3 = (e, t, n, r) => {
  const i = e._zod.def;
  yn(i.innerType, t, r);
  const o = t.seen.get(e);
  o.ref = i.innerType;
}, Eoe = /* @__PURE__ */ ce("ZodISODateTime", (e, t) => {
  kre.init(e, t), Kt.init(e, t);
});
function Soe(e) {
  return /* @__PURE__ */ Cie(Eoe, e);
}
const Ooe = /* @__PURE__ */ ce("ZodISODate", (e, t) => {
  Pre.init(e, t), Kt.init(e, t);
});
function $oe(e) {
  return /* @__PURE__ */ Iie(Ooe, e);
}
const Toe = /* @__PURE__ */ ce("ZodISOTime", (e, t) => {
  Dre.init(e, t), Kt.init(e, t);
});
function koe(e) {
  return /* @__PURE__ */ Nie(Toe, e);
}
const Poe = /* @__PURE__ */ ce("ZodISODuration", (e, t) => {
  Are.init(e, t), Kt.init(e, t);
});
function Doe(e) {
  return /* @__PURE__ */ Rie(Poe, e);
}
const Aoe = (e, t) => {
  y3.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => _ne(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => bne(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, ey, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, ey, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Nr = ce("ZodError", Aoe, {
  Parent: Error
}), Coe = /* @__PURE__ */ X0(Nr), Ioe = /* @__PURE__ */ e_(Nr), Noe = /* @__PURE__ */ rh(Nr), Roe = /* @__PURE__ */ ih(Nr), Moe = /* @__PURE__ */ Ene(Nr), joe = /* @__PURE__ */ Sne(Nr), Foe = /* @__PURE__ */ One(Nr), zoe = /* @__PURE__ */ $ne(Nr), Loe = /* @__PURE__ */ Tne(Nr), Voe = /* @__PURE__ */ kne(Nr), Boe = /* @__PURE__ */ Pne(Nr), Uoe = /* @__PURE__ */ Dne(Nr), tn = /* @__PURE__ */ ce("ZodType", (e, t) => (en.init(e, t), Object.assign(e["~standard"], {
  jsonSchema: {
    input: qd(e, "input"),
    output: qd(e, "output")
  }
}), e.toJSONSchema = noe(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(Uo(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
  ]
}), {
  parent: !0
}), e.with = e.check, e.clone = (n, r) => Ko(e, n, r), e.brand = () => e, e.register = ((n, r) => (n.add(e, r), e)), e.parse = (n, r) => Coe(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => Noe(e, n, r), e.parseAsync = async (n, r) => Ioe(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => Roe(e, n, r), e.spa = e.safeParseAsync, e.encode = (n, r) => Moe(e, n, r), e.decode = (n, r) => joe(e, n, r), e.encodeAsync = async (n, r) => Foe(e, n, r), e.decodeAsync = async (n, r) => zoe(e, n, r), e.safeEncode = (n, r) => Loe(e, n, r), e.safeDecode = (n, r) => Voe(e, n, r), e.safeEncodeAsync = async (n, r) => Boe(e, n, r), e.safeDecodeAsync = async (n, r) => Uoe(e, n, r), e.refine = (n, r) => e.check(Rae(n, r)), e.superRefine = (n) => e.check(Mae(n)), e.overwrite = (n) => e.check(/* @__PURE__ */ Sl(n)), e.optional = () => A2(e), e.exactOptional = () => xae(e), e.nullable = () => C2(e), e.nullish = () => A2(C2(e)), e.nonoptional = (n) => kae(e, n), e.array = () => st(e), e.or = (n) => mae([e, n]), e.and = (n) => yae(e, n), e.transform = (n) => I2(e, _ae(n)), e.default = (n) => Oae(e, n), e.prefault = (n) => Tae(e, n), e.catch = (n) => Dae(e, n), e.pipe = (n) => I2(e, n), e.readonly = () => Iae(e), e.describe = (n) => {
  const r = e.clone();
  return Jl.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = Jl.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Jl.get(e);
  const r = e.clone();
  return Jl.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e.apply = (n) => n(e), e)), j3 = /* @__PURE__ */ ce("_ZodString", (e, t) => {
  t_.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (r, i, o) => ioe(e, r, i);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(/* @__PURE__ */ Vie(...r)), e.includes = (...r) => e.check(/* @__PURE__ */ Kie(...r)), e.startsWith = (...r) => e.check(/* @__PURE__ */ qie(...r)), e.endsWith = (...r) => e.check(/* @__PURE__ */ Hie(...r)), e.min = (...r) => e.check(/* @__PURE__ */ Kd(...r)), e.max = (...r) => e.check(/* @__PURE__ */ A3(...r)), e.length = (...r) => e.check(/* @__PURE__ */ C3(...r)), e.nonempty = (...r) => e.check(/* @__PURE__ */ Kd(1, ...r)), e.lowercase = (r) => e.check(/* @__PURE__ */ Bie(r)), e.uppercase = (r) => e.check(/* @__PURE__ */ Uie(r)), e.trim = () => e.check(/* @__PURE__ */ Zie()), e.normalize = (...r) => e.check(/* @__PURE__ */ Wie(...r)), e.toLowerCase = () => e.check(/* @__PURE__ */ Gie()), e.toUpperCase = () => e.check(/* @__PURE__ */ Yie()), e.slugify = () => e.check(/* @__PURE__ */ Qie());
}), Koe = /* @__PURE__ */ ce("ZodString", (e, t) => {
  t_.init(e, t), j3.init(e, t), e.email = (n) => e.check(/* @__PURE__ */ fie(qoe, n)), e.url = (n) => e.check(/* @__PURE__ */ mie(Hoe, n)), e.jwt = (n) => e.check(/* @__PURE__ */ Aie(sae, n)), e.emoji = (n) => e.check(/* @__PURE__ */ gie(Woe, n)), e.guid = (n) => e.check(/* @__PURE__ */ O2(P2, n)), e.uuid = (n) => e.check(/* @__PURE__ */ die(hf, n)), e.uuidv4 = (n) => e.check(/* @__PURE__ */ pie(hf, n)), e.uuidv6 = (n) => e.check(/* @__PURE__ */ hie(hf, n)), e.uuidv7 = (n) => e.check(/* @__PURE__ */ vie(hf, n)), e.nanoid = (n) => e.check(/* @__PURE__ */ yie(Zoe, n)), e.guid = (n) => e.check(/* @__PURE__ */ O2(P2, n)), e.cuid = (n) => e.check(/* @__PURE__ */ bie(Goe, n)), e.cuid2 = (n) => e.check(/* @__PURE__ */ _ie(Yoe, n)), e.ulid = (n) => e.check(/* @__PURE__ */ wie(Qoe, n)), e.base64 = (n) => e.check(/* @__PURE__ */ kie(iae, n)), e.base64url = (n) => e.check(/* @__PURE__ */ Pie(oae, n)), e.xid = (n) => e.check(/* @__PURE__ */ xie(Joe, n)), e.ksuid = (n) => e.check(/* @__PURE__ */ Eie(Xoe, n)), e.ipv4 = (n) => e.check(/* @__PURE__ */ Sie(eae, n)), e.ipv6 = (n) => e.check(/* @__PURE__ */ Oie(tae, n)), e.cidrv4 = (n) => e.check(/* @__PURE__ */ $ie(nae, n)), e.cidrv6 = (n) => e.check(/* @__PURE__ */ Tie(rae, n)), e.e164 = (n) => e.check(/* @__PURE__ */ Die(aae, n)), e.datetime = (n) => e.check(Soe(n)), e.date = (n) => e.check($oe(n)), e.time = (n) => e.check(koe(n)), e.duration = (n) => e.check(Doe(n));
});
function oe(e) {
  return /* @__PURE__ */ cie(Koe, e);
}
const Kt = /* @__PURE__ */ ce("ZodStringFormat", (e, t) => {
  Ft.init(e, t), j3.init(e, t);
}), qoe = /* @__PURE__ */ ce("ZodEmail", (e, t) => {
  bre.init(e, t), Kt.init(e, t);
}), P2 = /* @__PURE__ */ ce("ZodGUID", (e, t) => {
  gre.init(e, t), Kt.init(e, t);
}), hf = /* @__PURE__ */ ce("ZodUUID", (e, t) => {
  yre.init(e, t), Kt.init(e, t);
}), Hoe = /* @__PURE__ */ ce("ZodURL", (e, t) => {
  _re.init(e, t), Kt.init(e, t);
}), Woe = /* @__PURE__ */ ce("ZodEmoji", (e, t) => {
  wre.init(e, t), Kt.init(e, t);
}), Zoe = /* @__PURE__ */ ce("ZodNanoID", (e, t) => {
  xre.init(e, t), Kt.init(e, t);
}), Goe = /* @__PURE__ */ ce("ZodCUID", (e, t) => {
  Ere.init(e, t), Kt.init(e, t);
}), Yoe = /* @__PURE__ */ ce("ZodCUID2", (e, t) => {
  Sre.init(e, t), Kt.init(e, t);
}), Qoe = /* @__PURE__ */ ce("ZodULID", (e, t) => {
  Ore.init(e, t), Kt.init(e, t);
}), Joe = /* @__PURE__ */ ce("ZodXID", (e, t) => {
  $re.init(e, t), Kt.init(e, t);
}), Xoe = /* @__PURE__ */ ce("ZodKSUID", (e, t) => {
  Tre.init(e, t), Kt.init(e, t);
}), eae = /* @__PURE__ */ ce("ZodIPv4", (e, t) => {
  Cre.init(e, t), Kt.init(e, t);
}), tae = /* @__PURE__ */ ce("ZodIPv6", (e, t) => {
  Ire.init(e, t), Kt.init(e, t);
}), nae = /* @__PURE__ */ ce("ZodCIDRv4", (e, t) => {
  Nre.init(e, t), Kt.init(e, t);
}), rae = /* @__PURE__ */ ce("ZodCIDRv6", (e, t) => {
  Rre.init(e, t), Kt.init(e, t);
}), iae = /* @__PURE__ */ ce("ZodBase64", (e, t) => {
  Mre.init(e, t), Kt.init(e, t);
}), oae = /* @__PURE__ */ ce("ZodBase64URL", (e, t) => {
  Fre.init(e, t), Kt.init(e, t);
}), aae = /* @__PURE__ */ ce("ZodE164", (e, t) => {
  zre.init(e, t), Kt.init(e, t);
}), sae = /* @__PURE__ */ ce("ZodJWT", (e, t) => {
  Vre.init(e, t), Kt.init(e, t);
}), F3 = /* @__PURE__ */ ce("ZodNumber", (e, t) => {
  T3.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (r, i, o) => ooe(e, r, i), e.gt = (r, i) => e.check(/* @__PURE__ */ T2(r, i)), e.gte = (r, i) => e.check(/* @__PURE__ */ zv(r, i)), e.min = (r, i) => e.check(/* @__PURE__ */ zv(r, i)), e.lt = (r, i) => e.check(/* @__PURE__ */ $2(r, i)), e.lte = (r, i) => e.check(/* @__PURE__ */ Fv(r, i)), e.max = (r, i) => e.check(/* @__PURE__ */ Fv(r, i)), e.int = (r) => e.check(D2(r)), e.safe = (r) => e.check(D2(r)), e.positive = (r) => e.check(/* @__PURE__ */ T2(0, r)), e.nonnegative = (r) => e.check(/* @__PURE__ */ zv(0, r)), e.negative = (r) => e.check(/* @__PURE__ */ $2(0, r)), e.nonpositive = (r) => e.check(/* @__PURE__ */ Fv(0, r)), e.multipleOf = (r, i) => e.check(/* @__PURE__ */ k2(r, i)), e.step = (r, i) => e.check(/* @__PURE__ */ k2(r, i)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function ke(e) {
  return /* @__PURE__ */ Mie(F3, e);
}
const lae = /* @__PURE__ */ ce("ZodNumberFormat", (e, t) => {
  Bre.init(e, t), F3.init(e, t);
});
function D2(e) {
  return /* @__PURE__ */ jie(lae, e);
}
const uae = /* @__PURE__ */ ce("ZodBoolean", (e, t) => {
  Ure.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => aoe(e, n, r);
});
function lr(e) {
  return /* @__PURE__ */ Fie(uae, e);
}
const cae = /* @__PURE__ */ ce("ZodUnknown", (e, t) => {
  Kre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => loe();
});
function Hd() {
  return /* @__PURE__ */ zie(cae);
}
const fae = /* @__PURE__ */ ce("ZodNever", (e, t) => {
  qre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => soe(e, n, r);
});
function dae(e) {
  return /* @__PURE__ */ Lie(fae, e);
}
const pae = /* @__PURE__ */ ce("ZodArray", (e, t) => {
  Hre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => doe(e, n, r, i), e.element = t.element, e.min = (n, r) => e.check(/* @__PURE__ */ Kd(n, r)), e.nonempty = (n) => e.check(/* @__PURE__ */ Kd(1, n)), e.max = (n, r) => e.check(/* @__PURE__ */ A3(n, r)), e.length = (n, r) => e.check(/* @__PURE__ */ C3(n, r)), e.unwrap = () => e.element;
});
function st(e, t) {
  return /* @__PURE__ */ Jie(pae, e, t);
}
const hae = /* @__PURE__ */ ce("ZodObject", (e, t) => {
  Zre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => poe(e, n, r, i), ht(e, "shape", () => t.shape), e.keyof = () => Pi(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Hd() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Hd() }), e.strict = () => e.clone({ ...e._zod.def, catchall: dae() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => hne(e, n), e.safeExtend = (n) => vne(e, n), e.merge = (n) => mne(e, n), e.pick = (n) => dne(e, n), e.omit = (n) => pne(e, n), e.partial = (...n) => gne(z3, e, n[0]), e.required = (...n) => yne(L3, e, n[0]);
});
function he(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...Ue(t)
  };
  return new hae(n);
}
const vae = /* @__PURE__ */ ce("ZodUnion", (e, t) => {
  Gre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => hoe(e, n, r, i), e.options = t.options;
});
function mae(e, t) {
  return new vae({
    type: "union",
    options: e,
    ...Ue(t)
  });
}
const gae = /* @__PURE__ */ ce("ZodIntersection", (e, t) => {
  Yre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => voe(e, n, r, i);
});
function yae(e, t) {
  return new gae({
    type: "intersection",
    left: e,
    right: t
  });
}
const ny = /* @__PURE__ */ ce("ZodEnum", (e, t) => {
  Qre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (r, i, o) => uoe(e, r, i), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, i) => {
    const o = {};
    for (const a of r)
      if (n.has(a))
        o[a] = t.entries[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new ny({
      ...t,
      checks: [],
      ...Ue(i),
      entries: o
    });
  }, e.exclude = (r, i) => {
    const o = { ...t.entries };
    for (const a of r)
      if (n.has(a))
        delete o[a];
      else
        throw new Error(`Key ${a} not found in enum`);
    return new ny({
      ...t,
      checks: [],
      ...Ue(i),
      entries: o
    });
  };
});
function Pi(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new ny({
    type: "enum",
    entries: n,
    ...Ue(t)
  });
}
const bae = /* @__PURE__ */ ce("ZodTransform", (e, t) => {
  Jre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => foe(e, n), e._zod.parse = (n, r) => {
    if (r.direction === "backward")
      throw new f3(e.constructor.name);
    n.addIssue = (o) => {
      if (typeof o == "string")
        n.issues.push(Ju(o, n.value, t));
      else {
        const a = o;
        a.fatal && (a.continue = !1), a.code ?? (a.code = "custom"), a.input ?? (a.input = n.value), a.inst ?? (a.inst = e), n.issues.push(Ju(a));
      }
    };
    const i = t.transform(n.value, n);
    return i instanceof Promise ? i.then((o) => (n.value = o, n)) : (n.value = i, n);
  };
});
function _ae(e) {
  return new bae({
    type: "transform",
    transform: e
  });
}
const z3 = /* @__PURE__ */ ce("ZodOptional", (e, t) => {
  D3.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => M3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function A2(e) {
  return new z3({
    type: "optional",
    innerType: e
  });
}
const wae = /* @__PURE__ */ ce("ZodExactOptional", (e, t) => {
  Xre.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => M3(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function xae(e) {
  return new wae({
    type: "optional",
    innerType: e
  });
}
const Eae = /* @__PURE__ */ ce("ZodNullable", (e, t) => {
  eie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => moe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function C2(e) {
  return new Eae({
    type: "nullable",
    innerType: e
  });
}
const Sae = /* @__PURE__ */ ce("ZodDefault", (e, t) => {
  tie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => yoe(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Oae(e, t) {
  return new Sae({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : v3(t);
    }
  });
}
const $ae = /* @__PURE__ */ ce("ZodPrefault", (e, t) => {
  nie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => boe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Tae(e, t) {
  return new $ae({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : v3(t);
    }
  });
}
const L3 = /* @__PURE__ */ ce("ZodNonOptional", (e, t) => {
  rie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => goe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function kae(e, t) {
  return new L3({
    type: "nonoptional",
    innerType: e,
    ...Ue(t)
  });
}
const Pae = /* @__PURE__ */ ce("ZodCatch", (e, t) => {
  iie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => _oe(e, n, r, i), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Dae(e, t) {
  return new Pae({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Aae = /* @__PURE__ */ ce("ZodPipe", (e, t) => {
  oie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => woe(e, n, r, i), e.in = t.in, e.out = t.out;
});
function I2(e, t) {
  return new Aae({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Cae = /* @__PURE__ */ ce("ZodReadonly", (e, t) => {
  aie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => xoe(e, n, r, i), e.unwrap = () => e._zod.def.innerType;
});
function Iae(e) {
  return new Cae({
    type: "readonly",
    innerType: e
  });
}
const Nae = /* @__PURE__ */ ce("ZodCustom", (e, t) => {
  sie.init(e, t), tn.init(e, t), e._zod.processJSONSchema = (n, r, i) => coe(e, n);
});
function Rae(e, t = {}) {
  return /* @__PURE__ */ Xie(Nae, e, t);
}
function Mae(e) {
  return /* @__PURE__ */ eoe(e);
}
const jae = he({
  id: oe(),
  name: oe(),
  slug: oe(),
  status: Pi(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  input: he({}).partial().passthrough(),
  output: he({}).partial().passthrough().nullable(),
  createdAt: oe(),
  startedAt: oe().nullable(),
  endedAt: oe().nullable()
}).passthrough();
he({ analyses: st(jae) }).passthrough();
he({
  name: oe().min(1).max(100),
  outputLocation: he({ s3BucketId: ke(), path: oe().optional() }).passthrough(),
  analysisSchemaId: ke().int().gt(0),
  version: ke(),
  input: Hd()
}).passthrough();
he({
  analysisId: oe().nullable(),
  analysisSlug: oe().nullable(),
  success: lr()
}).passthrough();
const Fae = he({ id: ke(), name: oe(), versions: st(ke()) }).passthrough();
he({ analysisSchemas: st(Fae) }).passthrough();
const V3 = he({
  id: ke(),
  name: oe(),
  schema: he({}).partial().passthrough()
}).passthrough(), N2 = he({ id: ke(), name: oe(), valueSchema: V3 }).passthrough(), zae = he({
  analysisSchemaId: ke(),
  version: ke(),
  createdAt: oe(),
  description: he({ short: oe().nullable(), long: oe().nullable() }).partial().passthrough(),
  inputs: st(N2),
  outputs: st(N2)
}).passthrough();
he({ versions: st(zae) }).passthrough();
he({ logs: st(oe()) }).passthrough();
const Lae = he({
  id: oe(),
  name: oe(),
  status: oe(),
  analysisId: oe(),
  startedAt: oe(),
  endedAt: oe(),
  memory: ke(),
  vcpus: ke(),
  cost: ke()
}).passthrough();
he({ tasks: st(Lae) }).passthrough();
he({
  totalCost: ke(),
  tasks: st(he({ name: oe(), cost: ke(), index: ke() }).passthrough()),
  runner: ke()
}).passthrough();
const Vae = he({
  analysisSchemaId: ke(),
  version: ke(),
  name: oe()
}).passthrough();
he({ next: st(Vae) }).passthrough();
he({ valueSchemas: st(V3) }).passthrough();
const Bae = Pi([
  "ADMIN",
  "USER",
  "PROFESSOR",
  "PREMIUM_USER",
  "FREE_USER"
]), B3 = Pi([
  "admin",
  "credits_unlimited",
  "files_read",
  "keypair_read",
  "lab_create",
  "labmember_read",
  "labmember_write",
  "lab_read",
  "plexus_read",
  "plexus_write",
  "tinkerbox_launch",
  "tinkerbox_read",
  "user_update"
]), U3 = he({
  id: oe(),
  firstname: oe().nullable(),
  lastname: oe().nullable(),
  email: oe().nullable(),
  keyPairId: ke(),
  roles: st(Bae),
  permissions: st(B3)
}).passthrough();
he({ user: U3 }).partial().passthrough();
he({ email: oe() }).passthrough();
he({ success: lr() }).passthrough();
he({ otp: oe() }).passthrough();
he({ success: lr() }).passthrough();
const Uae = he({ success: lr() }).passthrough();
he({ token: oe() }).passthrough();
he({ token: oe() }).passthrough();
he({ valid: lr() }).passthrough();
he({ name: oe(), permissions: st(B3) }).passthrough();
const Kae = he({
  id: ke(),
  instanceProfile: oe().nullable(),
  securityGroup: oe().nullable()
}).passthrough(), ah = he({
  id: ke(),
  name: oe(),
  labId: ke().nullish(),
  userId: oe().nullish(),
  status: Pi([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  ipAddress: oe().nullish(),
  lastLogin: oe().nullish(),
  keypairId: ke().nullish()
}).passthrough();
he({
  infra: st(Kae),
  keyPairs: st(oe()),
  tinkerBoxes: st(ah)
}).passthrough();
he({ count: ke().gte(1).lte(15) }).passthrough();
he({
  firstname: oe().min(1),
  lastname: oe().min(1),
  email: oe().email(),
  password: oe().min(8)
}).passthrough();
he({ users: st(U3) }).passthrough();
he({
  firstname: oe().nullable(),
  lastname: oe().nullable(),
  email: oe().nullable()
}).partial().passthrough();
const qae = he({ tinkerBox: ah, keyMaterial: oe() }).passthrough();
he({ tinkerBoxes: st(qae) }).passthrough();
const Hae = he({
  labName: oe(),
  ec2Cost: ke(),
  s3Cost: ke(),
  efsCost: ke(),
  totalCost: ke()
}).passthrough();
he({ clients: st(Hae) }).passthrough();
const Wae = he({
  name: oe(),
  labName: oe(),
  usage: oe(),
  cost: ke()
}).passthrough();
he({ tinkerBoxes: st(Wae) }).passthrough();
he({ tinkerboxes: st(ah) }).passthrough();
he({ tinkerBox: ah }).passthrough();
he({ name: oe() }).passthrough();
const Zae = he({
  id: ke(),
  date: oe(),
  tinkerBoxName: oe(),
  lastLoginDate: oe().nullable(),
  lastCommandDate: oe().nullable(),
  lastCommand: oe().nullable(),
  activeProcesses: lr(),
  status: Pi([
    "pending",
    "running",
    "stopping",
    "stopped",
    "shutting_down",
    "terminated"
  ]),
  tinkerBoxId: ke(),
  autoStopTime: oe().nullable()
}).passthrough();
he({ allLastActivity: st(Zae) }).passthrough();
he({ name: oe().nullable() }).partial().passthrough();
const Gae = he({
  id: ke(),
  name: oe(),
  s3BucketId: ke(),
  keyPairId: ke()
}).passthrough();
he({ labs: st(Gae) }).passthrough();
he({
  name: oe(),
  numTinkerBoxes: ke().optional().default(1)
}).passthrough();
he({ labId: ke(), taskId: oe() }).passthrough();
he({ id: oe(), labId: ke(), logs: oe() }).passthrough();
const K3 = he({
  id: ke(),
  labId: ke(),
  userId: oe(),
  role: Pi(["OWNER", "MEMBER"]),
  user: he({
    firstname: oe().nullable(),
    lastname: oe().nullable(),
    email: oe().nullable(),
    id: oe()
  }).partial().passthrough()
}).passthrough();
he({ labMember: K3.nullable() }).passthrough();
he({ labMembers: st(K3) }).passthrough();
he({
  labMember: he({
    id: ke().int(),
    labId: ke().int(),
    userId: oe(),
    role: Pi(["OWNER", "MEMBER"])
  }).passthrough()
}).passthrough();
he({ role: oe() }).passthrough();
he({ labMemberId: ke(), role: oe() }).passthrough();
he({ success: lr() }).passthrough();
he({
  client_secret: oe().nullable(),
  status: oe().nullable(),
  payment_status: oe()
}).passthrough();
he({ name: oe(), email: oe().email(), message: oe() }).passthrough();
he({ path: oe(), s3BucketId: ke().optional() }).passthrough();
const Yae = he({ success: lr() }).passthrough(), Qae = he({ url: oe() }).passthrough(), Jae = he({
  isFolder: lr(),
  bucketId: ke().optional(),
  path: oe()
}).passthrough(), Xae = he({ contents: st(Jae) }).passthrough(), ese = he({ files: st(oe()) }).passthrough();
he({
  buckets: st(he({
    id: ke().int(),
    bucket: oe(),
    region: oe(),
    prefix: oe().nullish()
  }).passthrough())
}).passthrough();
he({
  source: he({
    isFolder: lr(),
    bucketId: ke().optional(),
    path: oe()
  }).passthrough(),
  target: he({
    isFolder: lr(),
    bucketId: ke().optional(),
    path: oe()
  }).passthrough()
}).passthrough();
const tse = he({
  fileTransfers: st(he({
    id: ke().int(),
    name: oe(),
    userId: oe(),
    progress: ke()
  }).passthrough())
}).passthrough(), nse = he({
  id: ke(),
  name: oe(),
  analysisSchemaId: ke(),
  analysisSchemaVersion: ke(),
  config: he({}).partial().passthrough()
}).passthrough();
he({ templates: st(nse) }).passthrough();
he({
  name: oe().min(1).max(255),
  analysisSchemaId: ke().int(),
  analysisSchemaVersion: ke().int().gt(0),
  triggerLocation: he({
    bucketId: ke().int().gt(0),
    folderPath: oe().max(2048)
  }).passthrough(),
  config: Hd()
}).passthrough();
he({
  id: ke(),
  name: oe(),
  s3BucketId: ke(),
  triggerFolder: oe(),
  analysisSchemaId: ke(),
  analysisSchemaVersion: ke(),
  config: he({}).partial().passthrough()
}).passthrough();
he({ name: oe(), enabled: lr() }).passthrough();
he({
  id: ke(),
  name: oe(),
  schema: he({}).partial().passthrough()
}).passthrough();
he({
  id: ke(),
  formId: ke(),
  data: he({}).partial().passthrough(),
  dateCreated: oe()
}).passthrough();
he({
  id: ke(),
  name: oe(),
  displayName: oe(),
  hichip: oe(),
  source: oe(),
  bucket: oe(),
  bedpeKey: oe(),
  hicKey: oe(),
  category: oe()
}).passthrough();
he({
  id: ke(),
  sampleId: ke(),
  cluster: oe(),
  chr: oe(),
  start: ke(),
  end: ke(),
  size: ke(),
  genes: oe()
}).passthrough();
he({
  plotId: oe(),
  status: Pi(["PENDING", "COMPLETED", "FAILED", "CANCELLED"]),
  outputBucket: oe(),
  outputKey: oe(),
  inputs: he({}).partial().passthrough(),
  endedAt: oe().nullable(),
  downloadUrl: oe().nullable()
}).passthrough();
he({
  sample: oe(),
  range: oe(),
  genomeBuild: Pi(["hg19", "hg38"]),
  color: oe().regex(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/),
  inherent: oe(),
  flank: ke(),
  bedpe: oe()
}).passthrough();
const q3 = he({
  id: ke(),
  title: oe(),
  content: oe(),
  createdAt: oe(),
  updatedAt: oe(),
  isActive: lr()
}).passthrough();
he({ announcements: st(q3) }).passthrough();
he({ announcement: q3.nullable() }).passthrough();
const Ro = {
  SuccessDto: Uae,
  CreateDirectoryResponse: Yae,
  PresignedUrlResponse: Qae,
  ContentsResponse: Xae,
  DeleteFilesResponse: ese,
  FileTransfersResponse: tse
};
class Lv {
  constructor(t) {
    sX(this, "fetch"), this.fetch = t;
  }
  async download(t, n, r = null, i = !0) {
    let o = `/files/presigned/${encodeURIComponent(n)}/url?method=download`;
    t && (o += `&bucket=${t}`), r && (o += `&limit=${r}`);
    const a = (await this.fetch(o, { method: "GET" }, Ro.PresignedUrlResponse)).url;
    if (i) {
      const s = document.createElement("a");
      s.href = a, s.download = "", s.target = "_blank", s.click(), document.body.appendChild(s), s.click(), setTimeout(() => {
        document.body.removeChild(s);
      });
    }
    return a;
  }
  async upload(t, n, r) {
    const i = [];
    let o = `/files/presigned/${encodeURIComponent(r)}/url?method=upload`;
    n && (o = o += `&bucket=${n}`);
    const a = (await this.fetch(o, { method: "GET" }, Ro.PresignedUrlResponse)).url, s = new XMLHttpRequest();
    return s.open("PUT", a), s.addEventListener("error", () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }), s.onerror = () => {
      for (const l of i)
        l.onError(new Error("Failed to upload file"));
    }, s.upload.addEventListener("progress", (l) => {
      const u = l.loaded / l.total;
      for (const c of i)
        c.onProgress(u);
    }), s.upload.addEventListener("load", () => {
      for (const l of i)
        l.onComplete();
      s.upload.removeEventListener("progress", () => null);
    }), s.send(t), {
      subscribe(l) {
        i.push(l);
      }
    };
  }
}
const H3 = ({ className: e = "" }) => /* @__PURE__ */ M.jsx(
  "svg",
  {
    className: `${e} block`,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.81 296.2",
    children: /* @__PURE__ */ M.jsx("g", { children: /* @__PURE__ */ M.jsx("path", { d: "M64.3,112.5C28.5,174.6-.4,225.4,0,225.6s34.7-9.2,76.2-20.7,76.3-21.1,77.4-21.3c1.8-.3,2.3,2.8,9.6,56,4.2,31,7.8,56.5,8,56.6s20.5-15.2,45.2-34.3c29.3-22.7,44.6-35.1,44.4-36.1C260.2,223.6,131.2.4,130.2,0,129.8-.1,100.1,50.5,64.3,112.5Z" }) })
  }
);
function R2(e) {
  Se(() => {
    e && pr.error(e.toString());
  }, [e]);
}
async function rse(e, t, n) {
  await e(
    "/files/directory",
    {
      method: "POST",
      body: JSON.stringify({ s3BucketId: t, path: n })
    },
    Ro.CreateDirectoryResponse
  );
}
const ise = (e) => {
  const t = ay({
    mutationKey: ["createFolder"],
    mutationFn: async (n) => rse(e, n.s3BucketId, n.path)
  });
  return { ...t, createFolder: t.mutateAsync };
};
async function ose(e, t, n) {
  let i = `/files/${encodeURIComponent(t)}?`;
  return n && (i += `&bucket=${n}`), await e(
    i,
    { method: "DELETE" },
    Ro.DeleteFilesResponse
  );
}
const ase = (e) => {
  const t = ay({
    mutationKey: ["deleteFiles"],
    mutationFn: (n) => ose(e, n.path, n.s3BucketId)
  });
  return { ...t, deleteFiles: t.mutateAsync };
};
async function sse(e) {
  return e(
    "/file-transfer",
    { method: "GET" },
    Ro.FileTransfersResponse
  );
}
const lse = (e, t) => K2({
  queryKey: ["file-transfers"],
  queryFn: () => sse(t),
  refetchInterval: 500,
  enabled: e
}), use = async (e, t, n) => await n(
  `/files/?search=${t}&bucket=${e}`,
  {},
  Ro.ContentsResponse
), cse = async (e, t, n) => {
  let i = `/files/${encodeURIComponent(t || "")}?`;
  return e && (i += `bucket=${e}`), await n(i, { method: "GET" }, Ro.ContentsResponse);
}, fse = (e, t, n) => K2({
  queryKey: ["files", e, t],
  queryFn: async () => cse(e, t, n),
  refetchInterval: 2e3
});
async function dse(e, t, n) {
  return n(
    "/files/move",
    {
      method: "POST",
      body: JSON.stringify({ source: e, target: t })
    },
    Ro.SuccessDto
  );
}
function pse(e) {
  const t = ay({
    mutationKey: ["moveFiles"],
    mutationFn: ({ src: n, dest: r }) => dse(n, r, e)
  });
  return { ...t, moveFiles: t.mutateAsync };
}
function hse({
  s3BucketId: e,
  fetch: t,
  selectionMode: n,
  onSelectionChange: r,
  path: i,
  setPath: o,
  readOnly: a = !1,
  selection: s = [],
  className: l = ""
}) {
  const {
    data: u,
    error: c,
    refetch: f
  } = fse(e, i.join("/"), t), [d, p] = Fe(!1), { createFolder: h } = ise(t), { deleteFiles: v, error: m } = ase(t), { moveFiles: g, error: y } = pse(t), { data: w, error: x } = lse(d, t);
  Se(() => {
    w?.fileTransfers && w.fileTransfers.length > 0;
  }, [w]), R2(y), R2(x), vse(w), Se(() => {
    c && pr.error(c.message), m && pr.error(m.message);
  }, [c, m]);
  const S = u?.contents ?? [], O = i.length > 0 ? `/${i.join("/")}` : "/";
  return /* @__PURE__ */ M.jsx(
    rX,
    {
      className: l,
      selectionMode: n,
      filePathHomeDirectory: /* @__PURE__ */ M.jsx(H3, { className: "inline w-3 h-3" }),
      files: S,
      selection: s,
      readOnly: a,
      onSelectionChange: r,
      onDownload: async (P) => {
        await new Lv(t).download(e, P.path, null, !0), f();
      },
      onMoveUpAFolder: async (P) => {
        if (!P) {
          pr.error("Already at root folder");
          return;
        }
        const { path: b, parent: _ } = P;
        await g({
          src: b,
          dest: { isFolder: !0, path: _, bucketId: b.bucketId }
        }), p(!0), await f();
      },
      path: i,
      onNavigate: (P) => {
        o(P);
      },
      onMove: async (P, b) => {
        if (!b.isFolder) {
          pr.error("Target must be a folder");
          return;
        }
        await g({ src: P, dest: b }), await f(), p(!0);
      },
      onSearch: async (P) => (await use(e, P, t)).contents,
      onUpload: function(P) {
        const b = new Lv(t), _ = `${O}/${P[0].name}`;
        return b.upload(P[0], e, _);
      },
      onDelete: async (P) => {
        await v({ s3BucketId: e, path: P[0].path }), await f();
      },
      onCreateFolder: async (P) => {
        await h({ s3BucketId: e, path: P }), await f();
      },
      onPreview: async (P) => {
        await new Lv(t).download(e, P.path), f();
      }
    }
  );
}
const vse = (e) => {
  Se(() => {
    if (e?.fileTransfers.length)
      for (const t of e.fileTransfers)
        pr(t.name, {
          progress: t.progress,
          toastId: t.id
        });
  }, [e]);
};
function zle(e) {
  return /* @__PURE__ */ M.jsx(xI, { client: e.queryClient, children: /* @__PURE__ */ M.jsx(hse, { ...e }) });
}
var vf, mse = new Uint8Array(16);
function gse() {
  if (!vf && (vf = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !vf))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return vf(mse);
}
const yse = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function bse(e) {
  return typeof e == "string" && yse.test(e);
}
var hn = [];
for (var Vv = 0; Vv < 256; ++Vv)
  hn.push((Vv + 256).toString(16).substr(1));
function _se(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (hn[e[t + 0]] + hn[e[t + 1]] + hn[e[t + 2]] + hn[e[t + 3]] + "-" + hn[e[t + 4]] + hn[e[t + 5]] + "-" + hn[e[t + 6]] + hn[e[t + 7]] + "-" + hn[e[t + 8]] + hn[e[t + 9]] + "-" + hn[e[t + 10]] + hn[e[t + 11]] + hn[e[t + 12]] + hn[e[t + 13]] + hn[e[t + 14]] + hn[e[t + 15]]).toLowerCase();
  if (!bse(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function wse(e, t, n) {
  e = e || {};
  var r = e.random || (e.rng || gse)();
  return r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, _se(r);
}
const xse = (e) => {
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e.item(n);
    r && t.push(r);
  }
  return t;
}, Lle = ({
  children: e,
  onChange: t,
  className: n
}) => {
  const r = _e(wse());
  return /* @__PURE__ */ M.jsxs("div", { className: `${n} cursor-pointer`, children: [
    /* @__PURE__ */ M.jsx(
      "label",
      {
        htmlFor: r.current,
        onClick: (i) => i.stopPropagation(),
        className: "cursor-pointer",
        onKeyDown: (i) => {
          i.key === "Enter" && i.stopPropagation();
        },
        children: e
      }
    ),
    /* @__PURE__ */ M.jsx(
      "input",
      {
        onClick: (i) => i.stopPropagation(),
        onChange: (i) => {
          t(i.target.files ? xse(i.target.files) : []);
        },
        className: "absolute w-0 h-0",
        type: "file",
        id: r.current
      }
    )
  ] });
}, Vle = ({ name: e, ...t }) => {
  const [n, r] = EI(e), { capture: i, ...o } = t;
  return /* @__PURE__ */ M.jsxs("div", { children: [
    /* @__PURE__ */ M.jsx(pd, { ...o, ...n, placeholder: t.placeholder || e }),
    r.touched && r.error && /* @__PURE__ */ M.jsx(O7, { children: r.error })
  ] });
};
function Ble({ area: e, children: t, className: n }) {
  return /* @__PURE__ */ M.jsx("div", { className: `${n || ""}`, style: { gridArea: e }, children: t });
}
var Lf = { exports: {} }, Ese = Lf.exports, M2;
function Sse() {
  return M2 || (M2 = 1, (function(e, t) {
    (function(r, i) {
      e.exports = i(W);
    })(Ese, (n) => (
      /******/
      (() => {
        var r = {
          /***/
          "./node_modules/css-mediaquery/index.js": (
            /*!**********************************************!*\
              !*** ./node_modules/css-mediaquery/index.js ***!
              \**********************************************/
            /***/
            ((s, l) => {
              l.match = h, l.parse = v;
              var u = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, c = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, f = /^(?:(min|max)-)?(.+)/, d = /(em|rem|px|cm|mm|in|pt|pc)?$/, p = /(dpi|dpcm|dppx)?$/;
              function h(w, x) {
                return v(w).some(function(S) {
                  var O = S.inverse, P = S.type === "all" || x.type === S.type;
                  if (P && O || !(P || O))
                    return !1;
                  var b = S.expressions.every(function(_) {
                    var E = _.feature, A = _.modifier, k = _.value, R = x[E];
                    if (!R)
                      return !1;
                    switch (E) {
                      case "orientation":
                      case "scan":
                        return R.toLowerCase() === k.toLowerCase();
                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        k = y(k), R = y(R);
                        break;
                      case "resolution":
                        k = g(k), R = g(R);
                        break;
                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case /* Deprecated */
                      "device-pixel-ratio":
                        k = m(k), R = m(R);
                        break;
                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        k = parseInt(k, 10) || 1, R = parseInt(R, 10) || 0;
                        break;
                    }
                    switch (A) {
                      case "min":
                        return R >= k;
                      case "max":
                        return R <= k;
                      default:
                        return R === k;
                    }
                  });
                  return b && !O || !b && O;
                });
              }
              function v(w) {
                return w.split(",").map(function(x) {
                  x = x.trim();
                  var S = x.match(u), O = S[1], P = S[2], b = S[3] || "", _ = {};
                  return _.inverse = !!O && O.toLowerCase() === "not", _.type = P ? P.toLowerCase() : "all", b = b.match(/\([^\)]+\)/g) || [], _.expressions = b.map(function(E) {
                    var A = E.match(c), k = A[1].toLowerCase().match(f);
                    return {
                      modifier: k[1],
                      feature: k[2],
                      value: A[2]
                    };
                  }), _;
                });
              }
              function m(w) {
                var x = Number(w), S;
                return x || (S = w.match(/^(\d+)\s*\/\s*(\d+)$/), x = S[1] / S[2]), x;
              }
              function g(w) {
                var x = parseFloat(w), S = String(w).match(p)[1];
                switch (S) {
                  case "dpcm":
                    return x / 2.54;
                  case "dppx":
                    return x * 96;
                  default:
                    return x;
                }
              }
              function y(w) {
                var x = parseFloat(w), S = String(w).match(d)[1];
                switch (S) {
                  case "em":
                    return x * 16;
                  case "rem":
                    return x * 16;
                  case "cm":
                    return x * 96 / 2.54;
                  case "mm":
                    return x * 96 / 2.54 / 10;
                  case "in":
                    return x * 96;
                  case "pt":
                    return x * 72;
                  case "pc":
                    return x * 72 / 12;
                  default:
                    return x;
                }
              }
            })
          ),
          /***/
          "./node_modules/hyphenate-style-name/index.js": (
            /*!****************************************************!*\
              !*** ./node_modules/hyphenate-style-name/index.js ***!
              \****************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                default: () => v
                /* harmony export */
              });
              var c = /[A-Z]/g, f = /^ms-/, d = {};
              function p(m) {
                return "-" + m.toLowerCase();
              }
              function h(m) {
                if (d.hasOwnProperty(m))
                  return d[m];
                var g = m.replace(c, p);
                return d[m] = f.test(g) ? "-" + g : g;
              }
              const v = h;
            })
          ),
          /***/
          "./node_modules/matchmediaquery/index.js": (
            /*!***********************************************!*\
              !*** ./node_modules/matchmediaquery/index.js ***!
              \***********************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! css-mediaquery */
                "./node_modules/css-mediaquery/index.js"
              ).match, f = typeof window < "u" ? window.matchMedia : null;
              function d(h, v, m) {
                var g = this;
                if (f && !m) {
                  var y = f.call(window, h);
                  this.matches = y.matches, this.media = y.media, y.addListener(S);
                } else
                  this.matches = c(h, v), this.media = h;
                this.addListener = w, this.removeListener = x, this.dispose = O;
                function w(P) {
                  y && y.addListener(P);
                }
                function x(P) {
                  y && y.removeListener(P);
                }
                function S(P) {
                  g.matches = P.matches, g.media = P.media;
                }
                function O() {
                  y && y.removeListener(S);
                }
              }
              function p(h, v, m) {
                return new d(h, v, m);
              }
              s.exports = p;
            })
          ),
          /***/
          "./node_modules/object-assign/index.js": (
            /*!*********************************************!*\
              !*** ./node_modules/object-assign/index.js ***!
              \*********************************************/
            /***/
            ((s) => {
              /*
              object-assign
              (c) Sindre Sorhus
              @license MIT
              */
              var l = Object.getOwnPropertySymbols, u = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
              function f(p) {
                if (p == null)
                  throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(p);
              }
              function d() {
                try {
                  if (!Object.assign)
                    return !1;
                  var p = new String("abc");
                  if (p[5] = "de", Object.getOwnPropertyNames(p)[0] === "5")
                    return !1;
                  for (var h = {}, v = 0; v < 10; v++)
                    h["_" + String.fromCharCode(v)] = v;
                  var m = Object.getOwnPropertyNames(h).map(function(y) {
                    return h[y];
                  });
                  if (m.join("") !== "0123456789")
                    return !1;
                  var g = {};
                  return "abcdefghijklmnopqrst".split("").forEach(function(y) {
                    g[y] = y;
                  }), Object.keys(Object.assign({}, g)).join("") === "abcdefghijklmnopqrst";
                } catch {
                  return !1;
                }
              }
              s.exports = d() ? Object.assign : function(p, h) {
                for (var v, m = f(p), g, y = 1; y < arguments.length; y++) {
                  v = Object(arguments[y]);
                  for (var w in v)
                    u.call(v, w) && (m[w] = v[w]);
                  if (l) {
                    g = l(v);
                    for (var x = 0; x < g.length; x++)
                      c.call(v, g[x]) && (m[g[x]] = v[g[x]]);
                  }
                }
                return m;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/checkPropTypes.js": (
            /*!***************************************************!*\
              !*** ./node_modules/prop-types/checkPropTypes.js ***!
              \***************************************************/
            /***/
            ((s, l, u) => {
              var c = function() {
              };
              {
                var f = u(
                  /*! ./lib/ReactPropTypesSecret */
                  "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
                ), d = {}, p = u(
                  /*! ./lib/has */
                  "./node_modules/prop-types/lib/has.js"
                );
                c = function(v) {
                  var m = "Warning: " + v;
                  typeof console < "u" && console.error(m);
                  try {
                    throw new Error(m);
                  } catch {
                  }
                };
              }
              function h(v, m, g, y, w) {
                for (var x in v)
                  if (p(v, x)) {
                    var S;
                    try {
                      if (typeof v[x] != "function") {
                        var O = Error(
                          (y || "React class") + ": " + g + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof v[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                        );
                        throw O.name = "Invariant Violation", O;
                      }
                      S = v[x](m, x, y, g, null, f);
                    } catch (b) {
                      S = b;
                    }
                    if (S && !(S instanceof Error) && c(
                      (y || "React class") + ": type specification of " + g + " `" + x + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof S + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
                    ), S instanceof Error && !(S.message in d)) {
                      d[S.message] = !0;
                      var P = w ? w() : "";
                      c(
                        "Failed " + g + " type: " + S.message + (P ?? "")
                      );
                    }
                  }
              }
              h.resetWarningCache = function() {
                d = {};
              }, s.exports = h;
            })
          ),
          /***/
          "./node_modules/prop-types/factoryWithTypeCheckers.js": (
            /*!************************************************************!*\
              !*** ./node_modules/prop-types/factoryWithTypeCheckers.js ***!
              \************************************************************/
            /***/
            ((s, l, u) => {
              var c = u(
                /*! react-is */
                "./node_modules/react-is/index.js"
              ), f = u(
                /*! object-assign */
                "./node_modules/object-assign/index.js"
              ), d = u(
                /*! ./lib/ReactPropTypesSecret */
                "./node_modules/prop-types/lib/ReactPropTypesSecret.js"
              ), p = u(
                /*! ./lib/has */
                "./node_modules/prop-types/lib/has.js"
              ), h = u(
                /*! ./checkPropTypes */
                "./node_modules/prop-types/checkPropTypes.js"
              ), v = function() {
              };
              v = function(g) {
                var y = "Warning: " + g;
                typeof console < "u" && console.error(y);
                try {
                  throw new Error(y);
                } catch {
                }
              };
              function m() {
                return null;
              }
              s.exports = function(g, y) {
                var w = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
                function S(D) {
                  var C = D && (w && D[w] || D[x]);
                  if (typeof C == "function")
                    return C;
                }
                var O = "<<anonymous>>", P = {
                  array: A("array"),
                  bigint: A("bigint"),
                  bool: A("boolean"),
                  func: A("function"),
                  number: A("number"),
                  object: A("object"),
                  string: A("string"),
                  symbol: A("symbol"),
                  any: k(),
                  arrayOf: R,
                  element: N(),
                  elementType: U(),
                  instanceOf: H,
                  node: $(),
                  objectOf: ue,
                  oneOf: ee,
                  oneOfType: Q,
                  shape: I,
                  exact: L
                };
                function b(D, C) {
                  return D === C ? D !== 0 || 1 / D === 1 / C : D !== D && C !== C;
                }
                function _(D, C) {
                  this.message = D, this.data = C && typeof C == "object" ? C : {}, this.stack = "";
                }
                _.prototype = Error.prototype;
                function E(D) {
                  var C = {}, z = 0;
                  function Z(de, fe, Ee, re, xe, De, pe) {
                    if (re = re || O, De = De || Ee, pe !== d) {
                      if (y) {
                        var j = new Error(
                          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
                        );
                        throw j.name = "Invariant Violation", j;
                      } else if (typeof console < "u") {
                        var q = re + ":" + Ee;
                        !C[q] && // Avoid spamming the console because they are often not actionable except for lib authors
                        z < 3 && (v(
                          "You are manually calling a React.PropTypes validation function for the `" + De + "` prop on `" + re + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
                        ), C[q] = !0, z++);
                      }
                    }
                    return fe[Ee] == null ? de ? fe[Ee] === null ? new _("The " + xe + " `" + De + "` is marked as required " + ("in `" + re + "`, but its value is `null`.")) : new _("The " + xe + " `" + De + "` is marked as required in " + ("`" + re + "`, but its value is `undefined`.")) : null : D(fe, Ee, re, xe, De);
                  }
                  var ne = Z.bind(null, !1);
                  return ne.isRequired = Z.bind(null, !0), ne;
                }
                function A(D) {
                  function C(z, Z, ne, de, fe, Ee) {
                    var re = z[Z], xe = se(re);
                    if (xe !== D) {
                      var De = ve(re);
                      return new _(
                        "Invalid " + de + " `" + fe + "` of type " + ("`" + De + "` supplied to `" + ne + "`, expected ") + ("`" + D + "`."),
                        { expectedType: D }
                      );
                    }
                    return null;
                  }
                  return E(C);
                }
                function k() {
                  return E(m);
                }
                function R(D) {
                  function C(z, Z, ne, de, fe) {
                    if (typeof D != "function")
                      return new _("Property `" + fe + "` of component `" + ne + "` has invalid PropType notation inside arrayOf.");
                    var Ee = z[Z];
                    if (!Array.isArray(Ee)) {
                      var re = se(Ee);
                      return new _("Invalid " + de + " `" + fe + "` of type " + ("`" + re + "` supplied to `" + ne + "`, expected an array."));
                    }
                    for (var xe = 0; xe < Ee.length; xe++) {
                      var De = D(Ee, xe, ne, de, fe + "[" + xe + "]", d);
                      if (De instanceof Error)
                        return De;
                    }
                    return null;
                  }
                  return E(C);
                }
                function N() {
                  function D(C, z, Z, ne, de) {
                    var fe = C[z];
                    if (!g(fe)) {
                      var Ee = se(fe);
                      return new _("Invalid " + ne + " `" + de + "` of type " + ("`" + Ee + "` supplied to `" + Z + "`, expected a single ReactElement."));
                    }
                    return null;
                  }
                  return E(D);
                }
                function U() {
                  function D(C, z, Z, ne, de) {
                    var fe = C[z];
                    if (!c.isValidElementType(fe)) {
                      var Ee = se(fe);
                      return new _("Invalid " + ne + " `" + de + "` of type " + ("`" + Ee + "` supplied to `" + Z + "`, expected a single ReactElement type."));
                    }
                    return null;
                  }
                  return E(D);
                }
                function H(D) {
                  function C(z, Z, ne, de, fe) {
                    if (!(z[Z] instanceof D)) {
                      var Ee = D.name || O, re = T(z[Z]);
                      return new _("Invalid " + de + " `" + fe + "` of type " + ("`" + re + "` supplied to `" + ne + "`, expected ") + ("instance of `" + Ee + "`."));
                    }
                    return null;
                  }
                  return E(C);
                }
                function ee(D) {
                  if (!Array.isArray(D))
                    return arguments.length > 1 ? v(
                      "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
                    ) : v("Invalid argument supplied to oneOf, expected an array."), m;
                  function C(z, Z, ne, de, fe) {
                    for (var Ee = z[Z], re = 0; re < D.length; re++)
                      if (b(Ee, D[re]))
                        return null;
                    var xe = JSON.stringify(D, function(pe, j) {
                      var q = ve(j);
                      return q === "symbol" ? String(j) : j;
                    });
                    return new _("Invalid " + de + " `" + fe + "` of value `" + String(Ee) + "` " + ("supplied to `" + ne + "`, expected one of " + xe + "."));
                  }
                  return E(C);
                }
                function ue(D) {
                  function C(z, Z, ne, de, fe) {
                    if (typeof D != "function")
                      return new _("Property `" + fe + "` of component `" + ne + "` has invalid PropType notation inside objectOf.");
                    var Ee = z[Z], re = se(Ee);
                    if (re !== "object")
                      return new _("Invalid " + de + " `" + fe + "` of type " + ("`" + re + "` supplied to `" + ne + "`, expected an object."));
                    for (var xe in Ee)
                      if (p(Ee, xe)) {
                        var De = D(Ee, xe, ne, de, fe + "." + xe, d);
                        if (De instanceof Error)
                          return De;
                      }
                    return null;
                  }
                  return E(C);
                }
                function Q(D) {
                  if (!Array.isArray(D))
                    return v("Invalid argument supplied to oneOfType, expected an instance of array."), m;
                  for (var C = 0; C < D.length; C++) {
                    var z = D[C];
                    if (typeof z != "function")
                      return v(
                        "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + B(z) + " at index " + C + "."
                      ), m;
                  }
                  function Z(ne, de, fe, Ee, re) {
                    for (var xe = [], De = 0; De < D.length; De++) {
                      var pe = D[De], j = pe(ne, de, fe, Ee, re, d);
                      if (j == null)
                        return null;
                      j.data && p(j.data, "expectedType") && xe.push(j.data.expectedType);
                    }
                    var q = xe.length > 0 ? ", expected one of type [" + xe.join(", ") + "]" : "";
                    return new _("Invalid " + Ee + " `" + re + "` supplied to " + ("`" + fe + "`" + q + "."));
                  }
                  return E(Z);
                }
                function $() {
                  function D(C, z, Z, ne, de) {
                    return K(C[z]) ? null : new _("Invalid " + ne + " `" + de + "` supplied to " + ("`" + Z + "`, expected a ReactNode."));
                  }
                  return E(D);
                }
                function F(D, C, z, Z, ne) {
                  return new _(
                    (D || "React class") + ": " + C + " type `" + z + "." + Z + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ne + "`."
                  );
                }
                function I(D) {
                  function C(z, Z, ne, de, fe) {
                    var Ee = z[Z], re = se(Ee);
                    if (re !== "object")
                      return new _("Invalid " + de + " `" + fe + "` of type `" + re + "` " + ("supplied to `" + ne + "`, expected `object`."));
                    for (var xe in D) {
                      var De = D[xe];
                      if (typeof De != "function")
                        return F(ne, de, fe, xe, ve(De));
                      var pe = De(Ee, xe, ne, de, fe + "." + xe, d);
                      if (pe)
                        return pe;
                    }
                    return null;
                  }
                  return E(C);
                }
                function L(D) {
                  function C(z, Z, ne, de, fe) {
                    var Ee = z[Z], re = se(Ee);
                    if (re !== "object")
                      return new _("Invalid " + de + " `" + fe + "` of type `" + re + "` " + ("supplied to `" + ne + "`, expected `object`."));
                    var xe = f({}, z[Z], D);
                    for (var De in xe) {
                      var pe = D[De];
                      if (p(D, De) && typeof pe != "function")
                        return F(ne, de, fe, De, ve(pe));
                      if (!pe)
                        return new _(
                          "Invalid " + de + " `" + fe + "` key `" + De + "` supplied to `" + ne + "`.\nBad object: " + JSON.stringify(z[Z], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(D), null, "  ")
                        );
                      var j = pe(Ee, De, ne, de, fe + "." + De, d);
                      if (j)
                        return j;
                    }
                    return null;
                  }
                  return E(C);
                }
                function K(D) {
                  switch (typeof D) {
                    case "number":
                    case "string":
                    case "undefined":
                      return !0;
                    case "boolean":
                      return !D;
                    case "object":
                      if (Array.isArray(D))
                        return D.every(K);
                      if (D === null || g(D))
                        return !0;
                      var C = S(D);
                      if (C) {
                        var z = C.call(D), Z;
                        if (C !== D.entries) {
                          for (; !(Z = z.next()).done; )
                            if (!K(Z.value))
                              return !1;
                        } else
                          for (; !(Z = z.next()).done; ) {
                            var ne = Z.value;
                            if (ne && !K(ne[1]))
                              return !1;
                          }
                      } else
                        return !1;
                      return !0;
                    default:
                      return !1;
                  }
                }
                function Y(D, C) {
                  return D === "symbol" ? !0 : C ? C["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && C instanceof Symbol : !1;
                }
                function se(D) {
                  var C = typeof D;
                  return Array.isArray(D) ? "array" : D instanceof RegExp ? "object" : Y(C, D) ? "symbol" : C;
                }
                function ve(D) {
                  if (typeof D > "u" || D === null)
                    return "" + D;
                  var C = se(D);
                  if (C === "object") {
                    if (D instanceof Date)
                      return "date";
                    if (D instanceof RegExp)
                      return "regexp";
                  }
                  return C;
                }
                function B(D) {
                  var C = ve(D);
                  switch (C) {
                    case "array":
                    case "object":
                      return "an " + C;
                    case "boolean":
                    case "date":
                    case "regexp":
                      return "a " + C;
                    default:
                      return C;
                  }
                }
                function T(D) {
                  return !D.constructor || !D.constructor.name ? O : D.constructor.name;
                }
                return P.checkPropTypes = h, P.resetWarningCache = h.resetWarningCache, P.PropTypes = P, P;
              };
            })
          ),
          /***/
          "./node_modules/prop-types/index.js": (
            /*!******************************************!*\
              !*** ./node_modules/prop-types/index.js ***!
              \******************************************/
            /***/
            ((s, l, u) => {
              {
                var c = u(
                  /*! react-is */
                  "./node_modules/react-is/index.js"
                ), f = !0;
                s.exports = u(
                  /*! ./factoryWithTypeCheckers */
                  "./node_modules/prop-types/factoryWithTypeCheckers.js"
                )(c.isElement, f);
              }
            })
          ),
          /***/
          "./node_modules/prop-types/lib/ReactPropTypesSecret.js": (
            /*!*************************************************************!*\
              !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
              \*************************************************************/
            /***/
            ((s) => {
              var l = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
              s.exports = l;
            })
          ),
          /***/
          "./node_modules/prop-types/lib/has.js": (
            /*!********************************************!*\
              !*** ./node_modules/prop-types/lib/has.js ***!
              \********************************************/
            /***/
            ((s) => {
              s.exports = Function.call.bind(Object.prototype.hasOwnProperty);
            })
          ),
          /***/
          "./node_modules/react-is/cjs/react-is.development.js": (
            /*!***********************************************************!*\
              !*** ./node_modules/react-is/cjs/react-is.development.js ***!
              \***********************************************************/
            /***/
            ((s, l) => {
              /** @license React v16.13.1
               * react-is.development.js
               *
               * Copyright (c) Facebook, Inc. and its affiliates.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               */
              (function() {
                var u = typeof Symbol == "function" && Symbol.for, c = u ? Symbol.for("react.element") : 60103, f = u ? Symbol.for("react.portal") : 60106, d = u ? Symbol.for("react.fragment") : 60107, p = u ? Symbol.for("react.strict_mode") : 60108, h = u ? Symbol.for("react.profiler") : 60114, v = u ? Symbol.for("react.provider") : 60109, m = u ? Symbol.for("react.context") : 60110, g = u ? Symbol.for("react.async_mode") : 60111, y = u ? Symbol.for("react.concurrent_mode") : 60111, w = u ? Symbol.for("react.forward_ref") : 60112, x = u ? Symbol.for("react.suspense") : 60113, S = u ? Symbol.for("react.suspense_list") : 60120, O = u ? Symbol.for("react.memo") : 60115, P = u ? Symbol.for("react.lazy") : 60116, b = u ? Symbol.for("react.block") : 60121, _ = u ? Symbol.for("react.fundamental") : 60117, E = u ? Symbol.for("react.responder") : 60118, A = u ? Symbol.for("react.scope") : 60119;
                function k(pe) {
                  return typeof pe == "string" || typeof pe == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
                  pe === d || pe === y || pe === h || pe === p || pe === x || pe === S || typeof pe == "object" && pe !== null && (pe.$$typeof === P || pe.$$typeof === O || pe.$$typeof === v || pe.$$typeof === m || pe.$$typeof === w || pe.$$typeof === _ || pe.$$typeof === E || pe.$$typeof === A || pe.$$typeof === b);
                }
                function R(pe) {
                  if (typeof pe == "object" && pe !== null) {
                    var j = pe.$$typeof;
                    switch (j) {
                      case c:
                        var q = pe.type;
                        switch (q) {
                          case g:
                          case y:
                          case d:
                          case h:
                          case p:
                          case x:
                            return q;
                          default:
                            var J = q && q.$$typeof;
                            switch (J) {
                              case m:
                              case w:
                              case P:
                              case O:
                              case v:
                                return J;
                              default:
                                return j;
                            }
                        }
                      case f:
                        return j;
                    }
                  }
                }
                var N = g, U = y, H = m, ee = v, ue = c, Q = w, $ = d, F = P, I = O, L = f, K = h, Y = p, se = x, ve = !1;
                function B(pe) {
                  return ve || (ve = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), T(pe) || R(pe) === g;
                }
                function T(pe) {
                  return R(pe) === y;
                }
                function D(pe) {
                  return R(pe) === m;
                }
                function C(pe) {
                  return R(pe) === v;
                }
                function z(pe) {
                  return typeof pe == "object" && pe !== null && pe.$$typeof === c;
                }
                function Z(pe) {
                  return R(pe) === w;
                }
                function ne(pe) {
                  return R(pe) === d;
                }
                function de(pe) {
                  return R(pe) === P;
                }
                function fe(pe) {
                  return R(pe) === O;
                }
                function Ee(pe) {
                  return R(pe) === f;
                }
                function re(pe) {
                  return R(pe) === h;
                }
                function xe(pe) {
                  return R(pe) === p;
                }
                function De(pe) {
                  return R(pe) === x;
                }
                l.AsyncMode = N, l.ConcurrentMode = U, l.ContextConsumer = H, l.ContextProvider = ee, l.Element = ue, l.ForwardRef = Q, l.Fragment = $, l.Lazy = F, l.Memo = I, l.Portal = L, l.Profiler = K, l.StrictMode = Y, l.Suspense = se, l.isAsyncMode = B, l.isConcurrentMode = T, l.isContextConsumer = D, l.isContextProvider = C, l.isElement = z, l.isForwardRef = Z, l.isFragment = ne, l.isLazy = de, l.isMemo = fe, l.isPortal = Ee, l.isProfiler = re, l.isStrictMode = xe, l.isSuspense = De, l.isValidElementType = k, l.typeOf = R;
              })();
            })
          ),
          /***/
          "./node_modules/react-is/index.js": (
            /*!****************************************!*\
              !*** ./node_modules/react-is/index.js ***!
              \****************************************/
            /***/
            ((s, l, u) => {
              s.exports = u(
                /*! ./cjs/react-is.development.js */
                "./node_modules/react-is/cjs/react-is.development.js"
              );
            })
          ),
          /***/
          "./node_modules/shallow-equal/dist/index.esm.js": (
            /*!******************************************************!*\
              !*** ./node_modules/shallow-equal/dist/index.esm.js ***!
              \******************************************************/
            /***/
            ((s, l, u) => {
              u.r(l), u.d(l, {
                /* harmony export */
                shallowEqualArrays: () => (
                  /* binding */
                  f
                ),
                /* harmony export */
                shallowEqualObjects: () => (
                  /* binding */
                  c
                )
                /* harmony export */
              });
              function c(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = Object.keys(d), v = Object.keys(p), m = h.length;
                if (v.length !== m)
                  return !1;
                for (var g = 0; g < m; g++) {
                  var y = h[g];
                  if (d[y] !== p[y] || !Object.prototype.hasOwnProperty.call(p, y))
                    return !1;
                }
                return !0;
              }
              function f(d, p) {
                if (d === p)
                  return !0;
                if (!d || !p)
                  return !1;
                var h = d.length;
                if (p.length !== h)
                  return !1;
                for (var v = 0; v < h; v++)
                  if (d[v] !== p[v])
                    return !1;
                return !0;
              }
            })
          ),
          /***/
          "./src/Component.ts": (
            /*!**************************!*\
              !*** ./src/Component.ts ***!
              \**************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__rest || function(h, v) {
                var m = {};
                for (var g in h) Object.prototype.hasOwnProperty.call(h, g) && v.indexOf(g) < 0 && (m[g] = h[g]);
                if (h != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var y = 0, g = Object.getOwnPropertySymbols(h); y < g.length; y++)
                    v.indexOf(g[y]) < 0 && Object.prototype.propertyIsEnumerable.call(h, g[y]) && (m[g[y]] = h[g[y]]);
                return m;
              }, f = this && this.__importDefault || function(h) {
                return h && h.__esModule ? h : { default: h };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var d = f(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              )), p = function(h) {
                var v = h.children, m = h.device, g = h.onChange, y = c(h, ["children", "device", "onChange"]), w = (0, d.default)(y, m, g);
                return typeof v == "function" ? v(w) : w ? v : null;
              };
              l.default = p;
            })
          ),
          /***/
          "./src/Context.ts": (
            /*!************************!*\
              !*** ./src/Context.ts ***!
              \************************/
            /***/
            ((s, l, u) => {
              Object.defineProperty(l, "__esModule", { value: !0 });
              var c = u(
                /*! react */
                "react"
              ), f = (0, c.createContext)(void 0);
              l.default = f;
            })
          ),
          /***/
          "./src/index.ts": (
            /*!**********************!*\
              !*** ./src/index.ts ***!
              \**********************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(v) {
                return v && v.__esModule ? v : { default: v };
              };
              Object.defineProperty(l, "__esModule", { value: !0 }), l.Context = l.toQuery = l.useMediaQuery = l.default = void 0;
              var f = c(u(
                /*! ./useMediaQuery */
                "./src/useMediaQuery.ts"
              ));
              l.useMediaQuery = f.default;
              var d = c(u(
                /*! ./Component */
                "./src/Component.ts"
              ));
              l.default = d.default;
              var p = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              ));
              l.toQuery = p.default;
              var h = c(u(
                /*! ./Context */
                "./src/Context.ts"
              ));
              l.Context = h.default;
            })
          ),
          /***/
          "./src/mediaQuery.ts": (
            /*!***************************!*\
              !*** ./src/mediaQuery.ts ***!
              \***************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__assign || function() {
                return c = Object.assign || function(x) {
                  for (var S, O = 1, P = arguments.length; O < P; O++) {
                    S = arguments[O];
                    for (var b in S) Object.prototype.hasOwnProperty.call(S, b) && (x[b] = S[b]);
                  }
                  return x;
                }, c.apply(this, arguments);
              }, f = this && this.__rest || function(x, S) {
                var O = {};
                for (var P in x) Object.prototype.hasOwnProperty.call(x, P) && S.indexOf(P) < 0 && (O[P] = x[P]);
                if (x != null && typeof Object.getOwnPropertySymbols == "function")
                  for (var b = 0, P = Object.getOwnPropertySymbols(x); b < P.length; b++)
                    S.indexOf(P[b]) < 0 && Object.prototype.propertyIsEnumerable.call(x, P[b]) && (O[P[b]] = x[P[b]]);
                return O;
              }, d = this && this.__importDefault || function(x) {
                return x && x.__esModule ? x : { default: x };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var p = d(u(
                /*! prop-types */
                "./node_modules/prop-types/index.js"
              )), h = p.default.oneOfType([
                p.default.string,
                p.default.number
              ]), v = {
                all: p.default.bool,
                grid: p.default.bool,
                aural: p.default.bool,
                braille: p.default.bool,
                handheld: p.default.bool,
                print: p.default.bool,
                projection: p.default.bool,
                screen: p.default.bool,
                tty: p.default.bool,
                tv: p.default.bool,
                embossed: p.default.bool
              }, m = {
                orientation: p.default.oneOf([
                  "portrait",
                  "landscape"
                ]),
                scan: p.default.oneOf([
                  "progressive",
                  "interlace"
                ]),
                aspectRatio: p.default.string,
                deviceAspectRatio: p.default.string,
                height: h,
                deviceHeight: h,
                width: h,
                deviceWidth: h,
                color: p.default.bool,
                colorIndex: p.default.bool,
                monochrome: p.default.bool,
                resolution: h,
                type: Object.keys(v)
              };
              m.type;
              var g = f(
                m,
                ["type"]
              ), y = c({ minAspectRatio: p.default.string, maxAspectRatio: p.default.string, minDeviceAspectRatio: p.default.string, maxDeviceAspectRatio: p.default.string, minHeight: h, maxHeight: h, minDeviceHeight: h, maxDeviceHeight: h, minWidth: h, maxWidth: h, minDeviceWidth: h, maxDeviceWidth: h, minColor: p.default.number, maxColor: p.default.number, minColorIndex: p.default.number, maxColorIndex: p.default.number, minMonochrome: p.default.number, maxMonochrome: p.default.number, minResolution: h, maxResolution: h }, g), w = c(c({}, v), y);
              l.default = {
                all: w,
                types: v,
                matchers: m,
                features: y
              };
            })
          ),
          /***/
          "./src/toQuery.ts": (
            /*!************************!*\
              !*** ./src/toQuery.ts ***!
              \************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(g) {
                return g && g.__esModule ? g : { default: g };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), d = c(u(
                /*! ./mediaQuery */
                "./src/mediaQuery.ts"
              )), p = function(g) {
                return "not ".concat(g);
              }, h = function(g, y) {
                var w = (0, f.default)(g);
                return typeof y == "number" && (y = "".concat(y, "px")), y === !0 ? w : y === !1 ? p(w) : "(".concat(w, ": ").concat(y, ")");
              }, v = function(g) {
                return g.join(" and ");
              }, m = function(g) {
                var y = [];
                return Object.keys(d.default.all).forEach(function(w) {
                  var x = g[w];
                  x != null && y.push(h(w, x));
                }), v(y);
              };
              l.default = m;
            })
          ),
          /***/
          "./src/useMediaQuery.ts": (
            /*!******************************!*\
              !*** ./src/useMediaQuery.ts ***!
              \******************************/
            /***/
            (function(s, l, u) {
              var c = this && this.__importDefault || function(_) {
                return _ && _.__esModule ? _ : { default: _ };
              };
              Object.defineProperty(l, "__esModule", { value: !0 });
              var f = u(
                /*! react */
                "react"
              ), d = c(u(
                /*! matchmediaquery */
                "./node_modules/matchmediaquery/index.js"
              )), p = c(u(
                /*! hyphenate-style-name */
                "./node_modules/hyphenate-style-name/index.js"
              )), h = u(
                /*! shallow-equal */
                "./node_modules/shallow-equal/dist/index.esm.js"
              ), v = c(u(
                /*! ./toQuery */
                "./src/toQuery.ts"
              )), m = c(u(
                /*! ./Context */
                "./src/Context.ts"
              )), g = function(_) {
                return _.query || (0, v.default)(_);
              }, y = function(_) {
                if (_) {
                  var E = Object.keys(_);
                  return E.reduce(function(A, k) {
                    return A[(0, p.default)(k)] = _[k], A;
                  }, {});
                }
              }, w = function() {
                var _ = (0, f.useRef)(!1);
                return (0, f.useEffect)(function() {
                  _.current = !0;
                }, []), _.current;
              }, x = function(_) {
                var E = (0, f.useContext)(m.default), A = function() {
                  return y(_) || y(E);
                }, k = (0, f.useState)(A), R = k[0], N = k[1];
                return (0, f.useEffect)(function() {
                  var U = A();
                  (0, h.shallowEqualObjects)(R, U) || N(U);
                }, [_, E]), R;
              }, S = function(_) {
                var E = function() {
                  return g(_);
                }, A = (0, f.useState)(E), k = A[0], R = A[1];
                return (0, f.useEffect)(function() {
                  var N = E();
                  k !== N && R(N);
                }, [_]), k;
              }, O = function(_, E) {
                var A = function() {
                  return (0, d.default)(_, E || {}, !!E);
                }, k = (0, f.useState)(A), R = k[0], N = k[1], U = w();
                return (0, f.useEffect)(function() {
                  if (U) {
                    var H = A();
                    return N(H), function() {
                      H && H.dispose();
                    };
                  }
                }, [_, E]), R;
              }, P = function(_) {
                var E = (0, f.useState)(_.matches), A = E[0], k = E[1];
                return (0, f.useEffect)(function() {
                  var R = function(N) {
                    k(N.matches);
                  };
                  return _.addListener(R), k(_.matches), function() {
                    _.removeListener(R);
                  };
                }, [_]), A;
              }, b = function(_, E, A) {
                var k = x(E), R = S(_);
                if (!R)
                  throw new Error("Invalid or missing MediaQuery!");
                var N = O(R, k), U = P(N), H = w();
                return (0, f.useEffect)(function() {
                  H && A && A(U);
                }, [U]), (0, f.useEffect)(function() {
                  return function() {
                    N && N.dispose();
                  };
                }, []), U;
              };
              l.default = b;
            })
          ),
          /***/
          react: (
            /*!**************************************************************************************!*\
              !*** external {"commonjs":"react","commonjs2":"react","amd":"react","root":"React"} ***!
              \**************************************************************************************/
            /***/
            ((s) => {
              s.exports = n;
            })
          )
          /******/
        }, i = {};
        function o(s) {
          var l = i[s];
          if (l !== void 0)
            return l.exports;
          var u = i[s] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return r[s].call(u.exports, u, u.exports, o), u.exports;
        }
        o.d = (s, l) => {
          for (var u in l)
            o.o(l, u) && !o.o(s, u) && Object.defineProperty(s, u, { enumerable: !0, get: l[u] });
        }, o.o = (s, l) => Object.prototype.hasOwnProperty.call(s, l), o.r = (s) => {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(s, "__esModule", { value: !0 });
        };
        var a = o("./src/index.ts");
        return a;
      })()
    ));
  })(Lf)), Lf.exports;
}
var Ose = /* @__PURE__ */ Sse();
const $se = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536
}, W3 = (e) => Ose.useMediaQuery({ minWidth: $se[e] }), Z3 = Le({}), n_ = () => Ie(Z3), Tse = ({
  children: e,
  className: t = "",
  style: n = {},
  hideDrawerButton: r = !0
}) => {
  const { menuVisible: i, onMenuToggle: o, layoutRef: a } = n_(), s = W3("sm");
  return a ? da(
    /* @__PURE__ */ M.jsxs(
      "nav",
      {
        className: Un(
          "col-span-full bg-blue-500 flex justify-start items-center text-white px-4 col-start-1 row-span-1 w-full h-full",
          t
        ),
        style: n,
        children: [
          s && !r && /* @__PURE__ */ M.jsx(
            Pm,
            {
              className: "mr-8",
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ),
          e,
          !s && /* @__PURE__ */ M.jsx(M.Fragment, { children: /* @__PURE__ */ M.jsx(
            Pm,
            {
              sideBarVisible: i,
              onClick: () => o?.(!i)
            }
          ) })
        ]
      }
    ),
    a
  ) : null;
}, kse = ({ children: e }) => {
  const { layoutRef: t } = n_();
  return t ? da(
    /* @__PURE__ */ M.jsx("main", { className: "w-full h-full overflow-hidden row-start-2 col-start-2 col-span-full", children: e }),
    t
  ) : null;
}, j2 = Pr(
  [
    "bg-neutral-200",
    "h-full",
    "overflow-auto",
    "row-start-2",
    "col-span-1",
    "col-start-1"
  ],
  {
    variants: {
      size: {
        sm: ["sm:hidden", "block", "z-50"],
        lg: ["sm:block"]
      }
    }
  }
), Pse = ({ children: e }) => {
  const { onMenuToggle: t, menuVisible: n, layoutRef: r } = n_(), i = W3("sm");
  return r ? i ? n ? da(
    /* @__PURE__ */ M.jsx(
      "aside",
      {
        className: j2({ size: "lg" }),
        children: e
      },
      "app-layout-menu"
    ),
    r
  ) : null : n ? da(
    /* @__PURE__ */ M.jsxs(
      "aside",
      {
        className: j2({ size: "sm" }),
        children: [
          /* @__PURE__ */ M.jsx(
            "button",
            {
              onClick: () => t?.(!1),
              className: "ml-auto text-neutral-700",
              children: /* @__PURE__ */ M.jsx(ar, { icon: s6, size: "sm" })
            }
          ),
          e
        ]
      },
      "app-layout-menu"
    ),
    r
  ) : null : null;
};
function Dse({
  to: e,
  icon: t,
  name: n,
  hasNotifications: r,
  children: i,
  href: o,
  linkProps: a
}) {
  if (!o && !e)
    throw new Error("to or href is required");
  return /* @__PURE__ */ M.jsx(pF, { children: /* @__PURE__ */ M.jsx("div", { className: "flex flex-col my-2", children: o ? /* @__PURE__ */ M.jsxs(
    "a",
    {
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      href: o,
      target: "_blank",
      rel: "noreferrer",
      children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ M.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ M.jsx(
            ar,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ M.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ M.jsx(Md, {}),
        i
      ]
    }
  ) : /* @__PURE__ */ M.jsxs(
    Ya,
    {
      to: e,
      ...a || {},
      className: "flex p-2 my-2 list-none rounded-md cursor-pointer hover:bg-neutral-500",
      children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flex align-middle ", children: [
          r && /* @__PURE__ */ M.jsx("div", { className: "absolute w-2.5 h-2.5 transform -translate-x-2 -translate-y-2 bg-red-400 rounded-full" }),
          /* @__PURE__ */ M.jsx(
            ar,
            {
              icon: t,
              color: "gray",
              className: "my-auto mr-6",
              size: "1x"
            }
          ),
          /* @__PURE__ */ M.jsx("p", { children: n })
        ] }),
        /* @__PURE__ */ M.jsx(Md, {}),
        i
      ]
    }
  ) }) });
}
const Ase = Pr([
  "grid",
  "w-screen",
  "h-screen",
  "overflow-hidden",
  "bg-neutral-100",
  "flex-col",
  "app-layout",
  "grid-cols-[min-content_minmax(0,1fr)]",
  "grid-rows-[6rem_minmax(0,1fr)]"
]), sh = ({
  menuVisible: e = !1,
  children: t,
  onMenuToggle: n
}) => {
  const [r, i] = W.useState(null), [o, a] = W.useState(null), [s, l] = W.useState(null);
  return /* @__PURE__ */ M.jsx(
    Z3.Provider,
    {
      value: {
        menuVisible: e,
        menuRef: s,
        onMenuToggle: n,
        layoutRef: r,
        headerRef: o
      },
      children: /* @__PURE__ */ M.jsx(
        "div",
        {
          className: Ase(),
          ref: i,
          children: t
        }
      )
    }
  );
};
sh.Header = Tse;
sh.Body = kse;
sh.Menu = Pse;
sh.Link = Dse;
const Cse = ({
  onClick: e,
  sideBarVisible: t,
  className: n,
  showMenu: r = !0,
  isLoggedIn: i = !1,
  children: o
}) => /* @__PURE__ */ M.jsxs(
  "nav",
  {
    className: Un(
      "w-screen h-full flex justify-between col-span-12 row-span-1 px-4 bg-blue-500",
      n
    ),
    children: [
      /* @__PURE__ */ M.jsxs("div", { className: "flex", children: [
        r && /* @__PURE__ */ M.jsx(
          Pm,
          {
            sideBarVisible: t,
            onClick: e || (() => null)
          }
        ),
        /* @__PURE__ */ M.jsx(Ya, { to: "/app", className: "block mx-4 my-auto h-1/2", children: /* @__PURE__ */ M.jsx(H3, { className: "w-8 h-8" }) }),
        /* @__PURE__ */ M.jsx("h1", { className: "my-auto text-xl text-white uppercase font-terminal ", children: o })
      ] }),
      /* @__PURE__ */ M.jsxs(
        P0,
        {
          className: "my-auto",
          button: /* @__PURE__ */ M.jsx(ar, { color: "white", size: "1x", icon: a6 }),
          children: [
            i && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
              /* @__PURE__ */ M.jsx("p", { className: "mb-8 border-b border-opacity-30 border-b-black" }),
              /* @__PURE__ */ M.jsx(Ya, { className: "menu-item", to: "/app/account", children: "Account" }),
              /* @__PURE__ */ M.jsx(Ya, { className: "menu-item", to: "/app/account/change-password", children: "Change Password" }),
              /* @__PURE__ */ M.jsx(Ya, { className: "menu-item", to: "/app/account/tokens", children: "CLI Tokens" }),
              /* @__PURE__ */ M.jsx(
                la,
                {
                  onAction: async () => {
                  },
                  children: "Logout"
                }
              )
            ] }),
            !i && /* @__PURE__ */ M.jsx(Ya, { to: "/login", children: /* @__PURE__ */ M.jsx(la, { children: "Login" }) })
          ]
        }
      )
    ]
  }
), Tc = {};
ni`
    mutation CreateFolder($newFolder: String!, $currentFolder: String!, $s3BucketId: Float) {
  createFolder(
    newFolder: $newFolder
    currentFolder: $currentFolder
    s3BucketId: $s3BucketId
  )
}
    `;
ni`
    mutation DeleteFiles($paths: [S3ObjectInput!]!) {
  deleteFilesResolver(paths: $paths)
}
    `;
ni`
    mutation MoveS3Files($target: S3ObjectInput!, $source: S3ObjectInput!) {
  moveS3Files(target: $target, source: $source)
}
    `;
ni`
    mutation MoveUpAFolder($moveUpAFolderPath: S3ObjectInput!) {
  moveUpAFolder(path: $moveUpAFolderPath)
}
    `;
ni`
    query FileTransfers {
  fileTransfers {
    name
    progress
    id
  }
}
    `;
ni`
    query FolderContents($s3BucketId: Float, $folder: String) {
  folderContents(s3BucketId: $s3BucketId, folder: $folder) {
    contents {
      key
      name
      isFolder
      fullPath
      bucket
    }
    errors
  }
  me {
    id
    awsUsername
  }
}
    `;
ni`
    query folderContentsSearch($search: String!, $s3BucketId: Int) {
  fileSearch(search: $search, s3BucketId: $s3BucketId) {
    results {
      fullPath
      key
      name
      isFolder
      bucket
    }
    errors
  }
}
    `;
const G3 = ni`
    query Me {
  me {
    id
    email
    awsUsername
    firstname
    lastname
    roles {
      role
    }
  }
}
    `;
function Ise(e) {
  const t = { ...Tc, ...e };
  return Xu.useQuery(G3, t);
}
function Nse(e) {
  const t = { ...Tc, ...e };
  return Xu.useLazyQuery(G3, t);
}
const Y3 = ni`
    query PresignedDownloadUrl($bucket: String!, $key: String!, $limit: Float) {
  presignedDownloadUrl(bucket: $bucket, key: $key, limit: $limit)
}
    `;
function Rse(e) {
  const t = { ...Tc, ...e };
  return Xu.useQuery(Y3, t);
}
function Mse(e) {
  const t = { ...Tc, ...e };
  return Xu.useLazyQuery(Y3, t);
}
ni`
    subscription FileTranfersUpdated {
  fileTransfersUpdated {
    progress
    id
    name
  }
}
    `;
const jse = ni`
    subscription TaskQueueLogs($jobId: String!) {
  taskQueueLogs(jobId: $jobId) {
    message
    timestamp
  }
}
    `;
function Fse(e) {
  const t = { ...Tc, ...e };
  return Xu.useSubscription(jse, t);
}
const Ule = ({ appBarTitle: e }) => {
  const { data: t } = Ise();
  return /* @__PURE__ */ M.jsxs(In.div, { className: "grid w-screen h-screen bg-neutral-300 grid-rows-[4rem minmax(0, 1fr)] grid-cols-1", children: [
    /* @__PURE__ */ M.jsx(
      Cse,
      {
        className: "h-16 bg-blue-600 ",
        onClick: () => null,
        sideBarVisible: !1,
        showMenu: !1,
        isLoggedIn: !!t?.me,
        children: e
      }
    ),
    /* @__PURE__ */ M.jsx("div", { className: "flex justify-around w-full h-full ", children: /* @__PURE__ */ M.jsx("div", { className: "w-full h-full max-w-6xl p-4 overflow-scroll bg-neutral-100", children: /* @__PURE__ */ M.jsx(SI, {}) }) })
  ] });
}, zse = {
  initial: {
    opacity: 0
  },
  in: {
    opacity: 1
  },
  out: {
    opacity: 0
  }
}, Lse = ({
  children: e,
  className: t
}) => /* @__PURE__ */ M.jsx(
  In.div,
  {
    className: Un("w-full min-h-full overflow-scroll", t),
    initial: "initial",
    animate: "in",
    exit: "out",
    variants: zse,
    children: e
  }
), Vse = (e) => /* @__PURE__ */ M.jsx("h1", { className: "text-2xl flex-grow border-opacity-25", children: e.children }), Q3 = ({ children: e, title: t, className: n }) => /* @__PURE__ */ M.jsx("div", { className: `flex py-2 mb-4 border-b border-black ${n}`, children: /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
  typeof t == "string" ? /* @__PURE__ */ M.jsx(Vse, { children: t }) : t,
  e
] }) }), Kle = () => /* @__PURE__ */ M.jsx(Lse, { children: /* @__PURE__ */ M.jsx(Q3, { title: "Page not found" }) }), Bse = ({ data: e }) => {
  const t = URL.createObjectURL(e);
  return /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsx("img", { src: t, alt: "" }) });
}, Use = () => /* @__PURE__ */ M.jsx("div", { className: "loader" }), qle = () => /* @__PURE__ */ M.jsx("p", { children: "Loading..." });
async function J3(e, t, n, r) {
  const i = await e.getPage(n), o = i.getViewport({ scale: 5 });
  t.height = o.height, t.width = o.width;
  const a = t.getContext("2d");
  if (!a)
    return;
  const s = {
    canvasContext: a,
    viewport: o
  }, l = o.height * (n - 1);
  await i.render(s).promise, a.setTransform(1, 0, 0, 1, 0, 0), r.push({
    data: t.toDataURL(),
    offset: l,
    page: n
  }), n + 1 <= e.numPages && await J3(e, t, n + 1, r);
}
const Kse = ({ url: e, canvas: t }) => {
  const [n, r] = Fe(null), [i, o] = Fe([]), [a, s] = Fe(!1), l = Me(
    async (u) => {
      if (!t || !n) return;
      const c = { data: [] };
      await J3(n, t, u, c.data), o(c.data), s(!0);
    },
    [n, s]
  );
  return Se(() => {
    l(1);
  }, [n, l]), Se(() => {
    fh.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${fh.version}/pdf.worker.js`, fh.getDocument({ url: e }).promise.then((c) => {
      r(c);
    });
  }, []), {
    ready: a,
    pageData: i,
    totalPages: n?.numPages
  };
}, qse = ({ url: e }) => {
  const t = _e(null), { ready: n, pageData: r } = Kse({
    url: e,
    canvas: t.current
  });
  return /* @__PURE__ */ M.jsxs("div", { children: [
    !n && /* @__PURE__ */ M.jsx("canvas", { ref: t }),
    r.map(({ data: i }, o) => /* @__PURE__ */ M.jsx(
      "img",
      {
        className: "mb-2 max-w-xl",
        src: i
      },
      `pdf-preview-${e}=${o}`
    ))
  ] });
}, Hse = ({ data: e }) => {
  const [t, n] = Fe(null), r = async () => {
    const i = await e.text();
    n(i);
  };
  return Se(() => {
    r();
  }, [e]), t ? /* @__PURE__ */ M.jsx("div", { children: /* @__PURE__ */ M.jsx("div", { dangerouslySetInnerHTML: { __html: t } }) }) : null;
};
var Vf = { exports: {} };
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/
var Wse = Vf.exports, F2;
function Zse() {
  return F2 || (F2 = 1, (function(e, t) {
    ((n, r) => {
      e.exports = r();
    })(Wse, function n() {
      var r = typeof self < "u" ? self : typeof window < "u" ? window : r !== void 0 ? r : {}, i, o = !r.document && !!r.postMessage, a = r.IS_PAPA_WORKER || !1, s = {}, l = 0, u = {};
      function c(b) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = { data: [], errors: [], meta: {} }, function(_) {
          var E = S(_);
          E.chunkSize = parseInt(E.chunkSize), _.step || _.chunk || (E.chunkSize = null), this._handle = new v(E), (this._handle.streamer = this)._config = E;
        }.call(this, b), this.parseChunk = function(_, E) {
          var A = parseInt(this._config.skipFirstNLines) || 0;
          if (this.isFirstChunk && 0 < A) {
            let R = this._config.newline;
            R || (k = this._config.quoteChar || '"', R = this._handle.guessLineEndings(_, k)), _ = [..._.split(R).slice(A)].join(R);
          }
          this.isFirstChunk && P(this._config.beforeFirstChunk) && (k = this._config.beforeFirstChunk(_)) !== void 0 && (_ = k), this.isFirstChunk = !1, this._halted = !1;
          var A = this._partialLine + _, k = (this._partialLine = "", this._handle.parse(A, this._baseIndex, !this._finished));
          if (!this._handle.paused() && !this._handle.aborted()) {
            if (_ = k.meta.cursor, A = (this._finished || (this._partialLine = A.substring(_ - this._baseIndex), this._baseIndex = _), k && k.data && (this._rowCount += k.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview), a) r.postMessage({ results: k, workerId: u.WORKER_ID, finished: A });
            else if (P(this._config.chunk) && !E) {
              if (this._config.chunk(k, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
              this._completeResults = k = void 0;
            }
            return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(k.data), this._completeResults.errors = this._completeResults.errors.concat(k.errors), this._completeResults.meta = k.meta), this._completed || !A || !P(this._config.complete) || k && k.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), A || k && k.meta.paused || this._nextChunk(), k;
          }
          this._halted = !0;
        }, this._sendError = function(_) {
          P(this._config.error) ? this._config.error(_) : a && this._config.error && r.postMessage({ workerId: u.WORKER_ID, error: _, finished: !1 });
        };
      }
      function f(b) {
        var _;
        (b = b || {}).chunkSize || (b.chunkSize = u.RemoteChunkSize), c.call(this, b), this._nextChunk = o ? function() {
          this._readChunk(), this._chunkLoaded();
        } : function() {
          this._readChunk();
        }, this.stream = function(E) {
          this._input = E, this._nextChunk();
        }, this._readChunk = function() {
          if (this._finished) this._chunkLoaded();
          else {
            if (_ = new XMLHttpRequest(), this._config.withCredentials && (_.withCredentials = this._config.withCredentials), o || (_.onload = O(this._chunkLoaded, this), _.onerror = O(this._chunkError, this)), _.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !o), this._config.downloadRequestHeaders) {
              var E, A = this._config.downloadRequestHeaders;
              for (E in A) _.setRequestHeader(E, A[E]);
            }
            var k;
            this._config.chunkSize && (k = this._start + this._config.chunkSize - 1, _.setRequestHeader("Range", "bytes=" + this._start + "-" + k));
            try {
              _.send(this._config.downloadRequestBody);
            } catch (R) {
              this._chunkError(R.message);
            }
            o && _.status === 0 && this._chunkError();
          }
        }, this._chunkLoaded = function() {
          _.readyState === 4 && (_.status < 200 || 400 <= _.status ? this._chunkError() : (this._start += this._config.chunkSize || _.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((E) => (E = E.getResponseHeader("Content-Range")) !== null ? parseInt(E.substring(E.lastIndexOf("/") + 1)) : -1)(_), this.parseChunk(_.responseText)));
        }, this._chunkError = function(E) {
          E = _.statusText || E, this._sendError(new Error(E));
        };
      }
      function d(b) {
        (b = b || {}).chunkSize || (b.chunkSize = u.LocalChunkSize), c.call(this, b);
        var _, E, A = typeof FileReader < "u";
        this.stream = function(k) {
          this._input = k, E = k.slice || k.webkitSlice || k.mozSlice, A ? ((_ = new FileReader()).onload = O(this._chunkLoaded, this), _.onerror = O(this._chunkError, this)) : _ = new FileReaderSync(), this._nextChunk();
        }, this._nextChunk = function() {
          this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
          var k = this._input, R = (this._config.chunkSize && (R = Math.min(this._start + this._config.chunkSize, this._input.size), k = E.call(k, this._start, R)), _.readAsText(k, this._config.encoding));
          A || this._chunkLoaded({ target: { result: R } });
        }, this._chunkLoaded = function(k) {
          this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(k.target.result);
        }, this._chunkError = function() {
          this._sendError(_.error);
        };
      }
      function p(b) {
        var _;
        c.call(this, b = b || {}), this.stream = function(E) {
          return _ = E, this._nextChunk();
        }, this._nextChunk = function() {
          var E, A;
          if (!this._finished) return E = this._config.chunkSize, _ = E ? (A = _.substring(0, E), _.substring(E)) : (A = _, ""), this._finished = !_, this.parseChunk(A);
        };
      }
      function h(b) {
        c.call(this, b = b || {});
        var _ = [], E = !0, A = !1;
        this.pause = function() {
          c.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
          c.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(k) {
          this._input = k, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
          A && _.length === 1 && (this._finished = !0);
        }, this._nextChunk = function() {
          this._checkIsFinished(), _.length ? this.parseChunk(_.shift()) : E = !0;
        }, this._streamData = O(function(k) {
          try {
            _.push(typeof k == "string" ? k : k.toString(this._config.encoding)), E && (E = !1, this._checkIsFinished(), this.parseChunk(_.shift()));
          } catch (R) {
            this._streamError(R);
          }
        }, this), this._streamError = O(function(k) {
          this._streamCleanUp(), this._sendError(k);
        }, this), this._streamEnd = O(function() {
          this._streamCleanUp(), A = !0, this._streamData("");
        }, this), this._streamCleanUp = O(function() {
          this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
      }
      function v(b) {
        var _, E, A, k, R = Math.pow(2, 53), N = -R, U = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, H = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, ee = this, ue = 0, Q = 0, $ = !1, F = !1, I = [], L = { data: [], errors: [], meta: {} };
        function K(B) {
          return b.skipEmptyLines === "greedy" ? B.join("").trim() === "" : B.length === 1 && B[0].length === 0;
        }
        function Y() {
          if (L && A && (ve("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + u.DefaultDelimiter + "'"), A = !1), b.skipEmptyLines && (L.data = L.data.filter(function(C) {
            return !K(C);
          })), se()) {
            let C = function(z, Z) {
              P(b.transformHeader) && (z = b.transformHeader(z, Z)), I.push(z);
            };
            if (L) if (Array.isArray(L.data[0])) {
              for (var B = 0; se() && B < L.data.length; B++) L.data[B].forEach(C);
              L.data.splice(0, 1);
            } else L.data.forEach(C);
          }
          function T(C, z) {
            for (var Z = b.header ? {} : [], ne = 0; ne < C.length; ne++) {
              var de = ne, fe = C[ne], fe = ((Ee, re) => ((xe) => (b.dynamicTypingFunction && b.dynamicTyping[xe] === void 0 && (b.dynamicTyping[xe] = b.dynamicTypingFunction(xe)), (b.dynamicTyping[xe] || b.dynamicTyping) === !0))(Ee) ? re === "true" || re === "TRUE" || re !== "false" && re !== "FALSE" && (((xe) => {
                if (U.test(xe) && (xe = parseFloat(xe), N < xe && xe < R))
                  return 1;
              })(re) ? parseFloat(re) : H.test(re) ? new Date(re) : re === "" ? null : re) : re)(de = b.header ? ne >= I.length ? "__parsed_extra" : I[ne] : de, fe = b.transform ? b.transform(fe, de) : fe);
              de === "__parsed_extra" ? (Z[de] = Z[de] || [], Z[de].push(fe)) : Z[de] = fe;
            }
            return b.header && (ne > I.length ? ve("FieldMismatch", "TooManyFields", "Too many fields: expected " + I.length + " fields but parsed " + ne, Q + z) : ne < I.length && ve("FieldMismatch", "TooFewFields", "Too few fields: expected " + I.length + " fields but parsed " + ne, Q + z)), Z;
          }
          var D;
          L && (b.header || b.dynamicTyping || b.transform) && (D = 1, !L.data.length || Array.isArray(L.data[0]) ? (L.data = L.data.map(T), D = L.data.length) : L.data = T(L.data, 0), b.header && L.meta && (L.meta.fields = I), Q += D);
        }
        function se() {
          return b.header && I.length === 0;
        }
        function ve(B, T, D, C) {
          B = { type: B, code: T, message: D }, C !== void 0 && (B.row = C), L.errors.push(B);
        }
        P(b.step) && (k = b.step, b.step = function(B) {
          L = B, se() ? Y() : (Y(), L.data.length !== 0 && (ue += B.data.length, b.preview && ue > b.preview ? E.abort() : (L.data = L.data[0], k(L, ee))));
        }), this.parse = function(B, T, D) {
          var C = b.quoteChar || '"', C = (b.newline || (b.newline = this.guessLineEndings(B, C)), A = !1, b.delimiter ? P(b.delimiter) && (b.delimiter = b.delimiter(B), L.meta.delimiter = b.delimiter) : ((C = ((z, Z, ne, de, fe) => {
            var Ee, re, xe, De;
            fe = fe || [",", "	", "|", ";", u.RECORD_SEP, u.UNIT_SEP];
            for (var pe = 0; pe < fe.length; pe++) {
              for (var j, q = fe[pe], J = 0, X = 0, te = 0, le = (xe = void 0, new g({ comments: de, delimiter: q, newline: Z, preview: 10 }).parse(z)), ye = 0; ye < le.data.length; ye++) ne && K(le.data[ye]) ? te++ : (j = le.data[ye].length, X += j, xe === void 0 ? xe = j : 0 < j && (J += Math.abs(j - xe), xe = j));
              0 < le.data.length && (X /= le.data.length - te), (re === void 0 || J <= re) && (De === void 0 || De < X) && 1.99 < X && (re = J, Ee = q, De = X);
            }
            return { successful: !!(b.delimiter = Ee), bestDelimiter: Ee };
          })(B, b.newline, b.skipEmptyLines, b.comments, b.delimitersToGuess)).successful ? b.delimiter = C.bestDelimiter : (A = !0, b.delimiter = u.DefaultDelimiter), L.meta.delimiter = b.delimiter), S(b));
          return b.preview && b.header && C.preview++, _ = B, E = new g(C), L = E.parse(_, T, D), Y(), $ ? { meta: { paused: !0 } } : L || { meta: { paused: !1 } };
        }, this.paused = function() {
          return $;
        }, this.pause = function() {
          $ = !0, E.abort(), _ = P(b.chunk) ? "" : _.substring(E.getCharIndex());
        }, this.resume = function() {
          ee.streamer._halted ? ($ = !1, ee.streamer.parseChunk(_, !0)) : setTimeout(ee.resume, 3);
        }, this.aborted = function() {
          return F;
        }, this.abort = function() {
          F = !0, E.abort(), L.meta.aborted = !0, P(b.complete) && b.complete(L), _ = "";
        }, this.guessLineEndings = function(z, C) {
          z = z.substring(0, 1048576);
          var C = new RegExp(m(C) + "([^]*?)" + m(C), "gm"), D = (z = z.replace(C, "")).split("\r"), C = z.split(`
`), z = 1 < C.length && C[0].length < D[0].length;
          if (D.length === 1 || z) return `
`;
          for (var Z = 0, ne = 0; ne < D.length; ne++) D[ne][0] === `
` && Z++;
          return Z >= D.length / 2 ? `\r
` : "\r";
        };
      }
      function m(b) {
        return b.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      }
      function g(b) {
        var _ = (b = b || {}).delimiter, E = b.newline, A = b.comments, k = b.step, R = b.preview, N = b.fastMode, U = null, H = !1, ee = b.quoteChar == null ? '"' : b.quoteChar, ue = ee;
        if (b.escapeChar !== void 0 && (ue = b.escapeChar), (typeof _ != "string" || -1 < u.BAD_DELIMITERS.indexOf(_)) && (_ = ","), A === _) throw new Error("Comment character same as delimiter");
        A === !0 ? A = "#" : (typeof A != "string" || -1 < u.BAD_DELIMITERS.indexOf(A)) && (A = !1), E !== `
` && E !== "\r" && E !== `\r
` && (E = `
`);
        var Q = 0, $ = !1;
        this.parse = function(F, I, L) {
          if (typeof F != "string") throw new Error("Input must be a string");
          var K = F.length, Y = _.length, se = E.length, ve = A.length, B = P(k), T = [], D = [], C = [], z = Q = 0;
          if (!F) return J();
          if (N || N !== !1 && F.indexOf(ee) === -1) {
            for (var Z = F.split(E), ne = 0; ne < Z.length; ne++) {
              if (C = Z[ne], Q += C.length, ne !== Z.length - 1) Q += E.length;
              else if (L) return J();
              if (!A || C.substring(0, ve) !== A) {
                if (B) {
                  if (T = [], De(C.split(_)), X(), $) return J();
                } else De(C.split(_));
                if (R && R <= ne) return T = T.slice(0, R), J(!0);
              }
            }
            return J();
          }
          for (var de = F.indexOf(_, Q), fe = F.indexOf(E, Q), Ee = new RegExp(m(ue) + m(ee), "g"), re = F.indexOf(ee, Q); ; ) if (F[Q] === ee) for (re = Q, Q++; ; ) {
            if ((re = F.indexOf(ee, re + 1)) === -1) return L || D.push({ type: "Quotes", code: "MissingQuotes", message: "Quoted field unterminated", row: T.length, index: Q }), j();
            if (re === K - 1) return j(F.substring(Q, re).replace(Ee, ee));
            if (ee === ue && F[re + 1] === ue) re++;
            else if (ee === ue || re === 0 || F[re - 1] !== ue) {
              de !== -1 && de < re + 1 && (de = F.indexOf(_, re + 1));
              var xe = pe((fe = fe !== -1 && fe < re + 1 ? F.indexOf(E, re + 1) : fe) === -1 ? de : Math.min(de, fe));
              if (F.substr(re + 1 + xe, Y) === _) {
                C.push(F.substring(Q, re).replace(Ee, ee)), F[Q = re + 1 + xe + Y] !== ee && (re = F.indexOf(ee, Q)), de = F.indexOf(_, Q), fe = F.indexOf(E, Q);
                break;
              }
              if (xe = pe(fe), F.substring(re + 1 + xe, re + 1 + xe + se) === E) {
                if (C.push(F.substring(Q, re).replace(Ee, ee)), q(re + 1 + xe + se), de = F.indexOf(_, Q), re = F.indexOf(ee, Q), B && (X(), $)) return J();
                if (R && T.length >= R) return J(!0);
                break;
              }
              D.push({ type: "Quotes", code: "InvalidQuotes", message: "Trailing quote on quoted field is malformed", row: T.length, index: Q }), re++;
            }
          }
          else if (A && C.length === 0 && F.substring(Q, Q + ve) === A) {
            if (fe === -1) return J();
            Q = fe + se, fe = F.indexOf(E, Q), de = F.indexOf(_, Q);
          } else if (de !== -1 && (de < fe || fe === -1)) C.push(F.substring(Q, de)), Q = de + Y, de = F.indexOf(_, Q);
          else {
            if (fe === -1) break;
            if (C.push(F.substring(Q, fe)), q(fe + se), B && (X(), $)) return J();
            if (R && T.length >= R) return J(!0);
          }
          return j();
          function De(te) {
            T.push(te), z = Q;
          }
          function pe(te) {
            var le = 0;
            return le = te !== -1 && (te = F.substring(re + 1, te)) && te.trim() === "" ? te.length : le;
          }
          function j(te) {
            return L || (te === void 0 && (te = F.substring(Q)), C.push(te), Q = K, De(C), B && X()), J();
          }
          function q(te) {
            Q = te, De(C), C = [], fe = F.indexOf(E, Q);
          }
          function J(te) {
            if (b.header && !I && T.length && !H) {
              var le = T[0], ye = /* @__PURE__ */ Object.create(null), Ce = new Set(le);
              let He = !1;
              for (let it = 0; it < le.length; it++) {
                let vt = le[it];
                if (ye[vt = P(b.transformHeader) ? b.transformHeader(vt, it) : vt]) {
                  let bt, si = ye[vt];
                  for (; bt = vt + "_" + si, si++, Ce.has(bt); ) ;
                  Ce.add(bt), le[it] = bt, ye[vt]++, He = !0, (U = U === null ? {} : U)[bt] = vt;
                } else ye[vt] = 1, le[it] = vt;
                Ce.add(vt);
              }
              He && console.warn("Duplicate headers found and renamed."), H = !0;
            }
            return { data: T, errors: D, meta: { delimiter: _, linebreak: E, aborted: $, truncated: !!te, cursor: z + (I || 0), renamedHeaders: U } };
          }
          function X() {
            k(J()), T = [], D = [];
          }
        }, this.abort = function() {
          $ = !0;
        }, this.getCharIndex = function() {
          return Q;
        };
      }
      function y(b) {
        var _ = b.data, E = s[_.workerId], A = !1;
        if (_.error) E.userError(_.error, _.file);
        else if (_.results && _.results.data) {
          var k = { abort: function() {
            A = !0, w(_.workerId, { data: [], errors: [], meta: { aborted: !0 } });
          }, pause: x, resume: x };
          if (P(E.userStep)) {
            for (var R = 0; R < _.results.data.length && (E.userStep({ data: _.results.data[R], errors: _.results.errors, meta: _.results.meta }, k), !A); R++) ;
            delete _.results;
          } else P(E.userChunk) && (E.userChunk(_.results, k, _.file), delete _.results);
        }
        _.finished && !A && w(_.workerId, _.results);
      }
      function w(b, _) {
        var E = s[b];
        P(E.userComplete) && E.userComplete(_), E.terminate(), delete s[b];
      }
      function x() {
        throw new Error("Not implemented.");
      }
      function S(b) {
        if (typeof b != "object" || b === null) return b;
        var _, E = Array.isArray(b) ? [] : {};
        for (_ in b) E[_] = S(b[_]);
        return E;
      }
      function O(b, _) {
        return function() {
          b.apply(_, arguments);
        };
      }
      function P(b) {
        return typeof b == "function";
      }
      return u.parse = function(b, _) {
        var E = (_ = _ || {}).dynamicTyping || !1;
        if (P(E) && (_.dynamicTypingFunction = E, E = {}), _.dynamicTyping = E, _.transform = !!P(_.transform) && _.transform, !_.worker || !u.WORKERS_SUPPORTED) return E = null, u.NODE_STREAM_INPUT, typeof b == "string" ? (b = ((A) => A.charCodeAt(0) !== 65279 ? A : A.slice(1))(b), E = new (_.download ? f : p)(_)) : b.readable === !0 && P(b.read) && P(b.on) ? E = new h(_) : (r.File && b instanceof File || b instanceof Object) && (E = new d(_)), E.stream(b);
        (E = (() => {
          var A;
          return !!u.WORKERS_SUPPORTED && (A = (() => {
            var k = r.URL || r.webkitURL || null, R = n.toString();
            return u.BLOB_URL || (u.BLOB_URL = k.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ", "(", R, ")();"], { type: "text/javascript" })));
          })(), (A = new r.Worker(A)).onmessage = y, A.id = l++, s[A.id] = A);
        })()).userStep = _.step, E.userChunk = _.chunk, E.userComplete = _.complete, E.userError = _.error, _.step = P(_.step), _.chunk = P(_.chunk), _.complete = P(_.complete), _.error = P(_.error), delete _.worker, E.postMessage({ input: b, config: _, workerId: E.id });
      }, u.unparse = function(b, _) {
        var E = !1, A = !0, k = ",", R = `\r
`, N = '"', U = N + N, H = !1, ee = null, ue = !1, Q = ((() => {
          if (typeof _ == "object") {
            if (typeof _.delimiter != "string" || u.BAD_DELIMITERS.filter(function(I) {
              return _.delimiter.indexOf(I) !== -1;
            }).length || (k = _.delimiter), typeof _.quotes != "boolean" && typeof _.quotes != "function" && !Array.isArray(_.quotes) || (E = _.quotes), typeof _.skipEmptyLines != "boolean" && typeof _.skipEmptyLines != "string" || (H = _.skipEmptyLines), typeof _.newline == "string" && (R = _.newline), typeof _.quoteChar == "string" && (N = _.quoteChar), typeof _.header == "boolean" && (A = _.header), Array.isArray(_.columns)) {
              if (_.columns.length === 0) throw new Error("Option columns is empty");
              ee = _.columns;
            }
            _.escapeChar !== void 0 && (U = _.escapeChar + N), _.escapeFormulae instanceof RegExp ? ue = _.escapeFormulae : typeof _.escapeFormulae == "boolean" && _.escapeFormulae && (ue = /^[=+\-@\t\r].*$/);
          }
        })(), new RegExp(m(N), "g"));
        if (typeof b == "string" && (b = JSON.parse(b)), Array.isArray(b)) {
          if (!b.length || Array.isArray(b[0])) return $(null, b, H);
          if (typeof b[0] == "object") return $(ee || Object.keys(b[0]), b, H);
        } else if (typeof b == "object") return typeof b.data == "string" && (b.data = JSON.parse(b.data)), Array.isArray(b.data) && (b.fields || (b.fields = b.meta && b.meta.fields || ee), b.fields || (b.fields = Array.isArray(b.data[0]) ? b.fields : typeof b.data[0] == "object" ? Object.keys(b.data[0]) : []), Array.isArray(b.data[0]) || typeof b.data[0] == "object" || (b.data = [b.data])), $(b.fields || [], b.data || [], H);
        throw new Error("Unable to serialize unrecognized input");
        function $(I, L, K) {
          var Y = "", se = (typeof I == "string" && (I = JSON.parse(I)), typeof L == "string" && (L = JSON.parse(L)), Array.isArray(I) && 0 < I.length), ve = !Array.isArray(L[0]);
          if (se && A) {
            for (var B = 0; B < I.length; B++) 0 < B && (Y += k), Y += F(I[B], B);
            0 < L.length && (Y += R);
          }
          for (var T = 0; T < L.length; T++) {
            var D = (se ? I : L[T]).length, C = !1, z = se ? Object.keys(L[T]).length === 0 : L[T].length === 0;
            if (K && !se && (C = K === "greedy" ? L[T].join("").trim() === "" : L[T].length === 1 && L[T][0].length === 0), K === "greedy" && se) {
              for (var Z = [], ne = 0; ne < D; ne++) {
                var de = ve ? I[ne] : ne;
                Z.push(L[T][de]);
              }
              C = Z.join("").trim() === "";
            }
            if (!C) {
              for (var fe = 0; fe < D; fe++) {
                0 < fe && !z && (Y += k);
                var Ee = se && ve ? I[fe] : fe;
                Y += F(L[T][Ee], fe);
              }
              T < L.length - 1 && (!K || 0 < D && !z) && (Y += R);
            }
          }
          return Y;
        }
        function F(I, L) {
          var K, Y;
          return I == null ? "" : I.constructor === Date ? JSON.stringify(I).slice(1, 25) : (Y = !1, ue && typeof I == "string" && ue.test(I) && (I = "'" + I, Y = !0), K = I.toString().replace(Q, U), (Y = Y || E === !0 || typeof E == "function" && E(I, L) || Array.isArray(E) && E[L] || ((se, ve) => {
            for (var B = 0; B < ve.length; B++) if (-1 < se.indexOf(ve[B])) return !0;
            return !1;
          })(K, u.BAD_DELIMITERS) || -1 < K.indexOf(k) || K.charAt(0) === " " || K.charAt(K.length - 1) === " ") ? N + K + N : K);
        }
      }, u.RECORD_SEP = "", u.UNIT_SEP = "", u.BYTE_ORDER_MARK = "\uFEFF", u.BAD_DELIMITERS = ["\r", `
`, '"', u.BYTE_ORDER_MARK], u.WORKERS_SUPPORTED = !o && !!r.Worker, u.NODE_STREAM_INPUT = 1, u.LocalChunkSize = 10485760, u.RemoteChunkSize = 5242880, u.DefaultDelimiter = ",", u.Parser = g, u.ParserHandle = v, u.NetworkStreamer = f, u.FileStreamer = d, u.StringStreamer = p, u.ReadableStreamStreamer = h, r.jQuery && ((i = r.jQuery).fn.parse = function(b) {
        var _ = b.config || {}, E = [];
        return this.each(function(R) {
          if (!(i(this).prop("tagName").toUpperCase() === "INPUT" && i(this).attr("type").toLowerCase() === "file" && r.FileReader) || !this.files || this.files.length === 0) return !0;
          for (var N = 0; N < this.files.length; N++) E.push({ file: this.files[N], inputElem: this, instanceConfig: i.extend({}, _) });
        }), A(), this;
        function A() {
          if (E.length === 0) P(b.complete) && b.complete();
          else {
            var R, N, U, H, ee = E[0];
            if (P(b.before)) {
              var ue = b.before(ee.file, ee.inputElem);
              if (typeof ue == "object") {
                if (ue.action === "abort") return R = "AbortError", N = ee.file, U = ee.inputElem, H = ue.reason, void (P(b.error) && b.error({ name: R }, N, U, H));
                if (ue.action === "skip") return void k();
                typeof ue.config == "object" && (ee.instanceConfig = i.extend(ee.instanceConfig, ue.config));
              } else if (ue === "skip") return void k();
            }
            var Q = ee.instanceConfig.complete;
            ee.instanceConfig.complete = function($) {
              P(Q) && Q($, ee.file, ee.inputElem), k();
            }, u.parse(ee.file, ee.instanceConfig);
          }
        }
        function k() {
          E.splice(0, 1), A();
        }
      }), a && (r.onmessage = function(b) {
        b = b.data, u.WORKER_ID === void 0 && b && (u.WORKER_ID = b.workerId), typeof b.input == "string" ? r.postMessage({ workerId: u.WORKER_ID, results: u.parse(b.input, b.config), finished: !0 }) : (r.File && b.input instanceof File || b.input instanceof Object) && (b = u.parse(b.input, b.config)) && r.postMessage({ workerId: u.WORKER_ID, results: b, finished: !0 });
      }), (f.prototype = Object.create(c.prototype)).constructor = f, (d.prototype = Object.create(c.prototype)).constructor = d, (p.prototype = Object.create(p.prototype)).constructor = p, (h.prototype = Object.create(c.prototype)).constructor = h, u;
    });
  })(Vf)), Vf.exports;
}
var Gse = Zse();
const Yse = (e) => /* @__PURE__ */ M.jsx(
  "table",
  {
    className: "bg-neutral-200 mb-4 border-collapse rounded border-none",
    ...e
  }
), Qse = ({ data: e }) => {
  const [t, n] = Fe(null), r = async () => {
    const i = await e.text();
    Gse.parse(i, {
      complete: (o) => n(o.data)
    });
  };
  return Se(() => {
    r();
  }, [e]), t ? /* @__PURE__ */ M.jsx("div", { className: "p-4 rounded-md bg-neutral-200", children: /* @__PURE__ */ M.jsx(Yse, { children: /* @__PURE__ */ M.jsx("tbody", { children: t.map((i, o) => /* @__PURE__ */ M.jsx("tr", { children: Object.keys(i).map((a, s) => /* @__PURE__ */ M.jsx("td", { children: i[a] }, `cell-${o * s}`)) }, `row-${o}`)) }) }) }) : /* @__PURE__ */ M.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ M.jsx("p", { children: "Loading..." }) });
}, z2 = 5e3, Hle = ({ bucket: e, fileKey: t }) => {
  if (!e || !t)
    return /* @__PURE__ */ M.jsx("div", { children: "Invalid URL" });
  const n = t, r = n.endsWith(".pdf"), i = n.split(".").pop(), o = Rse({
    variables: { bucket: e, key: n, limit: r ? void 0 : z2 }
  }), [a] = Mse(), [s, l] = Fe(null), u = n.split("/").pop() || n, c = Me(
    async (d) => {
      const h = await (await fetch(d, {
        headers: { Range: `bytes=0-${z2}` }
      })).blob();
      l(h);
    },
    [l]
  );
  if (Se(() => {
    o.data?.presignedDownloadUrl && c(o.data.presignedDownloadUrl);
  }, [o.data?.presignedDownloadUrl, c]), !s)
    return /* @__PURE__ */ M.jsx("div", { className: "grid w-full h-full place-items-center", children: /* @__PURE__ */ M.jsx(Use, {}) });
  let f;
  switch (i) {
    case "svg":
      f = /* @__PURE__ */ M.jsx(Hse, { data: s });
      break;
    case "csv":
    case "bed":
    case "fastq":
    case "tsv":
      f = /* @__PURE__ */ M.jsx(Qse, { data: s });
      break;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
    case "ico":
    case "jfif":
      f = /* @__PURE__ */ M.jsx(Bse, { data: s });
      break;
    case "pdf":
      f = /* @__PURE__ */ M.jsx(qse, { url: o.data?.presignedDownloadUrl || "" });
      break;
    default:
      f = /* @__PURE__ */ M.jsx("div", { children: "Preview not available for this file type" });
      break;
  }
  return /* @__PURE__ */ M.jsxs("div", { className: "flex flex-col w-full h-full overflow-scroll", children: [
    /* @__PURE__ */ M.jsx(Q3, { title: u, children: /* @__PURE__ */ M.jsx(
      ly,
      {
        onClick: async () => {
          const p = (await a({ variables: { bucket: e, key: n } })).data?.presignedDownloadUrl;
          p && window.open(p);
        },
        variant: "gray",
        children: "Download"
      }
    ) }),
    /* @__PURE__ */ M.jsx("div", { className: "flex justify-around w-full", children: f })
  ] });
}, Jse = ({
  validate: e,
  children: t,
  onFailure: n
}) => {
  const [r, i] = Fe(!0), o = Me(async () => {
    await e() ? i(!1) : n();
  }, []);
  return Se(() => {
    o();
  }, []), r ? null : /* @__PURE__ */ M.jsx(M.Fragment, { children: t });
};
function Xse(e, t) {
  return t.some(
    (n) => e.some((r) => r.role === n)
  );
}
const Wle = ({
  roles: e,
  children: t,
  loginUrl: n
}) => {
  const [r] = Nse({ fetchPolicy: "cache-first" });
  return /* @__PURE__ */ M.jsx(
    Jse,
    {
      onFailure: () => {
        window.location.href = `${n}?redirect=${encodeURIComponent(
          window.location.href
        )}`;
      },
      validate: async () => {
        const i = await r();
        return !(!i.data?.me || !Xse(i.data.me.roles || [], e));
      },
      children: t
    }
  );
}, Zle = ({
  path: e,
  className: t,
  children: n,
  endpoint: r
}) => {
  const i = `${r}/download?bucket=${e}&key=${e}&isFolder=${e.isFolder ? 1 : 0}`;
  return /* @__PURE__ */ M.jsx("a", { className: t, href: i, download: "asfdkl", children: n });
};
function mf(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var Bv = { exports: {} }, L2;
function ele() {
  return L2 || (L2 = 1, (function(e, t) {
    (function(n) {
      e.exports = n();
    })(function() {
      return (function n(r, i, o) {
        function a(u, c) {
          if (!i[u]) {
            if (!r[u]) {
              var f = typeof mf == "function" && mf;
              if (!c && f) return f(u, !0);
              if (s) return s(u, !0);
              throw new Error("Cannot find module '" + u + "'");
            }
            c = i[u] = { exports: {} }, r[u][0].call(c.exports, function(d) {
              var p = r[u][1][d];
              return a(p || d);
            }, c, c.exports, n, r, i, o);
          }
          return i[u].exports;
        }
        for (var s = typeof mf == "function" && mf, l = 0; l < o.length; l++) a(o[l]);
        return a;
      })({ 1: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("crypto");
          function v(O, P) {
            P = y(O, P);
            var b;
            return (b = P.algorithm !== "passthrough" ? h.createHash(P.algorithm) : new S()).write === void 0 && (b.write = b.update, b.end = b.update), x(P, b).dispatch(O), b.update || b.end(""), b.digest ? b.digest(P.encoding === "buffer" ? void 0 : P.encoding) : (O = b.read(), P.encoding !== "buffer" ? O.toString(P.encoding) : O);
          }
          (i = r.exports = v).sha1 = function(O) {
            return v(O);
          }, i.keys = function(O) {
            return v(O, { excludeValues: !0, algorithm: "sha1", encoding: "hex" });
          }, i.MD5 = function(O) {
            return v(O, { algorithm: "md5", encoding: "hex" });
          }, i.keysMD5 = function(O) {
            return v(O, { algorithm: "md5", encoding: "hex", excludeValues: !0 });
          };
          var m = h.getHashes ? h.getHashes().slice() : ["sha1", "md5"], g = (m.push("passthrough"), ["buffer", "hex", "binary", "base64"]);
          function y(O, P) {
            var b = {};
            if (b.algorithm = (P = P || {}).algorithm || "sha1", b.encoding = P.encoding || "hex", b.excludeValues = !!P.excludeValues, b.algorithm = b.algorithm.toLowerCase(), b.encoding = b.encoding.toLowerCase(), b.ignoreUnknown = P.ignoreUnknown === !0, b.respectType = P.respectType !== !1, b.respectFunctionNames = P.respectFunctionNames !== !1, b.respectFunctionProperties = P.respectFunctionProperties !== !1, b.unorderedArrays = P.unorderedArrays === !0, b.unorderedSets = P.unorderedSets !== !1, b.unorderedObjects = P.unorderedObjects !== !1, b.replacer = P.replacer || void 0, b.excludeKeys = P.excludeKeys || void 0, O === void 0) throw new Error("Object argument required.");
            for (var _ = 0; _ < m.length; ++_) m[_].toLowerCase() === b.algorithm.toLowerCase() && (b.algorithm = m[_]);
            if (m.indexOf(b.algorithm) === -1) throw new Error('Algorithm "' + b.algorithm + '"  not supported. supported values: ' + m.join(", "));
            if (g.indexOf(b.encoding) === -1 && b.algorithm !== "passthrough") throw new Error('Encoding "' + b.encoding + '"  not supported. supported values: ' + g.join(", "));
            return b;
          }
          function w(O) {
            if (typeof O == "function") return /^function\s+\w*\s*\(\s*\)\s*{\s+\[native code\]\s+}$/i.exec(Function.prototype.toString.call(O)) != null;
          }
          function x(O, P, b) {
            b = b || [];
            function _(E) {
              return P.update ? P.update(E, "utf8") : P.write(E, "utf8");
            }
            return { dispatch: function(E) {
              return this["_" + ((E = O.replacer ? O.replacer(E) : E) === null ? "null" : typeof E)](E);
            }, _object: function(E) {
              var A, k = Object.prototype.toString.call(E), R = /\[object (.*)\]/i.exec(k);
              if (R = (R = R ? R[1] : "unknown:[" + k + "]").toLowerCase(), 0 <= (k = b.indexOf(E))) return this.dispatch("[CIRCULAR:" + k + "]");
              if (b.push(E), s !== void 0 && s.isBuffer && s.isBuffer(E)) return _("buffer:"), _(E);
              if (R === "object" || R === "function" || R === "asyncfunction") return k = Object.keys(E), O.unorderedObjects && (k = k.sort()), O.respectType === !1 || w(E) || k.splice(0, 0, "prototype", "__proto__", "constructor"), O.excludeKeys && (k = k.filter(function(N) {
                return !O.excludeKeys(N);
              })), _("object:" + k.length + ":"), A = this, k.forEach(function(N) {
                A.dispatch(N), _(":"), O.excludeValues || A.dispatch(E[N]), _(",");
              });
              if (!this["_" + R]) {
                if (O.ignoreUnknown) return _("[" + R + "]");
                throw new Error('Unknown object type "' + R + '"');
              }
              this["_" + R](E);
            }, _array: function(E, N) {
              N = N !== void 0 ? N : O.unorderedArrays !== !1;
              var k = this;
              if (_("array:" + E.length + ":"), !N || E.length <= 1) return E.forEach(function(U) {
                return k.dispatch(U);
              });
              var R = [], N = E.map(function(U) {
                var H = new S(), ee = b.slice();
                return x(O, H, ee).dispatch(U), R = R.concat(ee.slice(b.length)), H.read().toString();
              });
              return b = b.concat(R), N.sort(), this._array(N, !1);
            }, _date: function(E) {
              return _("date:" + E.toJSON());
            }, _symbol: function(E) {
              return _("symbol:" + E.toString());
            }, _error: function(E) {
              return _("error:" + E.toString());
            }, _boolean: function(E) {
              return _("bool:" + E.toString());
            }, _string: function(E) {
              _("string:" + E.length + ":"), _(E.toString());
            }, _function: function(E) {
              _("fn:"), w(E) ? this.dispatch("[native]") : this.dispatch(E.toString()), O.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(E.name)), O.respectFunctionProperties && this._object(E);
            }, _number: function(E) {
              return _("number:" + E.toString());
            }, _xml: function(E) {
              return _("xml:" + E.toString());
            }, _null: function() {
              return _("Null");
            }, _undefined: function() {
              return _("Undefined");
            }, _regexp: function(E) {
              return _("regex:" + E.toString());
            }, _uint8array: function(E) {
              return _("uint8array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _uint8clampedarray: function(E) {
              return _("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(E));
            }, _int8array: function(E) {
              return _("int8array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _uint16array: function(E) {
              return _("uint16array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _int16array: function(E) {
              return _("int16array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _uint32array: function(E) {
              return _("uint32array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _int32array: function(E) {
              return _("int32array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _float32array: function(E) {
              return _("float32array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _float64array: function(E) {
              return _("float64array:"), this.dispatch(Array.prototype.slice.call(E));
            }, _arraybuffer: function(E) {
              return _("arraybuffer:"), this.dispatch(new Uint8Array(E));
            }, _url: function(E) {
              return _("url:" + E.toString());
            }, _map: function(E) {
              return _("map:"), E = Array.from(E), this._array(E, O.unorderedSets !== !1);
            }, _set: function(E) {
              return _("set:"), E = Array.from(E), this._array(E, O.unorderedSets !== !1);
            }, _file: function(E) {
              return _("file:"), this.dispatch([E.name, E.size, E.type, E.lastModfied]);
            }, _blob: function() {
              if (O.ignoreUnknown) return _("[blob]");
              throw Error(`Hashing Blob objects is currently not supported
(see https://github.com/puleos/object-hash/issues/26)
Use "options.replacer" or "options.ignoreUnknown"
`);
            }, _domwindow: function() {
              return _("domwindow");
            }, _bigint: function(E) {
              return _("bigint:" + E.toString());
            }, _process: function() {
              return _("process");
            }, _timer: function() {
              return _("timer");
            }, _pipe: function() {
              return _("pipe");
            }, _tcp: function() {
              return _("tcp");
            }, _udp: function() {
              return _("udp");
            }, _tty: function() {
              return _("tty");
            }, _statwatcher: function() {
              return _("statwatcher");
            }, _securecontext: function() {
              return _("securecontext");
            }, _connection: function() {
              return _("connection");
            }, _zlib: function() {
              return _("zlib");
            }, _context: function() {
              return _("context");
            }, _nodescript: function() {
              return _("nodescript");
            }, _httpparser: function() {
              return _("httpparser");
            }, _dataview: function() {
              return _("dataview");
            }, _signal: function() {
              return _("signal");
            }, _fsevent: function() {
              return _("fsevent");
            }, _tlswrap: function() {
              return _("tlswrap");
            } };
          }
          function S() {
            return { buf: "", write: function(O) {
              this.buf += O;
            }, end: function(O) {
              this.buf += O;
            }, read: function() {
              return this.buf;
            } };
          }
          i.writeToStream = function(O, P, b) {
            return b === void 0 && (b = P, P = {}), x(P = y(O, P), b).dispatch(O);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/fake_9a5aa49d.js", "/");
      }, { buffer: 3, crypto: 5, lYpoI2: 11 }], 2: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          (function(h) {
            var v = typeof Uint8Array < "u" ? Uint8Array : Array, m = 43, g = 47, y = 48, w = 97, x = 65, S = 45, O = 95;
            function P(b) {
              return b = b.charCodeAt(0), b === m || b === S ? 62 : b === g || b === O ? 63 : b < y ? -1 : b < y + 10 ? b - y + 26 + 26 : b < x + 26 ? b - x : b < w + 26 ? b - w + 26 : void 0;
            }
            h.toByteArray = function(b) {
              var _, E;
              if (0 < b.length % 4) throw new Error("Invalid string. Length must be a multiple of 4");
              var A = b.length, A = b.charAt(A - 2) === "=" ? 2 : b.charAt(A - 1) === "=" ? 1 : 0, k = new v(3 * b.length / 4 - A), R = 0 < A ? b.length - 4 : b.length, N = 0;
              function U(H) {
                k[N++] = H;
              }
              for (_ = 0; _ < R; _ += 4, 0) U((16711680 & (E = P(b.charAt(_)) << 18 | P(b.charAt(_ + 1)) << 12 | P(b.charAt(_ + 2)) << 6 | P(b.charAt(_ + 3)))) >> 16), U((65280 & E) >> 8), U(255 & E);
              return A == 2 ? U(255 & (E = P(b.charAt(_)) << 2 | P(b.charAt(_ + 1)) >> 4)) : A == 1 && (U((E = P(b.charAt(_)) << 10 | P(b.charAt(_ + 1)) << 4 | P(b.charAt(_ + 2)) >> 2) >> 8 & 255), U(255 & E)), k;
            }, h.fromByteArray = function(b) {
              var _, E, A, k, R = b.length % 3, N = "";
              function U(H) {
                return "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(H);
              }
              for (_ = 0, A = b.length - R; _ < A; _ += 3) E = (b[_] << 16) + (b[_ + 1] << 8) + b[_ + 2], N += U((k = E) >> 18 & 63) + U(k >> 12 & 63) + U(k >> 6 & 63) + U(63 & k);
              switch (R) {
                case 1:
                  N = (N += U((E = b[b.length - 1]) >> 2)) + U(E << 4 & 63) + "==";
                  break;
                case 2:
                  N = (N = (N += U((E = (b[b.length - 2] << 8) + b[b.length - 1]) >> 10)) + U(E >> 4 & 63)) + U(E << 2 & 63) + "=";
              }
              return N;
            };
          })(i === void 0 ? this.base64js = {} : i);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/base64-js/lib/b64.js", "/node_modules/gulp-browserify/node_modules/base64-js/lib");
      }, { buffer: 3, lYpoI2: 11 }], 3: [function(n, r, i) {
        (function(o, a, m, l, u, c, f, d, p) {
          var h = n("base64-js"), v = n("ieee754");
          function m(T, D, C) {
            if (!(this instanceof m)) return new m(T, D, C);
            var z, Z, ne, de, fe = typeof T;
            if (D === "base64" && fe == "string") for (T = (de = T).trim ? de.trim() : de.replace(/^\s+|\s+$/g, ""); T.length % 4 != 0; ) T += "=";
            if (fe == "number") z = ue(T);
            else if (fe == "string") z = m.byteLength(T, D);
            else {
              if (fe != "object") throw new Error("First argument needs to be a number, array or string.");
              z = ue(T.length);
            }
            if (m._useTypedArrays ? Z = m._augment(new Uint8Array(z)) : ((Z = this).length = z, Z._isBuffer = !0), m._useTypedArrays && typeof T.byteLength == "number") Z._set(T);
            else if (Q(de = T) || m.isBuffer(de) || de && typeof de == "object" && typeof de.length == "number") for (ne = 0; ne < z; ne++) m.isBuffer(T) ? Z[ne] = T.readUInt8(ne) : Z[ne] = T[ne];
            else if (fe == "string") Z.write(T, 0, D);
            else if (fe == "number" && !m._useTypedArrays && !C) for (ne = 0; ne < z; ne++) Z[ne] = 0;
            return Z;
          }
          function g(T, D, C, z) {
            return m._charsWritten = L((function(Z) {
              for (var ne = [], de = 0; de < Z.length; de++) ne.push(255 & Z.charCodeAt(de));
              return ne;
            })(D), T, C, z);
          }
          function y(T, D, C, z) {
            return m._charsWritten = L((function(Z) {
              for (var ne, de, fe = [], Ee = 0; Ee < Z.length; Ee++) de = Z.charCodeAt(Ee), ne = de >> 8, de = de % 256, fe.push(de), fe.push(ne);
              return fe;
            })(D), T, C, z);
          }
          function w(T, D, C) {
            var z = "";
            C = Math.min(T.length, C);
            for (var Z = D; Z < C; Z++) z += String.fromCharCode(T[Z]);
            return z;
          }
          function x(T, D, C, ne) {
            ne || (B(typeof C == "boolean", "missing or invalid endian"), B(D != null, "missing offset"), B(D + 1 < T.length, "Trying to read beyond buffer length"));
            var Z, ne = T.length;
            if (!(ne <= D)) return C ? (Z = T[D], D + 1 < ne && (Z |= T[D + 1] << 8)) : (Z = T[D] << 8, D + 1 < ne && (Z |= T[D + 1])), Z;
          }
          function S(T, D, C, ne) {
            ne || (B(typeof C == "boolean", "missing or invalid endian"), B(D != null, "missing offset"), B(D + 3 < T.length, "Trying to read beyond buffer length"));
            var Z, ne = T.length;
            if (!(ne <= D)) return C ? (D + 2 < ne && (Z = T[D + 2] << 16), D + 1 < ne && (Z |= T[D + 1] << 8), Z |= T[D], D + 3 < ne && (Z += T[D + 3] << 24 >>> 0)) : (D + 1 < ne && (Z = T[D + 1] << 16), D + 2 < ne && (Z |= T[D + 2] << 8), D + 3 < ne && (Z |= T[D + 3]), Z += T[D] << 24 >>> 0), Z;
          }
          function O(T, D, C, z) {
            if (z || (B(typeof C == "boolean", "missing or invalid endian"), B(D != null, "missing offset"), B(D + 1 < T.length, "Trying to read beyond buffer length")), !(T.length <= D)) return z = x(T, D, C, !0), 32768 & z ? -1 * (65535 - z + 1) : z;
          }
          function P(T, D, C, z) {
            if (z || (B(typeof C == "boolean", "missing or invalid endian"), B(D != null, "missing offset"), B(D + 3 < T.length, "Trying to read beyond buffer length")), !(T.length <= D)) return z = S(T, D, C, !0), 2147483648 & z ? -1 * (4294967295 - z + 1) : z;
          }
          function b(T, D, C, z) {
            return z || (B(typeof C == "boolean", "missing or invalid endian"), B(D + 3 < T.length, "Trying to read beyond buffer length")), v.read(T, D, C, 23, 4);
          }
          function _(T, D, C, z) {
            return z || (B(typeof C == "boolean", "missing or invalid endian"), B(D + 7 < T.length, "Trying to read beyond buffer length")), v.read(T, D, C, 52, 8);
          }
          function E(T, D, C, z, Z) {
            if (Z || (B(D != null, "missing value"), B(typeof z == "boolean", "missing or invalid endian"), B(C != null, "missing offset"), B(C + 1 < T.length, "trying to write beyond buffer length"), Y(D, 65535)), Z = T.length, !(Z <= C)) for (var ne = 0, de = Math.min(Z - C, 2); ne < de; ne++) T[C + ne] = (D & 255 << 8 * (z ? ne : 1 - ne)) >>> 8 * (z ? ne : 1 - ne);
          }
          function A(T, D, C, z, Z) {
            if (Z || (B(D != null, "missing value"), B(typeof z == "boolean", "missing or invalid endian"), B(C != null, "missing offset"), B(C + 3 < T.length, "trying to write beyond buffer length"), Y(D, 4294967295)), Z = T.length, !(Z <= C)) for (var ne = 0, de = Math.min(Z - C, 4); ne < de; ne++) T[C + ne] = D >>> 8 * (z ? ne : 3 - ne) & 255;
          }
          function k(T, D, C, z, Z) {
            Z || (B(D != null, "missing value"), B(typeof z == "boolean", "missing or invalid endian"), B(C != null, "missing offset"), B(C + 1 < T.length, "Trying to write beyond buffer length"), se(D, 32767, -32768)), T.length <= C || E(T, 0 <= D ? D : 65535 + D + 1, C, z, Z);
          }
          function R(T, D, C, z, Z) {
            Z || (B(D != null, "missing value"), B(typeof z == "boolean", "missing or invalid endian"), B(C != null, "missing offset"), B(C + 3 < T.length, "Trying to write beyond buffer length"), se(D, 2147483647, -2147483648)), T.length <= C || A(T, 0 <= D ? D : 4294967295 + D + 1, C, z, Z);
          }
          function N(T, D, C, z, Z) {
            Z || (B(D != null, "missing value"), B(typeof z == "boolean", "missing or invalid endian"), B(C != null, "missing offset"), B(C + 3 < T.length, "Trying to write beyond buffer length"), ve(D, 34028234663852886e22, -34028234663852886e22)), T.length <= C || v.write(T, D, C, z, 23, 4);
          }
          function U(T, D, C, z, Z) {
            Z || (B(D != null, "missing value"), B(typeof z == "boolean", "missing or invalid endian"), B(C != null, "missing offset"), B(C + 7 < T.length, "Trying to write beyond buffer length"), ve(D, 17976931348623157e292, -17976931348623157e292)), T.length <= C || v.write(T, D, C, z, 52, 8);
          }
          i.Buffer = m, i.SlowBuffer = m, i.INSPECT_MAX_BYTES = 50, m.poolSize = 8192, m._useTypedArrays = (function() {
            try {
              var T = new ArrayBuffer(0), D = new Uint8Array(T);
              return D.foo = function() {
                return 42;
              }, D.foo() === 42 && typeof D.subarray == "function";
            } catch {
              return !1;
            }
          })(), m.isEncoding = function(T) {
            switch (String(T).toLowerCase()) {
              case "hex":
              case "utf8":
              case "utf-8":
              case "ascii":
              case "binary":
              case "base64":
              case "raw":
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                return !0;
              default:
                return !1;
            }
          }, m.isBuffer = function(T) {
            return !(T == null || !T._isBuffer);
          }, m.byteLength = function(T, D) {
            var C;
            switch (T += "", D || "utf8") {
              case "hex":
                C = T.length / 2;
                break;
              case "utf8":
              case "utf-8":
                C = F(T).length;
                break;
              case "ascii":
              case "binary":
              case "raw":
                C = T.length;
                break;
              case "base64":
                C = I(T).length;
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                C = 2 * T.length;
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return C;
          }, m.concat = function(T, D) {
            if (B(Q(T), `Usage: Buffer.concat(list, [totalLength])
list should be an Array.`), T.length === 0) return new m(0);
            if (T.length === 1) return T[0];
            if (typeof D != "number") for (Z = D = 0; Z < T.length; Z++) D += T[Z].length;
            for (var C = new m(D), z = 0, Z = 0; Z < T.length; Z++) {
              var ne = T[Z];
              ne.copy(C, z), z += ne.length;
            }
            return C;
          }, m.prototype.write = function(T, D, C, z) {
            isFinite(D) ? isFinite(C) || (z = C, C = void 0) : (Ee = z, z = D, D = C, C = Ee), D = Number(D) || 0;
            var Z, ne, de, fe, Ee = this.length - D;
            switch ((!C || Ee < (C = Number(C))) && (C = Ee), z = String(z || "utf8").toLowerCase()) {
              case "hex":
                Z = (function(re, xe, De, pe) {
                  De = Number(De) || 0;
                  var j = re.length - De;
                  (!pe || j < (pe = Number(pe))) && (pe = j), B((j = xe.length) % 2 == 0, "Invalid hex string"), j / 2 < pe && (pe = j / 2);
                  for (var q = 0; q < pe; q++) {
                    var J = parseInt(xe.substr(2 * q, 2), 16);
                    B(!isNaN(J), "Invalid hex string"), re[De + q] = J;
                  }
                  return m._charsWritten = 2 * q, q;
                })(this, T, D, C);
                break;
              case "utf8":
              case "utf-8":
                ne = this, de = D, fe = C, Z = m._charsWritten = L(F(T), ne, de, fe);
                break;
              case "ascii":
              case "binary":
                Z = g(this, T, D, C);
                break;
              case "base64":
                ne = this, de = D, fe = C, Z = m._charsWritten = L(I(T), ne, de, fe);
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                Z = y(this, T, D, C);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return Z;
          }, m.prototype.toString = function(T, D, C) {
            var z, Z, ne, de, fe = this;
            if (T = String(T || "utf8").toLowerCase(), D = Number(D) || 0, (C = C !== void 0 ? Number(C) : fe.length) === D) return "";
            switch (T) {
              case "hex":
                z = (function(Ee, re, xe) {
                  var De = Ee.length;
                  (!re || re < 0) && (re = 0), (!xe || xe < 0 || De < xe) && (xe = De);
                  for (var pe = "", j = re; j < xe; j++) pe += $(Ee[j]);
                  return pe;
                })(fe, D, C);
                break;
              case "utf8":
              case "utf-8":
                z = (function(Ee, re, xe) {
                  var De = "", pe = "";
                  xe = Math.min(Ee.length, xe);
                  for (var j = re; j < xe; j++) Ee[j] <= 127 ? (De += K(pe) + String.fromCharCode(Ee[j]), pe = "") : pe += "%" + Ee[j].toString(16);
                  return De + K(pe);
                })(fe, D, C);
                break;
              case "ascii":
              case "binary":
                z = w(fe, D, C);
                break;
              case "base64":
                Z = fe, de = C, z = (ne = D) === 0 && de === Z.length ? h.fromByteArray(Z) : h.fromByteArray(Z.slice(ne, de));
                break;
              case "ucs2":
              case "ucs-2":
              case "utf16le":
              case "utf-16le":
                z = (function(Ee, re, xe) {
                  for (var De = Ee.slice(re, xe), pe = "", j = 0; j < De.length; j += 2) pe += String.fromCharCode(De[j] + 256 * De[j + 1]);
                  return pe;
                })(fe, D, C);
                break;
              default:
                throw new Error("Unknown encoding");
            }
            return z;
          }, m.prototype.toJSON = function() {
            return { type: "Buffer", data: Array.prototype.slice.call(this._arr || this, 0) };
          }, m.prototype.copy = function(T, D, C, z) {
            if (D = D || 0, (z = z || z === 0 ? z : this.length) !== (C = C || 0) && T.length !== 0 && this.length !== 0) {
              B(C <= z, "sourceEnd < sourceStart"), B(0 <= D && D < T.length, "targetStart out of bounds"), B(0 <= C && C < this.length, "sourceStart out of bounds"), B(0 <= z && z <= this.length, "sourceEnd out of bounds"), z > this.length && (z = this.length);
              var Z = (z = T.length - D < z - C ? T.length - D + C : z) - C;
              if (Z < 100 || !m._useTypedArrays) for (var ne = 0; ne < Z; ne++) T[ne + D] = this[ne + C];
              else T._set(this.subarray(C, C + Z), D);
            }
          }, m.prototype.slice = function(T, D) {
            var C = this.length;
            if (T = ee(T, C, 0), D = ee(D, C, C), m._useTypedArrays) return m._augment(this.subarray(T, D));
            for (var z = D - T, Z = new m(z, void 0, !0), ne = 0; ne < z; ne++) Z[ne] = this[ne + T];
            return Z;
          }, m.prototype.get = function(T) {
            return console.log(".get() is deprecated. Access using array indexes instead."), this.readUInt8(T);
          }, m.prototype.set = function(T, D) {
            return console.log(".set() is deprecated. Access using array indexes instead."), this.writeUInt8(T, D);
          }, m.prototype.readUInt8 = function(T, D) {
            if (D || (B(T != null, "missing offset"), B(T < this.length, "Trying to read beyond buffer length")), !(T >= this.length)) return this[T];
          }, m.prototype.readUInt16LE = function(T, D) {
            return x(this, T, !0, D);
          }, m.prototype.readUInt16BE = function(T, D) {
            return x(this, T, !1, D);
          }, m.prototype.readUInt32LE = function(T, D) {
            return S(this, T, !0, D);
          }, m.prototype.readUInt32BE = function(T, D) {
            return S(this, T, !1, D);
          }, m.prototype.readInt8 = function(T, D) {
            if (D || (B(T != null, "missing offset"), B(T < this.length, "Trying to read beyond buffer length")), !(T >= this.length)) return 128 & this[T] ? -1 * (255 - this[T] + 1) : this[T];
          }, m.prototype.readInt16LE = function(T, D) {
            return O(this, T, !0, D);
          }, m.prototype.readInt16BE = function(T, D) {
            return O(this, T, !1, D);
          }, m.prototype.readInt32LE = function(T, D) {
            return P(this, T, !0, D);
          }, m.prototype.readInt32BE = function(T, D) {
            return P(this, T, !1, D);
          }, m.prototype.readFloatLE = function(T, D) {
            return b(this, T, !0, D);
          }, m.prototype.readFloatBE = function(T, D) {
            return b(this, T, !1, D);
          }, m.prototype.readDoubleLE = function(T, D) {
            return _(this, T, !0, D);
          }, m.prototype.readDoubleBE = function(T, D) {
            return _(this, T, !1, D);
          }, m.prototype.writeUInt8 = function(T, D, C) {
            C || (B(T != null, "missing value"), B(D != null, "missing offset"), B(D < this.length, "trying to write beyond buffer length"), Y(T, 255)), D >= this.length || (this[D] = T);
          }, m.prototype.writeUInt16LE = function(T, D, C) {
            E(this, T, D, !0, C);
          }, m.prototype.writeUInt16BE = function(T, D, C) {
            E(this, T, D, !1, C);
          }, m.prototype.writeUInt32LE = function(T, D, C) {
            A(this, T, D, !0, C);
          }, m.prototype.writeUInt32BE = function(T, D, C) {
            A(this, T, D, !1, C);
          }, m.prototype.writeInt8 = function(T, D, C) {
            C || (B(T != null, "missing value"), B(D != null, "missing offset"), B(D < this.length, "Trying to write beyond buffer length"), se(T, 127, -128)), D >= this.length || (0 <= T ? this.writeUInt8(T, D, C) : this.writeUInt8(255 + T + 1, D, C));
          }, m.prototype.writeInt16LE = function(T, D, C) {
            k(this, T, D, !0, C);
          }, m.prototype.writeInt16BE = function(T, D, C) {
            k(this, T, D, !1, C);
          }, m.prototype.writeInt32LE = function(T, D, C) {
            R(this, T, D, !0, C);
          }, m.prototype.writeInt32BE = function(T, D, C) {
            R(this, T, D, !1, C);
          }, m.prototype.writeFloatLE = function(T, D, C) {
            N(this, T, D, !0, C);
          }, m.prototype.writeFloatBE = function(T, D, C) {
            N(this, T, D, !1, C);
          }, m.prototype.writeDoubleLE = function(T, D, C) {
            U(this, T, D, !0, C);
          }, m.prototype.writeDoubleBE = function(T, D, C) {
            U(this, T, D, !1, C);
          }, m.prototype.fill = function(T, D, C) {
            if (D = D || 0, C = C || this.length, B(typeof (T = typeof (T = T || 0) == "string" ? T.charCodeAt(0) : T) == "number" && !isNaN(T), "value is not a number"), B(D <= C, "end < start"), C !== D && this.length !== 0) {
              B(0 <= D && D < this.length, "start out of bounds"), B(0 <= C && C <= this.length, "end out of bounds");
              for (var z = D; z < C; z++) this[z] = T;
            }
          }, m.prototype.inspect = function() {
            for (var T = [], D = this.length, C = 0; C < D; C++) if (T[C] = $(this[C]), C === i.INSPECT_MAX_BYTES) {
              T[C + 1] = "...";
              break;
            }
            return "<Buffer " + T.join(" ") + ">";
          }, m.prototype.toArrayBuffer = function() {
            if (typeof Uint8Array > "u") throw new Error("Buffer.toArrayBuffer not supported in this browser");
            if (m._useTypedArrays) return new m(this).buffer;
            for (var T = new Uint8Array(this.length), D = 0, C = T.length; D < C; D += 1) T[D] = this[D];
            return T.buffer;
          };
          var H = m.prototype;
          function ee(T, D, C) {
            return typeof T != "number" ? C : D <= (T = ~~T) ? D : 0 <= T || 0 <= (T += D) ? T : 0;
          }
          function ue(T) {
            return (T = ~~Math.ceil(+T)) < 0 ? 0 : T;
          }
          function Q(T) {
            return (Array.isArray || function(D) {
              return Object.prototype.toString.call(D) === "[object Array]";
            })(T);
          }
          function $(T) {
            return T < 16 ? "0" + T.toString(16) : T.toString(16);
          }
          function F(T) {
            for (var D = [], C = 0; C < T.length; C++) {
              var z = T.charCodeAt(C);
              if (z <= 127) D.push(T.charCodeAt(C));
              else for (var Z = C, ne = (55296 <= z && z <= 57343 && C++, encodeURIComponent(T.slice(Z, C + 1)).substr(1).split("%")), de = 0; de < ne.length; de++) D.push(parseInt(ne[de], 16));
            }
            return D;
          }
          function I(T) {
            return h.toByteArray(T);
          }
          function L(T, D, C, z) {
            for (var Z = 0; Z < z && !(Z + C >= D.length || Z >= T.length); Z++) D[Z + C] = T[Z];
            return Z;
          }
          function K(T) {
            try {
              return decodeURIComponent(T);
            } catch {
              return "�";
            }
          }
          function Y(T, D) {
            B(typeof T == "number", "cannot write a non-number as a number"), B(0 <= T, "specified a negative value for writing an unsigned value"), B(T <= D, "value is larger than maximum value for type"), B(Math.floor(T) === T, "value has a fractional component");
          }
          function se(T, D, C) {
            B(typeof T == "number", "cannot write a non-number as a number"), B(T <= D, "value larger than maximum allowed value"), B(C <= T, "value smaller than minimum allowed value"), B(Math.floor(T) === T, "value has a fractional component");
          }
          function ve(T, D, C) {
            B(typeof T == "number", "cannot write a non-number as a number"), B(T <= D, "value larger than maximum allowed value"), B(C <= T, "value smaller than minimum allowed value");
          }
          function B(T, D) {
            if (!T) throw new Error(D || "Failed assertion");
          }
          m._augment = function(T) {
            return T._isBuffer = !0, T._get = T.get, T._set = T.set, T.get = H.get, T.set = H.set, T.write = H.write, T.toString = H.toString, T.toLocaleString = H.toString, T.toJSON = H.toJSON, T.copy = H.copy, T.slice = H.slice, T.readUInt8 = H.readUInt8, T.readUInt16LE = H.readUInt16LE, T.readUInt16BE = H.readUInt16BE, T.readUInt32LE = H.readUInt32LE, T.readUInt32BE = H.readUInt32BE, T.readInt8 = H.readInt8, T.readInt16LE = H.readInt16LE, T.readInt16BE = H.readInt16BE, T.readInt32LE = H.readInt32LE, T.readInt32BE = H.readInt32BE, T.readFloatLE = H.readFloatLE, T.readFloatBE = H.readFloatBE, T.readDoubleLE = H.readDoubleLE, T.readDoubleBE = H.readDoubleBE, T.writeUInt8 = H.writeUInt8, T.writeUInt16LE = H.writeUInt16LE, T.writeUInt16BE = H.writeUInt16BE, T.writeUInt32LE = H.writeUInt32LE, T.writeUInt32BE = H.writeUInt32BE, T.writeInt8 = H.writeInt8, T.writeInt16LE = H.writeInt16LE, T.writeInt16BE = H.writeInt16BE, T.writeInt32LE = H.writeInt32LE, T.writeInt32BE = H.writeInt32BE, T.writeFloatLE = H.writeFloatLE, T.writeFloatBE = H.writeFloatBE, T.writeDoubleLE = H.writeDoubleLE, T.writeDoubleBE = H.writeDoubleBE, T.fill = H.fill, T.inspect = H.inspect, T.toArrayBuffer = H.toArrayBuffer, T;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/buffer/index.js", "/node_modules/gulp-browserify/node_modules/buffer");
      }, { "base64-js": 2, buffer: 3, ieee754: 10, lYpoI2: 11 }], 4: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, v = 4, m = new h(v);
          m.fill(0), r.exports = { hash: function(g, y, w, x) {
            for (var S = y((function(E, A) {
              E.length % v != 0 && (k = E.length + (v - E.length % v), E = h.concat([E, m], k));
              for (var k, R = [], N = A ? E.readInt32BE : E.readInt32LE, U = 0; U < E.length; U += v) R.push(N.call(E, U));
              return R;
            })(g = h.isBuffer(g) ? g : new h(g), x), 8 * g.length), y = x, O = new h(w), P = y ? O.writeInt32BE : O.writeInt32LE, b = 0; b < S.length; b++) P.call(O, S[b], 4 * b, !0);
            return O;
          } };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/helpers.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 5: [function(n, r, i) {
        (function(o, a, h, l, u, c, f, d, p) {
          var h = n("buffer").Buffer, v = n("./sha"), m = n("./sha256"), g = n("./rng"), y = { sha1: v, sha256: m, md5: n("./md5") }, w = 64, x = new h(w);
          function S(E, A) {
            var k = y[E = E || "sha1"], R = [];
            return k || O("algorithm:", E, "is not yet supported"), { update: function(N) {
              return h.isBuffer(N) || (N = new h(N)), R.push(N), N.length, this;
            }, digest: function(N) {
              var U = h.concat(R), U = A ? (function(H, ee, ue) {
                h.isBuffer(ee) || (ee = new h(ee)), h.isBuffer(ue) || (ue = new h(ue)), ee.length > w ? ee = H(ee) : ee.length < w && (ee = h.concat([ee, x], w));
                for (var Q = new h(w), $ = new h(w), F = 0; F < w; F++) Q[F] = 54 ^ ee[F], $[F] = 92 ^ ee[F];
                return ue = H(h.concat([Q, ue])), H(h.concat([$, ue]));
              })(k, A, U) : k(U);
              return R = null, N ? U.toString(N) : U;
            } };
          }
          function O() {
            var E = [].slice.call(arguments).join(" ");
            throw new Error([E, "we accept pull requests", "http://github.com/dominictarr/crypto-browserify"].join(`
`));
          }
          x.fill(0), i.createHash = function(E) {
            return S(E);
          }, i.createHmac = S, i.randomBytes = function(E, A) {
            if (!A || !A.call) return new h(g(E));
            try {
              A.call(this, void 0, new h(g(E)));
            } catch (k) {
              A(k);
            }
          };
          var P, b = ["createCredentials", "createCipher", "createCipheriv", "createDecipher", "createDecipheriv", "createSign", "createVerify", "createDiffieHellman", "pbkdf2"], _ = function(E) {
            i[E] = function() {
              O("sorry,", E, "is not implemented yet");
            };
          };
          for (P in b) _(b[P]);
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/index.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./md5": 6, "./rng": 7, "./sha": 8, "./sha256": 9, buffer: 3, lYpoI2: 11 }], 6: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function v(O, P) {
            O[P >> 5] |= 128 << P % 32, O[14 + (P + 64 >>> 9 << 4)] = P;
            for (var b = 1732584193, _ = -271733879, E = -1732584194, A = 271733878, k = 0; k < O.length; k += 16) {
              var R = b, N = _, U = E, H = A, b = g(b, _, E, A, O[k + 0], 7, -680876936), A = g(A, b, _, E, O[k + 1], 12, -389564586), E = g(E, A, b, _, O[k + 2], 17, 606105819), _ = g(_, E, A, b, O[k + 3], 22, -1044525330);
              b = g(b, _, E, A, O[k + 4], 7, -176418897), A = g(A, b, _, E, O[k + 5], 12, 1200080426), E = g(E, A, b, _, O[k + 6], 17, -1473231341), _ = g(_, E, A, b, O[k + 7], 22, -45705983), b = g(b, _, E, A, O[k + 8], 7, 1770035416), A = g(A, b, _, E, O[k + 9], 12, -1958414417), E = g(E, A, b, _, O[k + 10], 17, -42063), _ = g(_, E, A, b, O[k + 11], 22, -1990404162), b = g(b, _, E, A, O[k + 12], 7, 1804603682), A = g(A, b, _, E, O[k + 13], 12, -40341101), E = g(E, A, b, _, O[k + 14], 17, -1502002290), b = y(b, _ = g(_, E, A, b, O[k + 15], 22, 1236535329), E, A, O[k + 1], 5, -165796510), A = y(A, b, _, E, O[k + 6], 9, -1069501632), E = y(E, A, b, _, O[k + 11], 14, 643717713), _ = y(_, E, A, b, O[k + 0], 20, -373897302), b = y(b, _, E, A, O[k + 5], 5, -701558691), A = y(A, b, _, E, O[k + 10], 9, 38016083), E = y(E, A, b, _, O[k + 15], 14, -660478335), _ = y(_, E, A, b, O[k + 4], 20, -405537848), b = y(b, _, E, A, O[k + 9], 5, 568446438), A = y(A, b, _, E, O[k + 14], 9, -1019803690), E = y(E, A, b, _, O[k + 3], 14, -187363961), _ = y(_, E, A, b, O[k + 8], 20, 1163531501), b = y(b, _, E, A, O[k + 13], 5, -1444681467), A = y(A, b, _, E, O[k + 2], 9, -51403784), E = y(E, A, b, _, O[k + 7], 14, 1735328473), b = w(b, _ = y(_, E, A, b, O[k + 12], 20, -1926607734), E, A, O[k + 5], 4, -378558), A = w(A, b, _, E, O[k + 8], 11, -2022574463), E = w(E, A, b, _, O[k + 11], 16, 1839030562), _ = w(_, E, A, b, O[k + 14], 23, -35309556), b = w(b, _, E, A, O[k + 1], 4, -1530992060), A = w(A, b, _, E, O[k + 4], 11, 1272893353), E = w(E, A, b, _, O[k + 7], 16, -155497632), _ = w(_, E, A, b, O[k + 10], 23, -1094730640), b = w(b, _, E, A, O[k + 13], 4, 681279174), A = w(A, b, _, E, O[k + 0], 11, -358537222), E = w(E, A, b, _, O[k + 3], 16, -722521979), _ = w(_, E, A, b, O[k + 6], 23, 76029189), b = w(b, _, E, A, O[k + 9], 4, -640364487), A = w(A, b, _, E, O[k + 12], 11, -421815835), E = w(E, A, b, _, O[k + 15], 16, 530742520), b = x(b, _ = w(_, E, A, b, O[k + 2], 23, -995338651), E, A, O[k + 0], 6, -198630844), A = x(A, b, _, E, O[k + 7], 10, 1126891415), E = x(E, A, b, _, O[k + 14], 15, -1416354905), _ = x(_, E, A, b, O[k + 5], 21, -57434055), b = x(b, _, E, A, O[k + 12], 6, 1700485571), A = x(A, b, _, E, O[k + 3], 10, -1894986606), E = x(E, A, b, _, O[k + 10], 15, -1051523), _ = x(_, E, A, b, O[k + 1], 21, -2054922799), b = x(b, _, E, A, O[k + 8], 6, 1873313359), A = x(A, b, _, E, O[k + 15], 10, -30611744), E = x(E, A, b, _, O[k + 6], 15, -1560198380), _ = x(_, E, A, b, O[k + 13], 21, 1309151649), b = x(b, _, E, A, O[k + 4], 6, -145523070), A = x(A, b, _, E, O[k + 11], 10, -1120210379), E = x(E, A, b, _, O[k + 2], 15, 718787259), _ = x(_, E, A, b, O[k + 9], 21, -343485551), b = S(b, R), _ = S(_, N), E = S(E, U), A = S(A, H);
            }
            return Array(b, _, E, A);
          }
          function m(O, P, b, _, E, A) {
            return S((P = S(S(P, O), S(_, A))) << E | P >>> 32 - E, b);
          }
          function g(O, P, b, _, E, A, k) {
            return m(P & b | ~P & _, O, P, E, A, k);
          }
          function y(O, P, b, _, E, A, k) {
            return m(P & _ | b & ~_, O, P, E, A, k);
          }
          function w(O, P, b, _, E, A, k) {
            return m(P ^ b ^ _, O, P, E, A, k);
          }
          function x(O, P, b, _, E, A, k) {
            return m(b ^ (P | ~_), O, P, E, A, k);
          }
          function S(O, P) {
            var b = (65535 & O) + (65535 & P);
            return (O >> 16) + (P >> 16) + (b >> 16) << 16 | 65535 & b;
          }
          r.exports = function(O) {
            return h.hash(O, v, 16);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/md5.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 7: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          r.exports = function(h) {
            for (var v, m = new Array(h), g = 0; g < h; g++) (3 & g) == 0 && (v = 4294967296 * Math.random()), m[g] = v >>> ((3 & g) << 3) & 255;
            return m;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/rng.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { buffer: 3, lYpoI2: 11 }], 8: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h = n("./helpers");
          function v(y, w) {
            y[w >> 5] |= 128 << 24 - w % 32, y[15 + (w + 64 >> 9 << 4)] = w;
            for (var x, S, O, P = Array(80), b = 1732584193, _ = -271733879, E = -1732584194, A = 271733878, k = -1009589776, R = 0; R < y.length; R += 16) {
              for (var N = b, U = _, H = E, ee = A, ue = k, Q = 0; Q < 80; Q++) {
                P[Q] = Q < 16 ? y[R + Q] : g(P[Q - 3] ^ P[Q - 8] ^ P[Q - 14] ^ P[Q - 16], 1);
                var $ = m(m(g(b, 5), ($ = _, S = E, O = A, (x = Q) < 20 ? $ & S | ~$ & O : !(x < 40) && x < 60 ? $ & S | $ & O | S & O : $ ^ S ^ O)), m(m(k, P[Q]), (x = Q) < 20 ? 1518500249 : x < 40 ? 1859775393 : x < 60 ? -1894007588 : -899497514)), k = A, A = E, E = g(_, 30), _ = b, b = $;
              }
              b = m(b, N), _ = m(_, U), E = m(E, H), A = m(A, ee), k = m(k, ue);
            }
            return Array(b, _, E, A, k);
          }
          function m(y, w) {
            var x = (65535 & y) + (65535 & w);
            return (y >> 16) + (w >> 16) + (x >> 16) << 16 | 65535 & x;
          }
          function g(y, w) {
            return y << w | y >>> 32 - w;
          }
          r.exports = function(y) {
            return h.hash(y, v, 20, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 9: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          function h(w, x) {
            var S = (65535 & w) + (65535 & x);
            return (w >> 16) + (x >> 16) + (S >> 16) << 16 | 65535 & S;
          }
          function v(w, x) {
            var S, O = new Array(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), P = new Array(1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225), b = new Array(64);
            w[x >> 5] |= 128 << 24 - x % 32, w[15 + (x + 64 >> 9 << 4)] = x;
            for (var _, E, A = 0; A < w.length; A += 16) {
              for (var k = P[0], R = P[1], N = P[2], U = P[3], H = P[4], ee = P[5], ue = P[6], Q = P[7], $ = 0; $ < 64; $++) b[$] = $ < 16 ? w[$ + A] : h(h(h((E = b[$ - 2], g(E, 17) ^ g(E, 19) ^ y(E, 10)), b[$ - 7]), (E = b[$ - 15], g(E, 7) ^ g(E, 18) ^ y(E, 3))), b[$ - 16]), S = h(h(h(h(Q, g(E = H, 6) ^ g(E, 11) ^ g(E, 25)), H & ee ^ ~H & ue), O[$]), b[$]), _ = h(g(_ = k, 2) ^ g(_, 13) ^ g(_, 22), k & R ^ k & N ^ R & N), Q = ue, ue = ee, ee = H, H = h(U, S), U = N, N = R, R = k, k = h(S, _);
              P[0] = h(k, P[0]), P[1] = h(R, P[1]), P[2] = h(N, P[2]), P[3] = h(U, P[3]), P[4] = h(H, P[4]), P[5] = h(ee, P[5]), P[6] = h(ue, P[6]), P[7] = h(Q, P[7]);
            }
            return P;
          }
          var m = n("./helpers"), g = function(w, x) {
            return w >>> x | w << 32 - x;
          }, y = function(w, x) {
            return w >>> x;
          };
          r.exports = function(w) {
            return m.hash(w, v, 32, !0);
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/crypto-browserify/sha256.js", "/node_modules/gulp-browserify/node_modules/crypto-browserify");
      }, { "./helpers": 4, buffer: 3, lYpoI2: 11 }], 10: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          i.read = function(h, v, m, g, A) {
            var w, x, S = 8 * A - g - 1, O = (1 << S) - 1, P = O >> 1, b = -7, _ = m ? A - 1 : 0, E = m ? -1 : 1, A = h[v + _];
            for (_ += E, w = A & (1 << -b) - 1, A >>= -b, b += S; 0 < b; w = 256 * w + h[v + _], _ += E, b -= 8) ;
            for (x = w & (1 << -b) - 1, w >>= -b, b += g; 0 < b; x = 256 * x + h[v + _], _ += E, b -= 8) ;
            if (w === 0) w = 1 - P;
            else {
              if (w === O) return x ? NaN : 1 / 0 * (A ? -1 : 1);
              x += Math.pow(2, g), w -= P;
            }
            return (A ? -1 : 1) * x * Math.pow(2, w - g);
          }, i.write = function(h, v, m, g, y, k) {
            var x, S, O = 8 * k - y - 1, P = (1 << O) - 1, b = P >> 1, _ = y === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, E = g ? 0 : k - 1, A = g ? 1 : -1, k = v < 0 || v === 0 && 1 / v < 0 ? 1 : 0;
            for (v = Math.abs(v), isNaN(v) || v === 1 / 0 ? (S = isNaN(v) ? 1 : 0, x = P) : (x = Math.floor(Math.log(v) / Math.LN2), v * (g = Math.pow(2, -x)) < 1 && (x--, g *= 2), 2 <= (v += 1 <= x + b ? _ / g : _ * Math.pow(2, 1 - b)) * g && (x++, g /= 2), P <= x + b ? (S = 0, x = P) : 1 <= x + b ? (S = (v * g - 1) * Math.pow(2, y), x += b) : (S = v * Math.pow(2, b - 1) * Math.pow(2, y), x = 0)); 8 <= y; h[m + E] = 255 & S, E += A, S /= 256, y -= 8) ;
            for (x = x << y | S, O += y; 0 < O; h[m + E] = 255 & x, E += A, x /= 256, O -= 8) ;
            h[m + E - A] |= 128 * k;
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/ieee754/index.js", "/node_modules/gulp-browserify/node_modules/ieee754");
      }, { buffer: 3, lYpoI2: 11 }], 11: [function(n, r, i) {
        (function(o, a, s, l, u, c, f, d, p) {
          var h, v, m;
          function g() {
          }
          (o = r.exports = {}).nextTick = (v = typeof window < "u" && window.setImmediate, m = typeof window < "u" && window.postMessage && window.addEventListener, v ? function(y) {
            return window.setImmediate(y);
          } : m ? (h = [], window.addEventListener("message", function(y) {
            var w = y.source;
            w !== window && w !== null || y.data !== "process-tick" || (y.stopPropagation(), 0 < h.length && h.shift()());
          }, !0), function(y) {
            h.push(y), window.postMessage("process-tick", "*");
          }) : function(y) {
            setTimeout(y, 0);
          }), o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.on = g, o.addListener = g, o.once = g, o.off = g, o.removeListener = g, o.removeAllListeners = g, o.emit = g, o.binding = function(y) {
            throw new Error("process.binding is not supported");
          }, o.cwd = function() {
            return "/";
          }, o.chdir = function(y) {
            throw new Error("process.chdir is not supported");
          };
        }).call(this, n("lYpoI2"), typeof self < "u" ? self : typeof window < "u" ? window : {}, n("buffer").Buffer, arguments[3], arguments[4], arguments[5], arguments[6], "/node_modules/gulp-browserify/node_modules/process/browser.js", "/node_modules/gulp-browserify/node_modules/process");
      }, { buffer: 3, lYpoI2: 11 }] }, {}, [1])(1);
    });
  })(Bv)), Bv.exports;
}
var tle = ele();
const Jo = /* @__PURE__ */ Wd(tle), nle = ({
  children: e,
  showMenu: t
}) => /* @__PURE__ */ M.jsx(
  "div",
  {
    className: `absolute left-0 right-0 z-50 overflow-scroll rounded max-h-40 ${t ? "block" : "hidden"}`,
    children: e
  }
);
function Gle({
  options: e,
  onSelect: t,
  displayKey: n
}) {
  const [r, i] = Fe(!1), o = _e(null), a = () => i(!0), [s, l] = Fe(""), u = $e(() => {
    if (!s) return e;
    const c = new RegExp(s, "i");
    return e.filter((f) => n ? f[n].match(c) : f.match(c));
  }, [s, e]);
  return MQ(o, () => i(!1)), GA(
    {
      Escape: () => i(!1)
    },
    [i]
  ), /* @__PURE__ */ M.jsxs("div", { className: "relative", onFocus: a, children: [
    /* @__PURE__ */ M.jsx(
      pd,
      {
        autoComplete: "off",
        ref: o,
        type: "text",
        onChange: (c) => l(c.target.value),
        value: s
      }
    ),
    /* @__PURE__ */ M.jsx(nle, { showMenu: r, children: /* @__PURE__ */ M.jsxs(
      In.ul,
      {
        className: "flex flex-col w-full h-full p-2 rounded shadow-lg bg-neutral-200",
        layout: !0,
        children: [
          u.length > 0 && u.map((c) => /* @__PURE__ */ M.jsx("li", { className: "hover:text-blue-500", children: /* @__PURE__ */ M.jsx(
            "button",
            {
              onClick: () => {
                t(c), l(
                  n ? c[n] : c
                );
              },
              children: n ? c[n] : c
            }
          ) }, Jo(c))),
          r && u.length === 0 && /* @__PURE__ */ M.jsx("p", { className: "italic", children: "No Results" })
        ]
      }
    ) })
  ] });
}
function Yle({
  row: e,
  data: t,
  extras: n = [],
  hide: r,
  transform: i,
  editable: o = !1,
  onEdit: a,
  defaultSortKey: s,
  className: l = "",
  render: u,
  renderHeading: c,
  cell: f
}) {
  const [d, p] = Fe(s ?? ""), [h, v] = Fe(
    "desc"
    /* Descending */
  ), [m, g] = Fe({
    key: "",
    newValue: "",
    value: "",
    hashedRow: ""
  }), y = $e(() => [...t], [t]), w = _e(null), x = $e(() => d ? y.sort((A, k) => {
    const R = A[d] ?? "", N = k[d] ?? "";
    return R < N ? h === "asc" ? -1 : 1 : R > N ? h === "asc" ? 1 : -1 : 0;
  }) : y, [d, y, h]), S = $e(() => y.length === 0 ? [] : Object.getOwnPropertyNames(y[0]).reduce((k, R) => {
    if (r?.[R])
      return k;
    if (i && i[R]) {
      const N = i[R](R);
      return [
        ...k,
        {
          key: R,
          transformed: N
        }
      ];
    } else
      return console.log(
        `No transform for column ${R}, using key as transformed value`
      ), [...k, { key: R, transformed: R }];
  }, []), [y]), O = Me(
    (A, k) => u?.[A] ? u[A](k) : A === m.key && Jo(k) === m.hashedRow && o ? /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx(
        "form",
        {
          className: "absolute left-0 right-0 top-0 bottom-0",
          onSubmit: (R) => {
            R.preventDefault(), a && a({
              column: m.key,
              newValue: m.newValue,
              oldValue: m.value,
              rowData: k
            }), g({
              key: "",
              value: "",
              newValue: "",
              hashedRow: ""
            }), w.current?.blur();
          },
          children: /* @__PURE__ */ M.jsx(
            "textarea",
            {
              className: "w-full h-full",
              onBlur: () => {
                a?.({
                  column: m.key,
                  newValue: m.newValue,
                  oldValue: m.value,
                  rowData: k
                }), g({
                  key: "",
                  value: "",
                  newValue: "",
                  hashedRow: ""
                });
              },
              ref: w,
              autoFocus: !0,
              value: m.newValue,
              onChange: (R) => g({
                key: A,
                value: k[A],
                newValue: R.target.value,
                hashedRow: Jo(k)
              })
            },
            `${Jo(k)}}-${A}-${k[A]}-input`
          )
        }
      ),
      /* @__PURE__ */ M.jsx("p", { className: "invisible", children: k[A] })
    ] }) : /* @__PURE__ */ M.jsx("div", { children: k[A] }),
    [m, u]
  ), P = e ?? ((A) => /* @__PURE__ */ M.jsx("tr", { ...A })), b = (A) => c ? /* @__PURE__ */ M.jsx(M.Fragment, { children: c(A.children) }) : /* @__PURE__ */ M.jsx("tr", { ...A });
  let _ = !0;
  rle(c) && (c ? _ = !0 : _ = !1);
  const E = f ?? "td";
  return /* @__PURE__ */ M.jsxs("table", { className: l, children: [
    _ && /* @__PURE__ */ M.jsx("thead", { children: /* @__PURE__ */ M.jsxs(b, { children: [
      S.map(
        ({ key: A, transformed: k }) => !r?.[A] && /* @__PURE__ */ M.jsx(
          "th",
          {
            onClick: () => {
              d == A ? v(
                () => h === "asc" ? "desc" : "asc"
                /* Ascending */
              ) : (p(A), v(
                "asc"
                /* Ascending */
              ));
            },
            children: /* @__PURE__ */ M.jsxs("div", { className: "flex justify-start items-center", children: [
              k,
              A === d && h === "asc" && /* @__PURE__ */ M.jsx(
                ar,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: r6
                }
              ),
              A === d && h === "desc" && /* @__PURE__ */ M.jsx(
                ar,
                {
                  className: "mx-1",
                  size: "sm",
                  icon: J2
                }
              )
            ] })
          },
          A
        )
      ),
      (n || []).map(({ key: A }, k) => /* @__PURE__ */ M.jsx("th", { children: A }, `extras-${A}-${k}`))
    ] }) }),
    /* @__PURE__ */ M.jsx("tbody", { children: x.map(
      (A) => P(
        {
          key: Jo(A),
          children: Object.entries(A).map(([k, R]) => r?.[k] ? null : !r?.[k] && /* @__PURE__ */ M.jsx(
            E,
            {
              title: R,
              onClick: () => {
                o && !u?.[k] && g({
                  key: k,
                  value: R,
                  newValue: R,
                  hashedRow: Jo(A)
                });
              },
              children: O(k, A)
            },
            `${Jo(A)}}-${k}-${R}`
          ))
        },
        A
      )
    ) })
  ] });
}
function rle(e) {
  return typeof e == "boolean";
}
const X3 = Le(
  {}
);
function ile(e) {
  return /* @__PURE__ */ M.jsx(X3.Provider, { value: e.value, children: e.children });
}
const r_ = () => Ie(X3);
function ole({ items: e }) {
  const { activeTab: t, setActiveTab: n } = r_();
  return /* @__PURE__ */ M.jsx(
    "div",
    {
      className: "flex w-full bg-black overflow-x-scroll self-baseline tabs-list overflow-y-hidden",
      children: e.map((r) => /* @__PURE__ */ M.jsx(
        sle,
        {
          label: r.label,
          active: t === r.value,
          value: r.value,
          onClick: (i) => {
            n(i);
          }
        },
        `tab-${r.value}`
      ))
    }
  );
}
const ale = Pr(
  [
    "last:border-none",
    "border-r",
    "flex-shrink-0",
    "px-4",
    "pb-4",
    "hover:bg-gray-200",
    "whitespace-nowrap",
    "overflow-hidden",
    "text-ellipsis",
    "self-baseline"
  ],
  {
    variants: {
      active: {
        false: "bg-black text-white",
        true: "bg-white text-black"
      }
    }
  }
);
function sle(e) {
  return /* @__PURE__ */ M.jsx(
    "button",
    {
      onClick: () => e.onClick(e.value),
      className: ale({ active: e.active }),
      children: e.label
    }
  );
}
function lle({
  children: e,
  className: t,
  value: n
}) {
  const { activeTab: r, contentRef: i } = r_();
  return r !== n || !i ? null : da(
    /* @__PURE__ */ M.jsx("div", { className: `flex flex-col flex-grow h-full w-full ${t || ""} overflow-hidden`, children: e }),
    i
  );
}
const ule = (({
  children: e,
  items: t,
  onChange: n,
  activeTab: r
}) => {
  const [i, o] = Fe(null);
  return /* @__PURE__ */ M.jsx(
    ile,
    {
      value: {
        activeTab: r,
        setActiveTab: (a) => {
          n?.(a);
        },
        contentRef: i
      },
      children: /* @__PURE__ */ M.jsxs("div", { className: "flex flex-col tabs h-full overflow-hidden", children: [
        /* @__PURE__ */ M.jsx(ole, { items: t }),
        /* @__PURE__ */ M.jsx(
          "div",
          {
            className: "flex flex-col flex-grow-[2] h-full w-full overflow-hidden",
            ref: o,
            children: e
          }
        )
      ] })
    }
  );
});
ule.Tab = lle;
const cle = Pr([
  "rounded",
  "px-4",
  "py-2",
  "bg-neutral-50",
  "mr-1",
  "hover:bg-neutral-100",
  "hover:text-black",
  "text-neutral-800"
], {
  variants: {
    active: {
      true: ["bg-black", "hover:bg-black", "text-white"],
      false: []
    }
  }
}), Qle = ({ value: e, children: t }) => {
  const { activeTab: n, setActiveTab: r } = r_();
  return /* @__PURE__ */ M.jsx(
    "button",
    {
      className: cle({ active: n === e }),
      onClick: () => r(e),
      children: t
    }
  );
}, Jle = ({
  jobId: e,
  className: t = ""
}) => {
  const { data: n } = Fse({ variables: { jobId: e } }), [r, i] = Fe([]);
  return Se(() => {
    n?.taskQueueLogs && i((o) => [...o, n.taskQueueLogs]);
  }, [n]), /* @__PURE__ */ M.jsx(
    "div",
    {
      className: `${t} relative h-full p-4 overflow-y-scroll rounded bg-neutral-200 text-neutral-800`,
      children: r.map((o, a) => /* @__PURE__ */ M.jsx("pre", { children: o.message }, `task-queue-${e}-${o.timestamp}-${a}`))
    }
  );
}, eI = Le({}), Xle = () => Ie(eI), fle = (e = !1) => {
  const [t, n] = Fe(e);
  return Se(() => {
    const r = localStorage.getItem("darkMode");
    try {
      const i = JSON.parse(r || "");
      n(i.darkMode);
    } catch {
      localStorage.setItem(
        "darkMode",
        JSON.stringify({ darkMode: e })
      );
    }
  }, [n]), Se(() => {
    localStorage.setItem("darkMode", JSON.stringify({ darkMode: t }));
  }, [t]), {
    darkMode: !1,
    // disable dark mode for now
    setDarkMode: (r) => {
      localStorage.setItem("darkMode", JSON.stringify({ darkMode: !r })), n(r);
    }
  };
}, eue = ({ children: e }) => {
  const { darkMode: t, setDarkMode: n } = fle();
  return Se(() => {
    const r = document.querySelector("body");
    r && r.classList.remove("dark");
  }, [t]), /* @__PURE__ */ M.jsx(eI.Provider, { value: { darkMode: t, setDarkMode: n }, children: /* @__PURE__ */ M.jsx("div", { className: "", children: e }) });
}, tue = ({
  order: e,
  children: t,
  className: n = ""
}) => {
  function r(i, o) {
    switch (i) {
      case 1:
        return /* @__PURE__ */ M.jsx("h1", { className: `${n} text-2xl text-brand-500`, children: o });
      case 2:
        return /* @__PURE__ */ M.jsx("h2", { className: `${n} text-xl text-brand-600`, children: o });
      case 3:
        return /* @__PURE__ */ M.jsx("h3", { className: `${n} text-brand-800`, children: o });
      case 4:
        return /* @__PURE__ */ M.jsx("h4", { children: o });
      case 5:
        return /* @__PURE__ */ M.jsx("h5", { children: o });
      default:
      case 6:
        return /* @__PURE__ */ M.jsx("h6", { children: o });
    }
  }
  return r(e, t);
};
function nue({ on: e, onChange: t, className: n = "" }) {
  return /* @__PURE__ */ M.jsx(
    In.button,
    {
      layout: !0,
      onClick: () => t(!e),
      className: `
                w-12 h-4 p-1 items-center ${n} flex rounded transition-colors 
                ${e ? "justify-end bg-black" : "justify-start bg-neutral-100"}
            `,
      children: /* @__PURE__ */ M.jsx(
        In.div,
        {
          layout: !0,
          className: `w-4 h-2 rounded-sm transition-colors ${e ? "bg-neutral-100" : "bg-neutral-800"}`
        }
      )
    }
  );
}
const rue = Xt(
  ({ className: e, ...t }, n) => /* @__PURE__ */ M.jsx("textarea", { ref: n, ...t, className: Un(
    "dark:bg-neutral-800 dark:text-neutral-200 bg-white text-black px-2 border-black border font-body",
    e
  ) })
);
export {
  sh as AppLayout,
  ly as Button,
  qle as CircleSpinner,
  Sle as CopyButton,
  Ole as Delete,
  $le as Divider,
  Tle as Drawer,
  Pm as DrawerButton,
  kle as Dropdown,
  Ple as DynamicFormInput,
  Dle as Ellipses,
  O7 as Error,
  Ale as ErrorBoundary,
  pd as Field,
  rX as FileBrowser,
  Lle as FileInput,
  Ele as FlexBox,
  Vle as FormikField,
  Ble as GridArea,
  Bse as ImagePreview,
  RQ as Input,
  H3 as Logo,
  P0 as Menu,
  la as MenuItem,
  nC as MenuItemStyle,
  ZJ as MenuStyle,
  IJ as Modal,
  Mle as ModalContainer,
  Kle as NotFound,
  xle as Note,
  Lse as Page,
  Q3 as PageHeader,
  Vse as PageHeaderTitle,
  Hle as Preview,
  Jse as Protected,
  Ule as ReaderLayout,
  Wle as RequireRoles,
  Zle as S3DownloadLink,
  zle as S3FileBrowser,
  Hse as SVGPreview,
  E7 as Select,
  Gle as SelectionSearch,
  Md as Spacer,
  Use as Spinner,
  Qle as Tab,
  lle as TabContent,
  Yle as Table,
  Qse as TablePreview,
  ule as Tabs,
  ole as TabsList,
  Jle as TaskQueueLogs,
  rue as Textarea,
  eI as ThemeContext,
  eue as ThemeProvider,
  tue as Title,
  nue as Toggle,
  YJ as UploadToast,
  hse as _S3FileBrowser,
  xse as fileListToArray,
  zse as pageVariants,
  NJ as useModalContext,
  W3 as useTailwindBreakpoint,
  Xle as useTheme
};
//# sourceMappingURL=components.js.map
